let abilities = [
    {
      "asset_id": 5312,
      "resettable": 1,
      "name": "Abash",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2134,
      "activated": 1,
      "icon_name": "intoxicate",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this champion is attacked, the attacking champion becomes <condition value=charmed>Charmed</condition> for 2 turns.",
      "long_description": "When this champion is attacked, the attacking champion becomes <condition value=charmed>Charmed</condition> for 2 turns.",
      "class_name": "Abash",
      "revision": 1
    },
    {
      "asset_id": 5246,
      "resettable": 1,
      "name": "Abominable",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 2026,
      "activated": 1,
      "icon_name": "fangandfur",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 2,
      "short_description": "This unit has <ability value=600>Arctic</ability> and deals +1 DMG to Scented champions for each real friendly Yeti. When this ability is activated, the closest enemy champion within 6 spaces becomes Scented for 2 turns and loses <condition value=stealthed>Stealthed</condition>. If the enemy champion is <condition value=frightened>Frightened</condition>, it becomes Scented for 4 turns instead.",
      "long_description": "This unit has <ability value=600>Arctic</ability> and deals +1 DMG to Scented champions for each real friendly Yeti. When this ability is activated, the closest enemy champion within 6 spaces becomes Scented for 2 turns and loses <condition value=stealthed>Stealthed</condition>. If the enemy champion is <condition value=frightened>Frightened</condition>, it becomes Scented for 4 turns instead.",
      "class_name": "Abominable",
      "revision": 1
    },
    {
      "asset_id": 7334,
      "resettable": 0,
      "name": "Absolute Zero",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 3105,
      "activated": 1,
      "icon_name": "absolute_zero",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "Opposing champions within 2 spaces take 12 Frost damage, opposing champions within 4 spaces take 10 Frost damage, and opposing champions within 6 spaces take 8 Frost damage. This damage ignores DEF.",
      "long_description": "Opposing champions within 2 spaces take 12 Frost damage, opposing champions within 4 spaces take 10 Frost damage, and opposing champions within 6 spaces take 8 Frost damage. This damage ignores DEF.",
      "class_name": "AbsoluteZero",
      "revision": 1
    },
    {
      "asset_id": 4034,
      "resettable": 1,
      "name": "Absorb",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1317,
      "activated": 1,
      "icon_name": "eater_arrow",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "If this unit is successfully attacked at RNG 2 or greater, it gains <ability value=685>Arrow Eater</ability> for 1 turn.",
      "long_description": "If this unit is successfully attacked at RNG 2 or greater, it gains <ability value=685>Arrow Eater</ability> for 1 turn.",
      "class_name": "Absorb",
      "revision": 1
    },
    {
      "asset_id": 4370,
      "resettable": 1,
      "name": "Absorb Illusion",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 1429,
      "activated": 1,
      "icon_name": "heal",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 1,
      "short_description": "The nearest <condition value=illusion>Illusion</condition> within 5 spaces is destroyed and this unit heals 8 HP.",
      "long_description": "The nearest <condition value=illusion>Illusion</condition> within 5 spaces is destroyed and this unit heals 8 HP.",
      "class_name": "AbsorbIllusion",
      "revision": 1
    },
    {
      "asset_id": 7585,
      "resettable": 0,
      "name": "Absorb Relic",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 3221,
      "activated": 1,
      "icon_name": "absorb_relic",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "Target relic within 3 spaces is destroyed and this champion heals for 10 HP.  If the relic was friendly, this champion also gains +5 MAX HP.",
      "long_description": "Target relic within 3 spaces is destroyed and this champion heals for 10 HP.  If the relic was friendly, this champion also gains +5 MAX HP.",
      "class_name": "AbsorbRelic",
      "revision": 1
    },
    {
      "asset_id": 5333,
      "resettable": 1,
      "name": "Abuse Charged",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 2163,
      "activated": 1,
      "icon_name": "charged_abuse",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 1,
      "short_description": "When an opposing champion makes an attack against this champion, this unit gains 1 charge.",
      "long_description": "When an opposing champion makes an attack against this champion, this unit gains 1 charge.",
      "class_name": "AbuseCharged",
      "revision": 1
    },
    {
      "asset_id": 5333,
      "resettable": 1,
      "name": "Abuse Charged",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 2164,
      "activated": 1,
      "icon_name": "charged_abuse",
      "comments": "",
      "prerequisite_id": 2163,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 2,
      "short_description": "When an opposing champion makes an attack against this champion, this unit gains 2 charges.",
      "long_description": "When an opposing champion makes an attack against this champion, this unit gains 2 charges.",
      "class_name": "AbuseCharged",
      "revision": 1
    },
    {
      "asset_id": 5333,
      "resettable": 1,
      "name": "Abuse Charged",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 2165,
      "activated": 1,
      "icon_name": "charged_abuse",
      "comments": "",
      "prerequisite_id": 2164,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 3,
      "short_description": "When an opposing champion makes an attack against this champion, this unit gains 3 charges.",
      "long_description": "When an opposing champion makes an attack against this champion, this unit gains 3 charges.",
      "class_name": "AbuseCharged",
      "revision": 1
    },
    {
      "asset_id": 5661,
      "resettable": 1,
      "name": "Acid Acolyte",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2533,
      "activated": 1,
      "icon_name": "acolyte_acid",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "Whenever a champion takes Acid damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=scoured>Scoured</condition>.",
      "long_description": "Whenever a champion takes Acid damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=scoured>Scoured</condition>.",
      "class_name": "AcidAcolyte",
      "revision": 1
    },
    {
      "asset_id": 5594,
      "resettable": 1,
      "name": "Acid Amped",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2716,
      "activated": 1,
      "icon_name": "amped",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "This champion loses a charge at the end of its turn. While this champion has at least 8 charges, it has +1 SPD, +2 DMG, +2 DEF and <ability value=153>Acid Aura 3</ability>",
      "long_description": "This champion loses a charge at the end of its turn. While this champion has at least 8 charges, it has +1 SPD, +2 DMG, +2 DEF and <ability value=153>Acid Aura 3</ability>",
      "class_name": "AcidAmped",
      "revision": 1
    },
    {
      "asset_id": 4509,
      "resettable": 1,
      "name": "Acid Bomb",
      "ap_cost": 1,
      "level": 1,
      "ability_id": 848,
      "activated": 1,
      "icon_name": "acidaoe",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 6,
      "short_description": "Area Effect 2, Range 5: Affected units take Acid damage equal to 50% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=scoured>Scoured</condition> for 2 turns",
      "long_description": "Area Effect 2, Range 5: Affected units take Acid damage equal to 50% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=scoured>Scoured</condition> for 2 turns",
      "class_name": "AcidBomb",
      "revision": 1
    },
    {
      "asset_id": 4509,
      "resettable": 1,
      "name": "Acid Bomb",
      "ap_cost": 1,
      "level": 2,
      "ability_id": 849,
      "activated": 1,
      "icon_name": "acidaoe",
      "comments": "",
      "prerequisite_id": 848,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 8,
      "short_description": "Area Effect 2, Range 5: Affected units take Acid damage equal to 65% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=scoured>Scoured</condition> for 2 turns",
      "long_description": "Area Effect 2, Range 5: Affected units take Acid damage equal to 65% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=scoured>Scoured</condition> for 2 turns",
      "class_name": "AcidBomb",
      "revision": 1
    },
    {
      "asset_id": 4509,
      "resettable": 1,
      "name": "Acid Bomb",
      "ap_cost": 1,
      "level": 3,
      "ability_id": 850,
      "activated": 1,
      "icon_name": "acidaoe",
      "comments": "",
      "prerequisite_id": 849,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 10,
      "short_description": "Area Effect 2, Range 5: Affected units take Acid damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=scoured>Scoured</condition> for 2 turns",
      "long_description": "Area Effect 2, Range 5: Affected units take Acid damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=scoured>Scoured</condition> for 2 turns",
      "class_name": "AcidBomb",
      "revision": 1
    },
    {
      "asset_id": 4626,
      "resettable": 1,
      "name": "Acid Eater",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1047,
      "activated": 1,
      "icon_name": "eater_acid",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this unit takes Acid damage, it instead recovers HP equal to half the damage that would have been dealt. This unit cannot be <condition value=scoured>Scoured</condition>.",
      "long_description": "When this unit takes Acid damage, it instead recovers HP equal to half the damage that would have been dealt. This unit cannot be <condition value=scoured>Scoured</condition>.",
      "class_name": "AcidEater",
      "revision": 1
    },
    {
      "asset_id": 4081,
      "resettable": 1,
      "name": "Acidic Aura",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 151,
      "activated": 1,
      "icon_name": "novaacid",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 2,
      "short_description": "At the beginning of your opponent's turns, this unit deals 2 Acid damage to each champion within 2 spaces. This damage ignores DEF.",
      "long_description": "At the beginning of your opponent's turns, this unit deals 2 Acid damage to each champion within 2 spaces. This damage ignores DEF.",
      "class_name": "DamagingAuraAcid",
      "revision": 1
    },
    {
      "asset_id": 4081,
      "resettable": 1,
      "name": "Acidic Aura",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 152,
      "activated": 1,
      "icon_name": "novaacid",
      "comments": "none",
      "prerequisite_id": 151,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 4,
      "short_description": "At the beginning of your opponent's turns, this unit deals 4 Acid damage to each champion within 2 spaces. This damage ignores DEF.",
      "long_description": "At the beginning of your opponent's turns, this unit deals 4 Acid damage to each champion within 2 spaces. This damage ignores DEF.",
      "class_name": "DamagingAuraAcid",
      "revision": 1
    },
    {
      "asset_id": 4081,
      "resettable": 1,
      "name": "Acidic Aura",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 153,
      "activated": 1,
      "icon_name": "novaacid",
      "comments": "none",
      "prerequisite_id": 152,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 6,
      "short_description": "At the beginning of your opponent's turns, this unit deals 6 Acid damage to each champion within 2 spaces. This damage ignores DEF.",
      "long_description": "At the beginning of your opponent's turns, this unit deals 6 Acid damage to each champion within 2 spaces. This damage ignores DEF.",
      "class_name": "DamagingAuraAcid",
      "revision": 1
    },
    {
      "asset_id": 4365,
      "resettable": 1,
      "name": "Acidic Greeting",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1401,
      "activated": 1,
      "icon_name": "greeting_acid",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "When this champion comes into play, all enemy champions become <condition value=scoured>Scoured</condition> for 2 turns.",
      "long_description": "When this champion comes into play, all enemy champions become <condition value=scoured>Scoured</condition> for 2 turns.",
      "class_name": "AcidicGreeting",
      "revision": 1
    },
    {
      "asset_id": 7133,
      "resettable": 0,
      "name": "Activate Magnet",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2975,
      "activated": 1,
      "icon_name": "magnetic_hold",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "Target champion within 5 spaces is <condition value=magnetized>Magnetized</condition>.",
      "long_description": "Target champion within 5 spaces is <condition value=magnetized>Magnetized</condition>.",
      "class_name": "Magnetize",
      "revision": 1
    },
    {
      "asset_id": 4380,
      "resettable": 1,
      "name": "Adaptation",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1419,
      "activated": 1,
      "icon_name": "adaptation",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "When an enemy champion within 5 spaces activates an ability, this unit gains that ability for 4 turns. Basic Attacks and abilities that change a champion's form are not gained.",
      "long_description": "When an enemy champion within 5 spaces activates an ability, this unit gains that ability for 4 turns. Basic Attacks and abilities that change a champion's form are not gained.",
      "class_name": "Adaptation",
      "revision": 1
    },
    {
      "asset_id": 7474,
      "resettable": 0,
      "name": "Adaptive",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3163,
      "activated": 1,
      "icon_name": "special",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 6,
      "short_description": "When you successfully cast a spell that shares a faction with this unit, it gains +1 DMG. If the spell costs 35 nora or more, it also gains +3 MAX HP.",
      "long_description": "When you successfully cast a spell that shares a faction with this unit, it gains +1 DMG. If the spell costs 35 nora or more, it also gains +3 MAX HP.",
      "class_name": "Adaptive",
      "revision": 1
    },
    {
      "asset_id": 5349,
      "resettable": 1,
      "name": "Add Charge",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 2181,
      "activated": 1,
      "icon_name": "add_charged",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 2,
      "short_description": "Target unit within 7 spaces gains a charge and this unit loses a charge.  A unit may only gain charges from Add Charge or Remove Charge once per round.",
      "long_description": "Target unit within 7 spaces gains a charge and this unit loses a charge.  A unit may only gain charges from Add Charge or Remove Charge once per round.",
      "class_name": "AddCharge",
      "revision": 1
    },
    {
      "asset_id": 5710,
      "resettable": 1,
      "name": "Adept Arcanist",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2682,
      "activated": 1,
      "icon_name": "special",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 4,
      "short_description": "When a unit within 8 spaces, including this one, takes damage, this champion permanently gains a basic attack of that damage type.",
      "long_description": "When a unit within 8 spaces, including this one, takes damage, this champion permanently gains a basic attack of that damage type.",
      "class_name": "AdeptArcanist",
      "revision": 1
    },
    {
      "asset_id": 5367,
      "resettable": 1,
      "name": "Aegis",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2199,
      "activated": 1,
      "icon_name": "aegis",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 25,
      "short_description": "If another friendly Shattered Peaks champion is in play this champion has <ability value=68>Resistance: Poison 3</ability>, <ability value=80>Resistance: Disease 3</ability> and <ability value=49>Resistance: Physical 3</ability>.  If another friendly Savage Tundra champion is in play this champion has <ability value=84>Resistance: Psychic 3</ability>, <ability value=72>Resistance: Sonic 3</ability>, <ability value=76>Resistance: Acid 3</ability> and <ability value=64>Resistance: Electricity 3</ability>.",
      "long_description": "If another friendly Shattered Peaks champion is in play this champion has <ability value=68>Resistance: Poison 3</ability>, <ability value=80>Resistance: Disease 3</ability> and <ability value=49>Resistance: Physical 3</ability>.  If another friendly Savage Tundra champion is in play this champion has <ability value=84>Resistance: Psychic 3</ability>, <ability value=72>Resistance: Sonic 3</ability>, <ability value=76>Resistance: Acid 3</ability> and <ability value=64>Resistance: Electricity 3</ability>.",
      "class_name": "Aegis",
      "revision": 1
    },
    {
      "asset_id": 4577,
      "resettable": 1,
      "name": "Afflict",
      "ap_cost": 3,
      "level": 1,
      "ability_id": 972,
      "activated": 1,
      "icon_name": "lossoflife",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 1,
      "cost": 3,
      "short_description": "For 6 turns, target champion within 5 spaces loses 6 HP every time this unit is damaged by an attack from an opposing champion.",
      "long_description": "For 6 turns, target champion within 5 spaces loses 6 HP every time this unit is damaged by an attack from an opposing champion.",
      "class_name": "Afflict",
      "revision": 1
    },
    {
      "asset_id": 4577,
      "resettable": 1,
      "name": "Afflict",
      "ap_cost": 3,
      "level": 2,
      "ability_id": 973,
      "activated": 1,
      "icon_name": "lossoflife",
      "comments": "",
      "prerequisite_id": 972,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 1,
      "cost": 6,
      "short_description": "For 6 turns, target champion within 5 spaces loses 8 HP every time this unit is damaged by an attack from an opposing champion.",
      "long_description": "For 6 turns, target champion within 5 spaces loses 8 HP every time this unit is damaged by an attack from an opposing champion.",
      "class_name": "Afflict",
      "revision": 1
    },
    {
      "asset_id": 5926,
      "resettable": 0,
      "name": "Aggregate",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2964,
      "activated": 1,
      "icon_name": "breaker_electricity",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -3,
      "short_description": "Whenever this unit takes damage, all units with this ability also take damage.",
      "long_description": "Whenever this unit takes damage, all units with this ability also take damage.",
      "class_name": "Aggregate",
      "revision": 1
    },
    {
      "asset_id": 4823,
      "resettable": 1,
      "name": "Aid Defense",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1703,
      "activated": 1,
      "icon_name": "allybuffs",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 7,
      "short_description": "When this champion successfully damages a champion with a basic attack, friendly champions with the same race as this one have +1 DEF for 4 turns.",
      "long_description": "When this champion successfully damages a champion with a basic attack, friendly champions with the same race as this one have +1 DEF for 4 turns.",
      "class_name": "AidCyclops",
      "revision": 1
    },
    {
      "asset_id": 5194,
      "resettable": 1,
      "name": "Aim",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 2780,
      "activated": 1,
      "icon_name": "hunted",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "At the start of its next turn, this champion has +1 RNG, +3 DMG and <ability value=1775>Precision</ability> for 1 turn.",
      "long_description": "At the start of its next turn, this champion has +1 RNG, +3 DMG and <ability value=1775>Precision</ability> for 1 turn.",
      "class_name": "Aim",
      "revision": 1
    },
    {
      "asset_id": 5889,
      "resettable": 1,
      "name": "Air Drop",
      "ap_cost": 5,
      "level": 0,
      "ability_id": 2898,
      "activated": 1,
      "icon_name": "air_drop",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 15,
      "short_description": "Target a square up to 10 spaces away in an opponent's controlled font zone. At the start of your next turn, this champion is relocated to that square.",
      "long_description": "Target a square up to 10 spaces away in an opponent's controlled font zone. At the start of your next turn, this champion is relocated to that square.",
      "class_name": "AirDrop",
      "revision": 1
    },
    {
      "asset_id": 7125,
      "resettable": 0,
      "name": "Alluring Discipline",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2940,
      "activated": 1,
      "icon_name": "discipline_alluring",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 3,
      "short_description": "The next basic attack this champion makes causes <condition value=charmed>Charmed</condition> for 2 turns. If the target was <condition value=frozen popup=false>Frozen</condition>, all friendly Monks gain 1 damage for 6 turns",
      "long_description": "The next basic attack this champion makes causes <condition value=charmed>Charmed</condition> for 2 turns. If the target was <condition value=frozen popup=false>Frozen</condition>, all friendly Monks gain 1 damage for 6 turns",
      "class_name": "AlluringDiscipline",
      "revision": 1
    },
    {
      "asset_id": 4690,
      "resettable": 1,
      "name": "Ally: Forglar Swamp",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1130,
      "activated": 1,
      "icon_name": "allybuff_fs",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "While there are other friendly Forglar Swamp champions in play, this champion gets +7 HP and +2 DMG. Forglar champions gain 1 AP when this unit comes into play.",
      "long_description": "While there are other friendly Forglar Swamp champions in play, this champion gets +7 HP and +2 DMG. Forglar champions gain 1 AP when this unit comes into play.",
      "class_name": "AllyForglarSwamp",
      "revision": 1
    },
    {
      "asset_id": 4685,
      "resettable": 1,
      "name": "Ally: Forsaken Waste",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1125,
      "activated": 1,
      "icon_name": "allybuff_fw",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "While there are other friendly Forsaken Wastes champions in play, this champion gets +7 HP and +2 DMG. Forsaken champions gain 1 AP when this unit comes into play.",
      "long_description": "While there are other friendly Forsaken Wastes champions in play, this champion gets +7 HP and +2 DMG. Forsaken champions gain 1 AP when this unit comes into play.",
      "class_name": "AllyForsakenWaste",
      "revision": 1
    },
    {
      "asset_id": 4688,
      "resettable": 1,
      "name": "Ally: Ironfist Stronghold",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1128,
      "activated": 1,
      "icon_name": "allybuff_is",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "While there are other friendly Ironfist Stronghold champions in play, this champion gets +7 HP and +2 DMG. Ironfist champions gain 1 AP when this unit comes into play.",
      "long_description": "While there are other friendly Ironfist Stronghold champions in play, this champion gets +7 HP and +2 DMG. Ironfist champions gain 1 AP when this unit comes into play.",
      "class_name": "AllyIronfist",
      "revision": 1
    },
    {
      "asset_id": 4689,
      "resettable": 1,
      "name": "Ally: K'thir Forest",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1129,
      "activated": 1,
      "icon_name": "allybuff_kf",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "While there are other friendly K'thir Forest champions in play, this champion gets +7 HP and +2 DMG. K'thir champions gain 1 AP when this unit comes into play.",
      "long_description": "While there are other friendly K'thir Forest champions in play, this champion gets +7 HP and +2 DMG. K'thir champions gain 1 AP when this unit comes into play.",
      "class_name": "AllyKthirForest",
      "revision": 1
    },
    {
      "asset_id": 4691,
      "resettable": 1,
      "name": "Ally: Savage Tundra",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1131,
      "activated": 1,
      "icon_name": "allybuff_st",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "While there are other friendly Savage Tundra champions in play, this champion gets +7 HP and +2 DMG. Savage Tundra champions gain 1 AP when this unit comes into play.",
      "long_description": "While there are other friendly Savage Tundra champions in play, this champion gets +7 HP and +2 DMG. Savage Tundra champions gain 1 AP when this unit comes into play.",
      "class_name": "AllySavageTundra",
      "revision": 1
    },
    {
      "asset_id": 4686,
      "resettable": 1,
      "name": "Ally: Shattered Peaks",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1126,
      "activated": 1,
      "icon_name": "allybuff_sp",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "While there are other friendly Shattered Peaks champions in play, this champion gets +7 HP and +2 DMG. Shattered Peaks champions gain 1 AP when this unit comes into play.",
      "long_description": "While there are other friendly Shattered Peaks champions in play, this champion gets +7 HP and +2 DMG. Shattered Peaks champions gain 1 AP when this unit comes into play.",
      "class_name": "AllyShatteredPeaks",
      "revision": 1
    },
    {
      "asset_id": 4687,
      "resettable": 1,
      "name": "Ally: Sundered Lands",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1127,
      "activated": 1,
      "icon_name": "allybuff_sl",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "While there are other friendly Sundered Lands champions in play, this champion gets +7 HP and +2 DMG. Sundered Lands champions gain 1 AP when this unit comes into play.",
      "long_description": "While there are other friendly Sundered Lands champions in play, this champion gets +7 HP and +2 DMG. Sundered Lands champions gain 1 AP when this unit comes into play.",
      "class_name": "AllySunderedLands",
      "revision": 1
    },
    {
      "asset_id": 4684,
      "resettable": 1,
      "name": "Ally: Underdepths",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1124,
      "activated": 1,
      "icon_name": "allybuff_ud",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "While there are other friendly Underdepths champions in play, this champion gets +7 HP and +2 DMG. Underdepths champions gain 1 AP when this unit comes into play.",
      "long_description": "While there are other friendly Underdepths champions in play, this champion gets +7 HP and +2 DMG. Underdepths champions gain 1 AP when this unit comes into play.",
      "class_name": "AllyUnderdepths",
      "revision": 1
    },
    {
      "asset_id": 7161,
      "resettable": 0,
      "name": "Amber Sigil",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3004,
      "activated": 1,
      "icon_name": "griffin_sigil",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 5,
      "short_description": "This champion gains <ability value=1317>Absorb</ability> and +1 DEF for 5 turns when a friendly unit with a Sigil ability is deployed from the runedock.",
      "long_description": "This champion gains <ability value=1317>Absorb</ability> and +1 DEF for 5 turns when a friendly unit with a Sigil ability is deployed from the runedock.",
      "class_name": "AmberSigil",
      "revision": 1
    },
    {
      "asset_id": 4825,
      "resettable": 1,
      "name": "Ambush",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1705,
      "activated": 1,
      "icon_name": "assault",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 10,
      "short_description": "While <condition value=stealthed>Stealthed</condition>, if an opposing champion moves adjacent to this champion, this champion makes a free attack against that opponent that ignores DEF if it is greater than 0 and causes <condition value=ensnared>Ensnared</condition> 2.",
      "long_description": "While <condition value=stealthed>Stealthed</condition>, if an opposing champion moves adjacent to this champion, this champion makes a free attack against that opponent that ignores DEF if it is greater than 0 and causes <condition value=ensnared>Ensnared</condition> 2.",
      "class_name": "TunnelAmbush",
      "revision": 1
    },
    {
      "asset_id": 7142,
      "resettable": 0,
      "name": "Amethyst Sigil",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2984,
      "activated": 1,
      "icon_name": "griffin_sigil",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 3,
      "short_description": "This champion gains <ability value=1274>Vaporize</ability> for 5 turns when a friendly unit with a Sigil ability is deployed from the runedock.",
      "long_description": "This champion gains <ability value=1274>Vaporize</ability> for 5 turns when a friendly unit with a Sigil ability is deployed from the runedock.",
      "class_name": "AmethystSigil",
      "revision": 1
    },
    {
      "asset_id": 4826,
      "resettable": 1,
      "name": "Ammunition",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 1706,
      "activated": 1,
      "icon_name": "gun",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": -8,
      "short_description": "Once this champion has made at least 2 successful attacks, its range becomes 1.",
      "long_description": "Once this champion has made at least 2 successful attacks, its range becomes 1.",
      "class_name": "Ammunition",
      "revision": 1
    },
    {
      "asset_id": 4826,
      "resettable": 1,
      "name": "Ammunition",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 1707,
      "activated": 1,
      "icon_name": "gun",
      "comments": "",
      "prerequisite_id": 1706,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": -4,
      "short_description": "Once this champion has made at least 4 successful attacks, its range becomes 1.",
      "long_description": "Once this champion has made at least 4 successful attacks, its range becomes 1.",
      "class_name": "Ammunition",
      "revision": 1
    },
    {
      "asset_id": 4826,
      "resettable": 1,
      "name": "Ammunition",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 1708,
      "activated": 1,
      "icon_name": "gun",
      "comments": "",
      "prerequisite_id": 1707,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 0,
      "short_description": "Once this champion has made at least 6 successful attacks, its range becomes 1.",
      "long_description": "Once this champion has made at least 6 successful attacks, its range becomes 1.",
      "class_name": "Ammunition",
      "revision": 1
    },
    {
      "asset_id": 4001,
      "resettable": 1,
      "name": "Amphibious",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2,
      "activated": 1,
      "icon_name": "amphib",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 1,
      "short_description": "This champion ignores restrictions and penalties imposed by Water. ",
      "long_description": "This champion ignores restrictions and penalties imposed by Water.",
      "class_name": "Amphibious",
      "revision": 1
    },
    {
      "asset_id": 5630,
      "resettable": 1,
      "name": "Amplify: Acid",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2497,
      "activated": 1,
      "icon_name": "amp_acid",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "Acid damage dealt to champions and relics is increased by 10%.",
      "long_description": "Acid damage dealt to champions and relics is increased by 10%.",
      "class_name": "AmplifyAcid",
      "revision": 1
    },
    {
      "asset_id": 4991,
      "resettable": 1,
      "name": "Amplify: Disease",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 927,
      "activated": 1,
      "icon_name": "amp_disease",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "Disease damage dealt to champions and relics is increased by 10%.",
      "long_description": "Disease damage dealt to champions and relics is increased by 10%.",
      "class_name": "AmplifyDisease",
      "revision": 1
    },
    {
      "asset_id": 4494,
      "resettable": 1,
      "name": "Amplify: Fire",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 910,
      "activated": 1,
      "icon_name": "amp_fire",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "Fire damage dealt to champions and relics is increased by 10%.",
      "long_description": "Fire damage dealt to champions and relics is increased by 10%.",
      "class_name": "AmplifyFire",
      "revision": 1
    },
    {
      "asset_id": 4495,
      "resettable": 1,
      "name": "Amplify: Frost",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 909,
      "activated": 1,
      "icon_name": "amp_frost",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "Frost damage dealt to champions and relics is increased by 10%.",
      "long_description": "Frost damage dealt to champions and relics is increased by 10%.",
      "class_name": "AmplifyFrost",
      "revision": 1
    },
    {
      "asset_id": 5388,
      "resettable": 1,
      "name": "Amplify: Healing",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2220,
      "activated": 1,
      "icon_name": "amp_healing",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "All healing is increased by 50%.",
      "long_description": "All healing is increased by 50%.",
      "class_name": "AmplifyHealing",
      "revision": 1
    },
    {
      "asset_id": 5733,
      "resettable": 1,
      "name": "Amplify: Magic",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2633,
      "activated": 1,
      "icon_name": "amp_magic",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "Magic damage dealt to champions and relics is increased by 10%.",
      "long_description": "Magic damage dealt to champions and relics is increased by 10%.",
      "class_name": "AmplifyMagic",
      "revision": 1
    },
    {
      "asset_id": 4496,
      "resettable": 1,
      "name": "Amplify: Physical",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 908,
      "activated": 1,
      "icon_name": "amp_physical",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 15,
      "short_description": "All physical damage is increased by 10%.",
      "long_description": "All physical damage is increased by 10%.",
      "class_name": "AmplifyPhysical",
      "revision": 1
    },
    {
      "asset_id": 4497,
      "resettable": 1,
      "name": "Amplify: Poison",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 907,
      "activated": 1,
      "icon_name": "amp_poison",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "Poison damage dealt to champions and relics is increased by 10%.",
      "long_description": "Poison damage dealt to champions and relics is increased by 10%.",
      "class_name": "AmplifyPoison",
      "revision": 1
    },
    {
      "asset_id": 4498,
      "resettable": 1,
      "name": "Amplify: Psychic",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 906,
      "activated": 1,
      "icon_name": "amp_psychic",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "All psychic damage is increased by 10%.",
      "long_description": "All psychic damage is increased by 10%.",
      "class_name": "AmplifyPsychic",
      "revision": 1
    },
    {
      "asset_id": 7121,
      "resettable": 0,
      "name": "Amplify: Sonic",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2931,
      "activated": 1,
      "icon_name": "amp_sonic",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "Sonic damage dealt to champions and relics is increased by 10%.",
      "long_description": "Sonic damage dealt to champions and relics is increased by 10%.",
      "class_name": "AmplifySonic",
      "revision": 1
    },
    {
      "asset_id": 5645,
      "resettable": 1,
      "name": "Ancestral Anger",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2516,
      "activated": 1,
      "icon_name": "ancestral_avenger",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 30,
      "short_description": "Target champion within 5 spaces gains Berserker 3 and has a max range of 1 for 6 turns. If target champion is a Garu it also gains 2 ranks of Enrage.",
      "long_description": "Target champion within 5 spaces gains Berserker 3 and has a max range of 1 for 6 turns. If target champion is a Garu it also gains 2 ranks of Enrage.",
      "class_name": "CastAncestralAnger",
      "revision": 1
    },
    {
      "asset_id": 7511,
      "resettable": 0,
      "name": "Anchoring Force",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3185,
      "activated": 1,
      "icon_name": "anchoring_force",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "Enemy champions within 5 spaces are Slowed.",
      "long_description": "Enemy champions within 5 spaces are Slowed.",
      "class_name": "AnchoringForce",
      "revision": 1
    },
    {
      "asset_id": 5752,
      "resettable": 1,
      "name": "Ancient Corruption",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2702,
      "activated": 1,
      "icon_name": "defile_corpse",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 12,
      "short_description": "This champion gains +3 DMG, <ability value=2707>Vivify</ability> and <ability value=1846>Foul Strike</ability> for 6 turns.  The duration of this effect is decreased by 1 whenever this champion is successfully attacked.",
      "long_description": "This champion gains +3 DMG, <ability value=2707>Vivify</ability> and <ability value=1846>Foul Strike</ability> for 6 turns.  The duration of this effect is decreased by 1 whenever this champion is successfully attacked.",
      "class_name": "AncientCorruption",
      "revision": 1
    },
    {
      "asset_id": 5499,
      "resettable": 1,
      "name": "Animate",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2358,
      "activated": 1,
      "icon_name": "mobilize_engine",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "This champion loses <mechanic value=immobile>Immobile</mechanic> and Passive and gains <ability value=545>Attack: Physical</ability> for 3 turns.  This ability costs 10 nora.",
      "long_description": "This champion loses <mechanic value=immobile>Immobile</mechanic> and Passive and gains <ability value=545>Attack: Physical</ability> for 3 turns.  This ability costs 10 nora.",
      "class_name": "Animate",
      "revision": 1
    },
    {
      "asset_id": 5328,
      "resettable": 1,
      "name": "Annex",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2157,
      "activated": 1,
      "icon_name": "special",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 2,
      "short_description": "While this unit is in play, your shrine's <mechanic value=deployment_zone>Deployment Zone</mechanic> expands by 1.",
      "long_description": "While this unit is in play, your shrine's <mechanic value=deployment_zone>Deployment Zone</mechanic> expands by 1.",
      "class_name": "Annex",
      "revision": 1
    },
    {
      "asset_id": 5005,
      "resettable": 1,
      "name": "Annihilate",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 1886,
      "activated": 1,
      "icon_name": "novafire",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "Opposing champions within 2 spaces take 12 Fire damage, opposing champions within 4 spaces take 10 Fire damage, and opposing champions within 6 spaces take 8 Fire damage. This damage ignores DEF.",
      "long_description": "Opposing champions within 2 spaces take 12 Fire damage, opposing champions within 4 spaces take 10 Fire damage, and opposing champions within 6 spaces take 8 Fire damage. This damage ignores DEF.",
      "class_name": "Annihilate",
      "revision": 1
    },
    {
      "asset_id": 5093,
      "resettable": 1,
      "name": "Antagonize",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 1269,
      "activated": 1,
      "icon_name": "enrage",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "Target champion within 2 spaces can only target and attack this champion for 4 turns. A champion can only be antagonized by one champion at a time.",
      "long_description": "Target champion within 2 spaces can only target and attack this champion for 4 turns. A champion can only be antagonized by one champion at a time.",
      "class_name": "Antagonize",
      "revision": 1
    },
    {
      "asset_id": 5736,
      "resettable": 1,
      "name": "Anthomancy",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2623,
      "activated": 1,
      "icon_name": "scry",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this champion is deployed, 6 non-champion runes in your runedock are revealed.",
      "long_description": "When this champion is deployed, 6 non-champion runes in your runedock are revealed.",
      "class_name": "Anthomancy",
      "revision": 1
    },
    {
      "asset_id": 4071,
      "resettable": 1,
      "name": "Aquatic",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 114,
      "activated": 1,
      "icon_name": "aquatic",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": -10,
      "short_description": "This unit has <ability value=2>Amphibious</ability>. While occupying Water, this champion gets +1 SPD and has <ability value=6>Mobility</ability>. When moving to a location that is not at least half water, there is an additional 1 AP cost unless it is <condition value=flying>Flying</condition>. At the beginning of your turn, if this champion is not occupying Water, it loses 5 HP.",
      "long_description": "This unit has <ability value=2>Amphibious</ability>. While occupying Water, this champion gets +1 SPD and has <ability value=6>Mobility</ability>. When moving to a location that is not at least half water, there is an additional 1 AP cost unless it is <condition value=flying>Flying</condition>. At the beginning of your turn, if this champion is not occupying Water, it loses 5 HP.",
      "class_name": "Aquatic",
      "revision": 1
    },
    {
      "asset_id": 7404,
      "resettable": 0,
      "name": "Aquatic Armaments",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3146,
      "activated": 1,
      "icon_name": "comboatk_devastate",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "When a friendly champion with Aquatic, Semi-Aquatic, Race: Salaman, or Race: Boghopper becomes equipped, it gains 1 AP and +1 DEF for 4 turns. This does not stack.",
      "long_description": "When a friendly champion with Aquatic, Semi-Aquatic, Race: Salaman, or Race: Boghopper becomes equipped, it gains 1 AP and +1 DEF for 4 turns. This does not stack.",
      "class_name": "AquaticArmaments",
      "revision": 1
    },
    {
      "asset_id": 7367,
      "resettable": 0,
      "name": "Arcblade: Electricity",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 3123,
      "activated": 1,
      "icon_name": "glaive_electric",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 3,
      "ranked": 0,
      "cost": 8,
      "short_description": "This champion makes an Electricity attack at 12 DMG against target champion within 4 spaces. If successful, the nearest enemy champion within 4 spaces takes 9 damage then the next closest champion takes 6 damage. This damage ignores DEF.",
      "long_description": "This champion makes an Electricity attack at 12 DMG against target champion within 4 spaces. If successful, the nearest enemy champion within 4 spaces takes 9 damage then the next closest champion takes 6 damage. This damage ignores DEF.",
      "class_name": "Arcblade",
      "revision": 1
    },
    {
      "asset_id": 5607,
      "resettable": 1,
      "name": "Arcblade: Frost",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 2466,
      "activated": 1,
      "icon_name": "glaivebounce",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 3,
      "ranked": 0,
      "cost": 8,
      "short_description": "This champion makes a Frost attack at 12 DMG against target champion within 4 spaces. If successful, the nearest enemy champion within 4 spaces takes 9 damage then the next closest champion takes 6 damage. This damage ignores DEF.",
      "long_description": "This champion makes a Frost attack at 12 DMG against target champion within 4 spaces. If successful, the nearest enemy champion within 4 spaces takes 9 damage then the next closest champion takes 6 damage. This damage ignores DEF.",
      "class_name": "GlaiveBounce",
      "revision": 1
    },
    {
      "asset_id": 5628,
      "resettable": 1,
      "name": "Archery Bale",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2495,
      "activated": 1,
      "icon_name": "hunted",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "Friendly champions with Class: Archer within 5 spaces of this unit have +1 MAX RNG.",
      "long_description": "Friendly champions with Class: Archer within 5 spaces of this unit have +1 MAX RNG.",
      "class_name": "ArcheryBale",
      "revision": 1
    },
    {
      "asset_id": 4229,
      "resettable": 1,
      "name": "Arctic",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 600,
      "activated": 1,
      "icon_name": "arctic",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 2,
      "short_description": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
      "long_description": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
      "class_name": "Arctic",
      "revision": 1
    },
    {
      "asset_id": 5724,
      "resettable": 1,
      "name": "Arctic Bolt",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 2606,
      "activated": 1,
      "icon_name": "iceaoe",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 9,
      "short_description": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this champion take 12 Frost damage and become <condition value=chilled>Chilled</condition> 2. This damage ignores DEF.",
      "long_description": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this champion take 12 Frost damage and become <condition value=chilled>Chilled</condition> 2. This damage ignores DEF.",
      "class_name": "ArcticBolt",
      "revision": 1
    },
    {
      "asset_id": 7629,
      "resettable": 0,
      "name": "Arctic Bolt (Relic)",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3236,
      "activated": 1,
      "icon_name": "iceaoe",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this champion take 12 Frost damage and become <condition value=chilled>Chilled</condition> 2. This damage ignores DEF.",
      "long_description": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this champion take 12 Frost damage and become <condition value=chilled>Chilled</condition> 2. This damage ignores DEF.",
      "class_name": "RelicArcticBolt",
      "revision": 1
    },
    {
      "asset_id": 4238,
      "resettable": 1,
      "name": "Arctic Camouflage",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 616,
      "activated": 1,
      "icon_name": "camo",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 2,
      "short_description": "When this unit is damaged by a ranged attack while it is occupying Snow or Ice, that damage by is reduced by 2.",
      "long_description": "When this unit is damaged by a ranged attack while it is occupying Snow or Ice, that damage by is reduced by 2.",
      "class_name": "ArcticCamouflage",
      "revision": 1
    },
    {
      "asset_id": 4000,
      "resettable": 0,
      "name": "Arctic Flight",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2922,
      "activated": 1,
      "icon_name": "shimmering_wings",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "This unit has <ability value=600>Arctic</ability>, <condition value=flying>Flying</condition> and 2 ranks of <ability value=819>Sentry</ability>.",
      "long_description": "This unit has <ability value=600>Arctic</ability>, <condition value=flying>Flying</condition> and 2 ranks of <ability value=819>Sentry</ability>.",
      "class_name": "ArcticFlight",
      "revision": 1
    },
    {
      "asset_id": 4610,
      "resettable": 1,
      "name": "Arctic Trap",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1025,
      "activated": 1,
      "icon_name": "trapfrost",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "When an opposing unit moves within 2 spaces of this relic, all champions within range take 8 Frost damage and become <condition value=frozen>Frozen</condition> for 3 turns. This damage ignores DEF. All effected spaces become Deep Snow (Impeding 1) for 3 turns.",
      "long_description": "When an opposing unit moves within 2 spaces of this relic, all champions within range take 8 Frost damage and become <condition value=frozen>Frozen</condition> for 3 turns. This damage ignores DEF. All effected spaces become Deep Snow (Impeding 1) for 3 turns.",
      "class_name": "RelicArcticTrap",
      "revision": 1
    },
    {
      "asset_id": 4450,
      "resettable": 1,
      "name": "Aria the Priestess",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2774,
      "activated": 1,
      "icon_name": "hero",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "This rune is a Limited Edition rune from Plague of Ba'lah, and counts as a Northern Cross Priestess.",
      "long_description": "This rune is a Limited Edition rune from Plague of Ba'lah, and counts as a Northern Cross Priestess.",
      "class_name": "Placeholder",
      "revision": 1
    },
    {
      "asset_id": 4299,
      "resettable": 1,
      "name": "Ark of the Elsari",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 701,
      "activated": 1,
      "icon_name": "dead_magic_zone",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 1,
      "short_description": "Whenever a spell is successfully cast, all friendly champions for the casting player lose 4 life.",
      "long_description": "Whenever a spell is successfully cast, all friendly champions for the casting player lose 4 life.",
      "class_name": "RelicElsariArk",
      "revision": 1
    },
    {
      "asset_id": 4695,
      "resettable": 1,
      "name": "Armory ",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1135,
      "activated": 1,
      "icon_name": "forge",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "When this relic is deployed, concealed equipment runes in your rune dock are revealed. When you deploy an equipment rune, you are refunded 40% of the nora cost. When your equipment is destroyed, cooldown is reduced by 2. This effect does not stack.",
      "long_description": "When this relic is deployed, concealed equipment runes in your rune dock are revealed. When you deploy an equipment rune, you are refunded 40% of the nora cost. When your equipment is destroyed, cooldown is reduced by 2. This effect does not stack.",
      "class_name": "RelicArmory",
      "revision": 1
    },
    {
      "asset_id": 4277,
      "resettable": 1,
      "name": "Arrow Eater",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 685,
      "activated": 1,
      "icon_name": "eater_arrow",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 14,
      "short_description": "When this unit would take damage from a targeted ranged attack, that damage is prevented, and this champion gets a bonus to DMG equal to 25% of the damage that would have been dealt for 2 turns.",
      "long_description": "When this unit would take damage from a targeted ranged attack, that damage is prevented, and this champion gets a bonus to DMG equal to 25% of the damage that would have been dealt for 2 turns.",
      "class_name": "ArrowEater",
      "revision": 1
    },
    {
      "asset_id": 4566,
      "resettable": 1,
      "name": "Arrow Throw",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 974,
      "activated": 1,
      "icon_name": "dodge",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 4,
      "short_description": "When a champion makes an unsuccessful ranged attack against this unit, this unit makes a ranged attack against that unit at +1 DMG.",
      "long_description": "When a champion makes an unsuccessful ranged attack against this unit, this unit makes a ranged attack against that unit at +1 DMG.",
      "class_name": "ArrowThrow",
      "revision": 1
    },
    {
      "asset_id": 4566,
      "resettable": 1,
      "name": "Arrow Throw",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 975,
      "activated": 1,
      "icon_name": "dodge",
      "comments": "",
      "prerequisite_id": 974,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 5,
      "short_description": "When a champion makes an unsuccessful ranged attack against this unit, this unit makes a ranged attack against that unit at +2 DMG.",
      "long_description": "When a champion makes an unsuccessful ranged attack against this unit, this unit makes a ranged attack against that unit at +2 DMG.",
      "class_name": "ArrowThrow",
      "revision": 1
    },
    {
      "asset_id": 4566,
      "resettable": 0,
      "name": "Arrow Throw",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 2928,
      "activated": 1,
      "icon_name": "dodge",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 6,
      "short_description": "When a champion makes an unsuccessful ranged attack against this unit, this unit makes a ranged attack against that unit at +3 DMG.",
      "long_description": "When a champion makes an unsuccessful ranged attack against this unit, this unit makes a ranged attack against that unit at +3 DMG.",
      "class_name": "ArrowThrow",
      "revision": 1
    },
    {
      "asset_id": 4043,
      "resettable": 1,
      "name": "Arrowshot",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 1319,
      "activated": 1,
      "icon_name": "arrow",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "This unit makes a Physical attack at Range 3-6.",
      "long_description": "This unit makes a Physical attack at Range 3-6.",
      "class_name": "ArrowShot",
      "revision": 1
    },
    {
      "asset_id": 4565,
      "resettable": 0,
      "name": "Arroyo Portal",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3281,
      "activated": 1,
      "icon_name": "arroyo_rift",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 12,
      "short_description": "Target champion with Race: Spirit who was deployed this turn is relocated to a space next to this unit. This ability starts on cooldown.",
      "long_description": "Target champion with Race: Spirit who was deployed this turn is relocated to a space next to this unit. This ability starts on cooldown.",
      "class_name": "ArroyoPortalTeleport",
      "revision": 1
    },
    {
      "asset_id": 7668,
      "resettable": 0,
      "name": "Arroyo Rift",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 3250,
      "activated": 1,
      "icon_name": "arroyo_rift",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 20,
      "short_description": "Area Effect 3, Range 5: Affected spaces become <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic> for 5 turns and enemy champions are pulled towards the center by 1 spaces, lose 2AP and become Soultapped for 4 turns",
      "long_description": "Area Effect 3, Range 5: Affected spaces become <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic> for 5 turns and enemy champions are pulled towards the center by 1 spaces, lose 2AP and become Soultapped for 4 turns",
      "class_name": "ArroyoRift",
      "revision": 1
    },
    {
      "asset_id": 5322,
      "resettable": 1,
      "name": "Artillery Marker",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2151,
      "activated": 1,
      "icon_name": "novaspike",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "When an opposing champion moves within 3 spaces of this unit, that unit takes 12 Physical damage and this unit loses 6 HP. Opposing champions successfully damaged are knocked back 1 space and becomes <condition value=stunned>Stunned</condition> for 1 turn. Being knocked into range does not trigger Artillery Marker. This damage ignores DEF.",
      "long_description": "When an opposing champion moves within 3 spaces of this unit, that unit takes 12 Physical damage and this unit loses 6 HP. Opposing champions successfully damaged are knocked back 1 space and becomes <condition value=stunned>Stunned</condition> for 1 turn. Being knocked into range does not trigger Artillery Marker. This damage ignores DEF.",
      "class_name": "ArtilleryMarker",
      "revision": 1
    },
    {
      "asset_id": 5378,
      "resettable": 1,
      "name": "Artillery Strike",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 2210,
      "activated": 1,
      "icon_name": "artillery",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 25,
      "short_description": "Area Effect 2, Range 7-9: At the beginning of your next turn, units occupying the affected spaces take Fire damage equal to the damage of this unit when it made the attack. This damage will occur even if this unit is destroyed or removed from play.",
      "long_description": "Area Effect 2, Range 7-9: At the beginning of your next turn, units occupying the affected spaces take Fire damage equal to the damage of this unit when it made the attack. This damage will occur even if this unit is destroyed or removed from play.",
      "class_name": "ArtilleryStrike",
      "revision": 1
    },
    {
      "asset_id": 5375,
      "resettable": 1,
      "name": "Ascendance",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2207,
      "activated": 1,
      "icon_name": "ascendance",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "Spend 20 Charges. This champion becomes <condition value=ascended>Ascended</condition> and gains <ability value=1045>Elite</ability>.",
      "long_description": "Spend 20 Charges. This champion becomes <condition value=ascended>Ascended</condition> and gains <ability value=1045>Elite</ability>.",
      "class_name": "Ascendance",
      "revision": 1
    },
    {
      "asset_id": 5208,
      "resettable": 1,
      "name": "Aspiring Servant",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1985,
      "activated": 1,
      "icon_name": "revere",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 30,
      "short_description": "While Serkan, Lich Master or Czar of the Void is in play, this champion has <ability value=694>Lich-born</ability>.",
      "long_description": "While Serkan, Lich Master or Czar of the Void is in play, this champion has <ability value=694>Lich-born</ability>.",
      "class_name": "AspiringServant",
      "revision": 1
    },
    {
      "asset_id": 4129,
      "resettable": 1,
      "name": "Assassinate",
      "ap_cost": 1,
      "level": 2,
      "ability_id": 327,
      "activated": 1,
      "icon_name": "stab",
      "comments": "none",
      "prerequisite_id": 580,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 1,
      "cost": 20,
      "short_description": "While <condition value=stealthed>Stealthed</condition>, this champion makes an attack against target champion at triple DMG. This attack ignores DEF and does not miss.",
      "long_description": "While <condition value=stealthed>Stealthed</condition>, this champion makes an attack against target champion at triple DMG. This attack ignores DEF and does not miss.",
      "class_name": "Assassinate",
      "revision": 1
    },
    {
      "asset_id": 4129,
      "resettable": 1,
      "name": "Assassinate",
      "ap_cost": 1,
      "level": 1,
      "ability_id": 580,
      "activated": 1,
      "icon_name": "stab",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 1,
      "cost": 10,
      "short_description": "While <condition value=stealthed>Stealthed</condition>, this champion makes an attack against target champion at double DMG. This attack ignores DEF and does not miss.",
      "long_description": "While <condition value=stealthed>Stealthed</condition>, this champion makes an attack against target champion at double DMG. This attack ignores DEF and does not miss.",
      "class_name": "Assassinate",
      "revision": 1
    },
    {
      "asset_id": 4060,
      "resettable": 1,
      "name": "Assault",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1320,
      "activated": 1,
      "icon_name": "assault",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "This unit makes an attack at no AP cost against any unit that attempts to disengage from it. Spells and abilities that relocate other units do not trigger this ability.",
      "long_description": "This unit makes an attack at no AP cost against any unit that attempts to disengage from it. Spells and abilities that relocate other units do not trigger this ability.",
      "class_name": "Assault",
      "revision": 1
    },
    {
      "asset_id": 4353,
      "resettable": 1,
      "name": "Assimilate",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1387,
      "activated": 1,
      "icon_name": "assimilate",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this champion recovers a nora globe, it is healed for 6 HP.",
      "long_description": "When this champion recovers a nora globe, it is healed for 6 HP.",
      "class_name": "Assimilate",
      "revision": 1
    },
    {
      "asset_id": 5336,
      "resettable": 1,
      "name": "Attack Charged",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 2166,
      "activated": 1,
      "icon_name": "charged_abuse",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 2,
      "short_description": "When this champion makes a basic attack, it gains 1 charge.",
      "long_description": "When this champion makes a basic attack, it gains 1 charge.",
      "class_name": "AttackCharged",
      "revision": 1
    },
    {
      "asset_id": 5336,
      "resettable": 1,
      "name": "Attack Charged",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 2167,
      "activated": 1,
      "icon_name": "charged_abuse",
      "comments": "",
      "prerequisite_id": 2166,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 4,
      "short_description": "When this champion makes a basic attack, it gains 2 charges.",
      "long_description": "When this champion makes a basic attack, it gains 2 charges.",
      "class_name": "AttackCharged",
      "revision": 1
    },
    {
      "asset_id": 5336,
      "resettable": 1,
      "name": "Attack Charged",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 2168,
      "activated": 1,
      "icon_name": "charged_abuse",
      "comments": "",
      "prerequisite_id": 2167,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 6,
      "short_description": "When this champion makes a basic attack, it gains 3 charges.",
      "long_description": "When this champion makes a basic attack, it gains 3 charges.",
      "class_name": "AttackCharged",
      "revision": 1
    },
    {
      "asset_id": 4193,
      "resettable": 1,
      "name": "Attack: Acid",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 539,
      "activated": 1,
      "icon_name": "attack_acid",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 3,
      "ranked": 0,
      "cost": 2,
      "short_description": "This unit makes an Acid attack at its Range. This is a basic attack.",
      "long_description": "This unit makes an Acid attack at its Range. This is a basic attack.",
      "class_name": "AttackAcid",
      "revision": 1
    },
    {
      "asset_id": 4209,
      "resettable": 1,
      "name": "Attack: Arrow",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 555,
      "activated": 1,
      "icon_name": "arrow",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 3,
      "ranked": 0,
      "cost": 2,
      "short_description": "This unit makes a Physical attack at its Range. This is a basic attack.",
      "long_description": "This unit makes a Physical attack at its Range. This is a basic attack.",
      "class_name": "AttackArrow",
      "revision": 1
    },
    {
      "asset_id": 4206,
      "resettable": 1,
      "name": "Attack: Blue Magic",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 552,
      "activated": 1,
      "icon_name": "",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 3,
      "ranked": 0,
      "cost": 0,
      "short_description": "This unit makes a Magical attack at its Range. This is a basic attack.",
      "long_description": "This unit makes a Magical attack at its Range. This is a basic attack.",
      "class_name": "AttackMagicalBlue",
      "revision": 1
    },
    {
      "asset_id": 4207,
      "resettable": 1,
      "name": "Attack: Boulder",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 553,
      "activated": 1,
      "icon_name": "physicalaoe",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 3,
      "ranked": 0,
      "cost": 2,
      "short_description": "This unit makes a Physical attack at its Range. This is a basic attack.",
      "long_description": "This unit makes a Physical attack at its Range. This is a basic attack.",
      "class_name": "AttackBoulder",
      "revision": 1
    },
    {
      "asset_id": 4441,
      "resettable": 1,
      "name": "Attack: Cannon",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 792,
      "activated": 1,
      "icon_name": "artillery",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 3,
      "ranked": 0,
      "cost": 2,
      "short_description": "This unit makes a Physical attack at its Range. This is a basic attack.",
      "long_description": "This unit makes a Physical attack at its Range. This is a basic attack.",
      "class_name": "AttackCannon",
      "revision": 1
    },
    {
      "asset_id": 4195,
      "resettable": 1,
      "name": "Attack: Disease",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 541,
      "activated": 1,
      "icon_name": "attack_disease",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 3,
      "ranked": 0,
      "cost": 2,
      "short_description": "This unit makes a Disease attack at its Range. This is a basic attack.",
      "long_description": "This unit makes a Disease attack at its Range. This is a basic attack.",
      "class_name": "AttackDisease",
      "revision": 1
    },
    {
      "asset_id": 4196,
      "resettable": 1,
      "name": "Attack: Electricity",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 542,
      "activated": 1,
      "icon_name": "attack_electricity",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 3,
      "ranked": 0,
      "cost": 2,
      "short_description": "This unit makes a Electricity attack at its Range. This is a basic attack.",
      "long_description": "This unit makes a Electricity attack at its Range. This is a basic attack.",
      "class_name": "AttackElectricity",
      "revision": 1
    },
    {
      "asset_id": 4197,
      "resettable": 1,
      "name": "Attack: Fire",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 543,
      "activated": 1,
      "icon_name": "attack_fire",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 3,
      "ranked": 0,
      "cost": 2,
      "short_description": "This unit makes a Fire attack at its Range. This is a basic attack.",
      "long_description": "This unit makes a Fire attack at its Range. This is a basic attack.",
      "class_name": "AttackFire",
      "revision": 1
    },
    {
      "asset_id": 4213,
      "resettable": 1,
      "name": "Attack: Forglar Arrow",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 584,
      "activated": 1,
      "icon_name": "arrow",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 3,
      "ranked": 0,
      "cost": 2,
      "short_description": "This unit makes a Physical attack at its Range. This is a basic attack.",
      "long_description": "This unit makes a Physical attack at its Range. This is a basic attack.",
      "class_name": "AttackArrow",
      "revision": 1
    },
    {
      "asset_id": 4218,
      "resettable": 1,
      "name": "Attack: Forsaken Arrow",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 589,
      "activated": 1,
      "icon_name": "arrow",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 3,
      "ranked": 0,
      "cost": 2,
      "short_description": "This unit makes a Physical attack at its Range. This is a basic attack.",
      "long_description": "This unit makes a Physical attack at its Range. This is a basic attack.",
      "class_name": "AttackArrow",
      "revision": 1
    },
    {
      "asset_id": 4194,
      "resettable": 1,
      "name": "Attack: Frost",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 540,
      "activated": 1,
      "icon_name": "attack_frost",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 3,
      "ranked": 0,
      "cost": 2,
      "short_description": "This unit makes a Frost attack at its Range. This is a basic attack.",
      "long_description": "This unit makes a Frost attack at its Range. This is a basic attack.",
      "class_name": "AttackCold",
      "revision": 1
    },
    {
      "asset_id": 4203,
      "resettable": 1,
      "name": "Attack: Green Magic",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 549,
      "activated": 1,
      "icon_name": "magic",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 3,
      "ranked": 0,
      "cost": 2,
      "short_description": "This unit makes a Magical attack at its Range. This is a basic attack.",
      "long_description": "This unit makes a Magical attack at its Range. This is a basic attack.",
      "class_name": "AttackMagicalGreen",
      "revision": 1
    },
    {
      "asset_id": 4553,
      "resettable": 1,
      "name": "Attack: Gun",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 954,
      "activated": 1,
      "icon_name": "gun",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 3,
      "ranked": 0,
      "cost": 2,
      "short_description": "This unit makes a Physical attack at its Range. This is a basic attack.",
      "long_description": "This unit makes a Physical attack at its Range. This is a basic attack.",
      "class_name": "AttackGun",
      "revision": 1
    },
    {
      "asset_id": 4260,
      "resettable": 1,
      "name": "Attack: Ice Shard",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 652,
      "activated": 1,
      "icon_name": "ice",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 3,
      "ranked": 0,
      "cost": 2,
      "short_description": "This unit makes a Frost attack at its Range. This is a basic attack.",
      "long_description": "This unit makes a Frost attack at its Range. This is a basic attack.",
      "class_name": "AttackCold",
      "revision": 1
    },
    {
      "asset_id": 4217,
      "resettable": 1,
      "name": "Attack: Ironfist Arrow",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 588,
      "activated": 1,
      "icon_name": "arrow",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 3,
      "ranked": 0,
      "cost": 2,
      "short_description": "This unit makes a Physical attack at its Range. This is a basic attack.",
      "long_description": "This unit makes a Physical attack at its Range. This is a basic attack.",
      "class_name": "AttackArrow",
      "revision": 1
    },
    {
      "asset_id": 4216,
      "resettable": 1,
      "name": "Attack: K'thir Arrow",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 587,
      "activated": 1,
      "icon_name": "arrow",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 3,
      "ranked": 0,
      "cost": 2,
      "short_description": "This unit makes a Physical attack at its Range. This is a basic attack.",
      "long_description": "This unit makes a Physical attack at its Range. This is a basic attack.",
      "class_name": "AttackArrow",
      "revision": 1
    },
    {
      "asset_id": 5913,
      "resettable": 1,
      "name": "Attack: Keg",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2125,
      "activated": 1,
      "icon_name": "attack_poison",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 3,
      "ranked": 0,
      "cost": 2,
      "short_description": "This unit makes a Poison attack at its Range. This is a basic attack.",
      "long_description": "This unit makes a Poison attack at its Range. This is a basic attack.",
      "class_name": "AttackPoison",
      "revision": 1
    },
    {
      "asset_id": 5168,
      "resettable": 1,
      "name": "Attack: Loss of Life",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1943,
      "activated": 1,
      "icon_name": "lossoflife",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 3,
      "ranked": 0,
      "cost": 4,
      "short_description": "This unit makes a <mechanic value=lossoflife>Loss of Life</mechanic> attack at its Range against target champion. This is a basic attack.",
      "long_description": "This unit makes a <mechanic value=lossoflife>Loss of Life</mechanic> attack at its Range against target champion. This is a basic attack.",
      "class_name": "AttackLossOfLife",
      "revision": 1
    },
    {
      "asset_id": 4198,
      "resettable": 1,
      "name": "Attack: Magical",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 544,
      "activated": 1,
      "icon_name": "attack_magic",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 3,
      "ranked": 0,
      "cost": 2,
      "short_description": "This unit makes a Magical attack at its Range. This is a basic attack.",
      "long_description": "This unit makes a Magical attack at its Range. This is a basic attack.",
      "class_name": "AttackMagical",
      "revision": 1
    },
    {
      "asset_id": 4196,
      "resettable": 1,
      "name": "Attack: Mouth Lightning",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2270,
      "activated": 1,
      "icon_name": "attack_electricity",
      "comments": "Clone of Attack - Electricity for Voil King Ruubgaal.",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 3,
      "ranked": 0,
      "cost": 2,
      "short_description": "This unit makes an Electricity attack, from its freakin' mouth, at its Range. This is a basic attack.",
      "long_description": "This unit makes an Electricity attack, from its freakin' mouth, at its Range. This is a basic attack.",
      "class_name": "AttackElectricity",
      "revision": 1
    },
    {
      "asset_id": 4208,
      "resettable": 1,
      "name": "Attack: Net",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 554,
      "activated": 1,
      "icon_name": "net",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 3,
      "ranked": 0,
      "cost": 4,
      "short_description": "This unit makes a Physical attack at its Range. If successful, target becomes <condition value=grounded>Grounded</condition> for 2 turns. This is a basic attack.",
      "long_description": "This unit makes a Physical attack at its Range. If successful, target becomes <condition value=grounded>Grounded</condition> for 2 turns. This is a basic attack.",
      "class_name": "AttackNet",
      "revision": 1
    },
    {
      "asset_id": 4199,
      "resettable": 1,
      "name": "Attack: Physical",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 545,
      "activated": 1,
      "icon_name": "physical",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 3,
      "ranked": 0,
      "cost": 2,
      "short_description": "This unit makes a Physical attack at its range. This is a basic attack.",
      "long_description": "This unit makes a Physical attack at its range. This is a basic attack.",
      "class_name": "AttackPhysical",
      "revision": 1
    },
    {
      "asset_id": 4200,
      "resettable": 1,
      "name": "Attack: Poison",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 546,
      "activated": 1,
      "icon_name": "attack_poison",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 3,
      "ranked": 0,
      "cost": 2,
      "short_description": "This unit makes a Poison attack at its Range. This is a basic attack.",
      "long_description": "This unit makes a Poison attack at its Range. This is a basic attack.",
      "class_name": "AttackPoison",
      "revision": 1
    },
    {
      "asset_id": 4201,
      "resettable": 1,
      "name": "Attack: Psychic",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 547,
      "activated": 1,
      "icon_name": "attack_psychic",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 3,
      "ranked": 0,
      "cost": 2,
      "short_description": "This unit makes a Psychic attack at its Range. This is a basic attack.",
      "long_description": "This unit makes a Psychic attack at its Range. This is a basic attack.",
      "class_name": "AttackPsychic",
      "revision": 1
    },
    {
      "asset_id": 5915,
      "resettable": 0,
      "name": "Attack: Raven",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2949,
      "activated": 1,
      "icon_name": "physical",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 3,
      "ranked": 0,
      "cost": 2,
      "short_description": "This unit makes a Physical attack at its range. This is a basic attack.",
      "long_description": "This unit makes a Physical attack at its range. This is a basic attack.",
      "class_name": "AttackPhysical",
      "revision": 1
    },
    {
      "asset_id": 4204,
      "resettable": 1,
      "name": "Attack: Red Electricity",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 550,
      "activated": 1,
      "icon_name": "electric",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 3,
      "ranked": 0,
      "cost": 2,
      "short_description": "This unit makes a Electricity attack at its Range. This is a basic attack.",
      "long_description": "This unit makes a Electricity attack at its Range. This is a basic attack.",
      "class_name": "AttackElectricityRed",
      "revision": 1
    },
    {
      "asset_id": 4271,
      "resettable": 1,
      "name": "Attack: Rock",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 659,
      "activated": 1,
      "icon_name": "rock",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 3,
      "ranked": 0,
      "cost": 2,
      "short_description": "This unit makes a Physical attack at its range. This is a basic attack.",
      "long_description": "This unit makes a Physical attack at its range. This is a basic attack.",
      "class_name": "AttackBoulder",
      "revision": 1
    },
    {
      "asset_id": 4369,
      "resettable": 1,
      "name": "Attack: Sand",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1425,
      "activated": 1,
      "icon_name": "sand",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 3,
      "ranked": 0,
      "cost": 2,
      "short_description": "This unit makes an Physical attack at its Range. This is a basic attack.",
      "long_description": "This unit makes an Physical attack at its Range. This is a basic attack.",
      "class_name": "AttackSand",
      "revision": 1
    },
    {
      "asset_id": 4257,
      "resettable": 1,
      "name": "Attack: Savage Arrow",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 646,
      "activated": 1,
      "icon_name": "arrow",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 3,
      "ranked": 0,
      "cost": 2,
      "short_description": "This unit makes a Physical attack at its Range. This is a basic attack.",
      "long_description": "This unit makes a Physical attack at its Range. This is a basic attack.",
      "class_name": "AttackArrow",
      "revision": 1
    },
    {
      "asset_id": 4463,
      "resettable": 1,
      "name": "Attack: Shattered Arrow",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 816,
      "activated": 1,
      "icon_name": "arrow",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 3,
      "ranked": 0,
      "cost": 2,
      "short_description": "This unit makes a Physical attack at its Range. This is a basic attack.",
      "long_description": "This unit makes a Physical attack at its Range. This is a basic attack.",
      "class_name": "AttackArrow",
      "revision": 1
    },
    {
      "asset_id": 4202,
      "resettable": 1,
      "name": "Attack: Sonic",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 548,
      "activated": 1,
      "icon_name": "attack_sonic",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 3,
      "ranked": 0,
      "cost": 2,
      "short_description": "This unit makes a Sonic attack at its Range. This is a basic attack.",
      "long_description": "This unit makes a Sonic attack at its Range. This is a basic attack.",
      "class_name": "AttackSonic",
      "revision": 1
    },
    {
      "asset_id": 4259,
      "resettable": 1,
      "name": "Attack: Spear",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 648,
      "activated": 1,
      "icon_name": "spear",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 3,
      "ranked": 0,
      "cost": 2,
      "short_description": "This unit makes a Physical attack at its Range. This is a basic attack.",
      "long_description": "This unit makes a Physical attack at its Range. This is a basic attack.",
      "class_name": "AttackArrow",
      "revision": 1
    },
    {
      "asset_id": 4215,
      "resettable": 1,
      "name": "Attack: Sundered Arrow",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 586,
      "activated": 1,
      "icon_name": "arrow",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 3,
      "ranked": 0,
      "cost": 2,
      "short_description": "This unit makes a Physical attack at its Range. This is a basic attack.",
      "long_description": "This unit makes a Physical attack at its Range. This is a basic attack.",
      "class_name": "AttackArrow",
      "revision": 1
    },
    {
      "asset_id": 4196,
      "resettable": 1,
      "name": "Attack: Toe Lightning",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2521,
      "activated": 1,
      "icon_name": "attack_electricity",
      "comments": "Clone of Attack - Electricity for Drake Eminent.",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 3,
      "ranked": 0,
      "cost": 2,
      "short_description": "This unit makes an Electricity attack, from its dainty toes, at its Range. This is a basic attack.",
      "long_description": "This unit makes an Electricity attack, from its dainty toes, at its Range. This is a basic attack.",
      "class_name": "AttackElectricity",
      "revision": 1
    },
    {
      "asset_id": 4214,
      "resettable": 1,
      "name": "Attack: Underdepths Arrow",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 585,
      "activated": 1,
      "icon_name": "arrow",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 3,
      "ranked": 0,
      "cost": 2,
      "short_description": "This unit makes a Physical attack at its Range. This is a basic attack.",
      "long_description": "This unit makes a Physical attack at its Range. This is a basic attack.",
      "class_name": "AttackArrow",
      "revision": 1
    },
    {
      "asset_id": 7123,
      "resettable": 0,
      "name": "Attack: Whip",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2932,
      "activated": 1,
      "icon_name": "attack_whip",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 3,
      "ranked": 0,
      "cost": 2,
      "short_description": "This unit makes a Physical attack at its Range. This is a basic attack.",
      "long_description": "This unit makes a Physical attack at its Range. This is a basic attack.",
      "class_name": "AttackPhysical",
      "revision": 1
    },
    {
      "asset_id": 4205,
      "resettable": 1,
      "name": "Attack: Yellow Psychic",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 551,
      "activated": 1,
      "icon_name": "",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 3,
      "ranked": 0,
      "cost": 0,
      "short_description": "This unit makes a Psychic attack at its Range. This is a basic attack.",
      "long_description": "This unit makes a Psychic attack at its Range. This is a basic attack.",
      "class_name": "AttackPsychicYellow",
      "revision": 1
    },
    {
      "asset_id": 5206,
      "resettable": 1,
      "name": "Attendant",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 1983,
      "activated": 1,
      "icon_name": "attendant",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "Target Paladin within 3 spaces has +3 DMG and <ability value=396>Charge 3</ability> for 1 turn.  This ability costs an additional 5 AP if this champion has attacked this turn.",
      "long_description": "Target Paladin within 3 spaces has +3 DMG and <ability value=396>Charge 3</ability> for 1 turn.  This ability costs an additional 5 AP if this champion has attacked this turn.",
      "class_name": "Attendant",
      "revision": 1
    },
    {
      "asset_id": 4828,
      "resettable": 1,
      "name": "Augment Creation",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1710,
      "activated": 1,
      "icon_name": "surge",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 12,
      "short_description": "Friendly champions coming into play gain +2 DMG permanently.  This effect does not stack.",
      "long_description": "Friendly champions coming into play gain +2 DMG permanently.  This effect does not stack.",
      "class_name": "AugmentCreation",
      "revision": 1
    },
    {
      "asset_id": 5296,
      "resettable": 1,
      "name": "Augury",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2119,
      "activated": 1,
      "icon_name": "scry",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "This unit loses 3 HP and you gain 3 rune reveals.",
      "long_description": "This unit loses 3 HP and you gain 3 rune reveals.",
      "class_name": "Augury",
      "revision": 1
    },
    {
      "asset_id": 7480,
      "resettable": 0,
      "name": "Aurora Investigations",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3167,
      "activated": 1,
      "icon_name": "clue",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "The first time an enemy champion within 8 spaces of this champion makes a basic attack while a champion with this ability is in play, a \"Clue\" is created on the space it occupies.  When a friendly Elf or Fairy (including self) moves within 2 spaces of a space containing a \"Clue,\" the \"Clue\" is consumed and that champion gains 2 AP.",
      "long_description": "The first time an enemy champion within 8 spaces of this champion makes a basic attack while a champion with this ability is in play, a \"Clue\" is created on the space it occupies.  When a friendly Elf or Fairy (including self) moves within 2 spaces of a space containing a \"Clue,\" the \"Clue\" is consumed and that champion gains 2 AP.",
      "class_name": "AuroraInvestigations",
      "revision": 1
    },
    {
      "asset_id": 7145,
      "resettable": 0,
      "name": "Aurora Lance",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 2987,
      "activated": 1,
      "icon_name": "aurora_lance",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 3,
      "ranked": 0,
      "cost": 8,
      "short_description": "This champion makes a Magical attack at RNG 2-5.  If the attack is successful, the target becomes <condition value=blinded>Blinded</condition> for 2 turns.",
      "long_description": "This champion makes a Magical attack at RNG 2-5.  If the attack is successful, the target becomes <condition value=blinded>Blinded</condition> for 2 turns.",
      "class_name": "AuroraLance",
      "revision": 1
    },
    {
      "asset_id": 7174,
      "resettable": 0,
      "name": "Autophobia",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3017,
      "activated": 1,
      "icon_name": "autophobia",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": -10,
      "short_description": "At the beginning of its turn, this champion has -4 SPD for 1 turn unless at least one friendly champion sharing a race came into play from the runedock while this champion was in play during the last 2 turns.",
      "long_description": "At the beginning of its turn, this champion has -4 SPD for 1 turn unless at least one friendly champion sharing a race came into play from the runedock while this champion was in play during the last 2 turns.",
      "class_name": "Autophobia",
      "revision": 1
    },
    {
      "asset_id": 5110,
      "resettable": 1,
      "name": "Avalanche",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 1296,
      "activated": 1,
      "icon_name": "iceaoe",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 12,
      "short_description": "Area Effect 2, Range 5: Affected champions without <ability value=600>Arctic</ability> take 12 Frost damage.  This damage ignores DEF.  For 3 turns, spaces within the affected area are Deep Snow (Impeding 1).",
      "long_description": "Area Effect 2, Range 5: Affected champions without <ability value=600>Arctic</ability> take 12 Frost damage.  This damage ignores DEF.  For 3 turns, spaces within the affected area are Deep Snow (Impeding 1).",
      "class_name": "SnowBlast",
      "revision": 1
    },
    {
      "asset_id": 4914,
      "resettable": 1,
      "name": "Avatar",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1697,
      "activated": 1,
      "icon_name": "titan",
      "comments": "This ability is meant to be added to bosses (NPCs) in poxnora. ",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 25,
      "short_description": "This champion is immune to Stun, Slow, Ensnare, Root, Charm, Possesion, Pacify, Fear, Blinding and Knockback. This champion can not be targeted by spells or abilities which are not basic attacks. This champion takes 50% damage from spells. It cannot be relocated by other runes and cannot be removed from play. This champion may not be equipped. This champion can only be healed through regeneration, and is immune to Loss of Life effects that would cause it to lose 30 or more HP (Loss of Life effects do not include damage). This unit does not receive a faction bonus.",
      "long_description": "This champion is immune to Stun, Slow, Ensnare, Root, Charm, Possesion, Pacify, Fear, Blinding and Knockback. This champion can not be targeted by spells or abilities which are not basic attacks. This champion takes 50% damage from spells. It cannot be relocated by other runes and cannot be removed from play. This champion may not be equipped. This champion can only be healed through regeneration, and is immune to Loss of Life effects that would cause it to lose 30 or more HP (Loss of Life effects do not include damage). This unit does not receive a faction bonus.",
      "class_name": "Avatar",
      "revision": 1
    },
    {
      "asset_id": 5059,
      "resettable": 1,
      "name": "Backlash",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1913,
      "activated": 1,
      "icon_name": "nora_hex",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 4,
      "short_description": "Whenever a unit generates nora through an ability, it loses HP equal to the amount gained. If the nora was generated via a spell, the owner's shrine loses HP equal to half the amount gained. ",
      "long_description": "Whenever a unit generates nora through an ability, it loses HP equal to the amount gained. If the nora was generated via a spell, the owner's shrine loses HP equal to half the amount gained. ",
      "class_name": "Backlash",
      "revision": 1
    },
    {
      "asset_id": 4454,
      "resettable": 1,
      "name": "Bag of Boulders",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 806,
      "activated": 1,
      "icon_name": "rock",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "This champion makes a Physical attack at RNG 2-5 with +2 DMG.",
      "long_description": "This champion makes a Physical attack at RNG 2-5 with +2 DMG.",
      "class_name": "BagOfBouldersAttack",
      "revision": 1
    },
    {
      "asset_id": 4806,
      "resettable": 1,
      "name": "Balance",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 1565,
      "activated": 1,
      "icon_name": "soul_bond",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 4,
      "short_description": "When this unit comes into play, enemy champions take 2 Physical damage and friendly champions are healed for 2 HP.",
      "long_description": "When this unit comes into play, enemy champions take 2 Physical damage and friendly champions are healed for 2 HP.",
      "class_name": "Balance",
      "revision": 1
    },
    {
      "asset_id": 4806,
      "resettable": 1,
      "name": "Balance",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 1566,
      "activated": 1,
      "icon_name": "soul_bond",
      "comments": "",
      "prerequisite_id": 1565,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 6,
      "short_description": "When this unit comes into play, enemy champions take 3 Physical damage and friendly champions are healed for 2 HP.",
      "long_description": "When this unit comes into play, enemy champions take 3 Physical damage and friendly champions are healed for 2 HP.",
      "class_name": "Balance",
      "revision": 1
    },
    {
      "asset_id": 4806,
      "resettable": 1,
      "name": "Balance",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 1567,
      "activated": 1,
      "icon_name": "soul_bond",
      "comments": "",
      "prerequisite_id": 1566,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 8,
      "short_description": "When this unit comes into play, enemy champions take 3 Physical damage and friendly champions are healed for 3 HP.",
      "long_description": "When this unit comes into play, enemy champions take 3 Physical damage and friendly champions are healed for 3 HP.",
      "class_name": "Balance",
      "revision": 1
    },
    {
      "asset_id": 4806,
      "resettable": 1,
      "name": "Balance",
      "ap_cost": 0,
      "level": 4,
      "ability_id": 1568,
      "activated": 1,
      "icon_name": "soul_bond",
      "comments": "",
      "prerequisite_id": 1567,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 10,
      "short_description": "When this unit comes into play, enemy champions take 4 Physical damage and friendly champions are healed for 3 HP.",
      "long_description": "When this unit comes into play, enemy champions take 4 Physical damage and friendly champions are healed for 3 HP.",
      "class_name": "Balance",
      "revision": 1
    },
    {
      "asset_id": 7601,
      "resettable": 0,
      "name": "Ballista Assault Mode",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 3229,
      "activated": 1,
      "icon_name": "ballista_mode",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "Until this champion moves, when an enemy unit within this unit's range is the target of a friendly basic attack from another unit, this unit makes a basic Fire attack against the same target for 2 AP.",
      "long_description": "Until this champion moves, when an enemy unit within this unit's range is the target of a friendly basic attack from another unit, this unit makes a basic Fire attack against the same target for 2 AP.",
      "class_name": "BallistaAssaultMode",
      "revision": 1
    },
    {
      "asset_id": 5650,
      "resettable": 1,
      "name": "Bambura's Revenge",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2522,
      "activated": 1,
      "icon_name": "",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "This ability spawns lots of champions.",
      "long_description": "This ability spawns lots of champions.",
      "class_name": "BamburasRevenge",
      "revision": 1
    },
    {
      "asset_id": 5383,
      "resettable": 1,
      "name": "Banditry",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2212,
      "activated": 1,
      "icon_name": "banditry",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "Whenever this champion successfully damages a champion with any attack, that champion's controller loses up to 2 nora and you gain nora equal to the amount lost.",
      "long_description": "Whenever this champion successfully damages a champion with any attack, that champion's controller loses up to 2 nora and you gain nora equal to the amount lost.",
      "class_name": "Banditry",
      "revision": 1
    },
    {
      "asset_id": 4501,
      "resettable": 0,
      "name": "Barbarian Bound",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2937,
      "activated": 1,
      "icon_name": "savage",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -8,
      "short_description": "At the beginning of your enemy's turns, if there are no other friendly Barbarians in play, this unit is <condition value=possessed>Possessed</condition> by your enemy until end of turn.",
      "long_description": "At the beginning of your enemy's turns, if there are no other friendly Barbarians in play, this unit is <condition value=possessed>Possessed</condition> by your enemy until end of turn.",
      "class_name": "BarbarianBound",
      "revision": 1
    },
    {
      "asset_id": 4830,
      "resettable": 1,
      "name": "Barbarian Rider",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1712,
      "activated": 1,
      "icon_name": "rider",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 15,
      "short_description": "When this unit is destroyed, no nora globe is dropped and a Renegade with no upgrades is spawned in the location this unit occupied.",
      "long_description": "When this unit is destroyed, no nora globe is dropped and a Renegade with no upgrades is spawned in the location this unit occupied.",
      "class_name": "BarbarianRider",
      "revision": 1
    },
    {
      "asset_id": 4390,
      "resettable": 1,
      "name": "Barbaric Assault",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1431,
      "activated": 1,
      "icon_name": "multiattack",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "This unit gains <ability value=1348>Punish</ability> and <ability value=1242>Pace</ability> when another friendly Barbarian is within 3 spaces.",
      "long_description": "This unit gains <ability value=1348>Punish</ability> and <ability value=1242>Pace</ability> when another friendly Barbarian is within 3 spaces.",
      "class_name": "BarbaricAssault",
      "revision": 1
    },
    {
      "asset_id": 4058,
      "resettable": 1,
      "name": "Barrage",
      "ap_cost": 1,
      "level": 1,
      "ability_id": 100,
      "activated": 1,
      "icon_name": "arrowaoe",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 1,
      "cost": 4,
      "short_description": "This champion makes its basic ranged attack against target opposing champion. If successful, this unit makes an additional basic attack for free against the same target.",
      "long_description": "This champion makes its basic ranged attack against target opposing champion. If successful, this unit makes an additional basic attack for free against the same target.",
      "class_name": "Barrage",
      "revision": 1
    },
    {
      "asset_id": 4058,
      "resettable": 1,
      "name": "Barrage",
      "ap_cost": 1,
      "level": 2,
      "ability_id": 101,
      "activated": 1,
      "icon_name": "arrowaoe",
      "comments": "none",
      "prerequisite_id": 100,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 7,
      "short_description": "This champion makes its basic ranged attack against target opposing champion. If successful, this unit makes an additional basic attack for free against the same target.",
      "long_description": "This champion makes its basic ranged attack against target opposing champion. If successful, this unit makes an additional basic attack for free against the same target.",
      "class_name": "Barrage",
      "revision": 1
    },
    {
      "asset_id": 4058,
      "resettable": 1,
      "name": "Barrage",
      "ap_cost": 1,
      "level": 3,
      "ability_id": 102,
      "activated": 1,
      "icon_name": "arrowaoe",
      "comments": "none",
      "prerequisite_id": 101,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 1,
      "cost": 10,
      "short_description": "This champion makes its basic ranged attack against target opposing champion. If successful, this unit makes an additional basic attack for free against the same target.",
      "long_description": "This champion makes its basic ranged attack against target opposing champion. If successful, this unit makes an additional basic attack for free against the same target.",
      "class_name": "Barrage",
      "revision": 1
    },
    {
      "asset_id": 5398,
      "resettable": 1,
      "name": "Barricade",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2230,
      "activated": 1,
      "icon_name": "barricade",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this unit activates <ability value=1987>Hold the Line</ability>, it gains <ability value=1382>Prestige</ability> and <ability value=1209>Defiant</ability>. These abilities are removed when the condition of Holding the Line ends.",
      "long_description": "When this unit activates <ability value=1987>Hold the Line</ability>, it gains <ability value=1382>Prestige</ability> and <ability value=1209>Defiant</ability>. These abilities are removed when the condition of Holding the Line ends.",
      "class_name": "Barricade",
      "revision": 1
    },
    {
      "asset_id": 7597,
      "resettable": 0,
      "name": "Barricade Barrier",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 3225,
      "activated": 1,
      "icon_name": "charged_barricade",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 2,
      "ranked": 0,
      "cost": 10,
      "short_description": "Range 3: Summon a Barricade relic in target unoccupied space and all adjacent unoccupied spaces.",
      "long_description": "Range 3: Summon a Barricade relic in target unoccupied space and all adjacent unoccupied spaces.",
      "class_name": "BarricadeBarrier",
      "revision": 1
    },
    {
      "asset_id": 5164,
      "resettable": 1,
      "name": "Bash",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 2131,
      "activated": 1,
      "icon_name": "stab",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "This champion makes a Physical melee attack against target champion.",
      "long_description": "This champion makes a Physical melee attack against target champion.",
      "class_name": "Bash",
      "revision": 1
    },
    {
      "asset_id": 7811,
      "resettable": 0,
      "name": "Bashful Mika",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3323,
      "activated": 1,
      "icon_name": "intoxicate",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "When this champion is attacked, the attacking champion becomes <condition value=charmed>Charmed 3</condition>. All affected champions are disengaged from each other.",
      "long_description": "When this champion is attacked, the attacking champion becomes <condition value=charmed>Charmed 3</condition>. All affected champions are disengaged from each other.",
      "class_name": "BashfulMika",
      "revision": 1
    },
    {
      "asset_id": 5044,
      "resettable": 1,
      "name": "Bastion of Courage",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1223,
      "activated": 1,
      "icon_name": "tgtdefensive",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "Friendly champions have <ability value=3>Fearless</ability>.",
      "long_description": "Friendly champions have <ability value=3>Fearless</ability>.",
      "class_name": "BastionOfCourage",
      "revision": 1
    },
    {
      "asset_id": 5602,
      "resettable": 1,
      "name": "Bastion of Mobility",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1225,
      "activated": 1,
      "icon_name": "mobility",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "Friendly champions within 8 spaces have <ability value=6>Mobility</ability>.",
      "long_description": "Friendly champions within 8 spaces have <ability value=6>Mobility</ability>.",
      "class_name": "BastionOfMobility",
      "revision": 1
    },
    {
      "asset_id": 5045,
      "resettable": 1,
      "name": "Bastion of Will",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1224,
      "activated": 1,
      "icon_name": "iron_will",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "Friendly champions have <ability value=4>Iron Will</ability>.",
      "long_description": "Friendly champions have <ability value=4>Iron Will</ability>.",
      "class_name": "BastionOfWill",
      "revision": 1
    },
    {
      "asset_id": 5393,
      "resettable": 1,
      "name": "Bat Crypt",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2225,
      "activated": 1,
      "icon_name": "sumbat",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "When this relic is deployed and every 6 turns, a Bat Swarm with no upgrades is summoned on the nearest unoccupied space within 5 spaces. This relic loses 8 HP each time a Bat Swarm is summoned.",
      "long_description": "When this relic is deployed and every 6 turns, a Bat Swarm with no upgrades is summoned on the nearest unoccupied space within 5 spaces. This relic loses 8 HP each time a Bat Swarm is summoned.",
      "class_name": "BatCrypt",
      "revision": 1
    },
    {
      "asset_id": 4278,
      "resettable": 1,
      "name": "Battle Drum",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 668,
      "activated": 1,
      "icon_name": "drum",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "All friendly champions from the same faction as this one gain <condition value=benediction>Benediction</condition> for 1 turn and recover 1 AP.",
      "long_description": "All friendly champions from the same faction as this one gain <condition value=benediction>Benediction</condition> for 1 turn and recover 1 AP.",
      "class_name": "BattleDrum",
      "revision": 1
    },
    {
      "asset_id": 4472,
      "resettable": 1,
      "name": "Battle Harden",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 847,
      "activated": 1,
      "icon_name": "allybuffs",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 2,
      "short_description": "When this unit is deployed, friendly champions that share a faction with this champion gain +4 MAX HP for 6 turns. This does not stack.",
      "long_description": "When this unit is deployed, friendly champions that share a faction with this champion gain +4 MAX HP for 6 turns. This does not stack.",
      "class_name": "BattleHarden",
      "revision": 1
    },
    {
      "asset_id": 4472,
      "resettable": 1,
      "name": "Battle Harden",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 853,
      "activated": 1,
      "icon_name": "allybuffs",
      "comments": "",
      "prerequisite_id": 847,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 5,
      "short_description": "When this unit is deployed, friendly champions that share a faction with this champion gain +6 MAX HP and +1 DMG for 8 turns. This does not stack.",
      "long_description": "When this unit is deployed, friendly champions that share a faction with this champion gain +6 MAX HP and +1 DMG for 8 turns. This does not stack.",
      "class_name": "BattleHarden",
      "revision": 1
    },
    {
      "asset_id": 4472,
      "resettable": 1,
      "name": "Battle Harden",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 854,
      "activated": 1,
      "icon_name": "allybuffs",
      "comments": "",
      "prerequisite_id": 853,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 8,
      "short_description": "When this unit is deployed, friendly champions that share a faction with this champion gain +8 MAX HP and +1 DMG for 8 turns. This does not stack.",
      "long_description": "When this unit is deployed, friendly champions that share a faction with this champion gain +8 MAX HP and +1 DMG for 8 turns. This does not stack.",
      "class_name": "BattleHarden",
      "revision": 1
    },
    {
      "asset_id": 4594,
      "resettable": 1,
      "name": "Battle Hymn",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 976,
      "activated": 1,
      "icon_name": "dancesong",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 12,
      "short_description": "All friendly champions get <condition value=reverie>Reverie</condition> for 1 turn and recovers 2 AP.",
      "long_description": "All friendly champions get <condition value=reverie>Reverie</condition> for 1 turn and recovers 2 AP.",
      "class_name": "BattleHymn",
      "revision": 1
    },
    {
      "asset_id": 5533,
      "resettable": 1,
      "name": "Battle Leader",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2392,
      "activated": 1,
      "icon_name": "divine",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this champion destroys an opposing champion, friendly champions permanently gain +1 DMG. If those champions also share a race or class with this champion, they also are healed for 3 HP.",
      "long_description": "When this champion destroys an opposing champion, friendly champions permanently gain +1 DMG. If those champions also share a race or class with this champion, they also are healed for 3 HP.",
      "class_name": "BattleLeader",
      "revision": 1
    },
    {
      "asset_id": 5011,
      "resettable": 1,
      "name": "Battlefiend",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1191,
      "activated": 1,
      "icon_name": "berserker",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 15,
      "short_description": "When this unit's DMG modifier is greater than 5, it gets +2 SPD, <ability value=732>Fury</ability>, <ability value=15>Multiattack 1</ability> and <ability value=25>Berserker 3</ability>.",
      "long_description": "When this unit's DMG modifier is greater than 5, it gets +2 SPD, <ability value=732>Fury</ability>, <ability value=15>Multiattack 1</ability> and <ability value=25>Berserker 3</ability>.",
      "class_name": "Battlefiend",
      "revision": 1
    },
    {
      "asset_id": 4006,
      "resettable": 1,
      "name": "Battlemaster",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 7,
      "activated": 1,
      "icon_name": "aurapositive",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 5,
      "short_description": "Friendly champions within 2 spaces get +2 DMG and +1 DEF.  This effect does not stack.",
      "long_description": "Friendly champions within 2 spaces get +2 DMG and +1 DEF.  This effect does not stack.",
      "class_name": "Battlemaster",
      "revision": 1
    },
    {
      "asset_id": 4006,
      "resettable": 1,
      "name": "Battlemaster",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 8,
      "activated": 1,
      "icon_name": "aurapositive",
      "comments": "none",
      "prerequisite_id": 7,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 8,
      "short_description": "Friendly champions within 3 spaces get +2 DMG and +1 DEF.  This effect does not stack.",
      "long_description": "Friendly champions within 3 spaces get +2 DMG and +1 DEF.  This effect does not stack.",
      "class_name": "Battlemaster",
      "revision": 1
    },
    {
      "asset_id": 4006,
      "resettable": 1,
      "name": "Battlemaster",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 9,
      "activated": 1,
      "icon_name": "aurapositive",
      "comments": "none",
      "prerequisite_id": 8,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 11,
      "short_description": "Friendly champions within 4 spaces get +2 DMG and +1 DEF.  This effect does not stack.",
      "long_description": "Friendly champions within 4 spaces get +2 DMG and +1 DEF.  This effect does not stack.",
      "class_name": "Battlemaster",
      "revision": 1
    },
    {
      "asset_id": 5391,
      "resettable": 1,
      "name": "Beacon",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2223,
      "activated": 1,
      "icon_name": "independent",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "Starting on your next turn, spaces adjacent to this relic are deployment zones for the controller of this relic.",
      "long_description": "Starting on your next turn, spaces adjacent to this relic are deployment zones for the controller of this relic.",
      "class_name": "Beacon",
      "revision": 1
    },
    {
      "asset_id": 4504,
      "resettable": 1,
      "name": "Bear Form",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 858,
      "activated": 1,
      "icon_name": "transform",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "This champion gets Race: Beast, <ability value=1869>Hibernate</ability>, <ability value=261>Enrage 3</ability>, is <mechanic value=cleansed>Cleansed</mechanic>, and has RNG 1, -5 DMG, +1 DEF, and +25 MAX HP.",
      "long_description": "This champion gets Race: Beast, <ability value=1869>Hibernate</ability>, <ability value=261>Enrage 3</ability>, is <mechanic value=cleansed>Cleansed</mechanic>, and has RNG 1, -5 DMG, +1 DEF, and +25 MAX HP.",
      "class_name": "BearForm",
      "revision": 1
    },
    {
      "asset_id": 5173,
      "resettable": 1,
      "name": "Bear Kinship",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1950,
      "activated": 1,
      "icon_name": "buff",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 1,
      "short_description": "If a friendly Enraged Grizzly is in play, this champion gets +2 DMG and 2 additional ranks of <ability value=259>Enrage</ability>. If no other friendly Garu, this unit has -1 SPD.",
      "long_description": "If a friendly Enraged Grizzly is in play, this champion gets +2 DMG and 2 additional ranks of <ability value=259>Enrage</ability>. If no other friendly Garu, this unit has -1 SPD.",
      "class_name": "BearKinship",
      "revision": 1
    },
    {
      "asset_id": 5489,
      "resettable": 1,
      "name": "Beast Herder",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 2348,
      "activated": 1,
      "icon_name": "desert_hearder",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "Friendly Beasts within 5 spaces gain 3 AP and <ability value=396>Charge 3</ability> for 1 turn.  If the champion already has Charge, it gains <ability value=2092>Crushing Charge</ability> instead.",
      "long_description": "Friendly Beasts within 5 spaces gain 3 AP and <ability value=396>Charge 3</ability> for 1 turn.  If the champion already has Charge, it gains <ability value=2092>Crushing Charge</ability> instead.",
      "class_name": "BeastHerder",
      "revision": 1
    },
    {
      "asset_id": 7608,
      "resettable": 0,
      "name": "Beckoning Guile",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 3235,
      "activated": 1,
      "icon_name": "pull_guile",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "Target a space within 5 spaces. Enemy champions without <ability value=4>Iron Will</ability> within 5 spaces of the target move one space towards it.",
      "long_description": "Target a space within 5 spaces. Enemy champions without <ability value=4>Iron Will</ability> within 5 spaces of the target move one space towards it.",
      "class_name": "BeckoningGuile",
      "revision": 1
    },
    {
      "asset_id": 5192,
      "resettable": 1,
      "name": "Become: Bull",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 1969,
      "activated": 1,
      "icon_name": "transform",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "This ability begins play on cooldown. This champion loses this ability and the ability Become: Shaman, is <mechanic value=cleansed>Cleansed</mechanic>, and gets +3 DMG, +10 MAX HP, +1 DEF, Class: Warrior, <ability value=597>Unstoppable</ability> and <ability value=108>Pummel 1</ability>.",
      "long_description": "This ability begins play on cooldown. This champion loses this ability and the ability Become: Shaman, is <mechanic value=cleansed>Cleansed</mechanic>, and gets +3 DMG, +10 MAX HP, +1 DEF, Class: Warrior, <ability value=597>Unstoppable</ability> and <ability value=108>Pummel 1</ability>.",
      "class_name": "BecomeBull",
      "revision": 1
    },
    {
      "asset_id": 5193,
      "resettable": 1,
      "name": "Become: Shaman",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 1970,
      "activated": 1,
      "icon_name": "transform",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "This ability begins play on cooldown. This champion is <mechanic value=cleansed>Cleansed</mechanic>, loses this ability and the ability Become: Bull, and then it gains <ability value=367>Heal Champion 2</ability>, <ability value=1443>Council: Spells</ability>, <ability value=544>Attack: Magical</ability>Class: Shaman, its range becomes RNG 2-4.",
      "long_description": "This ability begins play on cooldown. This champion is <mechanic value=cleansed>Cleansed</mechanic>, loses this ability and the ability Become: Bull, and then it gains <ability value=367>Heal Champion 2</ability>, <ability value=1443>Council: Spells</ability>, <ability value=544>Attack: Magical</ability>Class: Shaman, its range becomes RNG 2-4.",
      "class_name": "BecomeShaman",
      "revision": 1
    },
    {
      "asset_id": 4136,
      "resettable": 1,
      "name": "Berserk Attack",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 346,
      "activated": 1,
      "icon_name": "offenseenhance",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 1,
      "cost": 0,
      "short_description": "This unit makes a close-combat attack at +2 DMG and becomes Berserked (This unit gets -2 DEF) for 2 turns.",
      "long_description": "This unit makes a close-combat attack at +2 DMG and becomes Berserked (This unit gets -2 DEF) for 2 turns.",
      "class_name": "BerserkAttack",
      "revision": 1
    },
    {
      "asset_id": 4136,
      "resettable": 1,
      "name": "Berserk Attack",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 347,
      "activated": 1,
      "icon_name": "offenseenhance",
      "comments": "none",
      "prerequisite_id": 346,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 1,
      "cost": 1,
      "short_description": "This unit makes a close-combat attack at +3 DMG and becomes Berserked (This unit gets -2 DEF) for 2 turns.",
      "long_description": "This unit makes a close-combat attack at +3 DMG and becomes Berserked (This unit gets -2 DEF) for 2 turns.",
      "class_name": "BerserkAttack",
      "revision": 1
    },
    {
      "asset_id": 4136,
      "resettable": 1,
      "name": "Berserk Attack",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 348,
      "activated": 1,
      "icon_name": "offenseenhance",
      "comments": "none",
      "prerequisite_id": 347,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 1,
      "cost": 2,
      "short_description": "This unit makes a close-combat attack at +4 DMG and becomes Berserked (This unit gets -2 DEF) for 2 turns.",
      "long_description": "This unit makes a close-combat attack at +4 DMG and becomes Berserked (This unit gets -2 DEF) for 2 turns.",
      "class_name": "BerserkAttack",
      "revision": 1
    },
    {
      "asset_id": 4010,
      "resettable": 1,
      "name": "Berserker",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 23,
      "activated": 1,
      "icon_name": "berserker",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": -5,
      "short_description": "This champion gets +2 DMG and <ability value=2005>Careless</ability>",
      "long_description": "This champion gets +2 DMG and <ability value=2005>Careless</ability>",
      "class_name": "Berserker",
      "revision": 1
    },
    {
      "asset_id": 4010,
      "resettable": 1,
      "name": "Berserker",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 24,
      "activated": 1,
      "icon_name": "berserker",
      "comments": "none",
      "prerequisite_id": 23,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 3,
      "short_description": "This champion gets +1 SPD, +3 DMG, and <ability value=2005>Careless</ability>.",
      "long_description": "This champion gets +1 SPD, +3 DMG, and <ability value=2005>Careless</ability>.",
      "class_name": "Berserker",
      "revision": 1
    },
    {
      "asset_id": 4010,
      "resettable": 1,
      "name": "Berserker",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 25,
      "activated": 1,
      "icon_name": "berserker",
      "comments": "none",
      "prerequisite_id": 24,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 12,
      "short_description": "This champion gets +2 SPD, +4 DMG, and <ability value=2005>Careless</ability>",
      "long_description": "This champion gets +2 SPD, +4 DMG, and <ability value=2005>Careless</ability>",
      "class_name": "Berserker",
      "revision": 1
    },
    {
      "asset_id": 7743,
      "resettable": 0,
      "name": "Beset",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 3277,
      "activated": 1,
      "icon_name": "relocate",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "This champion relocates to adjacent to target enemy champion with the <condition value=tagged>Tagged</condition> condition.",
      "long_description": "This champion relocates to adjacent to target enemy champion with the <condition value=tagged>Tagged</condition> condition.",
      "class_name": "Beset",
      "revision": 1
    },
    {
      "asset_id": 4813,
      "resettable": 1,
      "name": "Bestial Presence",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 1623,
      "activated": 1,
      "icon_name": "allybuffs",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 5,
      "short_description": "When this unit comes into play, all friendly champions gain +1 DMG for 2 turns.",
      "long_description": "When this unit comes into play, all friendly champions gain +1 DMG for 2 turns.",
      "class_name": "BestialPresence",
      "revision": 1
    },
    {
      "asset_id": 4813,
      "resettable": 1,
      "name": "Bestial Presence",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 1624,
      "activated": 1,
      "icon_name": "allybuffs",
      "comments": "",
      "prerequisite_id": 1623,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 6,
      "short_description": "When this unit comes into play, all friendly champions gain +2 DMG for 2 turns.",
      "long_description": "When this unit comes into play, all friendly champions gain +2 DMG for 2 turns.",
      "class_name": "BestialPresence",
      "revision": 1
    },
    {
      "asset_id": 4813,
      "resettable": 1,
      "name": "Bestial Presence",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 1625,
      "activated": 1,
      "icon_name": "allybuffs",
      "comments": "",
      "prerequisite_id": 1624,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 7,
      "short_description": "When this unit comes into play, all friendly champions gain +2 DMG and +5 HP for 4 turns.",
      "long_description": "When this unit comes into play, all friendly champions gain +2 DMG and +5 HP for 4 turns.",
      "class_name": "BestialPresence",
      "revision": 1
    },
    {
      "asset_id": 5664,
      "resettable": 1,
      "name": "Bestow",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2536,
      "activated": 1,
      "icon_name": "grantability",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 2,
      "short_description": "When this champion is destroyed, the closest friendly champion gains this unit's first upgrade ability. If that champion shares a race with this one, it gains the second upgrade ability as well.",
      "long_description": "When this champion is destroyed, the closest friendly champion gains this unit's first upgrade ability. If that champion shares a race with this one, it gains the second upgrade ability as well.",
      "class_name": "Bestow",
      "revision": 1
    },
    {
      "asset_id": 4192,
      "resettable": 1,
      "name": "Bile Explosion",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 534,
      "activated": 1,
      "icon_name": "deathnovaacid",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 9,
      "short_description": "When this unit is destroyed, units within 2 spaces take 5 Acid damage (ignores DEF), are <condition value=blinded>Blinded</condition> for 2 turns and become <condition value=scoured>Scoured</condition> for 2 turns.",
      "long_description": "When this unit is destroyed, units within 2 spaces take 5 Acid damage (ignores DEF), are <condition value=blinded>Blinded</condition> for 2 turns and become <condition value=scoured>Scoured</condition> for 2 turns.",
      "class_name": "BileExplosion",
      "revision": 1
    },
    {
      "asset_id": 4192,
      "resettable": 1,
      "name": "Bile Explosion",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 535,
      "activated": 1,
      "icon_name": "deathnovaacid",
      "comments": "none",
      "prerequisite_id": 534,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 12,
      "short_description": "When this unit is destroyed, units within 2 spaces take 10 Acid damage (ignores DEF), are <condition value=blinded>Blinded</condition> for 2 turns and become <condition value=scoured>Scoured</condition> for 2 turns.",
      "long_description": "When this unit is destroyed, units within 2 spaces take 10 Acid damage (ignores DEF), are <condition value=blinded>Blinded</condition> for 2 turns and become <condition value=scoured>Scoured</condition> for 2 turns.",
      "class_name": "BileExplosion",
      "revision": 1
    },
    {
      "asset_id": 4192,
      "resettable": 1,
      "name": "Bile Explosion",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 536,
      "activated": 1,
      "icon_name": "deathnovaacid",
      "comments": "none",
      "prerequisite_id": 535,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 15,
      "short_description": "When this unit is destroyed, units within 2 spaces take 15 Acid damage (ignores DEF), are <condition value=blinded>Blinded</condition> for 2 turns and become <condition value=scoured>Scoured</condition> for 2 turns.",
      "long_description": "When this unit is destroyed, units within 2 spaces take 15 Acid damage (ignores DEF), are <condition value=blinded>Blinded</condition> for 2 turns and become <condition value=scoured>Scoured</condition> for 2 turns.",
      "class_name": "BileExplosion",
      "revision": 1
    },
    {
      "asset_id": 7768,
      "resettable": 0,
      "name": "Bind: Spells",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3293,
      "activated": 1,
      "icon_name": "bind_spells",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 5,
      "short_description": "When this champion destroys an enemy champion, enemy spells cost 5 nora more to play while this champion is in play. This ability triggers up to 3 times.",
      "long_description": "When this champion destroys an enemy champion, enemy spells cost 5 nora more to play while this champion is in play. This ability triggers up to 3 times.",
      "class_name": "DeathBindSpellAegis",
      "revision": 1
    },
    {
      "asset_id": 4126,
      "resettable": 1,
      "name": "Binding Chains",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2678,
      "activated": 1,
      "icon_name": "disable",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 3,
      "ranked": 0,
      "cost": 7,
      "short_description": "Enemy champions within 3 spaces take 8 Physical damage and become <condition value=ensnared>Ensnared</condition> for 2 turns (this damage ignores DEF).  This ability's CD is reduced by 1 whenever this champion is successfully attacked.",
      "long_description": "Enemy champions within 3 spaces take 8 Physical damage and become <condition value=ensnared>Ensnared</condition> for 2 turns (this damage ignores DEF).  This ability's CD is reduced by 1 whenever this champion is successfully attacked.",
      "class_name": "BindingChains",
      "revision": 1
    },
    {
      "asset_id": 5405,
      "resettable": 1,
      "name": "Biogenesis",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2237,
      "activated": 1,
      "icon_name": "sumtree",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 15,
      "short_description": "When this champion is deployed and at the end of its every third turn, a Young Sapling is summoned to an adjacent space.",
      "long_description": "When this champion is deployed and at the end of its every third turn, a Young Sapling is summoned to an adjacent space.",
      "class_name": "Biogenesis",
      "revision": 1
    },
    {
      "asset_id": 5406,
      "resettable": 1,
      "name": "Black Tempest",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2238,
      "activated": 1,
      "icon_name": "black_tempest",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 18,
      "short_description": "At the beginning of each of this unit's turns, a random opposing champion within 8 spaces takes 6 Electricity damage (this damage ignores DEF).  For every 5 champions in play, this ability triggers again but can only affect a unit once per turn.",
      "long_description": "At the beginning of each of this unit's turns, a random opposing champion within 8 spaces takes 6 Electricity damage (this damage ignores DEF).  For every 5 champions in play, this ability triggers again but can only affect a unit once per turn.",
      "class_name": "BlackTempest",
      "revision": 1
    },
    {
      "asset_id": 5759,
      "resettable": 1,
      "name": "Blackguard Banner",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2771,
      "activated": 1,
      "icon_name": "defenseenhance",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "Friendly Skeezick Blackguards have +1 DMG and <ability value=1900>Tough 1 </ability>.",
      "long_description": "Friendly Skeezick Blackguards have +1 DMG and <ability value=1900>Tough 1 </ability>.",
      "class_name": "BlackguardBanner",
      "revision": 1
    },
    {
      "asset_id": 5793,
      "resettable": 1,
      "name": "Blackguard Training",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2772,
      "activated": 1,
      "icon_name": "defenseenhance",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "For every 25 damage this champion deals, a Blackguard Banner Relic with <ability value=2771>Blackguard Banner</ability> is deployed in an adjacent space.",
      "long_description": "For every 25 damage this champion deals, a Blackguard Banner Relic with <ability value=2771>Blackguard Banner</ability> is deployed in an adjacent space.",
      "class_name": "Blackguard",
      "revision": 1
    },
    {
      "asset_id": 4391,
      "resettable": 1,
      "name": "Blast",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 1432,
      "activated": 1,
      "icon_name": "magicaoe",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "This champion makes a Magic attack against every enemy champion within its range.",
      "long_description": "This champion makes a Magic attack against every enemy champion within its range.",
      "class_name": "Blast",
      "revision": 1
    },
    {
      "asset_id": 4198,
      "resettable": 1,
      "name": "Blast Attack",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2805,
      "activated": 1,
      "icon_name": "attack_magic",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 3,
      "ranked": 0,
      "cost": 0,
      "short_description": "This unit makes a Magical attack at its Range. This is not a basic attack.",
      "long_description": "This unit makes a Magical attack at its Range. This is not a basic attack.",
      "class_name": "BlastAttack",
      "revision": 1
    },
    {
      "asset_id": 4571,
      "resettable": 1,
      "name": "Bleed",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 977,
      "activated": 1,
      "icon_name": "blood_debt",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 6,
      "short_description": "When this unit damages a champion with a basic attack, the target is <condition value=bloodied>Bloodied</condition> for 6 turns and a blood ball is created in an adjacent space. Archdemons, Demons and Vampyres that capture the blood ball vampiric heal equal to 50% of the damage. Other champions take the same amount in disease damage. Only one blood ball per enemy can be active.",
      "long_description": "When this unit damages a champion with a basic attack, the target is <condition value=bloodied>Bloodied</condition> for 6 turns and a blood ball is created in an adjacent space. Archdemons, Demons and Vampyres that capture the blood ball vampiric heal equal to 50% of the damage. Other champions take the same amount in disease damage. Only one blood ball per enemy can be active.",
      "class_name": "Bleed",
      "revision": 1
    },
    {
      "asset_id": 4534,
      "resettable": 1,
      "name": "Blessed",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 867,
      "activated": 1,
      "icon_name": "blessed",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 4,
      "short_description": "At the beginning of your turn, if this unit was damaged the previous turn, it heals 5 HP.",
      "long_description": "At the beginning of your turn, if this unit was damaged the previous turn, it heals 5 HP.",
      "class_name": "Blessed",
      "revision": 1
    },
    {
      "asset_id": 5329,
      "resettable": 1,
      "name": "Blessing of Snowfall",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2158,
      "activated": 1,
      "icon_name": "domain_snow",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "This unit loses 3 HP. Friendly champions have <ability value=600>Arctic</ability> and Trail: Snow for 4 turns.",
      "long_description": "This unit loses 3 HP. Friendly champions have <ability value=600>Arctic</ability> and Trail: Snow for 4 turns.",
      "class_name": "BlessingOfSnowfall",
      "revision": 1
    },
    {
      "asset_id": 5478,
      "resettable": 1,
      "name": "Blessing of Stone",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 2337,
      "activated": 1,
      "icon_name": "resistance_physical",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "For 4 turns, all friendly champions gain 2 ranks of <ability value=47>Resistance: Physical</ability>. Friendly champions that are occupying rock terrain also gain <ability value=1242>Pace</ability> for 4 turns.",
      "long_description": "For 4 turns, all friendly champions gain 2 ranks of <ability value=47>Resistance: Physical</ability>. Friendly champions that are occupying rock terrain also gain <ability value=1242>Pace</ability> for 4 turns.",
      "class_name": "BlessingOfStone",
      "revision": 1
    },
    {
      "asset_id": 5141,
      "resettable": 1,
      "name": "Blessing of the Fallen",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1898,
      "activated": 1,
      "icon_name": "ondeath",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 5,
      "short_description": "When this unit is destroyed, friendly champions gain +1 DEF for 4 turns (this does not stack) and heal 10 HP.",
      "long_description": "When this unit is destroyed, friendly champions gain +1 DEF for 4 turns (this does not stack) and heal 10 HP.",
      "class_name": "BlessingOfTheFallen",
      "revision": 1
    },
    {
      "asset_id": 5622,
      "resettable": 1,
      "name": "Blind",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2486,
      "activated": 1,
      "icon_name": "blind",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "Target champion within 4 spaces is <condition value=blinded>Blinded</condition> for 2 turns.",
      "long_description": "Target champion within 4 spaces is <condition value=blinded>Blinded</condition> for 2 turns.",
      "class_name": "Blind",
      "revision": 1
    },
    {
      "asset_id": 4659,
      "resettable": 1,
      "name": "Blindfire",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1141,
      "activated": 1,
      "icon_name": "blindfire",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 8,
      "short_description": "When an enemy champion within this units range makes a successful ranged attack against a champion, this champion makes a Physical ranged combat attack against that champion for free.",
      "long_description": "When an enemy champion within this units range makes a successful ranged attack against a champion, this champion makes a Physical ranged combat attack against that champion for free.",
      "class_name": "BlindFire",
      "revision": 1
    },
    {
      "asset_id": 7122,
      "resettable": 0,
      "name": "Blindfold",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2930,
      "activated": 1,
      "icon_name": "blind",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -15,
      "short_description": "This champion is Blinded (This unit's attacks automatically miss)",
      "long_description": "This champion is Blinded (This unit's attacks automatically miss)",
      "class_name": "Blindfold",
      "revision": 1
    },
    {
      "asset_id": 5919,
      "resettable": 0,
      "name": "Blinding",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2953,
      "activated": 1,
      "icon_name": "blind",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "When this champion is attacked, the attacking champion becomes <condition value=blinded>Blinded</condition> for 2 turns. ",
      "long_description": "When this champion is attacked, the attacking champion becomes <condition value=blinded>Blinded</condition> for 2 turns. ",
      "class_name": "Blinding",
      "revision": 1
    },
    {
      "asset_id": 4775,
      "resettable": 1,
      "name": "Blitz",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1509,
      "activated": 1,
      "icon_name": "initiative",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "This champion gets +1 DMG for 2 turns for each space it moves, to a maximum of 5.",
      "long_description": "This champion gets +1 DMG for 2 turns for each space it moves, to a maximum of 5.",
      "class_name": "Blitz",
      "revision": 1
    },
    {
      "asset_id": 4096,
      "resettable": 1,
      "name": "Block",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 213,
      "activated": 1,
      "icon_name": "block",
      "comments": "none",
      "prerequisite_id": 212,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 1,
      "cost": 6,
      "short_description": "Next time target champion within 10 spaces makes a close-combat attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>. (You may target this unit to Block the next close-combat attack from any champion.)",
      "long_description": "Next time target champion within 10 spaces makes a close-combat attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>. (You may target this unit to Block the next close-combat attack from any champion.)",
      "class_name": "Block",
      "revision": 1
    },
    {
      "asset_id": 4096,
      "resettable": 1,
      "name": "Block",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 214,
      "activated": 1,
      "icon_name": "block",
      "comments": "none",
      "prerequisite_id": 213,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 1,
      "cost": 9,
      "short_description": "Next time target champion within 10 spaces makes a close-combat attack against this unit, that attack automatically misses. This effect is hidden until triggered. This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>. (You may target this unit to Block the next close-combat attack from any champion.)",
      "long_description": "Next time target champion within 10 spaces makes a close-combat attack against this unit, that attack automatically misses. This effect is hidden until triggered. This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>. (You may target this unit to Block the next close-combat attack from any champion.)",
      "class_name": "Block",
      "revision": 1
    },
    {
      "asset_id": 4822,
      "resettable": 1,
      "name": "Blockade",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1702,
      "activated": 1,
      "icon_name": "blockade",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "Enemy champions within 8 spaces cannot gain AP via spells and abilities.",
      "long_description": "Enemy champions within 8 spaces cannot gain AP via spells and abilities.",
      "class_name": "AerialBlockade",
      "revision": 1
    },
    {
      "asset_id": 5642,
      "resettable": 1,
      "name": "Blood Bind",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 2513,
      "activated": 1,
      "icon_name": "soul_siphon",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "This unit loses 5 HP and all opposing units within 4 spaces on a <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic> lose 5 HP and are <condition value=paralyzed>Paralyzed</condition> until the end of the next turn. This unit vampiric heals 5 HP for each affected champion. This ability enters play on cooldown.",
      "long_description": "This unit loses 5 HP and all opposing units within 4 spaces on a <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic> lose 5 HP and are <condition value=paralyzed>Paralyzed</condition> until the end of the next turn. This unit vampiric heals 5 HP for each affected champion. This ability enters play on cooldown.",
      "class_name": "Bloodbind",
      "revision": 1
    },
    {
      "asset_id": 4347,
      "resettable": 1,
      "name": "Blood Bond",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 1379,
      "activated": 1,
      "icon_name": "bloodbond",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 3,
      "short_description": "When a friendly champion within 5 spaces that has one or more of the same races as this champion is attacked, this unit gains 1 AP.",
      "long_description": "When a friendly champion within 5 spaces that has one or more of the same races as this champion is attacked, this unit gains 1 AP.",
      "class_name": "BloodBond",
      "revision": 1
    },
    {
      "asset_id": 4347,
      "resettable": 1,
      "name": "Blood Bond",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 1380,
      "activated": 1,
      "icon_name": "bloodbond",
      "comments": "",
      "prerequisite_id": 1379,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 6,
      "short_description": "When a friendly champion within 5 spaces that has one or more of the same races as this champion is attacked, this unit gains 2 AP.",
      "long_description": "When a friendly champion within 5 spaces that has one or more of the same races as this champion is attacked, this unit gains 2 AP.",
      "class_name": "BloodBond",
      "revision": 1
    },
    {
      "asset_id": 7346,
      "resettable": 0,
      "name": "Blood Casting",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3112,
      "activated": 1,
      "icon_name": "bloodball",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this champion is deployed, all real enemy champions in play have a Blood Ball worth 5 HP created adjacent to them.",
      "long_description": "When this champion is deployed, all real enemy champions in play have a Blood Ball worth 5 HP created adjacent to them.",
      "class_name": "BloodCasting",
      "revision": 1
    },
    {
      "asset_id": 8019,
      "resettable": 0,
      "name": "Blood Collection",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3416,
      "activated": 1,
      "icon_name": "bloodball",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "Whenever this champion collects a blood ball, it gains one charge. This champion automatically recovers blood balls within 3 spaces.",
      "long_description": "Whenever this champion collects a blood ball, it gains one charge. This champion automatically recovers blood balls within 3 spaces.",
      "class_name": "BloodCollection",
      "revision": 1
    },
    {
      "asset_id": 7390,
      "resettable": 0,
      "name": "Blood Convergence",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 3141,
      "activated": 1,
      "icon_name": "bloodball",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "Target enemy champion within 5 spaces loses 4 HP per Blood Ball within 3 spaces of it. Those Blood Balls are consumed and this champion vampiric heals for 50% of the HP lost to a maximum of 20 HP.",
      "long_description": "Target enemy champion within 5 spaces loses 4 HP per Blood Ball within 3 spaces of it. Those Blood Balls are consumed and this champion vampiric heals for 50% of the HP lost to a maximum of 20 HP.",
      "class_name": "HurlBloodballs",
      "revision": 1
    },
    {
      "asset_id": 4571,
      "resettable": 1,
      "name": "Blood Crest",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2700,
      "activated": 1,
      "icon_name": "blood_debt",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 15,
      "short_description": "Friendly champions with Race: Vampyre within 5 spaces gain <ability value=259>Enrage 1</ability> and <ability value=2942>Masochist</ability>.",
      "long_description": "Friendly champions with Race: Vampyre within 5 spaces gain <ability value=259>Enrage 1</ability> and <ability value=2942>Masochist</ability>.",
      "class_name": "BloodCrest",
      "revision": 1
    },
    {
      "asset_id": 5742,
      "resettable": 1,
      "name": "Blood Dispersal",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2629,
      "activated": 1,
      "icon_name": "blood_debt",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "When this champion successfully damages a <condition value=bloodied>Bloodied</condition> champion with a basic attack, friendly champions within 6 spaces of it are healed for the same amount, divided evenly among damaged champions, to a minimum of 1 and a maximum 6.",
      "long_description": "When this champion successfully damages a <condition value=bloodied>Bloodied</condition> champion with a basic attack, friendly champions within 6 spaces of it are healed for the same amount, divided evenly among damaged champions, to a minimum of 1 and a maximum 6.",
      "class_name": "BloodDispersal",
      "revision": 1
    },
    {
      "asset_id": 5605,
      "resettable": 1,
      "name": "Blood for Nora",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 2464,
      "activated": 1,
      "icon_name": "nora_hex",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "This unit loses 20 health. The next spell you cast this turn has its Nora cost reduced by 20. This effect does not stack.",
      "long_description": "This unit loses 20 health. The next spell you cast this turn has its Nora cost reduced by 20. This effect does not stack.",
      "class_name": "BloodForNora",
      "revision": 1
    },
    {
      "asset_id": 4011,
      "resettable": 1,
      "name": "Blood Frenzy",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 27,
      "activated": 1,
      "icon_name": "offenseenhance",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 2,
      "short_description": "While this champion has less than half of its max HP remaining, it gets +2 DMG, and gains 1 additional rank of <ability value=15>Multiattack</ability> (to a max of 3 ranks).",
      "long_description": "While this champion has less than half of its max HP remaining, it gets +2 DMG, and gains 1 additional rank of <ability value=15>Multiattack</ability> (to a max of 3 ranks).",
      "class_name": "BloodFrenzy",
      "revision": 1
    },
    {
      "asset_id": 4011,
      "resettable": 1,
      "name": "Blood Frenzy",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 28,
      "activated": 1,
      "icon_name": "offenseenhance",
      "comments": "none",
      "prerequisite_id": 27,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 5,
      "short_description": "While this champion has less than half of its max HP remaining, it gets -1 DEF, +4 DMG, and gains 2 additional ranks of <ability value=16>Multiattack</ability> (to a max of 3 ranks).",
      "long_description": "While this champion has less than half of its max HP remaining, it gets -1 DEF, +4 DMG, and gains 2 additional ranks of <ability value=16>Multiattack</ability> (to a max of 3 ranks).",
      "class_name": "BloodFrenzy",
      "revision": 1
    },
    {
      "asset_id": 4011,
      "resettable": 1,
      "name": "Blood Frenzy",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 29,
      "activated": 1,
      "icon_name": "offenseenhance",
      "comments": "none",
      "prerequisite_id": 28,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 8,
      "short_description": "While this champion has less than half of its max HP remaining, it gets -2 DEF, +6 DMG, and gains 3 additional ranks of <ability value=17>Multiattack</ability> (to a max of 3 ranks).",
      "long_description": "While this champion has less than half of its max HP remaining, it gets -2 DEF, +6 DMG, and gains 3 additional ranks of <ability value=17>Multiattack</ability> (to a max of 3 ranks).",
      "class_name": "BloodFrenzy",
      "revision": 1
    },
    {
      "asset_id": 4672,
      "resettable": 1,
      "name": "Blood Fueled",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1108,
      "activated": 1,
      "icon_name": "nexus_aura",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "This champion loses 8 HP and gains 8 AP. This champion does not gain AP at the beginning of turn. This ability starts on cooldown",
      "long_description": "This champion loses 8 HP and gains 8 AP. This champion does not gain AP at the beginning of turn. This ability starts on cooldown",
      "class_name": "BloodFueled",
      "revision": 1
    },
    {
      "asset_id": 5365,
      "resettable": 1,
      "name": "Blood Knowledge",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 2706,
      "activated": 1,
      "icon_name": "nora_hex",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "For each opposing champion within 4 spaces with <condition value=bloodied>Bloodied</condition>, your opponent loses 2 nora and this champion gains 1 AP and +1 DMG for 1 turn.",
      "long_description": "For each opposing champion within 4 spaces with <condition value=bloodied>Bloodied</condition>, your opponent loses 2 nora and this champion gains 1 AP and +1 DMG for 1 turn.",
      "class_name": "BloodKnowledge",
      "revision": 1
    },
    {
      "asset_id": 5365,
      "resettable": 1,
      "name": "Blood Magic",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2197,
      "activated": 1,
      "icon_name": "novablood",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 7,
      "short_description": "Enemy champions within 3 spaces lose 8 HP and are <condition value=bloodied>Bloodied</condition> for 8 turns.  If an affected champion is already Bloodied, this champion vampiric heals 8 HP.",
      "long_description": "Enemy champions within 3 spaces lose 8 HP and are <condition value=bloodied>Bloodied</condition> for 8 turns.  If an affected champion is already Bloodied, this champion vampiric heals 8 HP.",
      "class_name": "BloodMagic",
      "revision": 1
    },
    {
      "asset_id": 4805,
      "resettable": 1,
      "name": "Blood Offering",
      "ap_cost": 2,
      "level": 1,
      "ability_id": 1562,
      "activated": 1,
      "icon_name": "blood_debt",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 6,
      "activation_type": 1,
      "ranked": 1,
      "cost": 2,
      "short_description": "<mechanic value=sacrifice>Sacrifice</mechanic> target friendly real champion you own, the nearest enemy champion suffers 10 Magical damage. This damage ignores DEF.",
      "long_description": "<mechanic value=sacrifice>Sacrifice</mechanic> target friendly real champion you own, the nearest enemy champion suffers 10 Magical damage. This damage ignores DEF.",
      "class_name": "BloodOffering",
      "revision": 1
    },
    {
      "asset_id": 4805,
      "resettable": 1,
      "name": "Blood Offering",
      "ap_cost": 2,
      "level": 2,
      "ability_id": 1591,
      "activated": 1,
      "icon_name": "blood_debt",
      "comments": "none",
      "prerequisite_id": 1562,
      "cooldown": 6,
      "activation_type": 1,
      "ranked": 1,
      "cost": 2,
      "short_description": "<mechanic value=sacrifice>Sacrifice</mechanic> target friendly real champion you own, the nearest enemy champion suffers 13 Magical damage. This damage ignores DEF.",
      "long_description": "<mechanic value=sacrifice>Sacrifice</mechanic> target friendly real champion you own, the nearest enemy champion suffers 13 Magical damage. This damage ignores DEF.",
      "class_name": "BloodOffering",
      "revision": 1
    },
    {
      "asset_id": 4805,
      "resettable": 1,
      "name": "Blood Offering",
      "ap_cost": 2,
      "level": 3,
      "ability_id": 1592,
      "activated": 1,
      "icon_name": "blood_debt",
      "comments": "none",
      "prerequisite_id": 1591,
      "cooldown": 6,
      "activation_type": 1,
      "ranked": 1,
      "cost": 2,
      "short_description": "<mechanic value=sacrifice>Sacrifice</mechanic> target friendly real champion you own, the nearest enemy champion suffers 25 Magical damage. This damage ignores DEF.",
      "long_description": "<mechanic value=sacrifice>Sacrifice</mechanic> target friendly real champion you own, the nearest enemy champion suffers 25 Magical damage. This damage ignores DEF.",
      "class_name": "BloodOffering",
      "revision": 1
    },
    {
      "asset_id": 4168,
      "resettable": 1,
      "name": "Blood Rage",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 474,
      "activated": 1,
      "icon_name": "rend",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "This unit makes a melee attack and loses 8 HP. This ability's AP cost cannot be modified.",
      "long_description": "This unit makes a melee attack and loses 8 HP. This ability's AP cost cannot be modified.",
      "class_name": "BloodRage",
      "revision": 1
    },
    {
      "asset_id": 5365,
      "resettable": 0,
      "name": "Blood Spear",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 3333,
      "activated": 1,
      "icon_name": "novablood",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 3,
      "ranked": 0,
      "cost": 7,
      "short_description": "This champion makes a Loss of Life attack at RNG 2-5. If the target is <condition value=bloodied>Bloodied</condition> or has less than 50% HP remaining, this champion vampiric heals for 8.",
      "long_description": "This champion makes a Loss of Life attack at RNG 2-5. If the target is <condition value=bloodied>Bloodied</condition> or has less than 50% HP remaining, this champion vampiric heals for 8.",
      "class_name": "BloodSpear",
      "revision": 1
    },
    {
      "asset_id": 7976,
      "resettable": 0,
      "name": "Bloodlust",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3363,
      "activated": 1,
      "icon_name": "blood_debt",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "This champion deals 30% additional damage to Bloodied champions on basic attacks.",
      "long_description": "This champion deals 30% additional damage to Bloodied champions on basic attacks.",
      "class_name": "Bloodlust",
      "revision": 1
    },
    {
      "asset_id": 4039,
      "resettable": 1,
      "name": "Bloodseeker",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 2551,
      "activated": 1,
      "icon_name": "relocate_lightning",
      "comments": "Relic",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "This champion is relocated adjacent to target champion within 5 spaces with <condition value=bloodied>Bloodied</condition> or less than 50% HP and gains +2 SPD for 3 turns.",
      "long_description": "This champion is relocated adjacent to target champion within 5 spaces with <condition value=bloodied>Bloodied</condition> or less than 50% HP and gains +2 SPD for 3 turns.",
      "class_name": "Bloodseeker",
      "revision": 1
    },
    {
      "asset_id": 5799,
      "resettable": 1,
      "name": "Bloodsport",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2790,
      "activated": 1,
      "icon_name": "blood_debt",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this champion destroys an opposing champion with a basic attack, it permanently gains +1 DMG and +1 SPD. This effect does not stack.",
      "long_description": "When this champion destroys an opposing champion with a basic attack, it permanently gains +1 DMG and +1 SPD. This effect does not stack.",
      "class_name": "Bloodsport",
      "revision": 1
    },
    {
      "asset_id": 7419,
      "resettable": 0,
      "name": "Bloodspurt",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3151,
      "activated": 1,
      "icon_name": "blood_debt",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this unit is successfully attacked with a basic attack, the target is Bloodied (This unit cannot stealthed) for 6 turns and a blood ball worth 5 DMG is created in an adjacent space to the attacker.",
      "long_description": "When this unit is successfully attacked with a basic attack, the target is Bloodied (This unit cannot stealthed) for 6 turns and a blood ball worth 5 DMG is created in an adjacent space to the attacker.",
      "class_name": "Bloodsplurt",
      "revision": 1
    },
    {
      "asset_id": 5575,
      "resettable": 1,
      "name": "Bloodtracker",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2435,
      "activated": 1,
      "icon_name": "rend",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 2,
      "short_description": "When this unit is deployed, the nearest opposing champion becomes <condition value=eviscerated>Eviscerated</condition> for 3 turns and <condition value=bloodied>Bloodied</condition>.",
      "long_description": "When this unit is deployed, the nearest opposing champion becomes <condition value=eviscerated>Eviscerated</condition> for 3 turns and <condition value=bloodied>Bloodied</condition>.",
      "class_name": "Bloodtracker",
      "revision": 1
    },
    {
      "asset_id": 5228,
      "resettable": 1,
      "name": "Blundering",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2006,
      "activated": 1,
      "icon_name": "debuff",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -4,
      "short_description": "All friendly champions within 4 spaces of this champion have -1 DMG.",
      "long_description": "All friendly champions within 4 spaces of this champion have -1 DMG.",
      "class_name": "Blundering",
      "revision": 1
    },
    {
      "asset_id": 5017,
      "resettable": 1,
      "name": "Body Jumper",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1196,
      "activated": 1,
      "icon_name": "possess",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 6,
      "short_description": "When this unit is destroyed, the closest opposing champion is <condition value=possessed>Possessed</condition> and becomes <condition value=immobile>Immobile</condition> for 3 turns.",
      "long_description": "When this unit is destroyed, the closest opposing champion is <condition value=possessed>Possessed</condition> and becomes <condition value=immobile>Immobile</condition> for 3 turns.",
      "class_name": "BodyJumper",
      "revision": 1
    },
    {
      "asset_id": 4531,
      "resettable": 1,
      "name": "Bodyguard",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 877,
      "activated": 1,
      "icon_name": "block",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "Target champion within 5 spaces is Bodyguarded (While this unit is within 5 spaces of the Bodyguarding unit, all damage dealt to this champion is prevented and is dealt to the Bodyguarding unit instead) for 6 turns. If this unit attacks, this effect is removed. ",
      "long_description": "Target champion within 5 spaces is Bodyguarded (While this unit is within 5 spaces of the Bodyguarding unit, all damage dealt to this champion is prevented and is dealt to the Bodyguarding unit instead) for 6 turns. If this unit attacks, this effect is removed.",
      "class_name": "Bodyguard",
      "revision": 1
    },
    {
      "asset_id": 4371,
      "resettable": 1,
      "name": "Boghopper Rider",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1410,
      "activated": 1,
      "icon_name": "rider",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 25,
      "short_description": "When this unit is destroyed, no nora globe is dropped and a Boghopper with no upgrades is spawned in the location this unit occupied.",
      "long_description": "When this unit is destroyed, no nora globe is dropped and a Boghopper with no upgrades is spawned in the location this unit occupied.",
      "class_name": "TurtleRider",
      "revision": 1
    },
    {
      "asset_id": 5745,
      "resettable": 1,
      "name": "Bold",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2632,
      "activated": 1,
      "icon_name": "channel_defense",
      "comments": "x",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "This champion has +1 DEF for 2 turns for each space it moves, to a maximum of +5 DEF.",
      "long_description": "This champion has +1 DEF for 2 turns for each space it moves, to a maximum of +5 DEF.",
      "class_name": "Bold",
      "revision": 1
    },
    {
      "asset_id": 8015,
      "resettable": 0,
      "name": "Bolstered: Hyaenid",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3412,
      "activated": 1,
      "icon_name": "bulwark_hyaenid",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 2,
      "short_description": "When this unit is deployed, it gains +2 MAX HP for each champion with Race: Hyaenid in play.",
      "long_description": "When this unit is deployed, it gains +2 MAX HP for each champion with Race: Hyaenid in play.",
      "class_name": "BolsteredHyaenid",
      "revision": 1
    },
    {
      "asset_id": 4354,
      "resettable": 1,
      "name": "Bolt",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1388,
      "activated": 1,
      "icon_name": "bolt",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "When this champion successfully attacks an enemy champion, it is relocated to the nearest space to that target.",
      "long_description": "When this champion successfully attacks an enemy champion, it is relocated to the nearest space to that target.",
      "class_name": "Bolt",
      "revision": 1
    },
    {
      "asset_id": 5390,
      "resettable": 1,
      "name": "Bone Altar",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2222,
      "activated": 1,
      "icon_name": "sacrifice",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "<mechanic value=sacrifice>Sacrifice</mechanic> target champion you own within 4 spaces with Race: Skeleton, friendly Skeletons gain +4 HP and +1 DMG.",
      "long_description": "<mechanic value=sacrifice>Sacrifice</mechanic> target champion you own within 4 spaces with Race: Skeleton, friendly Skeletons gain +4 HP and +1 DMG.",
      "class_name": "BoneAltar",
      "revision": 1
    },
    {
      "asset_id": 7231,
      "resettable": 0,
      "name": "Bone Circle: Lich",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3051,
      "activated": 1,
      "icon_name": "soul_bond",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Friendly Lich gain +1 MAX RNG. This shares a CD with and removes the effects of Bone Circle: Skeletons when activated.",
      "long_description": "Friendly Lich gain +1 MAX RNG. This shares a CD with and removes the effects of Bone Circle: Skeletons when activated.",
      "class_name": "BoneCircleLich",
      "revision": 1
    },
    {
      "asset_id": 7230,
      "resettable": 0,
      "name": "Bone Circle: Skeletons",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3050,
      "activated": 1,
      "icon_name": "soul_bond",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Friendly Skeletons gain Spell Resistance. This shares a CD with and removes the effects of Bone Circle: Lich when activated.",
      "long_description": "Friendly Skeletons gain Spell Resistance. This shares a CD with and removes the effects of Bone Circle: Lich when activated.",
      "class_name": "BoneCircleSkeletons",
      "revision": 1
    },
    {
      "asset_id": 4383,
      "resettable": 1,
      "name": "Bone Fracture",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1424,
      "activated": 1,
      "icon_name": "bone_fracture",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 18,
      "short_description": "When this unit takes damage from any attack, a Lesser Bonemauler champion is summoned in the nearest available space.",
      "long_description": "When this unit takes damage from any attack, a Lesser Bonemauler champion is summoned in the nearest available space.",
      "class_name": "BoneFracture",
      "revision": 1
    },
    {
      "asset_id": 4673,
      "resettable": 1,
      "name": "Bone Mason",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 1109,
      "activated": 1,
      "icon_name": "shrinegood",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 4,
      "short_description": "When this champion deals damage to a champion on a close-combat attack, your shrine recovers 4 health.",
      "long_description": "When this champion deals damage to a champion on a close-combat attack, your shrine recovers 4 health.",
      "class_name": "BoneMason",
      "revision": 1
    },
    {
      "asset_id": 4673,
      "resettable": 1,
      "name": "Bone Mason",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 1110,
      "activated": 1,
      "icon_name": "shrinegood",
      "comments": "",
      "prerequisite_id": 1109,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 6,
      "short_description": "When this champion deals damage to a champion on a close-combat attack, your shrine recovers 6 health.",
      "long_description": "When this champion deals damage to a champion on a close-combat attack, your shrine recovers 6 health.",
      "class_name": "BoneMason",
      "revision": 1
    },
    {
      "asset_id": 7610,
      "resettable": 0,
      "name": "Bone Mine",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3190,
      "activated": 1,
      "icon_name": "bonespur",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 15,
      "short_description": "When this unit is deployed, 8 Bone Spurs are deployed within 5 spaces of this unit. At the end of its turns, an additional Bone Spur is created.  Each space may only have one Bone Spur.  When a champion with Race: Skeleton captures a Bone Spur, they gain +1 DMG for 1 turn and +2 MAX HP permanently. All other champions take 3 Physical damage when capturing a Bone Spur.",
      "long_description": "When this unit is deployed, 8 Bone Spurs are deployed within 5 spaces of this unit. At the end of its turns, an additional Bone Spur is created.  Each space may only have one Bone Spur.  When a champion with Race: Skeleton captures a Bone Spur, they gain +1 DMG for 1 turn and +2 MAX HP permanently. All other champions take 3 Physical damage when capturing a Bone Spur.",
      "class_name": "BoneMine",
      "revision": 1
    },
    {
      "asset_id": 7336,
      "resettable": 0,
      "name": "Bone Prison",
      "ap_cost": 5,
      "level": 0,
      "ability_id": 3106,
      "activated": 1,
      "icon_name": "bone_prison",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 15,
      "short_description": "3 Grave Warriors are summoned in the spaces closest to target enemy champion within 5 spaces.",
      "long_description": "3 Grave Warriors are summoned in the spaces closest to target enemy champion within 5 spaces.",
      "class_name": "BonePrison",
      "revision": 1
    },
    {
      "asset_id": 4450,
      "resettable": 1,
      "name": "Bone Trap",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2776,
      "activated": 1,
      "icon_name": "boon",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "When an enemy champion moves within 2 spaces of this relic, this relic is destroyed and enemy units within 2 spaces take 6 Physical damage, becomes <condition value=frightened>Frightened</condition> for 2 turns and a Scary Spooky Skeleton is summoned in the relic's place",
      "long_description": "When an enemy champion moves within 2 spaces of this relic, this relic is destroyed and enemy units within 2 spaces take 6 Physical damage, becomes <condition value=frightened>Frightened</condition> for 2 turns and a Scary Spooky Skeleton is summoned in the relic's place",
      "class_name": "BoneTrap",
      "revision": 1
    },
    {
      "asset_id": 4359,
      "resettable": 1,
      "name": "Book Burn",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 1392,
      "activated": 1,
      "icon_name": "bookburn",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 5,
      "short_description": "No spells may be cast for 3 turns.",
      "long_description": "No spells may be cast for 3 turns.",
      "class_name": "BookBurn",
      "revision": 1
    },
    {
      "asset_id": 5869,
      "resettable": 1,
      "name": "Boon of the Beast Clan",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2878,
      "activated": 1,
      "icon_name": "beast_clan",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "This unit gains Hawk Attack 1 and Leap 2 for 4 turns. Once this ability has been use once by any friendly champion, this ability is removed from all friendly champions.",
      "long_description": "This unit gains Hawk Attack 1 and Leap 2 for 4 turns. Once this ability has been use once by any friendly champion, this ability is removed from all friendly champions.",
      "class_name": "BoonBeastClan",
      "revision": 1
    },
    {
      "asset_id": 5870,
      "resettable": 1,
      "name": "Boon of the Blood Clan",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2879,
      "activated": 1,
      "icon_name": "blood_clan",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "This unit gains Rampage and Hostile for 4 turns. Once this ability has been use once by any friendly champion, this ability is removed from all friendly champions.",
      "long_description": "This unit gains Rampage and Hostile for 4 turns. Once this ability has been use once by any friendly champion, this ability is removed from all friendly champions.",
      "class_name": "BoonBloodClan",
      "revision": 1
    },
    {
      "asset_id": 5867,
      "resettable": 1,
      "name": "Boon of the Stone Clan",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2876,
      "activated": 1,
      "icon_name": "stone_clan",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "This unit gains Tough 2 and Pace for 4 turns. Once this ability has been use once by any friendly champion, this ability is removed from all friendly champions.",
      "long_description": "This unit gains Tough 2 and Pace for 4 turns. Once this ability has been use once by any friendly champion, this ability is removed from all friendly champions.",
      "class_name": "BoonStoneClan",
      "revision": 1
    },
    {
      "asset_id": 5868,
      "resettable": 1,
      "name": "Boon of the Storm Clan",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2877,
      "activated": 1,
      "icon_name": "storm_clan",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "This unit gains Jolt 2 and Rebuke 3 for 4 turns. Once this ability has been use once by any friendly champion, this ability is removed from all friendly champions.",
      "long_description": "This unit gains Jolt 2 and Rebuke 3 for 4 turns. Once this ability has been use once by any friendly champion, this ability is removed from all friendly champions.",
      "class_name": "BoonStormClan",
      "revision": 1
    },
    {
      "asset_id": 5624,
      "resettable": 1,
      "name": "Boon of the Wind",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2488,
      "activated": 1,
      "icon_name": "martyr",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 2,
      "short_description": "When this champion enters play the nearest friendly champion with <condition value=flying popup=false>Flying</condition> gains +1 DMG and an additional rank of <ability value=1376>Evasive</ability>.",
      "long_description": "When this champion enters play the nearest friendly champion with <condition value=flying popup=false>Flying</condition> gains +1 DMG and an additional rank of <ability value=1376>Evasive</ability>.",
      "class_name": "BoonOfTheWind",
      "revision": 1
    },
    {
      "asset_id": 4644,
      "resettable": 1,
      "name": "Boost",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1160,
      "activated": 1,
      "icon_name": "boost",
      "comments": "",
      "prerequisite_id": 1066,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 10,
      "short_description": "Friendly champions that share a race or class with this one have +5 MAX HP.  This does not stack with other Boosts.",
      "long_description": "Friendly champions that share a race or class with this one have +5 MAX HP.  This does not stack with other Boosts.",
      "class_name": "Boost",
      "revision": 1
    },
    {
      "asset_id": 4644,
      "resettable": 1,
      "name": "Boost: Beast ",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1065,
      "activated": 1,
      "icon_name": "boost",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 10,
      "short_description": "Friendly champions with Race: Beast have +5 MAX HP.  This does not stack  with other Boosts.",
      "long_description": "Friendly champions with Race: Beast have +5 MAX HP.  This does not stack  with other Boosts.",
      "class_name": "BoostBeast",
      "revision": 1
    },
    {
      "asset_id": 4819,
      "resettable": 1,
      "name": "Boost: Construct",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2508,
      "activated": 1,
      "icon_name": "boost",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 10,
      "short_description": "Friendly champions with Race: Construct have +5 MAX HP.  This does not stack  with other Boosts.",
      "long_description": "Friendly champions with Race: Construct have +5 MAX HP.  This does not stack  with other Boosts.",
      "class_name": "BoostConstruct",
      "revision": 1
    },
    {
      "asset_id": 4819,
      "resettable": 1,
      "name": "Boost: Plant",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1085,
      "activated": 1,
      "icon_name": "boost",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 7,
      "short_description": "Friendly champions with Race: Plant gain +5 MAX HP. This does not stack  with other Boosts.",
      "long_description": "Friendly champions with Race: Plant gain +5 MAX HP. This does not stack  with other Boosts.",
      "class_name": "BoostPlant",
      "revision": 1
    },
    {
      "asset_id": 4535,
      "resettable": 1,
      "name": "Boost: Skeleton",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 863,
      "activated": 1,
      "icon_name": "boost",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 7,
      "short_description": "Friendly champions with Race: Skeleton have +5 MAX HP. This does not stack  with other Boosts.",
      "long_description": "Friendly champions with Race: Skeleton have +5 MAX HP. This does not stack  with other Boosts.",
      "class_name": "BoostSkeleton",
      "revision": 1
    },
    {
      "asset_id": 5800,
      "resettable": 1,
      "name": "Born in Blood",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2791,
      "activated": 1,
      "icon_name": "borninblood",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 80,
      "short_description": "When this champion is destroyed, no nora globe is dropped and champions within 4 spaces are <condition value=bloodied>Bloodied</condition> and a Gahlroon with <condition value=impervious>Impervious</condition> for 2 turns is spawned in its place.",
      "long_description": "When this champion is destroyed, no nora globe is dropped and champions within 4 spaces are <condition value=bloodied>Bloodied</condition> and a Gahlroon with <condition value=impervious>Impervious</condition> for 2 turns is spawned in its place.",
      "class_name": "BornInBlood",
      "revision": 1
    },
    {
      "asset_id": 4931,
      "resettable": 1,
      "name": "Boss",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1048,
      "activated": 1,
      "icon_name": "titan",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": -5,
      "short_description": "When this unit dies, its owner's shrine is destroyed.",
      "long_description": "When this unit dies, its owner's shrine is destroyed.",
      "class_name": "Boss",
      "revision": 1
    },
    {
      "asset_id": 4451,
      "resettable": 1,
      "name": "Boulder Toss",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 803,
      "activated": 1,
      "icon_name": "rock",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "This champion makes a Physical attack at RNG 2-5. This ability is removed after use.",
      "long_description": "This champion makes a Physical attack at RNG 2-5. This ability is removed after use.",
      "class_name": "ThrowBoulder",
      "revision": 1
    },
    {
      "asset_id": 5659,
      "resettable": 1,
      "name": "Bounce",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2531,
      "activated": 1,
      "icon_name": "knockback",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "For 8 turns, the next time target opposing champion within 8 spaces engages one of your champions, it is knocked back 4 spaces. This effect is hidden until triggered and does not stack.",
      "long_description": "For 8 turns, the next time target opposing champion within 8 spaces engages one of your champions, it is knocked back 4 spaces. This effect is hidden until triggered and does not stack.",
      "class_name": "Bounce",
      "revision": 1
    },
    {
      "asset_id": 5404,
      "resettable": 1,
      "name": "Boundless Vitality",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2236,
      "activated": 1,
      "icon_name": "buff",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "When this champion has 20 or more charges, whenever it activates a base ability, the cooldown on that ability is set to 0.",
      "long_description": "When this champion has 20 or more charges, whenever it activates a base ability, the cooldown on that ability is set to 0.",
      "class_name": "BoundlessVitality",
      "revision": 1
    },
    {
      "asset_id": 4392,
      "resettable": 1,
      "name": "Bounty Hunter",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1433,
      "activated": 1,
      "icon_name": "hunter_bounty",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "This unit gains the Hunter ability that matches the faction of the first champion it successfully attacks with a basic attack, after the attack.",
      "long_description": "This unit gains the Hunter ability that matches the faction of the first champion it successfully attacks with a basic attack, after the attack.",
      "class_name": "BountyHunter",
      "revision": 1
    },
    {
      "asset_id": 5740,
      "resettable": 1,
      "name": "Brain Eater",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2634,
      "activated": 1,
      "icon_name": "eater_disease",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this champion destroys a champion with a different owner, it gains one of its upgraded abilities.",
      "long_description": "When this champion destroys a champion with a different owner, it gains one of its upgraded abilities.",
      "class_name": "BrainEater",
      "revision": 1
    },
    {
      "asset_id": 4766,
      "resettable": 1,
      "name": "Brainless",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1491,
      "activated": 1,
      "icon_name": "headless",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "When this unit is destroyed, it drops no nora globe and is re-spawned with the Headless ability at the location where it died.  The brainless unit is <ability value=814>Unequippable</ability>",
      "long_description": "When this unit is destroyed, it drops no nora globe and is re-spawned with the Headless ability at the location where it died.  The brainless unit is <ability value=814>Unequippable</ability>",
      "class_name": "Wander",
      "revision": 1
    },
    {
      "asset_id": 4163,
      "resettable": 1,
      "name": "Brand",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 2738,
      "activated": 1,
      "icon_name": "special",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 3,
      "short_description": "Target champion within 5 spaces becomes <condition value=branded>Branded</condition> for 4 turns.",
      "long_description": "Target champion within 5 spaces becomes <condition value=branded>Branded</condition> for 4 turns.",
      "class_name": "Brand",
      "revision": 1
    },
    {
      "asset_id": 5634,
      "resettable": 1,
      "name": "Brand of the Outlaw",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2643,
      "activated": 1,
      "icon_name": "brand_of_the_outlaw",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 7,
      "short_description": "When this champion successfully damages a champion with a basic attack, that unit gains <condition value=cursed>Cursed</condition>, <ability value=2260>Pariah</ability> and <ability value=2008>Liability</ability> for 4 turns.",
      "long_description": "When this champion successfully damages a champion with a basic attack, that unit gains <condition value=cursed>Cursed</condition>, <ability value=2260>Pariah</ability> and <ability value=2008>Liability</ability> for 4 turns.",
      "class_name": "BrandOfTheOutlaw",
      "revision": 1
    },
    {
      "asset_id": 4522,
      "resettable": 1,
      "name": "Bravery",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1502,
      "activated": 1,
      "icon_name": "buff",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "This unit gains <ability value=1006>Surge: Enemy</ability> and <ability value=4>Iron Will</ability> when a champion that shares a race with it is within 3 spaces. ",
      "long_description": "This unit gains <ability value=1006>Surge: Enemy</ability> and <ability value=4>Iron Will</ability> when a champion that shares a race with it is within 3 spaces. ",
      "class_name": "Bravery",
      "revision": 1
    },
    {
      "asset_id": 5567,
      "resettable": 1,
      "name": "Break the Line",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2427,
      "activated": 1,
      "icon_name": "knockback",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 6,
      "short_description": "When this champion charges, all opposing champions within 3 spaces of his end position are knocked back 3 spaces.",
      "long_description": "When this champion charges, all opposing champions within 3 spaces of his end position are knocked back 3 spaces.",
      "class_name": "BreakTheLine",
      "revision": 1
    },
    {
      "asset_id": 4559,
      "resettable": 1,
      "name": "Bridge to Nowhere",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2683,
      "activated": 1,
      "icon_name": "mobility",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "Friendly Fairy champions within 5 spaces have +1 SPD and <ability value=6>Mobility</ability>. This does not stack.",
      "long_description": "Friendly Fairy champions within 5 spaces have +1 SPD and <ability value=6>Mobility</ability>. This does not stack.",
      "class_name": "BridgeToNowhere",
      "revision": 1
    },
    {
      "asset_id": 5626,
      "resettable": 1,
      "name": "Brood Bond",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2490,
      "activated": 1,
      "icon_name": "broodbond",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 2,
      "short_description": "Friendly Myx Pupae hatch 1 turn faster (to a minimum of 2 turns) while this unit is in play. ",
      "long_description": "Friendly Myx Pupae hatch 1 turn faster (to a minimum of 2 turns) while this unit is in play. ",
      "class_name": "BroodBond",
      "revision": 1
    },
    {
      "asset_id": 5819,
      "resettable": 1,
      "name": "Broodcaller",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2828,
      "activated": 1,
      "icon_name": "broodcaller",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "When this champion is deployed, a level 3 Broodling is summoned at every friendly font deployment zone. ",
      "long_description": "When this champion is deployed, a level 3 Broodling is summoned at every friendly font deployment zone. ",
      "class_name": "Broodcaller",
      "revision": 1
    },
    {
      "asset_id": 5135,
      "resettable": 1,
      "name": "Brubaker Bond",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1905,
      "activated": 1,
      "icon_name": "brubaker_bond",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "When a champion of the same name is within 5 spaces of this unit, this unit gets <ability value=1320>Assault</ability> and <ability value=396>Charge 3</ability>. ",
      "long_description": "When a champion of the same name is within 5 spaces of this unit, this unit gets <ability value=1320>Assault</ability> and <ability value=396>Charge 3</ability>. ",
      "class_name": "BrubakerBond",
      "revision": 1
    },
    {
      "asset_id": 5138,
      "resettable": 1,
      "name": "Brubaker Resistance",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1906,
      "activated": 1,
      "icon_name": "defenseenhance",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "If this champion is the first Brubaker Brother it has <ability value=47>Resistance: Physical 2</ability>. If this champion is the second Brubaker Brother it has <ability value=52>Resistance: Magical 3</ability>.",
      "long_description": "If this champion is the first Brubaker Brother it has <ability value=47>Resistance: Physical 2</ability>. If this champion is the second Brubaker Brother it has <ability value=52>Resistance: Magical 3</ability>.",
      "class_name": "BrubakerResistance",
      "revision": 1
    },
    {
      "asset_id": 4170,
      "resettable": 1,
      "name": "Brushwalker",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 479,
      "activated": 1,
      "icon_name": "terraingrass",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 2,
      "short_description": "This champion ignores movement restrictions and movement penalties imposed by Vegetation.",
      "long_description": "This champion ignores movement restrictions and movement penalties imposed by Vegetation.",
      "class_name": "Brushwalker",
      "revision": 1
    },
    {
      "asset_id": 4746,
      "resettable": 1,
      "name": "Brutality",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1504,
      "activated": 1,
      "icon_name": "surge",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 7,
      "short_description": "This unit gains <ability value=16>Multiattack 2</ability> when a champion that shares a race with it is within 3 spaces.",
      "long_description": "This unit gains <ability value=16>Multiattack 2</ability> when a champion that shares a race with it is within 3 spaces.",
      "class_name": "Brutality",
      "revision": 1
    },
    {
      "asset_id": 7167,
      "resettable": 0,
      "name": "Bubble",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 3010,
      "activated": 1,
      "icon_name": "bubble",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "Target friendly champion within 4 spaces without a Buffer gains a <condition value=buffered>Buffer</condition> of 10 HP. Using this ability does not desealth this champion.  May target self.",
      "long_description": "Target friendly champion within 4 spaces without a Buffer gains a <condition value=buffered>Buffer</condition> of 10 HP. Using this ability does not desealth this champion.  May target self.",
      "class_name": "Bubble",
      "revision": 1
    },
    {
      "asset_id": 5609,
      "resettable": 1,
      "name": "Buckethead's Revenge",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2468,
      "activated": 1,
      "icon_name": "buckethead",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 30,
      "short_description": "When this champions health reaches 0 it is removed from play and a fearsome Buckethead spawns to rip someone's face off!",
      "long_description": "When this champions health reaches 0 it is removed from play and a fearsome Buckethead spawns to rip someone's face off!",
      "class_name": "BucketheadsRevenge",
      "revision": 1
    },
    {
      "asset_id": 5620,
      "resettable": 1,
      "name": "Build 'Em Tough",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2484,
      "activated": 1,
      "icon_name": "build_mine",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "Target Construct within 2 spaces gains a rank of <ability value=1900>Tough</ability>.",
      "long_description": "Target Construct within 2 spaces gains a rank of <ability value=1900>Tough</ability>.",
      "class_name": "BuildEmTough",
      "revision": 1
    },
    {
      "asset_id": 5372,
      "resettable": 1,
      "name": "Build Mine",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 2204,
      "activated": 1,
      "icon_name": "build_mine",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 14,
      "short_description": "A Mine relic with Mine (Friendly small champions adjacent to this relic gain Use Mine (This champion is relocated to a space adjacent to friendly Mine)) is deployed in target adjacent square.",
      "long_description": "A Mine relic with Mine (Friendly small champions adjacent to this relic gain Use Mine (This champion is relocated to a space adjacent to friendly Mine)) is deployed in target adjacent square.",
      "class_name": "BuildMine",
      "revision": 1
    },
    {
      "asset_id": 7216,
      "resettable": 0,
      "name": "Bulwark",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3044,
      "activated": 1,
      "icon_name": "surge",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 3,
      "short_description": "When this champion is deployed from the runedock, it permanently gains +2 MAX HP for each friendly champion that shares a race or class with it.",
      "long_description": "When this champion is deployed from the runedock, it permanently gains +2 MAX HP for each friendly champion that shares a race or class with it.",
      "class_name": "Bulwark",
      "revision": 1
    },
    {
      "asset_id": 5707,
      "resettable": 1,
      "name": "Bulwark: Fairy",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2747,
      "activated": 1,
      "icon_name": "bulwark_fairy",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 2,
      "short_description": "For each friendly Fairy, this unit gains +2 MAX HP.",
      "long_description": "For each friendly Fairy, this unit gains +2 MAX HP.",
      "class_name": "BulwarkFairy",
      "revision": 1
    },
    {
      "asset_id": 4833,
      "resettable": 1,
      "name": "Bulwark: Lonx",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1715,
      "activated": 1,
      "icon_name": "bulwark_lonx",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 2,
      "short_description": "For each friendly Lonx, this unit gets +2 MAX HP.",
      "long_description": "For each friendly Lonx, this unit gets +2 MAX HP.",
      "class_name": "BulwarkLonx",
      "revision": 1
    },
    {
      "asset_id": 5002,
      "resettable": 1,
      "name": "Burn",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 1882,
      "activated": 1,
      "icon_name": "dot_burn",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 3,
      "short_description": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=charred>Charred</condition> for 3 turns",
      "long_description": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=charred>Charred</condition> for 3 turns",
      "class_name": "Burn",
      "revision": 1
    },
    {
      "asset_id": 5002,
      "resettable": 1,
      "name": "Burn",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 1883,
      "activated": 1,
      "icon_name": "dot_burn",
      "comments": "",
      "prerequisite_id": 1882,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 6,
      "short_description": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=charred>Charred</condition> for 4 turns",
      "long_description": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=charred>Charred</condition> for 4 turns",
      "class_name": "Burn",
      "revision": 1
    },
    {
      "asset_id": 5002,
      "resettable": 1,
      "name": "Burn",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 1884,
      "activated": 1,
      "icon_name": "dot_burn",
      "comments": "",
      "prerequisite_id": 1883,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 9,
      "short_description": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=charred>Charred</condition> for 5 turns",
      "long_description": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=charred>Charred</condition> for 5 turns",
      "class_name": "Burn",
      "revision": 1
    },
    {
      "asset_id": 5838,
      "resettable": 1,
      "name": "Burning Presence",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2847,
      "activated": 1,
      "icon_name": "deathnovalava",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 8,
      "short_description": "At the end of each of its turns, opposing champions within 2 spaces of this unit take 8 Fire damage.",
      "long_description": "At the end of each of its turns, opposing champions within 2 spaces of this unit take 8 Fire damage.",
      "class_name": "BurningPresence",
      "revision": 1
    },
    {
      "asset_id": 7345,
      "resettable": 0,
      "name": "Burning Sandspout",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 3111,
      "activated": 1,
      "icon_name": "sandspout",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 3,
      "ranked": 0,
      "cost": 6,
      "short_description": "This champion makes a Fire attack at RNG 2-5. If the target is successfully damaged and is occupying Sand or is <condition value=sandblasted>Sandblasted</condition>, the target also becomes <condition value=charred>Charred</condition> for 3 turns and <condition value=inhibited>Inhibited</condition> for 5 turns.",
      "long_description": "This champion makes a Fire attack at RNG 2-5. If the target is successfully damaged and is occupying Sand or is <condition value=sandblasted>Sandblasted</condition>, the target also becomes <condition value=charred>Charred</condition> for 3 turns and <condition value=inhibited>Inhibited</condition> for 5 turns.",
      "class_name": "BurningSandspout",
      "revision": 1
    },
    {
      "asset_id": 7761,
      "resettable": 0,
      "name": "Burning Steel",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3280,
      "activated": 1,
      "icon_name": "fireaoe",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "When this unit is deployed, equipped enemy champions take 10 Fire damage.  If a champion affected by this ability is within 5 spaces of this unit, it also loses all AP.",
      "long_description": "When this unit is deployed, equipped enemy champions take 10 Fire damage.  If a champion affected by this ability is within 5 spaces of this unit, it also loses all AP.",
      "class_name": "BurningSteel",
      "revision": 1
    },
    {
      "asset_id": 4591,
      "resettable": 1,
      "name": "Cackle",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 966,
      "activated": 1,
      "icon_name": "cackle",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "Opposing champions within 2 spaces become <condition value=awestruck>Awestruck</condition> for 2 turns.",
      "long_description": "Opposing champions within 2 spaces become <condition value=awestruck>Awestruck</condition> for 2 turns.",
      "class_name": "Cackle",
      "revision": 1
    },
    {
      "asset_id": 5019,
      "resettable": 1,
      "name": "Calcify",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1199,
      "activated": 1,
      "icon_name": "novaphysical",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this champion is successfully attacked, it gains +2 DEF until the end of the turn.",
      "long_description": "When this champion is successfully attacked, it gains +2 DEF until the end of the turn.",
      "class_name": "Calcify",
      "revision": 1
    },
    {
      "asset_id": 4137,
      "resettable": 1,
      "name": "Calculated Attack",
      "ap_cost": 1,
      "level": 1,
      "ability_id": 350,
      "activated": 1,
      "icon_name": "",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 1,
      "cost": 1,
      "short_description": "DO NOT USE: This unit makes an attack at +2 ATK.",
      "long_description": "DO NOT USE: This unit makes an attack at +2 ATK.",
      "class_name": "CalculatedAttack",
      "revision": 1
    },
    {
      "asset_id": 4137,
      "resettable": 1,
      "name": "Calculated Attack",
      "ap_cost": 1,
      "level": 2,
      "ability_id": 351,
      "activated": 1,
      "icon_name": "",
      "comments": "none",
      "prerequisite_id": 350,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 1,
      "cost": 3,
      "short_description": "DO NOT USE: This unit makes an attack at +4 ATK.",
      "long_description": "DO NOT USE: This unit makes an attack at +4 ATK.",
      "class_name": "CalculatedAttack",
      "revision": 1
    },
    {
      "asset_id": 4137,
      "resettable": 1,
      "name": "Calculated Attack",
      "ap_cost": 1,
      "level": 3,
      "ability_id": 352,
      "activated": 1,
      "icon_name": "",
      "comments": "none",
      "prerequisite_id": 351,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 1,
      "cost": 6,
      "short_description": "DO NOT USE: This unit makes an attack at +6 ATK.",
      "long_description": "DO NOT USE: This unit makes an attack at +6 ATK.",
      "class_name": "CalculatedAttack",
      "revision": 1
    },
    {
      "asset_id": 5721,
      "resettable": 1,
      "name": "Caliginous Emulsion",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2603,
      "activated": 1,
      "icon_name": "drain",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 7,
      "short_description": "When a champion within 3 spaces would take Fire damage, it loses an equal amount of HP instead.",
      "long_description": "When a champion within 3 spaces would take Fire damage, it loses an equal amount of HP instead.",
      "class_name": "CaliginousEmulsion",
      "revision": 1
    },
    {
      "asset_id": 4061,
      "resettable": 1,
      "name": "Call",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1321,
      "activated": 1,
      "icon_name": "scry",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 2,
      "short_description": "When this unit comes into play a champion rune is revealed.",
      "long_description": "When this unit comes into play a champion rune is revealed.",
      "class_name": "Call",
      "revision": 1
    },
    {
      "asset_id": 4163,
      "resettable": 1,
      "name": "Call of the Hunter",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2785,
      "activated": 1,
      "icon_name": "relocate",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "This champion gains <ability value=657>Relocate: Ally</ability> for 2 turns.  This ability can only be used if this unit is adjacent to an opposing champion.",
      "long_description": "This champion gains <ability value=657>Relocate: Ally</ability> for 2 turns.  This ability can only be used if this unit is adjacent to an opposing champion.",
      "class_name": "CallOfTheHunter",
      "revision": 1
    },
    {
      "asset_id": 5660,
      "resettable": 1,
      "name": "Call to Arms",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2532,
      "activated": 1,
      "icon_name": "allybuffs",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 2,
      "short_description": "Whenever this champion makes a successful basic attack, the next champion deployed that shares a race or class with this one costs 2 less nora.  This effect stacks.",
      "long_description": "Whenever this champion makes a successful basic attack, the next champion deployed that shares a race or class with this one costs 2 less nora.  This effect stacks.",
      "class_name": "CallToArms",
      "revision": 1
    },
    {
      "asset_id": 5183,
      "resettable": 1,
      "name": "Call: Celestial Spear",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2733,
      "activated": 1,
      "icon_name": "deploy",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "Summon a Celestial Spear to target space within 3 spaces.  This ability is removed after use.",
      "long_description": "Summon a Celestial Spear to target space within 3 spaces.  This ability is removed after use.",
      "class_name": "CallCelestialSpear",
      "revision": 1
    },
    {
      "asset_id": 7908,
      "resettable": 0,
      "name": "Call: Dreamblossom",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 3340,
      "activated": 1,
      "icon_name": "deploy",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "Summon a Dreamblossom to target space within 3 spaces. This ability is removed after use.",
      "long_description": "Summon a Dreamblossom to target space within 3 spaces. This ability is removed after use.",
      "class_name": "CallDreamblossom",
      "revision": 1
    },
    {
      "asset_id": 4396,
      "resettable": 1,
      "name": "Camaraderie ",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1437,
      "activated": 1,
      "icon_name": "cost",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "Champions that share a race or class with this champion cost 3 less Nora. This does not stack.",
      "long_description": "Champions that share a race or class with this champion cost 3 less Nora. This does not stack.",
      "class_name": "Camaradarie",
      "revision": 1
    },
    {
      "asset_id": 4066,
      "resettable": 1,
      "name": "Camouflage",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 106,
      "activated": 1,
      "icon_name": "camo",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 2,
      "short_description": "When this unit is damaged by a ranged attack while it is occupying Vegetation, that damage is reduced by 2.",
      "long_description": "When this unit is damaged by a ranged attack while it is occupying Vegetation, that damage is reduced by 2.",
      "class_name": "Camouflage",
      "revision": 1
    },
    {
      "asset_id": 5399,
      "resettable": 1,
      "name": "Cannon Barrage",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2231,
      "activated": 1,
      "icon_name": "cannon_barrage",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "Spend 6 charges. Area Effect 2, Range 5: For each friendly real Tortun (up to 5), a random space is targeted by an AE1 Cannon Ball effect.  Units affected by the Cannon Ball effect take 10 Physical damage (this damage ignores DEF).",
      "long_description": "Spend 6 charges. Area Effect 2, Range 5: For each friendly real Tortun (up to 5), a random space is targeted by an AE1 Cannon Ball effect.  Units affected by the Cannon Ball effect take 10 Physical damage (this damage ignores DEF).",
      "class_name": "CannonBarrage",
      "revision": 1
    },
    {
      "asset_id": 5300,
      "resettable": 1,
      "name": "Cannon Shot",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2123,
      "activated": 1,
      "icon_name": "artillery",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "Target unit within 3-6 spaces takes 10 Physical damage (ignores DEF). This ability is not an attack and is removed after 4 uses.",
      "long_description": "Target unit within 3-6 spaces takes 10 Physical damage (ignores DEF). This ability is not an attack and is removed after 4 uses.",
      "class_name": "CannonShot",
      "revision": 1
    },
    {
      "asset_id": 5227,
      "resettable": 1,
      "name": "Careless",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2005,
      "activated": 1,
      "icon_name": "debuff",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -8,
      "short_description": "This unit loses all AP at the end of its turn.",
      "long_description": "This unit loses all AP at the end of its turn.",
      "class_name": "Careless",
      "revision": 1
    },
    {
      "asset_id": 5613,
      "resettable": 1,
      "name": "Carouse",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 2473,
      "activated": 1,
      "icon_name": "carouse",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "Target adjacent champion is equipped with a Pale Brew. If this champion is equipped with a Brew equipment, the target is equipped with that Brew instead. Brew replaces the Pale Brew. Equipment generated by this ability costs 0 nora.",
      "long_description": "Target adjacent champion is equipped with a Pale Brew. If this champion is equipped with a Brew equipment, the target is equipped with that Brew instead. Brew replaces the Pale Brew. Equipment generated by this ability costs 0 nora.",
      "class_name": "Carouse",
      "revision": 1
    },
    {
      "asset_id": 5644,
      "resettable": 1,
      "name": "Cast: Alacrity",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2515,
      "activated": 1,
      "icon_name": "killing_stroke",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "Area Effect 3, Range 4: Friendly champions gain 4 AP and lose 8 HP.",
      "long_description": "Area Effect 3, Range 4: Friendly champions gain 4 AP and lose 8 HP.",
      "class_name": "CastAlacrity",
      "revision": 1
    },
    {
      "asset_id": 5621,
      "resettable": 1,
      "name": "Cast: Blessing of Al'Mara",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 2485,
      "activated": 1,
      "icon_name": "flight",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "Target champion gains Flight; if target champion has Class: Paladin or Priest, it also gains <ability value=1395>Hunter: Walker</ability> and Race: Angel.",
      "long_description": "Target champion gains Flight; if target champion has Class: Paladin or Priest, it also gains <ability value=1395>Hunter: Walker</ability> and Race: Angel.",
      "class_name": "CastBlessingOfAlmara",
      "revision": 1
    },
    {
      "asset_id": 5579,
      "resettable": 1,
      "name": "Cast: Blood of the Dragon",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2439,
      "activated": 1,
      "icon_name": "draconic",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 6,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "For 6 turns, all friendly <mechanic value=dragonkin>Dragonkin</mechanic> have <ability value=249>Damage Shield: Acid 3</ability>.",
      "long_description": "For 6 turns, all friendly <mechanic value=dragonkin>Dragonkin</mechanic> have <ability value=249>Damage Shield: Acid 3</ability>.",
      "class_name": "CastBloodOfTheDragon",
      "revision": 1
    },
    {
      "asset_id": 5643,
      "resettable": 1,
      "name": "Cast: Cauterize ",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2514,
      "activated": 1,
      "icon_name": "fire",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "Target injured champion within 3 spaces takes 10 Fire damage and is <condition value=inhibited>Inhibited</condition> and <condition value=defiled>Defiled</condition>. ",
      "long_description": "Target injured champion within 3 spaces takes 10 Fire damage and is <condition value=inhibited>Inhibited</condition> and <condition value=defiled>Defiled</condition>. ",
      "class_name": "CastCauterize",
      "revision": 1
    },
    {
      "asset_id": 5572,
      "resettable": 1,
      "name": "Cast: Dark Pact",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2432,
      "activated": 1,
      "icon_name": "boost",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 6,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "Target a champion you own within 5 spaces. The next time this champion is the target of a spell within 6 turns, that spell is cast upon the closest enemy champion instead. Your shrine or avatar takes 5 damage when triggered. If the champion is not a valid target, the spell fizzles. This effect is hidden until triggered.",
      "long_description": "Target a champion you own within 5 spaces. The next time this champion is the target of a spell within 6 turns, that spell is cast upon the closest enemy champion instead. Your shrine or avatar takes 5 damage when triggered. If the champion is not a valid target, the spell fizzles. This effect is hidden until triggered.",
      "class_name": "CastDarkPact",
      "revision": 1
    },
    {
      "asset_id": 5649,
      "resettable": 1,
      "name": "Cast: Despoil",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2518,
      "activated": 1,
      "icon_name": "desecrate_earth",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "Area Effect 3, Range 4: A <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic> is created in the target area for 8 turns. For the next 6 turns, this area grows one space at the beginning of each of your turns. All nora globes that drop within the affected area are automatically collected by the casting player.",
      "long_description": "Area Effect 3, Range 4: A <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic> is created in the target area for 8 turns. For the next 6 turns, this area grows one space at the beginning of each of your turns. All nora globes that drop within the affected area are automatically collected by the casting player.",
      "class_name": "CastDespoil",
      "revision": 1
    },
    {
      "asset_id": 5641,
      "resettable": 1,
      "name": "Cast: Energy Overload",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2512,
      "activated": 1,
      "icon_name": "chrg_blast",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "For the next 6 turns, your opponent's Shrine or Avatar takes damage equal to 10% of their total nora at the end of their turn.",
      "long_description": "For the next 6 turns, your opponent's Shrine or Avatar takes damage equal to 10% of their total nora at the end of their turn.",
      "class_name": "CastEnergyOverload",
      "revision": 1
    },
    {
      "asset_id": 5476,
      "resettable": 1,
      "name": "Cast: Ghostly Visage",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2335,
      "activated": 1,
      "icon_name": "ethereal",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "Target champion within 4 spaces becomes <condition value=incorporeal>Incorporeal</condition> for 4 turns.",
      "long_description": "Target champion within 4 spaces becomes <condition value=incorporeal>Incorporeal</condition> for 4 turns.",
      "class_name": "CastGhostlyVisage",
      "revision": 1
    },
    {
      "asset_id": 5617,
      "resettable": 1,
      "name": "Cast: Hungry Mire",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 2481,
      "activated": 1,
      "icon_name": "hungry_mire",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "Area Effect 2, Range 4: For the next 4 turns, all spaces become Dirt and Shallow Water. When a champion without <condition value=flying>Flying</condition> enters one of these spaces, it takes 5 Physical damage and becomes <condition value=ensnared>Ensnared</condition> for 2 turns.",
      "long_description": "Area Effect 2, Range 4: For the next 4 turns, all spaces become Dirt and Shallow Water. When a champion without <condition value=flying>Flying</condition> enters one of these spaces, it takes 5 Physical damage and becomes <condition value=ensnared>Ensnared</condition> for 2 turns.",
      "class_name": "InvokeHungryMire",
      "revision": 1
    },
    {
      "asset_id": 5633,
      "resettable": 1,
      "name": "Cast: Light as a Feather",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2501,
      "activated": 1,
      "icon_name": "feather",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "Area Effect 1, Range 4: Affected champions gain <ability value=1>Flight</ability> and <ability value=6>Mobility</ability> for 6 turns and 1 AP.  If the champions have <ability value=5>Lumbering</ability> or <ability value=3064>Weighty</ability>, or <ability value=2012>Lethargic</ability>, they lose it for 6 turns.",
      "long_description": "Area Effect 1, Range 4: Affected champions gain <ability value=1>Flight</ability> and <ability value=6>Mobility</ability> for 6 turns and 1 AP.  If the champions have <ability value=5>Lumbering</ability> or <ability value=3064>Weighty</ability>, or <ability value=2012>Lethargic</ability>, they lose it for 6 turns.",
      "class_name": "CastLightAsAfeather",
      "revision": 1
    },
    {
      "asset_id": 5360,
      "resettable": 1,
      "name": "Cataclysm",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2192,
      "activated": 1,
      "icon_name": "cataclysm",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 20,
      "short_description": "Spend 15 charges.  All other champions within 8 spaces take 20 fire damage and this champion loses all remaining charges.",
      "long_description": "Spend 15 charges.  All other champions within 8 spaces take 20 fire damage and this champion loses all remaining charges.",
      "class_name": "Cataclysm",
      "revision": 1
    },
    {
      "asset_id": 7310,
      "resettable": 0,
      "name": "Catalyst: Electricity",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3090,
      "activated": 1,
      "icon_name": "breaker_electricity",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "When this unit is successfully attacked by a basic attack, all opposing champions within 3 spaces take 4 Electricity damage.",
      "long_description": "When this unit is successfully attacked by a basic attack, all opposing champions within 3 spaces take 4 Electricity damage.",
      "class_name": "CatalystElectricity",
      "revision": 1
    },
    {
      "asset_id": 5810,
      "resettable": 1,
      "name": "Catalyst: Frost",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2819,
      "activated": 1,
      "icon_name": "catalyst_frost",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "When this unit is successfully attacked by a basic attack, all opposing champions within 3 spaces take 4 Frost damage.",
      "long_description": "When this unit is successfully attacked by a basic attack, all opposing champions within 3 spaces take 4 Frost damage.",
      "class_name": "CatalystFrost",
      "revision": 1
    },
    {
      "asset_id": 7325,
      "resettable": 0,
      "name": "Catalyst: Psychic",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3100,
      "activated": 1,
      "icon_name": "catalyst_psychic",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "When this unit is successfully attacked by a basic attack, all opposing champions within 3 spaces take 4 Psychic damage.",
      "long_description": "When this unit is successfully attacked by a basic attack, all opposing champions within 3 spaces take 4 Psychic damage.",
      "class_name": "CatalystPsychic",
      "revision": 1
    },
    {
      "asset_id": 4183,
      "resettable": 1,
      "name": "Catapult",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 645,
      "activated": 1,
      "icon_name": "throw_champ",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "This unit is relocated to target location within 5 spaces.  This ability is removed after use.",
      "long_description": "This unit is relocated to target location within 5 spaces.  This ability is removed after use.",
      "class_name": "Catapult",
      "revision": 1
    },
    {
      "asset_id": 5833,
      "resettable": 1,
      "name": "Catharsis Bloom (relic)",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 2842,
      "activated": 1,
      "icon_name": "charm",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 2,
      "ranked": 0,
      "cost": 8,
      "short_description": "At the end of each of its turns, units within 2 spaces heal 6 HP.",
      "long_description": "At the end of each of its turns, units within 2 spaces heal 6 HP.",
      "class_name": "RelicCatharsisBloom",
      "revision": 1
    },
    {
      "asset_id": 5761,
      "resettable": 1,
      "name": "Celestial Radiance",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2736,
      "activated": 1,
      "icon_name": "novamagic",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this unit is deployed, opposing champions within 4 spaces takes 8 Magical damage. This damage ignores DEF. When a friendly Paladin, Priest or Shaman within 3 spaces is successfully attacked, the attacker takes 4 Electricity damage.",
      "long_description": "When this unit is deployed, opposing champions within 4 spaces takes 8 Magical damage. This damage ignores DEF. When a friendly Paladin, Priest or Shaman within 3 spaces is successfully attacked, the attacker takes 4 Electricity damage.",
      "class_name": "CelestialRadiance",
      "revision": 1
    },
    {
      "asset_id": 7178,
      "resettable": 0,
      "name": "Censure",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 3021,
      "activated": 1,
      "icon_name": "lossoflife",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 3,
      "ranked": 0,
      "cost": 8,
      "short_description": "This champion makes a <mechanic value=lossoflife>Loss of Life</mechanic> at RNG 2-5.  If that champion is Cursed or occupies Dead Magic Zone, it takes an additional 3 Psychic damage and loses all remaining AP.",
      "long_description": "This champion makes a <mechanic value=lossoflife>Loss of Life</mechanic> at RNG 2-5.  If that champion is Cursed or occupies Dead Magic Zone, it takes an additional 3 Psychic damage and loses all remaining AP.",
      "class_name": "Censure",
      "revision": 1
    },
    {
      "asset_id": 5748,
      "resettable": 1,
      "name": "Cerulean Sigil",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2715,
      "activated": 1,
      "icon_name": "griffin_sigil",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 3,
      "short_description": "This champion gains <ability value=1947>Entangling Attack</ability> for 5 turns when a friendly unit with a Sigil ability is deployed from the runedock.",
      "long_description": "This champion gains <ability value=1947>Entangling Attack</ability> for 5 turns when a friendly unit with a Sigil ability is deployed from the runedock.",
      "class_name": "CeruleanSigil",
      "revision": 1
    },
    {
      "asset_id": 4453,
      "resettable": 1,
      "name": "Chain Lightning",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 805,
      "activated": 1,
      "icon_name": "electric",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 7,
      "short_description": "This champion makes an attack at Range 2-4 against a champion for 13 Electricity damage, then each enemy unit within 2 spaces of the target takes 10 Electricity damage, then each enemy unit within 2 spaces of those units take 7 Electricity damage. This damage ignores DEF. A single unit may not take more than one instance of damage from this effect.",
      "long_description": "This champion makes an attack at Range 2-4 against a champion for 13 Electricity damage, then each enemy unit within 2 spaces of the target takes 10 Electricity damage, then each enemy unit within 2 spaces of those units take 7 Electricity damage. This damage ignores DEF. A single unit may not take more than one instance of damage from this effect.",
      "class_name": "ChainLightningAbility",
      "revision": 1
    },
    {
      "asset_id": 5708,
      "resettable": 1,
      "name": "Chains of Amareth",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2589,
      "activated": 1,
      "icon_name": "chains_of_amareth",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "When a friendly Fairy, Wizard or Elemental is deployed from the rune dock, it gains 5 MAX HP, this champion loses 5 MAX HP and you gain 5 nora. This ability does not stack",
      "long_description": "When a friendly Fairy, Wizard or Elemental is deployed from the rune dock, it gains 5 MAX HP, this champion loses 5 MAX HP and you gain 5 nora. This ability does not stack",
      "class_name": "ChainsOfAmareth",
      "revision": 1
    },
    {
      "asset_id": 4426,
      "resettable": 1,
      "name": "Change Attack: Loss of Life",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 1930,
      "activated": 1,
      "icon_name": "lossoflife",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "Damage dealt by this unit is Loss of Life",
      "long_description": "Damage dealt by this unit is Loss of Life",
      "class_name": "ChangeAttackLossOfLife",
      "revision": 1
    },
    {
      "asset_id": 4426,
      "resettable": 1,
      "name": "Change Attack: Physical",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 765,
      "activated": 1,
      "icon_name": "physical",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "Damage dealt by this unit is Physical damage.",
      "long_description": "Damage dealt by this unit is Physical damage.",
      "class_name": "ChangeAttackPhysical",
      "revision": 1
    },
    {
      "asset_id": 5777,
      "resettable": 1,
      "name": "Change of Plans",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2756,
      "activated": 1,
      "icon_name": "special",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 3,
      "short_description": "Target champion within 5 spaces and this champion gain <ability value=2474>Font Ignorance</ability> for 4 turns. If this effect is <mechanic value=cleansed>Cleansed</mechanic> off either champion, it is removed from the other.",
      "long_description": "Target champion within 5 spaces and this champion gain <ability value=2474>Font Ignorance</ability> for 4 turns. If this effect is <mechanic value=cleansed>Cleansed</mechanic> off either champion, it is removed from the other.",
      "class_name": "ChangeOfPlans",
      "revision": 1
    },
    {
      "asset_id": 5184,
      "resettable": 1,
      "name": "Channel: Damage",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1961,
      "activated": 1,
      "icon_name": "channel_damage",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "This champion has +1 DMG for 2 turns and <ability value=655>Skirmisher</ability> for 2 turns. This ability initially costs 4 nora to activate, with the cost increasing by 1 nora per activation for 1 turn.",
      "long_description": "This champion has +1 DMG for 2 turns and <ability value=655>Skirmisher</ability> for 2 turns. This ability initially costs 4 nora to activate, with the cost increasing by 1 nora per activation for 1 turn.",
      "class_name": "ChannelDamage",
      "revision": 1
    },
    {
      "asset_id": 5174,
      "resettable": 1,
      "name": "Channel: Defense",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1951,
      "activated": 1,
      "icon_name": "channel_defense",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "This champion has +1 DEF for 2 turns and <ability value=655>Skirmisher</ability> for 2 turns. This ability initially costs 4 nora to activate, with the cost increasing by 1 nora per activation for 1 turn.",
      "long_description": "This champion has +1 DEF for 2 turns and <ability value=655>Skirmisher</ability> for 2 turns. This ability initially costs 4 nora to activate, with the cost increasing by 1 nora per activation for 1 turn.",
      "class_name": "ChannelDefense",
      "revision": 1
    },
    {
      "asset_id": 5171,
      "resettable": 1,
      "name": "Channel: Speed",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1948,
      "activated": 1,
      "icon_name": "channel_speed",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "This champion has +1 SPD for 3 turns and <ability value=655>Skirmisher</ability> for 3 turns. This ability initially costs 4 nora to activate, with the cost increasing by 1 nora per activation for 1 turn.",
      "long_description": "This champion has +1 SPD for 3 turns and <ability value=655>Skirmisher</ability> for 3 turns. This ability initially costs 4 nora to activate, with the cost increasing by 1 nora per activation for 1 turn.",
      "class_name": "ChannelSpeed",
      "revision": 1
    },
    {
      "asset_id": 4148,
      "resettable": 1,
      "name": "Charge",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 394,
      "activated": 1,
      "icon_name": "charge",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 1,
      "cost": 1,
      "short_description": "This champion moves 1 space in a straight line through non-Impeding terrain and makes a close-combat attack at +1 DMG.",
      "long_description": "This champion moves 1 space in a straight line through non-Impeding terrain and makes a close-combat attack at +1 DMG.",
      "class_name": "Charge",
      "revision": 1
    },
    {
      "asset_id": 4148,
      "resettable": 1,
      "name": "Charge",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 395,
      "activated": 1,
      "icon_name": "charge",
      "comments": "none",
      "prerequisite_id": 394,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 1,
      "cost": 3,
      "short_description": "This champion moves 1-2 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +2 DMG.",
      "long_description": "This champion moves 1-2 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +2 DMG.",
      "class_name": "Charge",
      "revision": 1
    },
    {
      "asset_id": 4148,
      "resettable": 1,
      "name": "Charge",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 396,
      "activated": 1,
      "icon_name": "charge",
      "comments": "none",
      "prerequisite_id": 395,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 1,
      "cost": 5,
      "short_description": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
      "long_description": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
      "class_name": "Charge",
      "revision": 1
    },
    {
      "asset_id": 5331,
      "resettable": 1,
      "name": "Charged",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 2160,
      "activated": 1,
      "icon_name": "heal_charged",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 3,
      "short_description": "When this unit comes into play, it gains 3 charges.",
      "long_description": "When this unit comes into play, it gains 3 charges.",
      "class_name": "Charged",
      "revision": 1
    },
    {
      "asset_id": 5331,
      "resettable": 1,
      "name": "Charged",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 2161,
      "activated": 1,
      "icon_name": "heal_charged",
      "comments": "",
      "prerequisite_id": 2160,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 5,
      "short_description": "When this unit comes into play, it gains 5 charges.",
      "long_description": "When this unit comes into play, it gains 5 charges.",
      "class_name": "Charged",
      "revision": 1
    },
    {
      "asset_id": 5331,
      "resettable": 1,
      "name": "Charged",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 2162,
      "activated": 1,
      "icon_name": "heal_charged",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 7,
      "short_description": "When this unit comes into play, it gains 7 charges.",
      "long_description": "When this unit comes into play, it gains 7 charges.",
      "class_name": "Charged",
      "revision": 1
    },
    {
      "asset_id": 5358,
      "resettable": 1,
      "name": "Charged Attack",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2190,
      "activated": 1,
      "icon_name": "charged_attack",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "Spend 3 Charges: This champion makes an attack at its RNG. This is a free attack (costs 0 AP and is not on the attack chain).",
      "long_description": "Spend 3 Charges: This champion makes an attack at its RNG. This is a free attack (costs 0 AP and is not on the attack chain).",
      "class_name": "ChargedAttack",
      "revision": 1
    },
    {
      "asset_id": 5487,
      "resettable": 1,
      "name": "Charged Barricade",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2346,
      "activated": 1,
      "icon_name": "charged_barricade",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Spend 2 charges: Summon a Barricade relic to target location within 4 spaces. ",
      "long_description": "Spend 2 charges: Summon a Barricade relic to target location within 4 spaces. ",
      "class_name": "ChargedBarricade",
      "revision": 1
    },
    {
      "asset_id": 5448,
      "resettable": 1,
      "name": "Charged Blast",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2300,
      "activated": 1,
      "icon_name": "magicaoe",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 3,
      "ranked": 0,
      "cost": 6,
      "short_description": "Spend 5 Charges.  This champion makes a Magic attack against each opposing champion within its range.",
      "long_description": "Spend 5 Charges.  This champion makes a Magic attack against each opposing champion within its range.",
      "class_name": "ChargedBlast",
      "revision": 1
    },
    {
      "asset_id": 5412,
      "resettable": 1,
      "name": "Charged Disease Breath",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2243,
      "activated": 1,
      "icon_name": "diseaseaoe",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "Spend 6 Charges. Area Effect 2, Range 5: Affected units take Disease damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=diseased>Diseased</condition> for 2 turns. \r\n",
      "long_description": "Spend 6 Charges. Area Effect 2, Range 5: Affected units take Disease damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=diseased>Diseased</condition> for 2 turns. \r\n\r\n",
      "class_name": "ChargedDiseaseBreath",
      "revision": 1
    },
    {
      "asset_id": 4430,
      "resettable": 1,
      "name": "Charged Fire Bomb",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2696,
      "activated": 1,
      "icon_name": "fireaoe",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "Spend 6 Charges.  Area Effect 2, Range 5: Affected units take Fire damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=charred>Charred</condition> for 2 turns.",
      "long_description": "Spend 6 Charges.  Area Effect 2, Range 5: Affected units take Fire damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=charred>Charred</condition> for 2 turns.",
      "class_name": "ChargedFireBomb",
      "revision": 1
    },
    {
      "asset_id": 5415,
      "resettable": 1,
      "name": "Charged Flame Fist",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2279,
      "activated": 1,
      "icon_name": "chrg_flame_fist",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 3,
      "ranked": 0,
      "cost": 8,
      "short_description": "Spend 4 Charges. This unit makes a Fire attack at +2 DMG at its range against target unit.",
      "long_description": "Spend 4 Charges. This unit makes a Fire attack at +2 DMG at its range against target unit.",
      "class_name": "ChargedFlameFist",
      "revision": 1
    },
    {
      "asset_id": 5396,
      "resettable": 1,
      "name": "Charged Frost Cone",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2228,
      "activated": 1,
      "icon_name": "iceaoe",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "Spend 6 Charges.  Area Effect 2, Range 5: Affected units take Frost damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=chilled>Chilled</condition> 2. ",
      "long_description": "Spend 6 Charges.  Area Effect 2, Range 5: Affected units take Frost damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=chilled>Chilled</condition> 2. ",
      "class_name": "ChargedFrostCone",
      "revision": 1
    },
    {
      "asset_id": 5414,
      "resettable": 1,
      "name": "Charged Frost Kick",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2278,
      "activated": 1,
      "icon_name": "chrg_frost_kick",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 3,
      "ranked": 0,
      "cost": 8,
      "short_description": "Spend 4 Charges. This unit makes a Frost attack at +2 DMG at its range against target unit.",
      "long_description": "Spend 4 Charges. This unit makes a Frost attack at +2 DMG at its range against target unit.",
      "class_name": "ChargedFrostKick",
      "revision": 1
    },
    {
      "asset_id": 5357,
      "resettable": 1,
      "name": "Charged Heal",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2189,
      "activated": 1,
      "icon_name": "heal",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "Spend 3 Charges.  Target friendly champion within 5 spaces heals 12 HP.  May target self.\r\n",
      "long_description": "Spend 3 Charges.  Target friendly champion within 5 spaces heals 12 HP.  May target self.\r\n",
      "class_name": "ChargedHeal",
      "revision": 1
    },
    {
      "asset_id": 5397,
      "resettable": 1,
      "name": "Charged Magic Bomb",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2229,
      "activated": 1,
      "icon_name": "magicaoe",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "Spend 6 Charges.  Area Effect 2, Range 5: Affected units take Magic damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged have their DEF set to 0 until the end of turn if their DEF is greater than 0.",
      "long_description": "Spend 6 Charges.  Area Effect 2, Range 5: Affected units take Magic damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged have their DEF set to 0 until the end of turn if their DEF is greater than 0.",
      "class_name": "ChargedMagicBomb",
      "revision": 1
    },
    {
      "asset_id": 5450,
      "resettable": 1,
      "name": "Charged Portal",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2302,
      "activated": 1,
      "icon_name": "chrg_torton_portal",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 2,
      "short_description": "Spend 1 Charges.  Friendly champions within 4 spaces that share a race with this champion gain <ability value=820>Portal</ability> for 1 turn.",
      "long_description": "Spend 1 Charges.  Friendly champions within 4 spaces that share a race with this champion gain <ability value=820>Portal</ability> for 1 turn.",
      "class_name": "ChargedPortal",
      "revision": 1
    },
    {
      "asset_id": 4153,
      "resettable": 1,
      "name": "Charm",
      "ap_cost": 2,
      "level": 1,
      "ability_id": 414,
      "activated": 1,
      "icon_name": "charm",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 1,
      "cost": 2,
      "short_description": "Adjacent enemy champions become <condition value=charmed>Charmed 3</condition> All affected champions are disengaged from each other.",
      "long_description": "Adjacent enemy champions become <condition value=charmed>Charmed 3</condition> All affected champions are disengaged from each other.",
      "class_name": "Charm",
      "revision": 1
    },
    {
      "asset_id": 4153,
      "resettable": 1,
      "name": "Charm",
      "ap_cost": 2,
      "level": 2,
      "ability_id": 415,
      "activated": 1,
      "icon_name": "charm",
      "comments": "none",
      "prerequisite_id": 414,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 1,
      "cost": 4,
      "short_description": "Enemy champions within 2 spaces become <condition value=charmed>Charmed 3</condition> All affected champions are disengaged from each other.",
      "long_description": "Enemy champions within 2 spaces become <condition value=charmed>Charmed 3</condition> All affected champions are disengaged from each other.",
      "class_name": "Charm",
      "revision": 1
    },
    {
      "asset_id": 4153,
      "resettable": 1,
      "name": "Charm",
      "ap_cost": 2,
      "level": 3,
      "ability_id": 416,
      "activated": 1,
      "icon_name": "charm",
      "comments": "none",
      "prerequisite_id": 415,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 1,
      "cost": 6,
      "short_description": "Enemy champions within 3 spaces become <condition value=charmed>Charmed</condition> for 3 turns.",
      "long_description": "Enemy champions within 3 spaces become <condition value=charmed>Charmed</condition> for 3 turns.",
      "class_name": "Charm",
      "revision": 1
    },
    {
      "asset_id": 4588,
      "resettable": 1,
      "name": "Charm Serpent",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 980,
      "activated": 1,
      "icon_name": "charm",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "Control target enemy Serpent champion within 4 spaces. You control that unit for 3 turns. This unit is Paralyzed while it possesses that champion.",
      "long_description": "Control target enemy Serpent champion within 4 spaces. You control that unit for 3 turns. This unit is Paralyzed while it possesses that champion.",
      "class_name": "CharmSerpent",
      "revision": 1
    },
    {
      "asset_id": 2183,
      "resettable": 1,
      "name": "Chasm Walker",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1408,
      "activated": 1,
      "icon_name": "terrainchasm",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 2,
      "short_description": "This unit can walk over <mechanic value=chasm>chasm</mechanic> spaces without dying.",
      "long_description": "This unit can walk over <mechanic value=chasm>chasm</mechanic> spaces without dying.",
      "class_name": "ChasmWalker",
      "revision": 1
    },
    {
      "asset_id": 4431,
      "resettable": 1,
      "name": "Chill",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 774,
      "activated": 1,
      "icon_name": "dot_chill",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 3,
      "short_description": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=chilled>Chilled</condition> for 3 turns.",
      "long_description": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=chilled>Chilled</condition> for 3 turns.",
      "class_name": "Chill",
      "revision": 1
    },
    {
      "asset_id": 4431,
      "resettable": 1,
      "name": "Chill",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 775,
      "activated": 1,
      "icon_name": "dot_chill",
      "comments": "",
      "prerequisite_id": 774,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 6,
      "short_description": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=chilled>Chilled</condition> for 4 turns.",
      "long_description": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=chilled>Chilled</condition> for 4 turns.",
      "class_name": "Chill",
      "revision": 1
    },
    {
      "asset_id": 4431,
      "resettable": 1,
      "name": "Chill",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 776,
      "activated": 1,
      "icon_name": "dot_chill",
      "comments": "",
      "prerequisite_id": 775,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 9,
      "short_description": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=chilled>Chilled</condition> for 5 turns.",
      "long_description": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=chilled>Chilled</condition> for 5 turns.",
      "class_name": "Chill",
      "revision": 1
    },
    {
      "asset_id": 7124,
      "resettable": 0,
      "name": "Chilling Discipline",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2939,
      "activated": 1,
      "icon_name": "discipline_chilling",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 3,
      "short_description": "The next basic attack this champion makes causes <condition value=chilled>Chilled</condition> for 4 turns. If the target was <condition value=frozen popup=false>Frozen</condition>, all friendly Monks gain 1 damage for 6 turns",
      "long_description": "The next basic attack this champion makes causes <condition value=chilled>Chilled</condition> for 4 turns. If the target was <condition value=frozen popup=false>Frozen</condition>, all friendly Monks gain 1 damage for 6 turns",
      "class_name": "ChillingDiscipline",
      "revision": 1
    },
    {
      "asset_id": 5725,
      "resettable": 1,
      "name": "Choking Aura",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2612,
      "activated": 1,
      "icon_name": "choking_stench",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 7,
      "short_description": "The closest enemy unit within 6 spaces without <ability value=91>Vulnerability: Poison</ability> gains Vulnerability - Poison.",
      "long_description": "The closest enemy unit within 6 spaces without <ability value=91>Vulnerability: Poison</ability> gains Vulnerability - Poison.",
      "class_name": "ChokingAura",
      "revision": 1
    },
    {
      "asset_id": 5395,
      "resettable": 1,
      "name": "Choking Stench",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2227,
      "activated": 1,
      "icon_name": "choking_stench",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "Spaces within 2 spaces of this unit are <mechanic value=poison_cloud>Poison Cloud</mechanic>.  This Poison Cloud does not deal damage on deploy.",
      "long_description": "Spaces within 2 spaces of this unit are <mechanic value=poison_cloud>Poison Cloud</mechanic>.  This Poison Cloud does not deal damage on deploy.",
      "class_name": "ChokingStench",
      "revision": 1
    },
    {
      "asset_id": 7195,
      "resettable": 0,
      "name": "Chosen of Osarius",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3037,
      "activated": 1,
      "icon_name": "fate_osarius",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "When this champion is destroyed, a Head of Osarius relic is summoned to a random location within 4 spaces.",
      "long_description": "When this champion is destroyed, a Head of Osarius relic is summoned to a random location within 4 spaces.",
      "class_name": "FateOfOsarius",
      "revision": 1
    },
    {
      "asset_id": 7552,
      "resettable": 0,
      "name": "Chuck: Flaming Skull",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 3206,
      "activated": 1,
      "icon_name": "chuck_flamingskull",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 3,
      "ranked": 0,
      "cost": 10,
      "short_description": "This champion makes a Fire attack at RNG 2-5. A summoned Flaming Skull relic with 0 DEF, 15 HP, <ability value=3205>Flaming Skull</ability> is summoned adjacent to the target if it is successfully damaged.\r\n",
      "long_description": "This champion makes a Fire attack at RNG 2-5. A summoned Flaming Skull relic with 0 DEF, 15 HP, <ability value=3205>Flaming Skull</ability> is summoned adjacent to the target if it is successfully damaged.",
      "class_name": "ChuckFlamingSkull",
      "revision": 1
    },
    {
      "asset_id": 7605,
      "resettable": 0,
      "name": "Chuck: Mangled Totem",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 3232,
      "activated": 1,
      "icon_name": "chuck_mangledtotem",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 3,
      "ranked": 0,
      "cost": 15,
      "short_description": "This champion makes a Physical Attack at RNG 2-5.  A summoned Mangled Totem relic (20 HP with <ability value=2277>Punishing Aura</ability>) is summoned adjacent to the target if it is successfully damaged.",
      "long_description": "This champion makes a Physical Attack at RNG 2-5.  A summoned Mangled Totem relic (20 HP with <ability value=2277>Punishing Aura</ability>) is summoned adjacent to the target if it is successfully damaged.",
      "class_name": "ChuckMangledTotem",
      "revision": 1
    },
    {
      "asset_id": 5474,
      "resettable": 1,
      "name": "Chuck: Moga",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 2333,
      "activated": 1,
      "icon_name": "summoga",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 12,
      "short_description": "This champion makes a ranged Physical attack at RNG 2-5. A summoned Moga Axeman with no upgrades is summoned adjacent to the target if it is successfully damaged.",
      "long_description": "This champion makes a ranged Physical attack at RNG 2-5. A summoned Moga Axeman with no upgrades is summoned adjacent to the target if it is successfully damaged.",
      "class_name": "ChuckMoga",
      "revision": 1
    },
    {
      "asset_id": 7150,
      "resettable": 0,
      "name": "Chuck: Rusty Firecase",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 2992,
      "activated": 1,
      "icon_name": "summon_firecase",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 3,
      "ranked": 0,
      "cost": 15,
      "short_description": "This champion makes a ranged Fire attack at RNG 2-5.  A summoned Rusty Firecase with no upgrades is summoned adjacent to the target if it is successfully damaged.",
      "long_description": "This champion makes a ranged Fire attack at RNG 2-5.  A summoned Rusty Firecase with no upgrades is summoned adjacent to the target if it is successfully damaged.",
      "class_name": "ChuckFirecase",
      "revision": 1
    },
    {
      "asset_id": 5219,
      "resettable": 1,
      "name": "Chuck: Spider",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 1996,
      "activated": 1,
      "icon_name": "sumspider",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 3,
      "ranked": 0,
      "cost": 12,
      "short_description": "This champion makes a ranged Physical attack at RNG 2-5. A Spiderling is with no upgrades is summoned adjacent to the target if it is successfully damaged.",
      "long_description": "This champion makes a ranged Physical attack at RNG 2-5. A Spiderling is with no upgrades is summoned adjacent to the target if it is successfully damaged.",
      "class_name": "ChuckSpider",
      "revision": 1
    },
    {
      "asset_id": 7491,
      "resettable": 0,
      "name": "Chuck: Thunderaxe",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 3172,
      "activated": 1,
      "icon_name": "chuck_thunderaxe",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 3,
      "ranked": 0,
      "cost": 10,
      "short_description": "This champion makes an Electricity attack at RNG 2-5. A summoned Thunderaxe relic with 2 DEF, 25 HP, <ability value=3090>Catalyst: Electricity</ability> and <ability value=1827>Wieldable</ability> is summoned adjacent to the target if it is successfully damaged and this champion becomes unequipped.",
      "long_description": "This champion makes an Electricity attack at RNG 2-5. A summoned Thunderaxe relic with 2 DEF, 25 HP, <ability value=3090>Catalyst: Electricity</ability> and <ability value=1827>Wieldable</ability> is summoned adjacent to the target if it is successfully damaged and this champion becomes unequipped.",
      "class_name": "ChuckThunderaxe",
      "revision": 1
    },
    {
      "asset_id": 7244,
      "resettable": 0,
      "name": "Chuck: Wood",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 3058,
      "activated": 1,
      "icon_name": "chuck_wood",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 3,
      "ranked": 0,
      "cost": 10,
      "short_description": "This champion makes a Physical attack RNG 2-5.  A summoned Woodchucked Wood relic (15 HP with <ability value=2082>Jungle Front</ability>) is summoned adjacent to the target if it is successfully damaged.",
      "long_description": "This champion makes a Physical attack RNG 2-5.  A summoned Woodchucked Wood relic (15 HP with <ability value=2082>Jungle Front</ability>) is summoned adjacent to the target if it is successfully damaged.",
      "class_name": "ChuckWood",
      "revision": 1
    },
    {
      "asset_id": 5593,
      "resettable": 1,
      "name": "Chuck: Young Freeze Bug",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 2453,
      "activated": 1,
      "icon_name": "summon_freezbug",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 3,
      "ranked": 0,
      "cost": 15,
      "short_description": "This champion makes a Physical attack at RNG 2-5. A Young Freeze Bug with no upgrades is summoned adjacent to the target if it is successfully damaged.",
      "long_description": "This champion makes a Physical attack at RNG 2-5. A Young Freeze Bug with no upgrades is summoned adjacent to the target if it is successfully damaged.",
      "class_name": "ChuckFreezeBug",
      "revision": 1
    },
    {
      "asset_id": 5716,
      "resettable": 1,
      "name": "Circadian Rites",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2598,
      "activated": 1,
      "icon_name": "shrinegood",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 1,
      "short_description": "Friendly champions within 3 spaces have <ability value=542>Attack: Electricity</ability>. Friendly champions with Race: Mirefolk also gain <ability value=117>Regeneration 3</ability>.",
      "long_description": "Friendly champions within 3 spaces have <ability value=542>Attack: Electricity</ability>. Friendly champions with Race: Mirefolk also gain <ability value=117>Regeneration 3</ability>.",
      "class_name": "CircadianRites",
      "revision": 1
    },
    {
      "asset_id": 5510,
      "resettable": 1,
      "name": "Clamp",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2369,
      "activated": 1,
      "icon_name": "clamp",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 6,
      "short_description": "When this champion makes a successful melee attack against a champion, that champion gains <condition value=stationary>Stationary</condition> while engaged to this champion.",
      "long_description": "When this champion makes a successful melee attack against a champion, that champion gains <condition value=stationary>Stationary</condition> while engaged to this champion.",
      "class_name": "Clamp",
      "revision": 1
    },
    {
      "asset_id": 4221,
      "resettable": 1,
      "name": "Cleanse",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 592,
      "activated": 1,
      "icon_name": "cleanse",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 5,
      "short_description": "Target champion within 5 spaces is <mechanic value=cleansed>Cleansed</mechanic> and then is healed for 5 HP. May target self.",
      "long_description": "Target champion within 5 spaces is <mechanic value=cleansed>Cleansed</mechanic> and then is healed for 5 HP. May target self.",
      "class_name": "Cleanse",
      "revision": 1
    },
    {
      "asset_id": 5182,
      "resettable": 1,
      "name": "Cleansing Aura",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1959,
      "activated": 1,
      "icon_name": "aurapositive",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 10,
      "short_description": "Friendly champions within 3 spaces (including this one) are <mechanic value=cleansed>Cleansed</mechanic> at the start of your turns.",
      "long_description": "Friendly champions within 3 spaces (including this one) are <mechanic value=cleansed>Cleansed</mechanic> at the start of your turns.",
      "class_name": "SoothingAura",
      "revision": 1
    },
    {
      "asset_id": 8007,
      "resettable": 0,
      "name": "Cleansing Entrance",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3404,
      "activated": 1,
      "icon_name": "cleanse",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 0,
      "short_description": "When this unit is deployed, friendly champions within 3 spaces are <mechanic value=cleansed>Cleansed</mechanic>.",
      "long_description": "When this unit is deployed, friendly champions within 3 spaces are <mechanic value=cleansed>Cleansed</mechanic>.",
      "class_name": "CleansingEntrance",
      "revision": 1
    },
    {
      "asset_id": 5004,
      "resettable": 1,
      "name": "Cleansing Flame",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 1885,
      "activated": 1,
      "icon_name": "cleanse",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "Target champion within 4 spaces takes 10 Fire damage and is Cleansed and Dispelled.",
      "long_description": "Target champion within 4 spaces takes 10 Fire damage and is Cleansed and Dispelled.",
      "class_name": "CleansingFlame",
      "revision": 1
    },
    {
      "asset_id": 5517,
      "resettable": 1,
      "name": "Cleansing Luminescence",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2376,
      "activated": 1,
      "icon_name": "dispelling_luminesence",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "When this unit is deployed and at the start of its turns, friendly champions within 4 spaces become Cleansed.",
      "long_description": "When this unit is deployed and at the start of its turns, friendly champions within 4 spaces become Cleansed.",
      "class_name": "CleansingLuminescence",
      "revision": 1
    },
    {
      "asset_id": 5068,
      "resettable": 1,
      "name": "Cleave",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1244,
      "activated": 1,
      "icon_name": "multiattack",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "After this champion makes an basic attack, it then makes an attack against each other adjacent champion as well.",
      "long_description": "After this champion makes an basic attack, it then makes an attack against each other adjacent champion as well.",
      "class_name": "Rampage",
      "revision": 1
    },
    {
      "asset_id": 4568,
      "resettable": 1,
      "name": "Cloak",
      "ap_cost": 3,
      "level": 1,
      "ability_id": 981,
      "activated": 1,
      "icon_name": "stealth",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 5,
      "short_description": "Friendly champions within 2 spaces become <condition value=stealthed>Stealthed</condition> for 2 turns.",
      "long_description": "Friendly champions within 2 spaces become <condition value=stealthed>Stealthed</condition> for 2 turns.",
      "class_name": "Cloak",
      "revision": 1
    },
    {
      "asset_id": 4568,
      "resettable": 1,
      "name": "Cloak",
      "ap_cost": 3,
      "level": 2,
      "ability_id": 982,
      "activated": 1,
      "icon_name": "stealth",
      "comments": "",
      "prerequisite_id": 981,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 10,
      "short_description": "Friendly champions within 2 spaces become <condition value=stealthed>Stealthed</condition> for 6 turns.",
      "long_description": "Friendly champions within 2 spaces become <condition value=stealthed>Stealthed</condition> for 6 turns.",
      "class_name": "Cloak",
      "revision": 1
    },
    {
      "asset_id": 7140,
      "resettable": 0,
      "name": "Clone Equipment",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2982,
      "activated": 1,
      "icon_name": "duplicate_equip",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "Target champion within 6 spaces is equipped with a copy of the last equipment played by an opposing player while this unit was in play.  This shares a cooldown with Clone Relic.",
      "long_description": "Target champion within 6 spaces is equipped with a copy of the last equipment played by an opposing player while this unit was in play.  This shares a cooldown with Clone Relic.",
      "class_name": "CloneEquipment",
      "revision": 1
    },
    {
      "asset_id": 7631,
      "resettable": 0,
      "name": "Clone Matter",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 3239,
      "activated": 1,
      "icon_name": "absorb_relic",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 12,
      "short_description": "Target an enemy relic or enemy equipped champion within 8 spaces. If the target is a Relic, a copy of that Relic is summoned to an adjacent space. If the target is an equipped champion, a copy of that Equipment is equipped on the closest valid friendly champion (including this one).",
      "long_description": "Target an enemy relic or enemy equipped champion within 8 spaces. If the target is a Relic, a copy of that Relic is summoned to an adjacent space. If the target is an equipped champion, a copy of that Equipment is equipped on the closest valid friendly champion (including this one).",
      "class_name": "CloneMatter",
      "revision": 1
    },
    {
      "asset_id": 7633,
      "resettable": 0,
      "name": "Clone Matter (Relic)",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3240,
      "activated": 1,
      "icon_name": "absorb_relic",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 12,
      "short_description": "Target an enemy relic or enemy equipped champion within 8 spaces. If the target is a Relic, a copy of that Relic is summoned to an adjacent space. If the target is an equipped champion, a copy of that Equipment is equipped on the closest valid friendly champion (including this one). The CD on this ability is reduced by 2 when a relic or equipment within 8 spaces is destroyed.",
      "long_description": "Target an enemy relic or enemy equipped champion within 8 spaces. If the target is a Relic, a copy of that Relic is summoned to an adjacent space. If the target is an equipped champion, a copy of that Equipment is equipped on the closest valid friendly champion (including this one). The CD on this ability is reduced by 2 when a relic or equipment within 8 spaces is destroyed.",
      "class_name": "CloneMatter",
      "revision": 1
    },
    {
      "asset_id": 7139,
      "resettable": 0,
      "name": "Clone Relic",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2981,
      "activated": 1,
      "icon_name": "duplicate_equip",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "Deploy to an adjacent space a copy of the last relic deployed by an opposing player while this unit was in play. This ability shares a cooldown with Clone Equipment.",
      "long_description": "Deploy to an adjacent space a copy of the last relic deployed by an opposing player while this unit was in play. This ability shares a cooldown with Clone Equipment.",
      "class_name": "CloneRelic",
      "revision": 1
    },
    {
      "asset_id": 4614,
      "resettable": 1,
      "name": "Clutch of Vindrax",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1030,
      "activated": 1,
      "icon_name": "dragonegg",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "While in play, the Clutch of Vindrax will heal all Dragonkin within 5 spaces 2 HP at the end of your turn. When this unit is destroyed, a Dragon Broodling will be summoned.",
      "long_description": "While in play, the Clutch of Vindrax will heal all Dragonkin within 5 spaces 2 HP at the end of your turn. When this unit is destroyed, a Dragon Broodling will be summoned.",
      "class_name": "RelicClutchOfVindrax",
      "revision": 1
    },
    {
      "asset_id": 5018,
      "resettable": 1,
      "name": "Cocoon",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 1198,
      "activated": 1,
      "icon_name": "web",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "Target champion within 2 spaces becomes <condition value=cocooned>Cocooned</condition>. (After 3 turns, this champion loses Cocooned and gains +1 DEF, +1 SPD and +2 DMG. If this champion has Race: Arthropod, it loses Cocooned in 2 turns instead. This effect does not stack.)",
      "long_description": "Target champion within 2 spaces becomes <condition value=cocooned>Cocooned</condition>. (After 3 turns, this champion loses Cocooned and gains +1 DEF, +1 SPD and +2 DMG. If this champion has Race: Arthropod, it loses Cocooned in 2 turns instead. This effect does not stack.)",
      "class_name": "Cacoon",
      "revision": 1
    },
    {
      "asset_id": 7810,
      "resettable": 0,
      "name": "Coercive Pact ",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 3322,
      "activated": 1,
      "icon_name": "bloodbond",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "Target champion within 5 spaces loses 50% of its current HP. This unit loses HP by the same amount.",
      "long_description": "Target champion within 5 spaces loses 50% of its current HP. This unit loses HP by the same amount.",
      "class_name": "CoercivePact",
      "revision": 1
    },
    {
      "asset_id": 4352,
      "resettable": 1,
      "name": "Cold Snap",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 1386,
      "activated": 1,
      "icon_name": "repulsion",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "Champions within 5 spaces become <condition value=chilled>Chilled</condition> 3.",
      "long_description": "Champions within 5 spaces become <condition value=chilled>Chilled</condition> 3.",
      "class_name": "ColdSnap",
      "revision": 1
    },
    {
      "asset_id": 7222,
      "resettable": 0,
      "name": "Collective Struggle",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3046,
      "activated": 1,
      "icon_name": "soul_bond",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 0,
      "short_description": "Friendly champions deployed from the runedock while this unit is in play that have at least one race not shared by another friendly champion gain +2 DMG and +5 MAX HP permanently. This does not stack.",
      "long_description": "Friendly champions deployed from the runedock while this unit is in play that have at least one race not shared by another friendly champion gain +2 DMG and +5 MAX HP permanently. This does not stack.",
      "class_name": "CollectiveStruggle",
      "revision": 1
    },
    {
      "asset_id": 5419,
      "resettable": 0,
      "name": "Combat Awareness",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 3266,
      "activated": 1,
      "icon_name": "combat_awareness",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "Damage from spells and abilities that do not target this champion is reduced by 50%. This does not include terrain effects, conditions, or equipment on this champion.",
      "long_description": "Damage from spells and abilities that do not target this champion is reduced by 50%. This does not include terrain effects, conditions, or equipment on this champion.",
      "class_name": "CombatAwareness",
      "revision": 1
    },
    {
      "asset_id": 5419,
      "resettable": 1,
      "name": "Combat Awareness",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 2251,
      "activated": 1,
      "icon_name": "combat_awareness",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "Damage from spells and abilities that do not target this champion is prevented. This does not include terrain effects, conditions, or equipment on this champion.",
      "long_description": "Damage from spells and abilities that do not target this champion is prevented. This does not include terrain effects, conditions, or equipment on this champion.",
      "class_name": "CombatAwareness",
      "revision": 1
    },
    {
      "asset_id": 5573,
      "resettable": 1,
      "name": "Combat Regeneration",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2433,
      "activated": 1,
      "icon_name": "",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 0,
      "short_description": "Whenever this champion takes damage it heals 4 damage.",
      "long_description": "Whenever this champion takes damage it heals 4 damage.",
      "class_name": "CombatRegeneration",
      "revision": 1
    },
    {
      "asset_id": 4288,
      "resettable": 1,
      "name": "Combine",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 705,
      "activated": 1,
      "icon_name": "meld",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 1,
      "short_description": "The Moga Axeman, Shieldman and Crossbowman combine into a Moga Assault Team or Moga Team 6. To use this ability, you must have each of those units together in a formation that makes up the base of a large unit, with one empty space.",
      "long_description": "The Moga Axeman, Shieldman and Crossbowman combine into a Moga Assault Team or Moga Team 6. To use this ability, you must have each of those units together in a formation that makes up the base of a large unit, with one empty space.",
      "class_name": "Combine",
      "revision": 1
    },
    {
      "asset_id": 5325,
      "resettable": 1,
      "name": "Combo Attack: Burn",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2154,
      "activated": 1,
      "icon_name": "comboatk_devastate",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 6,
      "short_description": "When this champion makes two successful basic attacks against the same champion in a single turn, that champion becomes <condition value=charred>Charred</condition> for 5 turns",
      "long_description": "When this champion makes two successful basic attacks against the same champion in a single turn, that champion becomes <condition value=charred>Charred</condition> for 5 turns",
      "class_name": "ComboAttackBurn",
      "revision": 1
    },
    {
      "asset_id": 5324,
      "resettable": 1,
      "name": "Combo Attack: Declare Target",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2153,
      "activated": 1,
      "icon_name": "comboatk_drain",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 8,
      "short_description": "When this champion makes two successful basic attacks against the same champion in a single turn, that champion becomes Declared as Target for 1 turn (This champion has been declared as a target. Enemy champions that attack it gain 3 AP on the first successful attack per turn).",
      "long_description": "When this champion makes two successful basic attacks against the same champion in a single turn, that champion becomes Declared as Target for 1 turn (This champion has been declared as a target. Enemy champions that attack it gain 3 AP on the first successful attack per turn).",
      "class_name": "ComboAttackDeclareTarget",
      "revision": 1
    },
    {
      "asset_id": 5272,
      "resettable": 1,
      "name": "Combo Attack: Devastate",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2096,
      "activated": 1,
      "icon_name": "comboatk_devastate",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 18,
      "short_description": "When this champion makes two successful basic attacks against the same champion in a single turn, that champion takes Physical damage equal to 50% of its Max HP (rounded up).",
      "long_description": "When this champion makes two successful basic attacks against the same champion in a single turn, that champion takes Physical damage equal to 50% of its Max HP (rounded up).",
      "class_name": "ComboAttackDevastate",
      "revision": 1
    },
    {
      "asset_id": 5274,
      "resettable": 1,
      "name": "Combo Attack: Drain",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2098,
      "activated": 1,
      "icon_name": "comboatk_drain",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 6,
      "short_description": "When this champion makes two successful basic attacks against the same champion in a single turn, this unit heals an amount equal to the damage done on the second attack.",
      "long_description": "When this champion makes two successful basic attacks against the same champion in a single turn, this unit heals an amount equal to the damage done on the second attack.",
      "class_name": "ComboAttackDrain",
      "revision": 1
    },
    {
      "asset_id": 5273,
      "resettable": 1,
      "name": "Combo Attack: Rend",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2097,
      "activated": 1,
      "icon_name": "comboatk_rend",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 5,
      "short_description": "When this champion makes two successful basic attacks against the same champion in a single turn, that champion becomes <condition value=eviscerated>Eviscerated</condition> for 5 turns.",
      "long_description": "When this champion makes two successful basic attacks against the same champion in a single turn, that champion becomes <condition value=eviscerated>Eviscerated</condition> for 5 turns.",
      "class_name": "ComboAttackRend",
      "revision": 1
    },
    {
      "asset_id": 5271,
      "resettable": 1,
      "name": "Combo Attack: Slam",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2095,
      "activated": 1,
      "icon_name": "comboatk_slam",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this champion makes two successful basic attacks against the same champion in a single turn, that champion is knocked back 2 spaces.\r\n",
      "long_description": "When this champion makes two successful basic attacks against the same champion in a single turn, that champion is knocked back 2 spaces.",
      "class_name": "ComboAttackSlam",
      "revision": 1
    },
    {
      "asset_id": 5270,
      "resettable": 1,
      "name": "Combo Attack: Stun",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2094,
      "activated": 1,
      "icon_name": "comboatk_rend",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 15,
      "short_description": "When this champion makes two successful basic attacks that deal damage against the same champion in a single turn, that champion becomes <condition value=stunned>Stunned</condition> for 2 turns.",
      "long_description": "When this champion makes two successful basic attacks that deal damage against the same champion in a single turn, that champion becomes <condition value=stunned>Stunned</condition> for 2 turns.",
      "class_name": "ComboAttackStun",
      "revision": 1
    },
    {
      "asset_id": 4651,
      "resettable": 1,
      "name": "Command: Block",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 1138,
      "activated": 1,
      "icon_name": "command_block",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "Friendly champions within 3 spaces become <condition value=blocking>Blocking</condition>.",
      "long_description": "Friendly champions within 3 spaces become <condition value=blocking>Blocking</condition>.",
      "class_name": "CommandBlock",
      "revision": 1
    },
    {
      "asset_id": 4835,
      "resettable": 1,
      "name": "Command: Charge",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 1717,
      "activated": 1,
      "icon_name": "command_charge",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "All friendly champions within 3 spaces gain <ability value=396>Charge 3</ability> for 1 turn.",
      "long_description": "All friendly champions within 3 spaces gain <ability value=396>Charge 3</ability> for 1 turn.",
      "class_name": "CommandCharge",
      "revision": 1
    },
    {
      "asset_id": 4652,
      "resettable": 1,
      "name": "Command: Dodge",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 1139,
      "activated": 1,
      "icon_name": "command_dodge",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "Friendly champions within 3 spaces gain <condition value=dodging>Dodging</condition> for 6 turns.",
      "long_description": "Friendly champions within 3 spaces gain <condition value=dodging>Dodging</condition> for 6 turns.",
      "class_name": "CommandDodge",
      "revision": 1
    },
    {
      "asset_id": 4653,
      "resettable": 1,
      "name": "Command: Heal",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 1140,
      "activated": 1,
      "icon_name": "command_heal",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "The next time friendly champions within 3 spaces are healed, the amount is increased by 6.",
      "long_description": "The next time friendly champions within 3 spaces are healed, the amount is increased by 6.",
      "class_name": "CommandHeal",
      "revision": 1
    },
    {
      "asset_id": 5697,
      "resettable": 1,
      "name": "Commander",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2559,
      "activated": 1,
      "icon_name": "improve_damage",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 7,
      "short_description": "Friendly champions within 5 spaces that share a race or class with this champion have +2 DMG. This does not stack with other Commanders.",
      "long_description": "Friendly champions within 5 spaces that share a race or class with this champion have +2 DMG. This does not stack with other Commanders.",
      "class_name": "Commander",
      "revision": 1
    },
    {
      "asset_id": 5597,
      "resettable": 1,
      "name": "Commander: Angels (OLD)",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2457,
      "activated": 1,
      "icon_name": "allybuffs",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "Friendly Angels without this ability gain 5 HP and +1 DMG. Effects from Commander abilities do not stack.",
      "long_description": "Friendly Angels without this ability gain 5 HP and +1 DMG. Effects from Commander abilities do not stack.",
      "class_name": "CommanderAngels",
      "revision": 1
    },
    {
      "asset_id": 4836,
      "resettable": 1,
      "name": "Commander: Archer (OLD)",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1718,
      "activated": 1,
      "icon_name": "commander_archer",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "Friendly Archers without this ability gain 5 HP and +1 DMG. Effects from Commander abilities do not stack.",
      "long_description": "Friendly Archers without this ability gain 5 HP and +1 DMG. Effects from Commander abilities do not stack.",
      "class_name": "CommanderArcher",
      "revision": 1
    },
    {
      "asset_id": 4819,
      "resettable": 1,
      "name": "Commander: Beast",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2509,
      "activated": 1,
      "icon_name": "improve_damage",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 7,
      "short_description": "Friendly champions within 5 spaces with Race: Beast have +2 DMG. This does not stack with other Commanders.",
      "long_description": "Friendly champions within 5 spaces with Race: Beast have +2 DMG. This does not stack with other Commanders.",
      "class_name": "CommanderBeast",
      "revision": 1
    },
    {
      "asset_id": 7853,
      "resettable": 0,
      "name": "Commander: Dragon",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3330,
      "activated": 1,
      "icon_name": "improve_damage",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "Friendly champions within 5 spaces with Race: Dragon have +2 DMG. This does not stack with other Commanders.",
      "long_description": "Friendly champions within 5 spaces with Race: Dragon have +2 DMG. This does not stack with other Commanders.",
      "class_name": "CommanderDragon",
      "revision": 1
    },
    {
      "asset_id": 5689,
      "resettable": 1,
      "name": "Commander: Draksar (OLD)",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2647,
      "activated": 1,
      "icon_name": "allybuffs",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "Friendly Draksar without this ability gain 5 HP and +1 DMG. Effects from Commander abilities do not stack.",
      "long_description": "Friendly Draksar without this ability gain 5 HP and +1 DMG. Effects from Commander abilities do not stack.",
      "class_name": "CommanderDraksar",
      "revision": 1
    },
    {
      "asset_id": 5591,
      "resettable": 1,
      "name": "Commander: Elf (OLD)",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2751,
      "activated": 1,
      "icon_name": "commander_elf",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "Friendly Elf without this ability gain 5 HP and +1 DMG. Effects from Commander abilities do not stack.",
      "long_description": "Friendly Elf without this ability gain 5 HP and +1 DMG. Effects from Commander abilities do not stack.",
      "class_name": "CommanderElf",
      "revision": 1
    },
    {
      "asset_id": 7592,
      "resettable": 0,
      "name": "Commander: Flying",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3224,
      "activated": 1,
      "icon_name": "improve_damage",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 7,
      "short_description": "Friendly champions within 5 spaces with Flying have +2 DMG. This ability does not stack with other Commanders.",
      "long_description": "Friendly champions within 5 spaces with Flying have +2 DMG. This ability does not stack with other Commanders.",
      "class_name": "CommanderFlying",
      "revision": 1
    },
    {
      "asset_id": 5591,
      "resettable": 1,
      "name": "Commander: Lonx (OLD)",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2451,
      "activated": 1,
      "icon_name": "commander_lonx",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "Friendly Lonx without this ability gain 5 HP and +1 DMG. Effects from Commander abilities do not stack.",
      "long_description": "Friendly Lonx without this ability gain 5 HP and +1 DMG. Effects from Commander abilities do not stack.",
      "class_name": "CommanderLonx",
      "revision": 1
    },
    {
      "asset_id": 5179,
      "resettable": 1,
      "name": "Commander: Paladin (OLD)",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1956,
      "activated": 1,
      "icon_name": "commander_paladin",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "Friendly Paladin without this ability gain 5 HP and +1 DMG. Effects from Commander abilities do not stack.",
      "long_description": "Friendly Paladin without this ability gain 5 HP and +1 DMG. Effects from Commander abilities do not stack.",
      "class_name": "CommanderPaladin",
      "revision": 1
    },
    {
      "asset_id": 4062,
      "resettable": 1,
      "name": "Commander: Ranger (OLD)",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1322,
      "activated": 1,
      "icon_name": "commander_ranger",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "Friendly Rangers without this ability gain 5 HP and +1 DMG. Effects from Commander abilities do not stack.",
      "long_description": "Friendly Rangers without this ability gain 5 HP and +1 DMG. Effects from Commander abilities do not stack.",
      "class_name": "CommanderRanger",
      "revision": 1
    },
    {
      "asset_id": 5689,
      "resettable": 1,
      "name": "Commander: Slag (OLD)",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2564,
      "activated": 1,
      "icon_name": "commander_slag",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "Friendly Slag without this ability gain 5 HP and +1 DMG. Effects from Commander abilities do not stack.",
      "long_description": "Friendly Slag without this ability gain 5 HP and +1 DMG. Effects from Commander abilities do not stack.",
      "class_name": "CommanderSlag",
      "revision": 1
    },
    {
      "asset_id": 5689,
      "resettable": 0,
      "name": "Commander: Witch (OLD)",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2970,
      "activated": 1,
      "icon_name": "commander_ranger",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "Friendly Witches without this ability gain 5 HP and +1 DMG. Effects from Commander abilities do not stack.",
      "long_description": "Friendly Witches without this ability gain 5 HP and +1 DMG. Effects from Commander abilities do not stack.",
      "class_name": "CommanderWitch",
      "revision": 1
    },
    {
      "asset_id": 5304,
      "resettable": 1,
      "name": "Compelled: Protectorate",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1060,
      "activated": 1,
      "icon_name": "dispel",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -5,
      "short_description": "If you play any rune from the Wrath Alignment, this unit takes 15 damage.",
      "long_description": "If you play any rune from the Wrath Alignment, this unit takes 15 damage.",
      "class_name": "CompelledProtectorate",
      "revision": 1
    },
    {
      "asset_id": 5303,
      "resettable": 1,
      "name": "Compelled: Wrath",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1123,
      "activated": 1,
      "icon_name": "drain",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -5,
      "short_description": "If you play any rune from the Protectorate Alignment, this unit takes 15 damage.",
      "long_description": "If you play any rune from the Protectorate Alignment, this unit takes 15 damage.",
      "class_name": "CompelledWrath",
      "revision": 1
    },
    {
      "asset_id": 5699,
      "resettable": 1,
      "name": "Complex Machine",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2577,
      "activated": 1,
      "icon_name": "complex_machine",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "When this champion is within 5 spaces of a friendly champion with Class: Tinkerer, it gains +1 SPD and <ability value=116>Regeneration 2</ability>.",
      "long_description": "When this champion is within 5 spaces of a friendly champion with Class: Tinkerer, it gains +1 SPD and <ability value=116>Regeneration 2</ability>.",
      "class_name": "ComplexMachine",
      "revision": 1
    },
    {
      "asset_id": 4324,
      "resettable": 1,
      "name": "Conceal",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1352,
      "activated": 1,
      "icon_name": "shroud",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 2,
      "short_description": "Each player has 2 runes concealed.",
      "long_description": "Each player has 2 runes concealed.",
      "class_name": "Shroud",
      "revision": 1
    },
    {
      "asset_id": 4578,
      "resettable": 1,
      "name": "Concealment",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 983,
      "activated": 1,
      "icon_name": "amphib ",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 3,
      "short_description": "When this champion comes into play, 2 of your opponent's revealed runes become hidden.",
      "long_description": "When this champion comes into play, 2 of your opponent's revealed runes become hidden.",
      "class_name": "Conceal",
      "revision": 1
    },
    {
      "asset_id": 4578,
      "resettable": 1,
      "name": "Concealment",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 984,
      "activated": 1,
      "icon_name": "amphib ",
      "comments": "",
      "prerequisite_id": 983,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 7,
      "short_description": "When this champion comes into play, 4 of your opponent's revealed runes become hidden.",
      "long_description": "When this champion comes into play, 4 of your opponent's revealed runes become hidden.",
      "class_name": "Conceal",
      "revision": 1
    },
    {
      "asset_id": 7648,
      "resettable": 0,
      "name": "Conduit Mastery",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3243,
      "activated": 1,
      "icon_name": "conduit_mastery",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "When a friendly champion is affected by a friendly Conduit ability, this champion also gains the same effect. If the effect is a buff, it lasts for 6 turns.",
      "long_description": "When a friendly champion is affected by a friendly Conduit ability, this champion also gains the same effect. If the effect is a buff, it lasts for 6 turns.",
      "class_name": "ConduitMastery",
      "revision": 1
    },
    {
      "asset_id": 7643,
      "resettable": 0,
      "name": "Conduit Watcher",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3241,
      "activated": 1,
      "icon_name": "conduit_watcher",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 4,
      "short_description": "The first time each a turn a friendly champion activates a Conduit: X ability, this champion gains +2 MAX HP permanently and 1 AP.",
      "long_description": "The first time each a turn a friendly champion activates a Conduit: X ability, this champion gains +2 MAX HP permanently and 1 AP.",
      "class_name": "ConduitWatcher",
      "revision": 1
    },
    {
      "asset_id": 7654,
      "resettable": 0,
      "name": "Conduit: Damage",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 3244,
      "activated": 1,
      "icon_name": "conduit_damage",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "Target enemy champion within 5 spaces has -2 DMG and the closest friendly champion to the target (including this one) has +2 DMG until targets change or the target is destroyed.",
      "long_description": "Target enemy champion within 5 spaces has -2 DMG and the closest friendly champion to the target (including this one) has +2 DMG until targets change or the target is destroyed.",
      "class_name": "ConduitDamage",
      "revision": 1
    },
    {
      "asset_id": 7646,
      "resettable": 0,
      "name": "Conduit: HP",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 3242,
      "activated": 1,
      "icon_name": "conduit_hp",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "Target enemy champion within 5 spaces loses 6 HP and the closest friendly champion to the target (including this one) vampiric heals for 6 HP.",
      "long_description": "Target enemy champion within 5 spaces loses 6 HP and the closest friendly champion to the target (including this one) vampiric heals for 6 HP.",
      "class_name": "ConduitHP",
      "revision": 1
    },
    {
      "asset_id": 7655,
      "resettable": 0,
      "name": "Conduit: Speed",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3245,
      "activated": 1,
      "icon_name": "conduit_speed",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "Target enemy champion within 5 spaces has -1 SPD and the closest friendly champion to the target (including this one) has +1 SPD until targets change or the target is destroyed.",
      "long_description": "Target enemy champion within 5 spaces has -1 SPD and the closest friendly champion to the target (including this one) has +1 SPD until targets change or the target is destroyed.",
      "class_name": "ConduitSpeed",
      "revision": 1
    },
    {
      "asset_id": 7734,
      "resettable": 0,
      "name": "Conduit: Upgrade",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 3273,
      "activated": 1,
      "icon_name": "conduit_upgrade",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 12,
      "short_description": "Target enemy champion within 5 spaces loses its highest cost upgrade ability and the closest friendly champion gains that ability until targets change. ",
      "long_description": "Target enemy champion within 5 spaces loses its highest cost upgrade ability and the closest friendly champion gains that ability until targets change. ",
      "class_name": "ConduitUpgrade",
      "revision": 1
    },
    {
      "asset_id": 5909,
      "resettable": 1,
      "name": "Confuse",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2687,
      "activated": 1,
      "icon_name": "confuse",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "Target champion within 5 spaces is <condition name=confused>Confused</condition> for 4 turns.",
      "long_description": "Target champion within 5 spaces is <condition name=confused>Confused</condition> for 4 turns.",
      "class_name": "Confuse",
      "revision": 1
    },
    {
      "asset_id": 4399,
      "resettable": 1,
      "name": "Confuse Attacker",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1440,
      "activated": 1,
      "icon_name": "confuse",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 2,
      "short_description": "The next time this unit is successfully attacked (and damaged), it is relocated 3 spaces directly away from the source of the attack.\r\n",
      "long_description": "The next time this unit is successfully attacked (and damaged), it is relocated 3 spaces directly away from the source of the attack.",
      "class_name": "ConfuseAttacker",
      "revision": 1
    },
    {
      "asset_id": 4464,
      "resettable": 1,
      "name": "Confuse Enemy",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1441,
      "activated": 1,
      "icon_name": "confuse",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "The next time this champion successfully makes an attack against an enemy unit, this champion is relocated 3 spaces directly away from the target.",
      "long_description": "The next time this champion successfully makes an attack against an enemy unit, this champion is relocated 3 spaces directly away from the target.",
      "class_name": "ConfuseEnemy",
      "revision": 1
    },
    {
      "asset_id": 5731,
      "resettable": 1,
      "name": "Conjure Wealth",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2618,
      "activated": 1,
      "icon_name": "HawksTalon",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "On the beginning of your turn, you accrue 15 nora.  This is a passive ability.",
      "long_description": "On the beginning of your turn, you accrue 15 nora.  This is a passive ability.",
      "class_name": "ConjureWealth",
      "revision": 1
    },
    {
      "asset_id": 4837,
      "resettable": 1,
      "name": "Conqueror",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1719,
      "activated": 1,
      "icon_name": "offenseenhance",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "While this champion is in a neutral or enemy font zone, it gains +3 DMG and +1 DEF.",
      "long_description": "While this champion is in a neutral or enemy font zone, it gains +3 DMG and +1 DEF.",
      "class_name": "Conqueror",
      "revision": 1
    },
    {
      "asset_id": 4938,
      "resettable": 1,
      "name": "Consecrated Zone",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1823,
      "activated": 1,
      "icon_name": "smite",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "Area Effect 3: On deploy, friendly Priests, Shamans, and Paladins are cleansed and healed for 5 HP, and terrain modifications are removed from this space.  Affected spaces are <mechanic value=hallowed_ground>Hallowed Ground</mechanic>.",
      "long_description": "Area Effect 3: On deploy, friendly Priests, Shamans, and Paladins are cleansed and healed for 5 HP, and terrain modifications are removed from this space.  Affected spaces are <mechanic value=hallowed_ground>Hallowed Ground</mechanic>.",
      "class_name": "RelicHolyBladeOfValdac",
      "revision": 1
    },
    {
      "asset_id": 5116,
      "resettable": 1,
      "name": "Consecration",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 1305,
      "activated": 1,
      "icon_name": "consecrate_earth",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "Area Effect 2, Range 5: Friendly Priests, Shamans, and Paladins are cleansed and healed for 5 HP, and terrain modifications are removed from this space.  Affected spaces become <mechanic value=hallowed_ground>Hallowed Ground</mechanic> for 3 turns.",
      "long_description": "Area Effect 2, Range 5: Friendly Priests, Shamans, and Paladins are cleansed and healed for 5 HP, and terrain modifications are removed from this space.  Affected spaces become <mechanic value=hallowed_ground>Hallowed Ground</mechanic> for 3 turns.",
      "class_name": "Consecration",
      "revision": 1
    },
    {
      "asset_id": 4126,
      "resettable": 1,
      "name": "Constriction",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 324,
      "activated": 1,
      "icon_name": "constriction",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "This champion makes a melee attack against target opposing champion.  If successful, the target takes 50% damage and becomes Constricted 3 (This Champion may not move, activate special abilities, or attack units other than this one, and takes 5 Physical damage at the beginning of each turn).",
      "long_description": "This champion makes a melee attack against target opposing champion.  If successful, the target takes 50% damage and becomes Constricted 3 (This Champion may not move, activate special abilities, or attack units other than this one, and takes 5 Physical damage at the beginning of each turn).",
      "class_name": "Constriction",
      "revision": 1
    },
    {
      "asset_id": 4838,
      "resettable": 1,
      "name": "Consume",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 1720,
      "activated": 1,
      "icon_name": "devour",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 3,
      "short_description": "Sacrifice target owned adjacent champion and this champion is healed for the amount equal to the destroyed champion's current HP.",
      "long_description": "Sacrifice target owned adjacent champion and this champion is healed for the amount equal to the destroyed champion's current HP.",
      "class_name": "Consume",
      "revision": 1
    },
    {
      "asset_id": 5766,
      "resettable": 1,
      "name": "Containment Unit",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2744,
      "activated": 1,
      "icon_name": "crystallize",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "At the end of its turn, adjacent friendly champions are Crystallized for 1 turn.",
      "long_description": "At the end of its turn, adjacent friendly champions are Crystallized for 1 turn.",
      "class_name": "ContainmentUnit",
      "revision": 1
    },
    {
      "asset_id": 4063,
      "resettable": 1,
      "name": "Contaminate",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 1323,
      "activated": 1,
      "icon_name": "dot_poison",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 5,
      "short_description": "Target champion within 3 spaces gains the <ability value=167>Poison 1</ability> ability for 4 turns.",
      "long_description": "Target champion within 3 spaces gains the <ability value=167>Poison 1</ability> ability for 4 turns.",
      "class_name": "Contaminate",
      "revision": 1
    },
    {
      "asset_id": 5455,
      "resettable": 1,
      "name": "Contaminate Nora",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2307,
      "activated": 1,
      "icon_name": "nora_hex",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 2,
      "short_description": "Whenever an opposing unit captures a nora globe, it takes 4 disease damage.",
      "long_description": "Whenever an opposing unit captures a nora globe, it takes 4 disease damage.",
      "class_name": "ContaminateNora",
      "revision": 1
    },
    {
      "asset_id": 7749,
      "resettable": 0,
      "name": "Contaminated Wreckage",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3278,
      "activated": 1,
      "icon_name": "ichor_defense",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "Friendly champions within 5 spaces have <ability value=546>Attack: Poison</ability> and <ability value=167>Poison 1</ability>.  Friendly champions within 5 spaces gains 2 AP when it becomes equipped or if it is already equipped when this unit is deployed.",
      "long_description": "Friendly champions within 5 spaces have <ability value=546>Attack: Poison</ability> and <ability value=167>Poison 1</ability>.  Friendly champions within 5 spaces gains 2 AP when it becomes equipped or if it is already equipped when this unit is deployed.",
      "class_name": "ContaminatedWreckage",
      "revision": 1
    },
    {
      "asset_id": 4491,
      "resettable": 1,
      "name": "Cooperation",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1468,
      "activated": 1,
      "icon_name": "sibling",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 2,
      "short_description": "When this unit is within 5 spaces of a friendly champion, it gains <ability value=116>Regeneration 2</ability>.",
      "long_description": "When this unit is within 5 spaces of a friendly champion, it gains <ability value=116>Regeneration 2</ability>.",
      "class_name": "Cooperation",
      "revision": 1
    },
    {
      "asset_id": 5160,
      "resettable": 1,
      "name": "Coordination",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1933,
      "activated": 1,
      "icon_name": "allybuffs",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "All friendly champions within 2 spaces of this unit gain <ability value=1214>Encouraged</ability>.",
      "long_description": "All friendly champions within 2 spaces of this unit gain <ability value=1214>Encouraged</ability>.",
      "class_name": "RelicCoordinationTower",
      "revision": 1
    },
    {
      "asset_id": 5770,
      "resettable": 1,
      "name": "Coralwood Lagoon",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2752,
      "activated": 1,
      "icon_name": "special",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "Friendly champions with Race: Jellebrium within 5 spaces have <ability value=1534>Spell Resistance</ability> and <ability value=2338>Psychic Magnetism</ability>.",
      "long_description": "Friendly champions with Race: Jellebrium within 5 spaces have <ability value=1534>Spell Resistance</ability> and <ability value=2338>Psychic Magnetism</ability>.",
      "class_name": "CoralwoodLagoon",
      "revision": 1
    },
    {
      "asset_id": 5025,
      "resettable": 1,
      "name": "Corporeal Form",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 1205,
      "activated": 1,
      "icon_name": "ethereal",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "This champion loses <condition value=incorporeal>Incorporeal</condition>.  If it doesn't have Incorporeal, it gains Incorporeal instead.",
      "long_description": "This champion loses <condition value=incorporeal>Incorporeal</condition>.  If it doesn't have Incorporeal, it gains Incorporeal instead.",
      "class_name": "CorporealForm",
      "revision": 1
    },
    {
      "asset_id": 7077,
      "resettable": 1,
      "name": "Corpse Pile",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2462,
      "activated": 1,
      "icon_name": "zombie_apoc",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "When this unit is deployed, it loses 5 HP and an Infected Zombie with no upgrades is summoned on the nearest unoccupied space within 5 spaces. At the end of every 6 turns, this unit loses 5 HP and an Infected Zombie with no upgrades is summoned on the nearest unoccupied space within 5 spaces. ",
      "long_description": "When this unit is deployed, it loses 5 HP and an Infected Zombie with no upgrades is summoned on the nearest unoccupied space within 5 spaces. At the end of every 6 turns, this unit loses 5 HP and an Infected Zombie with no upgrades is summoned on the nearest unoccupied space within 5 spaces. ",
      "class_name": "AnimateCorpse",
      "revision": 1
    },
    {
      "asset_id": 0,
      "resettable": 0,
      "name": "Corpse Restoration",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3272,
      "activated": 1,
      "icon_name": "defile_corpse",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 14,
      "short_description": "The first time each turn a friendly real champion within 5 spaces is destroyed, a Shambling Zombie without upgrades is summoned adjacent to this unit.",
      "long_description": "The first time each turn a friendly real champion within 5 spaces is destroyed, a Shambling Zombie without upgrades is summoned adjacent to this unit.",
      "class_name": "CorpseRestoration",
      "revision": 1
    },
    {
      "asset_id": 5157,
      "resettable": 1,
      "name": "Corrosion",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1929,
      "activated": 1,
      "icon_name": "block",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "This relic loses 2 HP at the beginning of each of your turns.",
      "long_description": "This relic loses 2 HP at the beginning of each of your turns.",
      "class_name": "RelicTargetDummy",
      "revision": 1
    },
    {
      "asset_id": 4509,
      "resettable": 1,
      "name": "Corrosive Grenade",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 2620,
      "activated": 1,
      "icon_name": "acidaoe",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "Area Effect 2, Range 5: Affected units take 8 Acid Damage and becomes <condition value=sundered>Sundered</condition> for 3 turns.  This damage ignores DEF.",
      "long_description": "Area Effect 2, Range 5: Affected units take 8 Acid Damage and becomes <condition value=sundered>Sundered</condition> for 3 turns.  This damage ignores DEF.",
      "class_name": "CorrosiveGrenade",
      "revision": 1
    },
    {
      "asset_id": 5146,
      "resettable": 1,
      "name": "Corrupt Blast",
      "ap_cost": 1,
      "level": 1,
      "ability_id": 1641,
      "activated": 1,
      "icon_name": "diseaseaoe",
      "comments": "Range 3, AP Cost: Attack+1 ",
      "prerequisite_id": null,
      "cooldown": 6,
      "activation_type": 1,
      "ranked": 1,
      "cost": 2,
      "short_description": "Area Effect 2, Range 5: Affected units take Disease damage equal to 40% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=diseased>Diseased</condition> for 2 turns.",
      "long_description": "Area Effect 2, Range 5: Affected units take Disease damage equal to 40% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=diseased>Diseased</condition> for 2 turns.",
      "class_name": "CorruptBlast",
      "revision": 1
    },
    {
      "asset_id": 5146,
      "resettable": 1,
      "name": "Corrupt Blast",
      "ap_cost": 1,
      "level": 2,
      "ability_id": 1648,
      "activated": 1,
      "icon_name": "diseaseaoe",
      "comments": "Range 3, AP Cost: Attack+1 ",
      "prerequisite_id": 1641,
      "cooldown": 6,
      "activation_type": 1,
      "ranked": 1,
      "cost": 2,
      "short_description": "Area Effect 2, Range 5: Affected units take Disease damage equal to 40% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=diseased>Diseased</condition> for 2 turns.",
      "long_description": "Area Effect 2, Range 5: Affected units take Disease damage equal to 40% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=diseased>Diseased</condition> for 2 turns.",
      "class_name": "CorruptBlast",
      "revision": 1
    },
    {
      "asset_id": 5146,
      "resettable": 1,
      "name": "Corrupt Blast",
      "ap_cost": 1,
      "level": 3,
      "ability_id": 1649,
      "activated": 1,
      "icon_name": "diseaseaoe",
      "comments": "Range 3, AP Cost: Attack+1 ",
      "prerequisite_id": 1648,
      "cooldown": 6,
      "activation_type": 1,
      "ranked": 1,
      "cost": 2,
      "short_description": "Area Effect 2, Range 5: Affected units take Disease damage equal to 70% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=diseased>Diseased</condition> for 2 turns.",
      "long_description": "Area Effect 2, Range 5: Affected units take Disease damage equal to 70% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=diseased>Diseased</condition> for 2 turns.",
      "class_name": "CorruptBlast",
      "revision": 1
    },
    {
      "asset_id": 0,
      "resettable": 0,
      "name": "Corrupting Aura",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3377,
      "activated": 1,
      "icon_name": "vuln_disease",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 5,
      "short_description": "The closest enemy unit within 6 spaces without <ability value=94>Vulnerability: Disease</ability> gains Vulnerability: Disease.",
      "long_description": "The closest enemy unit within 6 spaces without <ability value=94>Vulnerability: Disease</ability> gains Vulnerability: Disease.",
      "class_name": "CorruptingAura",
      "revision": 1
    },
    {
      "asset_id": 5407,
      "resettable": 1,
      "name": "Corruption",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2239,
      "activated": 1,
      "icon_name": "ondeath",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 3,
      "short_description": "This unit loses 5 HP.  For 1 turn, this unit loses its basic attacks and gains <ability value=1943>Attack: Loss of Life</ability>.",
      "long_description": "This unit loses 5 HP.  For 1 turn, this unit loses its basic attacks and gains <ability value=1943>Attack: Loss of Life</ability>.",
      "class_name": "Corruption",
      "revision": 1
    },
    {
      "asset_id": 4513,
      "resettable": 1,
      "name": "Council: Spells",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1443,
      "activated": 1,
      "icon_name": "special",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "When an opposing player successfully casts a spell, you gain 5 nora.  This does not stack.",
      "long_description": "When an opposing player successfully casts a spell, you gain 5 nora.  This does not stack.",
      "class_name": "CouncilSpells",
      "revision": 1
    },
    {
      "asset_id": 4515,
      "resettable": 1,
      "name": "Counter Attack: Melee",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1444,
      "activated": 1,
      "icon_name": "counter",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 7,
      "short_description": "This unit makes a free attack against any champion that successfully attacks it with an attack at RNG 1.",
      "long_description": "This unit makes a free attack against any champion that successfully attacks it with an attack at RNG 1.",
      "class_name": "CounterAttackMelee",
      "revision": 1
    },
    {
      "asset_id": 4516,
      "resettable": 1,
      "name": "Counter Attack: Ranged",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1445,
      "activated": 1,
      "icon_name": "reflexes",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 7,
      "short_description": "This unit makes a free attack against any champion that successfully attacks it with an attack at RNG of 2 or more.",
      "long_description": "This unit makes a free attack against any champion that successfully attacks it with an attack at RNG of 2 or more.",
      "class_name": "CounterAttackRanged",
      "revision": 1
    },
    {
      "asset_id": 5161,
      "resettable": 1,
      "name": "Counterbalance",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1934,
      "activated": 1,
      "icon_name": "dispel",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "Nora globes captured by opposing units generate 50% Nora.",
      "long_description": "Nora globes captured by opposing units generate 50% Nora.",
      "class_name": "RelicCounterbalance",
      "revision": 1
    },
    {
      "asset_id": 5355,
      "resettable": 1,
      "name": "Counterspell Mastery",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2187,
      "activated": 1,
      "icon_name": "counterspell_mastery",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 15,
      "short_description": "When an opponent casts a spell, if this unit has at least 6 charges, this champion loses all charges and the spell fails.",
      "long_description": "When an opponent casts a spell, if this unit has at least 6 charges, this champion loses all charges and the spell fails.",
      "class_name": "CounterspellMastery",
      "revision": 1
    },
    {
      "asset_id": 4134,
      "resettable": 1,
      "name": "Counterstrike",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 338,
      "activated": 1,
      "icon_name": "counter",
      "comments": "No champion has this ability. Do not use this ability.",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 6,
      "short_description": "When a champion makes an unsuccessful attack against this unit, this unit makes an attack against that unit at +1 DMG.",
      "long_description": "When a champion makes an unsuccessful attack against this unit, this unit makes an attack against that unit at +1 DMG.",
      "class_name": "Counterstrike",
      "revision": 1
    },
    {
      "asset_id": 4134,
      "resettable": 1,
      "name": "Counterstrike",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 339,
      "activated": 1,
      "icon_name": "counter",
      "comments": "No champion has this ability. Do not use this ability.",
      "prerequisite_id": 338,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 8,
      "short_description": "When a champion makes an unsuccessful attack against this unit, this unit makes an attack against that unit at +2 DMG.",
      "long_description": "When a champion makes an unsuccessful attack against this unit, this unit makes an attack against that unit at +2 DMG.",
      "class_name": "Counterstrike",
      "revision": 1
    },
    {
      "asset_id": 4134,
      "resettable": 1,
      "name": "Counterstrike",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 340,
      "activated": 1,
      "icon_name": "counter",
      "comments": "No champion has this ability. Do not use this ability.",
      "prerequisite_id": 339,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 10,
      "short_description": "When a champion makes an unsuccessful attack against this unit, this unit makes an attack against that unit at +3 DMG.",
      "long_description": "When a champion makes an unsuccessful attack against this unit, this unit makes an attack against that unit at +3 DMG.",
      "class_name": "Counterstrike",
      "revision": 1
    },
    {
      "asset_id": 5848,
      "resettable": 1,
      "name": "Courage",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2857,
      "activated": 1,
      "icon_name": "aurapositive",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "This unit has +2 DMG and +1 DEF for every 8 HP it is missing. This stacks up to 3 times.",
      "long_description": "This unit has +2 DMG and +1 DEF for every 8 HP it is missing. This stacks up to 3 times.",
      "class_name": "Courage",
      "revision": 1
    },
    {
      "asset_id": 4492,
      "resettable": 1,
      "name": "Craft",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 947,
      "activated": 1,
      "icon_name": "forge",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 8,
      "activation_type": 1,
      "ranked": 0,
      "cost": 5,
      "short_description": "Equipment runes of the same faction as this unit have their cooldown reduced to 0.",
      "long_description": "Equipment runes of the same faction as this unit have their cooldown reduced to 0.",
      "class_name": "Craft",
      "revision": 1
    },
    {
      "asset_id": 5380,
      "resettable": 1,
      "name": "Crazed Charger",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2213,
      "activated": 1,
      "icon_name": "crazed_charger",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this champion activates <ability value=394>Charge</ability>, it's CD is set to 0.",
      "long_description": "When this champion activates <ability value=394>Charge</ability>, it's CD is set to 0.",
      "class_name": "CrazedCharger",
      "revision": 1
    },
    {
      "asset_id": 4414,
      "resettable": 1,
      "name": "Create Chasm",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 742,
      "activated": 1,
      "icon_name": "domain_chasm",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 13,
      "short_description": "Target unoccupied space becomes <mechanic value=chasm>Chasm</mechanic> and this champion gains <ability value=803>Boulder Toss</ability>. The Create Chasm ability does not come off cooldown while the champion has the Boulder Toss ability.",
      "long_description": "Target unoccupied space becomes <mechanic value=chasm>Chasm</mechanic> and this champion gains <ability value=803>Boulder Toss</ability>. The Create Chasm ability does not come off cooldown while the champion has the Boulder Toss ability.",
      "class_name": "CreateChasm",
      "revision": 1
    },
    {
      "asset_id": 5548,
      "resettable": 1,
      "name": "Creativity",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2408,
      "activated": 1,
      "icon_name": "hallucinogenic",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 2,
      "short_description": "When this champion makes a successful basic attack, non-champion runes in your runedock have their CD reduced by 1.",
      "long_description": "When this champion makes a successful basic attack, non-champion runes in your runedock have their CD reduced by 1.",
      "class_name": "Creativity",
      "revision": 1
    },
    {
      "asset_id": 5547,
      "resettable": 1,
      "name": "Creator",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2407,
      "activated": 1,
      "icon_name": "charged_death",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "This champion is the originator of the Imperfect Creations.",
      "long_description": "This champion is the originator of the Imperfect Creations.",
      "class_name": "Creator",
      "revision": 1
    },
    {
      "asset_id": 5251,
      "resettable": 1,
      "name": "Creep and Crawl",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2141,
      "activated": 1,
      "icon_name": "creep_and_crawl",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "While 4 or more friendly champions with the race Arthropod are in play, this unit gains <ability value=1306>Mountaineer</ability> and an additional rank of <ability value=15>Multiattack</ability>.",
      "long_description": "While 4 or more friendly champions with the race Arthropod are in play, this unit gains <ability value=1306>Mountaineer</ability> and an additional rank of <ability value=15>Multiattack</ability>.",
      "class_name": "CreepAndCrawl",
      "revision": 1
    },
    {
      "asset_id": 7382,
      "resettable": 0,
      "name": "Creeping Harvest",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3133,
      "activated": 1,
      "icon_name": "creep",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 2,
      "short_description": "When this champion captures a nora globe, your shrine's <mechanic value=deployment_zone>Deployment Zone</mechanic> increases by 1.  This ability is removed after 3 triggers.",
      "long_description": "When this champion captures a nora globe, your shrine's <mechanic value=deployment_zone>Deployment Zone</mechanic> increases by 1.  This ability is removed after 3 triggers.",
      "class_name": "CreepingHarvest",
      "revision": 1
    },
    {
      "asset_id": 7665,
      "resettable": 0,
      "name": "Creeping Pustule",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3248,
      "activated": 1,
      "icon_name": "creep",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 20,
      "short_description": "When a champion within 3 spaces takes 5 or more damage, a Death Carrionling with no upgrades is summoned 4 spaces away from that champion (if there are no empty spaces, it will be summoned farther away). This triggers once per turn.",
      "long_description": "When a champion within 3 spaces takes 5 or more damage, a Death Carrionling with no upgrades is summoned 4 spaces away from that champion (if there are no empty spaces, it will be summoned farther away). This triggers once per turn.",
      "class_name": "CreepingPustule",
      "revision": 1
    },
    {
      "asset_id": 5026,
      "resettable": 1,
      "name": "Cripple",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1206,
      "activated": 1,
      "icon_name": "debuff",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "When this champion successfully damages a champion with a basic attack, if that champion does not have Crippled, it becomes <condition value=crippled>Crippled</condition> for 10 turns. ",
      "long_description": "When this champion successfully damages a champion with a basic attack, if that champion does not have Crippled, it becomes <condition value=crippled>Crippled</condition> for 10 turns. ",
      "class_name": "Cripple",
      "revision": 1
    },
    {
      "asset_id": 5830,
      "resettable": 1,
      "name": "Crippling Discipline",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2839,
      "activated": 1,
      "icon_name": "discipline_distracting",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 3,
      "short_description": "The next basic attack this champion makes gains <ability value=2093>Ponderous</ability> for 2 turns. If the target was <condition value=frozen popup=false>Frozen</condition>, all friendly Monks gain 1 damage for 6 turns",
      "long_description": "The next basic attack this champion makes gains <ability value=2093>Ponderous</ability> for 2 turns. If the target was <condition value=frozen popup=false>Frozen</condition>, all friendly Monks gain 1 damage for 6 turns",
      "class_name": "CripplingDiscipline",
      "revision": 1
    },
    {
      "asset_id": 5783,
      "resettable": 1,
      "name": "Crushing Blow",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2704,
      "activated": 1,
      "icon_name": "shrink",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "When this champion makes a successful basic attack, that champion becomes <condition value=shrunken>Shrunken</condition> for 3 turns.",
      "long_description": "When this champion makes a successful basic attack, that champion becomes <condition value=shrunken>Shrunken</condition> for 3 turns.",
      "class_name": "CrushingBlow",
      "revision": 1
    },
    {
      "asset_id": 5268,
      "resettable": 1,
      "name": "Crushing Charge",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2092,
      "activated": 1,
      "icon_name": "crush",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "This unit moves 1-5 spaces in a straight-line to target unoccupied space. All champions in the path of this movement are knocked back 2 spaces to a random side and become <condition value=slowed>Slowed 2</condition>. If a champion remains in the path, this champion stops moving.",
      "long_description": "This unit moves 1-5 spaces in a straight-line to target unoccupied space. All champions in the path of this movement are knocked back 2 spaces to a random side and become <condition value=slowed>Slowed 2</condition>. If a champion remains in the path, this champion stops moving.",
      "class_name": "CrushingCharge",
      "revision": 1
    },
    {
      "asset_id": 5268,
      "resettable": 0,
      "name": "Crushing Charge (relic)",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3337,
      "activated": 1,
      "icon_name": "crush",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "This unit moves 1-5 squares in a straight-line to target unoccupied space. All champions in the path of this movement are knocked back 2 spaces to a random side. If a champion remains in the path, this unit stops moving.",
      "long_description": "This unit moves 1-5 squares in a straight-line to target unoccupied space. All champions in the path of this movement are knocked back 2 spaces to a random side. If a champion remains in the path, this unit stops moving.",
      "class_name": "CrushingChargeRelic",
      "revision": 1
    },
    {
      "asset_id": 4281,
      "resettable": 1,
      "name": "Crystallize",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 673,
      "activated": 1,
      "icon_name": "crystallize",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 5,
      "short_description": "Target friendly champion that is within 2 spaces becomes Crystallized until the beginning of your next turn. (Crystallized - This champion is <condition value=shielded>Shielded</condition>, <condition value=impervious>Impervious</condition>, and may not move, attack, or activate special abilities. At the beginning of your turn, this champion heals 4 HP).  May target self.",
      "long_description": "Target friendly champion that is within 2 spaces becomes Crystallized until the beginning of your next turn. (Crystallized - This champion is <condition value=shielded>Shielded</condition>, <condition value=impervious>Impervious</condition>, and may not move, attack, or activate special abilities. At the beginning of your turn, this champion heals 4 HP).  May target self.",
      "class_name": "CrystallizeAbility",
      "revision": 1
    },
    {
      "asset_id": 7320,
      "resettable": 0,
      "name": "Cull",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3096,
      "activated": 1,
      "icon_name": "offenseenhance",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 5,
      "short_description": "This champion deals 4 additional damage to champions with 0 AP (Fatigued) on basic attacks.",
      "long_description": "This champion deals 4 additional damage to champions with 0 AP (Fatigued) on basic attacks.",
      "class_name": "Cull",
      "revision": 1
    },
    {
      "asset_id": 4130,
      "resettable": 1,
      "name": "Curse",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 328,
      "activated": 1,
      "icon_name": "debuff",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 4,
      "short_description": "This unit makes a 5 dmg attack at range 1-5. If successful, the target becomes <condition value=cursed>Cursed</condition> for 2 turns. If the target was already Cursed, then this attack deals an additional 5 damage.",
      "long_description": "This unit makes a 5 dmg attack at range 1-5. If successful, the target becomes <condition value=cursed>Cursed</condition> for 2 turns. If the target was already Cursed, then this attack deals an additional 5 damage.",
      "class_name": "Curse",
      "revision": 1
    },
    {
      "asset_id": 4130,
      "resettable": 1,
      "name": "Curse",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 695,
      "activated": 1,
      "icon_name": "debuff",
      "comments": "none",
      "prerequisite_id": 328,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 6,
      "short_description": "This unit makes an 8 dmg attack at range 1-5. If successful, the target becomes <condition value=cursed>Cursed</condition> for 4 turns. If the target was already Cursed, then this attack deals an additional 5 damage.",
      "long_description": "This unit makes an 8 dmg attack at range 1-5. If successful, the target becomes <condition value=cursed>Cursed</condition> for 4 turns. If the target was already Cursed, then this attack deals an additional 5 damage.",
      "class_name": "Curse",
      "revision": 1
    },
    {
      "asset_id": 8014,
      "resettable": 0,
      "name": "Cursed Aura",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3411,
      "activated": 1,
      "icon_name": "debuff",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "Enemy champions that move within 3 spaces of this unit become <condition value=cursed>Cursed</condition> for 3 turns.",
      "long_description": "Enemy champions that move within 3 spaces of this unit become <condition value=cursed>Cursed</condition> for 3 turns.",
      "class_name": "CursedAura",
      "revision": 1
    },
    {
      "asset_id": 4524,
      "resettable": 1,
      "name": "Cursed Temple",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 918,
      "activated": 1,
      "icon_name": "shrinebad",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "Friendly champions with Race: Vampyre or Class: Witch gain +1 DMG, +1 DEF, <ability value=2628>Cursed Treasure</ability> and <ability value=2701>Shadestrike</ability> as long as a friendly champion with Lord of Strigoi or Queen of the Night is in play.",
      "long_description": "Friendly champions with Race: Vampyre or Class: Witch gain +1 DMG, +1 DEF, <ability value=2628>Cursed Treasure</ability> and <ability value=2701>Shadestrike</ability> as long as a friendly champion with Lord of Strigoi or Queen of the Night is in play.",
      "class_name": "RelicCursedTemple",
      "revision": 1
    },
    {
      "asset_id": 5741,
      "resettable": 1,
      "name": "Cursed Treasure",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2628,
      "activated": 1,
      "icon_name": "cursed_treasure",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "When a nora globe within 8 spaces is recovered, opposing champions within 3 spaces of the nora globe becomes <condition value=cursed>Cursed</condition> for 5 turns.  If the champion was already Cursed, it also takes 5 Disease damage.",
      "long_description": "When a nora globe within 8 spaces is recovered, opposing champions within 3 spaces of the nora globe becomes <condition value=cursed>Cursed</condition> for 5 turns.  If the champion was already Cursed, it also takes 5 Disease damage.",
      "class_name": "CursedTreasure",
      "revision": 1
    },
    {
      "asset_id": 7172,
      "resettable": 0,
      "name": "Cyclopean Machine",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3015,
      "activated": 1,
      "icon_name": "cyclopean_machine",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "When this champion is within 4 spaces of a friendly champion with Class: Tinkerer, it gains +1 SPD, <ability value=6>Mobility</ability> and <ability value=1900>Tough 1</ability>.",
      "long_description": "When this champion is within 4 spaces of a friendly champion with Class: Tinkerer, it gains +1 SPD, <ability value=6>Mobility</ability> and <ability value=1900>Tough 1</ability>.",
      "class_name": "CyclopeanMachine",
      "revision": 1
    },
    {
      "asset_id": 7191,
      "resettable": 0,
      "name": "Cyclopean Menace",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3038,
      "activated": 1,
      "icon_name": "cyclopean_menace",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 14,
      "short_description": "The first time each turn a friendly Cyclops or Construct is deployed from the runedock, this champion gains 2 AP and enemy champions within 2 spaces takes 4 Sonic damage.",
      "long_description": "The first time each turn a friendly Cyclops or Construct is deployed from the runedock, this champion gains 2 AP and enemy champions within 2 spaces takes 4 Sonic damage.",
      "class_name": "CyclopeanMenace",
      "revision": 1
    },
    {
      "asset_id": 4074,
      "resettable": 1,
      "name": "Damage Aura",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 123,
      "activated": 1,
      "icon_name": "novaphysical",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 2,
      "short_description": "At the beginning of your opponent's turns, this unit deals 2 Physical damage to each champion within 2 spaces. This damage ignores DEF.",
      "long_description": "At the beginning of your opponent's turns, this unit deals 2 Physical damage to each champion within 2 spaces. This damage ignores DEF.",
      "class_name": "DamagingAuraPhysical",
      "revision": 1
    },
    {
      "asset_id": 4074,
      "resettable": 1,
      "name": "Damage Aura",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 124,
      "activated": 1,
      "icon_name": "novaphysical",
      "comments": "none",
      "prerequisite_id": 123,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 4,
      "short_description": "At the beginning of your opponent's turns, this unit deals 4 Physical damage to each champion within 2 spaces. This damage ignores DEF.",
      "long_description": "At the beginning of your opponent's turns, this unit deals 4 Physical damage to each champion within 2 spaces. This damage ignores DEF.",
      "class_name": "DamagingAuraPhysical",
      "revision": 1
    },
    {
      "asset_id": 4074,
      "resettable": 1,
      "name": "Damage Aura",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 125,
      "activated": 1,
      "icon_name": "novaphysical",
      "comments": "none",
      "prerequisite_id": 124,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 6,
      "short_description": "At the beginning of your opponent's turns, this unit deals 6 Physical damage to each champion within 2 spaces. This damage ignores DEF.",
      "long_description": "At the beginning of your opponent's turns, this unit deals 6 Physical damage to each champion within 2 spaces. This damage ignores DEF.",
      "class_name": "DamagingAuraPhysical",
      "revision": 1
    },
    {
      "asset_id": 4105,
      "resettable": 1,
      "name": "Damage Shield: Acid",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 247,
      "activated": 1,
      "icon_name": "dmgshld_acid",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 1,
      "short_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 2 Acid damage. This damage ignores DEF.",
      "long_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 2 Acid damage. This damage ignores DEF.",
      "class_name": "DamageShieldAcid",
      "revision": 1
    },
    {
      "asset_id": 4105,
      "resettable": 1,
      "name": "Damage Shield: Acid",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 248,
      "activated": 1,
      "icon_name": "dmgshld_acid",
      "comments": "none",
      "prerequisite_id": 247,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 2,
      "short_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 4 Acid damage. This damage ignores DEF.",
      "long_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 4 Acid damage. This damage ignores DEF.",
      "class_name": "DamageShieldAcid",
      "revision": 1
    },
    {
      "asset_id": 4105,
      "resettable": 1,
      "name": "Damage Shield: Acid",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 249,
      "activated": 1,
      "icon_name": "dmgshld_acid",
      "comments": "none",
      "prerequisite_id": 248,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 3,
      "short_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Acid damage. This damage ignores DEF.",
      "long_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Acid damage. This damage ignores DEF.",
      "class_name": "DamageShieldAcid",
      "revision": 1
    },
    {
      "asset_id": 4106,
      "resettable": 1,
      "name": "Damage Shield: Disease",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 251,
      "activated": 1,
      "icon_name": "dmgshld_disease",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 1,
      "short_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 2 Disease damage. This damage ignores DEF.",
      "long_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 2 Disease damage. This damage ignores DEF.",
      "class_name": "DamageShieldDisease",
      "revision": 1
    },
    {
      "asset_id": 4106,
      "resettable": 1,
      "name": "Damage Shield: Disease",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 252,
      "activated": 1,
      "icon_name": "dmgshld_disease",
      "comments": "none",
      "prerequisite_id": 251,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 2,
      "short_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 4 Disease damage. This damage ignores DEF.",
      "long_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 4 Disease damage. This damage ignores DEF.",
      "class_name": "DamageShieldDisease",
      "revision": 1
    },
    {
      "asset_id": 4106,
      "resettable": 1,
      "name": "Damage Shield: Disease",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 253,
      "activated": 1,
      "icon_name": "dmgshld_disease",
      "comments": "none",
      "prerequisite_id": 252,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 3,
      "short_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Disease damage. This damage ignores DEF.",
      "long_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Disease damage. This damage ignores DEF.",
      "class_name": "DamageShieldDisease",
      "revision": 1
    },
    {
      "asset_id": 4102,
      "resettable": 1,
      "name": "Damage Shield: Electricity",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 235,
      "activated": 1,
      "icon_name": "dmgshld_lightning",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 1,
      "short_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 2 Electricity damage. This damage ignores DEF.",
      "long_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 2 Electricity damage. This damage ignores DEF.",
      "class_name": "DamageShieldElectricity",
      "revision": 1
    },
    {
      "asset_id": 4102,
      "resettable": 1,
      "name": "Damage Shield: Electricity",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 236,
      "activated": 1,
      "icon_name": "dmgshld_lightning",
      "comments": "none",
      "prerequisite_id": 235,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 2,
      "short_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 4 Electricity damage. This damage ignores DEF.",
      "long_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 4 Electricity damage. This damage ignores DEF.",
      "class_name": "DamageShieldElectricity",
      "revision": 1
    },
    {
      "asset_id": 4102,
      "resettable": 1,
      "name": "Damage Shield: Electricity",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 237,
      "activated": 1,
      "icon_name": "dmgshld_lightning",
      "comments": "none",
      "prerequisite_id": 236,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 3,
      "short_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Electricity damage. This damage ignores DEF.",
      "long_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Electricity damage. This damage ignores DEF.",
      "class_name": "DamageShieldElectricity",
      "revision": 1
    },
    {
      "asset_id": 4100,
      "resettable": 1,
      "name": "Damage Shield: Fire",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 227,
      "activated": 1,
      "icon_name": "dmgshld_fire",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 1,
      "short_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 2 Fire damage. This damage ignores DEF.",
      "long_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 2 Fire damage. This damage ignores DEF.",
      "class_name": "DamageShieldFire",
      "revision": 1
    },
    {
      "asset_id": 4100,
      "resettable": 1,
      "name": "Damage Shield: Fire",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 228,
      "activated": 1,
      "icon_name": "dmgshld_fire",
      "comments": "none",
      "prerequisite_id": 227,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 2,
      "short_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 4 Fire damage. This damage ignores DEF.",
      "long_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 4 Fire damage. This damage ignores DEF.",
      "class_name": "DamageShieldFire",
      "revision": 1
    },
    {
      "asset_id": 4100,
      "resettable": 1,
      "name": "Damage Shield: Fire",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 229,
      "activated": 1,
      "icon_name": "dmgshld_fire",
      "comments": "none",
      "prerequisite_id": 228,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 3,
      "short_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Fire damage. This damage ignores DEF.",
      "long_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Fire damage. This damage ignores DEF.",
      "class_name": "DamageShieldFire",
      "revision": 1
    },
    {
      "asset_id": 4101,
      "resettable": 1,
      "name": "Damage Shield: Frost",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 231,
      "activated": 1,
      "icon_name": "dmgshld_frost",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 1,
      "short_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 2 Frost damage. This damage ignores DEF.",
      "long_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 2 Frost damage. This damage ignores DEF.",
      "class_name": "DamageShieldCold",
      "revision": 1
    },
    {
      "asset_id": 4101,
      "resettable": 1,
      "name": "Damage Shield: Frost",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 232,
      "activated": 1,
      "icon_name": "dmgshld_frost",
      "comments": "none",
      "prerequisite_id": 231,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 2,
      "short_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 4 Frost damage. This damage ignores DEF.",
      "long_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 4 Frost damage. This damage ignores DEF.",
      "class_name": "DamageShieldCold",
      "revision": 1
    },
    {
      "asset_id": 4101,
      "resettable": 1,
      "name": "Damage Shield: Frost",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 233,
      "activated": 1,
      "icon_name": "dmgshld_frost",
      "comments": "none",
      "prerequisite_id": 232,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 3,
      "short_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Frost damage. This damage ignores DEF.",
      "long_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Frost damage. This damage ignores DEF.",
      "class_name": "DamageShieldCold",
      "revision": 1
    },
    {
      "asset_id": 4099,
      "resettable": 1,
      "name": "Damage Shield: Magical",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 223,
      "activated": 1,
      "icon_name": "dmgshld_magic",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 1,
      "short_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 2 Magical damage. This damage ignores DEF.",
      "long_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 2 Magical damage. This damage ignores DEF.",
      "class_name": "DamageShieldMagical",
      "revision": 1
    },
    {
      "asset_id": 4099,
      "resettable": 1,
      "name": "Damage Shield: Magical",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 224,
      "activated": 1,
      "icon_name": "dmgshld_magic",
      "comments": "none",
      "prerequisite_id": 223,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 2,
      "short_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 4 Magical damage. This damage ignores DEF.",
      "long_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 4 Magical damage. This damage ignores DEF.",
      "class_name": "DamageShieldMagical",
      "revision": 1
    },
    {
      "asset_id": 4099,
      "resettable": 1,
      "name": "Damage Shield: Magical",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 225,
      "activated": 1,
      "icon_name": "dmgshld_magic",
      "comments": "none",
      "prerequisite_id": 224,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 3,
      "short_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Magical damage. This damage ignores DEF.",
      "long_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Magical damage. This damage ignores DEF.",
      "class_name": "DamageShieldMagical",
      "revision": 1
    },
    {
      "asset_id": 4098,
      "resettable": 1,
      "name": "Damage Shield: Physical",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 219,
      "activated": 1,
      "icon_name": "dmgshld_physical",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 1,
      "short_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 2 Physical damage. This damage ignores DEF.",
      "long_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 2 Physical damage. This damage ignores DEF.",
      "class_name": "DamageShieldPhysical",
      "revision": 1
    },
    {
      "asset_id": 4098,
      "resettable": 1,
      "name": "Damage Shield: Physical",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 220,
      "activated": 1,
      "icon_name": "dmgshld_physical",
      "comments": "none",
      "prerequisite_id": 219,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 2,
      "short_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 4 Physical damage. This damage ignores DEF.",
      "long_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 4 Physical damage. This damage ignores DEF.",
      "class_name": "DamageShieldPhysical",
      "revision": 1
    },
    {
      "asset_id": 4098,
      "resettable": 1,
      "name": "Damage Shield: Physical",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 221,
      "activated": 1,
      "icon_name": "dmgshld_physical",
      "comments": "none",
      "prerequisite_id": 220,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 3,
      "short_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Physical damage. This damage ignores DEF.",
      "long_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Physical damage. This damage ignores DEF.",
      "class_name": "DamageShieldPhysical",
      "revision": 1
    },
    {
      "asset_id": 4103,
      "resettable": 1,
      "name": "Damage Shield: Poison",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 239,
      "activated": 1,
      "icon_name": "dmgshld_poison",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 1,
      "short_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 2 Poison damage. This damage ignores DEF.",
      "long_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 2 Poison damage. This damage ignores DEF.",
      "class_name": "DamageShieldPoison",
      "revision": 1
    },
    {
      "asset_id": 4103,
      "resettable": 1,
      "name": "Damage Shield: Poison",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 240,
      "activated": 1,
      "icon_name": "dmgshld_poison",
      "comments": "none",
      "prerequisite_id": 239,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 2,
      "short_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 4 Poison damage. This damage ignores DEF.",
      "long_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 4 Poison damage. This damage ignores DEF.",
      "class_name": "DamageShieldPoison",
      "revision": 1
    },
    {
      "asset_id": 4103,
      "resettable": 1,
      "name": "Damage Shield: Poison",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 241,
      "activated": 1,
      "icon_name": "dmgshld_poison",
      "comments": "none",
      "prerequisite_id": 240,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 3,
      "short_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Poison damage. This damage ignores DEF.",
      "long_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Poison damage. This damage ignores DEF.",
      "class_name": "DamageShieldPoison",
      "revision": 1
    },
    {
      "asset_id": 4107,
      "resettable": 1,
      "name": "Damage Shield: Psychic",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 255,
      "activated": 1,
      "icon_name": "dmgshld_psychic",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 1,
      "short_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 2 Psychic damage. This damage ignores DEF.",
      "long_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 2 Psychic damage. This damage ignores DEF.",
      "class_name": "DamageShieldPsychic",
      "revision": 1
    },
    {
      "asset_id": 4107,
      "resettable": 1,
      "name": "Damage Shield: Psychic",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 256,
      "activated": 1,
      "icon_name": "dmgshld_psychic",
      "comments": "none",
      "prerequisite_id": 255,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 2,
      "short_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 4 Psychic damage. This damage ignores DEF.",
      "long_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 4 Psychic damage. This damage ignores DEF.",
      "class_name": "DamageShieldPsychic",
      "revision": 1
    },
    {
      "asset_id": 4107,
      "resettable": 1,
      "name": "Damage Shield: Psychic",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 257,
      "activated": 1,
      "icon_name": "dmgshld_psychic",
      "comments": "none",
      "prerequisite_id": 256,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 3,
      "short_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Psychic damage. This damage ignores DEF.",
      "long_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Psychic damage. This damage ignores DEF.",
      "class_name": "DamageShieldPsychic",
      "revision": 1
    },
    {
      "asset_id": 4104,
      "resettable": 1,
      "name": "Damage Shield: Sonic",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 243,
      "activated": 1,
      "icon_name": "dmgshld_sonic",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 1,
      "short_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 2 Sonic damage. This damage ignores DEF.",
      "long_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 2 Sonic damage. This damage ignores DEF.",
      "class_name": "DamageShieldSonic",
      "revision": 1
    },
    {
      "asset_id": 4104,
      "resettable": 1,
      "name": "Damage Shield: Sonic",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 244,
      "activated": 1,
      "icon_name": "dmgshld_sonic",
      "comments": "none",
      "prerequisite_id": 243,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 2,
      "short_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 4 Sonic damage. This damage ignores DEF.",
      "long_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 4 Sonic damage. This damage ignores DEF.",
      "class_name": "DamageShieldSonic",
      "revision": 1
    },
    {
      "asset_id": 4104,
      "resettable": 1,
      "name": "Damage Shield: Sonic",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 245,
      "activated": 1,
      "icon_name": "dmgshld_sonic",
      "comments": "none",
      "prerequisite_id": 244,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 3,
      "short_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Sonic damage. This damage ignores DEF.",
      "long_description": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Sonic damage. This damage ignores DEF.",
      "class_name": "DamageShieldSonic",
      "revision": 1
    },
    {
      "asset_id": 7194,
      "resettable": 0,
      "name": "Dark Awakening",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3036,
      "activated": 1,
      "icon_name": "desecrate_earth",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "This champion has +1 DMG, +1 DEF and +1 SPD for every 3 champions (not including self) occupying a Dead Magic Zone.",
      "long_description": "This champion has +1 DMG, +1 DEF and +1 SPD for every 3 champions (not including self) occupying a Dead Magic Zone.",
      "class_name": "DarkAwakening",
      "revision": 1
    },
    {
      "asset_id": 4547,
      "resettable": 1,
      "name": "Dark Favor",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 939,
      "activated": 1,
      "icon_name": "drain",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 6,
      "short_description": "When this unit is deployed, enemy champions lose 3 HP.",
      "long_description": "When this unit is deployed, enemy champions lose 3 HP.",
      "class_name": "DarkFavor",
      "revision": 1
    },
    {
      "asset_id": 4547,
      "resettable": 1,
      "name": "Dark Favor",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 940,
      "activated": 1,
      "icon_name": "drain",
      "comments": "none",
      "prerequisite_id": 939,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 10,
      "short_description": "When this unit is deployed, enemy champions lose 6 HP.",
      "long_description": "When this unit is deployed, enemy champions lose 6 HP.",
      "class_name": "DarkFavor",
      "revision": 1
    },
    {
      "asset_id": 4547,
      "resettable": 1,
      "name": "Dark Favor",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 941,
      "activated": 1,
      "icon_name": "drain",
      "comments": "none",
      "prerequisite_id": 940,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 14,
      "short_description": "When this unit is deployed, enemy champions lose 9 HP.",
      "long_description": "When this unit is deployed, enemy champions lose 9 HP.",
      "class_name": "DarkFavor",
      "revision": 1
    },
    {
      "asset_id": 4576,
      "resettable": 1,
      "name": "Dark Healing",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 986,
      "activated": 1,
      "icon_name": "dark_heal",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 9,
      "short_description": "When an enemy champion within 10 spaces is healed by a spell or ability, the amount healed is reduced by 50%. At the end of each turn, friendly champions are healed by the same number of HP, distributed evenly among them to a maximum of 6 HP (rounded down, minimum 1). This effect does not stack.",
      "long_description": "When an enemy champion within 10 spaces is healed by a spell or ability, the amount healed is reduced by 50%. At the end of each turn, friendly champions are healed by the same number of HP, distributed evenly among them to a maximum of 6 HP (rounded down, minimum 1). This effect does not stack.",
      "class_name": "DarkHealing",
      "revision": 1
    },
    {
      "asset_id": 5551,
      "resettable": 1,
      "name": "Dark Raven Form",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 2411,
      "activated": 1,
      "icon_name": "transform",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "This unit becomes a Dark Raven and gains <ability value=1>Flight</ability>, <ability value=6>Mobility</ability>, <ability value=13>Detection 3</ability>, <ability value=1399>Hex 2</ability> and Race: Beast. It's RNG becomes 1-1 and it is <mechanic value=cleansed>Cleansed</mechanic>. ",
      "long_description": "This unit becomes a Dark Raven and gains <ability value=1>Flight</ability>, <ability value=6>Mobility</ability>, <ability value=13>Detection 3</ability>, <ability value=1399>Hex 2</ability> and Race: Beast. It's RNG becomes 1-1 and it is <mechanic value=cleansed>Cleansed</mechanic>. ",
      "class_name": "RavenForm",
      "revision": 1
    },
    {
      "asset_id": 5287,
      "resettable": 1,
      "name": "Dark Rider",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2110,
      "activated": 1,
      "icon_name": "rider",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 40,
      "short_description": "When this unit is destroyed, no nora globe is dropped and a normal sized General Korsien with <ability value=2315>Oblivion Shield</ability> and <ability value=805>Chain Lightning</ability> is spawned in the location this unit occupied.",
      "long_description": "When this unit is destroyed, no nora globe is dropped and a normal sized General Korsien with <ability value=2315>Oblivion Shield</ability> and <ability value=805>Chain Lightning</ability> is spawned in the location this unit occupied.",
      "class_name": "DarkRider",
      "revision": 1
    },
    {
      "asset_id": 5540,
      "resettable": 1,
      "name": "Dark Summons",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2399,
      "activated": 1,
      "icon_name": "sumimp",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 20,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "A random Demon champion with a nora cost of 65 or less from your runedock is automatically deployed on target space.  If there are no valid champions, a Level 3 Imp is deployed.  This ability begins play on cooldown.",
      "long_description": "A random Demon champion with a nora cost of 65 or less from your runedock is automatically deployed on target space.  If there are no valid champions, a Level 3 Imp is deployed.  This ability begins play on cooldown.",
      "class_name": "DarkSummons",
      "revision": 1
    },
    {
      "asset_id": 4939,
      "resettable": 1,
      "name": "Darkmarsh Helm",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1824,
      "activated": 1,
      "icon_name": "stealth",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "At the end of its turn, friendly champions within 5 spaces of this unit are Stealthed for 6 turns.",
      "long_description": "At the end of its turn, friendly champions within 5 spaces of this unit are Stealthed for 6 turns.",
      "class_name": "RelicDarkmarshHelm",
      "revision": 1
    },
    {
      "asset_id": 7153,
      "resettable": 0,
      "name": "Dashing Dodge",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2995,
      "activated": 1,
      "icon_name": "dashing_dodge",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "Next time target champion within 11 spaces makes a ranged attack against this unit, that attack automatically misses and this champion is relocated to the closest available space to target champion. This effect is hidden until triggered. This effect does not trigger if this unit is Paralyzed or Stunned. (You may target this unit to Artful Dodge the next ranged attack from any champion.)",
      "long_description": "Next time target champion within 11 spaces makes a ranged attack against this unit, that attack automatically misses and this champion is relocated to the closest available space to target champion. This effect is hidden until triggered. This effect does not trigger if this unit is Paralyzed or Stunned. (You may target this unit to Artful Dodge the next ranged attack from any champion.)",
      "class_name": "DashingDodge",
      "revision": 1
    },
    {
      "asset_id": 4036,
      "resettable": 1,
      "name": "Dawn Rock Tribe",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 713,
      "activated": 1,
      "icon_name": "aurapositive",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "This cyclops is a member of the Dawn Rock tribe.",
      "long_description": "This cyclops is a member of the Dawn Rock tribe.",
      "class_name": "DawnRockCyclops",
      "revision": 1
    },
    {
      "asset_id": 5717,
      "resettable": 1,
      "name": "Dazzling",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2762,
      "activated": 1,
      "icon_name": "fascinate",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 15,
      "short_description": "The first time this champion is engaged each turn, adjacent champions become <condition value=blinded>Blinded</condition> for 2 turns.",
      "long_description": "The first time this champion is engaged each turn, adjacent champions become <condition value=blinded>Blinded</condition> for 2 turns.",
      "class_name": "Dazzling",
      "revision": 1
    },
    {
      "asset_id": 7609,
      "resettable": 0,
      "name": "De'lim's Mass Teleport",
      "ap_cost": 5,
      "level": 0,
      "ability_id": 3237,
      "activated": 1,
      "icon_name": "relocate",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 0,
      "ranked": 0,
      "cost": 12,
      "short_description": "This champion is relocated to target space within 5 spaces. Friendly champions within 2 spaces are also relocated (distributed randomly within the AE).",
      "long_description": "This champion is relocated to target space within 5 spaces. Friendly champions within 2 spaces are also relocated (distributed randomly within the AE).",
      "class_name": "MassTeleportDelim",
      "revision": 1
    },
    {
      "asset_id": 4417,
      "resettable": 1,
      "name": "Dead Eater",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 746,
      "activated": 1,
      "icon_name": "nora_eater",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "When this unit recovers a nora globe, it recovers an additional 6 nora.",
      "long_description": "When this unit recovers a nora globe, it recovers an additional 6 nora.",
      "class_name": "DeadEater",
      "revision": 1
    },
    {
      "asset_id": 4925,
      "resettable": 1,
      "name": "Deafening Aura",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1807,
      "activated": 1,
      "icon_name": "deafening_aura",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "Whenever an enemy champion moves within 2 spaces of this unit, it takes 3 Sonic damage and is <condition value=distracted>Distracted</condition> for 2 turns.  This damage ignores DEF.",
      "long_description": "Whenever an enemy champion moves within 2 spaces of this unit, it takes 3 Sonic damage and is <condition value=distracted>Distracted</condition> for 2 turns.  This damage ignores DEF.",
      "class_name": "DeafeningAura",
      "revision": 1
    },
    {
      "asset_id": 5341,
      "resettable": 1,
      "name": "Death Charged",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 2172,
      "activated": 1,
      "icon_name": "charged_death",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 3,
      "short_description": "When a real champion is destroyed, this unit gains 1 charge.",
      "long_description": "When a real champion is destroyed, this unit gains 1 charge.",
      "class_name": "DeathCharged",
      "revision": 1
    },
    {
      "asset_id": 5341,
      "resettable": 1,
      "name": "Death Charged",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 2173,
      "activated": 1,
      "icon_name": "charged_death",
      "comments": "",
      "prerequisite_id": 2172,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 6,
      "short_description": "When a real champion is destroyed, this unit gains 2 charges.",
      "long_description": "When a real champion is destroyed, this unit gains 2 charges.",
      "class_name": "DeathCharged",
      "revision": 1
    },
    {
      "asset_id": 5341,
      "resettable": 1,
      "name": "Death Charged",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 2174,
      "activated": 1,
      "icon_name": "charged_death",
      "comments": "",
      "prerequisite_id": 2173,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 9,
      "short_description": "When a real champion is destroyed, this unit gains 3 charges.",
      "long_description": "When a real champion is destroyed, this unit gains 3 charges.",
      "class_name": "DeathCharged",
      "revision": 1
    },
    {
      "asset_id": 4386,
      "resettable": 1,
      "name": "Death Harvest",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1426,
      "activated": 1,
      "icon_name": "ondeath",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 13,
      "short_description": "When a friendly non-Illusion, non-Summoned champion is destroyed, you gain up to 12% of its nora cost, to a maximum of 7. This does not stack",
      "long_description": "When a friendly non-Illusion, non-Summoned champion is destroyed, you gain up to 12% of its nora cost, to a maximum of 7. This does not stack",
      "class_name": "DeathHarvest",
      "revision": 1
    },
    {
      "asset_id": 5409,
      "resettable": 1,
      "name": "Death Knell",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2241,
      "activated": 1,
      "icon_name": "death_toll",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "Spend 8 charges. Target opposing non-Avatar, non-Elite, non-Boss champion within 6 spaces gains <ability value=875>Short-Lived 1</ability> and this champion loses all remaining charges.",
      "long_description": "Spend 8 charges. Target opposing non-Avatar, non-Elite, non-Boss champion within 6 spaces gains <ability value=875>Short-Lived 1</ability> and this champion loses all remaining charges.",
      "class_name": "DeathKnell",
      "revision": 1
    },
    {
      "asset_id": 4093,
      "resettable": 1,
      "name": "Death Nova: Acid",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 199,
      "activated": 1,
      "icon_name": "deathnovaacid",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 1,
      "short_description": "When this unit is destroyed, it deals 5 Acid damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "long_description": "When this unit is destroyed, it deals 5 Acid damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "class_name": "DeathNovaAcid",
      "revision": 1
    },
    {
      "asset_id": 4093,
      "resettable": 1,
      "name": "Death Nova: Acid",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 200,
      "activated": 1,
      "icon_name": "deathnovaacid",
      "comments": "none",
      "prerequisite_id": 199,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 2,
      "short_description": "When this unit is destroyed, it deals 8 Acid damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "long_description": "When this unit is destroyed, it deals 8 Acid damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "class_name": "DeathNovaAcid",
      "revision": 1
    },
    {
      "asset_id": 4093,
      "resettable": 1,
      "name": "Death Nova: Acid",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 201,
      "activated": 1,
      "icon_name": "deathnovaacid",
      "comments": "none",
      "prerequisite_id": 200,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 4,
      "short_description": "When this unit is destroyed, it deals 11 Acid damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "long_description": "When this unit is destroyed, it deals 11 Acid damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "class_name": "DeathNovaAcid",
      "revision": 1
    },
    {
      "asset_id": 4094,
      "resettable": 1,
      "name": "Death Nova: Disease",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 203,
      "activated": 1,
      "icon_name": "deathnovadisease",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 1,
      "short_description": "When this unit is destroyed, it deals 5 Disease damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "long_description": "When this unit is destroyed, it deals 5 Disease damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "class_name": "DeathNovaDisease",
      "revision": 1
    },
    {
      "asset_id": 4094,
      "resettable": 1,
      "name": "Death Nova: Disease",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 204,
      "activated": 1,
      "icon_name": "deathnovadisease",
      "comments": "none",
      "prerequisite_id": 203,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 2,
      "short_description": "When this unit is destroyed, it deals 8 Disease damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "long_description": "When this unit is destroyed, it deals 8 Disease damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "class_name": "DeathNovaDisease",
      "revision": 1
    },
    {
      "asset_id": 4094,
      "resettable": 1,
      "name": "Death Nova: Disease",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 205,
      "activated": 1,
      "icon_name": "deathnovadisease",
      "comments": "none",
      "prerequisite_id": 204,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 4,
      "short_description": "When this unit is destroyed, it deals 11 Disease damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "long_description": "When this unit is destroyed, it deals 11 Disease damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "class_name": "DeathNovaDisease",
      "revision": 1
    },
    {
      "asset_id": 4090,
      "resettable": 1,
      "name": "Death Nova: Electricity",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 187,
      "activated": 1,
      "icon_name": "deathnovaelec",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 1,
      "short_description": "When this unit is destroyed, it deals 5 Electricity damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "long_description": "When this unit is destroyed, it deals 5 Electricity damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "class_name": "DeathNovaElectricity",
      "revision": 1
    },
    {
      "asset_id": 4090,
      "resettable": 1,
      "name": "Death Nova: Electricity",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 188,
      "activated": 1,
      "icon_name": "deathnovaelec",
      "comments": "none",
      "prerequisite_id": 187,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 2,
      "short_description": "When this unit is destroyed, it deals 8 Electricity damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "long_description": "When this unit is destroyed, it deals 8 Electricity damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "class_name": "DeathNovaElectricity",
      "revision": 1
    },
    {
      "asset_id": 4090,
      "resettable": 1,
      "name": "Death Nova: Electricity",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 189,
      "activated": 1,
      "icon_name": "deathnovaelec",
      "comments": "none",
      "prerequisite_id": 188,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 4,
      "short_description": "When this unit is destroyed, it deals 11 Electricity damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "long_description": "When this unit is destroyed, it deals 11 Electricity damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "class_name": "DeathNovaElectricity",
      "revision": 1
    },
    {
      "asset_id": 4088,
      "resettable": 1,
      "name": "Death Nova: Fire",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 179,
      "activated": 1,
      "icon_name": "deathnovafire",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 1,
      "short_description": "When this unit is destroyed, it deals 5 Fire damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "long_description": "When this unit is destroyed, it deals 5 Fire damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "class_name": "DeathNovaFire",
      "revision": 1
    },
    {
      "asset_id": 4088,
      "resettable": 1,
      "name": "Death Nova: Fire",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 180,
      "activated": 1,
      "icon_name": "deathnovafire",
      "comments": "none",
      "prerequisite_id": 179,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 2,
      "short_description": "When this unit is destroyed, it deals 8 Fire damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "long_description": "When this unit is destroyed, it deals 8 Fire damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "class_name": "DeathNovaFire",
      "revision": 1
    },
    {
      "asset_id": 4088,
      "resettable": 1,
      "name": "Death Nova: Fire",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 181,
      "activated": 1,
      "icon_name": "deathnovafire",
      "comments": "none",
      "prerequisite_id": 180,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 4,
      "short_description": "When this unit is destroyed, it deals 11 Fire damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "long_description": "When this unit is destroyed, it deals 11 Fire damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "class_name": "DeathNovaFire",
      "revision": 1
    },
    {
      "asset_id": 4088,
      "resettable": 1,
      "name": "Death Nova: Fire",
      "ap_cost": 0,
      "level": 4,
      "ability_id": 182,
      "activated": 1,
      "icon_name": "deathnovafire",
      "comments": "none",
      "prerequisite_id": 181,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 6,
      "short_description": "When this unit is destroyed, it deals 14 Fire damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "long_description": "When this unit is destroyed, it deals 14 Fire damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "class_name": "DeathNovaFire",
      "revision": 1
    },
    {
      "asset_id": 4089,
      "resettable": 1,
      "name": "Death Nova: Frost",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 183,
      "activated": 1,
      "icon_name": "deathnovafrost",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 1,
      "short_description": "When this unit is destroyed, it deals 5 Frost damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "long_description": "When this unit is destroyed, it deals 5 Frost damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "class_name": "DeathNovaCold",
      "revision": 1
    },
    {
      "asset_id": 4089,
      "resettable": 1,
      "name": "Death Nova: Frost",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 184,
      "activated": 1,
      "icon_name": "deathnovafrost",
      "comments": "none",
      "prerequisite_id": 183,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 2,
      "short_description": "When this unit is destroyed, it deals 8 Frost damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "long_description": "When this unit is destroyed, it deals 8 Frost damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "class_name": "DeathNovaCold",
      "revision": 1
    },
    {
      "asset_id": 4089,
      "resettable": 1,
      "name": "Death Nova: Frost",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 185,
      "activated": 1,
      "icon_name": "deathnovafrost",
      "comments": "none",
      "prerequisite_id": 184,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 4,
      "short_description": "When this unit is destroyed, it deals 11 Frost damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "long_description": "When this unit is destroyed, it deals 11 Frost damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "class_name": "DeathNovaCold",
      "revision": 1
    },
    {
      "asset_id": 4517,
      "resettable": 1,
      "name": "Death Nova: Lava",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 1446,
      "activated": 1,
      "icon_name": "deathnovalava",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 4,
      "short_description": "When this unit is destroyed, it deals 5 Fire damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. Affected spaces become Lava for 4 turns. This damage ignores DEF.",
      "long_description": "When this unit is destroyed, it deals 5 Fire damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. Affected spaces become Lava for 4 turns. This damage ignores DEF.",
      "class_name": "DeathNovaLava",
      "revision": 1
    },
    {
      "asset_id": 4517,
      "resettable": 1,
      "name": "Death Nova: Lava",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 1447,
      "activated": 1,
      "icon_name": "deathnovalava",
      "comments": "",
      "prerequisite_id": 1446,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 5,
      "short_description": "When this unit is destroyed, it deals 8 Fire damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. Affected spaces become Lava for 4 turns. This damage ignores DEF.",
      "long_description": "When this unit is destroyed, it deals 8 Fire damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. Affected spaces become Lava for 4 turns. This damage ignores DEF.",
      "class_name": "DeathNovaLava",
      "revision": 1
    },
    {
      "asset_id": 4517,
      "resettable": 1,
      "name": "Death Nova: Lava",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 1448,
      "activated": 1,
      "icon_name": "deathnovalava",
      "comments": "",
      "prerequisite_id": 1447,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 7,
      "short_description": "When this unit is destroyed, it deals 11 Fire damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. Affected spaces become Lava for 4 turns. This damage ignores DEF.",
      "long_description": "When this unit is destroyed, it deals 11 Fire damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. Affected spaces become Lava for 4 turns. This damage ignores DEF.",
      "class_name": "DeathNovaLava",
      "revision": 1
    },
    {
      "asset_id": 4087,
      "resettable": 1,
      "name": "Death Nova: Magical",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 175,
      "activated": 1,
      "icon_name": "deathnovamagic",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 1,
      "short_description": "When this unit is destroyed, it deals 5 Magical damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "long_description": "When this unit is destroyed, it deals 5 Magical damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "class_name": "DeathNovaMagical",
      "revision": 1
    },
    {
      "asset_id": 4087,
      "resettable": 1,
      "name": "Death Nova: Magical",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 176,
      "activated": 1,
      "icon_name": "deathnovamagic",
      "comments": "none",
      "prerequisite_id": 175,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 2,
      "short_description": "When this unit is destroyed, it deals 8 Magical damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "long_description": "When this unit is destroyed, it deals 8 Magical damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "class_name": "DeathNovaMagical",
      "revision": 1
    },
    {
      "asset_id": 4087,
      "resettable": 1,
      "name": "Death Nova: Magical",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 177,
      "activated": 1,
      "icon_name": "deathnovamagic",
      "comments": "none",
      "prerequisite_id": 176,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 4,
      "short_description": "When this unit is destroyed, it deals 11 Magical damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "long_description": "When this unit is destroyed, it deals 11 Magical damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "class_name": "DeathNovaMagical",
      "revision": 1
    },
    {
      "asset_id": 4086,
      "resettable": 1,
      "name": "Death Nova: Physical",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 171,
      "activated": 1,
      "icon_name": "deathnovaphysical",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 2,
      "ranked": 1,
      "cost": 1,
      "short_description": "When this unit is destroyed, it deals 5 Physical damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "long_description": "When this unit is destroyed, it deals 5 Physical damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "class_name": "DeathNovaPhysical",
      "revision": 1
    },
    {
      "asset_id": 4086,
      "resettable": 1,
      "name": "Death Nova: Physical",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 172,
      "activated": 1,
      "icon_name": "deathnovaphysical",
      "comments": "none",
      "prerequisite_id": 171,
      "cooldown": 3,
      "activation_type": 2,
      "ranked": 1,
      "cost": 2,
      "short_description": "When this unit is destroyed, it deals 8 Physical damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "long_description": "When this unit is destroyed, it deals 8 Physical damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "class_name": "DeathNovaPhysical",
      "revision": 1
    },
    {
      "asset_id": 4086,
      "resettable": 1,
      "name": "Death Nova: Physical",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 173,
      "activated": 1,
      "icon_name": "deathnovaphysical",
      "comments": "none",
      "prerequisite_id": 172,
      "cooldown": 3,
      "activation_type": 2,
      "ranked": 1,
      "cost": 4,
      "short_description": "When this unit is destroyed, it deals 11 Physical damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "long_description": "When this unit is destroyed, it deals 11 Physical damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "class_name": "DeathNovaPhysical",
      "revision": 1
    },
    {
      "asset_id": 4091,
      "resettable": 1,
      "name": "Death Nova: Poison",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 191,
      "activated": 1,
      "icon_name": "deathnovapoison",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 1,
      "short_description": "When this unit is destroyed, it deals 5 Poison damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "long_description": "When this unit is destroyed, it deals 5 Poison damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "class_name": "DeathNovaPoison",
      "revision": 1
    },
    {
      "asset_id": 4091,
      "resettable": 1,
      "name": "Death Nova: Poison",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 192,
      "activated": 1,
      "icon_name": "deathnovapoison",
      "comments": "none",
      "prerequisite_id": 191,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 2,
      "short_description": "When this unit is destroyed, it deals 8 Poison damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "long_description": "When this unit is destroyed, it deals 8 Poison damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "class_name": "DeathNovaPoison",
      "revision": 1
    },
    {
      "asset_id": 4091,
      "resettable": 1,
      "name": "Death Nova: Poison",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 193,
      "activated": 1,
      "icon_name": "deathnovapoison",
      "comments": "none",
      "prerequisite_id": 192,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 4,
      "short_description": "When this unit is destroyed, it deals 11 Poison damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "long_description": "When this unit is destroyed, it deals 11 Poison damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "class_name": "DeathNovaPoison",
      "revision": 1
    },
    {
      "asset_id": 4095,
      "resettable": 1,
      "name": "Death Nova: Psychic",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 207,
      "activated": 1,
      "icon_name": "deathnovapsychic",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 1,
      "short_description": "When this unit is destroyed, it deals 5 Psychic damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "long_description": "When this unit is destroyed, it deals 5 Psychic damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "class_name": "DeathNovaPsychic",
      "revision": 1
    },
    {
      "asset_id": 4095,
      "resettable": 1,
      "name": "Death Nova: Psychic",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 208,
      "activated": 1,
      "icon_name": "deathnovapsychic",
      "comments": "none",
      "prerequisite_id": 207,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 2,
      "short_description": "When this unit is destroyed, it deals 8 Psychic damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "long_description": "When this unit is destroyed, it deals 8 Psychic damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "class_name": "DeathNovaPsychic",
      "revision": 1
    },
    {
      "asset_id": 4095,
      "resettable": 1,
      "name": "Death Nova: Psychic",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 209,
      "activated": 1,
      "icon_name": "deathnovapsychic",
      "comments": "none",
      "prerequisite_id": 208,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 4,
      "short_description": "When this unit is destroyed, it deals 11 Psychic damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "long_description": "When this unit is destroyed, it deals 11 Psychic damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "class_name": "DeathNovaPsychic",
      "revision": 1
    },
    {
      "asset_id": 4671,
      "resettable": 1,
      "name": "Death Nova: Sand",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1105,
      "activated": 1,
      "icon_name": "deathnovasand",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this champion is destroyed, all champions within 2 spaces become <condition value=blinded>Blinded</condition> for 2 turns, and all spaces within 2 spaces become Sand for 6 turns.",
      "long_description": "When this champion is destroyed, all champions within 2 spaces become <condition value=blinded>Blinded</condition> for 2 turns, and all spaces within 2 spaces become Sand for 6 turns.",
      "class_name": "DeathNovaSand",
      "revision": 1
    },
    {
      "asset_id": 7278,
      "resettable": 0,
      "name": "Death Nova: Skeletons",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3075,
      "activated": 1,
      "icon_name": "deathnovaskeletons",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 14,
      "short_description": "When this unit is destroyed, 2 Grave Warriors are randomly summoned within 3 spaces.",
      "long_description": "When this unit is destroyed, 2 Grave Warriors are randomly summoned within 3 spaces.",
      "class_name": "DeathNovaSkeletons",
      "revision": 1
    },
    {
      "asset_id": 4092,
      "resettable": 1,
      "name": "Death Nova: Sonic",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 195,
      "activated": 1,
      "icon_name": "deathnovasonic",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 1,
      "short_description": "When this unit is destroyed, it deals 5 Sonic damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "long_description": "When this unit is destroyed, it deals 5 Sonic damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "class_name": "DeathNovaSonic",
      "revision": 1
    },
    {
      "asset_id": 4092,
      "resettable": 1,
      "name": "Death Nova: Sonic",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 196,
      "activated": 1,
      "icon_name": "deathnovasonic",
      "comments": "none",
      "prerequisite_id": 195,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 2,
      "short_description": "When this unit is destroyed, it deals 8 Sonic damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "long_description": "When this unit is destroyed, it deals 8 Sonic damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "class_name": "DeathNovaSonic",
      "revision": 1
    },
    {
      "asset_id": 4092,
      "resettable": 1,
      "name": "Death Nova: Sonic",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 197,
      "activated": 1,
      "icon_name": "deathnovasonic",
      "comments": "none",
      "prerequisite_id": 196,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 4,
      "short_description": "When this unit is destroyed, it deals 11 Sonic damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "long_description": "When this unit is destroyed, it deals 11 Sonic damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
      "class_name": "DeathNovaSonic",
      "revision": 1
    },
    {
      "asset_id": 4530,
      "resettable": 1,
      "name": "Death Pact",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 1450,
      "activated": 1,
      "icon_name": "bloodbond",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "Target champion within 5 spaces loses 50% of its current HP. This unit loses HP by the same amount.",
      "long_description": "Target champion within 5 spaces loses 50% of its current HP. This unit loses HP by the same amount.",
      "class_name": "DeathPact",
      "revision": 1
    },
    {
      "asset_id": 5884,
      "resettable": 1,
      "name": "Death Sentence",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 2893,
      "activated": 1,
      "icon_name": "final_judgement",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "This champion makes an attack against an opposing champion at 50% damage. If the attack is successful, that champion is <mechanic value=cleansed>Cleansed</mechanic> and it loses 5 HP for each condition removed.",
      "long_description": "This champion makes an attack against an opposing champion at 50% damage. If the attack is successful, that champion is <mechanic value=cleansed>Cleansed</mechanic> and it loses 5 HP for each condition removed.",
      "class_name": "FinalJudgement",
      "revision": 1
    },
    {
      "asset_id": 5028,
      "resettable": 1,
      "name": "Death Spawn: Carrionling",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1207,
      "activated": 1,
      "icon_name": "deathspawn_carrionling",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 5,
      "short_description": "When this champion is destroyed, a Death Carrionling champion with no upgrades is summoned in each space it occupied.",
      "long_description": "When this champion is destroyed, a Death Carrionling champion with no upgrades is summoned in each space it occupied.",
      "class_name": "DeathSpawnCarrionling",
      "revision": 1
    },
    {
      "asset_id": 4977,
      "resettable": 1,
      "name": "Death Spawn: Spiderling",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1859,
      "activated": 1,
      "icon_name": "deathspawn_spiderling",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 10,
      "short_description": "When this champion is destroyed, 2 Spiderling champions are summoned in the spaces it formerly occupied.",
      "long_description": "When this champion is destroyed, 2 Spiderling champions are summoned in the spaces it formerly occupied.",
      "class_name": "DeathSpawnSpiderling",
      "revision": 1
    },
    {
      "asset_id": 5351,
      "resettable": 1,
      "name": "Death Toll",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2183,
      "activated": 1,
      "icon_name": "death_toll",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -30,
      "short_description": "When this champion comes into play, the closest real champion you own is destroyed.  Otherwise, this champion is destroyed.",
      "long_description": "When this champion comes into play, the closest real champion you own is destroyed.  Otherwise, this champion is destroyed.",
      "class_name": "DeathToll",
      "revision": 1
    },
    {
      "asset_id": 4487,
      "resettable": 1,
      "name": "Death Touch",
      "ap_cost": 5,
      "level": 0,
      "ability_id": 889,
      "activated": 1,
      "icon_name": "lossoflife",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 20,
      "short_description": "Target champion within 2 spaces loses 50% of their current HP.",
      "long_description": "Target champion within 2 spaces loses 50% of their current HP.",
      "class_name": "DeathTouch",
      "revision": 1
    },
    {
      "asset_id": 5029,
      "resettable": 1,
      "name": "Debilitate",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1208,
      "activated": 1,
      "icon_name": "debuff",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 6,
      "short_description": "When this champion successfully damages a champion with a basic attack, if that champion does not have Debilitated, it becomes <condition value=debilitated>Debilitated</condition> for 6 turns. ",
      "long_description": "When this champion successfully damages a champion with a basic attack, if that champion does not have Debilitated, it becomes <condition value=debilitated>Debilitated</condition> for 6 turns. ",
      "class_name": "Debilitate",
      "revision": 1
    },
    {
      "asset_id": 5366,
      "resettable": 1,
      "name": "Decapitating Blow",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2198,
      "activated": 1,
      "icon_name": "decapitate",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 12,
      "short_description": "Target adjacent champion with less than 25% max HP is destroyed.",
      "long_description": "Target adjacent champion with less than 25% max HP is destroyed.",
      "class_name": "DecapitatingBlow",
      "revision": 1
    },
    {
      "asset_id": 4605,
      "resettable": 1,
      "name": "Decay",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1021,
      "activated": 1,
      "icon_name": "diseaseaoe",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "Opposing healing is reduced by 50%.",
      "long_description": "Opposing healing is reduced by 50%.",
      "class_name": "RelicDecayingHead",
      "revision": 1
    },
    {
      "asset_id": 4622,
      "resettable": 1,
      "name": "Deception",
      "ap_cost": 5,
      "level": 0,
      "ability_id": 1037,
      "activated": 1,
      "icon_name": "planar",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "This unit is relocated to target space within 5 spaces, 2 <condition value=illusion>Illusion</condition> copies of this champion are randomly spawned adjacent to target location.",
      "long_description": "This unit is relocated to target space within 5 spaces, 2 <condition value=illusion>Illusion</condition> copies of this champion are randomly spawned adjacent to target location.",
      "class_name": "Deception",
      "revision": 1
    },
    {
      "asset_id": 5606,
      "resettable": 1,
      "name": "Declare Hunted",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2465,
      "activated": 1,
      "icon_name": "hunted",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this unit is deployed from the runedock, the closest opposing champion becomes <condition value=tagged>Tagged</condition><ability value=3277> </ability> and permanently gains <ability value=2467>Hunted</ability>.",
      "long_description": "When this unit is deployed from the runedock, the closest opposing champion becomes <condition value=tagged>Tagged</condition><ability value=3277> </ability> and permanently gains <ability value=2467>Hunted</ability>.",
      "class_name": "DeclareEnemy",
      "revision": 1
    },
    {
      "asset_id": 4841,
      "resettable": 1,
      "name": "Declare Target",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 1723,
      "activated": 1,
      "icon_name": "declare_hunted",
      "comments": "Range 5",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "Target opposing champion within 5 spaces becomes  Declared as Target (This champion has been declared as a target. Enemy champions that attack it gain 3 AP on the first successful attack per turn) for 1 turn.",
      "long_description": "Target opposing champion within 5 spaces becomes  Declared as Target (This champion has been declared as a target. Enemy champions that attack it gain 3 AP on the first successful attack per turn) for 1 turn.",
      "class_name": "DeclareTarget",
      "revision": 1
    },
    {
      "asset_id": 7445,
      "resettable": 0,
      "name": "Declare Vengeance",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 3155,
      "activated": 1,
      "icon_name": "declare_vengeance",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 5,
      "short_description": "Target enemy champion within 5 spaces becomes Marked for Vengeance (When this champion is successfully attacked with a basic attack, it loses 3 HP.  If this champion is destroyed, the attacking champion gains +3 DMG for 6 turns.) until targets change.",
      "long_description": "Target enemy champion within 5 spaces becomes Marked for Vengeance (When this champion is successfully attacked with a basic attack, it loses 3 HP.  If this champion is destroyed, the attacking champion gains +3 DMG for 6 turns.) until targets change.",
      "class_name": "DeclareVengeance",
      "revision": 1
    },
    {
      "asset_id": 5279,
      "resettable": 1,
      "name": "Deconstruct",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2103,
      "activated": 1,
      "icon_name": "merge",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 4,
      "short_description": "This champion has <ability value=2101>Stitched</ability>. When this unit destroys an opposing champion, that unit does not drop a nora globe and a Stitched Remains relic is spawned in the location that champion occupied.",
      "long_description": "This champion has <ability value=2101>Stitched</ability>. When this unit destroys an opposing champion, that unit does not drop a nora globe and a Stitched Remains relic is spawned in the location that champion occupied.",
      "class_name": "Deconstruct",
      "revision": 1
    },
    {
      "asset_id": 5426,
      "resettable": 1,
      "name": "Deep Dive",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 2257,
      "activated": 1,
      "icon_name": "tunnel_dive",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "This ability may be activated only if this unit occupies water. This unit is relocated to target water space.",
      "long_description": "This ability may be activated only if this unit occupies water. This unit is relocated to target water space.",
      "class_name": "DeepDive",
      "revision": 1
    },
    {
      "asset_id": 4349,
      "resettable": 1,
      "name": "Deep Mine",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1383,
      "activated": 1,
      "icon_name": "noragen",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Deep Mine: This unit loses 50% of its HP permanently, but increases its Nora production by 5 per turn.",
      "long_description": "Deep Mine: This unit loses 50% of its HP permanently, but increases its Nora production by 5 per turn.",
      "class_name": "DeepMine",
      "revision": 1
    },
    {
      "asset_id": 4994,
      "resettable": 1,
      "name": "Deep Wounds",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1875,
      "activated": 1,
      "icon_name": "rend",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 8,
      "short_description": "Whenever this champion successfully damages an enemy champion with any attack, that champion becomes Wounded (This champion takes 35% additional damage from basic attacks made by champions with Deep Wounds.  This stacks up to 3 times) for 6 turns.",
      "long_description": "Whenever this champion successfully damages an enemy champion with any attack, that champion becomes Wounded (This champion takes 35% additional damage from basic attacks made by champions with Deep Wounds.  This stacks up to 3 times) for 6 turns.",
      "class_name": "DeepWounds",
      "revision": 1
    },
    {
      "asset_id": 5816,
      "resettable": 1,
      "name": "Defection",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2825,
      "activated": 1,
      "icon_name": "defection",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 15,
      "short_description": "This champion gains Wandering (At the beginning of your turn this unit moves 2 spaces randomly towards your enemies Shrine or Avatar. This unit cannot spend AP on movement.) and is <condition value=possessed>Possessed</condition> by target champion's controller for 2 turns. Target unit is Paralyzed while it possesses that champion.",
      "long_description": "This champion gains Wandering (At the beginning of your turn this unit moves 2 spaces randomly towards your enemies Shrine or Avatar. This unit cannot spend AP on movement.) and is <condition value=possessed>Possessed</condition> by target champion's controller for 2 turns. Target unit is Paralyzed while it possesses that champion.",
      "class_name": "Defection",
      "revision": 1
    },
    {
      "asset_id": 4012,
      "resettable": 1,
      "name": "Defender",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 31,
      "activated": 1,
      "icon_name": "defenseenhance",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 7,
      "short_description": "Friendly champions within 5 spaces that share a race or class with this champion has +2 DEF. This ability does not stack with other Defenders.",
      "long_description": "Friendly champions within 5 spaces that share a race or class with this champion has +2 DEF. This ability does not stack with other Defenders.",
      "class_name": "Defender",
      "revision": 1
    },
    {
      "asset_id": 4424,
      "resettable": 1,
      "name": "Defender of Chaos",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 762,
      "activated": 1,
      "icon_name": "shrinegood",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 4,
      "short_description": "When damage would be dealt to your Shrine, it is dealt to this unit instead.   Redirected damage cannot be reduced.",
      "long_description": "When damage would be dealt to your Shrine, it is dealt to this unit instead.   Redirected damage cannot be reduced.",
      "class_name": "DefenderOfChaos",
      "revision": 1
    },
    {
      "asset_id": 4424,
      "resettable": 1,
      "name": "Defender of Chaos",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 763,
      "activated": 1,
      "icon_name": "shrinegood",
      "comments": "",
      "prerequisite_id": 762,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 6,
      "short_description": "When damage would be dealt to your Shrine, it is dealt to this unit instead, and the damage is reduced by 2.   Redirected damage cannot be reduced.",
      "long_description": "When damage would be dealt to your Shrine, it is dealt to this unit instead, and the damage is reduced by 2.   Redirected damage cannot be reduced.",
      "class_name": "DefenderOfChaos",
      "revision": 1
    },
    {
      "asset_id": 5765,
      "resettable": 1,
      "name": "Defender of the Swamp",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2677,
      "activated": 1,
      "icon_name": "leap",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "This champion gains +1 DEF for 2 turns whenever a friendly champion within 6 spaces makes a successful basic attack.  If the attacking unit is a Boghopper, the effect lasts 4 turns instead.",
      "long_description": "This champion gains +1 DEF for 2 turns whenever a friendly champion within 6 spaces makes a successful basic attack.  If the attacking unit is a Boghopper, the effect lasts 4 turns instead.",
      "class_name": "DefenderOfTheSwamp",
      "revision": 1
    },
    {
      "asset_id": 5223,
      "resettable": 1,
      "name": "Defenseless",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2001,
      "activated": 1,
      "icon_name": "defpenalties",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -5,
      "short_description": "This unit takes 30% more damage from melee attacks. ",
      "long_description": "This unit takes 30% more damage from melee attacks. ",
      "class_name": "Defenseless",
      "revision": 1
    },
    {
      "asset_id": 4138,
      "resettable": 1,
      "name": "Defensive Stance",
      "ap_cost": 1,
      "level": 1,
      "ability_id": 354,
      "activated": 1,
      "icon_name": "buff",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 1,
      "short_description": "This champion has -2 DMG and +2 DEF for 4 turns.",
      "long_description": "This champion has -2 DMG and +2 DEF for 4 turns.",
      "class_name": "DefensiveStance",
      "revision": 1
    },
    {
      "asset_id": 4138,
      "resettable": 1,
      "name": "Defensive Stance",
      "ap_cost": 1,
      "level": 2,
      "ability_id": 355,
      "activated": 1,
      "icon_name": "buff",
      "comments": "none",
      "prerequisite_id": 354,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 2,
      "short_description": "This champion has -2 DMG and +3 DEF for 4 turns.",
      "long_description": "This champion has -2 DMG and +3 DEF for 4 turns.",
      "class_name": "DefensiveStance",
      "revision": 1
    },
    {
      "asset_id": 4138,
      "resettable": 1,
      "name": "Defensive Stance",
      "ap_cost": 1,
      "level": 3,
      "ability_id": 356,
      "activated": 1,
      "icon_name": "buff",
      "comments": "none",
      "prerequisite_id": 355,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 4,
      "short_description": "This champion has -2 DMG and +4 DEF for 4 turns.",
      "long_description": "This champion has -2 DMG and +4 DEF for 4 turns.",
      "class_name": "DefensiveStance",
      "revision": 1
    },
    {
      "asset_id": 4932,
      "resettable": 1,
      "name": "Defensive Strike",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1818,
      "activated": 1,
      "icon_name": "offenseenhance",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 5,
      "short_description": "For 4 turns, the first time a visible opposing champion moves into this champion's range, this champion makes a free basic attack against that champion. If this champion has no basic attack, it makes a Physical non-basic attack instead. This effect is hidden until triggered.",
      "long_description": "For 4 turns, the first time a visible opposing champion moves into this champion's range, this champion makes a free basic attack against that champion. If this champion has no basic attack, it makes a Physical non-basic attack instead. This effect is hidden until triggered.",
      "class_name": "DefensiveStrike",
      "revision": 1
    },
    {
      "asset_id": 5493,
      "resettable": 1,
      "name": "Defensive Turtle",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2352,
      "activated": 1,
      "icon_name": "turtle",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 4,
      "short_description": "The first time this champion's HP falls below 50% of its max HP, it becomes <condition value=turtled>Turtled</condition> for 1 turn, then this ability is removed.",
      "long_description": "The first time this champion's HP falls below 50% of its max HP, it becomes <condition value=turtled>Turtled</condition> for 1 turn, then this ability is removed.",
      "class_name": "DefensiveTurtle",
      "revision": 1
    },
    {
      "asset_id": 5030,
      "resettable": 1,
      "name": "Defiant",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1209,
      "activated": 1,
      "icon_name": "eater_rock",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this champion is successfully attacked it gains <ability value=868>Rock Eater</ability> for 2 turns.",
      "long_description": "When this champion is successfully attacked it gains <ability value=868>Rock Eater</ability> for 2 turns.",
      "class_name": "Defiant",
      "revision": 1
    },
    {
      "asset_id": 5698,
      "resettable": 1,
      "name": "Defiling Aura",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2575,
      "activated": 1,
      "icon_name": "defile_corpse",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 2,
      "short_description": "Opposing champions within 3 spaces are <condition value=defiled>Defiled</condition>.",
      "long_description": "Opposing champions within 3 spaces are <condition value=defiled>Defiled</condition>.",
      "class_name": "DefilingAura",
      "revision": 1
    },
    {
      "asset_id": 5518,
      "resettable": 1,
      "name": "Defiling Luminescence",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2377,
      "activated": 1,
      "icon_name": "defiling_luminesence",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "When this unit is deployed and at the start of its turns, opposing champions within 4 spaces become <condition value=cursed>Cursed</condition> for 2 turns and <condition value=defiled>Defiled</condition> for 2 turns.",
      "long_description": "When this unit is deployed and at the start of its turns, opposing champions within 4 spaces become <condition value=cursed>Cursed</condition> for 2 turns and <condition value=defiled>Defiled</condition> for 2 turns.",
      "class_name": "DefilingLuminescence",
      "revision": 1
    },
    {
      "asset_id": 4118,
      "resettable": 1,
      "name": "Deflect",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 295,
      "activated": 1,
      "icon_name": "deflect",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "Next time this unit takes damage from an attack made by target champion within 8 spaces, that damage is redirected to the nearest enemy within 8 spaces.  This effect is hidden until triggered. (You may target this unit to Deflect the damage from the next attack by any champion.)",
      "long_description": "Next time this unit takes damage from an attack made by target champion within 8 spaces, that damage is redirected to the nearest enemy within 8 spaces.  This effect is hidden until triggered. (You may target this unit to Deflect the damage from the next attack by any champion.)",
      "class_name": "Deflection",
      "revision": 1
    },
    {
      "asset_id": 4341,
      "resettable": 1,
      "name": "Deflect: Acid",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1369,
      "activated": 1,
      "icon_name": "deflect_acid",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "Next time this unit takes damage from an attack made by target champion within 8 spaces, that damage is redirected as Acid damage to the nearest enemy within 8 spaces. This effect is hidden until triggered. (You may target this unit to Deflect the damage from the next attack by any champion.)",
      "long_description": "Next time this unit takes damage from an attack made by target champion within 8 spaces, that damage is redirected as Acid damage to the nearest enemy within 8 spaces. This effect is hidden until triggered. (You may target this unit to Deflect the damage from the next attack by any champion.)",
      "class_name": "DeflectAcid",
      "revision": 1
    },
    {
      "asset_id": 4340,
      "resettable": 1,
      "name": "Deflect: Electric",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1368,
      "activated": 1,
      "icon_name": "deflect_electric",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "Next time this unit takes damage from an attack made by target champion within 8 spaces, that damage is redirected as Electric damage to the nearest enemy within 8 spaces. This effect is hidden until triggered. (You may target this unit to Deflect the damage from the next attack by any champion.)",
      "long_description": "Next time this unit takes damage from an attack made by target champion within 8 spaces, that damage is redirected as Electric damage to the nearest enemy within 8 spaces. This effect is hidden until triggered. (You may target this unit to Deflect the damage from the next attack by any champion.)",
      "class_name": "DeflectElectric",
      "revision": 1
    },
    {
      "asset_id": 4339,
      "resettable": 1,
      "name": "Deflect: Fire",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1367,
      "activated": 1,
      "icon_name": "deflect_fire",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "Next time this unit takes damage from an attack made by target champion within 8 spaces, that damage is redirected as Fire damage to the nearest enemy within 8 spaces. This effect is hidden until triggered. (You may target this unit to Deflect the damage from the next attack by any champion.)",
      "long_description": "Next time this unit takes damage from an attack made by target champion within 8 spaces, that damage is redirected as Fire damage to the nearest enemy within 8 spaces. This effect is hidden until triggered. (You may target this unit to Deflect the damage from the next attack by any champion.)",
      "class_name": "DeflectMagma",
      "revision": 1
    },
    {
      "asset_id": 4338,
      "resettable": 1,
      "name": "Deflect: Poison",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1366,
      "activated": 1,
      "icon_name": "deflect_poison",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "Next time this unit takes damage from an attack made by target champion within 8 spaces, that damage is redirected as Poison damage to the nearest enemy within 8 spaces. This effect is hidden until triggered. (You may target this unit to Deflect the damage from the next attack by any champion.)",
      "long_description": "Next time this unit takes damage from an attack made by target champion within 8 spaces, that damage is redirected as Poison damage to the nearest enemy within 8 spaces. This effect is hidden until triggered. (You may target this unit to Deflect the damage from the next attack by any champion.)",
      "class_name": "DeflectPoison",
      "revision": 1
    },
    {
      "asset_id": 4342,
      "resettable": 1,
      "name": "Deflect: Sand",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1370,
      "activated": 1,
      "icon_name": "deflect_sand",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "Next time this unit takes damage from an attack made by target champion within 8 spaces, that damage is redirected as Physical damage to the nearest enemy within 8 spaces. This effect is hidden until triggered. (You may target this unit to Deflect the damage from the next attack by any champion.)",
      "long_description": "Next time this unit takes damage from an attack made by target champion within 8 spaces, that damage is redirected as Physical damage to the nearest enemy within 8 spaces. This effect is hidden until triggered. (You may target this unit to Deflect the damage from the next attack by any champion.)",
      "class_name": "DeflectSand",
      "revision": 1
    },
    {
      "asset_id": 7185,
      "resettable": 0,
      "name": "Demolish",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3028,
      "activated": 1,
      "icon_name": "sacrifice",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "This unit destroys itself.",
      "long_description": "This unit destroys itself.",
      "class_name": "RelicDemolish",
      "revision": 1
    },
    {
      "asset_id": 4501,
      "resettable": 1,
      "name": "Demon Elf Bound",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 899,
      "activated": 1,
      "icon_name": "possess",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -8,
      "short_description": "At the beginning of your enemy's turns, if there are no other friendly Demon Elves in play, this unit is <condition value=possessed>Possessed</condition> by your enemy until end of turn.",
      "long_description": "At the beginning of your enemy's turns, if there are no other friendly Demon Elves in play, this unit is <condition value=possessed>Possessed</condition> by your enemy until end of turn.",
      "class_name": "DemonElfBound",
      "revision": 1
    },
    {
      "asset_id": 5297,
      "resettable": 1,
      "name": "Demon's Thirst",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2120,
      "activated": 1,
      "icon_name": "drain",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "This unit loses 10 HP and a blood globe worth 6 HP spawns in all adjacent squares.",
      "long_description": "This unit loses 10 HP and a blood globe worth 6 HP spawns in all adjacent squares.",
      "class_name": "DemonsThirst",
      "revision": 1
    },
    {
      "asset_id": 4437,
      "resettable": 1,
      "name": "Demonbound",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 785,
      "activated": 1,
      "icon_name": "disable",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -8,
      "short_description": "At the start of your turn, if there are no other friendly Demons in play, your Shrine or Avatar takes 5 magical damage.",
      "long_description": "At the start of your turn, if there are no other friendly Demons in play, your Shrine or Avatar takes 5 magical damage.",
      "class_name": "Demonbound",
      "revision": 1
    },
    {
      "asset_id": 5290,
      "resettable": 1,
      "name": "Demoralizing Descant",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 2113,
      "activated": 1,
      "icon_name": "dreadsong",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 5,
      "short_description": "Target champion within 5 spaces becomes Demoralized 4 (This champion has -2 DMG).  This effect stacks.  ",
      "long_description": "Target champion within 5 spaces becomes Demoralized 4 (This champion has -2 DMG).  This effect stacks.",
      "class_name": "DemoralizingDescant",
      "revision": 1
    },
    {
      "asset_id": 5451,
      "resettable": 1,
      "name": "Deploy Charged",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 2303,
      "activated": 1,
      "icon_name": "deploy_chrgd",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 5,
      "short_description": "When a champion is deployed from the runedock, this unit gains a charge.",
      "long_description": "When a champion is deployed from the runedock, this unit gains a charge.",
      "class_name": "DeployCharged",
      "revision": 1
    },
    {
      "asset_id": 5451,
      "resettable": 1,
      "name": "Deploy Charged",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 2318,
      "activated": 1,
      "icon_name": "deploy_chrgd",
      "comments": "",
      "prerequisite_id": 2303,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 10,
      "short_description": "When a champion is deployed from the runedock, this unit gains 2 charges.",
      "long_description": "When a champion is deployed from the runedock, this unit gains 2 charges.",
      "class_name": "DeployCharged",
      "revision": 1
    },
    {
      "asset_id": 5451,
      "resettable": 1,
      "name": "Deploy Charged",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 2319,
      "activated": 1,
      "icon_name": "deploy_chrgd",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 15,
      "short_description": "When a champion is deployed from the runedock, this unit gains 3 charges.",
      "long_description": "When a champion is deployed from the runedock, this unit gains 3 charges.",
      "class_name": "DeployCharged",
      "revision": 1
    },
    {
      "asset_id": 5640,
      "resettable": 1,
      "name": "Deploy Restricted",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2510,
      "activated": 1,
      "icon_name": "",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "This unit must be deployed in a deployment zone.",
      "long_description": "This unit must be deployed in a deployment zone.",
      "class_name": "DeployRestricted",
      "revision": 1
    },
    {
      "asset_id": 5814,
      "resettable": 1,
      "name": "Deploy: Flash Bomb (relic)",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2823,
      "activated": 1,
      "icon_name": "deploy",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 9,
      "short_description": "When this unit is deployed - All enemy champions within 2 spaces are Blinded 2 and this champion becomes Stealthed and is relocated to target space within 3 spaces. \r\n",
      "long_description": "When this unit is deployed - All enemy champions within 2 spaces are Blinded 2 (This unit's attacks automatically miss) and this champion becomes Stealthed (its location is hidden from your enemy) and is relocated to target space within 3 spaces. \r\n",
      "class_name": "DeployFlashBomb",
      "revision": 1
    },
    {
      "asset_id": 4842,
      "resettable": 1,
      "name": "Depression",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1724,
      "activated": 1,
      "icon_name": "debuff",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 2,
      "short_description": "Champions within 3 spaces of this unit have -2 DMG.",
      "long_description": "Champions within 3 spaces of this unit have -2 DMG.",
      "class_name": "Depression",
      "revision": 1
    },
    {
      "asset_id": 5618,
      "resettable": 1,
      "name": "Desecrate Earth",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2480,
      "activated": 1,
      "icon_name": "desecrate_earth",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "Area Effect 2, Range 5: Affected spaces becomes Desecrated Ground until the end of your next turn. (Desecrated Ground - At beginning of your turns and upon casting, champions without Race: Undead or Race: Spirit in this area lose 6 HP).",
      "long_description": "Area Effect 2, Range 5: Affected spaces becomes Desecrated Ground until the end of your next turn. (Desecrated Ground - At beginning of your turns and upon casting, champions without Race: Undead or Race: Spirit in this area lose 6 HP).",
      "class_name": "DesecrateEarth",
      "revision": 1
    },
    {
      "asset_id": 4901,
      "resettable": 1,
      "name": "Desecrated Zone",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 1617,
      "activated": 1,
      "icon_name": "terrain_dmz",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 4,
      "short_description": "Area Effect 1: Affected spaces are <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic>.",
      "long_description": "Area Effect 1: Affected spaces are <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic>.",
      "class_name": "DesecratedZone",
      "revision": 1
    },
    {
      "asset_id": 4901,
      "resettable": 1,
      "name": "Desecrated Zone",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 1618,
      "activated": 1,
      "icon_name": "terrain_dmz",
      "comments": "none",
      "prerequisite_id": 1617,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 6,
      "short_description": "Area Effect 2: Affected spaces are <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic>.",
      "long_description": "Area Effect 2: Affected spaces are <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic>.",
      "class_name": "DesecratedZone",
      "revision": 1
    },
    {
      "asset_id": 4901,
      "resettable": 1,
      "name": "Desecrated Zone",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 1619,
      "activated": 1,
      "icon_name": "terrain_dmz",
      "comments": "none",
      "prerequisite_id": 1618,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 8,
      "short_description": "Area Effect 3: Affected spaces are <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic>.",
      "long_description": "Area Effect 3: Affected spaces are <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic>.",
      "class_name": "DesecratedZone",
      "revision": 1
    },
    {
      "asset_id": 7313,
      "resettable": 0,
      "name": "Desert Brew",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3091,
      "activated": 1,
      "icon_name": "carouse",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 0,
      "short_description": "This unit is drinking a delicious Desert Brew from the 2015 Poxtoberfest!",
      "long_description": "This unit is drinking a delicious Desert Brew from the 2015 Poxtoberfest!",
      "class_name": "DesertBrewEffect",
      "revision": 1
    },
    {
      "asset_id": 4999,
      "resettable": 1,
      "name": "Desert Camouflage",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1907,
      "activated": 1,
      "icon_name": "camo",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 2,
      "short_description": "When this unit is damaged by a ranged attack while it is occupying Sand, that damage by is reduced by 2.",
      "long_description": "When this unit is damaged by a ranged attack while it is occupying Sand, that damage by is reduced by 2.",
      "class_name": "DesertCamouflage",
      "revision": 1
    },
    {
      "asset_id": 4998,
      "resettable": 1,
      "name": "Desert Front",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1879,
      "activated": 1,
      "icon_name": "terrainsand",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "At the beginning of each turn, all spaces within 3 spaces of this champion become Sand for 4 turns.",
      "long_description": "At the beginning of each turn, all spaces within 3 spaces of this champion become Sand for 4 turns.",
      "class_name": "DesertWalker",
      "revision": 1
    },
    {
      "asset_id": 4997,
      "resettable": 1,
      "name": "Desert Master",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1878,
      "activated": 1,
      "icon_name": "domain_sand",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "This champion has +1 DMG and +1 DEF for every 3 champions occupying sand terrain.",
      "long_description": "This champion has +1 DMG and +1 DEF for every 3 champions occupying sand terrain.",
      "class_name": "DesertMaster",
      "revision": 1
    },
    {
      "asset_id": 5755,
      "resettable": 1,
      "name": "Designate Flagbearer",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 2645,
      "activated": 1,
      "icon_name": "independent",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "Until target friendly champion within 3 spaces moves, it has <ability value=677>Overseer: Moga 2</ability>, <ability value=2479>Improve Speed</ability> and <ability value=1382>Prestige</ability>. Friendly champions within 5 spaces of it have <ability value=1377>Evasive 2</ability>. This affects a maximum of 1 target at a time.",
      "long_description": "Until target friendly champion within 3 spaces moves, it has <ability value=677>Overseer: Moga 2</ability>, <ability value=2479>Improve Speed</ability> and <ability value=1382>Prestige</ability>. Friendly champions within 5 spaces of it have <ability value=1377>Evasive 2</ability>. This affects a maximum of 1 target at a time.",
      "class_name": "DesignateFlagbearer",
      "revision": 1
    },
    {
      "asset_id": 5438,
      "resettable": 1,
      "name": "Designate Scapegoat",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2288,
      "activated": 1,
      "icon_name": "punishing_aura",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 5,
      "short_description": "Target friendly champion becomes the target of the next opposing spell. This effect is hidden until triggered.",
      "long_description": "Target friendly champion becomes the target of the next opposing spell. This effect is hidden until triggered.",
      "class_name": "DesignateScapegoat",
      "revision": 1
    },
    {
      "asset_id": 5520,
      "resettable": 1,
      "name": "Destabilizing Luminescence",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2379,
      "activated": 1,
      "icon_name": "destabilizing_luminesence",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "Spaces within 3 spaces of this unit are <mechanic value=unstableground>Unstable Ground</mechanic>",
      "long_description": "Spaces within 3 spaces of this unit are <mechanic value=unstableground>Unstable Ground</mechanic>",
      "class_name": "DestabilizingLuminescence",
      "revision": 1
    },
    {
      "asset_id": 4843,
      "resettable": 1,
      "name": "Destealth",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1725,
      "activated": 1,
      "icon_name": "stealth",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 1,
      "short_description": "This unit loses <condition value=stealthed>Stealthed</condition>.",
      "long_description": "This unit loses <condition value=stealthed>Stealthed</condition>.",
      "class_name": "Destealth",
      "revision": 1
    },
    {
      "asset_id": 4007,
      "resettable": 1,
      "name": "Detection",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 11,
      "activated": 1,
      "icon_name": "detection",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 1,
      "short_description": "Enemy units within 3 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 3 spaces are revealed.",
      "long_description": "Enemy units within 3 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 3 spaces are revealed.",
      "class_name": "Detection",
      "revision": 1
    },
    {
      "asset_id": 4007,
      "resettable": 1,
      "name": "Detection",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 12,
      "activated": 1,
      "icon_name": "detection",
      "comments": "none",
      "prerequisite_id": 11,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 2,
      "short_description": "Enemy units within 4 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 4 spaces are revealed.",
      "long_description": "Enemy units within 4 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 4 spaces are revealed.",
      "class_name": "Detection",
      "revision": 1
    },
    {
      "asset_id": 4007,
      "resettable": 1,
      "name": "Detection",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 13,
      "activated": 1,
      "icon_name": "detection",
      "comments": "none",
      "prerequisite_id": 12,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 3,
      "short_description": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
      "long_description": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
      "class_name": "Detection",
      "revision": 1
    },
    {
      "asset_id": 4629,
      "resettable": 1,
      "name": "Detonate",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 1049,
      "activated": 1,
      "icon_name": "auranegative",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "This unit is destroyed.",
      "long_description": "This unit is destroyed.",
      "class_name": "Detonate",
      "revision": 1
    },
    {
      "asset_id": 7389,
      "resettable": 0,
      "name": "Detonate Relic",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 3140,
      "activated": 1,
      "icon_name": "reclaim_materials",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 5,
      "short_description": "Target relic within 3 spaces is destroyed.  Other champions within 2 spaces of the relic take 12 Fire damage (ignores DEF).  If the target is a friendly relic, the CD of this ability is set to 2.",
      "long_description": "Target relic within 3 spaces is destroyed.  Other champions within 2 spaces of the relic take 12 Fire damage (ignores DEF).  If the target is a friendly relic, the CD of this ability is set to 2.",
      "class_name": "RepurposeRelic",
      "revision": 1
    },
    {
      "asset_id": 5831,
      "resettable": 1,
      "name": "Devotee of De'lim",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2840,
      "activated": 1,
      "icon_name": "devotee_delim",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "When a real Plant or Treefolk unit is destroyed, this unit gains 3 MAX HP and is healed for 6 HP.",
      "long_description": "When a real Plant or Treefolk unit is destroyed, this unit gains 3 MAX HP and is healed for 6 HP.",
      "class_name": "DevoteeDelim",
      "revision": 1
    },
    {
      "asset_id": 4844,
      "resettable": 1,
      "name": "Devour Life",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1726,
      "activated": 1,
      "icon_name": "devour",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -35,
      "short_description": "At the end of every other one of your turns, the champion with the lowest amount of health which is owned by this champion's owner is destroyed.",
      "long_description": "At the end of every other one of your turns, the champion with the lowest amount of health which is owned by this champion's owner is destroyed.",
      "class_name": "DevourLife",
      "revision": 1
    },
    {
      "asset_id": 4460,
      "resettable": 1,
      "name": "Devour Morsel",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 813,
      "activated": 1,
      "icon_name": "devour",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "<mechanic value=sacrifice>Sacrifice</mechanic> target adjacent unit with <ability value=812>Devourable</ability> and this unit heals HP equal to the HP of the sacrificed unit.",
      "long_description": "<mechanic value=sacrifice>Sacrifice</mechanic> target adjacent unit with <ability value=812>Devourable</ability> and this unit heals HP equal to the HP of the sacrificed unit.",
      "class_name": "DevourMorsel",
      "revision": 1
    },
    {
      "asset_id": 4459,
      "resettable": 1,
      "name": "Devourable",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 812,
      "activated": 1,
      "icon_name": "devour",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "Adjacent champions may sacrifice this unit and heal equal to its current health.",
      "long_description": "Adjacent champions may sacrifice this unit and heal equal to its current health.",
      "class_name": "Devourable",
      "revision": 1
    },
    {
      "asset_id": 5754,
      "resettable": 1,
      "name": "Dictate",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2642,
      "activated": 1,
      "icon_name": "dictate",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "Target friendly non-Illusion champion within 3 spaces loses 5 HP and this champion permanently gains +1 DMG and 2 AP.  This ability begins on CD.",
      "long_description": "Target friendly non-Illusion champion within 3 spaces loses 5 HP and this champion permanently gains +1 DMG and 2 AP.  This ability begins on CD.",
      "class_name": "Dictate",
      "revision": 1
    },
    {
      "asset_id": 5778,
      "resettable": 1,
      "name": "Dimension Door",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2698,
      "activated": 1,
      "icon_name": "relocate",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "Friendly Minotaurs gain <ability value=2699>Dimension Shift</ability>.",
      "long_description": "Friendly Minotaurs gain <ability value=2699>Dimension Shift</ability>.",
      "class_name": "DimensionDoor",
      "revision": 1
    },
    {
      "asset_id": 4151,
      "resettable": 1,
      "name": "Dimension Shift",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 2699,
      "activated": 1,
      "icon_name": "relocate",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "This champion is relocated to target space within 5 spaces. This ability may only target spaces within 2 spaces of a Dimension Door relic.",
      "long_description": "This champion is relocated to target space within 5 spaces. This ability may only target spaces within 2 spaces of a Dimension Door relic.",
      "class_name": "DimensionShift",
      "revision": 1
    },
    {
      "asset_id": 4550,
      "resettable": 1,
      "name": "Diplomat",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 944,
      "activated": 1,
      "icon_name": "diplomat",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 2,
      "short_description": "When this champion comes into play, the nearest enemy champion and the friendly real champion closest to it become <condition value=pacified>Pacified</condition> for 3 turns.",
      "long_description": "When this champion comes into play, the nearest enemy champion and the friendly real champion closest to it become <condition value=pacified>Pacified</condition> for 3 turns.",
      "class_name": "Diplomat",
      "revision": 1
    },
    {
      "asset_id": 5215,
      "resettable": 1,
      "name": "Dirge's Guard",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1992,
      "activated": 1,
      "icon_name": "revere",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "While Dirge, Moga Lord is in play, this champion gets +5 HP, +3 DMG and Bodyguard.",
      "long_description": "While Dirge, Moga Lord is in play, this champion gets +5 HP, +3 DMG and Bodyguard.",
      "class_name": "DirgesGuard",
      "revision": 1
    },
    {
      "asset_id": 7301,
      "resettable": 0,
      "name": "Disbelief",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3086,
      "activated": 1,
      "icon_name": "shattered_dreams",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 2,
      "short_description": "When this champion is deployed, enemy illusions and summoned units takes 10 Magic damage.",
      "long_description": "When this champion is deployed, enemy illusions and summoned units takes 10 Magic damage.",
      "class_name": "Disbelief",
      "revision": 1
    },
    {
      "asset_id": 5216,
      "resettable": 1,
      "name": "Disciple of the Scale",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1993,
      "activated": 1,
      "icon_name": "revere",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "While Vindrax is in play, this champion gains <ability value=1465>Instigate</ability> and <ability value=1786>Ritual of Destruction</ability>.  While Valdac is in play, this champion gains <ability value=371>Heal Mass 2</ability> and <ability value=3107>Ritual of Healing</ability>.",
      "long_description": "While Vindrax is in play, this champion gains <ability value=1465>Instigate</ability> and <ability value=1786>Ritual of Destruction</ability>.  While Valdac is in play, this champion gains <ability value=371>Heal Mass 2</ability> and <ability value=3107>Ritual of Healing</ability>.",
      "class_name": "Disciple",
      "revision": 1
    },
    {
      "asset_id": 5711,
      "resettable": 1,
      "name": "Disciple's Rapture",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2809,
      "activated": 1,
      "icon_name": "sacrificial_power",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 5,
      "short_description": "6 turns after deployment, this champion gains Manic and Intimidating.",
      "long_description": "6 turns after deployment, this champion gains Manic and Intimidating.",
      "class_name": "DisciplesRapture",
      "revision": 1
    },
    {
      "asset_id": 5577,
      "resettable": 1,
      "name": "Discipline",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2437,
      "activated": 1,
      "icon_name": "comboatk_slam",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "When this champion would be destroyed by damage from an attack, this champion is left with 1 hp and any excess damage transferred to the nearest friendly champion with Discipline within 5 spaces that would not be destroyed by the damage.  If there are no valid targets, this champion is destroyed instead.  ",
      "long_description": "When this champion would be destroyed by damage from an attack, this champion is left with 1 hp and any excess damage transferred to the nearest friendly champion with Discipline within 5 spaces that would not be destroyed by the damage.  If there are no valid targets, this champion is destroyed instead.",
      "class_name": "Discipline",
      "revision": 1
    },
    {
      "asset_id": 7357,
      "resettable": 0,
      "name": "Discovery",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3114,
      "activated": 1,
      "icon_name": "illuminate_unit",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "When an enemy champion is deployed, it becomes <condition value=illuminated>Illuminated</condition> for 4 turns.",
      "long_description": "When an enemy champion is deployed, it becomes <condition value=illuminated>Illuminated</condition> for 4 turns.",
      "class_name": "Discovery",
      "revision": 1
    },
    {
      "asset_id": 4082,
      "resettable": 1,
      "name": "Disease Aura",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 155,
      "activated": 1,
      "icon_name": "novadisease",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 2,
      "short_description": "At the beginning of your opponent's turns, this unit deals 2 Disease damage to each champion within 2 spaces. This damage ignores DEF.",
      "long_description": "At the beginning of your opponent's turns, this unit deals 2 Disease damage to each champion within 2 spaces. This damage ignores DEF.",
      "class_name": "DamagingAuraDisease",
      "revision": 1
    },
    {
      "asset_id": 4082,
      "resettable": 1,
      "name": "Disease Aura",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 156,
      "activated": 1,
      "icon_name": "novadisease",
      "comments": "none",
      "prerequisite_id": 155,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 4,
      "short_description": "At the beginning of your opponent's turns, this unit deals 4 Disease damage to each champion within 2 spaces. This damage ignores DEF.",
      "long_description": "At the beginning of your opponent's turns, this unit deals 4 Disease damage to each champion within 2 spaces. This damage ignores DEF.",
      "class_name": "DamagingAuraDisease",
      "revision": 1
    },
    {
      "asset_id": 4082,
      "resettable": 1,
      "name": "Disease Aura",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 157,
      "activated": 1,
      "icon_name": "novadisease",
      "comments": "none",
      "prerequisite_id": 156,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 6,
      "short_description": "At the beginning of your opponent's turns, this unit deals 6 Disease damage to each champion within 2 spaces. This damage ignores DEF.",
      "long_description": "At the beginning of your opponent's turns, this unit deals 6 Disease damage to each champion within 2 spaces. This damage ignores DEF.",
      "class_name": "DamagingAuraDisease",
      "revision": 1
    },
    {
      "asset_id": 4699,
      "resettable": 1,
      "name": "Disease Breath",
      "ap_cost": 1,
      "level": 1,
      "ability_id": 1144,
      "activated": 1,
      "icon_name": "diseaseaoe",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 6,
      "short_description": "Area Effect 2, Range 5: Affected units take Disease damage equal to 50% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=diseased>Diseased</condition> for 2 turns. ",
      "long_description": "Area Effect 2, Range 5: Affected units take Disease damage equal to 50% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=diseased>Diseased</condition> for 2 turns. ",
      "class_name": "DiseaseBreath",
      "revision": 1
    },
    {
      "asset_id": 4699,
      "resettable": 1,
      "name": "Disease Breath",
      "ap_cost": 1,
      "level": 2,
      "ability_id": 1145,
      "activated": 1,
      "icon_name": "diseaseaoe",
      "comments": "",
      "prerequisite_id": 1144,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 8,
      "short_description": "Area Effect 2, Range 5: Affected units take Disease damage equal to 65% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=diseased>Diseased</condition> for 2 turns. ",
      "long_description": "Area Effect 2, Range 5: Affected units take Disease damage equal to 65% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=diseased>Diseased</condition> for 2 turns. ",
      "class_name": "DiseaseBreath",
      "revision": 1
    },
    {
      "asset_id": 4699,
      "resettable": 1,
      "name": "Disease Breath",
      "ap_cost": 1,
      "level": 3,
      "ability_id": 1146,
      "activated": 1,
      "icon_name": "diseaseaoe",
      "comments": "",
      "prerequisite_id": 1145,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 10,
      "short_description": "Area Effect 2, Range 5: Affected units take Disease damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=diseased>Diseased</condition> for 2 turns. ",
      "long_description": "Area Effect 2, Range 5: Affected units take Disease damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=diseased>Diseased</condition> for 2 turns. ",
      "class_name": "DiseaseBreath",
      "revision": 1
    },
    {
      "asset_id": 5032,
      "resettable": 1,
      "name": "Disease Eater",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1211,
      "activated": 1,
      "icon_name": "eater_disease",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this champion would take Disease damage, it instead heals HP equal to half the damage that would have been dealt. This unit cannot be <condition value=diseased>Diseased</condition>.",
      "long_description": "When this champion would take Disease damage, it instead heals HP equal to half the damage that would have been dealt. This unit cannot be <condition value=diseased>Diseased</condition>.",
      "class_name": "DiseaseEater",
      "revision": 1
    },
    {
      "asset_id": 4433,
      "resettable": 1,
      "name": "Dismount",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 779,
      "activated": 1,
      "icon_name": "rider",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 3,
      "short_description": "Select an unoccupied adjacent space. Part of this unit is dismounted onto that space.",
      "long_description": "Select an unoccupied adjacent space. Part of this unit is dismounted onto that space.",
      "class_name": "Dismount",
      "revision": 1
    },
    {
      "asset_id": 4557,
      "resettable": 1,
      "name": "Dispel",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 1452,
      "activated": 1,
      "icon_name": "dispel",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "Target champion within 5 spaces is <mechanic value=dispelled>Dispelled</mechanic>. May target self.",
      "long_description": "Target champion within 5 spaces is <mechanic value=dispelled>Dispelled</mechanic>. May target self.",
      "class_name": "Dispel",
      "revision": 1
    },
    {
      "asset_id": 7160,
      "resettable": 0,
      "name": "Dispelling Blows",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3003,
      "activated": 1,
      "icon_name": "dispelling_blows",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 7,
      "short_description": "When this champion successfully attacks a champion with a basic attack, the target is <mechanic value=dispelled>Dispelled</mechanic>.",
      "long_description": "When this champion successfully attacks a champion with a basic attack, the target is <mechanic value=dispelled>Dispelled</mechanic>.",
      "class_name": "DispellingBlows",
      "revision": 1
    },
    {
      "asset_id": 4287,
      "resettable": 1,
      "name": "Disperse",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 706,
      "activated": 1,
      "icon_name": "tactician",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "This champion becomes three small units: the Moga Axeman, the Moga Shieldman and the Moga Crossbowman.",
      "long_description": "This champion becomes three small units: the Moga Axeman, the Moga Shieldman and the Moga Crossbowman.",
      "class_name": "Disperse",
      "revision": 1
    },
    {
      "asset_id": 5033,
      "resettable": 1,
      "name": "Dissipate",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1212,
      "activated": 1,
      "icon_name": "arrow",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -6,
      "short_description": "Ranged attacks made by this champion have a penalty of -2 DMG for each space the target is beyond the champion's minimum range (to a maximum of -4 DMG).",
      "long_description": "Ranged attacks made by this champion have a penalty of -2 DMG for each space the target is beyond the champion's minimum range (to a maximum of -4 DMG).",
      "class_name": "Dissipate",
      "revision": 1
    },
    {
      "asset_id": 5759,
      "resettable": 1,
      "name": "Distichous: FS/UD",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2789,
      "activated": 1,
      "icon_name": "distichous",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "When an FS champion is deployed from the runedock, this champion gains <ability value=1317>Absorb</ability> for 4 turns. When a UD champion is deployed from the runedock, this champion gains <ability value=99>Life Siphon</ability> for 4 turns.",
      "long_description": "When an FS champion is deployed from the runedock, this champion gains <ability value=1317>Absorb</ability> for 4 turns. When a UD champion is deployed from the runedock, this champion gains <ability value=99>Life Siphon</ability> for 4 turns.",
      "class_name": "DistichousFSUD",
      "revision": 1
    },
    {
      "asset_id": 5759,
      "resettable": 1,
      "name": "Distichous: IS/SP",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2735,
      "activated": 1,
      "icon_name": "distichous",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 12,
      "short_description": "When an IS champion is deployed from the runedock, this champion gains <ability value=1006>Surge: Enemy</ability> for 4 turns. When an SP champion is deployed from the runedock, this champion gains <ability value=1199>Calcify</ability> for 4 turns.",
      "long_description": "When an IS champion is deployed from the runedock, this champion gains <ability value=1006>Surge: Enemy</ability> for 4 turns. When an SP champion is deployed from the runedock, this champion gains <ability value=1199>Calcify</ability> for 4 turns.",
      "class_name": "DistichousISSP",
      "revision": 1
    },
    {
      "asset_id": 5759,
      "resettable": 1,
      "name": "Distichous: KF/FW",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2745,
      "activated": 1,
      "icon_name": "distichous",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "When a KF champion is deployed from the runedock, this champion gains <ability value=1237>Impenetrable</ability> for 4 turns. When an FW champion is deployed from the runedock, this champion gains <ability value=1850>Frightful Blows</ability> for 4 turns.",
      "long_description": "When a KF champion is deployed from the runedock, this champion gains <ability value=1237>Impenetrable</ability> for 4 turns. When an FW champion is deployed from the runedock, this champion gains <ability value=1850>Frightful Blows</ability> for 4 turns.",
      "class_name": "DistichousKFFW",
      "revision": 1
    },
    {
      "asset_id": 5759,
      "resettable": 1,
      "name": "Distichous: ST/SL",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2770,
      "activated": 1,
      "icon_name": "distichous",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "When an ST champion is deployed from the runedock, this champion gains <ability value=1744>Frost Acolyte</ability> and <ability value=135>Frost Aura 1</ability> for 4 turns.  When an SL champion is deployed from the runedock, this champion gains <ability value=1908>Fire Acolyte</ability> and <ability value=131>Fire Aura 1</ability> for 4 turns.",
      "long_description": "When an ST champion is deployed from the runedock, this champion gains <ability value=1744>Frost Acolyte</ability> and <ability value=135>Frost Aura 1</ability> for 4 turns.  When an SL champion is deployed from the runedock, this champion gains <ability value=1908>Fire Acolyte</ability> and <ability value=131>Fire Aura 1</ability> for 4 turns.",
      "class_name": "DistichousSTSL",
      "revision": 1
    },
    {
      "asset_id": 5188,
      "resettable": 1,
      "name": "Distracting Blows",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1965,
      "activated": 1,
      "icon_name": "distract",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
      "long_description": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
      "class_name": "DistractingBlows",
      "revision": 1
    },
    {
      "asset_id": 5728,
      "resettable": 1,
      "name": "Distracting Luminescence",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2615,
      "activated": 1,
      "icon_name": "destabilizing_luminesence",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 8,
      "short_description": "This unit has <ability value=1807>Deafening Aura</ability>",
      "long_description": "This unit has <ability value=1807>Deafening Aura</ability>",
      "class_name": "DistractingLuminescence",
      "revision": 1
    },
    {
      "asset_id": 4384,
      "resettable": 1,
      "name": "Dive",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 1405,
      "activated": 1,
      "icon_name": "tunnel_dive",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 1,
      "cost": 4,
      "short_description": "This unit is relocated to target water space within 6 spaces.",
      "long_description": "This unit is relocated to target water space within 6 spaces.",
      "class_name": "Dive",
      "revision": 1
    },
    {
      "asset_id": 4384,
      "resettable": 1,
      "name": "Dive",
      "ap_cost": 4,
      "level": 2,
      "ability_id": 1406,
      "activated": 1,
      "icon_name": "tunnel_dive",
      "comments": "",
      "prerequisite_id": 1405,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 1,
      "cost": 4,
      "short_description": "This ability may be activated only if this unit occupies water. This unit is relocated to target water space within 6 spaces.",
      "long_description": "This ability may be activated only if this unit occupies water. This unit is relocated to target water space within 6 spaces.",
      "class_name": "Dive",
      "revision": 1
    },
    {
      "asset_id": 4384,
      "resettable": 1,
      "name": "Dive",
      "ap_cost": 4,
      "level": 3,
      "ability_id": 1407,
      "activated": 1,
      "icon_name": "tunnel_dive",
      "comments": "",
      "prerequisite_id": 1406,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 1,
      "cost": 6,
      "short_description": "This ability may be activated only if this unit occupies water. This unit is relocated to target water space within 7 spaces.",
      "long_description": "This ability may be activated only if this unit occupies water. This unit is relocated to target water space within 7 spaces.",
      "class_name": "Dive",
      "revision": 1
    },
    {
      "asset_id": 4846,
      "resettable": 1,
      "name": "Divert",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1728,
      "activated": 1,
      "icon_name": "deflect",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "For 4 turns, the next time target friendly champion takes damage from an attack, that damage is redirected to the nearest opponent within 8 spaces.  This effect is hidden until triggered.",
      "long_description": "For 4 turns, the next time target friendly champion takes damage from an attack, that damage is redirected to the nearest opponent within 8 spaces.  This effect is hidden until triggered.",
      "class_name": "Divert",
      "revision": 1
    },
    {
      "asset_id": 4902,
      "resettable": 1,
      "name": "Divine Binding",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 1626,
      "activated": 1,
      "icon_name": "disable",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 2,
      "short_description": "Disengaging from this champion deals 10 Physical damage to the disengaging champion. This damage ignores DEF. Spells and abilities that relocate another unit do not trigger Divine Binding.",
      "long_description": "Disengaging from this champion deals 10 Physical damage to the disengaging champion. This damage ignores DEF. Spells and abilities that relocate another unit do not trigger Divine Binding.",
      "class_name": "DivineBinding",
      "revision": 1
    },
    {
      "asset_id": 4902,
      "resettable": 1,
      "name": "Divine Binding",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 1628,
      "activated": 1,
      "icon_name": "disable",
      "comments": "none",
      "prerequisite_id": 1626,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 2,
      "short_description": "Disengaging from this champion deals 11 Physical damage to the disengaging champion. This damage ignores DEF. Spells and abilities that relocate another unit do not trigger Divine Binding.",
      "long_description": "Disengaging from this champion deals 11 Physical damage to the disengaging champion. This damage ignores DEF. Spells and abilities that relocate another unit do not trigger Divine Binding.",
      "class_name": "DivineBinding",
      "revision": 1
    },
    {
      "asset_id": 4902,
      "resettable": 1,
      "name": "Divine Binding",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 1630,
      "activated": 1,
      "icon_name": "disable",
      "comments": "none",
      "prerequisite_id": 1628,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 2,
      "short_description": "Disengaging from this champion deals 12 Physical damage to the disengaging champion. This damage ignores DEF. Spells and abilities that relocate another unit do not trigger Divine Binding.",
      "long_description": "Disengaging from this champion deals 12 Physical damage to the disengaging champion. This damage ignores DEF. Spells and abilities that relocate another unit do not trigger Divine Binding.",
      "class_name": "DivineBinding",
      "revision": 1
    },
    {
      "asset_id": 4902,
      "resettable": 1,
      "name": "Divine Binding",
      "ap_cost": 0,
      "level": 4,
      "ability_id": 1631,
      "activated": 1,
      "icon_name": "disable",
      "comments": "none",
      "prerequisite_id": 1630,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 2,
      "short_description": "Disengaging from this champion deals 13 Physical damage to the disengaging champion. This damage ignores DEF. Spells and abilities that relocate another unit do not trigger Divine Binding.",
      "long_description": "Disengaging from this champion deals 13 Physical damage to the disengaging champion. This damage ignores DEF. Spells and abilities that relocate another unit do not trigger Divine Binding.",
      "class_name": "DivineBinding",
      "revision": 1
    },
    {
      "asset_id": 4902,
      "resettable": 1,
      "name": "Divine Binding",
      "ap_cost": 0,
      "level": 5,
      "ability_id": 1632,
      "activated": 1,
      "icon_name": "disable",
      "comments": "none",
      "prerequisite_id": 1631,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 2,
      "short_description": "Disengaging from this champion deals 14 Physical damage to the disengaging champion. This damage ignores DEF. Spells and abilities that relocate another unit do not trigger Divine Binding.",
      "long_description": "Disengaging from this champion deals 14 Physical damage to the disengaging champion. This damage ignores DEF. Spells and abilities that relocate another unit do not trigger Divine Binding.",
      "class_name": "DivineBinding",
      "revision": 1
    },
    {
      "asset_id": 4902,
      "resettable": 1,
      "name": "Divine Binding",
      "ap_cost": 0,
      "level": 6,
      "ability_id": 1633,
      "activated": 1,
      "icon_name": "disable",
      "comments": "none",
      "prerequisite_id": 1632,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 2,
      "short_description": "Disengaging from this champion deals 15 Physical damage to the disengaging champion. This damage ignores DEF. Spells and abilities that relocate another unit do not trigger Divine Binding.",
      "long_description": "Disengaging from this champion deals 15 Physical damage to the disengaging champion. This damage ignores DEF. Spells and abilities that relocate another unit do not trigger Divine Binding.",
      "class_name": "DivineBinding",
      "revision": 1
    },
    {
      "asset_id": 4799,
      "resettable": 1,
      "name": "Divine Blessing",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 1536,
      "activated": 1,
      "icon_name": "divine",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 5,
      "short_description": "When this unit comes into play, all friendly champions are healed for 5.",
      "long_description": "When this unit comes into play, all friendly champions are healed for 5.",
      "class_name": "DivineBlessing",
      "revision": 1
    },
    {
      "asset_id": 4799,
      "resettable": 1,
      "name": "Divine Blessing",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 1537,
      "activated": 1,
      "icon_name": "divine",
      "comments": "none",
      "prerequisite_id": 1536,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 5,
      "short_description": "When this unit comes into play, all friendly champions are healed for 6.",
      "long_description": "When this unit comes into play, all friendly champions are healed for 6.",
      "class_name": "DivineBlessing",
      "revision": 1
    },
    {
      "asset_id": 4799,
      "resettable": 1,
      "name": "Divine Blessing",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 1538,
      "activated": 1,
      "icon_name": "divine",
      "comments": "none",
      "prerequisite_id": 1537,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 5,
      "short_description": "When this unit comes into play, all friendly champions are healed for 7.",
      "long_description": "When this unit comes into play, all friendly champions are healed for 7.",
      "class_name": "DivineBlessing",
      "revision": 1
    },
    {
      "asset_id": 4799,
      "resettable": 1,
      "name": "Divine Blessing",
      "ap_cost": 0,
      "level": 4,
      "ability_id": 1539,
      "activated": 1,
      "icon_name": "divine",
      "comments": "none",
      "prerequisite_id": 1538,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 5,
      "short_description": "When this unit comes into play, all friendly champions are healed for 8.",
      "long_description": "When this unit comes into play, all friendly champions are healed for 8.",
      "class_name": "DivineBlessing",
      "revision": 1
    },
    {
      "asset_id": 4799,
      "resettable": 1,
      "name": "Divine Blessing",
      "ap_cost": 0,
      "level": 5,
      "ability_id": 1540,
      "activated": 1,
      "icon_name": "divine",
      "comments": "none",
      "prerequisite_id": 1539,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 5,
      "short_description": "When this unit comes into play, all friendly champions are healed for 9.",
      "long_description": "When this unit comes into play, all friendly champions are healed for 9.",
      "class_name": "DivineBlessing",
      "revision": 1
    },
    {
      "asset_id": 4799,
      "resettable": 1,
      "name": "Divine Blessing",
      "ap_cost": 0,
      "level": 6,
      "ability_id": 1541,
      "activated": 1,
      "icon_name": "divine",
      "comments": "none",
      "prerequisite_id": 1540,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 5,
      "short_description": "When this unit comes into play, all friendly champions are healed for 10.",
      "long_description": "When this unit comes into play, all friendly champions are healed for 10.",
      "class_name": "DivineBlessing",
      "revision": 1
    },
    {
      "asset_id": 4120,
      "resettable": 1,
      "name": "Divine Favor",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 303,
      "activated": 1,
      "icon_name": "divine",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 7,
      "short_description": "When this unit is deployed, friendly champions heal 4 HP.",
      "long_description": "When this unit is deployed, friendly champions heal 4 HP.",
      "class_name": "DivineFavor",
      "revision": 1
    },
    {
      "asset_id": 4120,
      "resettable": 1,
      "name": "Divine Favor",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 304,
      "activated": 1,
      "icon_name": "divine",
      "comments": "none",
      "prerequisite_id": 303,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 11,
      "short_description": "When this unit is deployed, friendly champions heal 8 HP.",
      "long_description": "When this unit is deployed, friendly champions heal 8 HP.",
      "class_name": "DivineFavor",
      "revision": 1
    },
    {
      "asset_id": 4120,
      "resettable": 1,
      "name": "Divine Favor",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 305,
      "activated": 1,
      "icon_name": "divine",
      "comments": "none",
      "prerequisite_id": 304,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 15,
      "short_description": "When this unit is deployed, friendly champions heal 12 HP.",
      "long_description": "When this unit is deployed, friendly champions heal 12 HP.",
      "class_name": "DivineFavor",
      "revision": 1
    },
    {
      "asset_id": 4802,
      "resettable": 1,
      "name": "Divine Healing",
      "ap_cost": 3,
      "level": 3,
      "ability_id": 2039,
      "activated": 1,
      "icon_name": "heal",
      "comments": "none",
      "prerequisite_id": 1555,
      "cooldown": 6,
      "activation_type": 1,
      "ranked": 1,
      "cost": 10,
      "short_description": "Target champion within 4 spaces is healed for 40% their base HP.",
      "long_description": "Target champion within 4 spaces is healed for 40% their base HP.",
      "class_name": "DivineHealing",
      "revision": 1
    },
    {
      "asset_id": 4802,
      "resettable": 1,
      "name": "Divine Healing",
      "ap_cost": 3,
      "level": 1,
      "ability_id": 1554,
      "activated": 1,
      "icon_name": "heal",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 6,
      "activation_type": 1,
      "ranked": 1,
      "cost": 10,
      "short_description": "Target champion within 4 spaces is healed for 25% their base HP.",
      "long_description": "Target champion within 4 spaces is healed for 25% their base HP.",
      "class_name": "DivineHealing",
      "revision": 1
    },
    {
      "asset_id": 4802,
      "resettable": 1,
      "name": "Divine Healing",
      "ap_cost": 3,
      "level": 2,
      "ability_id": 1555,
      "activated": 1,
      "icon_name": "heal",
      "comments": "none",
      "prerequisite_id": 1554,
      "cooldown": 6,
      "activation_type": 1,
      "ranked": 1,
      "cost": 10,
      "short_description": "Target champion within 4 spaces is healed for 25% their base HP.",
      "long_description": "Target champion within 4 spaces is healed for 25% their base HP.",
      "class_name": "DivineHealing",
      "revision": 1
    },
    {
      "asset_id": 4910,
      "resettable": 1,
      "name": "Divine Regeneration",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 1681,
      "activated": 1,
      "icon_name": "cleanse",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 2,
      "short_description": "At the beginning of your turn, this unit heals 1 HP.\r\n",
      "long_description": "At the beginning of your turn, this unit heals 1 HP.\r\n\r\n",
      "class_name": "DivineRegeneration",
      "revision": 1
    },
    {
      "asset_id": 4910,
      "resettable": 1,
      "name": "Divine Regeneration",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 1682,
      "activated": 1,
      "icon_name": "cleanse",
      "comments": "none",
      "prerequisite_id": 1681,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 2,
      "short_description": "At the beginning of your turn, this unit heals 2 HP.\r\n",
      "long_description": "At the beginning of your turn, this unit heals 2 HP.\r\n",
      "class_name": "DivineRegeneration",
      "revision": 1
    },
    {
      "asset_id": 4910,
      "resettable": 1,
      "name": "Divine Regeneration",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 1683,
      "activated": 1,
      "icon_name": "cleanse",
      "comments": "none",
      "prerequisite_id": 1682,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 2,
      "short_description": "At the beginning of your turn, this unit gains 3 HP.\r\n",
      "long_description": "At the beginning of your turn, this unit gains 3 HP.\r\n",
      "class_name": "DivineRegeneration",
      "revision": 1
    },
    {
      "asset_id": 4910,
      "resettable": 1,
      "name": "Divine Regeneration",
      "ap_cost": 0,
      "level": 4,
      "ability_id": 1684,
      "activated": 1,
      "icon_name": "cleanse",
      "comments": "none",
      "prerequisite_id": 1683,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 2,
      "short_description": "At the beginning of your turn, this unit gains 4 HP.",
      "long_description": "At the beginning of your turn, this unit gains 4 HP.\r\n",
      "class_name": "DivineRegeneration",
      "revision": 1
    },
    {
      "asset_id": 4910,
      "resettable": 1,
      "name": "Divine Regeneration",
      "ap_cost": 0,
      "level": 5,
      "ability_id": 1685,
      "activated": 1,
      "icon_name": "cleanse",
      "comments": "none",
      "prerequisite_id": 1684,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 2,
      "short_description": "At the beginning of your turn, this unit gains 5 HP.",
      "long_description": "At the beginning of your turn, this unit gains 5 HP.\r\n",
      "class_name": "DivineRegeneration",
      "revision": 1
    },
    {
      "asset_id": 4910,
      "resettable": 1,
      "name": "Divine Regeneration",
      "ap_cost": 0,
      "level": 6,
      "ability_id": 1686,
      "activated": 1,
      "icon_name": "cleanse",
      "comments": "none",
      "prerequisite_id": 1685,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 2,
      "short_description": "At the beginning of your turn, this unit gains 6 HP.\r\n",
      "long_description": "At the beginning of your turn, this unit gains 6 HP.\r\n",
      "class_name": "DivineRegeneration",
      "revision": 1
    },
    {
      "asset_id": 4800,
      "resettable": 1,
      "name": "Divine Shield",
      "ap_cost": 3,
      "level": 1,
      "ability_id": 1542,
      "activated": 1,
      "icon_name": "tgtdefensive",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 10,
      "activation_type": 1,
      "ranked": 1,
      "cost": 6,
      "short_description": "This champion becomes <condition value=impervious>Impervious</condition> for 2 turns.",
      "long_description": "This champion becomes <condition value=impervious>Impervious</condition> for 2 turns.",
      "class_name": "DivineShield",
      "revision": 1
    },
    {
      "asset_id": 4800,
      "resettable": 1,
      "name": "Divine Shield",
      "ap_cost": 3,
      "level": 2,
      "ability_id": 1543,
      "activated": 1,
      "icon_name": "tgtdefensive",
      "comments": "",
      "prerequisite_id": 1542,
      "cooldown": 9,
      "activation_type": 1,
      "ranked": 1,
      "cost": 6,
      "short_description": "This champion becomes <condition value=impervious>Impervious</condition> for 2 turns.",
      "long_description": "This champion becomes <condition value=impervious>Impervious</condition> for 2 turns.",
      "class_name": "DivineShield",
      "revision": 1
    },
    {
      "asset_id": 4800,
      "resettable": 1,
      "name": "Divine Shield",
      "ap_cost": 3,
      "level": 3,
      "ability_id": 1544,
      "activated": 1,
      "icon_name": "tgtdefensive",
      "comments": "",
      "prerequisite_id": 1543,
      "cooldown": 8,
      "activation_type": 1,
      "ranked": 1,
      "cost": 6,
      "short_description": "This champion becomes <condition value=impervious>Impervious</condition> for 2 turns.",
      "long_description": "This champion becomes <condition value=impervious>Impervious</condition> for 2 turns.",
      "class_name": "DivineShield",
      "revision": 1
    },
    {
      "asset_id": 4800,
      "resettable": 1,
      "name": "Divine Shield",
      "ap_cost": 3,
      "level": 4,
      "ability_id": 1545,
      "activated": 1,
      "icon_name": "tgtdefensive",
      "comments": "",
      "prerequisite_id": 1544,
      "cooldown": 7,
      "activation_type": 1,
      "ranked": 1,
      "cost": 6,
      "short_description": "This champion becomes <condition value=impervious>Impervious</condition> for 2 turns.",
      "long_description": "This champion becomes <condition value=impervious>Impervious</condition> for 2 turns.",
      "class_name": "DivineShield",
      "revision": 1
    },
    {
      "asset_id": 4800,
      "resettable": 1,
      "name": "Divine Shield",
      "ap_cost": 3,
      "level": 5,
      "ability_id": 1546,
      "activated": 1,
      "icon_name": "tgtdefensive",
      "comments": "",
      "prerequisite_id": 1545,
      "cooldown": 6,
      "activation_type": 1,
      "ranked": 1,
      "cost": 6,
      "short_description": "This champion becomes <condition value=impervious>Impervious</condition> for 2 turns.",
      "long_description": "This champion becomes <condition value=impervious>Impervious</condition> for 2 turns.",
      "class_name": "DivineShield",
      "revision": 1
    },
    {
      "asset_id": 4800,
      "resettable": 1,
      "name": "Divine Shield",
      "ap_cost": 3,
      "level": 6,
      "ability_id": 1547,
      "activated": 1,
      "icon_name": "tgtdefensive",
      "comments": "",
      "prerequisite_id": 1546,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 1,
      "cost": 6,
      "short_description": "This champion becomes <condition value=impervious>Impervious</condition> for 2 turns.",
      "long_description": "This champion becomes <condition value=impervious>Impervious</condition> for 2 turns.",
      "class_name": "DivineShield",
      "revision": 1
    },
    {
      "asset_id": 5535,
      "resettable": 1,
      "name": "Divine Wellspring",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2394,
      "activated": 1,
      "icon_name": "divine_wellspring",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "While this champion has at least 10 charges, friendly champions within 5 spaces cannot fall below 1 HP via <ability value=1389>Perseverance</ability>.  When this effect prevents the champion's HP from falling below 1, that champion gains <condition value=impervious>Impervious</condition>, <ability value=1237>Impenetrable</ability>, and <ability value=738>Shielded</ability> until the end of that turn and this champion loses all charges.",
      "long_description": "While this champion has at least 10 charges, friendly champions within 5 spaces cannot fall below 1 HP via <ability value=1389>Perseverance</ability>.  When this effect prevents the champion's HP from falling below 1, that champion gains <condition value=impervious>Impervious</condition>, <ability value=1237>Impenetrable</ability>, and <ability value=738>Shielded</ability> until the end of that turn and this champion loses all charges.",
      "class_name": "DivineWellspring",
      "revision": 1
    },
    {
      "asset_id": 4097,
      "resettable": 1,
      "name": "Dodge",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 217,
      "activated": 1,
      "icon_name": "dodge",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 1,
      "cost": 6,
      "short_description": "Next time target champion within 10 spaces makes a ranged attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>.  (You may target this unit to Dodge the next ranged attack from any champion.)",
      "long_description": "Next time target champion within 10 spaces makes a ranged attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>.  (You may target this unit to Dodge the next ranged attack from any champion.)",
      "class_name": "Dodge",
      "revision": 1
    },
    {
      "asset_id": 4097,
      "resettable": 1,
      "name": "Dodge",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 218,
      "activated": 1,
      "icon_name": "dodge",
      "comments": "none",
      "prerequisite_id": 217,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 1,
      "cost": 9,
      "short_description": "Next time target champion within 10 spaces makes a ranged attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is Paralyzed or Stunned.  (You may target this unit to Dodge the next ranged attack from any champion.)",
      "long_description": "Next time target champion within 10 spaces makes a ranged attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is Paralyzed or Stunned.  (You may target this unit to Dodge the next ranged attack from any champion.)",
      "class_name": "Dodge",
      "revision": 1
    },
    {
      "asset_id": 5636,
      "resettable": 1,
      "name": "Dogpile",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2502,
      "activated": 1,
      "icon_name": "dogpile",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this unit makes a successful basic attack against an enemy champion, the target becomes <condition value=dogpiled>Dogpiled</condition> for 6 turns.",
      "long_description": "When this unit makes a successful basic attack against an enemy champion, the target becomes <condition value=dogpiled>Dogpiled</condition> for 6 turns.",
      "class_name": "Dogpile",
      "revision": 1
    },
    {
      "asset_id": 5244,
      "resettable": 1,
      "name": "Domain: Amplify Poison",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2024,
      "activated": 1,
      "icon_name": "terrainwater",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "This champion receives Amplify Poison while in a water space",
      "long_description": "This champion receives Amplify Poison while in a water space",
      "class_name": "DomainAmplifyPoison",
      "revision": 1
    },
    {
      "asset_id": 4064,
      "resettable": 1,
      "name": "Domain: Arctic",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1324,
      "activated": 1,
      "icon_name": "domain_snow",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Snow or Ice.",
      "long_description": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Snow or Ice.",
      "class_name": "DomainSnow",
      "revision": 1
    },
    {
      "asset_id": 4848,
      "resettable": 1,
      "name": "Domain: Chasm",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1730,
      "activated": 1,
      "icon_name": "domain_chasm",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 2,
      "short_description": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying <mechanic value=chasm>Chasm</mechanic>.",
      "long_description": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying <mechanic value=chasm>Chasm</mechanic>.",
      "class_name": "DomainChasm",
      "revision": 1
    },
    {
      "asset_id": 5823,
      "resettable": 1,
      "name": "Domain: Dead Magic Zone",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2832,
      "activated": 1,
      "icon_name": "dead_magic_zone",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying a <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic>. \r\n",
      "long_description": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying a <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic>. ",
      "class_name": "DomainDeadMagicZone",
      "revision": 1
    },
    {
      "asset_id": 5247,
      "resettable": 1,
      "name": "Domain: Fireshield",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2028,
      "activated": 1,
      "icon_name": "terrainlava",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "This champion receives Damage Shield - Fire 3 while in a lava space",
      "long_description": "This champion receives Damage Shield - Fire 3 while in a lava space",
      "class_name": "DomainFireShield",
      "revision": 1
    },
    {
      "asset_id": 4180,
      "resettable": 1,
      "name": "Domain: Lava",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1329,
      "activated": 1,
      "icon_name": "domain_lava",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Lava.",
      "long_description": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Lava.",
      "class_name": "DomainLava",
      "revision": 1
    },
    {
      "asset_id": 4177,
      "resettable": 1,
      "name": "Domain: Rock",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1328,
      "activated": 1,
      "icon_name": "domain_rock",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Rock.",
      "long_description": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Rock.",
      "class_name": "DomainEarth",
      "revision": 1
    },
    {
      "asset_id": 4117,
      "resettable": 1,
      "name": "Domain: Sand",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1326,
      "activated": 1,
      "icon_name": "domain_sand",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Sand.",
      "long_description": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Sand.",
      "class_name": "DomainSand",
      "revision": 1
    },
    {
      "asset_id": 5246,
      "resettable": 1,
      "name": "Domain: Sandstriker",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2027,
      "activated": 1,
      "icon_name": "terrainsand",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "This champion receives Sandstriker while in a sand space",
      "long_description": "This champion receives Sandstriker while in a sand space",
      "class_name": "DomainSandstriker",
      "revision": 1
    },
    {
      "asset_id": 4849,
      "resettable": 1,
      "name": "Domain: Shadows",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1731,
      "activated": 1,
      "icon_name": "domain_shadows",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "At the beginning of each turn, this unit has +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> for 1 turn if it is <condition value=stealthed>Stealthed</condition>.",
      "long_description": "At the beginning of each turn, this unit has +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> for 1 turn if it is <condition value=stealthed>Stealthed</condition>.",
      "class_name": "DomainShadows",
      "revision": 1
    },
    {
      "asset_id": 5245,
      "resettable": 1,
      "name": "Domain: Stonebomb",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2023,
      "activated": 1,
      "icon_name": "terrainrock",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "This champion receives Stone Bomb 2 while in a rock space",
      "long_description": "This champion receives Stone Bomb 2 while in a rock space",
      "class_name": "DomainStoneBomb",
      "revision": 1
    },
    {
      "asset_id": 4154,
      "resettable": 1,
      "name": "Domain: Vegetation",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1327,
      "activated": 1,
      "icon_name": "domain_vegetation",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Vegetation.",
      "long_description": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Vegetation.",
      "class_name": "DomainGrass",
      "revision": 1
    },
    {
      "asset_id": 4110,
      "resettable": 1,
      "name": "Domain: Water",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1325,
      "activated": 1,
      "icon_name": "domain_water",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Water.",
      "long_description": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Water.",
      "class_name": "DomainWater",
      "revision": 1
    },
    {
      "asset_id": 4850,
      "resettable": 1,
      "name": "Doom",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 1732,
      "activated": 1,
      "icon_name": "ondeath",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 8,
      "activation_type": 1,
      "ranked": 0,
      "cost": 9,
      "short_description": "Target champion without <ability value=875>Short Lived</ability> within 2 spaces gains <ability value=876>Short Lived 2</ability>.  This effect cannot be <mechanic value=cleansed>Cleansed</mechanic>.",
      "long_description": "Target champion without <ability value=875>Short Lived</ability> within 2 spaces gains <ability value=876>Short Lived 2</ability>.  This effect cannot be <mechanic value=cleansed>Cleansed</mechanic>.",
      "class_name": "Doom",
      "revision": 1
    },
    {
      "asset_id": 5744,
      "resettable": 1,
      "name": "Double Trouble",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2631,
      "activated": 1,
      "icon_name": "zombie_apoc",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 15,
      "short_description": "When this champion is destroyed, instead of a nora globe, Cory the Zombie and Bragh the Zombie are spawned in the closest available spaces.",
      "long_description": "When this champion is destroyed, instead of a nora globe, Cory the Zombie and Bragh the Zombie are spawned in the closest available spaces.",
      "class_name": "DoubleTrouble",
      "revision": 1
    },
    {
      "asset_id": 4533,
      "resettable": 1,
      "name": "Draconic Force",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 879,
      "activated": 1,
      "icon_name": "draconic",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "This champion gets +2 DMG for each friendly <mechanic value=dragonkin>Dragonkin</mechanic> within 2 spaces.",
      "long_description": "This champion gets +2 DMG for each friendly <mechanic value=dragonkin>Dragonkin</mechanic> within 2 spaces.",
      "class_name": "DraconicForce",
      "revision": 1
    },
    {
      "asset_id": 5267,
      "resettable": 1,
      "name": "Dragging Attack",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2091,
      "activated": 1,
      "icon_name": "pull",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this champion successfully damages a small champion with a basic attack, that champion is relocated one space toward this unit.",
      "long_description": "When this champion successfully damages a small champion with a basic attack, that champion is relocated one space toward this unit.",
      "class_name": "DraggingAttack",
      "revision": 1
    },
    {
      "asset_id": 4583,
      "resettable": 1,
      "name": "Dragon Form",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 979,
      "activated": 1,
      "icon_name": "transform",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "This unit is <mechanic value=cleansed>Cleansed</mechanic> and gains +2 DMG, <ability value=37>Immunity: Fire,</ability> <ability value=2525>Dragonflight</ability>, and <ability value=2400>Flamethrower</ability>.",
      "long_description": "This unit is <mechanic value=cleansed>Cleansed</mechanic> and gains +2 DMG, <ability value=37>Immunity: Fire,</ability> <ability value=2525>Dragonflight</ability>, and <ability value=2400>Flamethrower</ability>.",
      "class_name": "DragonForm",
      "revision": 1
    },
    {
      "asset_id": 4936,
      "resettable": 1,
      "name": "Dragon God's Staff",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1822,
      "activated": 1,
      "icon_name": "novafire",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "At the end of your turns, enemy units within 3 takes 4 Fire damage and spaces are <mechanic value=dispelled>Dispelled</mechanic>.",
      "long_description": "At the end of your turns, enemy units within 3 takes 4 Fire damage and spaces are <mechanic value=dispelled>Dispelled</mechanic>.",
      "class_name": "RelicDragonGodsStaff",
      "revision": 1
    },
    {
      "asset_id": 5918,
      "resettable": 0,
      "name": "Dragonbark Tree",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2952,
      "activated": 1,
      "icon_name": "rapid_growth",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "This tree will turn into a Dragonbark Protector",
      "long_description": "This tree will turn into a Dragonbark Protector",
      "class_name": "DragonbarkTree",
      "revision": 1
    },
    {
      "asset_id": 4456,
      "resettable": 1,
      "name": "Dragonclaw",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 809,
      "activated": 1,
      "icon_name": "stab",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "This champion makes a Physical attack at RNG 1 at +4 DMG. If the target is successfully damaged, it becomes <condition value=eviscerated>Eviscerated</condition> for 3 turns.",
      "long_description": "This champion makes a Physical attack at RNG 1 at +4 DMG. If the target is successfully damaged, it becomes <condition value=eviscerated>Eviscerated</condition> for 3 turns.",
      "class_name": "DragonClawGreavesAttack",
      "revision": 1
    },
    {
      "asset_id": 5653,
      "resettable": 1,
      "name": "Dragonflight",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2525,
      "activated": 1,
      "icon_name": "skyreign",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "This unit has <condition value=flying>Flying</condition>. The next Dragon you deploy from the runedock gains 2 AP. When this effect triggers, this champion gains <ability value=1395>Hunter: Walker</ability> for 4 turns.",
      "long_description": "This unit has <condition value=flying>Flying</condition>. The next Dragon you deploy from the runedock gains 2 AP. When this effect triggers, this champion gains <ability value=1395>Hunter: Walker</ability> for 4 turns.",
      "class_name": "Dragonflight",
      "revision": 1
    },
    {
      "asset_id": 4477,
      "resettable": 1,
      "name": "Drain",
      "ap_cost": 2,
      "level": 1,
      "ability_id": 865,
      "activated": 1,
      "icon_name": "drain",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 1,
      "cost": 2,
      "short_description": "Target owned champion within 5 spaces loses 8 HP. This unit vampiric heals 8 HP.",
      "long_description": "Target owned champion within 5 spaces loses 8 HP. This unit vampiric heals 8 HP.",
      "class_name": "Drain",
      "revision": 1
    },
    {
      "asset_id": 4477,
      "resettable": 1,
      "name": "Drain",
      "ap_cost": 2,
      "level": 2,
      "ability_id": 866,
      "activated": 1,
      "icon_name": "drain",
      "comments": "",
      "prerequisite_id": 865,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 1,
      "cost": 4,
      "short_description": "Target owned champion within 5 spaces loses 12 HP. This unit vampiric heals 12 HP.",
      "long_description": "Target owned champion within 5 spaces loses 12 HP. This unit vampiric heals 12 HP.",
      "class_name": "Drain",
      "revision": 1
    },
    {
      "asset_id": 7449,
      "resettable": 0,
      "name": "Drain Vitality",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 3156,
      "activated": 1,
      "icon_name": "drain",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "For 6 turns, target champion has -5 DMG and -2 SPD and the closest 3 friendly champions gain +2 DMG and +1 SPD.",
      "long_description": "For 6 turns, target champion has -5 DMG and -2 SPD and the closest 3 friendly champions gain +2 DMG and +1 SPD.",
      "class_name": "DrainVitalityABILITY",
      "revision": 1
    },
    {
      "asset_id": 5516,
      "resettable": 1,
      "name": "Draining Luminescence",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2375,
      "activated": 1,
      "icon_name": "draining_luminesence",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this unit is deployed and at the start of its turns, the controller of each opposing champion within 4 spaces loses 3 nora.",
      "long_description": "When this unit is deployed and at the start of its turns, the controller of each opposing champion within 4 spaces loses 3 nora.",
      "class_name": "DrainingLuminescence",
      "revision": 1
    },
    {
      "asset_id": 5463,
      "resettable": 1,
      "name": "Draketooth Rifle",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 2316,
      "activated": 1,
      "icon_name": "gun",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 3,
      "ranked": 0,
      "cost": 0,
      "short_description": "This champion makes a Physical attack at RNG 2-5 for 14 DMG.",
      "long_description": "This champion makes a Physical attack at RNG 2-5 for 14 DMG.",
      "class_name": "DraketoothRifleAttack",
      "revision": 1
    },
    {
      "asset_id": 5046,
      "resettable": 1,
      "name": "Draksarbound",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1910,
      "activated": 1,
      "icon_name": "disable",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -5,
      "short_description": "At the beginning of your enemy's turns, if there are no other friendly Draksar in play, this unit is <condition value=possessed>Possessed</condition> by your enemy until end of turn.",
      "long_description": "At the beginning of your enemy's turns, if there are no other friendly Draksar in play, this unit is <condition value=possessed>Possessed</condition> by your enemy until end of turn.",
      "class_name": "Draksarbound",
      "revision": 1
    },
    {
      "asset_id": 4374,
      "resettable": 1,
      "name": "Draw Power",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1413,
      "activated": 1,
      "icon_name": "noragen",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 2,
      "short_description": "Your Shrine or Avatar loses 10 HP and you gain 5 Nora.",
      "long_description": "Your Shrine or Avatar loses 10 HP and you gain 5 Nora.",
      "class_name": "DrawPower",
      "revision": 1
    },
    {
      "asset_id": 4182,
      "resettable": 1,
      "name": "Dread",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1330,
      "activated": 1,
      "icon_name": "fear",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "Enemy champions within 8 spaces of this champion have -2 DMG.",
      "long_description": "Enemy champions within 8 spaces of this champion have -2 DMG.",
      "class_name": "Dread",
      "revision": 1
    },
    {
      "asset_id": 7386,
      "resettable": 0,
      "name": "Dread Field",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 3137,
      "activated": 1,
      "icon_name": "dread_field",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 7,
      "short_description": "Area Effect 2, Range 5: For 4 turns, the area becomes Dread Field (Champions have -5 DMG).",
      "long_description": "Area Effect 2, Range 5: For 4 turns, the area becomes Dread Field (Champions have -5 DMG).",
      "class_name": "DreadField",
      "revision": 1
    },
    {
      "asset_id": 5532,
      "resettable": 1,
      "name": "Dreadwing Potion",
      "ap_cost": 5,
      "level": 0,
      "ability_id": 2391,
      "activated": 1,
      "icon_name": "dreadwing_potion",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 6,
      "activation_type": 1,
      "ranked": 0,
      "cost": 25,
      "short_description": "Target champion within 3 spaces becomes a Dreadwing with 7 DMG, 7 SPD, RNG 1-2 and MAX HP of 36.  If it has a basic attack the attack becomes <ability value=545>Attack: Physical</ability>.",
      "long_description": "Target champion within 3 spaces becomes a Dreadwing with 7 DMG, 7 SPD, RNG 1-2 and MAX HP of 36.  If it has a basic attack the attack becomes <ability value=545>Attack: Physical</ability>.",
      "class_name": "DreadwingPotion",
      "revision": 1
    },
    {
      "asset_id": 7136,
      "resettable": 0,
      "name": "Dreamblossom",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2978,
      "activated": 1,
      "icon_name": "passive",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 0,
      "short_description": "When an opposing champion moves within 2 spaces of this unit, this unit is destroyed.  When this unit is destroyed, opposing champions within 2 spaces take 6 Magical damage and become <condition value=distracted>Distracted</condition> for 4 turns while friendly champions within 2 spaces heal 6 HP.",
      "long_description": "When an opposing champion moves within 2 spaces of this unit, this unit is destroyed.  When this unit is destroyed, opposing champions within 2 spaces take 6 Magical damage and become <condition value=distracted>Distracted</condition> for 4 turns while friendly champions within 2 spaces heal 6 HP.",
      "class_name": "RelicDreamblossom",
      "revision": 1
    },
    {
      "asset_id": 5394,
      "resettable": 1,
      "name": "Dreambox",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2226,
      "activated": 1,
      "icon_name": "dreambox",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "The next time a relic is deployed by an opponent from the runedock, that relic is destroyed and this relic becomes a copy of that relic under your control and ownership.",
      "long_description": "The next time a relic is deployed by an opponent from the runedock, that relic is destroyed and this relic becomes a copy of that relic under your control and ownership.",
      "class_name": "Dreambox",
      "revision": 1
    },
    {
      "asset_id": 5278,
      "resettable": 1,
      "name": "Dreameater",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2102,
      "activated": 1,
      "icon_name": "dreameater",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "At the beginning of each turn, if this champion is <condition value=stealthed>Stealthed</condition>, opposing champions within 5 spaces take 4 Psychic damage.",
      "long_description": "At the beginning of each turn, if this champion is <condition value=stealthed>Stealthed</condition>, opposing champions within 5 spaces take 4 Psychic damage.",
      "class_name": "Dreameater",
      "revision": 1
    },
    {
      "asset_id": 5522,
      "resettable": 1,
      "name": "Dreamstate",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2381,
      "activated": 1,
      "icon_name": "mindslice",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 12,
      "short_description": "Friendly champions (including this one) that come into play within 3 spaces of this unit have Shielded, Spellswallower, Favor and Council: Spells for 6 turns.",
      "long_description": "Friendly champions (including this one) that come into play within 3 spaces of this unit have Shielded, Spellswallower, Favor and Council: Spells for 6 turns.",
      "class_name": "Dreamstate",
      "revision": 1
    },
    {
      "asset_id": 5222,
      "resettable": 1,
      "name": "Drink Action Potion",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1999,
      "activated": 1,
      "icon_name": "action_potion",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 8,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "This champion recovers 4 AP.  This ability is removed after use.",
      "long_description": "This champion recovers 4 AP.  This ability is removed after use.",
      "class_name": "DrinkActionPotion",
      "revision": 1
    },
    {
      "asset_id": 4979,
      "resettable": 1,
      "name": "Drink Healing Potion",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 2640,
      "activated": 1,
      "icon_name": "healing_potion",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 8,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "This champion is <mechanic value=cleansed>Cleansed</mechanic> and heals for 8 HP. This ability is removed after use. ",
      "long_description": "This champion is <mechanic value=cleansed>Cleansed</mechanic> and heals for 8 HP. This ability is removed after use. ",
      "class_name": "DrinkHealingPotion",
      "revision": 1
    },
    {
      "asset_id": 4979,
      "resettable": 1,
      "name": "Drink Rage Potion",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 1862,
      "activated": 1,
      "icon_name": "rage_potion",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 8,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "This champion gains +3 DMG for 1 turn.  This ability is removed after use.",
      "long_description": "This champion gains +3 DMG for 1 turn.  This ability is removed after use.",
      "class_name": "DrinkPotion",
      "revision": 1
    },
    {
      "asset_id": 4979,
      "resettable": 1,
      "name": "Drink: Stoneskin Potion",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 2638,
      "activated": 1,
      "icon_name": "stoneskin_potion",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 8,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "This champion gains <ability value=1902>Tough 3</ability> for 4 turns.  This ability is removed after use.",
      "long_description": "This champion gains <ability value=1902>Tough 3</ability> for 4 turns.  This ability is removed after use.",
      "class_name": "DrinkStoneskinPotion",
      "revision": 1
    },
    {
      "asset_id": 4263,
      "resettable": 1,
      "name": "Drive",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 656,
      "activated": 1,
      "icon_name": "drive",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "Target champion within 5 spaces loses 2 HP (HP loss cannot be prevented) and gains Driven (This champion gets +2 DMG and +1 SPD) and recovers 1 AP. This ability can not be used on a champion who already has this effect.",
      "long_description": "Target champion within 5 spaces loses 2 HP (HP loss cannot be prevented) and gains Driven (This champion gets +2 DMG and +1 SPD) and recovers 1 AP. This ability can not be used on a champion who already has this effect.",
      "class_name": "Drive",
      "revision": 1
    },
    {
      "asset_id": 5428,
      "resettable": 1,
      "name": "Drop Beacon",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 2259,
      "activated": 1,
      "icon_name": "deploy",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 15,
      "short_description": "A Skywing Beacon with Beacon (Starting on your next turn, spaces adjacent to this relic are deployment zones for the controller of this relic) is deployed in target adjacent square.  This ability is removed after use.",
      "long_description": "A Skywing Beacon with Beacon (Starting on your next turn, spaces adjacent to this relic are deployment zones for the controller of this relic) is deployed in target adjacent square.  This ability is removed after use.",
      "class_name": "DropBeacon",
      "revision": 1
    },
    {
      "asset_id": 4955,
      "resettable": 1,
      "name": "Drop Blade",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 1839,
      "activated": 1,
      "icon_name": "spur",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "The Holy Blade of Valdac can be dropped as a relic.",
      "long_description": "The Holy Blade of Valdac can be dropped as a relic.",
      "class_name": "DropBlade",
      "revision": 1
    },
    {
      "asset_id": 4957,
      "resettable": 1,
      "name": "Drop Bracers",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 1841,
      "activated": 1,
      "icon_name": "spur",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "The Reactive Bracers can be dropped as a relic.",
      "long_description": "The Reactive Bracers can be dropped as a relic.",
      "class_name": "DropBracers",
      "revision": 1
    },
    {
      "asset_id": 4950,
      "resettable": 1,
      "name": "Drop Harpoon",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 1834,
      "activated": 1,
      "icon_name": "spur",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Drop the Vicious Harpoon as a relic in an adjacent empty space. This ability shares a cooldown with Pull.",
      "long_description": "Drop the Vicious Harpoon as a relic in an adjacent empty space. This ability shares a cooldown with Pull.",
      "class_name": "DropHarpoon",
      "revision": 1
    },
    {
      "asset_id": 4956,
      "resettable": 1,
      "name": "Drop Helm",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 1840,
      "activated": 1,
      "icon_name": "spur",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "The Darkmarsh Helm can be dropped as a relic.",
      "long_description": "The Darkmarsh Helm can be dropped as a relic.",
      "class_name": "DropHelm",
      "revision": 1
    },
    {
      "asset_id": 4952,
      "resettable": 1,
      "name": "Drop Pendant",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 1836,
      "activated": 1,
      "icon_name": "spur",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "The Ghost Pendant can be dropped as a relic.",
      "long_description": "The Ghost Pendant can be dropped as a relic.",
      "class_name": "DropPendant",
      "revision": 1
    },
    {
      "asset_id": 4953,
      "resettable": 1,
      "name": "Drop Staff",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 1837,
      "activated": 1,
      "icon_name": "spur",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "The Dragon God's Staff can be dropped as a relic.",
      "long_description": "The Dragon God's Staff can be dropped as a relic.",
      "class_name": "DropStaff",
      "revision": 1
    },
    {
      "asset_id": 4951,
      "resettable": 1,
      "name": "Drop Sword",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 1835,
      "activated": 1,
      "icon_name": "spur",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "The Sword of Shadows can be dropped as a relic.",
      "long_description": "The Sword of Shadows can be dropped as a relic.",
      "class_name": "DropSword",
      "revision": 1
    },
    {
      "asset_id": 4852,
      "resettable": 1,
      "name": "Drudgery",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 1734,
      "activated": 1,
      "icon_name": "debuff",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "All champions lose all of their AP. This ability begins on cooldown.",
      "long_description": "All champions lose all of their AP. This ability begins on cooldown.",
      "class_name": "Drudgery",
      "revision": 1
    },
    {
      "asset_id": 4313,
      "resettable": 1,
      "name": "Drunkard",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1341,
      "activated": 1,
      "icon_name": "intoxicate",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 2,
      "short_description": "When this unit comes into play, it becomes <condition value=intoxicated>Intoxicated</condition> for 6 turns. While this unit is <condition value=intoxicated popup=false>Intoxicated</condition>, it has +1 DEF, <ability value=4>Iron Will</ability> and <ability value=3>Fearless</ability>",
      "long_description": "When this unit comes into play, it becomes <condition value=intoxicated>Intoxicated</condition> for 6 turns. While this unit is <condition value=intoxicated popup=false>Intoxicated</condition>, it has +1 DEF, <ability value=4>Iron Will</ability> and <ability value=3>Fearless</ability>",
      "class_name": "Drunken",
      "revision": 1
    },
    {
      "asset_id": 7331,
      "resettable": 0,
      "name": "Drunken Revel",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3103,
      "activated": 1,
      "icon_name": "carouse",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "When a friendly champion becomes <condition value=intoxicated>Intoxicated</condition>, this champion gains 1 AP and +2 DMG for 2 turns. This effect stacks up to 3 times.",
      "long_description": "When a friendly champion becomes <condition value=intoxicated>Intoxicated</condition>, this champion gains 1 AP and +2 DMG for 2 turns. This effect stacks up to 3 times.",
      "class_name": "DrunkenRevel",
      "revision": 1
    },
    {
      "asset_id": 7990,
      "resettable": 0,
      "name": "Drunken Revel Aura",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3385,
      "activated": 1,
      "icon_name": "carouse",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "Friendly adjacent champions with Race: Dwarf gain <ability value=3103>Drunken Revel</ability>.",
      "long_description": "Friendly adjacent champions with Race: Dwarf gain <ability value=3103>Drunken Revel</ability>.",
      "class_name": "DrunkenRevelAura",
      "revision": 1
    },
    {
      "asset_id": 4853,
      "resettable": 1,
      "name": "Duel",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 1735,
      "activated": 1,
      "icon_name": "reflexes",
      "comments": "Range 3",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "Target an opposing champion within 2 spaces.  For 8 turns, this champion is Dueling the targeted opposing champion.  While Dueling, this champion cannot attack any champion other than the targeted champion and deals 50% more damage (after DEF) to the targeted champion and only takes 75% damage (after DEF) from the targeted champion.  This effect ends if the target is destroyed or removed from play.",
      "long_description": "Target an opposing champion within 2 spaces.  For 8 turns, this champion is Dueling the targeted opposing champion.  While Dueling, this champion cannot attack any champion other than the targeted champion and deals 50% more damage (after DEF) to the targeted champion and only takes 75% damage (after DEF) from the targeted champion.  This effect ends if the target is destroyed or removed from play.",
      "class_name": "Duel",
      "revision": 1
    },
    {
      "asset_id": 7995,
      "resettable": 0,
      "name": "Dune Armaments",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3390,
      "activated": 1,
      "icon_name": "comboatk_devastate",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "When a friendly champion with Race: Draksar, Race: Skeezick or Race: Arthropod becomes equipped, it gains 1 AP and +1 DMG for 4 turns. This does not stack.",
      "long_description": "When a friendly champion with Race: Draksar, Race: Skeezick or Race: Arthropod becomes equipped, it gains 1 AP and +1 DMG for 4 turns. This does not stack.",
      "class_name": "DuneArmaments",
      "revision": 1
    },
    {
      "asset_id": 5354,
      "resettable": 1,
      "name": "Duplicity",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2186,
      "activated": 1,
      "icon_name": "duplicate",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "Spend 8 Charges. Deploy a copy of this champion on target adjacent space and 1 illusion copy in an adjacent space. This champion loses all remaining charges.",
      "long_description": "Spend 8 Charges. Deploy a copy of this champion on target adjacent space and 1 illusion copy in an adjacent space. This champion loses all remaining charges.",
      "class_name": "Duplicate",
      "revision": 1
    },
    {
      "asset_id": 4698,
      "resettable": 1,
      "name": "Dwarf Driven",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1153,
      "activated": 1,
      "icon_name": "drive",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -12,
      "short_description": "This unit has lumbering unless it is adjacent to a Dwarf you control",
      "long_description": "This unit has lumbering unless it is adjacent to a Dwarf you control",
      "class_name": "DwarfDriven",
      "revision": 1
    },
    {
      "asset_id": 7332,
      "resettable": 0,
      "name": "Dwarven Noble",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 3104,
      "activated": 1,
      "icon_name": "drunken_noble",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 0,
      "ranked": 0,
      "cost": 12,
      "short_description": "This champion gains +2 DEF and Majestic 2 for 4 turns. The CD of this ability is reduced by 1 whenever a friendly Dwarf or Drunkard within 5 spaces is attacked (not including itself).",
      "long_description": "This champion gains +2 DEF and Majestic 2 for 4 turns. The CD of this ability is reduced by 1 whenever a friendly Dwarf or Drunkard within 5 spaces is attacked (not including itself).",
      "class_name": "DwarvenNoble",
      "revision": 1
    },
    {
      "asset_id": 4505,
      "resettable": 1,
      "name": "Eagle Form",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 852,
      "activated": 1,
      "icon_name": "transform",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "This unit becomes an Eagle with Race: Beast, RNG 1-1, <ability value=1>Flight</ability>, <ability value=6>Mobility</ability>, and <ability value=13>Detection 3</ability>. It gains +1 SPD and is <mechanic value=cleansed>Cleansed</mechanic>.",
      "long_description": "This unit becomes an Eagle with Race: Beast, RNG 1-1, <ability value=1>Flight</ability>, <ability value=6>Mobility</ability>, and <ability value=13>Detection 3</ability>. It gains +1 SPD and is <mechanic value=cleansed>Cleansed</mechanic>.",
      "class_name": "EagleForm",
      "revision": 1
    },
    {
      "asset_id": 4285,
      "resettable": 1,
      "name": "Earthbound",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 669,
      "activated": 1,
      "icon_name": "lumbering",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -5,
      "short_description": "This champion is <condition value=grounded>Grounded</condition>, cannot gain <condition value=flying popup=false>Flying</condition>, and cannot be relocated.",
      "long_description": "This champion is <condition value=grounded>Grounded</condition>, cannot gain <condition value=flying popup=false>Flying</condition>, and cannot be relocated.",
      "class_name": "Earthbound",
      "revision": 1
    },
    {
      "asset_id": 4479,
      "resettable": 1,
      "name": "Earthshake",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 953,
      "activated": 1,
      "icon_name": "knockback",
      "comments": "version of Tremor with no AP cost",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Opposing champions without <condition value=flying popup=false>Flying</condition> within 3 spaces of this unit are knocked back 1 space, gain <ability value=5>Lumbering</ability> for 2 turns and take 6 Physical damage. Enemy relics in the affected area take 6 Physical damage. This damage ignores DEF.",
      "long_description": "Opposing champions without <condition value=flying popup=false>Flying</condition> within 3 spaces of this unit are knocked back 1 space, gain <ability value=5>Lumbering</ability> for 2 turns and take 6 Physical damage. Enemy relics in the affected area take 6 Physical damage. This damage ignores DEF.",
      "class_name": "Tremor",
      "revision": 1
    },
    {
      "asset_id": 5224,
      "resettable": 1,
      "name": "Easy Target",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2002,
      "activated": 1,
      "icon_name": "easy_target",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -10,
      "short_description": "This unit takes 30% more damage from ranged attacks.",
      "long_description": "This unit takes 30% more damage from ranged attacks.",
      "class_name": "EasyTarget",
      "revision": 1
    },
    {
      "asset_id": 4270,
      "resettable": 1,
      "name": "Eat Traps",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 674,
      "activated": 1,
      "icon_name": "devour",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 5,
      "short_description": "All traps created by Lay Trap abilities within 3 space are destroyed. This unit gains +2 DMG per trap for 3 turns.",
      "long_description": "All traps created by Lay Trap abilities within 3 space are destroyed. This unit gains +2 DMG per trap for 3 turns.",
      "class_name": "EatTraps",
      "revision": 1
    },
    {
      "asset_id": 4737,
      "resettable": 1,
      "name": "Echo Chamber",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1282,
      "activated": 1,
      "icon_name": "sonicaoe",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Opposing champions and relics within 4 spaces take 8 Sonic damage. This damage ignores DEF. Champions that take damage become <condition value=distracted>Distracted</condition> for 2 turns.",
      "long_description": "Opposing champions and relics within 4 spaces take 8 Sonic damage. This damage ignores DEF. Champions that take damage become <condition value=distracted>Distracted</condition> for 2 turns.",
      "class_name": "EchoChamber",
      "revision": 1
    },
    {
      "asset_id": 7568,
      "resettable": 0,
      "name": "Electric Attack",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 3213,
      "activated": 1,
      "icon_name": "electric",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "This unit makes an Electric attack at range 2-4.",
      "long_description": "This unit makes an Electric attack at range 2-4.",
      "class_name": "ElectricAttack",
      "revision": 1
    },
    {
      "asset_id": 5682,
      "resettable": 1,
      "name": "Electric Overload",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2555,
      "activated": 1,
      "icon_name": "jolt",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 10,
      "short_description": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=shocked>Shocked</condition> for 3 turns. If that champion is already Shocked, it is equipped with a Lightning Rod. Equipment generated by this ability costs 0 nora.",
      "long_description": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=shocked>Shocked</condition> for 3 turns. If that champion is already Shocked, it is equipped with a Lightning Rod. Equipment generated by this ability costs 0 nora.",
      "class_name": "ElectricOverload",
      "revision": 1
    },
    {
      "asset_id": 4078,
      "resettable": 1,
      "name": "Electricity Aura",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 139,
      "activated": 1,
      "icon_name": "novaelectric",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 2,
      "short_description": "At the beginning of your opponent's turns, this unit deals 2 Electricity damage to each champion within 2 spaces. This damage ignores DEF.",
      "long_description": "At the beginning of your opponent's turns, this unit deals 2 Electricity damage to each champion within 2 spaces. This damage ignores DEF.",
      "class_name": "DamagingAuraElectricity",
      "revision": 1
    },
    {
      "asset_id": 4078,
      "resettable": 1,
      "name": "Electricity Aura",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 140,
      "activated": 1,
      "icon_name": "novaelectric",
      "comments": "none",
      "prerequisite_id": 139,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 4,
      "short_description": "At the beginning of your opponent's turns, this unit deals 4 Electricity damage to each champion within 2 spaces. This damage ignores DEF.",
      "long_description": "At the beginning of your opponent's turns, this unit deals 4 Electricity damage to each champion within 2 spaces. This damage ignores DEF.",
      "class_name": "DamagingAuraElectricity",
      "revision": 1
    },
    {
      "asset_id": 4078,
      "resettable": 1,
      "name": "Electricity Aura",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 141,
      "activated": 1,
      "icon_name": "novaelectric",
      "comments": "none",
      "prerequisite_id": 140,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 6,
      "short_description": "At the beginning of your opponent's turns, this unit deals 6 Electricity damage to each champion within 2 spaces. This damage ignores DEF.",
      "long_description": "At the beginning of your opponent's turns, this unit deals 6 Electricity damage to each champion within 2 spaces. This damage ignores DEF.",
      "class_name": "DamagingAuraElectricity",
      "revision": 1
    },
    {
      "asset_id": 4211,
      "resettable": 1,
      "name": "Electricity Eater",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1331,
      "activated": 1,
      "icon_name": "eater_electric",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this unit would take Electric damage, it instead recovers HP equal to half the damage that would have been dealt. This unit cannot be <condition value=shocked popup=false>Shocked</condition>.",
      "long_description": "When this unit would take Electric damage, it instead recovers HP equal to half the damage that would have been dealt. This unit cannot be <condition value=shocked popup=false>Shocked</condition>.",
      "class_name": "ElectricEater",
      "revision": 1
    },
    {
      "asset_id": 7226,
      "resettable": 0,
      "name": "Elemental Nexus: Elementals",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3048,
      "activated": 1,
      "icon_name": "soul_bond",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "Friendly Elementals gain <ability value=616>Arctic Camouflage</ability>. This shares a CD with and removes the effects of <ability value=3049>Elemental Nexus: Jakei</ability> when activated.",
      "long_description": "Friendly Elementals gain <ability value=616>Arctic Camouflage</ability>. This shares a CD with and removes the effects of <ability value=3049>Elemental Nexus: Jakei</ability> when activated.",
      "class_name": "ElementalNexusElementals",
      "revision": 1
    },
    {
      "asset_id": 7227,
      "resettable": 0,
      "name": "Elemental Nexus: Jakei",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3049,
      "activated": 1,
      "icon_name": "soul_bond",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "Friendly Jakei gain <ability value=2669>Snowstrike</ability>. This shares a CD with removes the effects of <ability value=3048>Elemental Nexus: Elementals</ability> when activated.",
      "long_description": "Friendly Jakei gain <ability value=2669>Snowstrike</ability>. This shares a CD with removes the effects of <ability value=3048>Elemental Nexus: Elementals</ability> when activated.",
      "class_name": "ElementalNexusJakei",
      "revision": 1
    },
    {
      "asset_id": 7373,
      "resettable": 0,
      "name": "Elemental Storm: Frost",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 3129,
      "activated": 1,
      "icon_name": "absolute_zero",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "Enemy champions within 3 spaces of at least one friendly Elemental, Shaman or Wizard, including this one, take 5 Frost damage (ignores DEF) and lose up to 1 AP. This champion gains 1 AP per AP lost this way.",
      "long_description": "Enemy champions within 3 spaces of at least one friendly Elemental, Shaman or Wizard, including this one, take 5 Frost damage (ignores DEF) and lose up to 1 AP. This champion gains 1 AP per AP lost this way.",
      "class_name": "ElementalBurst",
      "revision": 1
    },
    {
      "asset_id": 7765,
      "resettable": 0,
      "name": "Elemental Storm: Poison",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 3291,
      "activated": 1,
      "icon_name": "novapoison",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "Enemy champions within 3 spaces of at least one friendly Plant, Shaman or champion with Attack: Poison, including this one, take 5 Poison damage (ignores DEF) and lose up to 1 AP. This champion gains 1 AP per AP lost this way.",
      "long_description": "Enemy champions within 3 spaces of at least one friendly Plant, Shaman or champion with Attack: Poison, including this one, take 5 Poison damage (ignores DEF) and lose up to 1 AP. This champion gains 1 AP per AP lost this way.",
      "class_name": "ElementalStormPoison",
      "revision": 1
    },
    {
      "asset_id": 5718,
      "resettable": 1,
      "name": "Elemental Zephyr",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2600,
      "activated": 1,
      "icon_name": "gale",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 12,
      "short_description": "Friendly Elementals within 5 spaces have <ability value=6>Mobility</ability> and +1 SPD. This does not stack.",
      "long_description": "Friendly Elementals within 5 spaces have <ability value=6>Mobility</ability> and +1 SPD. This does not stack.",
      "class_name": "ElementalZephyr",
      "revision": 1
    },
    {
      "asset_id": 4624,
      "resettable": 1,
      "name": "Elite",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1045,
      "activated": 1,
      "icon_name": "titan",
      "comments": "This ability is ment to be added to bosses (NPCs) in poxnora. ",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 25,
      "short_description": "This unit cannot be Charmed, Possessed, Dominated, Frightened, Stunned, Slowed, Ensnared, Blinded, Paralyzed and Rooted.  This unit cannot be knocked back and is immune to effects that cause AP loss.  This unit is also immune to spells and abilities which would instantly kill, relocate or remove it from play. HP Loss to this unit is capped at 30 per source.  This unit cannot be equipped. This unit has Unstoppable, Iron Will and Fearless.",
      "long_description": "This unit cannot be Charmed, Possessed, Dominated, Frightened, Stunned, Slowed, Ensnared, Blinded, Paralyzed and Rooted.  This unit cannot be knocked back and is immune to effects that cause AP loss.  This unit is also immune to spells and abilities which would instantly kill, relocate or remove it from play. HP Loss to this unit is capped at 30 per source.  This unit cannot be equipped. This unit has Unstoppable, Iron Will and Fearless.",
      "class_name": "Elite",
      "revision": 1
    },
    {
      "asset_id": 4817,
      "resettable": 1,
      "name": "Elite Blade",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1696,
      "activated": 1,
      "icon_name": "charged_attack",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "This champion makes a Physical attack at close range. This attack costs 1 less AP than standard attacks and is part of the attack chain.",
      "long_description": "This champion makes a Physical attack at close range. This attack costs 1 less AP than standard attacks and is part of the attack chain.",
      "class_name": "EliteBladeAttack",
      "revision": 1
    },
    {
      "asset_id": 4511,
      "resettable": 1,
      "name": "Elite Skeezick Blade",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2656,
      "activated": 1,
      "icon_name": "stab",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "This champion makes a close-combat Physical attack. When a champion takes 1 or more damage from this attack, it becomes <condition value=eviscerated>Eviscerated</condition> for 3 turns and Inhibited (This unit cannot be healed).",
      "long_description": "This champion makes a close-combat Physical attack. When a champion takes 1 or more damage from this attack, it becomes <condition value=eviscerated>Eviscerated</condition> for 3 turns and Inhibited (This unit cannot be healed).",
      "class_name": "SkeezickBladeAttack",
      "revision": 1
    },
    {
      "asset_id": 5634,
      "resettable": 1,
      "name": "Elsari Coven",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2500,
      "activated": 1,
      "icon_name": "elsari",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "Whenever an opposing champion is deployed into or enters a friendly Dead Magic Zone, it becomes <condition value=cursed>Cursed</condition> for 2 turns plus 1 additional turn for each friendly Witch (to a maximum of 8).",
      "long_description": "Whenever an opposing champion is deployed into or enters a friendly Dead Magic Zone, it becomes <condition value=cursed>Cursed</condition> for 2 turns plus 1 additional turn for each friendly Witch (to a maximum of 8).",
      "class_name": "ElsariCoven",
      "revision": 1
    },
    {
      "asset_id": 7179,
      "resettable": 0,
      "name": "Elsari Dusk",
      "ap_cost": 5,
      "level": 0,
      "ability_id": 3022,
      "activated": 1,
      "icon_name": "familiar",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 25,
      "short_description": "This champion becomes Stealthed and permanently gains +10 MAX HP, +5 DMG, +3 SPD, Stealth and Elusive. This ability begins on cooldown and is removed after use.",
      "long_description": "This champion becomes Stealthed and permanently gains +10 MAX HP, +5 DMG, +3 SPD, Stealth and Elusive. This ability begins on cooldown and is removed after use.",
      "class_name": "ElsariDusk",
      "revision": 1
    },
    {
      "asset_id": 5610,
      "resettable": 1,
      "name": "Elusive",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2469,
      "activated": 1,
      "icon_name": "elusive",
      "comments": "Works just like Dodge except for ranged attacks.",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 12,
      "short_description": "All ranged attacks against this champion miss if it is not <condition value=stunned>Stunned</condition> or <condition value=paralyzed>Paralyzed</condition>.",
      "long_description": "All ranged attacks against this champion miss if it is not <condition value=stunned>Stunned</condition> or <condition value=paralyzed>Paralyzed</condition>.",
      "class_name": "Elusive",
      "revision": 1
    },
    {
      "asset_id": 7273,
      "resettable": 0,
      "name": "Elusive Leap",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 3072,
      "activated": 1,
      "icon_name": "dashing_dodge",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 9,
      "short_description": "This champion is relocated to target space within 4 spaces and the next basic attack against this champion within 6 turns misses.",
      "long_description": "This champion is relocated to target space within 4 spaces and the next basic attack against this champion within 6 turns misses.",
      "class_name": "DashingManeuver",
      "revision": 1
    },
    {
      "asset_id": 4615,
      "resettable": 1,
      "name": "Elven Statue",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1031,
      "activated": 1,
      "icon_name": "healmass",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "At the end of your turn, each friendly non-Demon Elf within 5 spaces heals 1 HP for each friendly non-Demon Elf in play, and each Demon Elf within 5 spaces takes 1 Magical damage for each friendly non-Demon Elf in play.",
      "long_description": "At the end of your turn, each friendly non-Demon Elf within 5 spaces heals 1 HP for each friendly non-Demon Elf in play, and each Demon Elf within 5 spaces takes 1 Magical damage for each friendly non-Demon Elf in play.",
      "class_name": "RelicElvenStatue",
      "revision": 1
    },
    {
      "asset_id": 4251,
      "resettable": 1,
      "name": "Ember Glow",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1332,
      "activated": 1,
      "icon_name": "eater_fire",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "If this unit would take Fire damage, it instead recovers HP equal to half the damage that would have been dealt.",
      "long_description": "If this unit would take Fire damage, it instead recovers HP equal to half the damage that would have been dealt.",
      "class_name": "EmberGlow",
      "revision": 1
    },
    {
      "asset_id": 5735,
      "resettable": 1,
      "name": "Emerald Sigil",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2734,
      "activated": 1,
      "icon_name": "griffin_sigil",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 3,
      "short_description": "This champion gains <ability value=2353>Grant: Teleport</ability> for 5 turns when a friendly unit with a Sigil ability is deployed from the runedock.",
      "long_description": "This champion gains <ability value=2353>Grant: Teleport</ability> for 5 turns when a friendly unit with a Sigil ability is deployed from the runedock.",
      "class_name": "EmeraldSigil",
      "revision": 1
    },
    {
      "asset_id": 5549,
      "resettable": 1,
      "name": "Empathy",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2409,
      "activated": 1,
      "icon_name": "martyr",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "Friendly champions within 5 spaces have an additional rank of Regeneration.",
      "long_description": "Friendly champions within 5 spaces have an additional rank of Regeneration.",
      "class_name": "Empathy",
      "revision": 1
    },
    {
      "asset_id": 7989,
      "resettable": 0,
      "name": "Empathy Aura",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3384,
      "activated": 1,
      "icon_name": "martyr",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "Friendly champions within 5 spaces that have Class: Priest gain <ability value=2409>Empathy</ability>.",
      "long_description": "Friendly champions within 5 spaces that have Class: Priest gain <ability value=2409>Empathy</ability>.",
      "class_name": "EmpathyAura",
      "revision": 1
    },
    {
      "asset_id": 5781,
      "resettable": 1,
      "name": "Empower",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 2705,
      "activated": 1,
      "icon_name": "divine",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 12,
      "short_description": "This champion gains <ability value=129>Magical Aura 3</ability>, <ability value=117>Regeneration 3</ability> and <ability value=1899>Scale Armor</ability> for 6 turns. The duration of this effect is decreased by 1 whenever this champion is successfully attacked.",
      "long_description": "This champion gains <ability value=129>Magical Aura 3</ability>, <ability value=117>Regeneration 3</ability> and <ability value=1899>Scale Armor</ability> for 6 turns. The duration of this effect is decreased by 1 whenever this champion is successfully attacked.",
      "class_name": "Empower",
      "revision": 1
    },
    {
      "asset_id": 7402,
      "resettable": 0,
      "name": "Empowered: Defense",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3145,
      "activated": 1,
      "icon_name": "fragile_defense",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "This champion has +3 DEF. This ability is removed after this champion has been the target of 3 successful basic attacks.",
      "long_description": "This champion has +3 DEF. This ability is removed after this champion has been the target of 3 successful basic attacks.",
      "class_name": "FragileDefense",
      "revision": 1
    },
    {
      "asset_id": 7385,
      "resettable": 0,
      "name": "Empowered: Offense",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3136,
      "activated": 1,
      "icon_name": "empowered_offense",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "This champion has +3 DMG and <ability value=1775>Precision</ability>. This ability is removed after 3 basic attacks.",
      "long_description": "This champion has +3 DMG and <ability value=1775>Precision</ability>. This ability is removed after 3 basic attacks.",
      "class_name": "EmpoweredOffense",
      "revision": 1
    },
    {
      "asset_id": 7430,
      "resettable": 0,
      "name": "Empowered: Range",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3153,
      "activated": 1,
      "icon_name": "empowered_range",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "This champion has +2 MIN RNG and +2 MAX RNG. This ability is removed after 3 basic attacks.",
      "long_description": "This champion has +2 MIN RNG and +2 MAX RNG. This ability is removed after 3 basic attacks.",
      "class_name": "EmpoweredRange",
      "revision": 1
    },
    {
      "asset_id": 7391,
      "resettable": 0,
      "name": "Empowered: Speed",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3142,
      "activated": 1,
      "icon_name": "empowered_speed",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "This champion has +1 SPD and Mobility. This ability is removed after 3 basic attacks.",
      "long_description": "This champion has +1 SPD and Mobility. This ability is removed after 3 basic attacks.",
      "class_name": "EmpoweredSpeed",
      "revision": 1
    },
    {
      "asset_id": 7591,
      "resettable": 0,
      "name": "Enchant: Magic",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 3223,
      "activated": 1,
      "icon_name": "enchant_magic",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "Target relic or equipped champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> and <ability value=225>Damage Shield: Magical 3</ability> for 6 turns.",
      "long_description": "Target relic or equipped champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> and <ability value=225>Damage Shield: Magical 3</ability> for 6 turns.",
      "class_name": "EnchantMagic",
      "revision": 1
    },
    {
      "asset_id": 7958,
      "resettable": 0,
      "name": "Enchant: Magic (Relic)",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3343,
      "activated": 1,
      "icon_name": "enchant_magic",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "Target relic or equipped champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> and <ability value=225>Damage Shield: Magical 3</ability> for 6 turns.",
      "long_description": "Target relic or equipped champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> and <ability value=225>Damage Shield: Magical 3</ability> for 6 turns.",
      "class_name": "EnchantMagic",
      "revision": 1
    },
    {
      "asset_id": 4992,
      "resettable": 1,
      "name": "Encourage",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 1655,
      "activated": 1,
      "icon_name": "allybuffs",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 2,
      "short_description": "This unit has Overseer: Moga 1. Friendly champions within 2 spaces have +5 HP.",
      "long_description": "This unit has Overseer: Moga 1. Friendly champions within 2 spaces have +5 HP.",
      "class_name": "Encourage",
      "revision": 1
    },
    {
      "asset_id": 4992,
      "resettable": 1,
      "name": "Encourage",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 1656,
      "activated": 1,
      "icon_name": "allybuffs",
      "comments": "none",
      "prerequisite_id": 1655,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 2,
      "short_description": "This unit has Overseer: Moga 1. Friendly champions within 2 spaces have +1 DEF and +5 HP.",
      "long_description": "This unit has Overseer: Moga 1. Friendly champions within 2 spaces have +1 DEF and +5 HP.",
      "class_name": "Encourage",
      "revision": 1
    },
    {
      "asset_id": 4992,
      "resettable": 1,
      "name": "Encourage",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 1657,
      "activated": 1,
      "icon_name": "allybuffs",
      "comments": "none",
      "prerequisite_id": 1656,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 2,
      "short_description": "This unit has Overseer: Moga 2. Friendly champions within 5 spaces have +1 DEF and +5 HP.",
      "long_description": "This unit has Overseer: Moga 2. Friendly champions within 5 spaces have +1 DEF and +5 HP.",
      "class_name": "Encourage",
      "revision": 1
    },
    {
      "asset_id": 5035,
      "resettable": 1,
      "name": "Encouraged",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1214,
      "activated": 1,
      "icon_name": "buff",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "When a friendly champion succesfully attacks, this champion gains +1 DMG for 1 turn.",
      "long_description": "When a friendly champion succesfully attacks, this champion gains +1 DMG for 1 turn.",
      "class_name": "Encouraged",
      "revision": 1
    },
    {
      "asset_id": 4558,
      "resettable": 1,
      "name": "Encroached",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1453,
      "activated": 1,
      "icon_name": "buff",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 14,
      "short_description": "This champion gets +2 DMG and +1 SPD for each font your opponent controls. It also gets +2 DEF if your opponent controls more fonts than you.",
      "long_description": "This champion gets +2 DMG and +1 SPD for each font your opponent controls. It also gets +2 DEF if your opponent controls more fonts than you.",
      "class_name": "Encroached",
      "revision": 1
    },
    {
      "asset_id": 5701,
      "resettable": 1,
      "name": "Endless Devotion",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2581,
      "activated": 1,
      "icon_name": "revere",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 2,
      "short_description": "When this champion is within 5 spaces of a Jakei, it gains <ability value=2373>Nora Gem</ability>.",
      "long_description": "When this champion is within 5 spaces of a Jakei, it gains <ability value=2373>Nora Gem</ability>.",
      "class_name": "EndlessDevotion",
      "revision": 1
    },
    {
      "asset_id": 4801,
      "resettable": 1,
      "name": "Enduring Aura",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 1548,
      "activated": 1,
      "icon_name": "aurapositive",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 1,
      "short_description": "Damage to friendly champions within 1 space is reduced by 1. (this ability and its effects do not stack)",
      "long_description": "Damage to friendly champions within 1 space is reduced by 1. (this ability and its effects do not stack)",
      "class_name": "EnduringAura",
      "revision": 1
    },
    {
      "asset_id": 4801,
      "resettable": 1,
      "name": "Enduring Aura",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 1549,
      "activated": 1,
      "icon_name": "aurapositive",
      "comments": "none",
      "prerequisite_id": 1548,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 2,
      "short_description": "Damage to friendly champions within 2 spaces is reduced by 1. (this ability and its effects do not stack)",
      "long_description": "Damage to friendly champions within 2 spaces is reduced by 1.(this ability and its effects do not stack)",
      "class_name": "EnduringAura",
      "revision": 1
    },
    {
      "asset_id": 4801,
      "resettable": 1,
      "name": "Enduring Aura",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 1550,
      "activated": 1,
      "icon_name": "aurapositive",
      "comments": "none",
      "prerequisite_id": 1549,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 4,
      "short_description": "Damage to friendly champions within 2 spaces is reduced by 2. (this ability and its effects do not stack)",
      "long_description": "Damage to friendly champions within 2 spaces is reduced by 2. (this ability and its effects do not stack)",
      "class_name": "EnduringAura",
      "revision": 1
    },
    {
      "asset_id": 4801,
      "resettable": 1,
      "name": "Enduring Aura",
      "ap_cost": 0,
      "level": 4,
      "ability_id": 1551,
      "activated": 1,
      "icon_name": "aurapositive",
      "comments": "none",
      "prerequisite_id": 1550,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 6,
      "short_description": "Damage to friendly champions within 3 spaces is reduced by 2. (this ability and its effects do not stack)",
      "long_description": "Damage to friendly champions within 3 spaces is reduced by 2. (this ability and its effects do not stack)",
      "class_name": "EnduringAura",
      "revision": 1
    },
    {
      "asset_id": 4801,
      "resettable": 1,
      "name": "Enduring Aura",
      "ap_cost": 0,
      "level": 5,
      "ability_id": 1552,
      "activated": 1,
      "icon_name": "aurapositive",
      "comments": "none",
      "prerequisite_id": 1551,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 9,
      "short_description": "Damage to friendly champions within 3 spaces is reduced by 3. (this ability and its effects do not stack)",
      "long_description": "Damage to friendly champions within 3 spaces is reduced by 3. (this ability and its effects do not stack)",
      "class_name": "EnduringAura",
      "revision": 1
    },
    {
      "asset_id": 4801,
      "resettable": 1,
      "name": "Enduring Aura",
      "ap_cost": 0,
      "level": 6,
      "ability_id": 1553,
      "activated": 1,
      "icon_name": "aurapositive",
      "comments": "none",
      "prerequisite_id": 1552,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 12,
      "short_description": "Damage to friendly champions within 4 spaces is reduced by 3. (this ability and its effects do not stack)",
      "long_description": "Damage to friendly champions within 4 spaces is reduced by 3. (this ability and its effects do not stack)",
      "class_name": "EnduringAura",
      "revision": 1
    },
    {
      "asset_id": 4223,
      "resettable": 1,
      "name": "Energy Thief",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 594,
      "activated": 1,
      "icon_name": "auranegative",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 8,
      "short_description": "When a non-illusion champion moves within 2 spaces of this champion, that champion loses 1 AP and this champion gains 1 AP. At the beginning of your turn, each champion within 2 spaces loses 1 AP, and then this champion gains 1 AP for each AP lost this way.",
      "long_description": "When a non-illusion champion moves within 2 spaces of this champion, that champion loses 1 AP and this champion gains 1 AP. At the beginning of your turn, each champion within 2 spaces loses 1 AP, and then this champion gains 1 AP for each AP lost this way.",
      "class_name": "APThief",
      "revision": 1
    },
    {
      "asset_id": 7431,
      "resettable": 0,
      "name": "Enervating Touch",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3154,
      "activated": 1,
      "icon_name": "touch_enervating",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "When this champion engages an enemy champion on its turn, that champion loses up to 2 AP and this champion gains AP equal to the amount lost. This ability can only trigger twice per turn.",
      "long_description": "When this champion engages an enemy champion on its turn, that champion loses up to 2 AP and this champion gains AP equal to the amount lost. This ability can only trigger twice per turn.",
      "class_name": "EnervatingTouch",
      "revision": 1
    },
    {
      "asset_id": 5036,
      "resettable": 1,
      "name": "Enfeeble",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1215,
      "activated": 1,
      "icon_name": "debuff",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "When this champion deals 1 or more damage to a champion on a basic attack, that champion becomes Enfeebled. (Enfeebled: This champion's ATK is reduced by 2 at the beginning of its owners turn until it reaches 0.)",
      "long_description": "When this champion deals 1 or more damage to a champion on a basic attack, that champion becomes Enfeebled. (Enfeebled: This champion's ATK is reduced by 2 at the beginning of its owners turn until it reaches 0.)",
      "class_name": "Enfeeble",
      "revision": 1
    },
    {
      "asset_id": 5812,
      "resettable": 1,
      "name": "Enforcement Action",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2821,
      "activated": 1,
      "icon_name": "aurapositive",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "When this champion makes a successful basic attack against an enemy champion, friendly champions with Devotee to D'elim gain +2 DMG for 4 turns.",
      "long_description": "When this champion makes a successful basic attack against an enemy champion, friendly champions with Devotee to D'elim gain +2 DMG for 4 turns.",
      "class_name": "EnforcementAction",
      "revision": 1
    },
    {
      "asset_id": 4411,
      "resettable": 1,
      "name": "Enhance Armor",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 739,
      "activated": 1,
      "icon_name": "defenseenhance",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "This unit gets -1 DEF and target champion gets +1 DEF. This ability may not be used if this unit has less than 1 DEF.",
      "long_description": "This unit gets -1 DEF and target champion gets +1 DEF. This ability may not be used if this unit has less than 1 DEF.",
      "class_name": "EnhanceArmor",
      "revision": 1
    },
    {
      "asset_id": 7606,
      "resettable": 0,
      "name": "Enigma Shield",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3233,
      "activated": 1,
      "icon_name": "enigma_shield",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "This champion is immune to damage from champion abilities (including basic attacks) if the source is not within 4 spaces.",
      "long_description": "This champion is immune to damage from champion abilities (including basic attacks) if the source is not within 4 spaces.",
      "class_name": "EnigmaShield",
      "revision": 1
    },
    {
      "asset_id": 4654,
      "resettable": 1,
      "name": "Enlightened",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1081,
      "activated": 1,
      "icon_name": "blessed",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "When this champion is healed, the amount is increased by 6.",
      "long_description": "When this champion is healed, the amount is increased by 6.",
      "class_name": "Enlightened",
      "revision": 1
    },
    {
      "asset_id": 4108,
      "resettable": 1,
      "name": "Enrage",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 259,
      "activated": 1,
      "icon_name": "enrage",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 2,
      "short_description": "When this unit is successfully attacked, it gets +3 DMG for 2 turns. This effect does not stack.",
      "long_description": "When this unit is successfully attacked, it gets +3 DMG for 2 turns. This effect does not stack.",
      "class_name": "Enrage",
      "revision": 1
    },
    {
      "asset_id": 4108,
      "resettable": 1,
      "name": "Enrage",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 260,
      "activated": 1,
      "icon_name": "enrage",
      "comments": "none",
      "prerequisite_id": 259,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 4,
      "short_description": "When this unit is successfully attacked, it gets +5 DMG for 2 turns. This effect does not stack.",
      "long_description": "When this unit is successfully attacked, it gets +5 DMG for 2 turns. This effect does not stack.",
      "class_name": "Enrage",
      "revision": 1
    },
    {
      "asset_id": 4108,
      "resettable": 1,
      "name": "Enrage",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 261,
      "activated": 1,
      "icon_name": "enrage",
      "comments": "none",
      "prerequisite_id": 260,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 6,
      "short_description": "When this unit is successfully attacked, it gets +7 DMG for 2 turns. This effect does not stack.",
      "long_description": "When this unit is successfully attacked, it gets +7 DMG for 2 turns. This effect does not stack.",
      "class_name": "Enrage",
      "revision": 1
    },
    {
      "asset_id": 4150,
      "resettable": 1,
      "name": "Ensnare",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 402,
      "activated": 1,
      "icon_name": "disable",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "This champion makes an attack against target opposing champion. If successful, the target becomes Ensnared 2 (loses flying and each movement costs an additional 2 AP) and takes 50% damage.",
      "long_description": "This champion makes an attack against target opposing champion. If successful, the target becomes Ensnared 2 (loses flying and each movement costs an additional 2 AP) and takes 50% damage.",
      "class_name": "Ensnare",
      "revision": 1
    },
    {
      "asset_id": 4526,
      "resettable": 1,
      "name": "Entangle",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 846,
      "activated": 1,
      "icon_name": "net",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "This unit makes a Physical attack at RNG 2-5 against target champion. If successful, that unit becomes <condition value=grounded>Grounded</condition> for 2 turns, <condition value=ensnared>Ensnared</condition> for 2 turns.",
      "long_description": "This unit makes a Physical attack at RNG 2-5 against target champion. If successful, that unit becomes <condition value=grounded>Grounded</condition> for 2 turns, <condition value=ensnared>Ensnared</condition> for 2 turns.",
      "class_name": "BolaAttack",
      "revision": 1
    },
    {
      "asset_id": 5170,
      "resettable": 1,
      "name": "Entangling Attack",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1947,
      "activated": 1,
      "icon_name": "disable",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "When this champion successfully damages a champion with a basic attack, that champion becomes <condition value=ensnared>Ensnared</condition> for 2 turns.",
      "long_description": "When this champion successfully damages a champion with a basic attack, that champion becomes <condition value=ensnared>Ensnared</condition> for 2 turns.",
      "class_name": "EntanglingAttack",
      "revision": 1
    },
    {
      "asset_id": 5158,
      "resettable": 1,
      "name": "Enveloping Mist",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1931,
      "activated": 1,
      "icon_name": "poison_cloud",
      "comments": "activated ability of \"Mist of the Dead\" relic",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "Opposing units within 5 spaces of this unit have their range reduced down to their minimum range for 4 turns.",
      "long_description": "Opposing units within 5 spaces of this unit have their range reduced down to their minimum range for 4 turns.",
      "class_name": "EnvelopingMist",
      "revision": 1
    },
    {
      "asset_id": 4579,
      "resettable": 1,
      "name": "Envenom",
      "ap_cost": 2,
      "level": 1,
      "ability_id": 987,
      "activated": 1,
      "icon_name": "poison",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 1,
      "cost": 4,
      "short_description": "Target opposing champion within 5 spaces becomes <condition value=poisoned>Poisoned</condition> for 1 turn and loses 3 AP at the start of their next turn.",
      "long_description": "Target opposing champion within 5 spaces becomes <condition value=poisoned>Poisoned</condition> for 1 turn and loses 3 AP at the start of their next turn.",
      "class_name": "Envenom",
      "revision": 1
    },
    {
      "asset_id": 4579,
      "resettable": 1,
      "name": "Envenom",
      "ap_cost": 2,
      "level": 2,
      "ability_id": 988,
      "activated": 1,
      "icon_name": "poison",
      "comments": "",
      "prerequisite_id": 987,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 1,
      "cost": 5,
      "short_description": "Target opposing champion within 5 spaces becomes <condition value=poisoned>Poisoned</condition> for 1 turn and loses 4 AP at the start of their next turn.",
      "long_description": "Target opposing champion within 5 spaces becomes <condition value=poisoned>Poisoned</condition> for 1 turn and loses 4 AP at the start of their next turn.",
      "class_name": "Envenom",
      "revision": 1
    },
    {
      "asset_id": 5801,
      "resettable": 1,
      "name": "Epochal Oasis",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2793,
      "activated": 1,
      "icon_name": "relocate",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 5,
      "short_description": "Friendly Elves within 3 spaces have Teleport 2.",
      "long_description": "Friendly Elves within 3 spaces have Teleport 2.",
      "class_name": "EpochalOasis",
      "revision": 1
    },
    {
      "asset_id": 5037,
      "resettable": 1,
      "name": "Equalize",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1216,
      "activated": 1,
      "icon_name": "cost",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "If your enemy controls more champions than you, receive a 15% nora refund when this champion comes into play.",
      "long_description": "If your enemy controls more champions than you, receive a 15% nora refund when this champion comes into play.",
      "class_name": "Equalize",
      "revision": 51
    },
    {
      "asset_id": 7505,
      "resettable": 0,
      "name": "Equip: Desert Brew",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3180,
      "activated": 1,
      "icon_name": "comboatk_devastate",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 12,
      "short_description": "This champion comes into play equipped with a Desert Brew.\r\n",
      "long_description": "This champion comes into play equipped with a Desert Brew.\r\n",
      "class_name": "EquipDesertBrew",
      "revision": 1
    },
    {
      "asset_id": 7889,
      "resettable": 0,
      "name": "Equip: Dwarven Ukulele",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3336,
      "activated": 1,
      "icon_name": "comboatk_devastate",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 15,
      "short_description": "This champion comes into play equipped with a Dwarven Ukulele.",
      "long_description": "This champion comes into play equipped with a Dwarven Ukulele.",
      "class_name": "EquipDwarvenUkulele",
      "revision": 1
    },
    {
      "asset_id": 7977,
      "resettable": 0,
      "name": "Equip: Firebeard Brew",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3364,
      "activated": 1,
      "icon_name": "comboatk_devastate",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 12,
      "short_description": "Unit is equipped with a Firebeard Brew (Equipped Champion is intoxicated. If the equipped champion is a dwarf it heals 3 hp per turn and gains burn rank 1. If not, it takes 3 fire damage per turn and is inhibited.)",
      "long_description": "Unit is equipped with a Firebeard Brew (Equipped Champion is intoxicated. If the equipped champion is a dwarf it heals 3 hp per turn and gains burn rank 1. If not, it takes 3 fire damage per turn and is inhibited.)",
      "class_name": "EquipFirebeardBrew",
      "revision": 1
    },
    {
      "asset_id": 5807,
      "resettable": 1,
      "name": "Equip: Frostcall Quiver",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2816,
      "activated": 1,
      "icon_name": "comboatk_devastate",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "This unit comes into play equipped with Frostcall Quiver.",
      "long_description": "This unit comes into play equipped with Frostcall Quiver.",
      "class_name": "EquipFrostcallQuiver",
      "revision": 1
    },
    {
      "asset_id": 7298,
      "resettable": 0,
      "name": "Equip: Heretic Shackle",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3084,
      "activated": 1,
      "icon_name": "comboatk_devastate",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 10,
      "short_description": "When this champion comes into play, the closest enemy champion is equipped with a Heretic Shackle.",
      "long_description": "When this champion comes into play, the closest enemy champion is equipped with a Heretic Shackle.",
      "class_name": "EquipHereticCollar",
      "revision": 1
    },
    {
      "asset_id": 5749,
      "resettable": 1,
      "name": "Equip: Holy Blade",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2653,
      "activated": 1,
      "icon_name": "comboatk_devastate",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "This champion comes into play equipped with a Holy Blade of Valdac.",
      "long_description": "This champion comes into play equipped with a Holy Blade of Valdac.",
      "class_name": "EquipHolyBlade",
      "revision": 1
    },
    {
      "asset_id": 5826,
      "resettable": 1,
      "name": "Equip: Mindflayer",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2835,
      "activated": 1,
      "icon_name": "comboatk_devastate",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "This champion comes into play equipped with a Mindflayer. \r\n",
      "long_description": "This champion comes into play equipped with a Mindflayer. \r\n",
      "class_name": "EquipMindflayer",
      "revision": 1
    },
    {
      "asset_id": 5749,
      "resettable": 1,
      "name": "Equip: Seed of Potential",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2675,
      "activated": 1,
      "icon_name": "comboatk_devastate",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 15,
      "short_description": "When this champion is deployed, it is equipped with a Seed of Potential.",
      "long_description": "When this champion is deployed, it is equipped with a Seed of Potential.",
      "class_name": "EquipSeedOfPotential",
      "revision": 1
    },
    {
      "asset_id": 7322,
      "resettable": 0,
      "name": "Equip: St Semmir's Brew",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3098,
      "activated": 1,
      "icon_name": "comboatk_devastate",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 12,
      "short_description": "This champion comes into play equipped with a St Semmir's Brew.\r\n",
      "long_description": "This champion comes into play equipped with a St Semmir's Brew.",
      "class_name": "EquipStSemmirsBrew",
      "revision": 1
    },
    {
      "asset_id": 7500,
      "resettable": 0,
      "name": "Equip: Thunderaxe",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3178,
      "activated": 1,
      "icon_name": "comboatk_devastate",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 20,
      "short_description": "This champion comes into play equipped with a Thunderaxe. (Equipped champion has <ability value=1739>Paralytic Feedback</ability> and <ability value=3172>Chuck: Thunderaxe</ability>. If the champion is Race: Minotaur, it also gains <ability value=3251>Portal Blast</ability>)",
      "long_description": "This champion comes into play equipped with a Thunderaxe. (Equipped champion has <ability value=1739>Paralytic Feedback</ability> and <ability value=3172>Chuck: Thunderaxe</ability>. If the champion is Race: Minotaur, it also gains <ability value=3251>Portal Blast</ability>)",
      "class_name": "EquipThunderaxe",
      "revision": 1
    },
    {
      "asset_id": 5014,
      "resettable": 1,
      "name": "Equipment Boon",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1194,
      "activated": 1,
      "icon_name": "buff",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "This champion gains +2 max HP and +1 DMG for each friendly equipment in play.",
      "long_description": "This champion gains +2 max HP and +1 DMG for each friendly equipment in play.",
      "class_name": "Blacksmith",
      "revision": 1
    },
    {
      "asset_id": 7508,
      "resettable": 0,
      "name": "Equippable",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 3183,
      "activated": 1,
      "icon_name": "loyalty",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "This relic can be picked up and equipped by its owner.",
      "long_description": "This relic can be picked up and equipped by its owner.",
      "class_name": "Equippable",
      "revision": 1
    },
    {
      "asset_id": 5352,
      "resettable": 1,
      "name": "Eradicate",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2184,
      "activated": 1,
      "icon_name": "eradicate",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 12,
      "short_description": "Spend all charges. Target champion within 5 spaces loses 2 HP for each charge spent this way (up to 20 HP).",
      "long_description": "Spend all charges. Target champion within 5 spaces loses 2 HP for each charge spent this way (up to 20 HP).",
      "class_name": "Eradicate",
      "revision": 1
    },
    {
      "asset_id": 4372,
      "resettable": 1,
      "name": "Erratic",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 1945,
      "activated": 1,
      "icon_name": "ondeath",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": -35,
      "short_description": "This unit is automatically removed from play the end of the turn after its deployment",
      "long_description": "This unit is automatically removed from play the end of the turn after its deployment",
      "class_name": "Erratic",
      "revision": 1
    },
    {
      "asset_id": 4372,
      "resettable": 1,
      "name": "Erratic",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 1411,
      "activated": 1,
      "icon_name": "ondeath",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": -35,
      "short_description": "This unit is automatically removed from play the end of the turn it is deployed.",
      "long_description": "This unit is automatically removed from play the end of the turn it is deployed.",
      "class_name": "Erratic",
      "revision": 1
    },
    {
      "asset_id": 7143,
      "resettable": 0,
      "name": "Escalating Rage",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2985,
      "activated": 1,
      "icon_name": "escalating_rage",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 8,
      "short_description": "At the beginning of its turn, this champion gains +2 DMG.  Every 4th trigger, it also gains full AP.  At the end of that turn, all DMG bonuses from this ability are removed.",
      "long_description": "At the beginning of its turn, this champion gains +2 DMG.  Every 4th trigger, it also gains full AP.  At the end of that turn, all DMG bonuses from this ability are removed.",
      "class_name": "EscalatingRage",
      "revision": 1
    },
    {
      "asset_id": 4519,
      "resettable": 1,
      "name": "Escalation",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1494,
      "activated": 1,
      "icon_name": "surge",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "This champion gains +1 DMG at the beginning of its owner's turns.",
      "long_description": "This champion gains +1 DMG at the beginning of its owner's turns.",
      "class_name": "Escalation",
      "revision": 1
    },
    {
      "asset_id": 4593,
      "resettable": 1,
      "name": "Escape",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1454,
      "activated": 1,
      "icon_name": "stealth",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "This unit becomes <condition value=stealthed>Stealthed</condition> for 3 turns at the end of any turn it was successfully damaged.",
      "long_description": "This unit becomes <condition value=stealthed>Stealthed</condition> for 3 turns at the end of any turn it was successfully damaged.",
      "class_name": "Escape",
      "revision": 1
    },
    {
      "asset_id": 4234,
      "resettable": 1,
      "name": "Essence Capture",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 607,
      "activated": 1,
      "icon_name": "noragen",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 5,
      "short_description": "When this champion deals damage to a champion on a basic attack, you gain nora equal to 30% of the damage dealt.",
      "long_description": "When this champion deals damage to a champion on a basic attack, you gain nora equal to 30% of the damage dealt.",
      "class_name": "EssenceCapture",
      "revision": 1
    },
    {
      "asset_id": 7157,
      "resettable": 0,
      "name": "Essence Claw",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 2999,
      "activated": 1,
      "icon_name": "deathnovapsychic",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 13,
      "short_description": "This champion makes a Psychic attack against target champion at RNG 1. If this destroys the champion, a 20 HP copy of the destroyed champion with <ability value=2372>Warding</ability> is summoned in its place under your control.",
      "long_description": "This champion makes a Psychic attack against target champion at RNG 1. If this destroys the champion, a 20 HP copy of the destroyed champion with <ability value=2372>Warding</ability> is summoned in its place under your control.",
      "class_name": "EssenceClaw",
      "revision": 1
    },
    {
      "asset_id": 4549,
      "resettable": 1,
      "name": "Eternal",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 942,
      "activated": 1,
      "icon_name": "bloodless",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "This unit cannot be Sacrificed.",
      "long_description": "This unit cannot be Sacrificed.",
      "class_name": "Bloodless",
      "revision": 1
    },
    {
      "asset_id": 7495,
      "resettable": 0,
      "name": "Eternal Life",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3175,
      "activated": 1,
      "icon_name": "phylactery",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "This unit has <ability value=942>Eternal</ability>. If a Phylactery is in play when this unit dies, your Shrine or Avatar loses 5 HP and the nearest Phylactery relic is destroyed and this unit is reanimated in its place.",
      "long_description": "This unit has <ability value=942>Eternal</ability>. If a Phylactery is in play when this unit dies, your Shrine or Avatar loses 5 HP and the nearest Phylactery relic is destroyed and this unit is reanimated in its place.",
      "class_name": "EternalLife",
      "revision": 1
    },
    {
      "asset_id": 5387,
      "resettable": 1,
      "name": "Eternal Storm",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2219,
      "activated": 1,
      "icon_name": "eternal_storm",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 30,
      "short_description": "At the beginning of your opponent's turns, for every charge on this unit, it deals 1 damage (type is one of the following types: fire, frost, magic, sonic, electricity, disease, poison, and psychic) to each opposing champion within 6 spaces.  This damage ignores DEF.",
      "long_description": "At the beginning of your opponent's turns, for every charge on this unit, it deals 1 damage (type is one of the following types: fire, frost, magic, sonic, electricity, disease, poison, and psychic) to each opposing champion within 6 spaces.  This damage ignores DEF.",
      "class_name": "EternalStorm",
      "revision": 1
    },
    {
      "asset_id": 4855,
      "resettable": 1,
      "name": "Ethereal",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1737,
      "activated": 1,
      "icon_name": "ethereal",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "This champion begins play <condition value=incorporeal>Incorporeal</condition> for 2 turns and becomes Incorporeal for 2 turns at the start of each of your other turns.",
      "long_description": "This champion begins play <condition value=incorporeal>Incorporeal</condition> for 2 turns and becomes Incorporeal for 2 turns at the start of each of your other turns.",
      "class_name": "Ethereal",
      "revision": 1
    },
    {
      "asset_id": 7130,
      "resettable": 0,
      "name": "Ethereal Being",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 2967,
      "activated": 1,
      "icon_name": "blessed",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 15,
      "short_description": "This unit is <condition value=incorporeal>Incorporeal</condition> and <condition value=pacified>Pacified</condition>. When activated or if this unit takes damage, it loses <condition value=incorporeal popup=false>Incorporeal</condition> and <condition value=pacified popup=false>Pacified</condition> until the end of the next turn.",
      "long_description": "This unit is <condition value=incorporeal>Incorporeal</condition> and <condition value=pacified>Pacified</condition>. When this ability is activated or this unit takes damage while <condition value=incorporeal popup=false>Incorporeal</condition>, it loses <condition value=incorporeal popup=false>Incorporeal</condition> and <condition value=pacified>Pacified</condition> until the end of the next turn.",
      "class_name": "EtherealBeing",
      "revision": 1
    },
    {
      "asset_id": 7356,
      "resettable": 0,
      "name": "Ethereal Hammer",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 3113,
      "activated": 1,
      "icon_name": "magic",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 3,
      "ranked": 0,
      "cost": 3,
      "short_description": "Make a Magical attack at 1-3 Range.",
      "long_description": "Make a Magical attack at 1-3 Range.",
      "class_name": "EtherealHammerAttack",
      "revision": 1
    },
    {
      "asset_id": 7979,
      "resettable": 0,
      "name": "Ethereal Pool",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3366,
      "activated": 1,
      "icon_name": "shrinebad",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "Friendly champions with race Archdemon within 5 spaces of this unit gain <ability value=1534>Spell Resistance</ability> and <ability value=1603>Reflection 2</ability>.",
      "long_description": "Friendly champions with race Archdemon within 5 spaces of this unit gain <ability value=1534>Spell Resistance</ability> and <ability value=1603>Reflection 2</ability>.",
      "class_name": "ForbiddenInsight",
      "revision": 1
    },
    {
      "asset_id": 4458,
      "resettable": 1,
      "name": "Euan's Hammer",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 811,
      "activated": 1,
      "icon_name": "magic",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "This champion makes a Magical attack at RNG 2-5. If successfully damaged, the target is knocked back 2 spaces and is <condition value=illuminated>Illuminated</condition> for 4 turns.",
      "long_description": "This champion makes a Magical attack at RNG 2-5. If successfully damaged, the target is knocked back 2 spaces and is <condition value=illuminated>Illuminated</condition> for 4 turns.",
      "class_name": "EuansHammer",
      "revision": 1
    },
    {
      "asset_id": 4346,
      "resettable": 1,
      "name": "Evasive",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 1376,
      "activated": 1,
      "icon_name": "resistance_ranged",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 3,
      "short_description": "This unit takes 20% less damage (after DEF) from ranged attacks.",
      "long_description": "This unit takes 20% less damage (after DEF) from ranged attacks.",
      "class_name": "Evasive",
      "revision": 1
    },
    {
      "asset_id": 4346,
      "resettable": 1,
      "name": "Evasive",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 1377,
      "activated": 1,
      "icon_name": "resistance_ranged",
      "comments": "",
      "prerequisite_id": 1376,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 6,
      "short_description": "This unit takes 35% less damage (after DEF) from ranged attacks.",
      "long_description": "This unit takes 35% less damage (after DEF) from ranged attacks.",
      "class_name": "Evasive",
      "revision": 1
    },
    {
      "asset_id": 4346,
      "resettable": 1,
      "name": "Evasive",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 1378,
      "activated": 1,
      "icon_name": "resistance_ranged",
      "comments": "",
      "prerequisite_id": 1377,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 9,
      "short_description": "This unit takes 50% less damage (after DEF) from ranged attacks.",
      "long_description": "This unit takes 50% less damage (after DEF) from ranged attacks.",
      "class_name": "Evasive",
      "revision": 1
    },
    {
      "asset_id": 5734,
      "resettable": 1,
      "name": "Eviscerating Luminescence",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2621,
      "activated": 1,
      "icon_name": "destabilizing_luminesence",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "When this unit is deployed and at the start of its turns, opposing champions within 4 spaces take 4 Physical damage and become <condition value=eviscerated>Eviscerated</condition> for 2 turns.",
      "long_description": "When this unit is deployed and at the start of its turns, opposing champions within 4 spaces take 4 Physical damage and become <condition value=eviscerated>Eviscerated</condition> for 2 turns.",
      "class_name": "EvisceratingLuminescence",
      "revision": 1
    },
    {
      "asset_id": 4812,
      "resettable": 1,
      "name": "Evolution",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 1605,
      "activated": 1,
      "icon_name": "",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 6,
      "short_description": "This champion has Leap 2",
      "long_description": "This champion has Leap 2",
      "class_name": "Evolution",
      "revision": 1
    },
    {
      "asset_id": 4812,
      "resettable": 1,
      "name": "Evolution",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 1607,
      "activated": 1,
      "icon_name": "",
      "comments": "",
      "prerequisite_id": 1605,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 6,
      "short_description": "This champion has Leap 3",
      "long_description": "This champion has Leap 3",
      "class_name": "Evolution",
      "revision": 1
    },
    {
      "asset_id": 5505,
      "resettable": 1,
      "name": "Evolution: Draksar Confessor",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 2364,
      "activated": 1,
      "icon_name": "mutation",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "This champion has <ability value=332>Sunder 1</ability>. When this ability is activated, the granted ability cycles to <ability value=1952>Slam</ability>, then to <ability value=3295>Healing Mind</ability>, then back to Sunder 1.",
      "long_description": "This champion has <ability value=332>Sunder 1</ability>. When this ability is activated, the granted ability cycles to <ability value=1952>Slam</ability>, then to <ability value=3295>Healing Mind</ability>, then back to Sunder 1.",
      "class_name": "EvolutionMutatedMorph",
      "revision": 1
    },
    {
      "asset_id": 4438,
      "resettable": 1,
      "name": "Evolution: Mutated Drake",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 658,
      "activated": 1,
      "icon_name": "mutation",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 9,
      "short_description": "This champion has <ability value=2493>Scour 3</ability>. When this ability is activated, the granted ability cycles to <ability value=2533>Acid Acolyte</ability>, then to <ability value=2994>Vigor: Acid</ability>, then back to Scour 3.",
      "long_description": "This champion has <ability value=2493>Scour 3</ability>. When this ability is activated, the granted ability cycles to <ability value=2533>Acid Acolyte</ability>, then to <ability value=2994>Vigor: Acid</ability>, then back to Scour 3.",
      "class_name": "EvolutionMutatedDrake",
      "revision": 1
    },
    {
      "asset_id": 4273,
      "resettable": 1,
      "name": "Execute",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 684,
      "activated": 1,
      "icon_name": "execute",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "For 1 turn, the next basic attack made by this unit deals 50% more damage if the target is a champion.",
      "long_description": "For 1 turn, the next basic attack made by this unit deals 50% more damage if the target is a champion.",
      "class_name": "Execute",
      "revision": 1
    },
    {
      "asset_id": 4143,
      "resettable": 1,
      "name": "Exertion",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 374,
      "activated": 1,
      "icon_name": "crazed_charger",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 1,
      "cost": 1,
      "short_description": "This champion loses 8 HP and gains 1 AP. This ability begins on CD.",
      "long_description": "This champion loses 8 HP and gains 1 AP. This ability begins on CD.",
      "class_name": "Exertion",
      "revision": 1
    },
    {
      "asset_id": 4143,
      "resettable": 1,
      "name": "Exertion",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 375,
      "activated": 1,
      "icon_name": "crazed_charger",
      "comments": "none",
      "prerequisite_id": 374,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 1,
      "cost": 2,
      "short_description": "This champion loses 8 HP and gains 2 AP. This ability begins on CD.",
      "long_description": "This champion loses 8 HP and gains 2 AP. This ability begins on CD.",
      "class_name": "Exertion",
      "revision": 1
    },
    {
      "asset_id": 4143,
      "resettable": 1,
      "name": "Exertion",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 376,
      "activated": 1,
      "icon_name": "crazed_charger",
      "comments": "none",
      "prerequisite_id": 375,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 1,
      "cost": 3,
      "short_description": "This champion loses 8 HP and gains 3 AP.  This ability begins on CD.",
      "long_description": "This champion loses 8 HP and gains 3 AP.  This ability begins on CD.",
      "class_name": "Exertion",
      "revision": 1
    },
    {
      "asset_id": 4305,
      "resettable": 1,
      "name": "Exhume",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1333,
      "activated": 1,
      "icon_name": "revive",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 9,
      "activation_type": 1,
      "ranked": 0,
      "cost": 9,
      "short_description": "Target adjacent champion you own will be reanimated when destroyed. This champion is destroyed when the target of this ability is reanimated and gains an additional 20 turn cooldown. If this champion is destroyed before the target, the target will not be reanimated.  This effect is hidden until triggered.",
      "long_description": "Target adjacent champion you own will be reanimated when destroyed. This champion is destroyed when the target of this ability is reanimated and gains an additional 20 turn cooldown. If this champion is destroyed before the target, the target will not be reanimated.  This effect is hidden until triggered.",
      "class_name": "Exhume",
      "revision": 1
    },
    {
      "asset_id": 4648,
      "resettable": 1,
      "name": "Exorcism",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 1077,
      "activated": 1,
      "icon_name": "special",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "Make an attack against a Wrath champion with +2 DMG. If the champion is destroyed by this attack, it returns to the owner's dock with +5 rounds to its cooldown.",
      "long_description": "Make an attack against a Wrath champion with +2 DMG. If the champion is destroyed by this attack, it returns to the owner's dock with +5 rounds to its cooldown.",
      "class_name": "Exorcism",
      "revision": 1
    },
    {
      "asset_id": 4616,
      "resettable": 1,
      "name": "Expedite",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1455,
      "activated": 1,
      "icon_name": "scry",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 2,
      "short_description": "When this unit successfully attacks, you gain a rune reveal.",
      "long_description": "When this unit successfully attacks, you gain a rune reveal.",
      "class_name": "Expedite",
      "revision": 1
    },
    {
      "asset_id": 4469,
      "resettable": 1,
      "name": "Explosive Attack",
      "ap_cost": 1,
      "level": 1,
      "ability_id": 837,
      "activated": 1,
      "icon_name": "knockback",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 1,
      "cost": 4,
      "short_description": "This unit makes a Fire attack at range at +2 DMG.   If successfully damaged, the target is knocked back 1 space. ",
      "long_description": "This unit makes a Fire attack at range at +2 DMG.   If successfully damaged, the target is knocked back 1 space. ",
      "class_name": "ExplosiveAttack",
      "revision": 1
    },
    {
      "asset_id": 4469,
      "resettable": 1,
      "name": "Explosive Attack",
      "ap_cost": 1,
      "level": 2,
      "ability_id": 838,
      "activated": 1,
      "icon_name": "knockback",
      "comments": "",
      "prerequisite_id": 837,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 1,
      "cost": 7,
      "short_description": "This unit makes a Fire attack at range at +4 DMG.   If successfully damaged, the target is knocked back 1 space. ",
      "long_description": "This unit makes a Fire attack at range at +4 DMG.   If successfully damaged, the target is knocked back 1 space. ",
      "class_name": "ExplosiveAttack",
      "revision": 1
    },
    {
      "asset_id": 4469,
      "resettable": 1,
      "name": "Explosive Attack",
      "ap_cost": 1,
      "level": 3,
      "ability_id": 839,
      "activated": 1,
      "icon_name": "knockback",
      "comments": "",
      "prerequisite_id": 838,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 1,
      "cost": 10,
      "short_description": "This unit makes a Fire attack at range at +6 DMG.   If successfully damaged, the target is knocked back 1 space. ",
      "long_description": "This unit makes a Fire attack at range at +6 DMG.   If successfully damaged, the target is knocked back 1 space. ",
      "class_name": "ExplosiveAttack",
      "revision": 1
    },
    {
      "asset_id": 4676,
      "resettable": 1,
      "name": "Extinguish",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1114,
      "activated": 1,
      "icon_name": "resistance_fire",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 6,
      "short_description": "When a friendly champion takes Fire damage, it is healed for up to 4 HP (or the amount of damage taken) at the end of that turn. If the champion is affected by <condition value=charred>Charred</condition>, the Charred condition is removed as well. This effect does not stack.",
      "long_description": "When a friendly champion takes Fire damage, it is healed for up to 4 HP (or the amount of damage taken) at the end of that turn. If the champion is affected by <condition value=charred>Charred</condition>, the Charred condition is removed as well. This effect does not stack.",
      "class_name": "Extinguish",
      "revision": 1
    },
    {
      "asset_id": 7630,
      "resettable": 0,
      "name": "Extinguish Matter",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 3238,
      "activated": 1,
      "icon_name": "reclaim_materials",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "Target relic or equipment on target champion within 3 spaces is destroyed and the closest enemy champion within 5 spaces to the target takes 10 Magical damage and becomes <condition value=cursed>Cursed 5</condition>.",
      "long_description": "Target relic or equipment on target champion within 3 spaces is destroyed and the closest enemy champion within 5 spaces to the target takes 10 Magical damage and becomes <condition value=cursed>Cursed 5</condition>.",
      "class_name": "ExtinguishMatter",
      "revision": 1
    },
    {
      "asset_id": 4306,
      "resettable": 1,
      "name": "Extraction",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 1334,
      "activated": 1,
      "icon_name": "terrainslime",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 30,
      "short_description": "Target unoccupied, adjacent space becomes Ooze for 5 turns and you gain 15 nora.",
      "long_description": "Target unoccupied, adjacent space becomes Ooze for 5 turns and you gain 15 nora.",
      "class_name": "Extraction",
      "revision": 1
    },
    {
      "asset_id": 4363,
      "resettable": 1,
      "name": "Fading Light",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1396,
      "activated": 1,
      "icon_name": "stealth",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this champion recovers a nora globe, it becomes <condition value=stealthed>Stealthed</condition>.",
      "long_description": "When this champion recovers a nora globe, it becomes <condition value=stealthed>Stealthed</condition>.",
      "class_name": "FadingLight",
      "revision": 1
    },
    {
      "asset_id": 4295,
      "resettable": 1,
      "name": "Failed Amplifier",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 697,
      "activated": 1,
      "icon_name": "special",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 1,
      "short_description": "No spells may be cast after one is successfully cast each turn.",
      "long_description": "No spells may be cast after one is successfully cast each turn.",
      "class_name": "RelicFailedAmplifier",
      "revision": 1
    },
    {
      "asset_id": 5566,
      "resettable": 1,
      "name": "Fairy Dust",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2426,
      "activated": 1,
      "icon_name": "fairydust",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "Target champion within 4 spaces gains <ability value=2266>Wandering</ability> for 2 Turns. ",
      "long_description": "Target champion within 4 spaces gains <ability value=2266>Wandering</ability> for 2 Turns. ",
      "class_name": "InvokeFairyDust",
      "revision": 1
    },
    {
      "asset_id": 7129,
      "resettable": 0,
      "name": "Fairy Flight",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2966,
      "activated": 1,
      "icon_name": "flight_fairy",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 2,
      "short_description": "This unit has <condition value=flying>Flying</condition> while it has at least 15 HP. When this unit has less than 15 HP, it gains <ability value=2001>Defenseless</ability>.",
      "long_description": "This unit has <condition value=flying>Flying</condition> while it has at least 15 HP. When this unit has less than 15 HP, it gains <ability value=2001>Defenseless</ability>.",
      "class_name": "FairyFlight",
      "revision": 1
    },
    {
      "asset_id": 5226,
      "resettable": 1,
      "name": "Faithless",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2004,
      "activated": 1,
      "icon_name": "dead_magic_zone",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -3,
      "short_description": "This unit has no spell presence.",
      "long_description": "This unit has no spell presence.",
      "class_name": "Faithless",
      "revision": 1
    },
    {
      "asset_id": 5211,
      "resettable": 1,
      "name": "Familiar",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1988,
      "activated": 1,
      "icon_name": "revere",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "While Grimlic or Demonologist is in play, when a friendly Wizard or Imp uses an activated ability that is not a basic attack, that ability has its cooldown reduced by 1 to a minimum of 1. This ability does not stack.",
      "long_description": "While Grimlic or Demonologist is in play, when a friendly Wizard or Imp uses an activated ability that is not a basic attack, that ability has its cooldown reduced by 1 to a minimum of 1. This ability does not stack.",
      "class_name": "Familiar",
      "revision": 1
    },
    {
      "asset_id": 4133,
      "resettable": 1,
      "name": "Farshot",
      "ap_cost": 1,
      "level": 1,
      "ability_id": 334,
      "activated": 1,
      "icon_name": "arrow",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 1,
      "cost": 2,
      "short_description": "This champion makes a ranged attack at +1 RNG and +1 AP.",
      "long_description": "This champion makes a ranged attack at +1 RNG and +1 AP.",
      "class_name": "Farshot",
      "revision": 1
    },
    {
      "asset_id": 4133,
      "resettable": 1,
      "name": "Farshot",
      "ap_cost": 1,
      "level": 2,
      "ability_id": 335,
      "activated": 1,
      "icon_name": "arrow",
      "comments": "none",
      "prerequisite_id": 334,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 1,
      "cost": 6,
      "short_description": "This champion makes a ranged attack at +2 RNG and +1 AP.",
      "long_description": "This champion makes a ranged attack at +2 RNG and +1 AP.",
      "class_name": "Farshot",
      "revision": 1
    },
    {
      "asset_id": 4133,
      "resettable": 1,
      "name": "Farshot",
      "ap_cost": 1,
      "level": 3,
      "ability_id": 336,
      "activated": 1,
      "icon_name": "arrow",
      "comments": "none",
      "prerequisite_id": 335,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 1,
      "cost": 9,
      "short_description": "This champion makes a ranged attack at +3 RNG and +1 AP.",
      "long_description": "This champion makes a ranged attack at +3 RNG and +1 AP.",
      "class_name": "Farshot",
      "revision": 1
    },
    {
      "asset_id": 4308,
      "resettable": 1,
      "name": "Fascinate",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1336,
      "activated": 1,
      "icon_name": "illuminate",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "At the beginning of your turn, any enemy champion without <ability value=4 popup=false>Iron Will</ability> within 5 spaces of this unit is moved 2 spaces directly towards this unit.",
      "long_description": "At the beginning of your turn, any enemy champion without <ability value=4 popup=false>Iron Will</ability> within 5 spaces of this unit is moved 2 spaces directly towards this unit.",
      "class_name": "Fascinate",
      "revision": 1
    },
    {
      "asset_id": 5038,
      "resettable": 1,
      "name": "Faultbreak",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1217,
      "activated": 1,
      "icon_name": "crush",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this champion moves by way of its normal movement, enemy champions within 2 spaces lose 1 AP.",
      "long_description": "When this champion moves by way of its normal movement, enemy champions within 2 spaces lose 1 AP.",
      "class_name": "FaultBreak",
      "revision": 1
    },
    {
      "asset_id": 5039,
      "resettable": 1,
      "name": "Favor",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1218,
      "activated": 1,
      "icon_name": "nora",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "When you successfully cast a spell that shares a faction with this unit, you gain 5 nora. This does not stack.",
      "long_description": "When you successfully cast a spell that shares a faction with this unit, you gain 5 nora. This does not stack.",
      "class_name": "Favor",
      "revision": 1
    },
    {
      "asset_id": 4163,
      "resettable": 1,
      "name": "Fear",
      "ap_cost": 2,
      "level": 1,
      "ability_id": 454,
      "activated": 1,
      "icon_name": "fear",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 1,
      "cost": 2,
      "short_description": "Adjacent enemy champions become <condition value=frightened>Frightened</condition> for 2 turns.",
      "long_description": "Adjacent enemy champions become <condition value=frightened>Frightened</condition> for 2 turns.",
      "class_name": "Fear",
      "revision": 1
    },
    {
      "asset_id": 4163,
      "resettable": 1,
      "name": "Fear",
      "ap_cost": 2,
      "level": 2,
      "ability_id": 455,
      "activated": 1,
      "icon_name": "fear",
      "comments": "none",
      "prerequisite_id": 454,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 1,
      "cost": 5,
      "short_description": "Enemy champions within 2 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
      "long_description": "Enemy champions within 2 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
      "class_name": "Fear",
      "revision": 1
    },
    {
      "asset_id": 4163,
      "resettable": 1,
      "name": "Fear",
      "ap_cost": 2,
      "level": 3,
      "ability_id": 456,
      "activated": 1,
      "icon_name": "fear",
      "comments": "none",
      "prerequisite_id": 455,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 1,
      "cost": 7,
      "short_description": "Enemy champions within 3 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
      "long_description": "Enemy champions within 3 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
      "class_name": "Fear",
      "revision": 1
    },
    {
      "asset_id": 4002,
      "resettable": 1,
      "name": "Fearless",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3,
      "activated": 1,
      "icon_name": "buff",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 2,
      "short_description": "This unit can not become <condition value=frightened>Frightened</condition>",
      "long_description": "This unit can not become <condition value=frightened>Frightened</condition>",
      "class_name": "Fearless",
      "revision": 1
    },
    {
      "asset_id": 7144,
      "resettable": 0,
      "name": "Fearsome Hunter",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2986,
      "activated": 1,
      "icon_name": "fear",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 3,
      "short_description": "When this champion destroys an enemy champion, enemy champions within 5 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
      "long_description": "When this champion destroys an enemy champion, enemy champions within 5 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
      "class_name": "FearsomeHunter",
      "revision": 1
    },
    {
      "asset_id": 4256,
      "resettable": 1,
      "name": "Feeding Frenzy",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 654,
      "activated": 1,
      "icon_name": "aquatic",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 0,
      "short_description": "This unit is destroyed after attacking.",
      "long_description": "This unit is destroyed after attacking.",
      "class_name": "FeedingFrenzyEffect",
      "revision": 1
    },
    {
      "asset_id": 5883,
      "resettable": 1,
      "name": "Feint",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2892,
      "activated": 1,
      "icon_name": "feint",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 3,
      "short_description": "This Champion makes a 0 damage attack against target champion within 5 spaces. This attack is not part of the attack chain. If this attack is successful, the attacked champion gains 1 stack of <condition value=sundered>Sundered</condition> for 1 turn. ",
      "long_description": "This Champion makes a 0 damage attack against target champion within 5 spaces. This attack is not part of the attack chain. If this attack is successful, the attacked champion gains 1 stack of <condition value=sundered>Sundered</condition> for 1 turn. ",
      "class_name": "Feint",
      "revision": 1
    },
    {
      "asset_id": 7544,
      "resettable": 0,
      "name": "Fellowship",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3198,
      "activated": 1,
      "icon_name": "solo_cleanse",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "When a friendly champion is deployed from the runedock, this champion is healed for 4 HP. If the deployed champion shares a race or class with this champion, this champion is healed for 6 HP instead.",
      "long_description": "When a friendly champion is deployed from the runedock, this champion is healed for 4 HP. If the deployed champion shares a race or class with this champion, this champion is healed for 6 HP instead.",
      "class_name": "Fellowship",
      "revision": 1
    },
    {
      "asset_id": 7964,
      "resettable": 0,
      "name": "Fen Teachings",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3351,
      "activated": 1,
      "icon_name": "amphib",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "This unit has <ability value=2>Amphibious</ability> and <ability value=600>Arctic</ability>.",
      "long_description": "This unit has <ability value=2>Amphibious</ability> and <ability value=600>Arctic</ability>.",
      "class_name": "FenTeachings",
      "revision": 1
    },
    {
      "asset_id": 7327,
      "resettable": 0,
      "name": "Ferocious Bite",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3101,
      "activated": 1,
      "icon_name": "ancestral_avenger",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "When this champion makes a successful basic attack, that champion has -3 DMG for 2 turns. This does not stack. If the target is <condition value=distracted>Distracted</condition> or <condition value=illuminated>Illuminated</condition>, that champion also gains 2 stacks of <condition value=sundered>Sundered</condition> for 3 turns.",
      "long_description": "When this champion makes a successful basic attack, that champion has -3 DMG for 2 turns. This does not stack. If the target is <condition value=distracted>Distracted</condition> or <condition value=illuminated>Illuminated</condition>, that champion also gains 2 stacks of <condition value=sundered>Sundered</condition> for 3 turns.",
      "class_name": "FerociousBite",
      "revision": 1
    },
    {
      "asset_id": 7453,
      "resettable": 0,
      "name": "Ferren Focus",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3160,
      "activated": 1,
      "icon_name": "ferren_focus",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "This champion has <ability value=600>Arctic</ability>.  When this champion makes a successful basic attack against a champion, the following debuffs are applied to the target in order: <condition value=frozen>Frozen</condition> for 1 turn, <condition value=slowed>Slowed</condition> for 2 turns, <condition value=sundered>Sundered</condition> for 3 turns.",
      "long_description": "This champion has <ability value=600>Arctic</ability>.  When this champion makes a successful basic attack against a champion, the following debuffs are applied to the target in order: <condition value=frozen>Frozen</condition> for 1 turn, <condition value=slowed>Slowed</condition> for 2 turns, <condition value=sundered>Sundered</condition> for 3 turns.",
      "class_name": "FerrenFocus",
      "revision": 1
    },
    {
      "asset_id": 4625,
      "resettable": 1,
      "name": "Fervor",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1456,
      "activated": 1,
      "icon_name": "stab",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 15,
      "short_description": "This champion makes an attack for 0 AP, if able, on the closest enemy champion within range at the beginning of your turn.",
      "long_description": "This champion makes an attack for 0 AP, if able, on the closest enemy champion within range at the beginning of your turn.",
      "class_name": "Fervor",
      "revision": 1
    },
    {
      "asset_id": 4233,
      "resettable": 1,
      "name": "Fester",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 606,
      "activated": 1,
      "icon_name": "inhibit",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 2,
      "short_description": "Target champion within 5 spaces becomes <condition value=inhibited>Inhibited</condition> for 6 turns.",
      "long_description": "Target champion within 5 spaces becomes <condition value=inhibited>Inhibited</condition> for 6 turns.",
      "class_name": "Fester",
      "revision": 1
    },
    {
      "asset_id": 5232,
      "resettable": 1,
      "name": "Fickle",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2010,
      "activated": 1,
      "icon_name": "passive",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -8,
      "short_description": "There is a 20% chance this unit will gain <condition value=pacified>Pacified</condition> for 1 turn at the beginning of your turns.",
      "long_description": "There is a 20% chance this unit will gain <condition value=pacified>Pacified</condition> for 1 turn at the beginning of your turns.",
      "class_name": "Fickle",
      "revision": 1
    },
    {
      "asset_id": 5040,
      "resettable": 1,
      "name": "Fiddle",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1219,
      "activated": 1,
      "icon_name": "",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "Target enemy champion within 4 spaces has its base DMG and base DEF swapped for the next 4 turns. This ability shares a cooldown with Meddle and Tamper.",
      "long_description": "Target enemy champion within 4 spaces has its base DMG and base DEF swapped for the next 4 turns. This ability shares a cooldown with Meddle and Tamper.",
      "class_name": "Fiddle",
      "revision": 1
    },
    {
      "asset_id": 5561,
      "resettable": 1,
      "name": "Field Officer",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2421,
      "activated": 1,
      "icon_name": "",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "Friendly champions within 5 spaces that share a race with this champion gain Fearless and Fury.  When this champion dies, affected champions instead suffer -4 DMG for 2 turns.",
      "long_description": "Friendly champions within 5 spaces that share a race with this champion gain Fearless and Fury.  When this champion dies, affected champions instead suffer -4 DMG for 2 turns.",
      "class_name": "FieldOfficer",
      "revision": 1
    },
    {
      "asset_id": 4973,
      "resettable": 1,
      "name": "Fiery Death",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1855,
      "activated": 1,
      "icon_name": "fiery_death",
      "comments": "See sporedrop",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 20,
      "short_description": "When this champion is destroyed, all champions in play suffer 10 fire damage and a Heart of Fire relic is deployed.  If the Heart of Fire is not destroyed after 2 rounds, it hatches, redeploying Firemaw.",
      "long_description": "When this champion is destroyed, all champions in play suffer 10 fire damage and a Heart of Fire relic is deployed.  If the Heart of Fire is not destroyed after 2 rounds, it hatches, redeploying Firemaw.",
      "class_name": "FieryDeath",
      "revision": 1
    },
    {
      "asset_id": 5041,
      "resettable": 1,
      "name": "Final Word",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1220,
      "activated": 1,
      "icon_name": "ondeath",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 9,
      "short_description": "When this unit is destroyed by a champion, the champion that destroyed it is also destroyed.",
      "long_description": "When this unit is destroyed by a champion, the champion that destroyed it is also destroyed.",
      "class_name": "FinalWord",
      "revision": 1
    },
    {
      "asset_id": 5887,
      "resettable": 1,
      "name": "Find Pupil",
      "ap_cost": 5,
      "level": 0,
      "ability_id": 2896,
      "activated": 1,
      "icon_name": "find_pupil",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "This champion moves 3 spaces at random, then gains <ability value=2911>Reveal: Kas Pupil</ability> (Spawn a Kas Pupil on target adjacent square) for 1 turn.",
      "long_description": "This champion moves 3 spaces at random, then gains <ability value=2911>Reveal: Kas Pupil</ability> (Spawn a Kas Pupil on target adjacent square) for 1 turn.",
      "class_name": "FindKasPupil",
      "revision": 1
    },
    {
      "asset_id": 5890,
      "resettable": 1,
      "name": "Find Source Crystal",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 2899,
      "activated": 1,
      "icon_name": "source_crystal",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "This champion moves 3 spaces at random, then gets <ability value=2912>Reveal: Source Crystal</ability> for 1 turn.  Source Crystal relics have: This relic has <ability value=538>Fire Eater</ability>, <ability value=1118>Lava-fall 1</ability>, and <ability value=2900>Initiate: Devotee to De'lim</ability>. If you have 3 or more Source crystals, they have Lava-Fall 2 instead.",
      "long_description": "This champion moves 3 spaces at random, then gets <ability value=2912>Reveal: Source Crystal</ability> for 1 turn.  Source Crystal relics have: This relic has <ability value=538>Fire Eater</ability>, <ability value=1118>Lava-fall 1</ability>, and <ability value=2900>Initiate: Devotee to De'lim</ability>. If you have 3 or more Source crystals, they have Lava-Fall 2 instead.",
      "class_name": "FindSourceCrystal",
      "revision": 1
    },
    {
      "asset_id": 5003,
      "resettable": 1,
      "name": "Fire Acolyte",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1908,
      "activated": 1,
      "icon_name": "acolyte_fire",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "Whenever a champion takes Fire damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=charred>Charred</condition>.",
      "long_description": "Whenever a champion takes Fire damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=charred>Charred</condition>.",
      "class_name": "FireAcolyte",
      "revision": 1
    },
    {
      "asset_id": 4428,
      "resettable": 1,
      "name": "Fire Attack",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 767,
      "activated": 1,
      "icon_name": "fire",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "This unit makes a Fire attack at range 2-4.",
      "long_description": "This unit makes a Fire attack at range 2-4.",
      "class_name": "FireAttack",
      "revision": 1
    },
    {
      "asset_id": 4076,
      "resettable": 1,
      "name": "Fire Aura",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 131,
      "activated": 1,
      "icon_name": "novafire",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 2,
      "short_description": "At the beginning of your opponent's turns, this unit deals 2 Fire damage to each champion within 2 spaces. This damage ignores DEF.",
      "long_description": "At the beginning of your opponent's turns, this unit deals 2 Fire damage to each champion within 2 spaces. This damage ignores DEF.",
      "class_name": "DamagingAuraFire",
      "revision": 1
    },
    {
      "asset_id": 4076,
      "resettable": 1,
      "name": "Fire Aura",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 132,
      "activated": 1,
      "icon_name": "novafire",
      "comments": "none",
      "prerequisite_id": 131,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 4,
      "short_description": "At the beginning of your opponent's turns, this unit deals 4 Fire damage to each champion within 2 spaces. This damage ignores DEF.",
      "long_description": "At the beginning of your opponent's turns, this unit deals 4 Fire damage to each champion within 2 spaces. This damage ignores DEF.",
      "class_name": "DamagingAuraFire",
      "revision": 1
    },
    {
      "asset_id": 4076,
      "resettable": 1,
      "name": "Fire Aura",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 133,
      "activated": 1,
      "icon_name": "novafire",
      "comments": "none",
      "prerequisite_id": 132,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 6,
      "short_description": "At the beginning of your opponent's turns, this unit deals 6 Fire damage to each champion within 2 spaces. This damage ignores DEF.",
      "long_description": "At the beginning of your opponent's turns, this unit deals 6 Fire damage to each champion within 2 spaces. This damage ignores DEF.",
      "class_name": "DamagingAuraFire",
      "revision": 1
    },
    {
      "asset_id": 4310,
      "resettable": 1,
      "name": "Fire Blast",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2099,
      "activated": 1,
      "icon_name": "artillery",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this unit makes a basic attack, all opposing champions within 2 spaces of the target take 50% Fire damage.",
      "long_description": "When this unit makes a basic attack, all opposing champions within 2 spaces of the target take 50% Fire damage.",
      "class_name": "ArtilleryBlast",
      "revision": 1
    },
    {
      "asset_id": 4430,
      "resettable": 1,
      "name": "Fire Bomb",
      "ap_cost": 1,
      "level": 1,
      "ability_id": 771,
      "activated": 1,
      "icon_name": "fireaoe",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 6,
      "short_description": "Area Effect 2, Range 5:  Affected units take Fire damage equal to 50% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=charred>Charred</condition> for 2 turns.",
      "long_description": "Area Effect 2, Range 5:  Affected units take Fire damage equal to 50% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=charred>Charred</condition> for 2 turns.",
      "class_name": "FireBomb",
      "revision": 1
    },
    {
      "asset_id": 4430,
      "resettable": 1,
      "name": "Fire Bomb",
      "ap_cost": 1,
      "level": 2,
      "ability_id": 772,
      "activated": 1,
      "icon_name": "fireaoe",
      "comments": "",
      "prerequisite_id": 771,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 8,
      "short_description": "Area Effect 2, Range 5:  Affected units take Fire damage equal to 65% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=charred>Charred</condition> for 2 turns.",
      "long_description": "Area Effect 2, Range 5:  Affected units take Fire damage equal to 65% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=charred>Charred</condition> for 2 turns.",
      "class_name": "FireBomb",
      "revision": 1
    },
    {
      "asset_id": 4430,
      "resettable": 1,
      "name": "Fire Bomb",
      "ap_cost": 1,
      "level": 3,
      "ability_id": 773,
      "activated": 1,
      "icon_name": "fireaoe",
      "comments": "",
      "prerequisite_id": 772,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 10,
      "short_description": "Area Effect 2, Range 5:  Affected units take Fire damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=charred>Charred</condition> for 2 turns.",
      "long_description": "Area Effect 2, Range 5:  Affected units take Fire damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=charred>Charred</condition> for 2 turns.",
      "class_name": "FireBomb",
      "revision": 1
    },
    {
      "asset_id": 4210,
      "resettable": 1,
      "name": "Fire Eater",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 538,
      "activated": 1,
      "icon_name": "eater_fire",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 7,
      "short_description": "This champion moves unimpeded over Lava. When this champion would take Fire damage, it instead heals HP equal to half the damage that would have been dealt. This champion may not become <condition value=charred popup=false>Charred</condition>.",
      "long_description": "This champion moves unimpeded over Lava. When this champion would take Fire damage, it instead heals HP equal to half the damage that would have been dealt. This champion may not become <condition value=charred popup=false>Charred</condition>.",
      "class_name": "FireEater",
      "revision": 1
    },
    {
      "asset_id": 4368,
      "resettable": 1,
      "name": "Fire Feed",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1404,
      "activated": 1,
      "icon_name": "eater_fire",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "At the end of your turn, this unit deals 4 Fire damage to all adjacent enemy champions and heals HP equal to the damage dealt this way. This damage ignores DEF.",
      "long_description": "At the end of your turn, this unit deals 4 Fire damage to all adjacent enemy champions and heals HP equal to the damage dealt this way. This damage ignores DEF.",
      "class_name": "FireFeed",
      "revision": 1
    },
    {
      "asset_id": 4187,
      "resettable": 1,
      "name": "Fire Ruby",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 529,
      "activated": 1,
      "icon_name": "fire",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "At the beginning of your turn, this unit deals 15 Fire damage to the closest enemy unit within 3 spaces. When an enemy champion enters a space within 3 spaces if this unit, that unit takes 2 Fire damage. This damage ignores DEF.",
      "long_description": "At the beginning of your turn, this unit deals 15 Fire damage to the closest enemy unit within 3 spaces. When an enemy champion enters a space within 3 spaces if this unit, that unit takes 2 Fire damage. This damage ignores DEF.",
      "class_name": "RelicFireRuby",
      "revision": 1
    },
    {
      "asset_id": 4794,
      "resettable": 1,
      "name": "Fire Turret",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 1528,
      "activated": 1,
      "icon_name": "fire",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "This unit makes a Fire attack at RNG 2-7.",
      "long_description": "This unit makes a Fire attack at RNG 2-7.",
      "class_name": "FireTurret",
      "revision": 1
    },
    {
      "asset_id": 4596,
      "resettable": 1,
      "name": "Fire Volatility",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 989,
      "activated": 1,
      "icon_name": "novafire",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 6,
      "short_description": "When this unit takes fire damage, it releases a flame pulse equal to that damage, to a maximum of 12 damage, to every unit within 2 spaces. This damage ignores DEF. This unit can not become <condition value=charred popup=false>Charred</condition>.",
      "long_description": "When this unit takes fire damage, it releases a flame pulse equal to that damage, to a maximum of 12 damage, to every unit within 2 spaces. This damage ignores DEF. This unit can not become <condition value=charred popup=false>Charred</condition>.",
      "class_name": "FireVolatility",
      "revision": 1
    },
    {
      "asset_id": 7980,
      "resettable": 0,
      "name": "Fireoak Snare",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3371,
      "activated": 1,
      "icon_name": "frostvine_snare",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "At the end of its turn, enemy champions within 2 spaces take 4 Fire damage and are <condition value=inhibited>Inhibited</condition> for 2 turns.",
      "long_description": "At the end of its turn, enemy champions within 2 spaces take 4 Fire damage and are <condition value=inhibited>Inhibited</condition> for 2 turns.",
      "class_name": "FireoakSnare",
      "revision": 1
    },
    {
      "asset_id": 4164,
      "resettable": 1,
      "name": "First Aid",
      "ap_cost": 3,
      "level": 1,
      "ability_id": 458,
      "activated": 1,
      "icon_name": "heal",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 1,
      "cost": 1,
      "short_description": "Target adjacent friendly champion gains 3 HP.",
      "long_description": "Target adjacent friendly champion gains 3 HP.",
      "class_name": "FirstAid",
      "revision": 1
    },
    {
      "asset_id": 4164,
      "resettable": 1,
      "name": "First Aid",
      "ap_cost": 3,
      "level": 2,
      "ability_id": 459,
      "activated": 1,
      "icon_name": "heal",
      "comments": "none",
      "prerequisite_id": 458,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 1,
      "cost": 3,
      "short_description": "Target adjacent friendly champion gains 4 HP.",
      "long_description": "Target adjacent friendly champion gains 4 HP.",
      "class_name": "FirstAid",
      "revision": 1
    },
    {
      "asset_id": 4164,
      "resettable": 1,
      "name": "First Aid",
      "ap_cost": 3,
      "level": 3,
      "ability_id": 460,
      "activated": 1,
      "icon_name": "heal",
      "comments": "none",
      "prerequisite_id": 459,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 1,
      "cost": 6,
      "short_description": "Target adjacent friendly champion gains 5 HP.",
      "long_description": "Target adjacent friendly champion gains 5 HP.",
      "class_name": "FirstAid",
      "revision": 1
    },
    {
      "asset_id": 4146,
      "resettable": 1,
      "name": "Flame Armor",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 388,
      "activated": 1,
      "icon_name": "immunity_fire",
      "comments": "none",
      "prerequisite_id": 387,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 1,
      "cost": 5,
      "short_description": "This unit gets +3 DEF and gains <ability value=229>Damage Shield: Fire 3</ability> for 2 turns.",
      "long_description": "This unit gets +3 DEF and gains <ability value=229>Damage Shield: Fire 3</ability> for 2 turns.",
      "class_name": "FlameArmor",
      "revision": 1
    },
    {
      "asset_id": 5212,
      "resettable": 1,
      "name": "Flame Charge",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 1989,
      "activated": 1,
      "icon_name": "amp_fire",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 5,
      "short_description": "Until end of turn, all Fire damage is increased by 2. This unit loses 5 HP.",
      "long_description": "Until end of turn, all Fire damage is increased by 2. This unit loses 5 HP.",
      "class_name": "FlameCharge",
      "revision": 1
    },
    {
      "asset_id": 4144,
      "resettable": 1,
      "name": "Flame Nova",
      "ap_cost": 3,
      "level": 1,
      "ability_id": 378,
      "activated": 1,
      "icon_name": "novafire",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 2,
      "short_description": "This unit deals 3 Fire damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged become <condition value=inhibited>Inhibited</condition> 4.",
      "long_description": "This unit deals 3 Fire damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged become <condition value=inhibited>Inhibited</condition> 4.",
      "class_name": "FlameNova",
      "revision": 1
    },
    {
      "asset_id": 4144,
      "resettable": 1,
      "name": "Flame Nova",
      "ap_cost": 3,
      "level": 2,
      "ability_id": 379,
      "activated": 1,
      "icon_name": "novafire",
      "comments": "none",
      "prerequisite_id": 378,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 4,
      "short_description": "This unit deals 6 Fire damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged become <condition value=inhibited>Inhibited</condition> 4.",
      "long_description": "This unit deals 6 Fire damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged become <condition value=inhibited>Inhibited</condition> 4.",
      "class_name": "FlameNova",
      "revision": 1
    },
    {
      "asset_id": 4144,
      "resettable": 1,
      "name": "Flame Nova",
      "ap_cost": 3,
      "level": 3,
      "ability_id": 380,
      "activated": 1,
      "icon_name": "novafire",
      "comments": "none",
      "prerequisite_id": 379,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 6,
      "short_description": "This unit deals 9 Fire damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged become <condition value=inhibited>Inhibited</condition> 4.",
      "long_description": "This unit deals 9 Fire damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged become <condition value=inhibited>Inhibited</condition> 4.",
      "class_name": "FlameNova",
      "revision": 1
    },
    {
      "asset_id": 7535,
      "resettable": 0,
      "name": "Flame Prison",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 3193,
      "activated": 1,
      "icon_name": "trail_firewall",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "Spaces adjacent to target champion within 5 spaces becomes Fire Wall (Whenever an enemy champion enters this space, it takes 5 Fire damage and becomes Charred 4) for 2 turns.",
      "long_description": "Spaces adjacent to target champion within 5 spaces becomes Fire Wall (Whenever an enemy champion enters this space, it takes 5 Fire damage and becomes Charred 4) for 2 turns.",
      "class_name": "FlamePrison",
      "revision": 1
    },
    {
      "asset_id": 4503,
      "resettable": 1,
      "name": "Flame Siphon",
      "ap_cost": 3,
      "level": 1,
      "ability_id": 885,
      "activated": 1,
      "icon_name": "fire",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 1,
      "cost": 5,
      "short_description": "Target friendly champion within 5 spaces takes 10 Fire damage, you gain 100% of the damage taken in Nora.  May target self.",
      "long_description": "Target friendly champion within 5 spaces takes 10 Fire damage, you gain 100% of the damage taken in Nora.  May target self.",
      "class_name": "FlameSiphon",
      "revision": 1
    },
    {
      "asset_id": 4503,
      "resettable": 1,
      "name": "Flame Siphon",
      "ap_cost": 3,
      "level": 2,
      "ability_id": 886,
      "activated": 1,
      "icon_name": "fire",
      "comments": "",
      "prerequisite_id": 885,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 1,
      "cost": 10,
      "short_description": "Target friendly champion within 6 spaces takes 10 Fire damage, you gain 150% of the damage taken in Nora.  May target self.",
      "long_description": "Target friendly champion within 6 spaces takes 10 Fire damage, you gain 150% of the damage taken in Nora.  May target self.",
      "class_name": "FlameSiphon",
      "revision": 1
    },
    {
      "asset_id": 7293,
      "resettable": 0,
      "name": "Flame Surge",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 3082,
      "activated": 1,
      "icon_name": "charge_flame",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 12,
      "short_description": "This champion gains 3 AP and Pacified for 1 turn. For each space moved, enemy champions within 2 spaces take 3 Fire damage (this damage ignores DEF). This ability begins on CD.",
      "long_description": "This champion gains 3 AP and Pacified for 1 turn. For each space moved, enemy champions within 2 spaces take 3 Fire damage (this damage ignores DEF). This ability begins on CD.",
      "class_name": "FlameSurge",
      "revision": 1
    },
    {
      "asset_id": 7303,
      "resettable": 0,
      "name": "Flameburst",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 3088,
      "activated": 1,
      "icon_name": "fireaoe",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 3,
      "ranked": 0,
      "cost": 8,
      "short_description": "This champion makes an attack at RNG 1-3 for 10 Fire damage.  If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=charred>Charred</condition> for 3 turns.",
      "long_description": "This champion makes an attack at RNG 1-3 for 10 Fire damage.  If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=charred>Charred</condition> for 3 turns.",
      "class_name": "Flameburst",
      "revision": 1
    },
    {
      "asset_id": 4220,
      "resettable": 1,
      "name": "Flamestrike",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 591,
      "activated": 1,
      "icon_name": "fire",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 7,
      "short_description": "This champion makes a Fire attack at RNG 2-5. If the target is successfully damaged, it also becomes <condition value=charred>Charred</condition> for 3 turns.",
      "long_description": "This champion makes a Fire attack at RNG 2-5. If the target is successfully damaged, it also becomes <condition value=charred>Charred</condition> for 3 turns.",
      "class_name": "Flamestrike",
      "revision": 1
    },
    {
      "asset_id": 5541,
      "resettable": 1,
      "name": "Flamethrower",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 2400,
      "activated": 1,
      "icon_name": "fireaoe",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 9,
      "short_description": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this champion take 12 Fire damage and are <condition value=enflamed>Enflamed</condition> 2. This damage ignores DEF.",
      "long_description": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this champion take 12 Fire damage and are <condition value=enflamed>Enflamed</condition> 2. This damage ignores DEF.",
      "class_name": "Flamethrower",
      "revision": 1
    },
    {
      "asset_id": 7551,
      "resettable": 0,
      "name": "Flaming Skull",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 3205,
      "activated": 1,
      "icon_name": "flaming_skull",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "Adjacent friendly champions have <ability value=3204>Kick Flaming Skull</ability>.",
      "long_description": "Adjacent friendly champions have <ability value=3204>Kick Flaming Skull</ability>.",
      "class_name": "FlamingSkull",
      "revision": 1
    },
    {
      "asset_id": 5569,
      "resettable": 1,
      "name": "Flanking",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2429,
      "activated": 1,
      "icon_name": "flank",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "Whenever this champion makes a basic attack, it has +5 DMG for that attack if the target is engaged to another champion.",
      "long_description": "Whenever this champion makes a basic attack, it has +5 DMG for that attack if the target is engaged to another champion.",
      "class_name": "Flanking",
      "revision": 1
    },
    {
      "asset_id": 5835,
      "resettable": 1,
      "name": "Flash Bang",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2844,
      "activated": 1,
      "icon_name": "flashbang",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 6,
      "short_description": "When an enemy champion moves within 2 spaces of this relic, this relic is destroyed and enemy units within 2 spaces take 6 Magical damage and become Blinded for 2 turns.",
      "long_description": "When an enemy champion moves within 2 spaces of this relic, this relic is destroyed and enemy units within 2 spaces take 6 Magical damage and become Blinded for 2 turns.",
      "class_name": "RelicFlashBang",
      "revision": 1
    },
    {
      "asset_id": 5513,
      "resettable": 1,
      "name": "Flash Bomb",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 2371,
      "activated": 1,
      "icon_name": "flash_bomb",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "All enemy champions within 2 spaces are <condition value=blinded>Blinded</condition> for 2 turns and this champion becomes <condition value=stealthed>Stealthed</condition> for 4 turns and is relocated to target space within 5 spaces.",
      "long_description": "All enemy champions within 2 spaces are <condition value=blinded>Blinded</condition> for 2 turns and this champion becomes <condition value=stealthed>Stealthed</condition> for 4 turns and is relocated to target space within 5 spaces.",
      "class_name": "FlashBomb",
      "revision": 1
    },
    {
      "asset_id": 7689,
      "resettable": 0,
      "name": "Fledgling Mimicry",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3256,
      "activated": 1,
      "icon_name": "fledgling_mimicry",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 14,
      "short_description": "When the next friendly champion with a Sigil ability is deployed from the runedock, this champion gains that Sigil ability and has it triggered.  This champion also gains the upgraded abilities of that champion. ",
      "long_description": "When the next friendly champion with a Sigil ability is deployed from the runedock, this champion gains that Sigil ability and has it triggered.  This champion also gains the upgraded abilities of that champion. ",
      "class_name": "FledglingMimicry",
      "revision": 1
    },
    {
      "asset_id": 4070,
      "resettable": 1,
      "name": "Fleet",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1190,
      "activated": 1,
      "icon_name": "initiative",
      "comments": "",
      "prerequisite_id": 563,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "When this champion is deployed, it gains 5 AP.",
      "long_description": "When this champion is deployed, it gains 5 AP.",
      "class_name": "Fleet",
      "revision": 1
    },
    {
      "asset_id": 5390,
      "resettable": 1,
      "name": "Fleshgrinder",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2778,
      "activated": 1,
      "icon_name": "blood_debt",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "<mechanic value=sacrifice>Sacrifice</mechanic> target real champion you own within 3 spaces. The closest opposing champion within 8 spaces takes 15 Magical damage and becomes <condition value=bloodied>Bloodied</condition> for 6 turns. Blood Balls worth 8 HP each are created in all adjacent spaces to that champion.",
      "long_description": "<mechanic value=sacrifice>Sacrifice</mechanic> target real champion you own within 3 spaces. The closest opposing champion within 8 spaces takes 15 Magical damage and becomes <condition value=bloodied>Bloodied</condition> for 6 turns. Blood Balls worth 8 HP each are created in all adjacent spaces to that champion.",
      "class_name": "Fleshgrinder",
      "revision": 1
    },
    {
      "asset_id": 4000,
      "resettable": 1,
      "name": "Flight",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1,
      "activated": 1,
      "icon_name": "flight",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
      "long_description": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
      "class_name": "Flight",
      "revision": 1
    },
    {
      "asset_id": 5631,
      "resettable": 1,
      "name": "Fling Corpse",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2498,
      "activated": 1,
      "icon_name": "zombie_apoc",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Target unit at Range 4-8 takes 8 Physical damage and a Molding Corpse with 10 HP is summoned next to the target. This ability is not an attack. This ability is removed after it has been used 4 times",
      "long_description": "Target unit at Range 4-8 takes 8 Physical damage and a Molding Corpse with 10 HP is summoned next to the target. This ability is not an attack. This ability is removed after it has been used 4 times",
      "class_name": "CorpseShot",
      "revision": 1
    },
    {
      "asset_id": 5688,
      "resettable": 1,
      "name": "Flourish",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2563,
      "activated": 1,
      "icon_name": "auranegative",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "Opposing champions within 4 spaces are <condition value=charmed>Charmed</condition> and <condition value=distracted>Distracted</condition> for 4 turns. ",
      "long_description": "Opposing champions within 4 spaces are <condition value=charmed>Charmed</condition> and <condition value=distracted>Distracted</condition> for 4 turns. ",
      "class_name": "Flourish",
      "revision": 1
    },
    {
      "asset_id": 5465,
      "resettable": 1,
      "name": "Flurry",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2323,
      "activated": 1,
      "icon_name": "multiattack",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 25,
      "short_description": "This unit has furious attacks (This unit's basic attacks cost 1 AP).",
      "long_description": "This unit has furious attacks (This unit's basic attacks cost 1 AP).",
      "class_name": "Flurry",
      "revision": 1
    },
    {
      "asset_id": 5051,
      "resettable": 1,
      "name": "Font Aversion",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1911,
      "activated": 1,
      "icon_name": "drain",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": -10,
      "short_description": "This unit will automatically <mechanic value=sacrifice>Sacrifice</mechanic> if deployed in a font zone.",
      "long_description": "This unit will automatically <mechanic value=sacrifice>Sacrifice</mechanic> if deployed in a font zone.",
      "class_name": "FontAversion",
      "revision": 1
    },
    {
      "asset_id": 5042,
      "resettable": 1,
      "name": "Font Blessing",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1221,
      "activated": 1,
      "icon_name": "buff",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "While this champion is within 5 spaces of a font deployment zone you control, it gets +1 DEF, +5 DMG, and +10 HP.",
      "long_description": "While this champion is within 5 spaces of a font deployment zone you control, it gets +1 DEF, +5 DMG, and +10 HP.",
      "class_name": "FontBlessing",
      "revision": 1
    },
    {
      "asset_id": 5614,
      "resettable": 1,
      "name": "Font Ignorance",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2474,
      "activated": 1,
      "icon_name": "font_ignorance",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -8,
      "short_description": "This unit cannot contest or capture fonts.",
      "long_description": "This unit cannot contest or capture fonts.",
      "class_name": "FontIgnorance",
      "revision": 1
    },
    {
      "asset_id": 4677,
      "resettable": 1,
      "name": "Font Powered",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 1116,
      "activated": 1,
      "icon_name": "special",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 0,
      "short_description": "At the beginning of your turn, if this relic is not within a font friendly deployment zone, it becomes Unpowered (loses the Powered condition).",
      "long_description": "At the beginning of your turn, if this relic is not within a font deployment zone you control, it becomes Unpowered (loses the Powered condition).",
      "class_name": "FontPowered",
      "revision": 1
    },
    {
      "asset_id": 4677,
      "resettable": 1,
      "name": "Font Powered",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 1155,
      "activated": 1,
      "icon_name": "special",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 0,
      "short_description": "At the beginning of your turn, if this relic is not within a font friendly deployment zone, or you have less than 5 nora in your nora bank, it becomes Unpowered (loses the Powered condition). Otherwise, it becomes Powered (loses the Unpowered condition), and you lose 5 nora.",
      "long_description": "At the beginning of your turn, if this relic is not within a font deployment zone you control, or you have less than 5 nora in your nora bank, it becomes Unpowered (loses the Powered condition). Otherwise, it becomes Powered (loses the Unpowered condition), and you lose 5 nora.",
      "class_name": "FontPowered",
      "revision": 1
    },
    {
      "asset_id": 4633,
      "resettable": 1,
      "name": "Forage",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1457,
      "activated": 1,
      "icon_name": "forage",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "This unit gains 2 AP when it captures a nora globe.",
      "long_description": "This unit gains 2 AP when it captures a nora globe.",
      "class_name": "Forage",
      "revision": 1
    },
    {
      "asset_id": 5809,
      "resettable": 1,
      "name": "Forbidden Discipline",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2818,
      "activated": 1,
      "icon_name": "discipline_forbidden",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "The next basic attack this champion makes causes the target to become <condition value=frightened>Frightened</condition> for 2 turns. If the target was <condition value=frozen>Frozen</condition>, all friendly Monks gain 1 damage for 6 turns",
      "long_description": "The next basic attack this champion makes causes the target to become <condition value=frightened>Frightened</condition> for 2 turns. If the target was <condition value=frozen>Frozen</condition>, all friendly Monks gain 1 damage for 6 turns",
      "class_name": "ForbiddenDiscipline",
      "revision": 1
    },
    {
      "asset_id": 4149,
      "resettable": 1,
      "name": "Force Barrier",
      "ap_cost": 3,
      "level": 1,
      "ability_id": 398,
      "activated": 1,
      "icon_name": "forcebarrier",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 6,
      "short_description": "Range 1: Unoccupied spaces within 2 spaces of target unoccupied space become Inaccessible for 2 turns.",
      "long_description": "Range 1: Unoccupied spaces within 2 spaces of target unoccupied space become Inaccessible for 2 turns.",
      "class_name": "ForceBarrier",
      "revision": 1
    },
    {
      "asset_id": 4149,
      "resettable": 1,
      "name": "Force Barrier",
      "ap_cost": 3,
      "level": 2,
      "ability_id": 399,
      "activated": 1,
      "icon_name": "forcebarrier",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "Range 2: Unoccupied spaces within 2 spaces of target unoccupied space become Inaccessible for 2 turns.",
      "long_description": "Range 2: Unoccupied spaces within 2 spaces of target unoccupied space become Inaccessible for 2 turns.",
      "class_name": "ForceBarrier",
      "revision": 1
    },
    {
      "asset_id": 4149,
      "resettable": 1,
      "name": "Force Barrier",
      "ap_cost": 3,
      "level": 3,
      "ability_id": 400,
      "activated": 1,
      "icon_name": "forcebarrier",
      "comments": "none",
      "prerequisite_id": 399,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 10,
      "short_description": "Range 3: Unoccupied spaces within 2 spaces of target unoccupied space become Inaccessible for 2 turns.",
      "long_description": "Range 3: Unoccupied spaces within 2 spaces of target unoccupied space become Inaccessible for 2 turns.",
      "class_name": "ForceBarrier",
      "revision": 1
    },
    {
      "asset_id": 5427,
      "resettable": 1,
      "name": "Force of Nature",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2258,
      "activated": 1,
      "icon_name": "force_of_nature",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -15,
      "short_description": "This unit is removed from play after 12 turns.",
      "long_description": "This unit is removed from play after 12 turns.",
      "class_name": "ForceofNature",
      "revision": 1
    },
    {
      "asset_id": 7578,
      "resettable": 0,
      "name": "Force Projection",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3219,
      "activated": 1,
      "icon_name": "forcebarrier",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this champion makes a basic attack, the farthest adjacent accessible space from this champion to the target becomes Inaccessible for 2 turns.",
      "long_description": "When this champion makes a basic attack, the farthest adjacent accessible space from this champion to the target becomes Inaccessible for 2 turns.",
      "class_name": "ForceProjection",
      "revision": 1
    },
    {
      "asset_id": 7960,
      "resettable": 0,
      "name": "Forest Exploit",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3347,
      "activated": 1,
      "icon_name": "exploit_ironfist",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 7,
      "short_description": "When this champion makes a successful basic attack against a target with <condition value=charmed>Charmed</condition>, <condition value=illuminated>Illuminated</condition> or <condition value=pacified>Pacified</condition> it gains 1 AP and has +2 DMG for the attack. This champion does not trigger removal of Illuminated with its basic attacks.",
      "long_description": "When this champion makes a successful basic attack against a target with <condition value=charmed>Charmed</condition>, <condition value=illuminated>Illuminated</condition> or <condition value=pacified>Pacified</condition> it gains 1 AP and has +2 DMG for the attack. This champion does not trigger removal of Illuminated with its basic attacks.",
      "class_name": "ForestExploit",
      "revision": 1
    },
    {
      "asset_id": 4634,
      "resettable": 1,
      "name": "Forest Front",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1458,
      "activated": 1,
      "icon_name": "terraingrass",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "At the beginning of each turn, all spaces within 3 spaces of this champion become Vegetation for 4 turns.",
      "long_description": "At the beginning of each turn, all spaces within 3 spaces of this champion become Vegetation for 4 turns.",
      "class_name": "ForestWalker",
      "revision": 1
    },
    {
      "asset_id": 5908,
      "resettable": 0,
      "name": "Forest Lerper Form",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 2936,
      "activated": 1,
      "icon_name": "transform",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 9,
      "short_description": "This unit becomes a Forest Lerper with <ability value=2324>Pounce</ability> and <ability value=545>Attack: Physical</ability>. It gains +1 SPD, its range becomes 1 and it is <mechanic value=cleansed>Cleansed</mechanic>.",
      "long_description": "This unit becomes a Forest Lerper with <ability value=2324>Pounce</ability> and <ability value=545>Attack: Physical</ability>. It gains +1 SPD, its range becomes 1 and it is <mechanic value=cleansed>Cleansed</mechanic>.",
      "class_name": "ForestLerperForm",
      "revision": 1
    },
    {
      "asset_id": 4397,
      "resettable": 1,
      "name": "Forge Hammer",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 832,
      "activated": 1,
      "icon_name": "forge",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 2,
      "ranked": 0,
      "cost": 6,
      "short_description": "When this champion makes a successful basic attack, the next Construct, relic or equipment deployed from the runedock costs 2 less nora.  This effect stacks.",
      "long_description": "Whenever this champion makes a successful basic attack, the next Construct, relic or equipment deployed from the runedock costs 2 less nora.  This effect stacks.",
      "class_name": "ForgeHammerAttack",
      "revision": 1
    },
    {
      "asset_id": 5714,
      "resettable": 1,
      "name": "Forsaken Exploit",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2596,
      "activated": 1,
      "icon_name": "exploit_forsaken",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 7,
      "short_description": "When this champion makes a successful basic attack against a target with <condition value=diseased>Diseased</condition>, <condition value=cursed>Cursed</condition> or <condition value=hexed>Hexed</condition> it gains 1 AP and has +2 DMG for the attack.",
      "long_description": "When this champion makes a successful basic attack against a target with <condition value=diseased>Diseased</condition>, <condition value=cursed>Cursed</condition> or <condition value=hexed>Hexed</condition> it gains 1 AP and has +2 DMG for the attack.",
      "class_name": "ForsakenExploit",
      "revision": 1
    },
    {
      "asset_id": 5344,
      "resettable": 1,
      "name": "Fortify",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2273,
      "activated": 1,
      "icon_name": "shrinegood",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 10,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "For 2 turns, all damage dealt to your shrine is prevented.",
      "long_description": "For 2 turns, all damage dealt to your shrine is prevented.",
      "class_name": "Fortify",
      "revision": 1
    },
    {
      "asset_id": 4965,
      "resettable": 1,
      "name": "Foul Strike",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1846,
      "activated": 1,
      "icon_name": "diseaseaoe",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 8,
      "short_description": "When this champion successfully damages a champion with a basic attack, all opposing champions within 3 spaces of the target are <condition value=diseased>Diseased</condition> and <condition value=inhibited>Inhibited</condition> for 4 turns.",
      "long_description": "When this champion successfully damages a champion with a basic attack, all opposing champions within 3 spaces of the target are <condition value=diseased>Diseased</condition> and <condition value=inhibited>Inhibited</condition> for 4 turns.",
      "class_name": "FoulStrike",
      "revision": 1
    },
    {
      "asset_id": 7514,
      "resettable": 0,
      "name": "Fractured Lands",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3186,
      "activated": 1,
      "icon_name": "trail_rock",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 12,
      "short_description": "When an enemy champion within 5 spaces makes a basic attack, it loses 2 AP.",
      "long_description": "When an enemy champion within 5 spaces makes a basic attack, it loses 2 AP.",
      "class_name": "FracturedLands",
      "revision": 1
    },
    {
      "asset_id": 5674,
      "resettable": 1,
      "name": "Free Attack",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2547,
      "activated": 1,
      "icon_name": "none",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 3,
      "ranked": 0,
      "cost": 0,
      "short_description": "Used internally.",
      "long_description": "Used internally.",
      "class_name": "FreeAttack",
      "revision": 1
    },
    {
      "asset_id": 5550,
      "resettable": 1,
      "name": "Free Soul",
      "ap_cost": 5,
      "level": 0,
      "ability_id": 2410,
      "activated": 1,
      "icon_name": "sentry",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Target adjacent Soul Battery is freed from its torment.",
      "long_description": "Target adjacent Soul Battery is freed from its torment.",
      "class_name": "FreeSoul",
      "revision": 1
    },
    {
      "asset_id": 4981,
      "resettable": 1,
      "name": "Freeze",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 1863,
      "activated": 1,
      "icon_name": "crystallize",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "Target opposing champion within 2 spaces is <condition value=crystallized>Crystallized</condition> for 2 turns and <condition value=frozen>Frozen</condition> 4.",
      "long_description": "Target opposing champion within 2 spaces is <condition value=crystallized>Crystallized</condition> for 2 turns and <condition value=frozen>Frozen</condition> 4.",
      "class_name": "Freeze",
      "revision": 1
    },
    {
      "asset_id": 4351,
      "resettable": 1,
      "name": "Freezing Aura",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1385,
      "activated": 1,
      "icon_name": "novafrost",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "Enemy champions within 3 spaces are <condition value=frozen>Frozen</condition>.  ",
      "long_description": "Enemy champions within 3 spaces are <condition value=frozen>Frozen</condition>.  ",
      "class_name": "FreezingAura",
      "revision": 2
    },
    {
      "asset_id": 7602,
      "resettable": 0,
      "name": "Freezing Chains",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 3230,
      "activated": 1,
      "icon_name": "grip_icelord",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 7,
      "short_description": "Enemy champions within 3 spaces take 8 Frost damage and become <condition value=frozen>Frozen</condition> for 2 turns (this damage ignores DEF).  This ability's CD is reduced by 1 whenever this champion is successfully attacked.",
      "long_description": "Enemy champions within 3 spaces take 8 Frost damage and become <condition value=frozen>Frozen</condition> for 2 turns (this damage ignores DEF).  This ability's CD is reduced by 1 whenever this champion is successfully attacked.",
      "class_name": "GripOfTheIcelord",
      "revision": 1
    },
    {
      "asset_id": 5808,
      "resettable": 1,
      "name": "Freezing Discipline",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2817,
      "activated": 1,
      "icon_name": "discipline_freezing",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 2,
      "short_description": "The next basic attack this champion makes causes <condition value=frozen>Frozen</condition> for 4 turns. If the target was <condition value=frozen popup=false>Frozen</condition>, all friendly Monks gain 1 damage for 6 turns",
      "long_description": "The next basic attack this champion makes causes <condition value=frozen>Frozen</condition> for 4 turns. If the target was <condition value=frozen popup=false>Frozen</condition>, all friendly Monks gain 1 damage for 6 turns",
      "class_name": "FreezingDiscipline",
      "revision": 1
    },
    {
      "asset_id": 7722,
      "resettable": 0,
      "name": "Friends for Life",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3267,
      "activated": 1,
      "icon_name": "friends_for_life",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "This champion has +2 DEF, <ability value=116>Regeneration 2</ability> and <ability value=1214>Encouraged</ability> as long as it within 5 spaces of at least one friendly champion with this ability.",
      "long_description": "This champion has +2 DEF, <ability value=116>Regeneration 2</ability> and <ability value=1214>Encouraged</ability> as long as it within 5 spaces of at least one friendly champion with this ability.",
      "class_name": "FriendsForLife",
      "revision": 1
    },
    {
      "asset_id": 5147,
      "resettable": 1,
      "name": "Frightful Aura",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 1653,
      "activated": 1,
      "icon_name": "fear",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 2,
      "short_description": "All opposing champions within 3 spaces have -1 DMG. All friendly undead champions within 3 spaces have +1 DEF.",
      "long_description": "All opposing champions within 3 spaces have -1 DMG. All friendly undead champions within 3 spaces have +1 DEF.",
      "class_name": "FrightfulAura",
      "revision": 1
    },
    {
      "asset_id": 5147,
      "resettable": 1,
      "name": "Frightful Aura",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 1654,
      "activated": 1,
      "icon_name": "fear",
      "comments": "none",
      "prerequisite_id": 1653,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 3,
      "short_description": "All opposing champions within 3 spaces have -2 DMG. All friendly Undead champions within 3 spaces have +1 DEF.",
      "long_description": "All opposing champions within 3 spaces have -2 DMG. All friendly Undead champions within 3 spaces have +1 DEF.",
      "class_name": "FrightfulAura",
      "revision": 1
    },
    {
      "asset_id": 5147,
      "resettable": 1,
      "name": "Frightful Aura",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 2067,
      "activated": 1,
      "icon_name": "fear",
      "comments": "none",
      "prerequisite_id": 1654,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 4,
      "short_description": "All opposing champions within 3 spaces have -2 DMG. All friendly undead champions within 3 spaces have +2 DEF.",
      "long_description": "All opposing champions within 3 spaces have -2 DMG. All friendly undead champions within 3 spaces have +2 DEF.",
      "class_name": "FrightfulAura",
      "revision": 1
    },
    {
      "asset_id": 5147,
      "resettable": 1,
      "name": "Frightful Aura",
      "ap_cost": 0,
      "level": 4,
      "ability_id": 2068,
      "activated": 1,
      "icon_name": "fear",
      "comments": "none",
      "prerequisite_id": 2067,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 6,
      "short_description": "All opposing champions within 4 spaces have -2 DMG. All friendly Undead champions within 4 spaces have +2 DEF.",
      "long_description": "All opposing champions within 4 spaces have -2 DMG. All friendly Undead champions within 4 spaces have +2 DEF.",
      "class_name": "FrightfulAura",
      "revision": 1
    },
    {
      "asset_id": 5147,
      "resettable": 1,
      "name": "Frightful Aura",
      "ap_cost": 0,
      "level": 5,
      "ability_id": 2069,
      "activated": 1,
      "icon_name": "fear",
      "comments": "none",
      "prerequisite_id": 2068,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 7,
      "short_description": "All opposing champions within 4 spaces have -3 DMG. All friendly Undead champions within 4 spaces have +2 DEF.",
      "long_description": "All opposing champions within 4 spaces have -3 DMG. All friendly Undead champions within 4 spaces have +2 DEF.",
      "class_name": "FrightfulAura",
      "revision": 1
    },
    {
      "asset_id": 5147,
      "resettable": 1,
      "name": "Frightful Aura",
      "ap_cost": 0,
      "level": 6,
      "ability_id": 2070,
      "activated": 1,
      "icon_name": "fear",
      "comments": "none",
      "prerequisite_id": 2069,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 8,
      "short_description": "All opposing champions within 4 spaces have -3 DMG. All friendly Undead champions within 4 spaces have +3 DEF.",
      "long_description": "All opposing champions within 4 spaces have -3 DMG. All friendly Undead champions within 4 spaces have +3 DEF.",
      "class_name": "FrightfulAura",
      "revision": 1
    },
    {
      "asset_id": 4969,
      "resettable": 1,
      "name": "Frightful Blows",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1850,
      "activated": 1,
      "icon_name": "fear_blows",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 8,
      "short_description": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=frightened>Frightened</condition> for 2 turns.",
      "long_description": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=frightened>Frightened</condition> for 2 turns.",
      "class_name": "FrightfulBlows",
      "revision": 1
    },
    {
      "asset_id": 4861,
      "resettable": 1,
      "name": "Frigid Lance",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 1743,
      "activated": 1,
      "icon_name": "ice",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "This champion makes a Frost attack at RNG 2-5.  If the target is occupying Ice, Snow or is <condition value=frozen>Frozen</condition> and is successfully damaged, the target also becomes <condition value=chilled>Chilled</condition> for 3 turns and <condition value=inhibited>Inhibited</condition> for 3 turns.",
      "long_description": "This champion makes a Frost attack at RNG 2-5.  If the target is occupying Ice, Snow or is Frozen and is successfully damaged, the target also becomes <condition value=chilled>Chilled</condition> for 3 turns and <condition value=inhibited>Inhibited</condition> for 3 turns.",
      "class_name": "FrigidLance",
      "revision": 1
    },
    {
      "asset_id": 4862,
      "resettable": 1,
      "name": "Frost Acolyte",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1744,
      "activated": 1,
      "icon_name": "catalyst_frost",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "Whenever a champion takes Frost damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=chilled>Chilled</condition>.",
      "long_description": "Whenever a champion takes Frost damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=chilled>Chilled</condition>.",
      "class_name": "FrostAcolyte",
      "revision": 1
    },
    {
      "asset_id": 5594,
      "resettable": 1,
      "name": "Frost Amped",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2454,
      "activated": 1,
      "icon_name": "amped",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "This champion loses a charge at the end of its turn. While this champion has at least 8 charges, it has +1 SPD, +2 DMG, +2 DEF and <ability value=137>Frost Aura 3</ability>.",
      "long_description": "This champion loses a charge at the end of its turn. While this champion has at least 8 charges, it has +1 SPD, +2 DMG, +2 DEF and <ability value=137>Frost Aura 3</ability>.",
      "class_name": "FrostAmped",
      "revision": 1
    },
    {
      "asset_id": 4147,
      "resettable": 1,
      "name": "Frost Armor",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 390,
      "activated": 1,
      "icon_name": "dmgshld_frost",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 1,
      "cost": 5,
      "short_description": "This unit gets +3 DEF and gains <ability value=233>Damage Shield: Frost 3</ability> for 2 turns.",
      "long_description": "This unit gets +3 DEF and gains <ability value=233>Damage Shield: Frost 3</ability> for 2 turns.",
      "class_name": "FrostArmor",
      "revision": 1
    },
    {
      "asset_id": 4425,
      "resettable": 1,
      "name": "Frost Attack",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 764,
      "activated": 1,
      "icon_name": "ice",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "This unit makes a Frost attack at range 2-4.",
      "long_description": "This unit makes a Frost attack at range 2-4.",
      "class_name": "FrostAttack",
      "revision": 1
    },
    {
      "asset_id": 4077,
      "resettable": 1,
      "name": "Frost Aura",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 135,
      "activated": 1,
      "icon_name": "novafrost",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 2,
      "short_description": "At the beginning of your opponent's turns, this unit deals 2 Frost damage to each champion within 2 spaces. This damage ignores DEF.",
      "long_description": "At the beginning of your opponent's turns, this unit deals 2 Frost damage to each champion within 2 spaces. This damage ignores DEF.",
      "class_name": "DamagingAuraCold",
      "revision": 1
    },
    {
      "asset_id": 4077,
      "resettable": 1,
      "name": "Frost Aura",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 136,
      "activated": 1,
      "icon_name": "novafrost",
      "comments": "none",
      "prerequisite_id": 135,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 4,
      "short_description": "At the beginning of your opponent's turns, this unit deals 4 Frost damage to each champion within 2 spaces. This damage ignores DEF.",
      "long_description": "At the beginning of your opponent's turns, this unit deals 4 Frost damage to each champion within 2 spaces. This damage ignores DEF.",
      "class_name": "DamagingAuraCold",
      "revision": 1
    },
    {
      "asset_id": 4077,
      "resettable": 1,
      "name": "Frost Aura",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 137,
      "activated": 1,
      "icon_name": "novafrost",
      "comments": "none",
      "prerequisite_id": 136,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 6,
      "short_description": "At the beginning of your opponent's turns, this unit deals 6 Frost damage to each champion within 2 spaces. This damage ignores DEF.",
      "long_description": "At the beginning of your opponent's turns, this unit deals 6 Frost damage to each champion within 2 spaces. This damage ignores DEF.",
      "class_name": "DamagingAuraCold",
      "revision": 1
    },
    {
      "asset_id": 4231,
      "resettable": 1,
      "name": "Frost Cone ",
      "ap_cost": 1,
      "level": 1,
      "ability_id": 602,
      "activated": 1,
      "icon_name": "iceaoe",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 6,
      "short_description": "Area Effect 2, Range 5: Affected units take Frost damage equal to 50% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=chilled>Chilled</condition> for 2 turns.",
      "long_description": "Area Effect 2, Range 5: Affected units take Frost damage equal to 50% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=chilled>Chilled</condition> for 2 turns.",
      "class_name": "FrostCone",
      "revision": 1
    },
    {
      "asset_id": 4231,
      "resettable": 1,
      "name": "Frost Cone ",
      "ap_cost": 1,
      "level": 2,
      "ability_id": 603,
      "activated": 1,
      "icon_name": "iceaoe",
      "comments": "",
      "prerequisite_id": 602,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 8,
      "short_description": "Area Effect 2, Range 5: Affected units take Frost damage equal to 65% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=chilled>Chilled</condition> for 2 turns.",
      "long_description": "Area Effect 2, Range 5: Affected units take Frost damage equal to 65% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=chilled>Chilled</condition> for 2 turns.",
      "class_name": "FrostCone",
      "revision": 1
    },
    {
      "asset_id": 4231,
      "resettable": 1,
      "name": "Frost Cone ",
      "ap_cost": 1,
      "level": 3,
      "ability_id": 604,
      "activated": 1,
      "icon_name": "iceaoe",
      "comments": "",
      "prerequisite_id": 603,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 10,
      "short_description": "Area Effect 2, Range 5: Affected units take Frost damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=chilled>Chilled</condition> for 2 turns.",
      "long_description": "Area Effect 2, Range 5: Affected units take Frost damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=chilled>Chilled</condition> for 2 turns.",
      "class_name": "FrostCone",
      "revision": 1
    },
    {
      "asset_id": 7271,
      "resettable": 0,
      "name": "Frost Greeting",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3071,
      "activated": 1,
      "icon_name": "greeting_frost",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "When this champion comes into play, all enemy champions become <condition value=chilled>Chilled</condition> for 2 turns.",
      "long_description": "When this champion comes into play, all enemy champions become <condition value=chilled>Chilled</condition> for 2 turns.",
      "class_name": "FrostGreeting",
      "revision": 1
    },
    {
      "asset_id": 7165,
      "resettable": 0,
      "name": "Frost Mallet",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 3008,
      "activated": 1,
      "icon_name": "ice",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 3,
      "ranked": 0,
      "cost": 10,
      "short_description": "This champion makes a Frost attack at RNG 2-5.  If the attack is successful, the target becomes <mechanic value=slowed>Slowed</mechanic> for 2 turns.  When this ability is not on CD, this champion's successful basic attacks cause <mechanic value=slowed>Slowed</mechanic> for 2 turns.",
      "long_description": "This champion makes a Frost attack at RNG 2-5.  If the attack is successful, the target becomes <mechanic value=slowed>Slowed</mechanic> for 2 turns.  When this ability is not on CD, this champion's successful basic attacks cause <mechanic value=slowed>Slowed</mechanic> for 2 turns.",
      "class_name": "FrostMallet",
      "revision": 1
    },
    {
      "asset_id": 4145,
      "resettable": 1,
      "name": "Frost Nova",
      "ap_cost": 3,
      "level": 1,
      "ability_id": 382,
      "activated": 1,
      "icon_name": "novafrost",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 2,
      "short_description": "This unit deals 3 Frost damage to each unit within 2 spaces. This damage ignores DEF. Champions damaged by Frost Nova become <mechanic value=slowed>Slowed</mechanic> 4.",
      "long_description": "This unit deals 3 Frost damage to each unit within 2 spaces. This damage ignores DEF. Champions damaged by Frost Nova become <mechanic value=slowed>Slowed</mechanic> 4.",
      "class_name": "FrostNova",
      "revision": 1
    },
    {
      "asset_id": 4145,
      "resettable": 1,
      "name": "Frost Nova",
      "ap_cost": 3,
      "level": 2,
      "ability_id": 383,
      "activated": 1,
      "icon_name": "novafrost",
      "comments": "none",
      "prerequisite_id": 382,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 4,
      "short_description": "This unit deals 6 Frost damage to each unit within 2 spaces. This damage ignores DEF. Champions damaged by Frost Nova become <mechanic value=slowed>Slowed</mechanic> 4.",
      "long_description": "This unit deals 6 Frost damage to each unit within 2 spaces. This damage ignores DEF. Champions damaged by Frost Nova become <mechanic value=slowed>Slowed</mechanic> 4.",
      "class_name": "FrostNova",
      "revision": 1
    },
    {
      "asset_id": 4145,
      "resettable": 1,
      "name": "Frost Nova",
      "ap_cost": 3,
      "level": 3,
      "ability_id": 384,
      "activated": 1,
      "icon_name": "novafrost",
      "comments": "none",
      "prerequisite_id": 383,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 6,
      "short_description": "This unit deals 9 Frost damage to each unit within 2 spaces. This damage ignores DEF. Champions damaged by Frost Nova become <mechanic value=slowed>Slowed</mechanic> 4.",
      "long_description": "This unit deals 9 Frost damage to each unit within 2 spaces. This damage ignores DEF. Champions damaged by Frost Nova become <mechanic value=slowed>Slowed</mechanic> 4.",
      "class_name": "FrostNova",
      "revision": 1
    },
    {
      "asset_id": 5686,
      "resettable": 1,
      "name": "Frost Overload",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2561,
      "activated": 1,
      "icon_name": "dot_chill",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 8,
      "short_description": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=chilled>Chilled</condition> 3. If that champion is already Chilled, it is equipped with a Frost Amulet. Equipment generated by this ability costs 0 nora.",
      "long_description": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=chilled>Chilled</condition> 3. If that champion is already Chilled, it is equipped with a Frost Amulet. Equipment generated by this ability costs 0 nora.",
      "class_name": "FrostOverload",
      "revision": 1
    },
    {
      "asset_id": 7707,
      "resettable": 0,
      "name": "Frost Stance",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3262,
      "activated": 1,
      "icon_name": "frost_stance",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 2,
      "short_description": "Until this ability is activated again, this champion has -1 SPD and gains <ability value=2819>Catalyst: Frost</ability>.",
      "long_description": "Until this ability is activated again, this champion has -1 SPD and gains <ability value=2819>Catalyst: Frost</ability>.",
      "class_name": "FrostStance",
      "revision": 1
    },
    {
      "asset_id": 4795,
      "resettable": 1,
      "name": "Frost Turret",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 1529,
      "activated": 1,
      "icon_name": "ice",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "This unit makes a Frost attack at RNG 2-7.",
      "long_description": "This unit makes a Frost attack at RNG 2-7.",
      "class_name": "FrostTurret",
      "revision": 1
    },
    {
      "asset_id": 4679,
      "resettable": 1,
      "name": "Frostburn",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1117,
      "activated": 1,
      "icon_name": "resistance_frost",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 6,
      "short_description": "When a friendly champion takes frost damage, it is healed for up to 4 HP (or the amount of damage taken) at the end of that turn. If the champion is affected by <condition value=chilled>Chilled</condition>, the Chilled condition is removed as well. This effect does not stack.",
      "long_description": "When a friendly champion takes frost damage, it is healed for up to 4 HP (or the amount of damage taken) at the end of that turn. If the champion is affected by <condition value=chilled>Chilled</condition>, the Chilled condition is removed as well. This effect does not stack.",
      "class_name": "Frostburn",
      "revision": 1
    },
    {
      "asset_id": 7553,
      "resettable": 0,
      "name": "Frostvine Snare",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3207,
      "activated": 1,
      "icon_name": "frostvine_snare",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "At the end of its turn, enemy champions within 2 spaces take 4 Frost damage and are <condition value=ensnared>Ensnared</condition> for 2 turns.",
      "long_description": "At the end of its turn, enemy champions within 2 spaces take 4 Frost damage and are <condition value=ensnared>Ensnared</condition> for 2 turns.",
      "class_name": "FrostvineSnare",
      "revision": 1
    },
    {
      "asset_id": 4768,
      "resettable": 1,
      "name": "Fry",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 1495,
      "activated": 1,
      "icon_name": "novaelectric",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "If this champion occupies water when activating this ability, all enemy champions in water within 5 spaces take 8 Electricity damage.",
      "long_description": "If this champion occupies water when activating this ability, all enemy champions in water within 5 spaces take 8 Electricity damage.",
      "class_name": "Fry",
      "revision": 1
    },
    {
      "asset_id": 4336,
      "resettable": 1,
      "name": "Fuel Rage",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 1364,
      "activated": 1,
      "icon_name": "drive",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Target champion within 3 spaces that has the <ability value=1363>Unleash</ability> ability gains 1 AP and +1 DMG for 1 turn. This effect can stack up to 4 times.",
      "long_description": "Target champion within 3 spaces that has the <ability value=1363>Unleash</ability> ability gains 1 AP and +1 DMG for 1 turn. This effect can stack up to 4 times.",
      "class_name": "FuelRage",
      "revision": 1
    },
    {
      "asset_id": 4199,
      "resettable": 1,
      "name": "Furious Attack",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2274,
      "activated": 1,
      "icon_name": "furious_attacks",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 3,
      "ranked": 0,
      "cost": 0,
      "short_description": "This unit makes a Physical attack at its Range. This is a basic attack.  This attack always costs 1 AP.",
      "long_description": "This unit makes a Physical attack at its Range. This is a basic attack.  This attack always costs 1 AP.",
      "class_name": "AttackPhysical",
      "revision": 1
    },
    {
      "asset_id": 5371,
      "resettable": 1,
      "name": "Furious Attacks",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2203,
      "activated": 1,
      "icon_name": "furious_attacks",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "Spend 12 charges. For 1 turn, basic attacks made by this champion costs a maximum of 1 AP.",
      "long_description": "Spend 12 charges. For 1 turn, basic attacks made by this champion costs a maximum of 1 AP.",
      "class_name": "FuriousAttacks",
      "revision": 1
    },
    {
      "asset_id": 5420,
      "resettable": 1,
      "name": "Furring",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2252,
      "activated": 1,
      "icon_name": "furring",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "When this unit has been in play for 6 turns, it is removed from play and a Furbull is deployed in the same location. If this unit was summoned, a Furbull without upgrades is summoned instead.\r\n",
      "long_description": "When this unit has been in play for 6 turns, it is removed from play and a Furbull is deployed in the same location. If this unit was summoned, a Furbull without upgrades is summoned instead.",
      "class_name": "Furring",
      "revision": 1
    },
    {
      "asset_id": 4406,
      "resettable": 1,
      "name": "Fury",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 732,
      "activated": 1,
      "icon_name": "enrage",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this unit makes a successful basic attack, it permanently gains +1 DMG.",
      "long_description": "When this unit makes a successful basic attack, it permanently gains +1 DMG.",
      "class_name": "Fury",
      "revision": 1
    },
    {
      "asset_id": 7710,
      "resettable": 0,
      "name": "Fury of a Thousand Strikes",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3264,
      "activated": 1,
      "icon_name": "fury_1k_strikes",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 10,
      "short_description": "The first time each turn this champion makes a successful basic attack, other friendly champions within 5 spaces that share a race or class with this champion have their CDs reduced by 1 and their attack chain is reset.",
      "long_description": "The first time each turn this champion makes a successful basic attack, other friendly champions within 5 spaces that share a race or class with this champion have their CDs reduced by 1 and their attack chain is reset.",
      "class_name": "FuryOfAThousandStrikes",
      "revision": 1
    },
    {
      "asset_id": 5765,
      "resettable": 1,
      "name": "Fury of the Swamp",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2676,
      "activated": 1,
      "icon_name": "leap",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "This champion gains +1 DMG for 2 turns whenever a friendly champion within 6 spaces makes a successful basic attack.  If the attacking unit is a Boghopper, the effect lasts 4 turns instead.",
      "long_description": "This champion gains +1 DMG for 2 turns whenever a friendly champion within 6 spaces makes a successful basic attack.  If the attacking unit is a Boghopper, the effect lasts 4 turns instead.",
      "class_name": "FuryOfTheSwamp",
      "revision": 1
    },
    {
      "asset_id": 4269,
      "resettable": 1,
      "name": "G'hernbound",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 679,
      "activated": 1,
      "icon_name": "ghernbound",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -6,
      "short_description": "This unit has -3 DMG, -1 SPD unless it is within range of a unit with <ability value=676>Overseer: Moga</ability>.",
      "long_description": "This unit has -3 DMG, -1 SPD unless it is within range of a unit with <ability value=676>Overseer: Moga</ability>.",
      "class_name": "Ghernbound",
      "revision": 1
    },
    {
      "asset_id": 5114,
      "resettable": 1,
      "name": "Gain Control",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1303,
      "activated": 1,
      "icon_name": "gale",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "The effects of <ability value=874>Reckless Flight</ability> and <ability value=2266>Wandering</ability> are negated until the end of this turn. This ability costs 6 Nora upon activation.",
      "long_description": "The effects of <ability value=874>Reckless Flight</ability> and <ability value=2266>Wandering</ability> are negated until the end of this turn. This ability costs 6 Nora upon activation.",
      "class_name": "GainControl",
      "revision": 1
    },
    {
      "asset_id": 5047,
      "resettable": 1,
      "name": "Gain Resistance Frost",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1226,
      "activated": 1,
      "icon_name": "resistance_frost",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "All friendly champions without the Ice Eater ability receive the Resistance - Frost 2 (  \t When this unit takes Frost damage, that damage is reduced by 35% (rounded up)) ability when this champion is in play.",
      "long_description": "All friendly champions without the Ice Eater ability receive the Resistance - Frost 2 (  \t When this unit takes Frost damage, that damage is reduced by 35% (rounded up)) ability when this champion is in play.",
      "class_name": "GainResistanceFrost",
      "revision": 1
    },
    {
      "asset_id": 5276,
      "resettable": 1,
      "name": "Gale",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2100,
      "activated": 1,
      "icon_name": "gale",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "Area Effect 2, Range 5: Affected champions are knocked back 2 spaces.",
      "long_description": "Area Effect 2, Range 5: Affected champions are knocked back 2 spaces.",
      "class_name": "Gale",
      "revision": 1
    },
    {
      "asset_id": 5564,
      "resettable": 1,
      "name": "Garu Form",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2424,
      "activated": 1,
      "icon_name": "transform",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "This unit is <mechanic value=cleansed>Cleansed</mechanic> and becomes a Garu with RNG 1, Berserker 3, Rend 1 and 10 HP.",
      "long_description": "This unit is <mechanic value=cleansed>Cleansed</mechanic> and becomes a Garu with RNG 1, Berserker 3, Rend 1 and 10 HP.",
      "class_name": "GaruForm",
      "revision": 1
    },
    {
      "asset_id": 5405,
      "resettable": 1,
      "name": "Geogenesis",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2661,
      "activated": 1,
      "icon_name": "sum_rockling",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 15,
      "short_description": "At end of this champion's first turn and every three thereafter, a Rockling with no upgrades is summoned to an adjacent space.",
      "long_description": "At end of this champion's first turn and every three thereafter, a Rockling with no upgrades is summoned to an adjacent space.",
      "class_name": "Geogenesis",
      "revision": 1
    },
    {
      "asset_id": 4373,
      "resettable": 1,
      "name": "Germinate",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1412,
      "activated": 1,
      "icon_name": "sumtree",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "Spawn a Sapling with <ability value=655>Skirmisher</ability> and <ability value=2474>Font Ignorance</ability> on an adjacent space for 20 Nora.",
      "long_description": "Spawn a Sapling with <ability value=655>Skirmisher</ability> and <ability value=2474>Font Ignorance</ability> on an adjacent space for 20 Nora.",
      "class_name": "Germinate",
      "revision": 1
    },
    {
      "asset_id": 4714,
      "resettable": 1,
      "name": "Germination Engine ",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1134,
      "activated": 1,
      "icon_name": "sumtree",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "When this relic is deployed, a Level 3 Young Sapling is summoned on the nearest unoccupied space within 5 spaces. At the end of every 6 turns, a Young Sapling is summoned on the nearest unoccupied space within 5 spaces. This relic loses 5 HP each time a Young Sapling is summoned. This relic has Forest Front.",
      "long_description": "When this relic is deployed, a Level 3 Young Sapling is summoned on the nearest unoccupied space within 5 spaces. At the end of every 6 turns, a Level 3 Young Sapling is summoned on the nearest unoccupied space within 5 spaces. This relic loses 5 HP each time a Level 3 Young Sapling is summoned. This relic has Forest Front.",
      "class_name": "RelicGerminationEngine",
      "revision": 1
    },
    {
      "asset_id": 4228,
      "resettable": 1,
      "name": "Ghost",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 599,
      "activated": 1,
      "icon_name": "ghost",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "This champion is <condition value=incorporeal>Incorporeal</condition>.",
      "long_description": "This champion is <condition value=incorporeal>Incorporeal</condition>.",
      "class_name": "Ghost",
      "revision": 1
    },
    {
      "asset_id": 4935,
      "resettable": 1,
      "name": "Ghost Pendant",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1821,
      "activated": 1,
      "icon_name": "shadow_shift",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "All opposing champions within 3 spaces of this relic become <condition value=cursed>Cursed</condition> for 2 turns at the beginning of your turns.",
      "long_description": "All opposing champions within 3 spaces of this relic become <condition value=cursed>Cursed</condition> for 2 turns at the beginning of your turns.",
      "class_name": "RelicGhostPendant",
      "revision": 1
    },
    {
      "asset_id": 4309,
      "resettable": 1,
      "name": "Gift of Fertility",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1337,
      "activated": 1,
      "icon_name": "surge",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "Abilities that create units that are on your champions have their cooldowns decreased by 1 (to a minimum of 1). This does not stack.",
      "long_description": "Abilities that create units that are on your champions have their cooldowns decreased by 1 (to a minimum of 1). This does not stack.",
      "class_name": "GiftOfFertility",
      "revision": 1
    },
    {
      "asset_id": 5589,
      "resettable": 1,
      "name": "Gift of Forglar",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 2448,
      "activated": 1,
      "icon_name": "",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "This unit loses 5 HP and target Boghopper Tad within 3 spaces is removed from play and a Level 1 Boghopper Pupil is deployed in the same location the Sapling occupied. ",
      "long_description": "This unit loses 5 HP and target Boghopper Tad within 3 spaces is removed from play and a Level 1 Boghopper Pupil is deployed in the same location the Sapling occupied.",
      "class_name": "GiftOfForglar",
      "revision": 1
    },
    {
      "asset_id": 5424,
      "resettable": 1,
      "name": "Gift of Ironwood",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 2255,
      "activated": 1,
      "icon_name": "gif_of_ironwood",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 0,
      "ranked": 0,
      "cost": 35,
      "short_description": "This unit loses 10 HP and target Sapling within 3 spaces is removed from play and a Gnarlwood Grappler with no upgrades is summoned in the same location the Sapling occupied.",
      "long_description": "This unit loses 10 HP and target Sapling within 3 spaces is removed from play and a Gnarlwood Grappler with no upgrades is summoned in the same location the Sapling occupied.",
      "class_name": "GiftOfIronwood",
      "revision": 1
    },
    {
      "asset_id": 4984,
      "resettable": 1,
      "name": "Gift of Scrying",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1866,
      "activated": 1,
      "icon_name": "scry",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "You have an additional rune reveal each of your turns.",
      "long_description": "You have an additional rune reveal each of your turns.",
      "class_name": "Explorer",
      "revision": 1
    },
    {
      "asset_id": 7316,
      "resettable": 0,
      "name": "Gift of the Djinn: Dao",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 3094,
      "activated": 1,
      "icon_name": "revere",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "Target champion with Race: Elemental or Hyaenid within 5 spaces gains <ability value=2078>Reflexes 3</ability> until this ability is used again.",
      "long_description": "Target champion with Race: Elemental or Hyaenid within 5 spaces gains <ability value=2078>Reflexes 3</ability> until this ability is used again.",
      "class_name": "GiftOfTheDjinnDao",
      "revision": 1
    },
    {
      "asset_id": 7317,
      "resettable": 0,
      "name": "Gift of the Djinn: Dew",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 3095,
      "activated": 1,
      "icon_name": "revere",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "Target champion with Race: Elemental or Hyaenid within 5 spaces gains <ability value=117>Regeneration 3</ability> until this ability is used again.",
      "long_description": "Target champion with Race: Elemental or Hyaenid within 5 spaces gains <ability value=117>Regeneration 3</ability> until this ability is used again.",
      "class_name": "GiftOfTheDjinnDew",
      "revision": 1
    },
    {
      "asset_id": 7314,
      "resettable": 0,
      "name": "Gift of the Djinn: Ifrit",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 3092,
      "activated": 1,
      "icon_name": "revere",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "Target champion with Race: Elemental or Hyaenid within 5 spaces gains <ability value=25>Berserker 3</ability> until this ability is used again.",
      "long_description": "Target champion with Race: Elemental or Hyaenid within 5 spaces gains <ability value=25>Berserker 3</ability> until this ability is used again.",
      "class_name": "GiftOfTheDjinnIfrit",
      "revision": 1
    },
    {
      "asset_id": 7315,
      "resettable": 0,
      "name": "Gift of the Djinn: Marid",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 3093,
      "activated": 1,
      "icon_name": "revere",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 3,
      "short_description": "Target champion with Race: Elemental or Hyaenid within 5 spaces gains <ability value=518>Leap 3</ability> until this ability is used again.",
      "long_description": "Target champion with Race: Elemental or Hyaenid within 5 spaces gains <ability value=518>Leap 3</ability> until this ability is used again.",
      "class_name": "GiftOfTheDjinnMarid",
      "revision": 1
    },
    {
      "asset_id": 7538,
      "resettable": 0,
      "name": "Gift: Draketooth Rifle",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3195,
      "activated": 1,
      "icon_name": "gift",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 25,
      "short_description": "The next champion you deploy from the runedock while this champion is in play is equipped with a Draketooth Rifle.",
      "long_description": "The next champion you deploy from the runedock while this champion is in play is equipped with a Draketooth Rifle.",
      "class_name": "GiftDraketoothRifle",
      "revision": 1
    },
    {
      "asset_id": 7849,
      "resettable": 0,
      "name": "Gift: Emergency Kit",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3329,
      "activated": 1,
      "icon_name": "gift",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 20,
      "short_description": "The next champion you deploy from the runedock while this champion is in play is equipped with an Emergency Kit.",
      "long_description": "The next champion you deploy from the runedock while this champion is in play is equipped with an Emergency Kit.",
      "class_name": "GiftEmergencyKit",
      "revision": 1
    },
    {
      "asset_id": 7569,
      "resettable": 0,
      "name": "Gift: Future Sight",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3214,
      "activated": 1,
      "icon_name": "gift",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "The next champion you deploy from the runedock while this champion is in play gains <ability value=13>Detection 3</ability> and a <condition value=buffered>Buffer</condition> of +10 HP.",
      "long_description": "The next champion you deploy from the runedock while this champion is in play gains <ability value=13>Detection 3</ability> and a <condition value=buffered>Buffer</condition> of +10 HP.",
      "class_name": "GiftFutureSight",
      "revision": 1
    },
    {
      "asset_id": 7756,
      "resettable": 0,
      "name": "Gift: Kingmaker",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3283,
      "activated": 1,
      "icon_name": "gift",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 15,
      "short_description": "The next champion you deploy from the runedock while this champion is in play has <ability value=608>Majestic 1</ability> and <ability value=3>Fearless</ability>.",
      "long_description": "The next champion you deploy from the runedock while this champion is in play has <ability value=608>Majestic 1</ability> and <ability value=3>Fearless</ability>.",
      "class_name": "GiftKingmaker",
      "revision": 1
    },
    {
      "asset_id": 7755,
      "resettable": 0,
      "name": "Gift: Magical Training",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3282,
      "activated": 1,
      "icon_name": "gift",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "The next champion you deploy from the runedock while this champion is in play has <ability value=961>Reckless Blast 2</ability> and <ability value=1873>Magic Blast</ability>.",
      "long_description": "The next champion you deploy from the runedock while this champion is in play has <ability value=961>Reckless Blast 2</ability> and <ability value=1873>Magic Blast</ability>.",
      "class_name": "GiftMagicalTraining",
      "revision": 1
    },
    {
      "asset_id": 7418,
      "resettable": 0,
      "name": "Gift: Pilgrim's Offering",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3150,
      "activated": 1,
      "icon_name": "gift",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "The next champion you deploy from the runedock while this champion is in play has <ability value=867>Blessed</ability> and 2 ranks of <ability value=116>Regeneration</ability>.",
      "long_description": "The next champion you deploy from the runedock while this champion is in play has <ability value=867>Blessed</ability> and 2 ranks of <ability value=116>Regeneration</ability>.",
      "class_name": "PilgrimsGift",
      "revision": 1
    },
    {
      "asset_id": 7757,
      "resettable": 0,
      "name": "Gift: Smuggle",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3284,
      "activated": 1,
      "icon_name": "gift",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "The next champion you deploy from the runedock while this champion is in play gains <ability value=1790>Shadow Shift</ability> and <ability value=325>Stealth</ability>.",
      "long_description": "The next champion you deploy from the runedock while this champion is in play gains <ability value=1790>Shadow Shift</ability> and <ability value=325>Stealth</ability>.",
      "class_name": "GiftSmuggle",
      "revision": 1
    },
    {
      "asset_id": 7370,
      "resettable": 0,
      "name": "Gift: Spare Wings",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3126,
      "activated": 1,
      "icon_name": "gift",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 14,
      "short_description": "The next champion you deploy from the runedock while this champion is in play has +1 SPD and <ability value=1>Flight</ability>.",
      "long_description": "The next champion you deploy from the runedock while this champion is in play has +1 SPD and <ability value=1>Flight</ability>.",
      "class_name": "SpareWings",
      "revision": 1
    },
    {
      "asset_id": 5048,
      "resettable": 1,
      "name": "Give Refuge: Voil",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1227,
      "activated": 1,
      "icon_name": "tunnel_earth",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "Voil friendly champions that are adjacent to this unit gain Take Refuge (This champion loses all conditions, recovers 4 HP, and is removed from play. At the end of your next turn, it returns to play adjacent to the unit granting this ability. If the unit granting this ability is destroyed before this champion returns to play, this champion is destroyed).",
      "long_description": "Voil friendly champions that are adjacent to this unit gain Take Refuge (This champion loses all conditions, recovers 4 HP, and is removed from play. At the end of your next turn, it returns to play adjacent to the unit granting this ability. If the unit granting this ability is destroyed before this champion returns to play, this champion is destroyed).",
      "class_name": "GiveRefugeVoil",
      "revision": 1
    },
    {
      "asset_id": 4378,
      "resettable": 1,
      "name": "Globe Of Deception",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1417,
      "activated": 1,
      "icon_name": "globe_deception",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "All nora globes become blood balls instead. If a demon captures the bloodball, it heals for the amount of nora that would have been recovered from the Nora Globe. If a non-demon captures it, it takes that same amount in Magical damage.",
      "long_description": "All nora globes become blood balls instead. If a demon captures the bloodball, it heals for the amount of nora that would have been recovered from the Nora Globe. If a non-demon captures it, it takes that same amount in Magical damage.",
      "class_name": "RelicGlobeOfDeception",
      "revision": 1
    },
    {
      "asset_id": 7809,
      "resettable": 0,
      "name": "Glorious Drain",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 3321,
      "activated": 1,
      "icon_name": "drain",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "Target friendly champion you own loses 12 HP. This unit vampiric heals 12 HP.",
      "long_description": "Target friendly champion you own loses 12 HP. This unit vampiric heals 12 HP.",
      "class_name": "GloriousDrain",
      "revision": 1
    },
    {
      "asset_id": 4183,
      "resettable": 1,
      "name": "Glorious Leap",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 2690,
      "activated": 1,
      "icon_name": "leap",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 7,
      "short_description": "This champion is relocated to target space within 4 spaces. Opposing champions within 2 spaces of the target space are <condition value=awestruck>Awestruck</condition> for 2 turns.",
      "long_description": "This champion is relocated to target space within 4 spaces. Opposing champions within 2 spaces of the target space are <condition value=awestruck>Awestruck</condition> for 2 turns.",
      "class_name": "GloriousLeap",
      "revision": 1
    },
    {
      "asset_id": 4143,
      "resettable": 1,
      "name": "Gluttony",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 2708,
      "activated": 1,
      "icon_name": "devour",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "This champion gains 1 AP and +1 DMG for 1 turn for every 25 HP on opposing champions within 3 spaces, rounded down.",
      "long_description": "This champion gains 1 AP and +1 DMG for 1 turn for every 25 HP on opposing champions within 3 spaces, rounded down.",
      "class_name": "Gluttony",
      "revision": 1
    },
    {
      "asset_id": 7147,
      "resettable": 0,
      "name": "Glyph of Protection",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2989,
      "activated": 1,
      "icon_name": "seal_of_protection",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "When this champion is deployed, it gains a <condition value=buffered>Buffer</condition> of 6 HP. If this champion ends its turn within 3 spaces of a friendly non-Illusion champion, the Buffer is reset to 6 HP.",
      "long_description": "When this champion is deployed, it gains a <condition value=buffered>Buffer</condition> of 6 HP. If this champion ends its turn within 3 spaces of a friendly non-Illusion champion, the Buffer is reset to 6 HP.",
      "class_name": "SealOfProtection",
      "revision": 1
    },
    {
      "asset_id": 4962,
      "resettable": 1,
      "name": "Goblin Mob",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1843,
      "activated": 1,
      "icon_name": "multitude",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "The goblin mob is endless.",
      "long_description": "The goblin mob is endless.",
      "class_name": "TestAbility",
      "revision": 1
    },
    {
      "asset_id": 7778,
      "resettable": 0,
      "name": "Goblin Rockpack",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3300,
      "activated": 1,
      "icon_name": "pack_mentality",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 40,
      "short_description": "When this champion is deployed from the runedock, 2 Goblin Rockpack champions with no upgrades are summoned adjacent to it.",
      "long_description": "When this champion is deployed from the runedock, 2 Goblin Rockpack champions with no upgrades are summoned adjacent to it.",
      "class_name": "GoblinRockpack",
      "revision": 1
    },
    {
      "asset_id": 5651,
      "resettable": 1,
      "name": "Goblin Thievery",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 2523,
      "activated": 1,
      "icon_name": "goblin_thievery",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "Gain a random ability that is not a basic attack from target opposing champion within 5 spaces. Friendly Goblins within 5 spaces of this champion also gain that ability. This ability does not break stealth and is removed upon use.",
      "long_description": "Gain a random ability that is not a basic attack from target opposing champion within 5 spaces. Friendly Goblins within 5 spaces of this champion also gain that ability. This ability does not break stealth and is removed upon use.",
      "class_name": "GoblinThievery",
      "revision": 1
    },
    {
      "asset_id": 4582,
      "resettable": 1,
      "name": "Golem Form",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 968,
      "activated": 1,
      "icon_name": "transform",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "This unit is <mechanic value=cleansed>Cleansed</mechanic> and gets 15 MAX HP, +1 DEF, <ability value=48>Resistance: Physical 3</ability>, and <ability value=5>Lumbering</ability>.",
      "long_description": "This unit is <mechanic value=cleansed>Cleansed</mechanic> and gets 15 MAX HP, +1 DEF, <ability value=48>Resistance: Physical 3</ability>, and <ability value=5>Lumbering</ability>.",
      "class_name": "GolemForm",
      "revision": 1
    },
    {
      "asset_id": 4239,
      "resettable": 1,
      "name": "Gore",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 617,
      "activated": 1,
      "icon_name": "gore",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 2,
      "short_description": "When this champion makes a close-combat or Charge attack that deals Physical damage to a champion, that champion becomes <condition value=gored>Gored</condition>. This can stack up to 3 times.",
      "long_description": "When this champion makes a close-combat or Charge attack that deals Physical damage to a champion, that champion becomes <condition value=gored>Gored</condition>. This can stack up to 3 times.",
      "class_name": "Gore",
      "revision": 1
    },
    {
      "asset_id": 4532,
      "resettable": 1,
      "name": "Grace of the Dead",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 890,
      "activated": 1,
      "icon_name": "healmass",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 4,
      "short_description": "When this unit dies, all friendly champions are healed for 6 HP. At the start of your next turn, all friendly champions are healed for 3 HP.",
      "long_description": "When this unit dies, all friendly champions are healed for 6 HP. At the start of your next turn, all friendly champions are healed for 3 HP.",
      "class_name": "GraceOfTheDead",
      "revision": 1
    },
    {
      "asset_id": 4532,
      "resettable": 1,
      "name": "Grace of the Dead",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 892,
      "activated": 1,
      "icon_name": "healmass",
      "comments": "",
      "prerequisite_id": 890,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 8,
      "short_description": "When this unit dies, all friendly champions are healed for 12 HP. At the start of your next turn, all friendly champions are healed for 6 HP.",
      "long_description": "When this unit dies, all friendly champions are healed for 12 HP. At the start of your next turn, all friendly champions are healed for 6 HP.",
      "class_name": "GraceOfTheDead",
      "revision": 1
    },
    {
      "asset_id": 5253,
      "resettable": 1,
      "name": "Grand Entrance",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1338,
      "activated": 1,
      "icon_name": "majestic",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 2,
      "short_description": "When this unit is deployed, the closest enemy champion is <condition value=awestruck>Awestruck</condition> for 3 turns.",
      "long_description": "When this unit is deployed, the closest enemy champion is <condition value=awestruck>Awestruck</condition> for 3 turns.",
      "class_name": "GrandEntrance",
      "revision": 1
    },
    {
      "asset_id": 5221,
      "resettable": 1,
      "name": "Grant: Action Potion",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 1998,
      "activated": 1,
      "icon_name": "grantability",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 12,
      "short_description": "Target champion within 3 spaces gains <ability value=1999>Drink Action Potion</ability> for 6 turns.",
      "long_description": "Target champion within 3 spaces gains <ability value=1999>Drink Action Potion</ability> for 6 turns.",
      "class_name": "GrantActionPotion",
      "revision": 1
    },
    {
      "asset_id": 5052,
      "resettable": 1,
      "name": "Grant: Damage Shield: Magical",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 1230,
      "activated": 1,
      "icon_name": "grantability",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 1,
      "short_description": "Target champion within 5 spaces gains <ability value=225>Damage Shield: Magical 3</ability> for 2 turns.",
      "long_description": "Target champion within 5 spaces gains <ability value=225>Damage Shield: Magical 3</ability> for 2 turns.",
      "class_name": "GrantDamageShieldMagical",
      "revision": 1
    },
    {
      "asset_id": 5496,
      "resettable": 1,
      "name": "Grant: Death Nova: Fire",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 2355,
      "activated": 1,
      "icon_name": "grantability",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 3,
      "short_description": "Target champion within 5 spaces gains <ability value=181>Death Nova: Fire 2</ability> and <ability value=562>Self Destruct</ability> for 2 turns.",
      "long_description": "Target champion within 5 spaces gains <ability value=181>Death Nova: Fire 2</ability> and <ability value=562>Self Destruct</ability> for 2 turns.",
      "class_name": "GrantDeathNovaFire",
      "revision": 1
    },
    {
      "asset_id": 4868,
      "resettable": 1,
      "name": "Grant: Domain Rock",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 2664,
      "activated": 1,
      "icon_name": "grantability",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 3,
      "short_description": "Target champion within 5 spaces gains <ability value=1328>Domain: Rock</ability> for 2 turns.",
      "long_description": "Target champion within 5 spaces gains <ability value=1328>Domain: Rock</ability> for 2 turns.",
      "class_name": "GrantDomainRock",
      "revision": 1
    },
    {
      "asset_id": 5289,
      "resettable": 1,
      "name": "Grant: Draconic Force",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 2112,
      "activated": 1,
      "icon_name": "grantability",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "Target champion within 5 spaces gains <ability value=879>Draconic Force</ability> for 2 turns.",
      "long_description": "Target champion within 5 spaces gains <ability value=879>Draconic Force</ability> for 2 turns.",
      "class_name": "GrantDraconicForce",
      "revision": 1
    },
    {
      "asset_id": 5307,
      "resettable": 1,
      "name": "Grant: Electricity Aura",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 2129,
      "activated": 1,
      "icon_name": "grantability",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "Target champion within 5 spaces gains <ability value=141>Electricity Aura 3</ability> for 2 turns.",
      "long_description": "Target champion within 5 spaces gains <ability value=141>Electricity Aura 3</ability> for 2 turns.",
      "class_name": "GrantElectricityAura",
      "revision": 1
    },
    {
      "asset_id": 4995,
      "resettable": 1,
      "name": "Grant: Elemental Immunity",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 1876,
      "activated": 1,
      "icon_name": "grantability",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 5,
      "short_description": "Target champion within 5 spaces gains <ability value=37>Immunity: Fire</ability>, <ability value=38>Immunity: Frost</ability> and <ability value=39>Immunity: Electricity</ability> for 2 turns.",
      "long_description": "Target champion within 5 spaces gains <ability value=37>Immunity: Fire</ability>, <ability value=38>Immunity: Frost</ability> and <ability value=39>Immunity: Electricity</ability> for 2 turns.",
      "class_name": "GrantImmunityElectric",
      "revision": 1
    },
    {
      "asset_id": 5445,
      "resettable": 1,
      "name": "Grant: Evasive",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 2297,
      "activated": 1,
      "icon_name": "grantability",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 3,
      "short_description": "Target champion within 5 spaces gains <ability value=1377>Evasive 2</ability> for 2 turns.",
      "long_description": "Target champion within 5 spaces gains <ability value=1377>Evasive 2</ability> for 2 turns.",
      "class_name": "Grant-Evasive",
      "revision": 1
    },
    {
      "asset_id": 5305,
      "resettable": 1,
      "name": "Grant: Flight",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 630,
      "activated": 1,
      "icon_name": "flight",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 3,
      "short_description": "Target champion within 5 spaces gains <condition value=flying>Flying</condition> for 2 turns.",
      "long_description": "Target champion within 5 spaces gains <condition value=flying>Flying</condition> for 2 turns.",
      "class_name": "GrantFlight",
      "revision": 1
    },
    {
      "asset_id": 4869,
      "resettable": 1,
      "name": "Grant: Frost Aura",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 1751,
      "activated": 1,
      "icon_name": "grantability",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "Target champion within 5 spaces gains <ability value=137>Frost Aura 3</ability> for 2 turns.",
      "long_description": "Target champion within 5 spaces gains <ability value=137>Frost Aura 3</ability> for 2 turns.",
      "class_name": "GrantFrostAura",
      "revision": 1
    },
    {
      "asset_id": 4865,
      "resettable": 1,
      "name": "Grant: Frost Trap",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 1747,
      "activated": 1,
      "icon_name": "grantability",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "Target champion within 5 spaces gains <ability value=452>Lay Trap: Frost 3</ability> for 2 turns.",
      "long_description": "Target champion within 5 spaces gains <ability value=452>Lay Trap: Frost 3</ability> for 2 turns.",
      "class_name": "GrantFrostTrap",
      "revision": 1
    },
    {
      "asset_id": 4978,
      "resettable": 1,
      "name": "Grant: Healing Potion",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2639,
      "activated": 1,
      "icon_name": "grantability",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "Target champion within 3 spaces gains <ability value=2640>Drink Healing Potion</ability> for 6 turns.",
      "long_description": "Target champion within 3 spaces gains <ability value=2640>Drink Healing Potion</ability> for 6 turns.",
      "class_name": "GrantHealingPotion",
      "revision": 1
    },
    {
      "asset_id": 4867,
      "resettable": 1,
      "name": "Grant: Lay Trap: Boulder",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 1749,
      "activated": 1,
      "icon_name": "grantability",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "Target champion within 5 spaces gains <ability value=729>Lay Trap: Boulder 3 </ability> for 2 turns.",
      "long_description": "Target champion within 5 spaces gains <ability value=729>Lay Trap: Boulder 3 </ability> for 2 turns.",
      "class_name": "GrantStoneTrap",
      "revision": 1
    },
    {
      "asset_id": 4864,
      "resettable": 1,
      "name": "Grant: Lay Trap: Fire",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 1746,
      "activated": 1,
      "icon_name": "grantability",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "Target champion within 5 spaces gains <ability value=444>Lay Trap: Fire 3</ability> for 2 turns.",
      "long_description": "Target champion within 5 spaces gains <ability value=444>Lay Trap: Fire 3</ability> for 2 turns.",
      "class_name": "GrantFireTrap",
      "revision": 1
    },
    {
      "asset_id": 5307,
      "resettable": 1,
      "name": "Grant: Magical Aura",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 2607,
      "activated": 1,
      "icon_name": "grantability",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "Target champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> for 2 turns.",
      "long_description": "Target champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> for 2 turns.",
      "class_name": "GrantMagicalAura",
      "revision": 1
    },
    {
      "asset_id": 5842,
      "resettable": 1,
      "name": "Grant: Mobility",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 2851,
      "activated": 1,
      "icon_name": "grantability",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 2,
      "short_description": "Target champion within 5 spaces gains <ability value=6>Mobility</ability> for 2 turns.",
      "long_description": "Target champion within 5 spaces gains <ability value=6>Mobility</ability> for 2 turns.",
      "class_name": "GrantMobility",
      "revision": 1
    },
    {
      "asset_id": 4866,
      "resettable": 1,
      "name": "Grant: Poison Cloud Trap",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 1748,
      "activated": 1,
      "icon_name": "grantability",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "Target champion within 5 spaces gains <ability value=446>Lay Trap: Poison Cloud</ability> for 2 turns.",
      "long_description": "Target champion within 5 spaces gains <ability value=446>Lay Trap: Poison Cloud</ability> for 2 turns.",
      "class_name": "GrantPoisonTrap",
      "revision": 1
    },
    {
      "asset_id": 4978,
      "resettable": 1,
      "name": "Grant: Rage Potion",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 1860,
      "activated": 1,
      "icon_name": "grantability",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "Target champion within 3 spaces gains Drink Rage Potion (This champion gains +3 DMG for 1 turn) for 6 turns.",
      "long_description": "Target champion within 3 spaces gains Drink Rage Potion (This champion gains +3 DMG for 1 turn) for 6 turns.",
      "class_name": "RagePotion",
      "revision": 1
    },
    {
      "asset_id": 5446,
      "resettable": 1,
      "name": "Grant: Reflexes",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 2298,
      "activated": 1,
      "icon_name": "grantability",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 3,
      "short_description": "Target champion within 5 spaces gains <ability value=2077>Reflexes 2</ability> for 2 turns.",
      "long_description": "Target champion within 5 spaces gains <ability value=2077>Reflexes 2</ability> for 2 turns.",
      "class_name": "GrantReflexes",
      "revision": 1
    },
    {
      "asset_id": 5305,
      "resettable": 1,
      "name": "Grant: Sonic Aura",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 2127,
      "activated": 1,
      "icon_name": "grantability",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "Target champion within 5 spaces gains <ability value=149>Sonic Aura 3</ability> for 2 turns.",
      "long_description": "Target champion within 5 spaces gains <ability value=149>Sonic Aura 3</ability> for 2 turns.",
      "class_name": "GrantSonicAura",
      "revision": 1
    },
    {
      "asset_id": 4978,
      "resettable": 1,
      "name": "Grant: Stoneskin Potion",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2637,
      "activated": 1,
      "icon_name": "grantability",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "Target champion within 3 spaces gains <ability value=2638>Drink: Stoneskin Potion</ability> for 6 turns.",
      "long_description": "Target champion within 3 spaces gains <ability value=2638>Drink: Stoneskin Potion</ability> for 6 turns.",
      "class_name": "GrantStoneskinPotion",
      "revision": 1
    },
    {
      "asset_id": 5494,
      "resettable": 1,
      "name": "Grant: Teleport",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 2353,
      "activated": 1,
      "icon_name": "grantability",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 5,
      "short_description": "Target champion within 5 spaces gains <ability value=407>Teleport 2</ability> for 2 turns.",
      "long_description": "Target champion within 5 spaces gains <ability value=407>Teleport 2</ability> for 2 turns.",
      "class_name": "GrantTeleport",
      "revision": 1
    },
    {
      "asset_id": 4868,
      "resettable": 1,
      "name": "Grant: Tempo",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 1750,
      "activated": 1,
      "icon_name": "grantability",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 2,
      "short_description": "Target champion within 5 spaces gains <ability value=1271>Tempo</ability> for 2 turns.",
      "long_description": "Target champion within 5 spaces gains <ability value=1271>Tempo</ability> for 2 turns.",
      "class_name": "GrantTempo",
      "revision": 1
    },
    {
      "asset_id": 5049,
      "resettable": 1,
      "name": "Grant: Trail Sand",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 1228,
      "activated": 1,
      "icon_name": "grantability",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 2,
      "short_description": "Target champion within 5 spaces gains <ability value=1102>Trail: Sand</ability> for 2 turns.",
      "long_description": "Target champion within 5 spaces gains <ability value=1102>Trail: Sand</ability> for 2 turns.",
      "class_name": "GrantTrailSand",
      "revision": 1
    },
    {
      "asset_id": 5050,
      "resettable": 1,
      "name": "Grant: Tunnel Sand",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 1229,
      "activated": 1,
      "icon_name": "grantability",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 3,
      "short_description": "Target champion within 5 spaces gains <ability value=1150>Tunnel: Sand 3</ability> for 2 turns.",
      "long_description": "Target champion within 5 spaces gains <ability value=1150>Tunnel: Sand 3</ability> for 2 turns.",
      "class_name": "GrantTunnelSand",
      "revision": 1
    },
    {
      "asset_id": 5073,
      "resettable": 1,
      "name": "Grappling Hook",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2660,
      "activated": 1,
      "icon_name": "pull",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 5,
      "short_description": "This champion is relocated to target space within 2-5 spaces.  If that space is occupied by a champion, both champions are relocated up to 2 spaces towards each other. This ability may not be used on impassable or inaccessible spaces.",
      "long_description": "This champion is relocated to target space within 2-5 spaces.  If that space is occupied by a champion, both champions are relocated up to 2 spaces towards each other. This ability may not be used on impassable or inaccessible spaces.",
      "class_name": "GrapplingHook",
      "revision": 1
    },
    {
      "asset_id": 7384,
      "resettable": 0,
      "name": "Gravebind",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3135,
      "activated": 1,
      "icon_name": "swarm_skeleton",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "The first time each turn an opposing real champion within 5 spaces is destroyed, a Grave Warrior without upgrades is summoned adjacent to this unit.",
      "long_description": "The first time each turn an opposing real champion within 5 spaces is destroyed, a Grave Warrior without upgrades is summoned adjacent to this unit.",
      "class_name": "Gravebind",
      "revision": 1
    },
    {
      "asset_id": 4307,
      "resettable": 1,
      "name": "Gravetend",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1335,
      "activated": 1,
      "icon_name": "ondeath",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 2,
      "short_description": "When this unit is deployed, your champion with the highest cooldown is set to 0. When this unit is destroyed, your enemy's champion with the highest cooldown is set to 0.",
      "long_description": "When this unit is deployed, your champion with the highest cooldown is set to 0. When this unit is destroyed, your enemy's champion with the highest cooldown is set to 0.",
      "class_name": "Gravetend",
      "revision": 1
    },
    {
      "asset_id": 4443,
      "resettable": 1,
      "name": "Graveyard",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 795,
      "activated": 1,
      "icon_name": "sumskel",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "A Skeleton champion with Font Ignorance is spawned to an unoccupied space adjacent to this relic. Your Shrine or Avatar loses 2 HP when you activate this ability.",
      "long_description": "A Skeleton champion with Font Ignorance is spawned to an unoccupied space adjacent to this relic. Your Shrine or Avatar loses 2 HP when you activate this ability.",
      "class_name": "RelicGraveyard",
      "revision": 1
    },
    {
      "asset_id": 5276,
      "resettable": 1,
      "name": "Gravity Well",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2717,
      "activated": 1,
      "icon_name": "gravitywell",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "Champions within 4 spaces are relocated 2 spaces closer to this one.",
      "long_description": "Champions within 4 spaces are relocated 2 spaces closer to this one.",
      "class_name": "GravityWell",
      "revision": 1
    },
    {
      "asset_id": 5529,
      "resettable": 1,
      "name": "Greater Vampirism",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2388,
      "activated": 1,
      "icon_name": "greater_vampirism",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "All vampiric healing is increased 50%. This does not stack.",
      "long_description": "All vampiric healing is increased 50%. This does not stack.",
      "class_name": "GreaterVampirism",
      "revision": 1
    },
    {
      "asset_id": 4377,
      "resettable": 1,
      "name": "Greenhouse",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1416,
      "activated": 1,
      "icon_name": "allybuffs",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "All Plants within 5 spaces gain +2 DMG and +1 DEF. This effect does not stack.",
      "long_description": "All Plants within 5 spaces gain +2 DMG and +1 DEF. This effect does not stack.",
      "class_name": "Greenhouse",
      "revision": 1
    },
    {
      "asset_id": 7134,
      "resettable": 0,
      "name": "Griffin Perch",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2976,
      "activated": 1,
      "icon_name": "griffin_perch",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "Sigil abilities triggered on friendly champions last an additional 2 turns.",
      "long_description": "Sigil abilities triggered on friendly champions last an additional 2 turns.",
      "class_name": "RelicGriffinPerch",
      "revision": 1
    },
    {
      "asset_id": 5524,
      "resettable": 1,
      "name": "Grim Aura",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2383,
      "activated": 1,
      "icon_name": "dark_aura",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "Enemy champions moving within 3 spaces of this unit lose all AP.",
      "long_description": "Enemy champions moving within 3 spaces of this unit lose all AP.",
      "class_name": "GrimAura",
      "revision": 1
    },
    {
      "asset_id": 4241,
      "resettable": 1,
      "name": "Grimlic's Eye",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 627,
      "activated": 1,
      "icon_name": "detection",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "Enemy champions within 5 spaces of this relic are <condition value=illuminated>Illuminated</condition>.",
      "long_description": "Enemy champions within 5 spaces of this relic are <condition value=illuminated>Illuminated</condition>.",
      "class_name": "RelicGrimlicsEye",
      "revision": 1
    },
    {
      "asset_id": 4442,
      "resettable": 1,
      "name": "Grimlic's Portal",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 794,
      "activated": 1,
      "icon_name": "relocate",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "Champions adjacent to this relic gain Portal (This unit may teleport to any deployment zone its controller controls.).",
      "long_description": "Champions adjacent to this relic gain Portal (This unit may teleport to any deployment zone its owner controls).",
      "class_name": "RelicGrimlicsPortal",
      "revision": 1
    },
    {
      "asset_id": 4585,
      "resettable": 1,
      "name": "Gronk Rider",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 990,
      "activated": 1,
      "icon_name": "rider",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 10,
      "short_description": "When this unit is destroyed, no nora globe is dropped and a Dwarven Handler with no upgrades is spawned in the location this unit occupied.",
      "long_description": "When this unit is destroyed, no nora globe is dropped and a Dwarven Handler with no upgrades is spawned in the location this unit occupied.",
      "class_name": "GronkRider",
      "revision": 1
    },
    {
      "asset_id": 4131,
      "resettable": 1,
      "name": "Ground",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 329,
      "activated": 1,
      "icon_name": "net",
      "comments": "do not use, use Web, Bola Attack, Ensnare, etc.",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 5,
      "short_description": "This champion makes an attack against target champion at 50% DMG. On successful damage, the target becomes <condition value=grounded>Grounded</condition> for 2 turns.",
      "long_description": "This champion makes an attack against target champion at 50% DMG. On successful damage, the target becomes <condition value=grounded>Grounded</condition> for 2 turns.",
      "class_name": "Ground",
      "revision": 1
    },
    {
      "asset_id": 5402,
      "resettable": 1,
      "name": "Grow",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 2234,
      "activated": 1,
      "icon_name": "grow",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 0,
      "ranked": 0,
      "cost": 20,
      "short_description": "This champion gains HP and permanently gains MAX HP equal to its base HP. When this ability has been used 2 times, it permanently gains <ability value=1395>Hunter: Walker</ability>.  When this ability has been used 3 times, it gains <ability value=1244>Cleave</ability>.  When this ability has been used 4 times, it permanently gains <ability value=1272>Titan</ability>.",
      "long_description": "This champion gains HP and permanently gains MAX HP equal to its base HP. When this ability has been used 2 times, it permanently gains <ability value=1395>Hunter: Walker</ability>.  When this ability has been used 3 times, it gains <ability value=1244>Cleave</ability>.  When this ability has been used 4 times, it permanently gains <ability value=1272>Titan</ability>.",
      "class_name": "Grow",
      "revision": 1
    },
    {
      "asset_id": 4798,
      "resettable": 1,
      "name": "Growth",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 1558,
      "activated": 1,
      "icon_name": "plantregen",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 6,
      "short_description": "Friendly champions within 1 space are healed for 2 HP at the beginning of your turns.",
      "long_description": "Friendly champions within 1 space are healed for 2 HP at the beginning of your turns.",
      "class_name": "Growth",
      "revision": 1
    },
    {
      "asset_id": 4798,
      "resettable": 1,
      "name": "Growth",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 1559,
      "activated": 1,
      "icon_name": "plantregen",
      "comments": "",
      "prerequisite_id": 1558,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 6,
      "short_description": "Friendly champions within 2 spaces are healed for 2 HP at the beginning of your turns.",
      "long_description": "Friendly champions within 2 spaces are healed for 2 HP at the beginning of your turns.",
      "class_name": "Growth",
      "revision": 1
    },
    {
      "asset_id": 4798,
      "resettable": 1,
      "name": "Growth",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 1560,
      "activated": 1,
      "icon_name": "plantregen",
      "comments": "",
      "prerequisite_id": 1559,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 6,
      "short_description": "Friendly champions within 2 spaces are healed for 3 HP at the beginning of your turns.",
      "long_description": "Friendly champions within 2 spaces are healed for 3 HP at the beginning of your turns.",
      "class_name": "Growth",
      "revision": 1
    },
    {
      "asset_id": 4798,
      "resettable": 1,
      "name": "Growth",
      "ap_cost": 0,
      "level": 4,
      "ability_id": 1561,
      "activated": 1,
      "icon_name": "plantregen",
      "comments": "",
      "prerequisite_id": 1560,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 6,
      "short_description": "Friendly champions within 3 spaces are healed for 3 HP at the beginning of your turns.",
      "long_description": "Friendly champions within 3 spaces are healed for 3 HP at the beginning of your turns.",
      "class_name": "Growth",
      "revision": 1
    },
    {
      "asset_id": 5771,
      "resettable": 1,
      "name": "Grumble Rock",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2684,
      "activated": 1,
      "icon_name": "fangandfur",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "Friendly Yeti champions within 5 spaces of this relic gain <ability value=396>Charge 3</ability>.",
      "long_description": "Friendly Yeti champions within 5 spaces of this relic gain <ability value=396>Charge 3</ability>.",
      "class_name": "GrumbleRock",
      "revision": 1
    },
    {
      "asset_id": 4292,
      "resettable": 1,
      "name": "Guard Tower",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 690,
      "activated": 1,
      "icon_name": "novaphysical",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 6,
      "short_description": "At the start of your turns, enemy champions within 4 spaces take 2 Physical damage and are knocked back 1 space (does not affect Stealthed champions).",
      "long_description": "At the start of your turns, enemy champions within 4 spaces take 2 Physical damage and are knocked back 1 space (does not affect Stealthed champions).",
      "class_name": "RelicGuardTower",
      "revision": 1
    },
    {
      "asset_id": 5526,
      "resettable": 1,
      "name": "Guarded: Beast",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2385,
      "activated": 1,
      "icon_name": "guarded",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 8,
      "short_description": "The first time each turn this unit is successfully attacked, friendly Beasts within 5 spaces gain 2 AP and +2 DMG for 2 turns.",
      "long_description": "The first time each turn this unit is successfully attacked, friendly Beasts within 5 spaces gain 2 AP and +2 DMG for 2 turns.",
      "class_name": "GuardedBeast",
      "revision": 1
    },
    {
      "asset_id": 5526,
      "resettable": 1,
      "name": "Guarded: Boghopper",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2919,
      "activated": 1,
      "icon_name": "guarded",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 8,
      "short_description": "The first time each turn this unit is successfully attacked, friendly Boghopper within 5 spaces gain 2 AP and +2 DMG for 2 turns.",
      "long_description": "The first time each turn this unit is successfully attacked, friendly Boghopper within 5 spaces gain 2 AP and +2 DMG for 2 turns.",
      "class_name": "GuardedBoghopper",
      "revision": 1
    },
    {
      "asset_id": 5673,
      "resettable": 1,
      "name": "Guarded: Cyclops",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2759,
      "activated": 1,
      "icon_name": "guarded",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 8,
      "short_description": "The first time each turn this unit is successfully attacked, friendly Cyclops within 5 spaces gain 2 AP and +2 DMG for 2 turns.",
      "long_description": "The first time each turn this unit is successfully attacked, friendly Cyclops within 5 spaces gain 2 AP and +2 DMG for 2 turns.",
      "class_name": "GuardedCyclops",
      "revision": 1
    },
    {
      "asset_id": 5526,
      "resettable": 0,
      "name": "Guarded: Draksar",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2969,
      "activated": 1,
      "icon_name": "bulwark_draksar",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 8,
      "short_description": "The first time each turn this unit is successfully attacked, friendly Draksar within 5 spaces gain 2 AP and +2 DMG for 2 turns.",
      "long_description": "The first time each turn this unit is successfully attacked, friendly Draksar within 5 spaces gain 2 AP and +2 DMG for 2 turns.",
      "class_name": "GuardedDraksar",
      "revision": 1
    },
    {
      "asset_id": 5588,
      "resettable": 1,
      "name": "Guarded: Garu",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2450,
      "activated": 1,
      "icon_name": "guarded",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "The first time each turn this unit is successfully attacked, friendly Garu within 5 spaces gain 2 AP and +2 DMG for 2 turns.",
      "long_description": "The first time each turn this unit is successfully attacked, friendly Garu within 5 spaces gain 2 AP and +2 DMG for 2 turns.",
      "class_name": "GuardedGaru",
      "revision": 1
    },
    {
      "asset_id": 5526,
      "resettable": 1,
      "name": "Guarded: Moga",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2920,
      "activated": 1,
      "icon_name": "guarded",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 8,
      "short_description": "The first time each turn this unit is successfully attacked, friendly Moga within 5 spaces gain 2 AP and +2 DMG for 2 turns.",
      "long_description": "The first time each turn this unit is successfully attacked, friendly Moga within 5 spaces gain 2 AP and +2 DMG for 2 turns.",
      "class_name": "GuardedMoga",
      "revision": 1
    },
    {
      "asset_id": 5685,
      "resettable": 1,
      "name": "Guarded: Skeezick",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2560,
      "activated": 1,
      "icon_name": "guarded",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 8,
      "short_description": "The first time each turn this unit is successfully attacked, friendly Skeezick within 5 spaces gain 2 AP and +2 DMG for 2 turns.",
      "long_description": "The first time each turn this unit is successfully attacked, friendly Skeezick within 5 spaces gain 2 AP and +2 DMG for 2 turns.",
      "class_name": "GuardedSkeezick",
      "revision": 1
    },
    {
      "asset_id": 5673,
      "resettable": 1,
      "name": "Guarded: Slag",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2545,
      "activated": 1,
      "icon_name": "guarded",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 8,
      "short_description": "The first time each turn this unit is successfully attacked, friendly Slag within 5 spaces gain 2 AP and +2 DMG for 2 turns.",
      "long_description": "The first time each turn this unit is successfully attacked, friendly Slag within 5 spaces gain 2 AP and +2 DMG for 2 turns.",
      "class_name": "GuardedSlag",
      "revision": 1
    },
    {
      "asset_id": 5673,
      "resettable": 0,
      "name": "Guarded: Yeti",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2925,
      "activated": 1,
      "icon_name": "guarded",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 8,
      "short_description": "The first time each turn this unit is successfully attacked, friendly Yeti within 5 spaces gain 2 AP and +2 DMG for 2 turns.",
      "long_description": "The first time each turn this unit is successfully attacked, friendly Yeti within 5 spaces gain 2 AP and +2 DMG for 2 turns.",
      "class_name": "GuardedYeti",
      "revision": 1
    },
    {
      "asset_id": 7507,
      "resettable": 0,
      "name": "Guardian's Light",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 3182,
      "activated": 1,
      "icon_name": "guardians_light",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 9,
      "short_description": "Target friendly champion within 5 spaces gains Magic Beam for 1 turn. If the target is a Megalith Guardian, this champion gains 1 AP.",
      "long_description": "Target friendly champion within 5 spaces gains Magic Beam for 1 turn. If the target is a Megalith Guardian, this champion gains 1 AP.",
      "class_name": "GuardiansLight",
      "revision": 1
    },
    {
      "asset_id": 7502,
      "resettable": 0,
      "name": "Guardian's Treasure",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3179,
      "activated": 1,
      "icon_name": "pirates_treasure",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "Friendly Dragons and Beasts within 5 spaces have +2 DMG and +1 DEF.  This does not stack.\r\n",
      "long_description": "Friendly Dragons and Beasts within 5 spaces have +2 DMG and +1 DEF.  This does not stack.\r\n",
      "class_name": "GuardiansTreasure",
      "revision": 1
    },
    {
      "asset_id": 5684,
      "resettable": 1,
      "name": "Guiding Spirit",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2666,
      "activated": 1,
      "icon_name": "guiding_spirit",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 2,
      "short_description": "When this unit is destroyed, you gain 5% of its nora cost for each real friendly champion that shares a race with it, to a maximum of 20%.",
      "long_description": "When this unit is destroyed, you gain 5% of its nora cost for each real friendly champion that shares a race with it, to a maximum of 20%.",
      "class_name": "GuidingSpirit",
      "revision": 1
    },
    {
      "asset_id": 5054,
      "resettable": 1,
      "name": "Habitation",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1232,
      "activated": 1,
      "icon_name": "buff",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 12,
      "short_description": "This champion gets +1 DEF, +1 DMG and +1 SPD for each font you control.",
      "long_description": "This champion gets +1 DEF, +1 DMG and +1 SPD for each font you control.",
      "class_name": "Habitation",
      "revision": 1
    },
    {
      "asset_id": 7379,
      "resettable": 0,
      "name": "Hahndor Memorial",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3131,
      "activated": 1,
      "icon_name": "inquisition",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "Enemy champions within 5 spaces are <ability value=2004>Faithless</ability>.  When this relic is deployed and when enemy champions moves within 5 spaces of this unit, they take 2 Fire damage and become <condition value=branded>Branded</condition> for 4 turns.",
      "long_description": "Enemy champions within 5 spaces are <ability value=2004>Faithless</ability>.  When this relic is deployed and when enemy champions moves within 5 spaces of this unit, they take 2 Fire damage and become <condition value=branded>Branded</condition> for 4 turns.",
      "class_name": "ShrineOfStSemmir",
      "revision": 1
    },
    {
      "asset_id": 4744,
      "resettable": 1,
      "name": "Halberd of J'Thir",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1289,
      "activated": 1,
      "icon_name": "aurapositive",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "Friendly champions within 5 spaces have <ability value=1775>Precision</ability> and <ability value=6>Mobility</ability>.",
      "long_description": "Friendly champions within 5 spaces have <ability value=1775>Precision</ability> and <ability value=6>Mobility</ability>.",
      "class_name": "RelicHalberdOfJthir",
      "revision": 1
    },
    {
      "asset_id": 5457,
      "resettable": 1,
      "name": "Hallucinogenic",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2309,
      "activated": 1,
      "icon_name": "hallucinogenic",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 8,
      "short_description": "When this unit is successfully attacked by a basic attack, the attacking champion gains <ability value=2266>Wandering</ability> for 3 turns.",
      "long_description": "When this unit is successfully attacked by a basic attack, the attacking champion gains <ability value=2266>Wandering</ability> for 3 turns.",
      "class_name": "Hallucinogenic",
      "revision": 1
    },
    {
      "asset_id": 4537,
      "resettable": 1,
      "name": "Hammer Throw",
      "ap_cost": 1,
      "level": 1,
      "ability_id": 870,
      "activated": 1,
      "icon_name": "hammer",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 6,
      "short_description": "Make a magical attack with a range of 3-6, at +2 DMG against target enemy unit.",
      "long_description": "Make a magical attack with a range of 3-6, at +2 DMG against target enemy unit.",
      "class_name": "HammerThrow",
      "revision": 1
    },
    {
      "asset_id": 4537,
      "resettable": 1,
      "name": "Hammer Throw",
      "ap_cost": 1,
      "level": 2,
      "ability_id": 872,
      "activated": 1,
      "icon_name": "hammer",
      "comments": "",
      "prerequisite_id": 870,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 8,
      "short_description": "Make a magical attack with a range of 3-6, at +4 DMG against target enemy unit.",
      "long_description": "Make a magical attack with a range of 3-6, at +4 DMG against target enemy unit.",
      "class_name": "HammerThrow",
      "revision": 1
    },
    {
      "asset_id": 4537,
      "resettable": 1,
      "name": "Hammer Throw",
      "ap_cost": 1,
      "level": 3,
      "ability_id": 873,
      "activated": 1,
      "icon_name": "hammer",
      "comments": "",
      "prerequisite_id": 872,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 10,
      "short_description": "Make a magical attack with a range of 3-6, at +6 DMG against target enemy unit.",
      "long_description": "Make a magical attack with a range of 3-6, at +6 DMG against target enemy unit.",
      "class_name": "HammerThrow",
      "revision": 1
    },
    {
      "asset_id": 4808,
      "resettable": 1,
      "name": "Harden",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 1577,
      "activated": 1,
      "icon_name": "defenseenhance",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 6,
      "short_description": "When this unit comes into play, all friendly champions gain a rank of Resistance - Frost and Resistance - Fire for 4 turns.",
      "long_description": "When this unit comes into play, all friendly champions gain a rank of Resistance - Frost and Resistance - Fire for 4 turns.",
      "class_name": "Harden",
      "revision": 1
    },
    {
      "asset_id": 4808,
      "resettable": 1,
      "name": "Harden",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 1578,
      "activated": 1,
      "icon_name": "defenseenhance",
      "comments": "",
      "prerequisite_id": 1577,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 6,
      "short_description": "When this unit comes into play, all friendly champions gain a rank of Resistance - Magical, Resistance - Frost and Resistance - Fire for 4 turns.",
      "long_description": "When this unit comes into play, all friendly champions gain a rank of Resistance - Magical, Resistance - Frost and Resistance - Fire for 4 turns.",
      "class_name": "Harden",
      "revision": 1
    },
    {
      "asset_id": 4808,
      "resettable": 1,
      "name": "Harden",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 2043,
      "activated": 1,
      "icon_name": "defenseenhance",
      "comments": "",
      "prerequisite_id": 1577,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 6,
      "short_description": "When this unit comes into play, all friendly champions gain a rank of Resistance - Physical, Resistance - Magical, Resistance - Frost and Resistance - Fire for 4 turns.",
      "long_description": "When this unit comes into play, all friendly champions gain a rank of Resistance - Physical, Resistance - Magical, Resistance - Frost and Resistance - Fire for 4 turns.",
      "class_name": "Harden",
      "revision": 1
    },
    {
      "asset_id": 4311,
      "resettable": 1,
      "name": "Harvest",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 1339,
      "activated": 1,
      "icon_name": "charm",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "Friendly Plant champions lose 1 AP and 2 HP each. You gain 3 nora for each Plant effected.",
      "long_description": "Friendly Plant champions lose 1 AP and 2 HP each. You gain 3 nora for each Plant effected.",
      "class_name": "Harvest",
      "revision": 1
    },
    {
      "asset_id": 5741,
      "resettable": 1,
      "name": "Harvest Organs",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2695,
      "activated": 1,
      "icon_name": "killing_stroke",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "When this champion recovers a nora globe, it gains 3 charges and +4 MAX HP permanently.",
      "long_description": "When this champion recovers a nora globe, it gains 3 charges and +4 MAX HP permanently.",
      "class_name": "HarvestOrgans",
      "revision": 1
    },
    {
      "asset_id": 5482,
      "resettable": 1,
      "name": "Haste",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2340,
      "activated": 1,
      "icon_name": "initiative",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "Target champion within 5 spaces has +4 SPD for 3 turns. ",
      "long_description": "Target champion within 5 spaces has +4 SPD for 3 turns. ",
      "class_name": "Haste",
      "revision": 1
    },
    {
      "asset_id": 4237,
      "resettable": 1,
      "name": "Haunt",
      "ap_cost": 4,
      "level": 1,
      "ability_id": 613,
      "activated": 1,
      "icon_name": "possess",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 1,
      "cost": 4,
      "short_description": "Target opposing relic within 3 spaces becomes <condition value=possessed>Possessed</condition> for 3 turns.  This unit is <condition value=paralyzed>Paralyzed</condition> while you control the Relic.",
      "long_description": "Target opposing relic within 3 spaces becomes <condition value=possessed>Possessed</condition> for 3 turns.  This unit is <condition value=paralyzed>Paralyzed</condition> while you control the Relic.",
      "class_name": "HauntAbility",
      "revision": 1
    },
    {
      "asset_id": 4237,
      "resettable": 1,
      "name": "Haunt",
      "ap_cost": 4,
      "level": 2,
      "ability_id": 614,
      "activated": 1,
      "icon_name": "possess",
      "comments": "",
      "prerequisite_id": 613,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 1,
      "cost": 8,
      "short_description": "Target opposing relic within 3 spaces becomes <condition value=possessed>Possessed</condition> for 6 turns.  This unit is <condition value=paralyzed>Paralyzed</condition> while you control the Relic.",
      "long_description": "Target opposing relic within 3 spaces becomes <condition value=possessed>Possessed</condition> for 6 turns.  This unit is <condition value=paralyzed>Paralyzed</condition> while you control the Relic.",
      "class_name": "HauntAbility",
      "revision": 1
    },
    {
      "asset_id": 4237,
      "resettable": 1,
      "name": "Haunt",
      "ap_cost": 4,
      "level": 3,
      "ability_id": 615,
      "activated": 1,
      "icon_name": "possess",
      "comments": "",
      "prerequisite_id": 614,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 1,
      "cost": 12,
      "short_description": "Target opposing relic within 3 spaces becomes <condition value=possessed>Possessed</condition> for 9 turns.  This unit is <condition value=paralyzed>Paralyzed</condition> while you control the Relic.",
      "long_description": "Target opposing relic within 3 spaces becomes <condition value=possessed>Possessed</condition> for 9 turns.  This unit is <condition value=paralyzed>Paralyzed</condition> while you control the Relic.",
      "class_name": "HauntAbility",
      "revision": 1
    },
    {
      "asset_id": 7603,
      "resettable": 0,
      "name": "Haunted Domain",
      "ap_cost": 5,
      "level": 0,
      "ability_id": 3231,
      "activated": 1,
      "icon_name": "haunted_domain",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 12,
      "short_description": "Area Effect 3, Range 5: Affected spaces becomes Haunted Domain for 5 turns and 4 Smoke Spirits (7 DMG, 5 SPD, 1-1 RNG, 8 HP, Flight) are summoned randomly within the affected area. Smoke Spirits are Sacrificed if they leave the Haunted Domain",
      "long_description": "Area Effect 3, Range 5: Affected spaces becomes Haunted Domain for 5 turns and 4 Smoke Spirits (7 DMG, 5 SPD, 1-1 RNG, 8 HP, Flight) are summoned randomly within the affected area. Smoke Spirits are Sacrificed if they leave the Haunted Domain",
      "class_name": "HauntedDomain",
      "revision": 1
    },
    {
      "asset_id": 5782,
      "resettable": 1,
      "name": "Haunting Visions",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2703,
      "activated": 1,
      "icon_name": "possess",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "At the beginning of its turn, this champion gains 2 AP and +3 DMG and +1 DEF for 2 turns if opponent has 25 or less nora. This does not stack.",
      "long_description": "At the beginning of its turn, this champion gains 2 AP and +3 DMG and +1 DEF for 2 turns if opponent has 25 or less nora. This does not stack.",
      "class_name": "HauntingVisions",
      "revision": 1
    },
    {
      "asset_id": 4486,
      "resettable": 1,
      "name": "Hawk Attack",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 887,
      "activated": 1,
      "icon_name": "hawk_attack",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 0,
      "ranked": 1,
      "cost": 8,
      "short_description": "This unit makes a Physical attack at Range 3-6. If attack is successful, the target is <condition value=eviscerated>Eviscerated</condition> for 3 turns.",
      "long_description": "This unit makes a Physical attack at Range 3-6. If attack is successful, the target is <condition value=eviscerated>Eviscerated</condition> for 3 turns.",
      "class_name": "HawkAttack",
      "revision": 1
    },
    {
      "asset_id": 5841,
      "resettable": 1,
      "name": "Hawks Talon",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2850,
      "activated": 1,
      "icon_name": "manic",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 5,
      "short_description": "x",
      "long_description": "text goes here",
      "class_name": "HawksTalon",
      "revision": 1
    },
    {
      "asset_id": 4514,
      "resettable": 0,
      "name": "heacy crosboew",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 3162,
      "activated": 1,
      "icon_name": "arrow",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 5,
      "short_description": "This champion makes a Physical attack at 12 DMG and RNG 2-5 (this ignores DEF).",
      "long_description": "This champion makes a Physical attack at 12 DMG and RNG 2-5 (this ignores DEF).",
      "class_name": "HeavyCrossbowAttack",
      "revision": 1
    },
    {
      "asset_id": 4636,
      "resettable": 1,
      "name": "Headless",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1460,
      "activated": 1,
      "icon_name": "headless",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -30,
      "short_description": "At the beginning of your turn this unit moves 2 spaces randomly towards your enemies Shrine or Avatar. This unit cannot spend AP on movement.",
      "long_description": "At the beginning of your turn this unit moves 2 spaces randomly towards your enemies shrine. This unit cannot spend AP on movement.",
      "class_name": "Headless",
      "revision": 1
    },
    {
      "asset_id": 4141,
      "resettable": 1,
      "name": "Heal Champion",
      "ap_cost": 3,
      "level": 1,
      "ability_id": 366,
      "activated": 1,
      "icon_name": "heal",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 1,
      "cost": 4,
      "short_description": "Target friendly champion within 5 spaces heals 4 HP. May target self.",
      "long_description": "Target friendly champion within 5 spaces heals 4 HP. May target self.",
      "class_name": "HealingSingle",
      "revision": 1
    },
    {
      "asset_id": 4141,
      "resettable": 1,
      "name": "Heal Champion",
      "ap_cost": 3,
      "level": 2,
      "ability_id": 367,
      "activated": 1,
      "icon_name": "heal",
      "comments": "none",
      "prerequisite_id": 366,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 1,
      "cost": 6,
      "short_description": "Target friendly champion within 5 spaces heals 8 HP. May target self.",
      "long_description": "Target friendly champion within 5 spaces heals 8 HP. May target self.",
      "class_name": "HealingSingle",
      "revision": 1
    },
    {
      "asset_id": 4141,
      "resettable": 1,
      "name": "Heal Champion",
      "ap_cost": 3,
      "level": 3,
      "ability_id": 368,
      "activated": 1,
      "icon_name": "heal",
      "comments": "none",
      "prerequisite_id": 367,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 8,
      "short_description": "Target friendly champion within 5 spaces heals 12 HP. May target self.",
      "long_description": "Target friendly champion within 5 spaces heals 12 HP. May target self.",
      "class_name": "HealingSingle",
      "revision": 1
    },
    {
      "asset_id": 5338,
      "resettable": 1,
      "name": "Heal Charged",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 2169,
      "activated": 1,
      "icon_name": "heal_charged",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 2,
      "short_description": "When any unit is healed, this unit gains 1 charge.",
      "long_description": "When any unit is healed, this unit gains 1 charge.",
      "class_name": "HealCharged",
      "revision": 1
    },
    {
      "asset_id": 5338,
      "resettable": 1,
      "name": "Heal Charged",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 2170,
      "activated": 1,
      "icon_name": "heal_charged",
      "comments": "",
      "prerequisite_id": 2169,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 4,
      "short_description": "When any unit is healed, this unit gains 2 charges.",
      "long_description": "When any unit is healed, this unit gains 2 charges.",
      "class_name": "HealCharged",
      "revision": 1
    },
    {
      "asset_id": 5338,
      "resettable": 1,
      "name": "Heal Charged",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 2171,
      "activated": 1,
      "icon_name": "heal_charged",
      "comments": "",
      "prerequisite_id": 2170,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 8,
      "short_description": "When any unit is healed, this unit gains 3 charges.",
      "long_description": "When any unit is healed, this unit gains 3 charges.",
      "class_name": "HealCharged",
      "revision": 1
    },
    {
      "asset_id": 4142,
      "resettable": 1,
      "name": "Heal Mass",
      "ap_cost": 3,
      "level": 1,
      "ability_id": 370,
      "activated": 1,
      "icon_name": "healmass",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 1,
      "cost": 4,
      "short_description": "Friendly champions, including this one, within 3 spaces heal 3 HP.",
      "long_description": "Friendly champions, including this one, within 3 spaces heal 3 HP.",
      "class_name": "HealingMass",
      "revision": 1
    },
    {
      "asset_id": 4142,
      "resettable": 1,
      "name": "Heal Mass",
      "ap_cost": 3,
      "level": 2,
      "ability_id": 371,
      "activated": 1,
      "icon_name": "healmass",
      "comments": "none",
      "prerequisite_id": 370,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 1,
      "cost": 6,
      "short_description": "Friendly champions, including this one, within 3 spaces heal 6 HP.",
      "long_description": "Friendly champions, including this one, within 3 spaces heal 6 HP.",
      "class_name": "HealingMass",
      "revision": 1
    },
    {
      "asset_id": 4142,
      "resettable": 1,
      "name": "Heal Mass",
      "ap_cost": 3,
      "level": 3,
      "ability_id": 372,
      "activated": 1,
      "icon_name": "healmass",
      "comments": "none",
      "prerequisite_id": 371,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 8,
      "short_description": "Friendly champions, including this one, within 3 spaces heal 9 HP.",
      "long_description": "Friendly champions, including this one, within 3 spaces heal 9 HP.",
      "class_name": "HealingMass",
      "revision": 1
    },
    {
      "asset_id": 4647,
      "resettable": 1,
      "name": "Heal Self",
      "ap_cost": 3,
      "level": 1,
      "ability_id": 1073,
      "activated": 1,
      "icon_name": "heal",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 1,
      "cost": 1,
      "short_description": "This unit recovers 4 HP.",
      "long_description": "This unit recovers 4 HP.",
      "class_name": "HealSelf",
      "revision": 1
    },
    {
      "asset_id": 4647,
      "resettable": 1,
      "name": "Heal Self",
      "ap_cost": 3,
      "level": 2,
      "ability_id": 1075,
      "activated": 1,
      "icon_name": "heal",
      "comments": "",
      "prerequisite_id": 1073,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 1,
      "cost": 3,
      "short_description": "This unit recovers 8 HP.",
      "long_description": "This unit recovers 8 HP.",
      "class_name": "HealSelf",
      "revision": 1
    },
    {
      "asset_id": 4647,
      "resettable": 1,
      "name": "Heal Self",
      "ap_cost": 3,
      "level": 3,
      "ability_id": 1076,
      "activated": 1,
      "icon_name": "heal",
      "comments": "",
      "prerequisite_id": 1075,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 5,
      "short_description": "This unit recovers 12 HP.",
      "long_description": "This unit recovers 12 HP.",
      "class_name": "HealSelf",
      "revision": 1
    },
    {
      "asset_id": 4587,
      "resettable": 1,
      "name": "Heal Serpent",
      "ap_cost": 3,
      "level": 1,
      "ability_id": 991,
      "activated": 1,
      "icon_name": "heal",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 1,
      "cost": 4,
      "short_description": "Target friendly Serpent within 3 spaces recovers 6 HP.   Other friendly Serpents recover 3 HP.",
      "long_description": "Target friendly Serpent within 3 spaces recovers 6 HP.   Other friendly Serpents recover 3 HP.",
      "class_name": "HealSerpent",
      "revision": 1
    },
    {
      "asset_id": 4587,
      "resettable": 1,
      "name": "Heal Serpent",
      "ap_cost": 3,
      "level": 2,
      "ability_id": 992,
      "activated": 1,
      "icon_name": "heal",
      "comments": "",
      "prerequisite_id": 991,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 1,
      "cost": 9,
      "short_description": "Target friendly Serpent within 3 spaces recovers 12 HP.   Other friendly Serpents recover 6 HP.",
      "long_description": "Target friendly Serpent within 3 spaces recovers 12 HP.   Other friendly Serpents recover 6 HP.",
      "class_name": "HealSerpent",
      "revision": 1
    },
    {
      "asset_id": 4439,
      "resettable": 1,
      "name": "Healing Breath",
      "ap_cost": 3,
      "level": 1,
      "ability_id": 789,
      "activated": 1,
      "icon_name": "healmass",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 10,
      "short_description": "Area Effect 2, Range 3: Other champions are <mechanic value=cleansed>Cleansed</mechanic> and healed 18 HP divided by the number of targets (rounded down to a max of 8 HP per target).",
      "long_description": "Area Effect 2, Range 3: Other champions are <mechanic value=cleansed>Cleansed</mechanic> and healed 18 HP divided by the number of targets (rounded down to a max of 8 HP per target).",
      "class_name": "HealingBreath",
      "revision": 1
    },
    {
      "asset_id": 4439,
      "resettable": 1,
      "name": "Healing Breath",
      "ap_cost": 3,
      "level": 2,
      "ability_id": 790,
      "activated": 1,
      "icon_name": "healmass",
      "comments": "",
      "prerequisite_id": 789,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 14,
      "short_description": "Area Effect 2, Range 3: Other champions are <mechanic value=cleansed>Cleansed</mechanic> and healed 25 HP divided by the number of targets (rounded down to a max of 12 HP per target).",
      "long_description": "Area Effect 2, Range 3: Other champions are <mechanic value=cleansed>Cleansed</mechanic> and healed 25 HP divided by the number of targets (rounded down to a max of 12 HP per target).",
      "class_name": "HealingBreath",
      "revision": 1
    },
    {
      "asset_id": 4631,
      "resettable": 1,
      "name": "Healing Deficiency",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1054,
      "activated": 1,
      "icon_name": "inhibit",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -4,
      "short_description": "Healing received by this unit is reduced by 50%.",
      "long_description": "Healing received by this unit is reduced by 50%.",
      "class_name": "LimitedHeal",
      "revision": 1
    },
    {
      "asset_id": 7770,
      "resettable": 0,
      "name": "Healing Mind",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3295,
      "activated": 1,
      "icon_name": "healing_wind",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "When this champion makes a successful basic attack, the closest friendly damaged champion (not including this one) within 5 spaces of this champion is healed for 5.",
      "long_description": "When this champion makes a successful basic attack, the closest friendly damaged champion (not including this one) within 5 spaces of this champion is healed for 5.",
      "class_name": "HealingMind",
      "revision": 1
    },
    {
      "asset_id": 5600,
      "resettable": 1,
      "name": "Healing Waters",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2460,
      "activated": 1,
      "icon_name": "heal",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "Target champion within 2 spaces heals HP equal to half its max HP.",
      "long_description": "Target champion within 2 spaces heals HP equal to half its max HP.",
      "class_name": "RelicLayOnHands",
      "revision": 1
    },
    {
      "asset_id": 7554,
      "resettable": 0,
      "name": "Healing Wind",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3208,
      "activated": 1,
      "icon_name": "healing_wind",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "When this champion makes a successful basic attack, the closest friendly damaged champion (not including this one) within 5 spaces of the target is healed for 4.  If the champion has <condition value=flying>Flying</condition>, it is healed for 8 HP instead.",
      "long_description": "When this champion makes a successful basic attack, the closest friendly damaged champion (not including this one) within 5 spaces of the target is healed for 4.  If the champion has <condition value=flying>Flying</condition>, it is healed for 8 HP instead.",
      "class_name": "HealingWind",
      "revision": 1
    },
    {
      "asset_id": 7472,
      "resettable": 1,
      "name": "Heart Strike",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2646,
      "activated": 1,
      "icon_name": "killing_stroke",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "When this champion makes a successful basic attack against a champion with 50% or less HP, it gains 1 AP and has +2 DMG for the attack.",
      "long_description": "When this champion makes a successful basic attack against a champion with 50% or less HP, it gains 1 AP and has +2 DMG for the attack.",
      "class_name": "HeartStrike",
      "revision": 1
    },
    {
      "asset_id": 7966,
      "resettable": 0,
      "name": "Heartbreaker",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3353,
      "activated": 1,
      "icon_name": "charm",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "This champion does double damage to <condition value=charmed>Charmed</condition> champions. The condition is then removed.",
      "long_description": "This champion does double damage to <condition value=charmed>Charmed</condition> champions. The condition is then removed.",
      "class_name": "Heartbreaker",
      "revision": 1
    },
    {
      "asset_id": 4870,
      "resettable": 1,
      "name": "Heavy Charger",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1752,
      "activated": 1,
      "icon_name": "crush",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 7,
      "short_description": "This champion deals 50% more damage when using <ability value=394>Charge</ability>.",
      "long_description": "This champion deals 50% more damage when using <ability value=394>Charge</ability>.",
      "class_name": "HeavyCharger",
      "revision": 1
    },
    {
      "asset_id": 4514,
      "resettable": 1,
      "name": "Heavy Crossbow",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 943,
      "activated": 1,
      "icon_name": "arrow",
      "comments": "This uses the same asset id as Spear Attack",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "This champion makes a Physical attack at 12 DMG and RNG 2-5 (this ignores DEF).",
      "long_description": "This champion makes a Physical attack at 12 DMG and RNG 2-5 (this ignores DEF).",
      "class_name": "HeavyCrossbowAttack",
      "revision": 1
    },
    {
      "asset_id": 5544,
      "resettable": 1,
      "name": "Hellstorm",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2404,
      "activated": 1,
      "icon_name": "fireaoe",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "After 3 rounds, this champion deals massive fire damage to all opposing champions based on the number of charges it has.  This ability consumes all charges.",
      "long_description": "After 3 rounds, this champion deals massive fire damage to all opposing champions based on the number of charges it has.  This ability consumes all charges.",
      "class_name": "Hellstorm",
      "revision": 1
    },
    {
      "asset_id": 5229,
      "resettable": 1,
      "name": "Helpless",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2007,
      "activated": 1,
      "icon_name": "defpenalties",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -17,
      "short_description": "This champion has <ability value=2002>Easy Target</ability> and <ability value=2001>Defenseless</ability> ",
      "long_description": "This champion has <ability value=2002>Easy Target</ability> and <ability value=2001>Defenseless</ability> ",
      "class_name": "Helpless",
      "revision": 1
    },
    {
      "asset_id": 4637,
      "resettable": 1,
      "name": "Herbivore",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1461,
      "activated": 1,
      "icon_name": "passive",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "When this unit deals damage to a plant champion, it heals HP equal to half the damage dealt and gains 1 AP.",
      "long_description": "When this unit deals damage to a plant champion, it heals HP equal to half the damage dealt and gains 1 AP.",
      "class_name": "Herbivore",
      "revision": 1
    },
    {
      "asset_id": 4450,
      "resettable": 1,
      "name": "Hero",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 802,
      "activated": 1,
      "icon_name": "hero",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
      "long_description": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
      "class_name": "Hero",
      "revision": 1
    },
    {
      "asset_id": 4364,
      "resettable": 1,
      "name": "Hex",
      "ap_cost": 1,
      "level": 1,
      "ability_id": 1398,
      "activated": 1,
      "icon_name": "lossoflife",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 1,
      "cost": 5,
      "short_description": "This champion makes a Loss of Life attack for 4 life against target champion within 4 spaces. When a champion loses 1 or more life from this attack, it becomes <condition value=hexed>Hexed</condition> for 3 turns.  This effect does not stack.",
      "long_description": "This champion makes a Loss of Life attack for 4 life against target champion within 4 spaces. When a champion loses 1 or more life from this attack, it becomes <condition value=hexed>Hexed</condition> for 3 turns.  This effect does not stack.\r\n",
      "class_name": "Hex",
      "revision": 1
    },
    {
      "asset_id": 4364,
      "resettable": 1,
      "name": "Hex",
      "ap_cost": 1,
      "level": 2,
      "ability_id": 1399,
      "activated": 1,
      "icon_name": "lossoflife",
      "comments": "",
      "prerequisite_id": 1398,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 1,
      "cost": 7,
      "short_description": "This champion makes a Loss of Life attack for 6 life against target champion within 5 spaces. When a champion loses 1 or more life from this attack, it becomes Hexed 3 (This unit's DMG is reduced by 60%). This effect does not stack.",
      "long_description": "This champion makes a Loss of Life attack for 6 life against target champion within 5 spaces. When a champion loses 1 or more life from this attack, it becomes Hexed 3 (This unit's DMG is reduced by 60%). This effect does not stack.",
      "class_name": "Hex",
      "revision": 1
    },
    {
      "asset_id": 4364,
      "resettable": 1,
      "name": "Hex",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 1400,
      "activated": 1,
      "icon_name": "lossoflife",
      "comments": "",
      "prerequisite_id": 1399,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 1,
      "cost": 9,
      "short_description": "This champion makes a Loss of Life attack for 8 life against target champion within 6 spaces. When a champion loses 1 or more life from this attack, it becomes Hexed 3 (This unit's DMG is reduced by 60%). This effect does not stack.",
      "long_description": "This champion makes a Loss of Life attack for 8 life against target champion within 6 spaces. When a champion loses 1 or more life from this attack, it becomes Hexed 3 (This unit's DMG is reduced by 60%). This effect does not stack.",
      "class_name": "Hex",
      "revision": 1
    },
    {
      "asset_id": 4987,
      "resettable": 1,
      "name": "Hibernate",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 1869,
      "activated": 1,
      "icon_name": "hibernate",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "This champion becomes <condition value=stealthed>Stealthed</condition> for 6 turns. At the start of next turn, it gains <ability value=117>Regeneration 3</ability>, <ability value=757>Immobile</ability> and <condition value=pacified>Pacified</condition> for 3 turns or until it is destealthed.",
      "long_description": "This champion becomes <condition value=stealthed>Stealthed</condition> for 6 turns. At the start of next turn, it gains <ability value=117>Regeneration 3</ability>, <ability value=757>Immobile</ability> and <condition value=pacified>Pacified</condition> for 3 turns or until it is destealthed.",
      "class_name": "Hibernate",
      "revision": 1
    },
    {
      "asset_id": 4603,
      "resettable": 1,
      "name": "Hidden: Arctic",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1019,
      "activated": 1,
      "icon_name": "stealth",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "At the end of your turn, if this champion occupies Ice or Snow, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
      "long_description": "At the end of your turn, if this champion occupies Ice or Snow, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
      "class_name": "HiddenArctic",
      "revision": 1
    },
    {
      "asset_id": 4871,
      "resettable": 1,
      "name": "Hidden: Chasm",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1753,
      "activated": 1,
      "icon_name": "stealth",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "At the end of your turn, if this champion occupies a chasm space, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
      "long_description": "At the end of your turn, if this champion occupies a chasm space, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
      "class_name": "HiddenChasm",
      "revision": 1
    },
    {
      "asset_id": 4872,
      "resettable": 1,
      "name": "Hidden: Dead Magic Zone",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1754,
      "activated": 1,
      "icon_name": "stealth",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "At the end of your turn, if this champion occupies a <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic>, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
      "long_description": "At the end of your turn, if this champion occupies a <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic>, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.\r\n",
      "class_name": "HiddenDeadMagicZone",
      "revision": 1
    },
    {
      "asset_id": 7986,
      "resettable": 0,
      "name": "Hidden: Ooze",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3382,
      "activated": 1,
      "icon_name": "stealth",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "At the end of your turn, if this unit occupies Ooze, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
      "long_description": "At the end of your turn, if this unit occupies Ooze, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
      "class_name": "HiddenOoze",
      "revision": 1
    },
    {
      "asset_id": 4599,
      "resettable": 1,
      "name": "Hidden: Rock",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 970,
      "activated": 1,
      "icon_name": "stealth",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "At the end of your turn, if this champion occupies Rock, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
      "long_description": "At the end of your turn, if this champion occupies Rock, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
      "class_name": "HiddenStone",
      "revision": 1
    },
    {
      "asset_id": 4665,
      "resettable": 1,
      "name": "Hidden: Sand",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1099,
      "activated": 1,
      "icon_name": "stealth",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 3,
      "short_description": "At the end of your turn, if this champion occupies Sand, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
      "long_description": "At the end of your turn, if this champion occupies Sand, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
      "class_name": "HiddenSand",
      "revision": 1
    },
    {
      "asset_id": 4440,
      "resettable": 1,
      "name": "Hidden: Vegetation",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 791,
      "activated": 1,
      "icon_name": "stealth",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 3,
      "short_description": "At the end of your turn, if this champion occupies Vegetation, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
      "long_description": "At the end of your turn, if this champion occupies Vegetation, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
      "class_name": "HiddenForest",
      "revision": 1
    },
    {
      "asset_id": 4473,
      "resettable": 1,
      "name": "Hidden: Water",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 855,
      "activated": 1,
      "icon_name": "stealth",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 3,
      "short_description": "At the end of your turn, if this champion occupies Water, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
      "long_description": "At the end of your turn, if this champion occupies Water, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
      "class_name": "HiddenWater",
      "revision": 1
    },
    {
      "asset_id": 4185,
      "resettable": 1,
      "name": "Hinder Movement",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 524,
      "activated": 1,
      "icon_name": "pindown",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "This unit makes an attack at RNG 2-5. If successful, the target becomes <mechanic value=slowed>Slowed</mechanic> for 3 turns.",
      "long_description": "This unit makes an attack at RNG 2-5. If successful, the target becomes <mechanic value=slowed>Slowed</mechanic> for 3 turns.",
      "class_name": "HinderMovement",
      "revision": 1
    },
    {
      "asset_id": 5531,
      "resettable": 1,
      "name": "Hit and Run",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2390,
      "activated": 1,
      "icon_name": "hit_and_run",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "When this champion makes a basic attack, it gains <ability value=6>Mobility</ability> for 1 turn and 1 AP whenever it moves for 1 turn. This effect may trigger up to 3 times per turn.",
      "long_description": "When this champion makes a basic attack, it gains <ability value=6>Mobility</ability> for 1 turn and 1 AP whenever it moves for 1 turn. This effect may trigger up to 3 times per turn.",
      "class_name": "HitAndRun",
      "revision": 1
    },
    {
      "asset_id": 5237,
      "resettable": 1,
      "name": "Hive",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2017,
      "activated": 1,
      "icon_name": "locust_swarm",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 0,
      "short_description": "At the end of your turn all enemy champions within 4 spaces take 3 Physical damage and become <condition value=poisoned>Poisoned</condition> for 2 turns.  This damage ignores DEF.",
      "long_description": "At the end of your turn all enemy champions within 4 spaces take 3 Physical damage and become <condition value=poisoned>Poisoned</condition> for 2 turns.  This damage ignores DEF.",
      "class_name": "Hive",
      "revision": 1
    },
    {
      "asset_id": 5210,
      "resettable": 1,
      "name": "Hold the Line",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 1987,
      "activated": 1,
      "icon_name": "defenseenhance",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "This champion gains +2 DEF, +1 MAX RNG, <ability value=680>Planar Bound</ability>, <ability value=597>Unstoppable</ability>, <ability value=4>Iron Will</ability> and <ability value=1818>Defensive Strike</ability> until it moves. This does not stack.",
      "long_description": "This champion gains +2 DEF, +1 MAX RNG, <ability value=680>Planar Bound</ability>, <ability value=597>Unstoppable</ability>, <ability value=4>Iron Will</ability> and <ability value=1818>Defensive Strike</ability> until it moves. This does not stack.",
      "class_name": "HoldTheLine",
      "revision": 1
    },
    {
      "asset_id": 7555,
      "resettable": 0,
      "name": "Holy Armaments",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3209,
      "activated": 1,
      "icon_name": "comboatk_devastate",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "When a friendly Paladin, Priest or Shaman becomes equipped, it gains 1 AP and +2 DMG for 2 turns. This does not stack.",
      "long_description": "When a friendly Paladin, Priest or Shaman becomes equipped, it gains 1 AP and +2 DMG for 2 turns. This does not stack.",
      "class_name": "HolyArmaments",
      "revision": 1
    },
    {
      "asset_id": 7542,
      "resettable": 0,
      "name": "Homing Sense",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3197,
      "activated": 1,
      "icon_name": "homing_sense",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "This unit has <ability value=6>Mobility</ability>. At the beginning of its turns, if it is not <condition value=stunned>Stunned</condition> or <condition value=paralyzed>Paralyzed</condition>, this unit is relocated to the closest enemy champion within 5 spaces.",
      "long_description": "This unit has <ability value=6>Mobility</ability>. At the beginning of its turns, if it is not <condition value=stunned>Stunned</condition> or <condition value=paralyzed>Paralyzed</condition>, this unit is relocated to the closest enemy champion within 5 spaces.",
      "class_name": "HomingSense",
      "revision": 1
    },
    {
      "asset_id": 5209,
      "resettable": 1,
      "name": "Honor Guard",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1986,
      "activated": 1,
      "icon_name": "revere",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "While Juya White-Eyes or Jakei Frost Queen is in play, this champion has <ability value=15>Multiattack 1</ability> and +1 DEF.",
      "long_description": "While Juya White-Eyes or Jakei Frost Queen is in play, this champion has <ability value=15>Multiattack 1</ability> and +1 DEF.",
      "class_name": "HonorGuard",
      "revision": 1
    },
    {
      "asset_id": 5599,
      "resettable": 1,
      "name": "Honorary Sigil",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2459,
      "activated": 1,
      "icon_name": "griffin_sigil",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "This counts as a Sigil ability.  When this unit is deployed, other Sigil abilities will trigger.",
      "long_description": "This counts as a Sigil ability.  When this unit is deployed, other Sigil abilities will trigger.",
      "class_name": "HonorarySigil",
      "revision": 1
    },
    {
      "asset_id": 4874,
      "resettable": 1,
      "name": "Horn of K'thir",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 1756,
      "activated": 1,
      "icon_name": "horn_kithir",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "All friendly champions get +1 DEF and have +4 DMG on melee attacks for 2 turns.",
      "long_description": "All friendly champions get +1 DEF and have +4 DMG on melee attacks for 2 turns.",
      "class_name": "HornOfKthir",
      "revision": 1
    },
    {
      "asset_id": 4119,
      "resettable": 1,
      "name": "Horrific Aura",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 299,
      "activated": 1,
      "icon_name": "fear",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "For 2 turns, when a champion attacks this unit, that champion becomes <condition value=frightened>Frightened</condition> and the attack misses. This effect is hidden until triggered.",
      "long_description": "For 2 turns, when a champion attacks this unit, that champion becomes <condition value=frightened>Frightened</condition> and the attack misses. This effect is hidden until triggered.",
      "class_name": "HorrificAura",
      "revision": 1
    },
    {
      "asset_id": 4119,
      "resettable": 1,
      "name": "Horrific Aura",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 300,
      "activated": 1,
      "icon_name": "fear",
      "comments": "none",
      "prerequisite_id": 299,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 1,
      "cost": 8,
      "short_description": "For 2 turns, when a champion attacks this unit, that champion becomes <condition value=frightened>Frightened</condition> for 2 turns and the attack misses. This effect is hidden until triggered.",
      "long_description": "For 2 turns, when a champion attacks this unit, that champion becomes <condition value=frightened>Frightened</condition> for 2 turns and the attack misses. This effect is hidden until triggered.",
      "class_name": "HorrificAura",
      "revision": 1
    },
    {
      "asset_id": 4119,
      "resettable": 1,
      "name": "Horrific Aura",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 301,
      "activated": 1,
      "icon_name": "fear",
      "comments": "none",
      "prerequisite_id": 300,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 10,
      "short_description": "For 2 turns, when a champion attacks this unit, that champion becomes <condition value=frightened>Frightened</condition> for 2 turns and the attack misses. This effect is hidden until triggered.",
      "long_description": "For 2 turns, when a champion attacks this unit, that champion becomes <condition value=frightened>Frightened</condition> for 2 turns and the attack misses. This effect is hidden until triggered.",
      "class_name": "HorrificAura",
      "revision": 1
    },
    {
      "asset_id": 5782,
      "resettable": 1,
      "name": "Horrifying Delusion",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2783,
      "activated": 1,
      "icon_name": "possess",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "If the opposing player has 25 or less nora at the beginning of this unit's turn, it gains <ability value=1850>Frightful Blows</ability> and <ability value=99>Life Siphon</ability>.",
      "long_description": "If the opposing player has 25 or less nora at the beginning of this unit's turn, it gains <ability value=1850>Frightful Blows</ability> and <ability value=99>Life Siphon</ability>.",
      "class_name": "HorrifyingVisions",
      "revision": 1
    },
    {
      "asset_id": 5056,
      "resettable": 1,
      "name": "Hostile",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1233,
      "activated": 1,
      "icon_name": "enrage",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "This unit sacrifices 5 HP to gain +5 DMG until the end of turn.",
      "long_description": "This unit sacrifices 5 HP to gain +5 DMG until the end of turn.",
      "class_name": "Hostile",
      "revision": 1
    },
    {
      "asset_id": 5611,
      "resettable": 1,
      "name": "Howling Attack",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 2470,
      "activated": 1,
      "icon_name": "horrific_howl",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "This champion makes a Sonic attack at +2 DMG against target enemy champion within 4 spaces. If successfully damaged, the target becomes <condition value=frightened>Frightened</condition> for 2 turns.",
      "long_description": "This champion makes a Sonic attack at +2 DMG against target enemy champion within 4 spaces. If successfully damaged, the target becomes <condition value=frightened>Frightened</condition> for 2 turns.",
      "class_name": "HorrificHowl",
      "revision": 1
    },
    {
      "asset_id": 5608,
      "resettable": 1,
      "name": "Hunted",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2467,
      "activated": 1,
      "icon_name": "declare_hunted",
      "comments": "A sub ability from Declare Enemy.",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "This champion receives 4 more damage from any Attack by a champion with <ability value=2465>Declare Hunted</ability>.",
      "long_description": "This champion receives 4 more damage from any Attack by a champion with <ability value=2465>Declare Hunted</ability>.",
      "class_name": "HuntedAbility",
      "revision": 1
    },
    {
      "asset_id": 5194,
      "resettable": 1,
      "name": "Hunter's Blind",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 1971,
      "activated": 1,
      "icon_name": "camo",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 20,
      "short_description": "Until this unit moves, it gets +3 DMG, its range becomes 4-8, and it will becomed <condition value=stealthed>Stealthed</condition> at the end of your turns.",
      "long_description": "Until this unit moves, it gets +3 DMG, its range becomes 4-8, and it will becomed <condition value=stealthed>Stealthed</condition> at the end of your turns.",
      "class_name": "HuntersBlind",
      "revision": 1
    },
    {
      "asset_id": 7788,
      "resettable": 0,
      "name": "Hunter's Mark OLD",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3310,
      "activated": 1,
      "icon_name": "hunted",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "When this unit is deployed, the closest opposing champion becomes <condition value=tagged>Tagged</condition><ability value=3277> </ability> and permanently gains <ability value=2467>Hunted</ability>.",
      "long_description": "When this unit is deployed, the closest opposing champion becomes <condition value=tagged>Tagged</condition><ability value=3277> </ability> and permanently gains <ability value=2467>Hunted</ability>.",
      "class_name": "HuntersMark",
      "revision": 1
    },
    {
      "asset_id": 5713,
      "resettable": 1,
      "name": "Hunter: Bloodied",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2595,
      "activated": 1,
      "icon_name": "blood_debt",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 3,
      "short_description": "When this unit would deal damage with any Attack to a <condition value=bloodied>Bloodied</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=bloodied>Bloodied</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
      "long_description": "When this unit would deal damage with any Attack to a <condition value=bloodied>Bloodied</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=bloodied>Bloodied</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
      "class_name": "HunterBlood",
      "revision": 1
    },
    {
      "asset_id": 5386,
      "resettable": 1,
      "name": "Hunter: Brawler",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2217,
      "activated": 1,
      "icon_name": "foe_rogue",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 2,
      "short_description": "When this unit would deal damage to a champion with Class: Monk, Brute, or Rogue with any Attack, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Monk, Brute, or Rogue, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
      "long_description": "When this unit would deal damage to a champion with Class: Monk, Brute, or Rogue with any Attack, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Monk, Brute, or Rogue, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
      "class_name": "HunterBrawler",
      "revision": 1
    },
    {
      "asset_id": 7967,
      "resettable": 0,
      "name": "Hunter: Charmed",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3354,
      "activated": 1,
      "icon_name": "hunter_hero",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "When this unit would deal damage to a <condition value=charmed>Charmed</condition> champion with any Attack, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=charmed>Charmed</condition> champion, that damage is decreased by 2.",
      "long_description": "When this unit would deal damage to a <condition value=charmed>Charmed</condition> champion with any Attack, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=charmed>Charmed</condition> champion, that damage is decreased by 2.",
      "class_name": "HunterCharmed",
      "revision": 1
    },
    {
      "asset_id": 5381,
      "resettable": 0,
      "name": "Hunter: Cleric",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2933,
      "activated": 1,
      "icon_name": "foe_ranger",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 2,
      "short_description": "When this unit would deal damage to a champion with Class: Priest or Shaman with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Priest or Shaman, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
      "long_description": "When this unit would deal damage to a champion with Class: Priest or Shaman with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Priest or Shaman, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
      "class_name": "HunterCleric",
      "revision": 1
    },
    {
      "asset_id": 7186,
      "resettable": 0,
      "name": "Hunter: Crippled",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3029,
      "activated": 1,
      "icon_name": "hunter_crippled",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 2,
      "short_description": "When this unit would deal damage to a champion with less than 0 DEF with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a champion with less than 0 DEF, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
      "long_description": "When this unit would deal damage to a champion with less than 0 DEF with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a champion with less than 0 DEF, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
      "class_name": "HunterDefense",
      "revision": 1
    },
    {
      "asset_id": 4966,
      "resettable": 1,
      "name": "Hunter: Diseased",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1847,
      "activated": 1,
      "icon_name": "disease",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "When this unit would deal damage to a <condition value=diseased>Diseased</condition> champion with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=diseased>Diseased</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
      "long_description": "When this unit would deal damage to a <condition value=diseased>Diseased</condition> champion with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=diseased>Diseased</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
      "class_name": "HunterDiseased",
      "revision": 1
    },
    {
      "asset_id": 7132,
      "resettable": 0,
      "name": "Hunter: Equipped",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2974,
      "activated": 1,
      "icon_name": "hunter_equipped",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "When this unit would deal damage to an equipped champion with any attack, that damage is increased by 2. When this unit would receive damage from any attack by an equipped champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
      "long_description": "When this unit would deal damage to an equipped champion with any attack, that damage is increased by 2. When this unit would receive damage from any attack by an equipped champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
      "class_name": "HunterEquipped",
      "revision": 1
    },
    {
      "asset_id": 4922,
      "resettable": 1,
      "name": "Hunter: Fighter",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1804,
      "activated": 1,
      "icon_name": "foe_warrior",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "When this unit would deal damage to a champion with Class: Warrior, Knight or Paladin with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Warrior, Knight or Paladin, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
      "long_description": "When this unit would deal damage to a champion with Class: Warrior, Knight or Paladin with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Warrior, Knight or Paladin, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
      "class_name": "HunterFighter",
      "revision": 1
    },
    {
      "asset_id": 5020,
      "resettable": 1,
      "name": "Hunter: Flying",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1200,
      "activated": 1,
      "icon_name": "gale",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "When this unit would deal damage to a <condition value=flying popup=false>Flying</condition> champion with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=flying popup=false>Flying</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
      "long_description": "When this unit would deal damage to a <condition value=flying popup=false>Flying</condition> champion with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=flying popup=false>Flying</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
      "class_name": "HunterFlying",
      "revision": 1
    },
    {
      "asset_id": 4448,
      "resettable": 1,
      "name": "Hunter: Forglar Swamp",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 800,
      "activated": 1,
      "icon_name": "hunter_fs",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 3,
      "short_description": "When this unit would deal damage to a Forglar Swamp champion with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a Forglar Swamp  champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
      "long_description": "When this unit would deal damage to a Forglar Swamp champion with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a Forglar Swamp  champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
      "class_name": "HunterForglarSwamp",
      "revision": 1
    },
    {
      "asset_id": 4444,
      "resettable": 1,
      "name": "Hunter: Forsaken Wastes",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 796,
      "activated": 1,
      "icon_name": "hunter_fw",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 3,
      "short_description": "When this unit would deal damage to a Forsaken Wastes champion with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a Forsaken Wastes champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
      "long_description": "When this unit would deal damage to a Forsaken Wastes champion with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a Forsaken Wastes champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
      "class_name": "HunterForsakenWastes",
      "revision": 1
    },
    {
      "asset_id": 4697,
      "resettable": 1,
      "name": "Hunter: Hero",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1142,
      "activated": 1,
      "icon_name": "hunter_hero",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 2,
      "short_description": "When this unit would deal damage with any attack to a champion with <ability value=802>Hero</ability>, <ability value=2265>Split Hero</ability> or with a nora cost of 80 or greater that damage is increased by 2. When this unit would receive damage from any attack by a champion with <ability value=802>Hero</ability>, <ability value=2265>Split Hero</ability> or with a nora cost of 80 or greater, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
      "long_description": "When this unit would deal damage with any attack to a champion with <ability value=802>Hero</ability>, <ability value=2265>Split Hero</ability> or with a nora cost of 80 or greater that damage is increased by 2. When this unit would receive damage from any attack by a champion with <ability value=802>Hero</ability>, <ability value=2265>Split Hero</ability> or with a nora cost of 80 or greater, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
      "class_name": "HunterHero",
      "revision": 1
    },
    {
      "asset_id": 4447,
      "resettable": 1,
      "name": "Hunter: Ironfist Stronghold",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 799,
      "activated": 1,
      "icon_name": "hunter_is",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 3,
      "short_description": "When this unit would deal damage with any attack to an Ironfist Stronghold champion, that damage is increased by 2. When this unit would receive damage from any attack by an Ironfist Stronghold champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
      "long_description": "When this unit would deal damage with any attack to an Ironfist Stronghold champion, that damage is increased by 2. When this unit would receive damage from any attack by an Ironfist Stronghold champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
      "class_name": "HunterIronfistStronghold",
      "revision": 1
    },
    {
      "asset_id": 4040,
      "resettable": 1,
      "name": "Hunter: K'thir Forest",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 720,
      "activated": 1,
      "icon_name": "hunter_kf",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 3,
      "short_description": "When this unit would deal damage with any attack to a K'thir Forest champion, that damage is increased by 2. When this unit would receive damage from any attack by a K'thir Forest champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
      "long_description": "When this unit would deal damage with any attack to a K'thir Forest champion, that damage is increased by 2. When this unit would receive damage from any attack by a K'thir Forest champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
      "class_name": "HunterKthirForest",
      "revision": 1
    },
    {
      "asset_id": 5385,
      "resettable": 1,
      "name": "Hunter: Mage",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2216,
      "activated": 1,
      "icon_name": "wizard_foe",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 2,
      "short_description": "When this unit would deal damage with any attack to a champion with Class: Wizard or Witch, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Wizard or Witch, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
      "long_description": "When this unit would deal damage with any attack to a champion with Class: Wizard or Witch, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Wizard or Witch, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
      "class_name": "HunterMage",
      "revision": 1
    },
    {
      "asset_id": 7200,
      "resettable": 0,
      "name": "Hunter: Meek",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3041,
      "activated": 1,
      "icon_name": "hunter_meek",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "When this unit would deal damage to a champion with nora cost 72 or less, that damage is increased by 2. When this unit would receive damage from a champion with nora cost 72 or less, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
      "long_description": "When this unit would deal damage to a champion with nora cost 72 or less, that damage is increased by 2. When this unit would receive damage from a champion with nora cost 72 or less, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
      "class_name": "HunterMeek",
      "revision": 1
    },
    {
      "asset_id": 7848,
      "resettable": 0,
      "name": "Hunter: Poisoned",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3328,
      "activated": 1,
      "icon_name": "poison",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 3,
      "short_description": "When this unit would deal damage with any attack to a <condition value=poisoned>Poisoned</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=poisoned>Poisoned</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities. This does not stack with other Hunter: X abilities.",
      "long_description": "When this unit would deal damage with any attack to a <condition value=poisoned>Poisoned</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=poisoned>Poisoned</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities. This does not stack with other Hunter: X abilities.",
      "class_name": "HunterPoisoned",
      "revision": 1
    },
    {
      "asset_id": 7159,
      "resettable": 0,
      "name": "Hunter: Quick",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3002,
      "activated": 1,
      "icon_name": "hunter_quick",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this unit would deal damage with any attack to a champion with SPD 7 or more, that damage is increased by 2. When this unit would receive damage from any attack by a champion with SPD 7 or more, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
      "long_description": "When this unit would deal damage with any attack to a champion with SPD 7 or more, that damage is increased by 2. When this unit would receive damage from any attack by a champion with SPD 7 or more, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
      "class_name": "HunterQuick",
      "revision": 1
    },
    {
      "asset_id": 4041,
      "resettable": 1,
      "name": "Hunter: Savage Tundra",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 719,
      "activated": 1,
      "icon_name": "hunter_st",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 3,
      "short_description": "When this unit would deal damage with any attack to a Savage Tundra champion, that damage is increased by 2. When this unit would receive damage from any attack by a Savage Tundra champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
      "long_description": "When this unit would deal damage with any attack to a Savage Tundra champion, that damage is increased by 2. When this unit would receive damage from any attack by a Savage Tundra champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
      "class_name": "HunterSavageTundra",
      "revision": 1
    },
    {
      "asset_id": 5381,
      "resettable": 1,
      "name": "Hunter: Scout",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2214,
      "activated": 1,
      "icon_name": "foe_archer",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 2,
      "short_description": "When this unit would deal damage with any attack to a champion with Class: Ranger, Archer or Bard, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Ranger, Archer or Bard, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
      "long_description": "When this unit would deal damage with any attack to a champion with Class: Ranger, Archer or Bard, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Ranger, Archer or Bard, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
      "class_name": "HunterScout",
      "revision": 1
    },
    {
      "asset_id": 4283,
      "resettable": 1,
      "name": "Hunter: Shattered Peaks",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 666,
      "activated": 1,
      "icon_name": "hunter_sp",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 3,
      "short_description": "When this unit would deal damage with any attack to a Shattered Peaks champion, that damage is increased by 2. When this unit would receive damage from any attack by a Shattered Peaks champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
      "long_description": "When this unit would deal damage with any attack to a Shattered Peaks champion, that damage is increased by 2. When this unit would receive damage from any attack by a Shattered Peaks champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
      "class_name": "HunterShatteredPeaks",
      "revision": 1
    },
    {
      "asset_id": 5169,
      "resettable": 1,
      "name": "Hunter: Small",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1946,
      "activated": 1,
      "icon_name": "titan",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "When this unit would deal damage with any attack to a champion with Size: Small, that damage is increased by 2. When this champion would receive damage from any attack by a champion with Size: Small, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
      "long_description": "When this unit would deal damage with any attack to a champion with Size: Small, that damage is increased by 2. When this champion would receive damage from any attack by a champion with Size: Small, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
      "class_name": "HunterSmall",
      "revision": 1
    },
    {
      "asset_id": 5713,
      "resettable": 1,
      "name": "Hunter: Soultapped",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2784,
      "activated": 1,
      "icon_name": "dot_soultap",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "When this unit would deal damage with any attack to a <condition value=soultapped>Soultapped</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=soultapped>Soultapped</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
      "long_description": "When this unit would deal damage with any attack to a <condition value=soultapped>Soultapped</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=soultapped>Soultapped</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
      "class_name": "HunterSoultapped",
      "revision": 1
    },
    {
      "asset_id": 4449,
      "resettable": 1,
      "name": "Hunter: Sundered Lands",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 801,
      "activated": 1,
      "icon_name": "hunter_sl",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 3,
      "short_description": "When this unit would deal damage with any attack to a Sundered Lands champion, that damage is increased by 2. When this unit would receive damage from any attack by a Sundered Lands champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
      "long_description": "When this unit would deal damage with any attack to a Sundered Lands champion, that damage is increased by 2. When this unit would receive damage from any attack by a Sundered Lands champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
      "class_name": "HunterSunderedLands",
      "revision": 1
    },
    {
      "asset_id": 4445,
      "resettable": 1,
      "name": "Hunter: Underdepths",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 797,
      "activated": 1,
      "icon_name": "hunter_ud",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 3,
      "short_description": "When this unit would deal damage with any attack to an Underdepths champion, that damage is increased by 2. When this unit would receive damage from any attack by an Underdepths champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
      "long_description": "When this unit would deal damage with any attack to an Underdepths champion, that damage is increased by 2. When this unit would receive damage from any attack by an Underdepths champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
      "class_name": "HunterUnderdepths",
      "revision": 1
    },
    {
      "asset_id": 4362,
      "resettable": 1,
      "name": "Hunter: Walker",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1395,
      "activated": 1,
      "icon_name": "predator_angel",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "When this unit would deal damage with any attack to a champion without <condition value=flying popup=false>Flying</condition>, that damage is increased by 2. When this unit would receive damage from any attack by a champion without <condition value=flying popup=false>Flying</condition>, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
      "long_description": "When this unit would deal damage with any attack to a champion without <condition value=flying popup=false>Flying</condition>, that damage is increased by 2. When this unit would receive damage from any attack by a champion without <condition value=flying popup=false>Flying</condition>, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
      "class_name": "HunterGrounded",
      "revision": 1
    },
    {
      "asset_id": 5058,
      "resettable": 1,
      "name": "Hunter: Wrath",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1235,
      "activated": 1,
      "icon_name": "hunter_wrath",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "When this unit would deal attack damage to a Wrath champion, that damage is increased by 2. When this unit would receive damage from any attack by a Wrath champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
      "long_description": "When this unit would deal attack damage to a Wrath champion, that damage is increased by 2. When this unit would receive damage from any attack by a Wrath champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
      "class_name": "HunterWrath",
      "revision": 1
    },
    {
      "asset_id": 5008,
      "resettable": 1,
      "name": "Huntmaster Bound",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1889,
      "activated": 1,
      "icon_name": "disable",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -6,
      "short_description": "At the beginning of your enemy's turns, if there are no other Boghopper Huntmasters in play, this unit is <condition value=possessed>Possessed</condition> by your enemy until end of turn.",
      "long_description": "At the beginning of your enemy's turns, if there are no other Boghopper Huntmasters in play, this unit is <condition value=possessed>Possessed</condition> by your enemy until end of turn.",
      "class_name": "HuntmasterBound",
      "revision": 1
    },
    {
      "asset_id": 4638,
      "resettable": 1,
      "name": "Hydrate",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 1462,
      "activated": 1,
      "icon_name": "terrainwater",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "Friendly champions within 2 spaces gain 2 AP and the spaces they are standing in turn to Water for 3 turns.",
      "long_description": "Friendly champions within 2 spaces gain 2 AP and the spaces they are standing in turn to Water for 3 turns.",
      "class_name": "Hydrate",
      "revision": 1
    },
    {
      "asset_id": 4692,
      "resettable": 1,
      "name": "Ice Aura",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1132,
      "activated": 1,
      "icon_name": "terrainice",
      "comments": "The implementing class for this ability is RelicGlacierEngine, despite its name being different. -Alan.",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "When this unit comes into play, spaces within 3 spaces of this unit become <mechanic value=ice_terrain>Ice Terrain</mechanic>.",
      "long_description": "When this unit comes into play, spaces within 3 spaces of this unit become <mechanic value=ice_terrain>Ice Terrain</mechanic>.",
      "class_name": "RelicGlacierEngine",
      "revision": 1
    },
    {
      "asset_id": 4617,
      "resettable": 1,
      "name": "Ice Block",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1032,
      "activated": 1,
      "icon_name": "terrainice",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "When this relic has been in play for 8 turns, it is removed, and the space it occupied becomes Shallow Water (non-Impeding) for 3 turns.",
      "long_description": "When this relic has been in play for 8 turns, it is removed, and the space it occupied becomes Shallow Water (non-Impeding) for 3 turns.",
      "class_name": "RelicIceBlock",
      "revision": 1
    },
    {
      "asset_id": 4457,
      "resettable": 1,
      "name": "Ice Carved Greaves",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 810,
      "activated": 1,
      "icon_name": "attack_frost",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "This champion makes a close-combat Frost attack at +4 DMG and +1 AP. When a champion takes 1 or more damage from this attack, it becomes <condition value=chilled>Chilled</condition> for 3 turns.",
      "long_description": "This champion makes a close-combat Frost attack at +4 DMG and +1 AP. When a champion takes 1 or more damage from this attack, it becomes <condition value=chilled>Chilled</condition> for 3 turns.",
      "class_name": "IceCarvedGreavesAttack",
      "revision": 1
    },
    {
      "asset_id": 4490,
      "resettable": 1,
      "name": "Ice Eater",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 898,
      "activated": 1,
      "icon_name": "eater_frost",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 7,
      "short_description": "This champion has <ability value=600>Arctic</ability>. At the beginning of your turn, if this unit occupies Snow or Ice, it heals 2 HP. When this unit would take Frost damage, it instead heals HP equal to half the damage that would have been dealt.",
      "long_description": "This champion has <ability value=600>Arctic</ability>. At the beginning of your turn, if this unit occupies Snow or Ice, it heals 2 HP. When this unit would take Frost damage, it instead heals HP equal to half the damage that would have been dealt.",
      "class_name": "IceEater",
      "revision": 1
    },
    {
      "asset_id": 5111,
      "resettable": 1,
      "name": "Ice Front",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1297,
      "activated": 1,
      "icon_name": "terrainice",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "At the beginning of each turn, all spaces within 3 spaces of this champion become Ice for 4 turns.",
      "long_description": "At the beginning of each turn, all spaces within 3 spaces of this champion become Ice for 4 turns.",
      "class_name": "IceFront",
      "revision": 1
    },
    {
      "asset_id": 4711,
      "resettable": 1,
      "name": "Ice Generator",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1164,
      "activated": 1,
      "icon_name": "terrainice",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "At the end of your turn, spaces adjacent to terrain generated by this ability become Ice.  When this relic leaves play, at end of turn, and the end of each turn thereafter, this terrain manipulation effect ends on the most recently affected spaces.",
      "long_description": "At the end of your turn, spaces adjacent to terrain generated by this ability become Ice.  When this relic leaves play, at end of turn, and the end of each turn thereafter, this terrain manipulation effect ends on the most recently affected spaces.",
      "class_name": "IceGenerator",
      "revision": 1
    },
    {
      "asset_id": 4242,
      "resettable": 1,
      "name": "Ice Shard",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 628,
      "activated": 1,
      "icon_name": "arctic",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "When a champion or relic takes Frost damage, that damage is increased by 20%. This effect does not stack.",
      "long_description": "When a champion or relic takes Frost damage, that damage is increased by 20%. This effect does not stack.",
      "class_name": "RelicIceShard",
      "revision": 1
    },
    {
      "asset_id": 666,
      "resettable": 1,
      "name": "Ice Statue",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 693,
      "activated": 1,
      "icon_name": "novafrost",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 1,
      "short_description": "When an opposing champion moves within 3 spaces of the Ice Statue, it loses 1 AP and becomes <condition value=chilled>Chilled</condition> for 2 turns and <condition value=frozen>Frozen</condition> for 3 turns.",
      "long_description": "When an opposing champion moves within 3 spaces of the Ice Statue, it loses 1 AP and becomes <condition value=chilled>Chilled</condition> for 2 turns and <condition value=frozen>Frozen</condition> for 3 turns.",
      "class_name": "RelicIceStatue",
      "revision": 1
    },
    {
      "asset_id": 5060,
      "resettable": 1,
      "name": "Ice Veil",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1236,
      "activated": 1,
      "icon_name": "terrainice",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "When this champion comes into play all terrain within 10 spaces turns into ice terrain for 3 turns.",
      "long_description": "When this champion comes into play all terrain within 10 spaces turns into ice terrain for 3 turns.",
      "class_name": "IceVeil",
      "revision": 1
    },
    {
      "asset_id": 4261,
      "resettable": 1,
      "name": "Icebreaker",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 649,
      "activated": 1,
      "icon_name": "dispel",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 2,
      "short_description": "Snow and Ice spaces adjacent to this champion are Water (Impeding 1) for the next 4 turns. Champions occupying spaces modified this way become <condition value=grounded>Grounded</condition> for 2 turns.",
      "long_description": "Snow and Ice spaces adjacent to this champion are Water (Impeding 1) for the next 4 turns. Champions occupying spaces modified this way become <condition value=grounded>Grounded</condition> for 2 turns.",
      "class_name": "Icebreaker",
      "revision": 1
    },
    {
      "asset_id": 4639,
      "resettable": 1,
      "name": "Iceguard",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1463,
      "activated": 1,
      "icon_name": "iceguard",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "The next time this unit is damaged, this unit becomes <condition value=crystallized>Crystallized</condition> for 1 turn.",
      "long_description": "The next time this unit is damaged, this unit becomes <condition value=crystallized>Crystallized</condition> for 1 turn.",
      "class_name": "Iceguard",
      "revision": 1
    },
    {
      "asset_id": 4940,
      "resettable": 1,
      "name": "Iceguard Bracers",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1825,
      "activated": 1,
      "icon_name": "novafrost",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "When an enemy champion moves within 3 spaces of this relic, it suffers 5 Frost damage.",
      "long_description": "When an enemy champion moves within 3 spaces of this relic, it suffers 5 Frost damage.",
      "class_name": "RelicReactiveBracers",
      "revision": 1
    },
    {
      "asset_id": 4250,
      "resettable": 1,
      "name": "Icewalker",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 640,
      "activated": 1,
      "icon_name": "terrainice",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 2,
      "short_description": "This champion moves unimpeded over Snow and does not suffer the -1 SPD penalty while occupying Ice.",
      "long_description": "This champion moves unimpeded over Snow and does not suffer the -1 SPD penalty while occupying Ice.",
      "class_name": "Icewalker",
      "revision": 1
    },
    {
      "asset_id": 5574,
      "resettable": 1,
      "name": "Ichor: Berserker",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2721,
      "activated": 1,
      "icon_name": "ichor_utility",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "This champion gains a rank of Berserker for each champion within 6 spaces with an Ichor ability.",
      "long_description": "This champion gains a rank of Berserker for each champion within 6 spaces with an Ichor ability.",
      "class_name": "IchorBerserker",
      "revision": 1
    },
    {
      "asset_id": 5574,
      "resettable": 1,
      "name": "Ichor: Burn",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2722,
      "activated": 1,
      "icon_name": "ichor_offense",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 2,
      "short_description": "This champion gains a rank of Burn for each champion within 6 spaces with an Ichor ability.",
      "long_description": "This champion gains a rank of Burn for each champion within 6 spaces with an Ichor ability.",
      "class_name": "IchorBurn",
      "revision": 1
    },
    {
      "asset_id": 5574,
      "resettable": 1,
      "name": "Ichor: Chill",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2724,
      "activated": 1,
      "icon_name": "ichor_offense",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 2,
      "short_description": "This champion gains a rank of Chill for each champion within 6 spaces with an Ichor ability.",
      "long_description": "This champion gains a rank of Chill for each champion within 6 spaces with an Ichor ability.",
      "class_name": "IchorChill",
      "revision": 1
    },
    {
      "asset_id": 5574,
      "resettable": 1,
      "name": "Ichor: Evasive",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2726,
      "activated": 1,
      "icon_name": "ichor_defense",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 2,
      "short_description": "This champion gains a rank of Evasive for each champion within 6 spaces with an Ichor ability.",
      "long_description": "This champion gains a rank of Evasive for each champion within 6 spaces with an Ichor ability.",
      "class_name": "IchorEvasive",
      "revision": 1
    },
    {
      "asset_id": 5574,
      "resettable": 1,
      "name": "Ichor: Fire Aura",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2798,
      "activated": 1,
      "icon_name": "ichor_utility",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 2,
      "short_description": "This champion gains a rank of Fire Aura for each champion within 6 spaces with an Ichor ability.",
      "long_description": "This champion gains a rank of Fire Aura for each champion within 6 spaces with an Ichor ability.",
      "class_name": "IchorFireAura",
      "revision": 1
    },
    {
      "asset_id": 5774,
      "resettable": 1,
      "name": "Ichor: Multiattack",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2728,
      "activated": 1,
      "icon_name": "ichor_offense",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "This champion gains a rank of Multiattack for each champion within 6 spaces with an Ichor ability.",
      "long_description": "This champion gains a rank of Multiattack for each champion within 6 spaces with an Ichor ability.",
      "class_name": "IchorMultiattack",
      "revision": 1
    },
    {
      "asset_id": 5574,
      "resettable": 1,
      "name": "Ichor: Nora Miner",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2729,
      "activated": 1,
      "icon_name": "ichor_utility",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "This champion gains a rank of Nora Miner for each champion within 6 spaces with an Ichor ability.",
      "long_description": "This champion gains a rank of Nora Miner for each champion within 6 spaces with an Ichor ability.",
      "class_name": "IchorNoraMiner",
      "revision": 1
    },
    {
      "asset_id": 5574,
      "resettable": 1,
      "name": "Ichor: Poison",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2730,
      "activated": 1,
      "icon_name": "ichor_offense",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 2,
      "short_description": "This champion gains a rank of Poison for each champion within 6 spaces with an Ichor ability.",
      "long_description": "This champion gains a rank of Poison for each champion within 6 spaces with an Ichor ability.",
      "class_name": "IchorPoison",
      "revision": 1
    },
    {
      "asset_id": 5574,
      "resettable": 1,
      "name": "Ichor: Poison Aura",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2727,
      "activated": 1,
      "icon_name": "ichor_offense",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 2,
      "short_description": "This champion gains a rank of Poison Aura for each champion within 6 spaces with an Ichor ability.",
      "long_description": "This champion gains a rank of Poison Aura for each champion within 6 spaces with an Ichor ability.",
      "class_name": "IchorPoisonAura",
      "revision": 1
    },
    {
      "asset_id": 5574,
      "resettable": 1,
      "name": "Ichor: Reflexes",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2725,
      "activated": 1,
      "icon_name": "ichor_defense",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 2,
      "short_description": "This champion gains a rank of Reflexes for each champion within 6 spaces with an Ichor ability.",
      "long_description": "This champion gains a rank of Reflexes for each champion within 6 spaces with an Ichor ability.",
      "class_name": "IchorReflexes",
      "revision": 1
    },
    {
      "asset_id": 5574,
      "resettable": 1,
      "name": "Ichor: Regeneration",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2732,
      "activated": 1,
      "icon_name": "ichor_utility",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 2,
      "short_description": "This champion gains a rank of Regeneration for each champion within 6 spaces with an Ichor ability.",
      "long_description": "This champion gains a rank of Regeneration for each champion within 6 spaces with an Ichor ability.",
      "class_name": "IchorRegeneration",
      "revision": 1
    },
    {
      "asset_id": 5574,
      "resettable": 1,
      "name": "Ichor: Rend",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2731,
      "activated": 1,
      "icon_name": "ichor_offense",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 2,
      "short_description": "This champion gains a rank of Rend for each champion within 6 spaces with an Ichor ability.",
      "long_description": "This champion gains a rank of Rend for each champion within 6 spaces with an Ichor ability.",
      "class_name": "IchorRend",
      "revision": 1
    },
    {
      "asset_id": 5574,
      "resettable": 1,
      "name": "Ichor: Resistance Physical",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2720,
      "activated": 1,
      "icon_name": "ichor_defense",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 2,
      "short_description": "This champion gains a rank of Resistance - Physical for each champion within 6 spaces with an Ichor ability.",
      "long_description": "This champion gains a rank of Resistance - Physical for each champion within 6 spaces with an Ichor ability.",
      "class_name": "IchorResistancePhysical",
      "revision": 1
    },
    {
      "asset_id": 5574,
      "resettable": 1,
      "name": "Ichor: Stat Bonus Damage",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2803,
      "activated": 1,
      "icon_name": "ichor_offense",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 2,
      "short_description": "This champion gains a rank of Stat Bonus - Damage for each champion within 6 spaces with an Ichor ability.",
      "long_description": "This champion gains a rank of Stat Bonus - Damage for each champion within 6 spaces with an Ichor ability.",
      "class_name": "IchorStatBonusDamage",
      "revision": 1
    },
    {
      "asset_id": 5574,
      "resettable": 1,
      "name": "Ichor: Tough",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2723,
      "activated": 1,
      "icon_name": "ichor_defense",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 2,
      "short_description": "This champion gains a rank of Tough for each champion within 6 spaces with an Ichor ability.",
      "long_description": "This champion gains a rank of Tough for each champion within 6 spaces with an Ichor ability.",
      "class_name": "IchorTough",
      "revision": 1
    },
    {
      "asset_id": 4358,
      "resettable": 1,
      "name": "Ignorance",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1391,
      "activated": 1,
      "icon_name": "ignorance",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 7,
      "short_description": "Enemy Wizards, Shamans and Priests within 5 spaces of this unit may not activate abilities.",
      "long_description": "Enemy Wizards, Shamans and Priests within 5 spaces of this unit may not activate abilities.",
      "class_name": "Ignorance",
      "revision": 1
    },
    {
      "asset_id": 5469,
      "resettable": 1,
      "name": "Il'Tara's Burden",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2327,
      "activated": 1,
      "icon_name": "eradicate",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Spend 12 Charges.  This champion makes a magic attack at double damage against every enemy within its range.",
      "long_description": "Spend 12 Charges.  This champion makes a magic attack at double damage against every enemy within its range.",
      "class_name": "IltarasBurden",
      "revision": 1
    },
    {
      "asset_id": 5717,
      "resettable": 1,
      "name": "Illuminate",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2671,
      "activated": 1,
      "icon_name": "illuminate",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this champion successfully damages a unit with a basic attack, that unit is <condition value=illuminated>Illuminated</condition> for 4 turns.",
      "long_description": "When this champion successfully damages a unit with a basic attack, that unit is <condition value=illuminated>Illuminated</condition> for 4 turns.",
      "class_name": "Illuminate",
      "revision": 1
    },
    {
      "asset_id": 7220,
      "resettable": 0,
      "name": "Illuminating Burst",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3045,
      "activated": 1,
      "icon_name": "illuminate",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "When this unit comes into play and when it is destroyed, enemy champions within 5 spaces become <condition value=illuminated>Illuminated</condition> for 4 turns.",
      "long_description": "When this unit comes into play and when it is destroyed, enemy champions within 5 spaces become <condition value=illuminated>Illuminated</condition> for 4 turns.",
      "class_name": "IlluminatingBurst",
      "revision": 1
    },
    {
      "asset_id": 5150,
      "resettable": 1,
      "name": "Illusion of Lies",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1895,
      "activated": 1,
      "icon_name": "planar",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 10,
      "short_description": "When a friendly champion is deployed from the runedock, an illusion copy of that champion is spawned in the nearest deployment zone.",
      "long_description": "When a friendly champion is deployed from the runedock, an illusion copy of that champion is spawned in the nearest deployment zone.",
      "class_name": "WebOfLies",
      "revision": 1
    },
    {
      "asset_id": 4252,
      "resettable": 1,
      "name": "Illusion: Archer",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 642,
      "activated": 1,
      "icon_name": "illusion_archer",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 2,
      "short_description": "Create a Elven Archer Illusion in the nearest deployment zone. The illusion will appear upgraded at random.",
      "long_description": "Create a Elven Archer Illusion in the nearest deployment zone. The illusion will appear upgraded at random.",
      "class_name": "CreateIllusionElvenArcher",
      "revision": 1
    },
    {
      "asset_id": 4254,
      "resettable": 1,
      "name": "Illusion: Elf",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 641,
      "activated": 1,
      "icon_name": "illusion_elf",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 2,
      "short_description": "Create a Elven BladeMaster <condition value=illusion>Illusion</condition> in the nearest deployment zone. The illusion will appear upgraded at random.",
      "long_description": "Create a Elven BladeMaster <condition value=illusion>Illusion</condition> in the nearest deployment zone. The illusion will appear upgraded at random.",
      "class_name": "CreateIllusionBladeMaster",
      "revision": 1
    },
    {
      "asset_id": 4254,
      "resettable": 1,
      "name": "Illusion: Garu",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 644,
      "activated": 1,
      "icon_name": "illusion_garu",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 2,
      "short_description": "Create a Elder Garu Illusion in the nearest deployment zone. The illusion will appear upgraded at random.",
      "long_description": "Create a Elder Garu Illusion in the nearest deployment zone. The illusion will appear upgraded at random.",
      "class_name": "CreateIllusionElderGaru",
      "revision": 1
    },
    {
      "asset_id": 4253,
      "resettable": 1,
      "name": "Illusion: Mage",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 643,
      "activated": 1,
      "icon_name": "illusion_mage",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 2,
      "short_description": "Create a Elven Mage Illusion in the nearest deployment zone. The illusion will appear upgraded at random.",
      "long_description": "Create a Elven Mage Illusion in the nearest deployment zone. The illusion will appear upgraded at random.",
      "class_name": "CreateIllusionElvenMage",
      "revision": 1
    },
    {
      "asset_id": 5481,
      "resettable": 1,
      "name": "Imbue: Stun",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 2339,
      "activated": 1,
      "icon_name": "amped",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 9,
      "short_description": "Target champion within 5 spaces becomes Imbued(For 5 turns, their next basic attack has a damage type of Magical and deals +2 damage. Champions damaged by this attack become <condition value=stunned>Stunned</condition> for 2 turns).  May target self.",
      "long_description": "Target champion within 5 spaces becomes Imbued(For 5 turns, their next basic attack has a damage type of Magical and deals +2 damage. Champions damaged by this attack become <condition value=stunned>Stunned</condition> for 2 turns).  May target self.",
      "class_name": "Imbue",
      "revision": 1
    },
    {
      "asset_id": 7957,
      "resettable": 0,
      "name": "Imbue: Stun (relic)",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3338,
      "activated": 1,
      "icon_name": "amped",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 9,
      "short_description": "Target champion within 5 spaces becomes Imbued(For 5 turns, their next basic attack has a damage type of Magical and deals +2 damage. Champions damaged by this attack become <condition value=stunned>Stunned</condition> for 2 turns).  May target self.",
      "long_description": "Target champion within 5 spaces becomes Imbued(For 5 turns, their next basic attack has a damage type of Magical and deals +2 damage. Champions damaged by this attack become <condition value=stunned>Stunned</condition> for 2 turns).  May target self.",
      "class_name": "Imbue",
      "revision": 1
    },
    {
      "asset_id": 4421,
      "resettable": 1,
      "name": "Immobile",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 757,
      "activated": 1,
      "icon_name": "debuff",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -30,
      "short_description": "This unit cannot move or be relocated.",
      "long_description": "This unit cannot move or be relocated.",
      "class_name": "Immobile",
      "revision": 1
    },
    {
      "asset_id": 4067,
      "resettable": 1,
      "name": "Immortality",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 107,
      "activated": 1,
      "icon_name": "ondeath",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 3,
      "short_description": "When this unit is destroyed, its cooldown is set to 0. When this unit is deployed, your Shrine or Avatar loses 5 HP.",
      "long_description": "When this unit is destroyed, its cooldown is set to 0. When this unit is deployed, your Shrine or Avatar loses 5 HP.",
      "class_name": "Immortality",
      "revision": 1
    },
    {
      "asset_id": 4020,
      "resettable": 1,
      "name": "Immunity: Acid",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 42,
      "activated": 1,
      "icon_name": "immunity_acid",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 3,
      "short_description": "Acid damage that would be dealt to this unit is prevented. This unit may not become <condition value=scoured>Scoured</condition>.",
      "long_description": "Acid damage that would be dealt to this unit is prevented. This unit may not become <condition value=scoured>Scoured</condition>.",
      "class_name": "ImmunityAcid",
      "revision": 1
    },
    {
      "asset_id": 4021,
      "resettable": 1,
      "name": "Immunity: Disease",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 43,
      "activated": 1,
      "icon_name": "immunity_disease",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 3,
      "short_description": "Disease damage that would be dealt to this unit is prevented. This unit may not become <condition value=diseased>Diseased</condition>.\r\n",
      "long_description": "Disease damage that would be dealt to this unit is prevented. This unit may not become <condition value=diseased>Diseased</condition>.\r\n",
      "class_name": "ImmunityDisease",
      "revision": 1
    },
    {
      "asset_id": 4017,
      "resettable": 1,
      "name": "Immunity: Electricity",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 39,
      "activated": 1,
      "icon_name": "immunity_electric",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 3,
      "short_description": "Electricity damage that would be dealt to this unit is prevented. This unit may not become <condition value=shocked popup=false>Shocked</condition>.",
      "long_description": "Electricity damage that would be dealt to this unit is prevented. This unit may not become <condition value=shocked popup=false>Shocked</condition>.",
      "class_name": "ImmunityElectricity",
      "revision": 1
    },
    {
      "asset_id": 4015,
      "resettable": 1,
      "name": "Immunity: Fire",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 37,
      "activated": 1,
      "icon_name": "immunity_fire",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 4,
      "short_description": "Fire damage that would be dealt to this unit is prevented. This unit may not become <condition value=charred popup=false>Charred</condition>.",
      "long_description": "Fire damage that would be dealt to this unit is prevented. This unit may not become <condition value=charred popup=false>Charred</condition>.",
      "class_name": "ImmunityFire",
      "revision": 1
    },
    {
      "asset_id": 4016,
      "resettable": 1,
      "name": "Immunity: Frost",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 38,
      "activated": 1,
      "icon_name": "immunity_frost",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 4,
      "short_description": "Frost damage that would be dealt to this unit is prevented. This unit may not become Chilled.",
      "long_description": "Frost damage that would be dealt to this unit is prevented. This unit may not become Chilled.",
      "class_name": "ImmunityFrost",
      "revision": 1
    },
    {
      "asset_id": 4014,
      "resettable": 1,
      "name": "Immunity: Magical",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 36,
      "activated": 1,
      "icon_name": "immunity_magic",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 7,
      "short_description": "Magical damage that would be dealt to this unit is prevented.",
      "long_description": "Magical damage that would be dealt to this unit is prevented.",
      "class_name": "ImmunityMagical",
      "revision": 1
    },
    {
      "asset_id": 4013,
      "resettable": 1,
      "name": "Immunity: Physical",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 35,
      "activated": 1,
      "icon_name": "immunity_physical",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 10,
      "short_description": "Physical damage that would be dealt to this unit is prevented. This unit may not be <condition value=eviscerated popup=false>Eviscerated</condition>.",
      "long_description": "Physical damage that would be dealt to this unit is prevented. This unit may not be <condition value=eviscerated popup=false>Eviscerated</condition>.",
      "class_name": "ImmunityPhysical",
      "revision": 1
    },
    {
      "asset_id": 4018,
      "resettable": 1,
      "name": "Immunity: Poison",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 40,
      "activated": 1,
      "icon_name": "immunity_poison",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 3,
      "short_description": "Poison damage that would be dealt to this unit is prevented. This unit may not become <condition value=poisoned popup=false>Poisoned</condition>.",
      "long_description": "Poison damage that would be dealt to this unit is prevented. This unit may not become <condition value=poisoned popup=false>Poisoned</condition>.",
      "class_name": "ImmunityPoison",
      "revision": 1
    },
    {
      "asset_id": 4022,
      "resettable": 1,
      "name": "Immunity: Psychic",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 44,
      "activated": 1,
      "icon_name": "immunity_psychic",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 3,
      "short_description": "Psychic damage that would be dealt to this unit is prevented.",
      "long_description": "Psychic damage that would be dealt to this unit is prevented.",
      "class_name": "ImmunityPsychic",
      "revision": 1
    },
    {
      "asset_id": 5555,
      "resettable": 1,
      "name": "Immunity: Ranged DO NOT USE",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2415,
      "activated": 1,
      "icon_name": "imunityranged",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "All ranged attacks against this champion miss.",
      "long_description": "All ranged attacks against this champion miss.",
      "class_name": "ImmunityRanged",
      "revision": 1
    },
    {
      "asset_id": 4019,
      "resettable": 1,
      "name": "Immunity: Sonic",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 41,
      "activated": 1,
      "icon_name": "immunity_sonic",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 3,
      "short_description": "Sonic damage that would be dealt to this unit is prevented.",
      "long_description": "Sonic damage that would be dealt to this unit is prevented.",
      "class_name": "ImmunitySonic",
      "revision": 1
    },
    {
      "asset_id": 4640,
      "resettable": 1,
      "name": "Immunity: Voil ",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1061,
      "activated": 1,
      "icon_name": "immunity_sonic",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "Damage dealt to this champion by Voil is prevented.",
      "long_description": "Damage dealt to this champion by Voil is prevented.",
      "class_name": "ImmunityVoil",
      "revision": 1
    },
    {
      "asset_id": 4642,
      "resettable": 1,
      "name": "Immunize",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 1464,
      "activated": 1,
      "icon_name": "blessed",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "Target unit within 5 spaces gains <ability value=43>Immunity: Disease</ability> for 5 turns.",
      "long_description": "Target unit within 5 spaces gains <ability value=43>Immunity: Disease</ability> for 5 turns.",
      "class_name": "Immunize",
      "revision": 1
    },
    {
      "asset_id": 4696,
      "resettable": 1,
      "name": "Impact Strike",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 1137,
      "activated": 1,
      "icon_name": "knockback",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "Target of this attack takes damage and is knocked back 1 space. Enemy units without flying within 3 spaces of this unit are knocked back 1 space, and take half of the damage.",
      "long_description": "Target of this attack takes damage and is knocked back 1 space. Enemy units without flying within 3 spaces of this unit are knocked back 1 space, and take half of the damage.",
      "class_name": "ImpactStrike",
      "revision": 1
    },
    {
      "asset_id": 5460,
      "resettable": 1,
      "name": "Impair Vision",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2312,
      "activated": 1,
      "icon_name": "observe",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this champion successfully damages a champion with a basic attack, if that champion's MAX RNG is greater than its MIN RNG, it is Impaired (This champion's maximum range is lowered by 1. This effect stacks) for 4 turns.",
      "long_description": "When this champion successfully damages a champion with a basic attack, if that champion's MAX RNG is greater than its MIN RNG, it is Impaired (This champion's maximum range is lowered by 1. This effect stacks) for 4 turns.",
      "class_name": "ImpairVision",
      "revision": 1
    },
    {
      "asset_id": 5702,
      "resettable": 1,
      "name": "Impairing Feedback",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2582,
      "activated": 1,
      "icon_name": "illuminate",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "When this champion is successfully attacked by a basic attack, if the attacking champion's MAX RNG is greater than its MIN RNG, it is Impaired (This champion's maximum range is lowered by 1. This effect stacks) for 4 turns.",
      "long_description": "When this champion is successfully attacked by a basic attack, if the attacking champion's MAX RNG is greater than its MIN RNG, it is Impaired (This champion's maximum range is lowered by 1. This effect stacks) for 4 turns.",
      "class_name": "GlaringFeedback",
      "revision": 1
    },
    {
      "asset_id": 5727,
      "resettable": 1,
      "name": "Impairing Luminescence",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2614,
      "activated": 1,
      "icon_name": "dispelling_luminesence",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "This unit has <ability value=2582>Impairing Feedback</ability> (When this champion is successfully attacked by a basic attack, if the attacking champion's MAX RNG is greater than its MIN RNG, it is Impaired for 6 turns).",
      "long_description": "This unit has <ability value=2582>Impairing Feedback</ability> (When this champion is successfully attacked by a basic attack, if the attacking champion's MAX RNG is greater than its MIN RNG, it is Impaired for 6 turns).",
      "class_name": "ImpairingLuminescence",
      "revision": 1
    },
    {
      "asset_id": 5700,
      "resettable": 1,
      "name": "Impaling Strike",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 2580,
      "activated": 1,
      "icon_name": "stab",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 9,
      "short_description": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this champion take 12 Physical damage and become <condition value=bloodied>Bloodied</condition> for 4 turns. This damage ignores DEF.",
      "long_description": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this champion take 12 Physical damage and become <condition value=bloodied>Bloodied</condition> for 4 turns. This damage ignores DEF.",
      "class_name": "ImpalingStrike",
      "revision": 1
    },
    {
      "asset_id": 4314,
      "resettable": 1,
      "name": "Impart",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 1342,
      "activated": 1,
      "icon_name": "heal",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "Target champion within 3 spaces is healed for 5 HP and gains 1 DMG. This unit loses 8 life and gains -1 DMG.",
      "long_description": "Target champion within 3 spaces is healed for 5 HP and gains 1 DMG. This unit loses 8 life and gains -1 DMG.",
      "class_name": "Impart",
      "revision": 1
    },
    {
      "asset_id": 4877,
      "resettable": 1,
      "name": "Impassioned",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1759,
      "activated": 1,
      "icon_name": "tgtdefensive",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "This unit gets +3 DMG and +1 DEF when your shrine or avatar has less than half its HP.",
      "long_description": "This unit gets +3 DMG and +1 DEF when your shrine or avatar has less than half its HP.",
      "class_name": "Impassioned",
      "revision": 1
    },
    {
      "asset_id": 4878,
      "resettable": 1,
      "name": "Impatient",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1760,
      "activated": 1,
      "icon_name": "impatient",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -8,
      "short_description": "This unit loses 5 HP at the end of your turn if it did not successfully attack.  Every time a friendly champion within 3 spaces successfully attacks, this unit gains 1 AP.",
      "long_description": "This unit loses 5 HP at the end of your turn if it did not successfully attack.  Every time a friendly champion within 3 spaces successfully attacks, this unit gains 1 AP.",
      "class_name": "Impatient",
      "revision": 1
    },
    {
      "asset_id": 5061,
      "resettable": 1,
      "name": "Impenetrable",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1237,
      "activated": 1,
      "icon_name": "ironwill",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "This champion can not be the target of abilities your enemy controls, including non-basic attacks.  This does not include basic attacks.",
      "long_description": "This champion can not be the target of abilities your enemy controls, including non-basic attacks.  This does not include basic attacks.",
      "class_name": "Impenetrable",
      "revision": 1
    },
    {
      "asset_id": 5545,
      "resettable": 1,
      "name": "Imperfect Creation",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2405,
      "activated": 1,
      "icon_name": "nemesis_x",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 0,
      "short_description": "When this champion is destroyed its creator loses 25 health.",
      "long_description": "When this champion is destroyed its creator loses 25 health.",
      "class_name": "ImperfectCreation",
      "revision": 1
    },
    {
      "asset_id": 7197,
      "resettable": 0,
      "name": "Imposing Aura",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3031,
      "activated": 1,
      "icon_name": "imposing_aura",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "Enemy champions within 3 spaces have -2 DMG and <ability value=2005>Careless</ability>.",
      "long_description": "Enemy champions within 3 spaces have -2 DMG and <ability value=2005>Careless</ability>.",
      "class_name": "ImposingAura",
      "revision": 1
    },
    {
      "asset_id": 4693,
      "resettable": 1,
      "name": "Impregnable",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1056,
      "activated": 1,
      "icon_name": "ironwill",
      "comments": "Really for shrines on boss fights",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 30,
      "short_description": "This unit cannot take damage, lose life, or be directly harmed.",
      "long_description": "This unit cannot take damage, lose life, or be directly harmed.",
      "class_name": "Impregnable",
      "revision": 1
    },
    {
      "asset_id": 5615,
      "resettable": 1,
      "name": "Improve Range",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2478,
      "activated": 1,
      "icon_name": "improve_range",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "Units within 5 spaces of this champion that share a race or class with this champion have +1 MAX RNG. This ability does not stack.",
      "long_description": "Units within 5 spaces of this champion that share a race or class with this champion have +1 MAX RNG. This ability does not stack.",
      "class_name": "ImproveRange",
      "revision": 1
    },
    {
      "asset_id": 5616,
      "resettable": 1,
      "name": "Improve Speed",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2479,
      "activated": 1,
      "icon_name": "improve_speed",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 10,
      "short_description": "Units within 5 spaces of this champion that share a race or class with this champion have +1 SPD. This ability does not stack.",
      "long_description": "Units within 5 spaces of this champion that share a race or class with this champion have +1 SPD. This ability does not stack.",
      "class_name": "ImproveSpeed",
      "revision": 1
    },
    {
      "asset_id": 5016,
      "resettable": 1,
      "name": "Incite Rage",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 1897,
      "activated": 1,
      "icon_name": "enrage",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "Target friendly Barbarian within 5 spaces gains <ability value=2253>Manic</ability> for 1 turn.",
      "long_description": "Target friendly Barbarian within 5 spaces gains <ability value=2253>Manic</ability> for 1 turn.",
      "class_name": "InciteRage",
      "revision": 1
    },
    {
      "asset_id": 5815,
      "resettable": 1,
      "name": "Incoherent Babbling",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2824,
      "activated": 1,
      "icon_name": "rover_babbling",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "Champions within 3 spaces are <condition value=distracted>Distracted</condition>. ",
      "long_description": "Champions within 3 spaces are <condition value=distracted>Distracted</condition>. ",
      "class_name": "IncoherentBabbling",
      "revision": 1
    },
    {
      "asset_id": 7740,
      "resettable": 0,
      "name": "Incubate: Young Myx Slasher",
      "ap_cost": 5,
      "level": 0,
      "ability_id": 3276,
      "activated": 1,
      "icon_name": "incubate_slasher",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "Target friendly Myx Pupae within 3 spaces is destroyed and a young Young Myx Slasher is summoned in its place.",
      "long_description": "Target friendly Myx Pupae within 3 spaces is destroyed and a young Young Myx Slasher is summoned in its place.",
      "class_name": "IncubateYoungMyxSlasher",
      "revision": 1
    },
    {
      "asset_id": 7739,
      "resettable": 0,
      "name": "Incubate: Young Myx Spitter",
      "ap_cost": 5,
      "level": 0,
      "ability_id": 3275,
      "activated": 1,
      "icon_name": "incubate_spitter",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "Target friendly Myx Pupae within 3 spaces is destroyed and a Young Myx Spitter is summoned in its place.",
      "long_description": "Target friendly Myx Pupae within 3 spaces is destroyed and a Young Myx Spitter is summoned in its place.",
      "class_name": "IncubateYoungMyxSpitter",
      "revision": 1
    },
    {
      "asset_id": 5118,
      "resettable": 1,
      "name": "Indentured: Lich",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1309,
      "activated": 1,
      "icon_name": "disable",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -8,
      "short_description": "If you do not control a lich at the end of your turn, this unit will <mechanic value=sacrifice>Sacrifice</mechanic> itself",
      "long_description": "If you do not control a lich at the end of your turn, this unit will <mechanic value=sacrifice>Sacrifice</mechanic> itself",
      "class_name": "IndenturedLich",
      "revision": 1
    },
    {
      "asset_id": 5301,
      "resettable": 1,
      "name": "Independent",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2124,
      "activated": 1,
      "icon_name": "independent",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "This champion receives a split bonus instead of a full faction bonus. Split bonuses still apply as normal.",
      "long_description": "This champion receives a split bonus instead of a full faction bonus. Split bonuses still apply as normal.",
      "class_name": "Independent",
      "revision": 1
    },
    {
      "asset_id": 7994,
      "resettable": 0,
      "name": "Infernal Armaments",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3389,
      "activated": 1,
      "icon_name": "comboatk_devastate",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "When a friendly champion with Race: Minotaur, Race: Demon Elf or Race: Archdemon becomes equipped, it gains 1 AP and +1 DEF for 4 turns. This does not stack.",
      "long_description": "When a friendly champion with Race: Minotaur, Race: Demon Elf or Race: Archdemon becomes equipped, it gains 1 AP and +1 DEF for 4 turns. This does not stack.",
      "class_name": "InfernalArmaments",
      "revision": 1
    },
    {
      "asset_id": 4265,
      "resettable": 1,
      "name": "Infest",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 672,
      "activated": 1,
      "icon_name": "disease",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 20,
      "short_description": "Make an attack against target champion within 2 spaces. If successful, the attack does no damage, Parasitic Fesh is removed from play, and the targeted champion becomes Infested (at the beginning of each turn, it loses 8 HP. If it is destroyed this way, a Parasitic Fesh spawns at half HP in that champion's space, under your control. This condition can not be cleansed.",
      "long_description": "Make an attack against target champion within 2 spaces. If successful, the attack does no damage, Parasitic Fesh is removed from play, and the targeted champion becomes Infested (at the beginning of each turn, it loses 8 HP. If it is destroyed this way, a Parasitic Fesh spawns at half HP in that champion's space, under your control. This condition can not be cleansed.",
      "class_name": "Infest",
      "revision": 1
    },
    {
      "asset_id": 5081,
      "resettable": 1,
      "name": "Inhibiting Touch",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1255,
      "activated": 1,
      "icon_name": "inhibit",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=Inhibited>Inhibited</condition> for 4 turns.",
      "long_description": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=Inhibited>Inhibited</condition> for 4 turns.",
      "class_name": "SearingTouch",
      "revision": 1
    },
    {
      "asset_id": 5891,
      "resettable": 1,
      "name": "Initiate: Devotee to De'lim",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2900,
      "activated": 1,
      "icon_name": "improve_damage",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "Target friendly champion within 3 spaces is Consumed By Fire (This champion is Shielded, Immobile, and Pacified. At the beginning of your turn, this champion takes 10 Fire Damage) and at the start of its next turn, it also gains <ability value=2840>Devotee of De'lim</ability> and <ability value=55>Resistance: Fire 2</ability>.",
      "long_description": "Target friendly champion within 3 spaces is Consumed By Fire (This champion is Shielded, Immobile, and Pacified. At the beginning of your turn, this champion takes 10 Fire Damage) and at the start of its next turn, it also gains <ability value=2840>Devotee of De'lim</ability> and <ability value=55>Resistance: Fire 2</ability>.",
      "class_name": "InitiateDevoteeDelim",
      "revision": 1
    },
    {
      "asset_id": 4070,
      "resettable": 1,
      "name": "Initiative",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 113,
      "activated": 1,
      "icon_name": "initiative",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 5,
      "short_description": "When this champion is deployed, it gains 1 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
      "long_description": "When this champion is deployed, it gains 1 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
      "class_name": "Initiative",
      "revision": 1
    },
    {
      "asset_id": 4070,
      "resettable": 1,
      "name": "Initiative",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 563,
      "activated": 1,
      "icon_name": "initiative",
      "comments": "",
      "prerequisite_id": 113,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 8,
      "short_description": "When this champion is deployed, it gains 2 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
      "long_description": "When this champion is deployed, it gains 2 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
      "class_name": "Initiative",
      "revision": 1
    },
    {
      "asset_id": 7304,
      "resettable": 0,
      "name": "Initiator",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3089,
      "activated": 1,
      "icon_name": "initiator",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 4,
      "short_description": "This champion deals 4 additional damage to champions with 35 or more HP.",
      "long_description": "This champion deals 4 additional damage to champions with 35 or more HP.",
      "class_name": "Initiator",
      "revision": 1
    },
    {
      "asset_id": 4039,
      "resettable": 1,
      "name": "Ink",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 718,
      "activated": 1,
      "icon_name": "ink",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "Target champion within 3 spaces becomes Blinded 4 (its attacks automatically miss).",
      "long_description": "Target champion within 3 spaces becomes Blinded 4 (its attacks automatically miss).",
      "class_name": "OctopiInk",
      "revision": 1
    },
    {
      "asset_id": 5347,
      "resettable": 1,
      "name": "Inquisition",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2276,
      "activated": 1,
      "icon_name": "inquisition",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "When this champion is deployed and at the end of your turns, the closest opposing champion within 5 spaces becomes <ability value=2004>Faithless</ability> and <condition value=branded>Branded</condition> for 4 turns.",
      "long_description": "When this champion is deployed and at the end of your turns, the closest opposing champion within 5 spaces becomes <ability value=2004>Faithless</ability> and <condition value=branded>Branded</condition> for 4 turns.",
      "class_name": "Inquisition",
      "revision": 1
    },
    {
      "asset_id": 5134,
      "resettable": 1,
      "name": "Inscrutable Form",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1926,
      "activated": 1,
      "icon_name": "inhibit",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "This champion cannot be cloned or copied. No other champions can take the form of this champion.",
      "long_description": "This champion cannot be cloned or copied. No other champions can take the form of this champion.",
      "class_name": "InscrutableForm",
      "revision": 1
    },
    {
      "asset_id": 4407,
      "resettable": 1,
      "name": "Inspire",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 733,
      "activated": 1,
      "icon_name": "allybuffs",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 2,
      "short_description": "Select a friendly champion within 5 spaces of this unit. That champion gains +2 DMG, and this unit receives -2 DMG.",
      "long_description": "Select a friendly champion within 5 spaces of this unit. That champion gains +2 DMG, and this unit receives -2 DMG.",
      "class_name": "Inspire",
      "revision": 1
    },
    {
      "asset_id": 5598,
      "resettable": 1,
      "name": "Instability",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2458,
      "activated": 1,
      "icon_name": "instability",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": -10,
      "short_description": "When this unit activates an ability, it loses 10 HP.",
      "long_description": "When this unit activates an ability, it loses 10 HP.",
      "class_name": "Instability",
      "revision": 1
    },
    {
      "asset_id": 4658,
      "resettable": 1,
      "name": "Instigate",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1465,
      "activated": 1,
      "icon_name": "allybuffs",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "Friendly champions within 5 spaces that share a race or class with this one gain <ability value=259>Enrage 1</ability>. This does not stack.",
      "long_description": "Friendly champions within 5 spaces that share a race or class with this one gain <ability value=259>Enrage 1</ability>. This does not stack.",
      "class_name": "Instigate",
      "revision": 1
    },
    {
      "asset_id": 4879,
      "resettable": 1,
      "name": "Insubstantiate",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1761,
      "activated": 1,
      "icon_name": "stealth",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "At the end of your turn, all <condition value=incorporeal>Incorporeal</condition> champions within 8 spaces become <condition value=stealthed>Stealthed</condition> for 4 turns.",
      "long_description": "At the end of your turn, all <condition value=incorporeal>Incorporeal</condition> champions within 8 spaces become <condition value=stealthed>Stealthed</condition> for 4 turns.",
      "class_name": "Insubstantiate",
      "revision": 1
    },
    {
      "asset_id": 4312,
      "resettable": 1,
      "name": "Intensify",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1340,
      "activated": 1,
      "icon_name": "intensify",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "After 10 turns, this ability is removed and this unit is <mechanic value=cleansed>Cleansed</mechanic>, is healed for 15 HP and gains +10 MAX HP, +1 RNG and +1 SPD permanently.",
      "long_description": "After 10 turns, this ability is removed and this unit is <mechanic value=cleansed>Cleansed</mechanic>, is healed for 15 HP and gains +10 MAX HP, +1 RNG and +1 SPD permanently.",
      "class_name": "Intensify",
      "revision": 1
    },
    {
      "asset_id": 4188,
      "resettable": 1,
      "name": "Intensify Fire and Acid",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 530,
      "activated": 1,
      "icon_name": "dragon_skull",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "Fire damage and Acid damage dealt to champions is increased by 20%.",
      "long_description": "Fire damage and Acid damage dealt to champions is increased by 20%.",
      "class_name": "RelicDragonSkull",
      "revision": 1
    },
    {
      "asset_id": 5062,
      "resettable": 1,
      "name": "Intimidating",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1238,
      "activated": 1,
      "icon_name": "dictate",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "This champion may not be the target of close-combat attacks, except those made by champions who have <ability value=3 popup=false>Fearless</ability> or <ability value=4 popup=false>Iron Will</ability>",
      "long_description": "This champion may not be the target of close-combat attacks, except those made by champions who have <ability value=3 popup=false>Fearless</ability> or <ability value=4 popup=false>Iron Will</ability>",
      "class_name": "IntimidatingPresence",
      "revision": 1
    },
    {
      "asset_id": 4125,
      "resettable": 1,
      "name": "Invigorate",
      "ap_cost": 2,
      "level": 1,
      "ability_id": 323,
      "activated": 1,
      "icon_name": "buff",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 1,
      "cost": 5,
      "short_description": "Target champion within 2 spaces gains 2 AP.",
      "long_description": "Target champion within 2 spaces gains 2 AP.",
      "class_name": "Invigorate",
      "revision": 1
    },
    {
      "asset_id": 4125,
      "resettable": 1,
      "name": "Invigorate",
      "ap_cost": 2,
      "level": 2,
      "ability_id": 579,
      "activated": 1,
      "icon_name": "buff",
      "comments": "",
      "prerequisite_id": 323,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 1,
      "cost": 12,
      "short_description": "Target champion within 2 spaces gains 4 AP.",
      "long_description": "Target champion within 2 spaces gains 4 AP.",
      "class_name": "Invigorate",
      "revision": 1
    },
    {
      "asset_id": 7786,
      "resettable": 0,
      "name": "Invoke: Confessor's Exaction",
      "ap_cost": 5,
      "level": 0,
      "ability_id": 3308,
      "activated": 1,
      "icon_name": "invoke",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 8,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "Area Effect 4: Enemy champions take 8 Psychic damage, lose 3 AP and are <condition value=confused>Confused</condition> for 3 turns. This effect is automatically triggered the first time this champion falls below 50% MAX HP (this triggers even if the ability is already on cooldown and will place the ability on full cooldown).",
      "long_description": "Area Effect 4: Enemy champions take 8 Psychic damage, lose 3 AP and are <condition value=confused>Confused</condition> for 3 turns. This effect is automatically triggered the first time this champion falls below 50% MAX HP (this triggers even if the ability is already on cooldown and will place the ability on full cooldown).",
      "class_name": "InvokeForcedMutation",
      "revision": 1
    },
    {
      "asset_id": 7783,
      "resettable": 0,
      "name": "Invoke: Icefang Rumble",
      "ap_cost": 5,
      "level": 0,
      "ability_id": 3305,
      "activated": 1,
      "icon_name": "invoke",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 8,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "Area Effect 4: Enemy champions take 10 Sonic Damage and become <condition value=frozen>Frozen</condition> for 3 turns. Affected spaces become Deep Snow (Impeding 2) for 3 turns. This effect is automatically triggered with cooldown the first time this champion falls below 50% MAX HP (this triggers even if the ability is already on cooldown and will place the ability on full cooldown).",
      "long_description": "Area Effect 4: Enemy champions take 10 Sonic Damage and become <condition value=frozen>Frozen</condition> for 3 turns. Affected spaces become Deep Snow (Impeding 2) for 3 turns. This effect is automatically triggered with cooldown the first time this champion falls below 50% MAX HP (this triggers even if the ability is already on cooldown and will place the ability on full cooldown).",
      "class_name": "InvokeIcefangRumble",
      "revision": 1
    },
    {
      "asset_id": 7875,
      "resettable": 0,
      "name": "Invoke: Intercedence",
      "ap_cost": 5,
      "level": 0,
      "ability_id": 3303,
      "activated": 1,
      "icon_name": "invoke",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 8,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "Area Effect 4: Friendly champions (including this one) are Cleansed and gain 1 stack of Wind Shield for 4 turns. This effect is automatically triggered with cooldown the first time this champion falls below 50% MAX HP (this triggers even if the ability is already on cooldown and will place the ability on full cooldown).\r\n",
      "long_description": "Area Effect 4: Friendly champions (including this one) are Cleansed and gain 1 stack of Wind Shield for 4 turns. This effect is automatically triggered with cooldown the first time this champion falls below 50% MAX HP (this triggers even if the ability is already on cooldown and will place the ability on full cooldown).\r\n",
      "class_name": "InvokeIntercedence",
      "revision": 1
    },
    {
      "asset_id": 7784,
      "resettable": 0,
      "name": "Invoke: Lifeleech",
      "ap_cost": 5,
      "level": 0,
      "ability_id": 3306,
      "activated": 1,
      "icon_name": "invoke",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 8,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "Area Effect 4: Enemy champions lose 8 HP and this champion gains +4 MAX HP for each champion affected. This effect is automatically triggered with cooldown the first time this champion falls below 50% MAX HP (this triggers even if the ability is already on cooldown and will place the ability on full cooldown).\r\n",
      "long_description": "Area Effect 4: Enemy champions lose 8 HP and this champion gains +4 MAX HP for each champion affected. This effect is automatically triggered with cooldown the first time this champion falls below 50% MAX HP (this triggers even if the ability is already on cooldown and will place the ability on full cooldown).\r\n",
      "class_name": "InvokeLifeleech",
      "revision": 1
    },
    {
      "asset_id": 7782,
      "resettable": 0,
      "name": "Invoke: Sarnghavian Rage",
      "ap_cost": 5,
      "level": 0,
      "ability_id": 3304,
      "activated": 1,
      "icon_name": "invoke",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 8,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "Area Effect 4: Enemy champions take 10 Physical damage and this champion gains 1 AP and +1 DMG for 2 turns for each enemy champion affected. This effect is automatically triggered with cooldown the first time this champion falls below 50% MAX HP (this triggers even if the ability is already on cooldown and will place the ability on full cooldown).",
      "long_description": "Area Effect 4: Enemy champions take 10 Physical damage and this champion gains 1 AP and +1 DMG for 2 turns for each enemy champion affected. This effect is automatically triggered with cooldown the first time this champion falls below 50% MAX HP (this triggers even if the ability is already on cooldown and will place the ability on full cooldown).",
      "class_name": "InvokeSarnghavianRage",
      "revision": 1
    },
    {
      "asset_id": 7781,
      "resettable": 0,
      "name": "Invoke: Veil of the Mind",
      "ap_cost": 5,
      "level": 0,
      "ability_id": 3302,
      "activated": 1,
      "icon_name": "invoke",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 8,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "Area Effect 4: Friendly champions (including this one) are Cleansed and have the CD on their non-basic attack abilities reduced by 2 and enemy champions are Dispelled and have the CD on their non-basic attack abilities increased by 2. This effect is automatically triggered with cooldown the first time this champion falls below 50% MAX HP (this triggers even if the ability is already on cooldown and will place the ability on full cooldown).",
      "long_description": "Area Effect 4: Friendly champions (including this one) are Cleansed and have the CD on their non-basic attack abilities reduced by 2 and enemy champions are Dispelled and have the CD on their non-basic attack abilities increased by 2. This effect is automatically triggered with cooldown the first time this champion falls below 50% MAX HP (this triggers even if the ability is already on cooldown and will place the ability on full cooldown).",
      "class_name": "InvokeVeilOfTheMind",
      "revision": 1
    },
    {
      "asset_id": 7787,
      "resettable": 0,
      "name": "Invoke: Vothsair Crush",
      "ap_cost": 5,
      "level": 0,
      "ability_id": 3309,
      "activated": 1,
      "icon_name": "invoke",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 8,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "Area Effect 4: Enemy champions take 10 Physical damage and are <condition value=scolded>Scolded</condition> for 2 turns. This effect is automatically triggered with cooldown the first time this champion falls below 50% MAX HP (this triggers even if the ability is already on cooldown and will place the ability on full cooldown).",
      "long_description": "Area Effect 4: Enemy champions take 10 Physical damage and are <condition value=scolded>Scolded</condition> for 2 turns. This effect is automatically triggered with cooldown the first time this champion falls below 50% MAX HP (this triggers even if the ability is already on cooldown and will place the ability on full cooldown).",
      "class_name": "InvokeVothsairCrush",
      "revision": 1
    },
    {
      "asset_id": 7785,
      "resettable": 0,
      "name": "Invoke: Warbeast Roar",
      "ap_cost": 5,
      "level": 0,
      "ability_id": 3307,
      "activated": 1,
      "icon_name": "invoke",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 8,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "Area Effect 4: Friendly champions (including this one) gain +3 DMG for 2 turns and enemy champions take 8 Sonic damage and become <condition value=frightened>Frightened</condition> for 2 turns. This effect is automatically triggered with cooldown the first time this champion falls below 50% MAX HP (this triggers even if the ability is already on cooldown and will place the ability on full cooldown).",
      "long_description": "Area Effect 4: Friendly champions (including this one) gain +3 DMG for 2 turns and enemy champions take 8 Sonic damage and become <condition value=frightened>Frightened</condition> for 2 turns. This effect is automatically triggered with cooldown the first time this champion falls below 50% MAX HP (this triggers even if the ability is already on cooldown and will place the ability on full cooldown).",
      "class_name": "InvokeWarbeastRoar",
      "revision": 1
    },
    {
      "asset_id": 5717,
      "resettable": 1,
      "name": "Iridescent Projection",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2599,
      "activated": 1,
      "icon_name": "magicaoe",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 7,
      "short_description": "When a friendly champion within 8 spaces makes an attack, a random opposing unit within 8 spaces of this one takes 2 Magical damage.   If the attacking champion is a Fairy or a Wizard, the closest unit to this one takes the damage instead.  This damage ignores DEF.",
      "long_description": "When a friendly champion within 8 spaces makes an attack, a random opposing unit within 8 spaces of this one takes 2 Magical damage.   If the attacking champion is a Fairy or a Wizard, the closest unit to this one takes the damage instead.  This damage ignores DEF.",
      "class_name": "IridescentProjection",
      "revision": 1
    },
    {
      "asset_id": 4003,
      "resettable": 1,
      "name": "Iron Will",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 4,
      "activated": 1,
      "icon_name": "iron_will",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "This champion cannot be <condition value=charmed>Charmed</condition>, <condition value=possessed>Possessed</condition> or <condition value=distracted>Distracted</condition>.",
      "long_description": "This champion cannot be <condition value=charmed>Charmed</condition>, <condition value=possessed>Possessed</condition> or <condition value=distracted>Distracted</condition>.",
      "class_name": "IronWill",
      "revision": 1
    },
    {
      "asset_id": 7998,
      "resettable": 0,
      "name": "Ironfist Armaments",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3393,
      "activated": 1,
      "icon_name": "comboatk_devastate",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "When a friendly champion with Race: Angel, Race: Barbarian, Race: Dwarf, or Race: Construct becomes equipped, it gains 1 AP and +2 DMG for 2 turns. This does not stack.",
      "long_description": "When a friendly champion with Race: Angel, Race: Barbarian, Race: Dwarf, or Race: Construct becomes equipped, it gains 1 AP and +2 DMG for 2 turns. This does not stack.",
      "class_name": "IronfistArmaments",
      "revision": 1
    },
    {
      "asset_id": 7567,
      "resettable": 0,
      "name": "Ironfist Exploit",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3212,
      "activated": 1,
      "icon_name": "exploit_ironfist",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 7,
      "short_description": "When this champion makes a successful basic attack against a target with <condition value=stunned>Stunned</condition>, <condition value=branded>Branded</condition> or <condition value=fatigued>Fatigued</condition>, it gains 1 AP and has +2 DMG for the attack.",
      "long_description": "When this champion makes a successful basic attack against a target with <condition value=stunned>Stunned</condition>, <condition value=branded>Branded</condition> or <condition value=fatigued>Fatigued</condition>, it gains 1 AP and has +2 DMG for the attack.",
      "class_name": "IronfistExploit",
      "revision": 1
    },
    {
      "asset_id": 7590,
      "resettable": 0,
      "name": "Irresponsible Essence Imbibement",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 3191,
      "activated": 1,
      "icon_name": "essence_imbibement",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "Enemy champions within 5 spaces lose between 5 and 15 HP and this champion gains MAX HP equal to 75% of the amount lost. If this champion has more than 75 HP, it is destroyed.",
      "long_description": "Enemy champions within 5 spaces lose between 5 and 15 HP and this champion gains MAX HP equal to 75% of the amount lost. If this champion has more than 75 HP, it is destroyed.",
      "class_name": "IrresponsibleEssenceImbibement",
      "revision": 1
    },
    {
      "asset_id": 5787,
      "resettable": 1,
      "name": "Ivory Sigil",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2714,
      "activated": 1,
      "icon_name": "griffin_sigil",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 2,
      "short_description": "This champion gains <ability value=2671>Illuminate</ability> for 5 turns when a friendly unit with a Sigil ability is deployed from the runedock.",
      "long_description": "This champion gains <ability value=2671>Illuminate</ability> for 5 turns when a friendly unit with a Sigil ability is deployed from the runedock.",
      "class_name": "IvorySigil",
      "revision": 1
    },
    {
      "asset_id": 5832,
      "resettable": 1,
      "name": "Jakei Globe (relic)",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2841,
      "activated": 1,
      "icon_name": "jakei_globe_relic",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 2,
      "ranked": 0,
      "cost": 3,
      "short_description": "At the beginning of each turn, spaces between this relic and the four closest friendly Jakei become Ice for 1 turn.\r\n",
      "long_description": "At the beginning of each turn, spaces between this relic and the four closest friendly Jakei become Ice for 1 turn.\r\n",
      "class_name": "RelicJakeiGlobe",
      "revision": 1
    },
    {
      "asset_id": 5657,
      "resettable": 1,
      "name": "Jellebrium Mind",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2529,
      "activated": 1,
      "icon_name": "jellebrium_mind",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 6,
      "short_description": "When this unit is deployed, a revealed rune in the opposing rune dock has +2 CD for each friendly unit with Jellebrium Mind, including this one. At the beginning of its turns, for every 5 runes your opponent has on cooldown, this unit is healed for 2 and gains a rank of <ability value=406>Teleport</ability> for 1 turn (if it is a champion).",
      "long_description": "When this unit is deployed, a revealed rune in the opposing rune dock has +2 CD for each friendly unit with Jellebrium Mind, including this one. At the beginning of its turns, for every 5 runes your opponent has on cooldown, this unit is healed for 2 and gains a rank of <ability value=406>Teleport</ability> for 1 turn (if it is a champion).",
      "class_name": "JellebriumMind",
      "revision": 1
    },
    {
      "asset_id": 5330,
      "resettable": 1,
      "name": "Jolt",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2159,
      "activated": 1,
      "icon_name": "jolt",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "x",
      "long_description": "x",
      "class_name": "Jolt",
      "revision": 1
    },
    {
      "asset_id": 5413,
      "resettable": 1,
      "name": "Jolt",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 2244,
      "activated": 1,
      "icon_name": "jolt",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 3,
      "short_description": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=shocked>Shocked</condition> for 3 turns.\r\n",
      "long_description": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=shocked>Shocked</condition> for 3 turns.\r\n",
      "class_name": "Jolt",
      "revision": 1
    },
    {
      "asset_id": 5413,
      "resettable": 1,
      "name": "Jolt",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 2245,
      "activated": 1,
      "icon_name": "jolt",
      "comments": "",
      "prerequisite_id": 2244,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 6,
      "short_description": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=shocked>Shocked</condition> for 4 turns.\r\n",
      "long_description": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=shocked>Shocked</condition> for 4 turns.\r\n",
      "class_name": "Jolt",
      "revision": 1
    },
    {
      "asset_id": 5413,
      "resettable": 1,
      "name": "Jolt",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 2246,
      "activated": 1,
      "icon_name": "jolt",
      "comments": "",
      "prerequisite_id": 2245,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 9,
      "short_description": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=shocked>Shocked</condition> for 5 turns.\r\n",
      "long_description": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=shocked>Shocked</condition> for 5 turns.\r\n",
      "class_name": "Jolt",
      "revision": 1
    },
    {
      "asset_id": 5410,
      "resettable": 1,
      "name": "Journey to Oblivion",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2249,
      "activated": 1,
      "icon_name": "journey_to_oblivion",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "Spend 20 Charges. Target opposing non-Avatar, non-Boss, non-Elite champion within 5 spaces is removed from play, has its CD set to 6, and has 80% of its nora cost refunded at the beginning of its owner's next turn. That player has 4 of their revealed runes concealed.",
      "long_description": "Spend 20 Charges. Target opposing non-Avatar, non-Boss, non-Elite champion within 5 spaces is removed from play, has its CD set to 6, and has 80% of its nora cost refunded at the beginning of its owner's next turn. That player has 4 of their revealed runes concealed.",
      "class_name": "JourneyToOblivion",
      "revision": 1
    },
    {
      "asset_id": 5293,
      "resettable": 1,
      "name": "Judgement",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2116,
      "activated": 1,
      "icon_name": "divine",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "Champions within 3 spaces of this champion are <mechanic value=cleansed>Cleansed</mechanic>.  For each condition removed this way, the affected champion loses 10 HP.",
      "long_description": "Champions within 3 spaces of this champion are <mechanic value=cleansed>Cleansed</mechanic>.  For each condition removed this way, the affected champion loses 10 HP.",
      "class_name": "Judgement",
      "revision": 1
    },
    {
      "asset_id": 5261,
      "resettable": 1,
      "name": "Jungle Front",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2082,
      "activated": 1,
      "icon_name": "ferociousgrowth",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "At the beginning of each turn, all spaces within 3 spaces of this champion become Jungle (Impeding Vegetation) for 4 turns.",
      "long_description": "At the beginning of each turn, all spaces within 3 spaces of this champion become Jungle (Impeding Vegetation) for 4 turns.",
      "class_name": "FerociousGrowth",
      "revision": 1
    },
    {
      "asset_id": 8018,
      "resettable": 0,
      "name": "Jungle Kingdom",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3415,
      "activated": 1,
      "icon_name": "tunnel_vegetation",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "Friendly champions with Race: Leoss within 3 spaces gain <ability value=2088>Tunnel: Vegetation</ability>.",
      "long_description": "Friendly champions with Race: Leoss within 3 spaces gain <ability value=2088>Tunnel: Vegetation</ability>.",
      "class_name": "JungleKingdom",
      "revision": 1
    },
    {
      "asset_id": 7374,
      "resettable": 0,
      "name": "Karmic Reward",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3130,
      "activated": 1,
      "icon_name": "soul_bond",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "The first time each turn this champion activates a non-basic attack ability, it is healed for 6 HP.  If that ability targets a friendly champion, this champion also gains 2 MAX HP.",
      "long_description": "The first time each turn this champion activates a non-basic attack ability, it is healed for 6 HP.  If that ability targets a friendly champion, this champion also gains 2 MAX HP.",
      "class_name": "KarmicReward",
      "revision": 1
    },
    {
      "asset_id": 5786,
      "resettable": 1,
      "name": "Keg Toss",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 2712,
      "activated": 1,
      "icon_name": "special_keg",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "Area Effect 2, Range 5: All units become <condition value=intoxicated>Intoxicated</condition> for 4 turns. Opposing units take Physical damage equal to 80% of this unit's DMG.",
      "long_description": "Area Effect 2, Range 5: All units become <condition value=intoxicated>Intoxicated</condition> for 4 turns. Opposing units take Physical damage equal to 80% of this unit's DMG.",
      "class_name": "KegToss",
      "revision": 1
    },
    {
      "asset_id": 5432,
      "resettable": 1,
      "name": "Ki Strike",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2282,
      "activated": 1,
      "icon_name": "ki_strike",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 5,
      "short_description": "This champion's next basic attack this turn has +DMG equal to the number of charges it currently has and the champion loses a third of its charges (rounded down).",
      "long_description": "This champion's next basic attack this turn has +DMG equal to the number of charges it currently has and the champion loses a third of its charges (rounded down).",
      "class_name": "KiStrike",
      "revision": 1
    },
    {
      "asset_id": 7628,
      "resettable": 0,
      "name": "Kick Flaming Skull",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3204,
      "activated": 1,
      "icon_name": "chuck_flamingskull",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "This champion makes a Fire attack at RNG 2-5 and the Flaming Skull relic is destroyed. Champions within 2 spaces of the target take 50% DMG.",
      "long_description": "This champion makes a Fire attack at RNG 2-5 and the Flaming Skull relic is destroyed. Champions within 2 spaces of the target take 50% DMG.",
      "class_name": "KickFlamingSkull",
      "revision": 1
    },
    {
      "asset_id": 4643,
      "resettable": 1,
      "name": "Kill Frenzy ",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1063,
      "activated": 1,
      "icon_name": "furious_attacks",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "When this champion destroys a champion with an attack, its attack costs are reset and it gains 2 AP.",
      "long_description": "When this champion destroys a champion with an attack, its attack costs are reset and it gains 2 AP.",
      "class_name": "KillFrenzy",
      "revision": 1
    },
    {
      "asset_id": 7254,
      "resettable": 0,
      "name": "Kill Sense",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3063,
      "activated": 1,
      "icon_name": "killing_stroke",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "Enemy champions within 5 spaces with 50% or less HP are <condition value=slowed>Slowed</condition>.  This champion gains +1 SPD and +2 DMG for every enemy champion within 5 spaces with 4 SPD or less.",
      "long_description": "Enemy champions within 5 spaces with 50% or less HP are <condition value=slowed>Slowed</condition>.  This champion gains +1 SPD and +2 DMG for every enemy champion within 5 spaces with 4 SPD or less.",
      "class_name": "KillSense",
      "revision": 1
    },
    {
      "asset_id": 5368,
      "resettable": 1,
      "name": "Killing Stroke",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2200,
      "activated": 1,
      "icon_name": "killing_stroke",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 25,
      "short_description": "When this champion successfully deals damage on a basic attack to a non-Avatar, non-Boss, non-Elite champion with a different owner, this champion is Sacrificed and the other champion is destroyed.",
      "long_description": "When this champion successfully deals damage on a basic attack to a non-Avatar, non-Boss, non-Elite champion with a different owner, this champion is Sacrificed and the other champion is destroyed.",
      "class_name": "KillingStroke",
      "revision": 1
    },
    {
      "asset_id": 7162,
      "resettable": 0,
      "name": "Kinetic Impulse",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3005,
      "activated": 1,
      "icon_name": "rock",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "Ranged attacks made by this champion have a bonus of 2 DMG for each space the target is beyond the champion's minimum range (to a maximum of 4 DMG).",
      "long_description": "Ranged attacks made by this champion have a bonus of 2 DMG for each space the target is beyond the champion's minimum range (to a maximum of 4 DMG).",
      "class_name": "KineticImpulse",
      "revision": 1
    },
    {
      "asset_id": 7987,
      "resettable": 0,
      "name": "Knight of Despair",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3378,
      "activated": 1,
      "icon_name": "revere",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "While General Korsien or Eldrick, Czar of the Void is in play, this champion has <ability value=1850>Frightful Blows</ability> and <ability value=2665>Psychological Warfare</ability>.",
      "long_description": "While General Korsien or Eldrick, Czar of the Void is in play, this champion has <ability value=1850>Frightful Blows</ability> and <ability value=2665>Psychological Warfare</ability>.",
      "class_name": "KnightOfDespair",
      "revision": 1
    },
    {
      "asset_id": 4224,
      "resettable": 1,
      "name": "Knockback",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 595,
      "activated": 1,
      "icon_name": "knockback",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 1,
      "cost": 2,
      "short_description": "This unit makes an attack against a champion. If the attack is successful, the attacked unit takes 50% damage, and is knocked back 1 space.",
      "long_description": "This unit makes an attack against a champion. If the attack is successful, the attacked unit takes 50% damage, and is knocked back 1 space.",
      "class_name": "Knockback",
      "revision": 1
    },
    {
      "asset_id": 4224,
      "resettable": 1,
      "name": "Knockback",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 622,
      "activated": 1,
      "icon_name": "knockback",
      "comments": "",
      "prerequisite_id": 595,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 1,
      "cost": 3,
      "short_description": "This unit makes an attack against a champion. If the attack is successful, the attacked unit takes 50% damage, and is knocked back 2 spaces.",
      "long_description": "This unit makes an attack against a champion. If the attack is successful, the attacked unit takes 50% damage, and is knocked back 2 spaces.",
      "class_name": "Knockback",
      "revision": 1
    },
    {
      "asset_id": 4224,
      "resettable": 1,
      "name": "Knockback",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 623,
      "activated": 1,
      "icon_name": "knockback",
      "comments": "",
      "prerequisite_id": 622,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 1,
      "cost": 4,
      "short_description": "This unit makes an attack against a champion. If the attack is successful, the attacked unit takes 50% damage, and is knocked back 3 spaces.",
      "long_description": "This unit makes an attack against a champion. If the attack is successful, the attacked unit takes 50% damage, and is knocked back 3 spaces.",
      "class_name": "Knockback",
      "revision": 1
    },
    {
      "asset_id": 4602,
      "resettable": 1,
      "name": "Knockout",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 1017,
      "activated": 1,
      "icon_name": "stun",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 5,
      "short_description": "This champion makes an attack at RNG 1-2.  If successful, the target becomes <condition value=paralyzed>Paralyzed</condition> 2. This champion must be <condition value=stealthed>Stealthed</condition> and does not destealth the champion.",
      "long_description": "This champion makes an attack at RNG 1-2.  If successful, the target becomes <condition value=paralyzed>Paralyzed</condition> 2. This champion must be <condition value=stealthed>Stealthed</condition> and does not destealth the champion.",
      "class_name": "Knockout",
      "revision": 1
    },
    {
      "asset_id": 5320,
      "resettable": 1,
      "name": "Land Mine",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2149,
      "activated": 1,
      "icon_name": "landmine",
      "comments": "x",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 0,
      "short_description": "When an enemy champion moves within 2 spaces of this relic, it is destroyed and enemy units within 3 spaces take 12 Fire damage.   This damage ignores DEF.  Units successfully damaged are knocked back 2 spaces and become <condition value=distracted>Distracted</condition> for 2 turns.",
      "long_description": "When an enemy champion moves within 2 spaces of this relic, it is destroyed and enemy units within 3 spaces take 12 Fire damage.   This damage ignores DEF.  Units successfully damaged are knocked back 2 spaces and become <condition value=distracted>Distracted</condition> for 2 turns.",
      "class_name": "TortunMine",
      "revision": 1
    },
    {
      "asset_id": 8008,
      "resettable": 0,
      "name": "Land of the Trolls",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3405,
      "activated": 1,
      "icon_name": "tunnel_earth",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "Friendly champions within 3 spaces gain <ability value=2037>Terraform Rock 2</ability>. Friendly champions within range with <ability value=2527>Rock Defiance</ability> also gain <ability value=755>Tunnel: Earth</ability>.",
      "long_description": "Friendly champions within 3 spaces gain <ability value=2037>Terraform Rock 2</ability>. Friendly champions within range with <ability value=2527>Rock Defiance</ability> also gain <ability value=755>Tunnel: Earth</ability>.",
      "class_name": "LandOfTheTrolls",
      "revision": 1
    },
    {
      "asset_id": 4367,
      "resettable": 1,
      "name": "Latch On",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 1403,
      "activated": 1,
      "icon_name": "disable",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 3,
      "short_description": "For the next 3 turns this unit stays adjacent to target champion while it moves. Target unit gains <ability value=5>Lumbering</ability>.",
      "long_description": "For the next 3 turns this unit stays adjacent to target champion while it moves. Target unit gains <ability value=5>Lumbering</ability>.",
      "class_name": "LatchOn",
      "revision": 1
    },
    {
      "asset_id": 5680,
      "resettable": 1,
      "name": "Lava Born",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2552,
      "activated": 1,
      "icon_name": "domain_lava",
      "comments": "x",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": -8,
      "short_description": "When this champion is not occupying lava, its RNG becomes 1-1 and it gains <ability value=1209>Defiant</ability> and +2 DEF.",
      "long_description": "When this champion is not occupying lava, its RNG becomes 1-1 and it gains <ability value=1209>Defiant</ability> and +2 DEF.",
      "class_name": "LavaBorn",
      "revision": 1
    },
    {
      "asset_id": 7518,
      "resettable": 0,
      "name": "Lava Font",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3187,
      "activated": 1,
      "icon_name": "lava_font",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "When an enemy champion within 5 spaces makes a basic attack, it takes 4 Fire damage.",
      "long_description": "When an enemy champion within 5 spaces makes a basic attack, it takes 4 Fire damage.",
      "class_name": "LavaFont",
      "revision": 1
    },
    {
      "asset_id": 5440,
      "resettable": 1,
      "name": "Lava Front",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2292,
      "activated": 1,
      "icon_name": "domain_lava",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 10,
      "short_description": " At the end of each turn, all spaces adjacent to this unit becomes Deep Lava (Impeding 1, 8 fire damage on entry and when occupied) for 2 turns.",
      "long_description": " At the end of each turn, all spaces adjacent to this unit becomes Deep Lava (Impeding 1, 8 fire damage on entry and when occupied) for 2 turns.",
      "class_name": "LavaFront",
      "revision": 1
    },
    {
      "asset_id": 4771,
      "resettable": 1,
      "name": "Lava Storm",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 1499,
      "activated": 1,
      "icon_name": "fireaoe",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 12,
      "short_description": "Area Effect 2, Range 5: Affected champions take 12 Fire damage. This damage ignores DEF. For the next 2 turns, spaces within the affected area are Shallow Lava (4 Fire damage on entry and when occupied).",
      "long_description": "Area Effect 2, Range 5: Affected champions take 12 Fire damage. This damage ignores DEF. For the next 2 turns, spaces within the affected area are Shallow Lava (4 Fire damage on entry and when occupied).",
      "class_name": "LavaStorm",
      "revision": 1
    },
    {
      "asset_id": 4612,
      "resettable": 1,
      "name": "Lava Trap",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1027,
      "activated": 1,
      "icon_name": "trapfire",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "When an enemy champion moves within 2 spaces of the trap, the relic is destroyed and enemy units within range take 8 fire damage. The location of the relic becomes Lava (Impeding 1, 8 Fire damage on entry and when occupied) for 5 turns. This damage ignores DEF.",
      "long_description": "When an enemy champion moves within 2 spaces of the trap, the relic is destroyed and enemy units within range take 8 fire damage. The location of the relic becomes Lava (Impeding 1, 8 Fire damage on entry and when occupied) for 5 turns. This damage ignores DEF.",
      "class_name": "RelicLavaTrap",
      "revision": 1
    },
    {
      "asset_id": 4680,
      "resettable": 1,
      "name": "Lava-Fall",
      "ap_cost": 2,
      "level": 1,
      "ability_id": 1118,
      "activated": 1,
      "icon_name": "terrainlava",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 4,
      "short_description": "Spaces within 2 spaces of this champion are Shallow Lava (4 Fire damage on entry and when occupied) for 4 turns.",
      "long_description": "Spaces within 2 spaces of this champion are Shallow Lava (4 Fire damage on entry and when occupied) for 4 turns.",
      "class_name": "LavaFall",
      "revision": 1
    },
    {
      "asset_id": 4680,
      "resettable": 1,
      "name": "Lava-Fall",
      "ap_cost": 2,
      "level": 2,
      "ability_id": 1119,
      "activated": 1,
      "icon_name": "terrainlava",
      "comments": "",
      "prerequisite_id": 1118,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 8,
      "short_description": "Spaces within 4 spaces of this champion are Shallow Lava (4 Fire damage on entry and when occupied) for 4 turns.",
      "long_description": "Spaces within 4 spaces of this champion are Shallow Lava (4 Fire damage on entry and when occupied) for 4 turns.",
      "class_name": "LavaFall",
      "revision": 1
    },
    {
      "asset_id": 4680,
      "resettable": 1,
      "name": "Lava-Fall (relic)",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 2905,
      "activated": 1,
      "icon_name": "terrainlava",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 4,
      "short_description": "Spaces within 2 spaces of this champion are Shallow Lava (4 Fire damage on entry and when occupied) for 4 turns.",
      "long_description": "Spaces within 2 spaces of this champion are Shallow Lava (4 Fire damage on entry and when occupied) for 4 turns.",
      "class_name": "RelicLavaFall",
      "revision": 1
    },
    {
      "asset_id": 4680,
      "resettable": 1,
      "name": "Lava-Fall (relic)",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 2906,
      "activated": 1,
      "icon_name": "terrainlava",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 8,
      "short_description": "Spaces within 4 spaces of this champion are Shallow Lava (4 Fire damage on entry and when occupied) for 4 turns.",
      "long_description": "Spaces within 4 spaces of this champion are Shallow Lava (4 Fire damage on entry and when occupied) for 4 turns.",
      "class_name": "RelicLavaFall",
      "revision": 1
    },
    {
      "asset_id": 4171,
      "resettable": 1,
      "name": "Lavawalker",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 480,
      "activated": 1,
      "icon_name": "terrainlava",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 2,
      "short_description": "This champion ignores movement restrictions and movement penalties imposed by Lava. Fire damage that would be dealt to this champion by Lava is prevented.",
      "long_description": "This champion ignores movement restrictions and movement penalties imposed by Lava. Fire damage that would be dealt to this champion by Lava is prevented.",
      "class_name": "Lavawalker",
      "revision": 1
    },
    {
      "asset_id": 4222,
      "resettable": 1,
      "name": "Lay Hands",
      "ap_cost": 4,
      "level": 1,
      "ability_id": 620,
      "activated": 1,
      "icon_name": "heal",
      "comments": "",
      "prerequisite_id": 593,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 15,
      "short_description": "Target champion within 2 spaces (including this champion) heals HP equal to its max HP.",
      "long_description": "Target champion within 2 spaces (including this champion) heals HP equal to its max HP.",
      "class_name": "LayOnHands",
      "revision": 1
    },
    {
      "asset_id": 4630,
      "resettable": 1,
      "name": "Lay Hatchling",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 1053,
      "activated": 1,
      "icon_name": "sumdragonegg",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "Unit summons a dragon egg relic to target adjacent space. At the end of the next turn, the egg will hatch into a Draksar Broodling.",
      "long_description": "Unit summons a dragon egg relic to target adjacent space. At the end of the next turn, the egg will hatch into a Draksar Broodling.",
      "class_name": "LayHatchling",
      "revision": 1
    },
    {
      "asset_id": 5637,
      "resettable": 1,
      "name": "Lay Myx Pupae",
      "ap_cost": 5,
      "level": 0,
      "ability_id": 2499,
      "activated": 1,
      "icon_name": "hatch_myx_pupae",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "Summon a <ability value=2494>Myx Pupae</ability> relic to target adjacent space.",
      "long_description": "Summon a <ability value=2494>Myx Pupae</ability> relic to target adjacent space.",
      "class_name": "LayMyxPupae",
      "revision": 1
    },
    {
      "asset_id": 7154,
      "resettable": 0,
      "name": "Lay Trap: Acid",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 2996,
      "activated": 1,
      "icon_name": "trapthorn",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 2,
      "short_description": "Lay an Acid Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 2 Acid Damage and becomes <condition value=scoured>Scoured</condition> for 2 turns.",
      "long_description": "Lay an Acid Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 2 Acid Damage and becomes <condition value=scoured>Scoured</condition> for 2 turns.",
      "class_name": "LayTrapAcid",
      "revision": 1
    },
    {
      "asset_id": 7154,
      "resettable": 0,
      "name": "Lay Trap: Acid",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 2997,
      "activated": 1,
      "icon_name": "trapthorn",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "Lay an Acid Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 4 Acid Damage and becomes <condition value=scoured>Scoured</condition> for 2 turns.",
      "long_description": "Lay an Acid Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 4 Acid Damage and becomes <condition value=scoured>Scoured</condition> for 2 turns.",
      "class_name": "LayTrapAcid",
      "revision": 1
    },
    {
      "asset_id": 7154,
      "resettable": 0,
      "name": "Lay Trap: Acid",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 2998,
      "activated": 1,
      "icon_name": "trapthorn",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "Lay an Acid Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 6 Acid Damage and becomes <condition value=scoured>Scoured</condition> for 2 turns.",
      "long_description": "Lay an Acid Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 6 Acid Damage and becomes <condition value=scoured>Scoured</condition> for 2 turns.",
      "class_name": "LayTrapAcid",
      "revision": 1
    },
    {
      "asset_id": 4404,
      "resettable": 1,
      "name": "Lay Trap: Boulder",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 727,
      "activated": 1,
      "icon_name": "traprock",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 1,
      "cost": 2,
      "short_description": "Lay a Boulder Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 4 Physical Damage.",
      "long_description": "Lay a Boulder Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 4 Physical Damage.",
      "class_name": "LayTrapBoulder",
      "revision": 1
    },
    {
      "asset_id": 4404,
      "resettable": 1,
      "name": "Lay Trap: Boulder",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 728,
      "activated": 1,
      "icon_name": "traprock",
      "comments": "",
      "prerequisite_id": 727,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 1,
      "cost": 4,
      "short_description": "Lay a Boulder Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 7 Physical Damage.",
      "long_description": "Lay a Boulder Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 7 Physical Damage.",
      "class_name": "LayTrapBoulder",
      "revision": 1
    },
    {
      "asset_id": 4404,
      "resettable": 1,
      "name": "Lay Trap: Boulder",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 729,
      "activated": 1,
      "icon_name": "traprock",
      "comments": "",
      "prerequisite_id": 728,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 1,
      "cost": 6,
      "short_description": "Lay a Boulder Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 10 Physical Damage.",
      "long_description": "Lay a Boulder Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 10 Physical Damage.",
      "class_name": "LayTrapBoulder",
      "revision": 1
    },
    {
      "asset_id": 4160,
      "resettable": 1,
      "name": "Lay Trap: Fire",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 442,
      "activated": 1,
      "icon_name": "trapfire",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 1,
      "cost": 2,
      "short_description": "Lay a Fire Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 3 Fire Damage.",
      "long_description": "Lay a Fire Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 3 Fire Damage.",
      "class_name": "LayTrapFire",
      "revision": 1
    },
    {
      "asset_id": 4160,
      "resettable": 1,
      "name": "Lay Trap: Fire",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 443,
      "activated": 1,
      "icon_name": "trapfire",
      "comments": "none",
      "prerequisite_id": 442,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 1,
      "cost": 4,
      "short_description": "Lay a Fire Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 6 Fire Damage.",
      "long_description": "Lay a Fire Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 6 Fire Damage.",
      "class_name": "LayTrapFire",
      "revision": 1
    },
    {
      "asset_id": 4160,
      "resettable": 1,
      "name": "Lay Trap: Fire",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 444,
      "activated": 1,
      "icon_name": "trapfire",
      "comments": "none",
      "prerequisite_id": 443,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 1,
      "cost": 6,
      "short_description": "Lay a Fire Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 9 Fire Damage.",
      "long_description": "Lay a Fire Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 9 Fire Damage.",
      "class_name": "LayTrapFire",
      "revision": 1
    },
    {
      "asset_id": 4162,
      "resettable": 1,
      "name": "Lay Trap: Frost",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 450,
      "activated": 1,
      "icon_name": "trapfrost",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 1,
      "cost": 2,
      "short_description": "Lay a Frost Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 2 Frost Damage and becomes <mechanic value=slowed>Slowed</mechanic> for 2 turns.",
      "long_description": "Lay a Frost Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 2 Frost Damage and becomes <mechanic value=slowed>Slowed</mechanic> for 2 turns.",
      "class_name": "LayTrapCold",
      "revision": 1
    },
    {
      "asset_id": 4162,
      "resettable": 1,
      "name": "Lay Trap: Frost",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 451,
      "activated": 1,
      "icon_name": "trapfrost",
      "comments": "none",
      "prerequisite_id": 450,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 1,
      "cost": 4,
      "short_description": "Lay a Frost Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 4 Frost Damage and becomes <mechanic value=slowed>Slowed</mechanic> for 3 turns.",
      "long_description": "Lay a Frost Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 4 Frost Damage and becomes <mechanic value=slowed>Slowed</mechanic> for 3 turns.",
      "class_name": "LayTrapCold",
      "revision": 1
    },
    {
      "asset_id": 4162,
      "resettable": 1,
      "name": "Lay Trap: Frost",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 452,
      "activated": 1,
      "icon_name": "trapfrost",
      "comments": "none",
      "prerequisite_id": 451,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 1,
      "cost": 6,
      "short_description": "Lay a Frost Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 6 Frost Damage and becomes <mechanic value=slowed>Slowed</mechanic> for 4 turns.",
      "long_description": "Lay a Frost Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 6 Frost Damage and becomes <mechanic value=slowed>Slowed</mechanic> for 4 turns.",
      "class_name": "LayTrapCold",
      "revision": 1
    },
    {
      "asset_id": 4161,
      "resettable": 1,
      "name": "Lay Trap: Poison Cloud",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 446,
      "activated": 1,
      "icon_name": "trappoison",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "Lay a Poison Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, all spaces within a range of 2 are covered in a <mechanic value=poison_cloud>poison cloud</mechanic> until end of the next turn.",
      "long_description": "Lay a Poison Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, all spaces within a range of 2 are covered in a <mechanic value=poison_cloud>poison cloud</mechanic> until end of the next turn.",
      "class_name": "LayTrapPoisonCloud",
      "revision": 1
    },
    {
      "asset_id": 7392,
      "resettable": 0,
      "name": "Lead the Charge",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3143,
      "activated": 1,
      "icon_name": "lead_the_charge",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 6,
      "short_description": "When this champion is deployed from the runedock, the next 2 champions you deploy from the runedock while this champion is in play gain a rank of <ability value=113>Initiative</ability>.",
      "long_description": "When this champion is deployed from the runedock, the next 2 champions you deploy from the runedock while this champion is in play gain a rank of <ability value=113>Initiative</ability>.",
      "class_name": "LeadTheCharge",
      "revision": 1
    },
    {
      "asset_id": 4183,
      "resettable": 1,
      "name": "Leap",
      "ap_cost": 3,
      "level": 1,
      "ability_id": 516,
      "activated": 1,
      "icon_name": "leap",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 1,
      "cost": 1,
      "short_description": "This champion is relocated to target space within 2 spaces. If this champion is engaged, this ability costs 1 additional AP.",
      "long_description": "This champion is relocated to target space within 2 spaces. If this champion is engaged, this ability costs 1 additional AP.",
      "class_name": "Leap",
      "revision": 1
    },
    {
      "asset_id": 4183,
      "resettable": 1,
      "name": "Leap",
      "ap_cost": 3,
      "level": 2,
      "ability_id": 517,
      "activated": 1,
      "icon_name": "leap",
      "comments": "none",
      "prerequisite_id": 516,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 1,
      "cost": 3,
      "short_description": "This champion is relocated to target space within 3 spaces. If this champion is engaged, this ability costs 1 additional AP.",
      "long_description": "This champion is relocated to target space within 3 spaces. If this champion is engaged, this ability costs 1 additional AP.",
      "class_name": "Leap",
      "revision": 1
    },
    {
      "asset_id": 4183,
      "resettable": 1,
      "name": "Leap",
      "ap_cost": 3,
      "level": 3,
      "ability_id": 518,
      "activated": 1,
      "icon_name": "leap",
      "comments": "none",
      "prerequisite_id": 517,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 1,
      "cost": 5,
      "short_description": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
      "long_description": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
      "class_name": "Leap",
      "revision": 1
    },
    {
      "asset_id": 5574,
      "resettable": 1,
      "name": "Leech Vitality",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2434,
      "activated": 1,
      "icon_name": "overkill",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 12,
      "short_description": "When this champion damages an opposing champion, it permanently gains MAX HP equal to 50% of the damage dealt (to a maximum of 5).",
      "long_description": "When this champion damages an opposing champion, it permanently gains MAX HP equal to 50% of the damage dealt (to a maximum of 5).",
      "class_name": "LeechVitality",
      "revision": 1
    },
    {
      "asset_id": 5715,
      "resettable": 1,
      "name": "Legacy of Kings",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2597,
      "activated": 1,
      "icon_name": "shrinegood",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 1,
      "short_description": "The first 8 damage each turn that would be dealt to friendly units, including this one, within 5 spaces is prevented.",
      "long_description": "The first 8 damage each turn that would be dealt to friendly units, including this one, within 5 spaces is prevented.",
      "class_name": "LegacyOfKings",
      "revision": 1
    },
    {
      "asset_id": 5827,
      "resettable": 1,
      "name": "Lethal Poison",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2836,
      "activated": 1,
      "icon_name": "katipo_poison",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "When this champion successfully damages a champion with a basic attack, that champion gains a stack of <condition value=lethal>Lethal</condition> if it does not have Avatar, Boss, Elite or Immunity: Poison. This condition can not be cleansed.",
      "long_description": "When this champion successfully damages a champion with a basic attack, that champion gains a stack of <condition value=lethal>Lethal</condition> if it does not have Avatar, Boss, Elite or Immunity: Poison. This condition can not be cleansed.",
      "class_name": "LethalPoison",
      "revision": 1
    },
    {
      "asset_id": 5234,
      "resettable": 1,
      "name": "Lethargic",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2012,
      "activated": 1,
      "icon_name": "lumbering",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -6,
      "short_description": "At the beginning of every 6 turns, this champion is in play, it gains <ability value=5>Lumbering</ability> for 1 turn.",
      "long_description": "At the beginning of every 6 turns, this champion is in play, it gains <ability value=5>Lumbering</ability> for 1 turn.",
      "class_name": "Lethargic",
      "revision": 1
    },
    {
      "asset_id": 4395,
      "resettable": 1,
      "name": "Leverage: Beast",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1436,
      "activated": 1,
      "icon_name": "cost",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this unit is deployed from the runedock, the next Beast that costs 80 or more nora that you deploy from the runedock costs 10 less nora. This effect lasts for a maximum of 3 turns and does not stack.",
      "long_description": "When this unit is deployed from the runedock, the next Beast that costs 80 or more nora that you deploy from the runedock costs 10 less nora. This effect lasts for a maximum of 3 turns and does not stack.",
      "class_name": "LeverageBeast",
      "revision": 1
    },
    {
      "asset_id": 4395,
      "resettable": 0,
      "name": "Leverage: Elemental",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2962,
      "activated": 1,
      "icon_name": "cost",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this unit is deployed from the runedock, the next Elemental you deploy from the runedock cost 10 less nora for 3 turns. This effect does not stack.",
      "long_description": "When this unit is deployed from the runedock, the next Elemental you deploy from the runedock cost 10 less nora for 3 turns. This effect does not stack.",
      "class_name": "LeverageElemental",
      "revision": 1
    },
    {
      "asset_id": 4395,
      "resettable": 1,
      "name": "Leverage: Fairy",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2622,
      "activated": 1,
      "icon_name": "cost",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this unit is deployed from the runedock, the next Fairy you deploy from the runedock cost 10 less nora for 3 turns. This effect does not stack.",
      "long_description": "When this unit is deployed from the runedock, the next Fairy you deploy from the runedock cost 10 less nora for 3 turns. This effect does not stack.",
      "class_name": "LeverageFairy",
      "revision": 1
    },
    {
      "asset_id": 4395,
      "resettable": 0,
      "name": "Leverage: Garu",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2968,
      "activated": 1,
      "icon_name": "cost",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this unit is deployed from the runedock, the next Garu with a nora cost of 80 or more that you deploy from the runedock costs 10 less nora for 3 turns. This effect does not stack.",
      "long_description": "When this unit is deployed from the runedock, the next Garu with a nora cost of 80 or more that you deploy from the runedock costs 10 less nora for 3 turns. This effect does not stack.",
      "class_name": "LeverageGaru",
      "revision": 1
    },
    {
      "asset_id": 4395,
      "resettable": 1,
      "name": "Leverage: Lich",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1308,
      "activated": 1,
      "icon_name": "cost",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this unit is deployed from the runedock, the next Lich that costs 80 or more nora that you deploy from the runedock costs 10 less nora. This effect lasts for a maximum of 3 turns and does not stack.",
      "long_description": "When this unit is deployed from the runedock, the next Lich that costs 80 or more nora that you deploy from the runedock costs 10 less nora. This effect lasts for a maximum of 3 turns and does not stack.",
      "class_name": "LeverageLich",
      "revision": 1
    },
    {
      "asset_id": 4395,
      "resettable": 1,
      "name": "Leverage: Yeti",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1438,
      "activated": 1,
      "icon_name": "cost",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this unit is deployed from the runedock, the next Yeti you deploy from the runedock cost 10 less nora for 3 turns. This effect does not stack.",
      "long_description": "When this unit is deployed from the runedock, the next Yeti you deploy from the runedock cost 10 less nora for 3 turns. This effect does not stack.",
      "class_name": "LeverageYeti",
      "revision": 1
    },
    {
      "asset_id": 5230,
      "resettable": 1,
      "name": "Liability",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2008,
      "activated": 1,
      "icon_name": "dampen",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -4,
      "short_description": "Friendly champions within 5 spaces of this champion have -1 DEF.",
      "long_description": "Friendly champions within 5 spaces of this champion have -1 DEF.",
      "class_name": "Liability",
      "revision": 1
    },
    {
      "asset_id": 5119,
      "resettable": 1,
      "name": "Lich Apprentice",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 1310,
      "activated": 1,
      "icon_name": "drain",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 5,
      "short_description": "This unit loses 10 max HP and Lich friendly champions gain an additional +5 HP.\r\n\r\n",
      "long_description": "This unit loses 10 max HP and Lich friendly champions gain an additional +5 HP.\r\n",
      "class_name": "Apprentice",
      "revision": 1
    },
    {
      "asset_id": 4272,
      "resettable": 1,
      "name": "Lich-born",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 694,
      "activated": 1,
      "icon_name": "ondeath",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 35,
      "short_description": "This unit cannot be the target of spells.  When this unit is destroyed, it reanimates as a Lich Knight champion, loses Lich-born, gains +1 DEF, +4 DMG, <ability value=1>Flight</ability>, <ability value=105>Scorn</ability>, <ability value=99>Life Siphon</ability>, <ability value=36>Immunity: Magical</ability>, and gains <ability value=544>Attack: Magical</ability> as its basic attack.",
      "long_description": "This unit cannot be the target of spells.  When this unit is destroyed, it reanimates as a Lich Knight champion, loses Lich-born, gains +1 DEF, +4 DMG, <ability value=1>Flight</ability>, <ability value=105>Scorn</ability>, <ability value=99>Life Siphon</ability>, <ability value=36>Immunity: Magical</ability>, and gains <ability value=544>Attack: Magical</ability> as its basic attack.",
      "class_name": "LichBorn",
      "revision": 1
    },
    {
      "asset_id": 4563,
      "resettable": 1,
      "name": "Lichbound",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 996,
      "activated": 1,
      "icon_name": "disable",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -14,
      "short_description": "At the beginning of your enemy's turn, if you do not control a Lich, this unit is <condition value=possessed>Possessed</condition> by your enemy until end of turn.",
      "long_description": "At the beginning of your enemy's turn, if you do not control a Lich, this unit is <condition value=possessed>Possessed</condition> by your enemy until end of turn.",
      "class_name": "Lichbound",
      "revision": 1
    },
    {
      "asset_id": 4057,
      "resettable": 1,
      "name": "Life Siphon",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 99,
      "activated": 1,
      "icon_name": "heal",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 6,
      "short_description": "When this unit attacks and deals damage to a champion, it vampiric heals HP equal to half the damage dealt.",
      "long_description": "When this unit attacks and deals damage to a champion, it vampiric heals HP equal to half the damage dealt.",
      "class_name": "LifeSiphon",
      "revision": 1
    },
    {
      "asset_id": 7173,
      "resettable": 0,
      "name": "Life Siphon: Scoured",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3016,
      "activated": 1,
      "icon_name": "siphon_scoured",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this champion successfully damages a champion with <condition value=scoured>Scoured</condition> with a basic attack, it vampiric heals HP equal to half the damage dealt (rounded down).",
      "long_description": "When this champion successfully damages a champion with <condition value=scoured>Scoured</condition> with a basic attack, it vampiric heals HP equal to half the damage dealt (rounded down).",
      "class_name": "SiphonScoured",
      "revision": 1
    },
    {
      "asset_id": 4056,
      "resettable": 1,
      "name": "Lifedrinker",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 98,
      "activated": 1,
      "icon_name": "ondeath",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 8,
      "short_description": "When this unit destroys an opposing champion, it vampiric heals HP equal to half the destroyed champion's max HP.",
      "long_description": "When this unit destroys an opposing champion, it vampiric heals HP equal to half the destroyed champion's max HP.",
      "class_name": "Lifedrinker",
      "revision": 1
    },
    {
      "asset_id": 4881,
      "resettable": 1,
      "name": "Lift",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 1763,
      "activated": 1,
      "icon_name": "feather",
      "comments": "Range 1",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 5,
      "short_description": "Target champion gains flying, no longer engages opposing units, and cannot spend AP on movement for 2 rounds.  Whenever this champion moves, target champion moves to where this champion was.  This champion's movement costs 3 AP while target champion is Lifted.",
      "long_description": "Target champion gains flying, no longer engages opposing units, and cannot spend AP on movement for 2 rounds.  Whenever this champion moves, target champion moves to where this champion was.  This champion's movement costs 3 AP while target champion is Lifted.\r\n",
      "class_name": "Lift",
      "revision": 1
    },
    {
      "asset_id": 5788,
      "resettable": 1,
      "name": "Lightning Amped",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2763,
      "activated": 1,
      "icon_name": "amped",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "This champion loses a charge at the end of its turn. While this champion has at least 8 charges, it has +1 SPD, +2 DMG, +2 DEF and Electricity Aura 3.",
      "long_description": "This champion loses a charge at the end of its turn. While this champion has at least 8 charges, it has +1 SPD, +2 DMG, +2 DEF and Electricity Aura 3.",
      "class_name": "LightningAmped",
      "revision": 1
    },
    {
      "asset_id": 5667,
      "resettable": 1,
      "name": "Lightning Blast",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2539,
      "activated": 1,
      "icon_name": "electricaoe",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this unit makes a basic attack, all opposing champions within 2 spaces of the target take 50% Electricity damage.",
      "long_description": "When this unit makes a basic attack, all opposing champions within 2 spaces of the target take 50% Electricity damage.",
      "class_name": "LightningBlast",
      "revision": 1
    },
    {
      "asset_id": 5542,
      "resettable": 1,
      "name": "Lightning Skewer",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 2401,
      "activated": 1,
      "icon_name": "electricaoe",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 3,
      "ranked": 0,
      "cost": 9,
      "short_description": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this unit take 12 Electricity damage and are <condition value=paralyzed>Paralyzed</condition> 1. This damage ignores DEF.",
      "long_description": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this unit take 12 Electricity damage and are <condition value=paralyzed>Paralyzed</condition> 1. This damage ignores DEF.",
      "class_name": "LightningSkewer",
      "revision": 1
    },
    {
      "asset_id": 5601,
      "resettable": 1,
      "name": "Lightning Skewer (relic)",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2461,
      "activated": 1,
      "icon_name": "electricaoe",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this unit take 12 Electricity damage and are <condition value=paralyzed>Paralyzed</condition> 1. This damage ignores DEF.",
      "long_description": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this unit take 12 Electricity damage and are <condition value=paralyzed>Paralyzed</condition> 1. This damage ignores DEF.",
      "class_name": "RelicLightningSkewer",
      "revision": 1
    },
    {
      "asset_id": 5439,
      "resettable": 1,
      "name": "Lightning Storm ",
      "ap_cost": 4,
      "level": 1,
      "ability_id": 2289,
      "activated": 1,
      "icon_name": "electricaoe",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 6,
      "short_description": "Area Effect 2, Range 5: Affected units take Electricity damage equal to 50% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=shocked>Shocked</condition> for 2 turns.",
      "long_description": "Area Effect 2, Range 5: Affected units take Electricity damage equal to 50% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=shocked>Shocked</condition> for 2 turns.",
      "class_name": "LightningStorm",
      "revision": 1
    },
    {
      "asset_id": 5439,
      "resettable": 1,
      "name": "Lightning Storm ",
      "ap_cost": 4,
      "level": 2,
      "ability_id": 2290,
      "activated": 1,
      "icon_name": "electricaoe",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 8,
      "short_description": "Area Effect 2, Range 5: Affected units take Electricity damage equal to 65% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=shocked>Shocked</condition> for 2 turns.",
      "long_description": "Area Effect 2, Range 5: Affected units take Electricity damage equal to 65% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=shocked>Shocked</condition> for 2 turns.",
      "class_name": "LightningStorm",
      "revision": 1
    },
    {
      "asset_id": 5439,
      "resettable": 1,
      "name": "Lightning Storm ",
      "ap_cost": 4,
      "level": 3,
      "ability_id": 2291,
      "activated": 1,
      "icon_name": "electricaoe",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 10,
      "short_description": "Area Effect 2, Range 5: Affected units take Electricity damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=shocked>Shocked</condition> for 2 turns.\r\n",
      "long_description": "Area Effect 2, Range 5: Affected units take Electricity damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=shocked>Shocked</condition> for 2 turns.\r\n",
      "class_name": "LightningStorm",
      "revision": 1
    },
    {
      "asset_id": 7146,
      "resettable": 0,
      "name": "Lightseeker",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 2988,
      "activated": 1,
      "icon_name": "relocate_lightning",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "This champion is relocated adjacent to target champion within 5 spaces with <condition value=blinded>Blinded</condition> or <condition value=illuminated>Illuminated</condition> and gains +2 SPD for 3 turns.",
      "long_description": "This champion is relocated adjacent to target champion within 5 spaces with <condition value=blinded>Blinded</condition> or <condition value=illuminated>Illuminated</condition> and gains +2 SPD for 3 turns.",
      "class_name": "AuroraRelocation",
      "revision": 1
    },
    {
      "asset_id": 5703,
      "resettable": 1,
      "name": "Limbo",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2583,
      "activated": 1,
      "icon_name": "sum_festering_corpse",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -10,
      "short_description": "When this champion is destroyed, no nora globe is dropped and a Level 1 Frenzied Zombie (HP 30, Manic, Reconstitute and Absorb) is deployed under your opponent's control.",
      "long_description": "When this champion is destroyed, no nora globe is dropped and a Level 1 Frenzied Zombie (HP 25, Manic, Reconstitute and Absorb) is deployed under your opponent's control.",
      "class_name": "Limbo",
      "revision": 1
    },
    {
      "asset_id": 5726,
      "resettable": 1,
      "name": "Living Luminescence",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2613,
      "activated": 1,
      "icon_name": "dispelling_luminesence",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "This unit has <ability value=2083>Trailblaze</ability>, <abiluty value=3101>Ferocious Growth</ability> and <ability value=3415>Jungle Kingdom</ability>.",
      "long_description": "This unit has <ability value=2083>Trailblaze</ability>, <abiluty value=3101>Ferocious Growth</ability> and <ability value=3415>Jungle Kingdom</ability>.",
      "class_name": "LivingLuminescence",
      "revision": 1
    },
    {
      "asset_id": 4219,
      "resettable": 1,
      "name": "Load Catapult",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 590,
      "activated": 1,
      "icon_name": "throw_champ",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 25,
      "short_description": "Target adjacent, friendly, normal-sized champion gains Catapult until end of turn (this champion is relocated to target space 2-5 spaces away, for 0 AP). When a champion with Catapult is no longer adjacent to this unit, it loses the Catapult ability.",
      "long_description": "Target adjacent, friendly, normal-sized champion gains Catapult until end of turn (this champion is relocated to target space 2-5 spaces away, for 0 AP). When a champion with Catapult is no longer adjacent to this unit, it loses the Catapult ability.",
      "class_name": "DwarvenCatapult",
      "revision": 1
    },
    {
      "asset_id": 4290,
      "resettable": 1,
      "name": "Lockdown",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 689,
      "activated": 1,
      "icon_name": "debuff",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "All units within 5 spaces have <ability value=669>Earthbound</ability>",
      "long_description": "All units within 5 spaces have <ability value=669>Earthbound</ability>",
      "class_name": "RelicWindGenerator",
      "revision": 1
    },
    {
      "asset_id": 4772,
      "resettable": 1,
      "name": "Locust Cloud",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 1500,
      "activated": 1,
      "icon_name": "locust_swarm",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "Area Effect 2, Range 5: Affected champions take 8 Physical damage.  This damage ignores DEF.  For 3 turns, spaces within the affected area are Mini-locust Swarm (Opposing champions within the affected area have -2 DEF).",
      "long_description": "Area Effect 2, Range 5: Affected champions take 8 Physical damage.  This damage ignores DEF.  For 3 turns, spaces within the affected area are Mini-locust Swarm (Opposing champions within the affected area have -2 DEF).",
      "class_name": "Invasion",
      "revision": 1
    },
    {
      "asset_id": 5773,
      "resettable": 0,
      "name": "Logistics: Damage",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3374,
      "activated": 1,
      "icon_name": "special",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +3 DMG permanently.",
      "long_description": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +3 DMG permanently.",
      "class_name": "LogisticsDamage",
      "revision": 1
    },
    {
      "asset_id": 5773,
      "resettable": 1,
      "name": "Logistics: Flanking",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2686,
      "activated": 1,
      "icon_name": "special",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains <ability value=2429>Flanking</ability> permanently.",
      "long_description": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains <ability value=2429>Flanking</ability> permanently.",
      "class_name": "LogisticsFlanking",
      "revision": 1
    },
    {
      "asset_id": 5773,
      "resettable": 1,
      "name": "Logistics: Force Barrier",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2760,
      "activated": 1,
      "icon_name": "special",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains <ability value=400>Force Barrier 3</ability> permanently.",
      "long_description": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains <ability value=400>Force Barrier 3</ability> permanently.",
      "class_name": "LogisticsForceBarrier",
      "revision": 1
    },
    {
      "asset_id": 5773,
      "resettable": 1,
      "name": "Logistics: Heal Champion",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2801,
      "activated": 1,
      "icon_name": "special",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains <ability value=368>Heal Champion 3</ability> permanently.",
      "long_description": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains <ability value=368>Heal Champion 3</ability> permanently.",
      "class_name": "LogisticsHealChampion",
      "revision": 1
    },
    {
      "asset_id": 5773,
      "resettable": 1,
      "name": "Logistics: Life Siphon",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2800,
      "activated": 1,
      "icon_name": "special",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains <ability value=99>Life Siphon</ability> permanently.",
      "long_description": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains <ability value=99>Life Siphon</ability> permanently.",
      "class_name": "LogisticsLifeSiphon",
      "revision": 1
    },
    {
      "asset_id": 5773,
      "resettable": 1,
      "name": "Logistics: Range",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2797,
      "activated": 1,
      "icon_name": "special",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +2 MAX RNG permanently.",
      "long_description": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +2 MAX RNG permanently.",
      "class_name": "LogisticsRange",
      "revision": 1
    },
    {
      "asset_id": 5773,
      "resettable": 1,
      "name": "Logistics: Speed",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2766,
      "activated": 1,
      "icon_name": "special",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
      "long_description": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
      "class_name": "LogisticsSpeed",
      "revision": 1
    },
    {
      "asset_id": 5912,
      "resettable": 0,
      "name": "Long Fuse Bomb",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2946,
      "activated": 1,
      "icon_name": "cannon_barrage",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 5,
      "short_description": "When this relic is destroyed, it deals 15 damage to opposing champions within 5 spaces.This explosion deals -2 damage for every space away from the center of the blast. This relic destroys itself at the end of the turn after coming into play.",
      "long_description": "When this relic is destroyed, it deals 15 damage to opposing champions within 5 spaces.This explosion deals -2 damage for every space away from the center of the blast. This relic destroys itself at the end of the turn after coming into play.",
      "class_name": "LongFuseBomb",
      "revision": 1
    },
    {
      "asset_id": 5063,
      "resettable": 1,
      "name": "Lonx Guardian",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1239,
      "activated": 1,
      "icon_name": "dodge",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "Friendly Lonx champions that are adjacent to this champion may not be the target of ranged attacks.",
      "long_description": "Friendly Lonx champions that are adjacent to this champion may not be the target of ranged attacks.",
      "class_name": "LonxGuardian",
      "revision": 1
    },
    {
      "asset_id": 8002,
      "resettable": 0,
      "name": "Lord of Strigoi",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3399,
      "activated": 1,
      "icon_name": "soul_siphon",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "This champion has <ability value=977>Bleed</ability>. After this champion uses an ability, friendly champions with Race: Vampyre within 3 spaces of this champion gain +2 Max HP and -1 CD on their abilities. This may only trigger once per turn.",
      "long_description": "This champion has <ability value=977>Bleed</ability>. After this champion uses an ability, friendly champions with Race: Vampyre within 3 spaces of this champion gain +2 Max HP and -1 CD on their abilities. This may only trigger once per turn.",
      "class_name": "LordOfStrigoi",
      "revision": 1
    },
    {
      "asset_id": 4743,
      "resettable": 1,
      "name": "Lotus Altar",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1288,
      "activated": 1,
      "icon_name": "defenseenhance",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "Units within 5 spaces of this relic are Shielded.",
      "long_description": "Units within 5 spaces of this relic are Shielded.",
      "class_name": "RelicForglarAltar",
      "revision": 1
    },
    {
      "asset_id": 5159,
      "resettable": 1,
      "name": "Loyalty",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1932,
      "activated": 1,
      "icon_name": "loyalty",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "This champion gains +2 DMG and +5 HP as long as all friendly units that you own share a faction with it.",
      "long_description": "This champion gains +2 DMG and +5 HP as long as all friendly units that you own share a faction with it.",
      "class_name": "Loyalty",
      "revision": 1
    },
    {
      "asset_id": 4004,
      "resettable": 1,
      "name": "Lumbering",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 5,
      "activated": 1,
      "icon_name": "lumbering",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -18,
      "short_description": "This champion's AP cost for each movement is increased by 1.",
      "long_description": "This champion's AP cost for each movement is increased by 1.",
      "class_name": "Lumbering",
      "revision": 1
    },
    {
      "asset_id": 4882,
      "resettable": 1,
      "name": "Magic Acolyte",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1764,
      "activated": 1,
      "icon_name": "acolyte_magic",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "Whenever a champion takes Magic damage, this champion heals 2 HP.  This triggers up to 3 times per turn.\r\n\r\n",
      "long_description": "Whenever a champion takes Magic damage, this champion heals 2 HP.  This triggers up to 3 times per turn.\r\n\r\n",
      "class_name": "MagicAcolyte",
      "revision": 1
    },
    {
      "asset_id": 5679,
      "resettable": 1,
      "name": "Magic Beam",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 2579,
      "activated": 1,
      "icon_name": "magicaoe",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 9,
      "short_description": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this champion take 12 Magic damage (ignores DEF) and has its DEF set to 0 for 1 turn if its DEF is greater than 0.",
      "long_description": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this champion take 12 Magic damage (ignores DEF) and has its DEF set to 0 for 1 turn if its DEF is greater than 0.",
      "class_name": "MagicBeam",
      "revision": 1
    },
    {
      "asset_id": 4990,
      "resettable": 1,
      "name": "Magic Blast",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1873,
      "activated": 1,
      "icon_name": "magicaoe",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this unit makes a basic attack, all opposing champions within 2 spaces of the target take 50% Magic damage.",
      "long_description": "When this unit makes a basic attack, all opposing champions within 2 spaces of the target take 50% Magic damage.",
      "class_name": "MagicBlast",
      "revision": 1
    },
    {
      "asset_id": 4416,
      "resettable": 1,
      "name": "Magic Eater",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 745,
      "activated": 1,
      "icon_name": "eater_magic",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 7,
      "short_description": "When this unit would take Magic damage, it instead recovers HP equal to half the damage that would have been dealt.",
      "long_description": "When this unit would take Magic damage, it instead recovers HP equal to half the damage that would have been dealt.",
      "class_name": "MagicEater",
      "revision": 1
    },
    {
      "asset_id": 5768,
      "resettable": 1,
      "name": "Magic Foci (Not Implemented)",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2749,
      "activated": 1,
      "icon_name": "magicaoe",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 5,
      "short_description": "For every 10 damage friendly units within 6 spaces receive (including this one), the closest opposing champion within 6 spaces of this unit takes 3 Magic damage.",
      "long_description": "For every 10 damage friendly units within 6 spaces receive (including this one), the closest opposing champion within 6 spaces of this unit takes 3 Magic damage.",
      "class_name": "MagicFoci",
      "revision": 1
    },
    {
      "asset_id": 4422,
      "resettable": 1,
      "name": "Magic Nova",
      "ap_cost": 3,
      "level": 1,
      "ability_id": 758,
      "activated": 1,
      "icon_name": "novamagic",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 2,
      "short_description": "This unit deals 3 Magic damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged have -1 DEF for 4 turns.",
      "long_description": "This unit deals 3 Magic damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged have -1 DEF for 4 turns.",
      "class_name": "MagicalNova",
      "revision": 1
    },
    {
      "asset_id": 4422,
      "resettable": 1,
      "name": "Magic Nova",
      "ap_cost": 3,
      "level": 2,
      "ability_id": 759,
      "activated": 1,
      "icon_name": "novamagic",
      "comments": "",
      "prerequisite_id": 758,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 4,
      "short_description": "This unit deals 6 Magic damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged have -1 DEF for 4 turns.",
      "long_description": "This unit deals 6 Magic damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged have -1 DEF for 4 turns.",
      "class_name": "MagicalNova",
      "revision": 1
    },
    {
      "asset_id": 4422,
      "resettable": 1,
      "name": "Magic Nova",
      "ap_cost": 3,
      "level": 3,
      "ability_id": 760,
      "activated": 1,
      "icon_name": "novamagic",
      "comments": "",
      "prerequisite_id": 759,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 6,
      "short_description": "This unit deals 9 Magic damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged have -1 DEF for 4 turns.",
      "long_description": "This unit deals 9 Magic damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged have -1 DEF for 4 turns.",
      "class_name": "MagicalNova",
      "revision": 1
    },
    {
      "asset_id": 4796,
      "resettable": 1,
      "name": "Magic Turret",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 1530,
      "activated": 1,
      "icon_name": "magic",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "This unit makes a Magic attack at RNG 2-7.",
      "long_description": "This unit makes a Magic attack at RNG 2-7.",
      "class_name": "MagicTurret",
      "revision": 1
    },
    {
      "asset_id": 7983,
      "resettable": 0,
      "name": "Magic Ward",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3379,
      "activated": 1,
      "icon_name": "spell_resistance",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -4,
      "short_description": "This champion cannot be the target of friendly spells.",
      "long_description": "This champion cannot be the target of friendly spells.",
      "class_name": "MagicWard",
      "revision": 1
    },
    {
      "asset_id": 4427,
      "resettable": 1,
      "name": "Magical Attack",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 766,
      "activated": 1,
      "icon_name": "magic",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "This unit makes a Magical attack at range 2-4.",
      "long_description": "This unit makes a Magical attack at range 2-4.",
      "class_name": "MagicalAttack",
      "revision": 1
    },
    {
      "asset_id": 4075,
      "resettable": 1,
      "name": "Magical Aura",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 127,
      "activated": 1,
      "icon_name": "novamagic",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 2,
      "short_description": "At the beginning of your opponent's turns, this unit deals 2 Magical damage to each champion within 2 spaces. This damage ignores DEF.",
      "long_description": "At the beginning of your opponent's turns, this unit deals 2 Magical damage to each champion within 2 spaces. This damage ignores DEF.",
      "class_name": "DamagingAuraMagical",
      "revision": 1
    },
    {
      "asset_id": 4075,
      "resettable": 1,
      "name": "Magical Aura",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 128,
      "activated": 1,
      "icon_name": "novamagic",
      "comments": "none",
      "prerequisite_id": 127,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 4,
      "short_description": "At the beginning of your opponent's turns, this unit deals 4 Magical damage to each champion within 2 spaces. This damage ignores DEF.",
      "long_description": "At the beginning of your opponent's turns, this unit deals 4 Magical damage to each champion within 2 spaces. This damage ignores DEF.",
      "class_name": "DamagingAuraMagical",
      "revision": 1
    },
    {
      "asset_id": 4075,
      "resettable": 1,
      "name": "Magical Aura",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 129,
      "activated": 1,
      "icon_name": "novamagic",
      "comments": "none",
      "prerequisite_id": 128,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 6,
      "short_description": "At the beginning of your opponent's turns, this unit deals 6 Magical damage to each champion within 2 spaces. This damage ignores DEF.",
      "long_description": "At the beginning of your opponent's turns, this unit deals 6 Magical damage to each champion within 2 spaces. This damage ignores DEF.",
      "class_name": "DamagingAuraMagical",
      "revision": 1
    },
    {
      "asset_id": 4646,
      "resettable": 1,
      "name": "Magical Bomb",
      "ap_cost": 1,
      "level": 1,
      "ability_id": 1069,
      "activated": 1,
      "icon_name": "magicaoe",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 6,
      "short_description": "Area Effect 2, Range 5: Affected units take Magic damage equal to 50% of this unit's DMG. This damage ignores DEF. Champions successfully damaged have their DEF set to 0 until the end of turn if their DEF is greater than 0.",
      "long_description": "Area Effect 2, Range 5: Affected units take Magic damage equal to 50% of this unit's DMG. This damage ignores DEF. Champions successfully damaged have their DEF set to 0 until the end of turn if their DEF is greater than 0.",
      "class_name": "MagicalBomb",
      "revision": 1
    },
    {
      "asset_id": 4646,
      "resettable": 1,
      "name": "Magical Bomb",
      "ap_cost": 1,
      "level": 2,
      "ability_id": 1070,
      "activated": 1,
      "icon_name": "magicaoe",
      "comments": "",
      "prerequisite_id": 1069,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 8,
      "short_description": "Area Effect 2, Range 5: Affected units take Magic damage equal to 65% of this unit's DMG. This damage ignores DEF. Champions successfully damaged have their DEF set to 0 until the end of turn if their DEF is greater than 0.",
      "long_description": "Area Effect 2, Range 5: Affected units take Magic damage equal to 65% of this unit's DMG. This damage ignores DEF. Champions successfully damaged have their DEF set to 0 until the end of turn if their DEF is greater than 0.",
      "class_name": "MagicalBomb",
      "revision": 1
    },
    {
      "asset_id": 4646,
      "resettable": 1,
      "name": "Magical Bomb",
      "ap_cost": 1,
      "level": 3,
      "ability_id": 1072,
      "activated": 1,
      "icon_name": "magicaoe",
      "comments": "",
      "prerequisite_id": 1070,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 10,
      "short_description": "Area Effect 2, Range 5: Affected units take Magic damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged have their DEF set to 0 until the end of turn if their DEF is greater than 0.",
      "long_description": "Area Effect 2, Range 5: Affected units take Magic damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged have their DEF set to 0 until the end of turn if their DEF is greater than 0.",
      "class_name": "MagicalBomb",
      "revision": 1
    },
    {
      "asset_id": 5494,
      "resettable": 1,
      "name": "Magnate's Blessing",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 2743,
      "activated": 1,
      "icon_name": "majestic",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "Target champion within 4 spaces gains <ability value=608>Majestic 1</ability> for 4 turns. It also gains +1 DMG for 4 turns for every 25 HP on opposing champions within 3 spaces of it, rounded down. This does not stack.",
      "long_description": "Target champion within 4 spaces gains <ability value=608>Majestic 1</ability> for 4 turns. It also gains +1 DMG for 4 turns for every 25 HP on opposing champions within 3 spaces of it, rounded down. This does not stack.",
      "class_name": "Magnate",
      "revision": 1
    },
    {
      "asset_id": 5010,
      "resettable": 1,
      "name": "Magnetic Pulse",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1891,
      "activated": 1,
      "icon_name": "auranegative",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 4,
      "short_description": "Area Effect 5: Equipped enemy champions have -2 DMG and <ability value=2005>Careless</ability>.  Equipped friendly champions have +2 DMG.",
      "long_description": "Area Effect 5: Equipped enemy champions have -2 DMG and <ability value=2005>Careless</ability>.  Equipped friendly champions have +2 DMG.",
      "class_name": "MagneticPulse",
      "revision": 1
    },
    {
      "asset_id": 4235,
      "resettable": 1,
      "name": "Majestic",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 608,
      "activated": 1,
      "icon_name": "majestic",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 9,
      "short_description": "Opposing champions adjacent to this unit are <condition value=awestruck>Awestruck</condition>.",
      "long_description": "Opposing champions adjacent to this unit are <condition value=awestruck>Awestruck</condition>.",
      "class_name": "Majestic",
      "revision": 1
    },
    {
      "asset_id": 4235,
      "resettable": 1,
      "name": "Majestic",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 609,
      "activated": 1,
      "icon_name": "majestic",
      "comments": "",
      "prerequisite_id": 608,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 14,
      "short_description": "Opposing champions within 2 spaces of this unit are <condition value=awestruck>Awestruck</condition>.",
      "long_description": "Opposing champions within 2 spaces of this unit are <condition value=awestruck>Awestruck</condition>.",
      "class_name": "Majestic",
      "revision": 1
    },
    {
      "asset_id": 5280,
      "resettable": 1,
      "name": "Majestic Aura",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 2047,
      "activated": 1,
      "icon_name": "majestic",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 6,
      "short_description": "When this unit comes into play, this unit has <ability value=608>Majestic 1</ability> for 2 turns.",
      "long_description": "When this unit comes into play, this unit has <ability value=608>Majestic 1</ability> for 2 turns.",
      "class_name": "MajesticAura",
      "revision": 1
    },
    {
      "asset_id": 5280,
      "resettable": 1,
      "name": "Majestic Aura",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 2048,
      "activated": 1,
      "icon_name": "majestic",
      "comments": "",
      "prerequisite_id": 2047,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 6,
      "short_description": "When this unit comes into play, this unit has <ability value=608>Majestic 1</ability> for 4 turns.",
      "long_description": "When this unit comes into play, this unit has <ability value=608>Majestic 1</ability> for 4 turns.",
      "class_name": "MajesticAura",
      "revision": 1
    },
    {
      "asset_id": 5280,
      "resettable": 1,
      "name": "Majestic Aura",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 2049,
      "activated": 1,
      "icon_name": "majestic",
      "comments": "",
      "prerequisite_id": 2048,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 6,
      "short_description": "When this unit comes into play, this unit has <ability value=608>Majestic 1</ability> for 6 turns.",
      "long_description": "When this unit comes into play, this unit has <ability value=608>Majestic 1</ability> for 6 turns.",
      "class_name": "MajesticAura",
      "revision": 1
    },
    {
      "asset_id": 5112,
      "resettable": 1,
      "name": "Make Ice",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 1298,
      "activated": 1,
      "icon_name": "special",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 3,
      "short_description": "An Ice Block is summoned to an adjacent space.",
      "long_description": "An Ice Block is summoned to an adjacent space.",
      "class_name": "MakeIce",
      "revision": 1
    },
    {
      "asset_id": 4199,
      "resettable": 1,
      "name": "Mammoth Club",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 958,
      "activated": 1,
      "icon_name": "hammer",
      "comments": "This uses the same class id as Attack - Physical",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "This champion makes a close-combat Physical attack at +6 DMG and +1 AP.",
      "long_description": "This champion makes a close-combat Physical attack at +6 DMG and +1 AP.",
      "class_name": "MammothClubAttack",
      "revision": 1
    },
    {
      "asset_id": 5421,
      "resettable": 1,
      "name": "Manic",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2253,
      "activated": 1,
      "icon_name": "manic",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 15,
      "short_description": "At the end of its turn, if this champion has a MIN RNG of 1, it moves 2 spaces toward the closest enemy champion, and makes an attack against that champion if possible.",
      "long_description": "At the end of its turn, if this champion has a MIN RNG of 1, it moves 2 spaces toward the closest enemy champion, and makes an attack against that champion if possible.",
      "class_name": "Manic",
      "revision": 1
    },
    {
      "asset_id": 5452,
      "resettable": 1,
      "name": "Manifestation",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2304,
      "activated": 1,
      "icon_name": "spirit_proj",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 0,
      "short_description": "At the start of turn and end of each turn, if there are no friendly champions with <ability value=2294>Spirit Projection</ability> within 5 spaces this unit, it is destroyed.",
      "long_description": "At the start of turn and end of each turn, if there are no friendly champions with <ability value=2294>Spirit Projection</ability> within 5 spaces this unit, it is destroyed.",
      "class_name": "Manifestation",
      "revision": 1
    },
    {
      "asset_id": 5369,
      "resettable": 1,
      "name": "Marauder",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2201,
      "activated": 1,
      "icon_name": "marauder",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 30,
      "short_description": "When this champion is deployed, a Level 1 Deep Elf Renegade and a Level 1 Elven Scoundrel are summoned adjacent to it.",
      "long_description": "When this champion is deployed, a Level 1 Deep Elf Renegade and a Level 1 Elven Scoundrel are summoned adjacent to it.",
      "class_name": "Marauder",
      "revision": 1
    },
    {
      "asset_id": 4985,
      "resettable": 1,
      "name": "Mark",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 1867,
      "activated": 1,
      "icon_name": "declare_hunted",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 5,
      "short_description": "This ability does not destealth, and is only usable while stealthed.  Target champion within 3 spaces suffers 2 additional damage from all attacks made by friendly units this turn.",
      "long_description": "This ability does not destealth, and is only usable while stealthed.  Target champion within 3 spaces suffers 2 additional damage from all attacks made by friendly units this turn.",
      "class_name": "Mark",
      "revision": 1
    },
    {
      "asset_id": 7198,
      "resettable": 1,
      "name": "Mark of Al'Mara",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2808,
      "activated": 1,
      "icon_name": "special",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this champion successfully damages a champion with a basic attack, that champion is Branded (When a Paladin, Shaman or Priest makes a basic attack against this champion, the target takes 2 additional fire damage (ignores DEF). This does not stack) for 3 turns.",
      "long_description": "When this champion successfully damages a champion with a basic attack, that champion is Branded (When a Paladin, Shaman or Priest makes a basic attack against this champion, the target takes 2 additional fire damage (ignores DEF). This does not stack) for 3 turns.",
      "class_name": "MarkOfTheCross",
      "revision": 1
    },
    {
      "asset_id": 7196,
      "resettable": 0,
      "name": "Mark of Osarius",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3040,
      "activated": 1,
      "icon_name": "fate_osarius",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 8,
      "short_description": "After this champion has dealt 40 damage, a Head of Osarius relic is summoned to the closest available space to this champion and this ability is removed.",
      "long_description": "After this champion has dealt 40 damage, a Head of Osarius relic is summoned to the closest available space to this champion and this ability is removed.",
      "class_name": "MarkOfOsarius",
      "revision": 1
    },
    {
      "asset_id": 4776,
      "resettable": 1,
      "name": "Market",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1510,
      "activated": 1,
      "icon_name": "cost",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "Relics and equipment you deploy receive a 10% nora refund. This effect does not stack.",
      "long_description": "Relics and equipment you deploy receive a 10% nora refund. This effect does not stack.",
      "class_name": "Market",
      "revision": 1
    },
    {
      "asset_id": 5737,
      "resettable": 1,
      "name": "Marsh Awakening",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2624,
      "activated": 1,
      "icon_name": "aquatic",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "This champion has +1 DMG, +1 DEF and +1 SPD for every 2 opposing champions occupying water.",
      "long_description": "This champion has +1 DMG, +1 DEF and +1 SPD for every 2 opposing champions occupying water.",
      "class_name": "MarshAwakening",
      "revision": 1
    },
    {
      "asset_id": 7137,
      "resettable": 0,
      "name": "Marsh Gas",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2979,
      "activated": 1,
      "icon_name": "poisonaoe",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "This unit loses 5 HP.  Until end of turn, all Poison damage is treated as Fire damage instead.",
      "long_description": "This unit loses 5 HP.  Until end of turn, all Poison damage is treated as Fire damage instead.",
      "class_name": "MarshGas",
      "revision": 1
    },
    {
      "asset_id": 4927,
      "resettable": 1,
      "name": "Marsh Lesson",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 1809,
      "activated": 1,
      "icon_name": "semiaquatic",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "Target friendly champion within 3 spaces loses <ability value=114>Aquatic</ability> and gains <ability value=859>Semi Aquatic</ability>. This ability cost 8 nora.",
      "long_description": "Target friendly champion within 3 spaces loses <ability value=114>Aquatic</ability> and gains <ability value=859>Semi Aquatic</ability>. This ability cost 8 nora.",
      "class_name": "MarshLesson",
      "revision": 1
    },
    {
      "asset_id": 4809,
      "resettable": 1,
      "name": "Marsh Singer",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 1579,
      "activated": 1,
      "icon_name": "noragen",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 6,
      "short_description": "At the beginning of your turn, you gain 1 nora.",
      "long_description": "At the beginning of your turn, you gain 1 nora.",
      "class_name": "MarshSinger",
      "revision": 1
    },
    {
      "asset_id": 4809,
      "resettable": 1,
      "name": "Marsh Singer",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 1580,
      "activated": 1,
      "icon_name": "noragen",
      "comments": "",
      "prerequisite_id": 1579,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 6,
      "short_description": "At the beginning of your turn, you gain 2 nora.",
      "long_description": "At the beginning of your turn, you gain 2 nora.",
      "class_name": "MarshSinger",
      "revision": 1
    },
    {
      "asset_id": 4809,
      "resettable": 1,
      "name": "Marsh Singer",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 1581,
      "activated": 1,
      "icon_name": "noragen",
      "comments": "",
      "prerequisite_id": 1580,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 6,
      "short_description": "At the beginning of your turn, you gain 6 nora.",
      "long_description": "At the beginning of your turn, you gain 6 nora.",
      "class_name": "MarshSinger",
      "revision": 1
    },
    {
      "asset_id": 5684,
      "resettable": 1,
      "name": "Martyrdom",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2557,
      "activated": 1,
      "icon_name": "intensify",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 6,
      "short_description": "When a real friendly champion is destroyed, this unit is healed for 8 HP. If this unit shares a race with the destroyed unit, also gain +1 DMG.",
      "long_description": "When a real friendly champion is destroyed, this unit is healed for 8 HP. If this unit shares a race with the destroyed unit, also gain +1 DMG.",
      "class_name": "Martyrdom",
      "revision": 1
    },
    {
      "asset_id": 7128,
      "resettable": 0,
      "name": "Masochist",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2942,
      "activated": 1,
      "icon_name": "drive",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 5,
      "short_description": "Whenever this champion is successfully attacked, it regenerates 2 health ",
      "long_description": "Whenever this champion is successfully attacked, it regenerates 2 health ",
      "class_name": "Masochist",
      "revision": 1
    },
    {
      "asset_id": 4225,
      "resettable": 1,
      "name": "Mason",
      "ap_cost": 3,
      "level": 1,
      "ability_id": 596,
      "activated": 1,
      "icon_name": "shrinegood",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 1,
      "cost": 4,
      "short_description": "Target friendly Relic, Shrine or champion with Race: Construct within 5 spaces heals 4 HP. ",
      "long_description": "Target friendly Relic, Shrine or champion with Race: Construct within 5 spaces heals 4 HP. ",
      "class_name": "Mason",
      "revision": 1
    },
    {
      "asset_id": 4225,
      "resettable": 1,
      "name": "Mason",
      "ap_cost": 3,
      "level": 2,
      "ability_id": 624,
      "activated": 1,
      "icon_name": "shrinegood",
      "comments": "",
      "prerequisite_id": 596,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 1,
      "cost": 6,
      "short_description": "Target friendly Relic, Shrine or champion with Race: Construct within 5 spaces heals 8 HP. ",
      "long_description": "Target friendly Relic, Shrine or champion with Race: Construct within 5 spaces heals 8 HP. ",
      "class_name": "Mason",
      "revision": 1
    },
    {
      "asset_id": 4225,
      "resettable": 1,
      "name": "Mason",
      "ap_cost": 3,
      "level": 3,
      "ability_id": 625,
      "activated": 1,
      "icon_name": "shrinegood",
      "comments": "",
      "prerequisite_id": 624,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 8,
      "short_description": "Target friendly Relic, Shrine or champion with Race: Construct within 5 spaces heals 12 HP. ",
      "long_description": "Target friendly Relic, Shrine or champion with Race: Construct within 5 spaces heals 12 HP. ",
      "class_name": "Mason",
      "revision": 1
    },
    {
      "asset_id": 5238,
      "resettable": 1,
      "name": "Mason's Spire",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 2018,
      "activated": 1,
      "icon_name": "defenseenhance",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 12,
      "short_description": "Friendly relics within 8 spaces have +10 MAX HP.",
      "long_description": "Friendly relics within 8 spaces have +10 MAX HP.",
      "class_name": "RelicMasonsSpire",
      "revision": 1
    },
    {
      "asset_id": 5238,
      "resettable": 0,
      "name": "Mason's Spire",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 3165,
      "activated": 1,
      "icon_name": "defenseenhance",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "Friendly relics within 5 spaces have +10 MAX HP.",
      "long_description": "Friendly relics within 5 spaces have +10 MAX HP.",
      "class_name": "RelicMasonsSpire",
      "revision": 1
    },
    {
      "asset_id": 7600,
      "resettable": 0,
      "name": "Mass Teleport",
      "ap_cost": 5,
      "level": 0,
      "ability_id": 3228,
      "activated": 1,
      "icon_name": "relocate",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 12,
      "short_description": "This champion is relocated to target space within 5 spaces. Friendly champions within 2 spaces are also relocated (distributed within the AE).",
      "long_description": "This champion is relocated to target space within 5 spaces. Friendly champions within 2 spaces are also relocated (distributed within the AE).",
      "class_name": "MassTeleport",
      "revision": 1
    },
    {
      "asset_id": 4983,
      "resettable": 1,
      "name": "Master Climber",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1865,
      "activated": 1,
      "icon_name": "buff",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 4,
      "short_description": "This champion gains +1 DEF and +1 DMG for 2 turns every time it changes elevation.",
      "long_description": "This champion gains +1 DEF and +1 DMG for 2 turns every time it changes elevation.",
      "class_name": "MasterClimber",
      "revision": 1
    },
    {
      "asset_id": 8013,
      "resettable": 0,
      "name": "Master Reconstructor",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3410,
      "activated": 1,
      "icon_name": "stitched",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 12,
      "short_description": "This champion has <ability value=2101>Stitched</ability>, <ability value=2104>Reconstruct: Blackguard</ability>, <ability value=2106>Reconstruct: Dreameater</ability> and <ability value=2105>Reconstruct: Magician</ability>.",
      "long_description": "This champion has <ability value=2101>Stitched</ability>, <ability value=2104>Reconstruct: Blackguard</ability>, <ability value=2106>Reconstruct: Dreameater</ability> and <ability value=2105>Reconstruct: Magician</ability>.",
      "class_name": "StitchedFirst",
      "revision": 1
    },
    {
      "asset_id": 5794,
      "resettable": 1,
      "name": "Mastermind",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2794,
      "activated": 1,
      "icon_name": "surge",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "At the end of its turn, this champion has +1 SPD and <ability value=2479>Improve Speed</ability> for 3 turns if you have 35 or less nora.",
      "long_description": "At the end of its turn, this champion has +1 SPD and <ability value=2479>Improve Speed</ability> for 3 turns if you have 35 or less nora.",
      "class_name": "Mastermind",
      "revision": 1
    },
    {
      "asset_id": 7323,
      "resettable": 0,
      "name": "Maxxarek's Servant",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3099,
      "activated": 1,
      "icon_name": "relocate",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 10,
      "short_description": "When this champion is deployed, the closest friendly champion gains <ability value=741>Relocate: Demon</ability>. Friendly Archdemons besides Maxxarek gain <ability value=2536>Bestow</ability> and <ability value=2753>Noble Sacrifice</ability>.",
      "long_description": "When this champion is deployed, the closest friendly champion gains <ability value=741>Relocate: Demon</ability>. Friendly Archdemons besides Maxxarek gain <ability value=2536>Bestow</ability> and <ability value=2753>Noble Sacrifice</ability>.",
      "class_name": "MaxxareksServant",
      "revision": 1
    },
    {
      "asset_id": 4608,
      "resettable": 1,
      "name": "Mead Trap",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1024,
      "activated": 1,
      "icon_name": "trapmead",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "When an enemy unit moves within 2 spaces of the trap, all enemy non-dwarf champions within 3 spaces become Intoxicated 5 (This champion's DEF and DMG reduced by 40%.)",
      "long_description": "When an enemy unit moves within 2 spaces of the trap, all enemy non-dwarf champions within 3 spaces become Intoxicated 5 (This champion's DEF and DMG reduced by 40%.)",
      "class_name": "RelicMeadTrap",
      "revision": 1
    },
    {
      "asset_id": 5064,
      "resettable": 1,
      "name": "Meddle",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1240,
      "activated": 1,
      "icon_name": "soul_bond",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 2,
      "short_description": "Target enemy champion within 4 spaces has its base ATK and base DEF swapped for the next 4 turns. This ability shares a cooldown with Fiddle and Tamper.",
      "long_description": "Target enemy champion within 4 spaces has its base ATK and base DEF swapped for the next 4 turns. This ability shares a cooldown with Fiddle and Tamper.",
      "class_name": "Meddle",
      "revision": 1
    },
    {
      "asset_id": 7482,
      "resettable": 0,
      "name": "Megalith Guardians",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3168,
      "activated": 1,
      "icon_name": "megalith_guardian",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 30,
      "short_description": "When this champion is deployed from the runedock, 2 Megalith Guardians are summoned in adjacent squares. At the beginning of each turn, for each Megalith Guardian within 5 spaces, this champion has +1 DMG, +1 MAX RNG and +1 DEF. This stacks up to 2 times.",
      "long_description": "When this champion is deployed from the runedock, 2 Megalith Guardians are summoned in adjacent squares. At the beginning of each turn, for each Megalith Guardian within 5 spaces, this champion has +1 DMG, +1 MAX RNG and +1 DEF. This stacks up to 2 times.",
      "class_name": "MegalithGuardians",
      "revision": 1
    },
    {
      "asset_id": 5286,
      "resettable": 1,
      "name": "Meld: Stitched Magearm",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2109,
      "activated": 1,
      "icon_name": "meld",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "The Stitched Mesmer, Magician and Shaman combine into a Stitched Magearm with full HP. To use this ability, you must have each of those units together in a formation that makes up the base of a large unit, with one empty space.",
      "long_description": "The Stitched Mesmer, Magician and Shaman combine into a Stitched Magearm with full HP. To use this ability, you must have each of those units together in a formation that makes up the base of a large unit, with one empty space.",
      "class_name": "MeldStitchedMagearm",
      "revision": 1
    },
    {
      "asset_id": 5285,
      "resettable": 1,
      "name": "Meld: Stitched Merged",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2108,
      "activated": 1,
      "icon_name": "meld",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "The Stitched Hexer, Blackguard and Dreameater combine into a Stitched Merged with full HP. To use this ability, you must have each of those units together in a formation that makes up the base of a large unit, with one empty space.",
      "long_description": "The Stitched Hexer, Blackguard and Dreameater combine into a Stitched Merged with full HP. To use this ability, you must have each of those units together in a formation that makes up the base of a large unit, with one empty space.",
      "class_name": "MeldStitchedMerged",
      "revision": 1
    },
    {
      "asset_id": 4123,
      "resettable": 1,
      "name": "Melee Specialist",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 315,
      "activated": 1,
      "icon_name": "whirl",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 2,
      "short_description": "While this champion is within 3 spaces of at least 2 enemy champions it gets +2 DMG.",
      "long_description": "While this champion is within 3 spaces of at least 2 enemy champions it gets +2 DMG.",
      "class_name": "MeleeSpecialist",
      "revision": 1
    },
    {
      "asset_id": 4123,
      "resettable": 1,
      "name": "Melee Specialist",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 316,
      "activated": 1,
      "icon_name": "whirl",
      "comments": "none",
      "prerequisite_id": 315,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 4,
      "short_description": "While this champion is within 3 spaces of at least 2 enemy champions it gets +1 DEF and +3 DMG.",
      "long_description": "While this champion is within 3 spaces of at least 2 enemy champions it gets +1 DEF and +3 DMG.",
      "class_name": "MeleeSpecialist",
      "revision": 1
    },
    {
      "asset_id": 4123,
      "resettable": 1,
      "name": "Melee Specialist",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 317,
      "activated": 1,
      "icon_name": "whirl",
      "comments": "none",
      "prerequisite_id": 316,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 7,
      "short_description": "While this champion is within 3 spaces of at least 2 enemy champions it gets +2 DEF and +4 DMG.",
      "long_description": "While this champion is within 3 spaces of at least 2 enemy champions it gets +2 DEF and +4 DMG.",
      "class_name": "MeleeSpecialist",
      "revision": 1
    },
    {
      "asset_id": 4573,
      "resettable": 1,
      "name": "Melt",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 997,
      "activated": 1,
      "icon_name": "melt",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 7,
      "short_description": "All snow, ice or water terrain with 6 spaces become dirt for 6 turns. <ability value=600>Arctic</ability>, <ability value=2>Amphibious</ability> and <ability value=114>Aquatic</ability> units within 6 spaces take 7 damage.",
      "long_description": "All snow, ice or water terrain with 6 spaces become dirt for 6 turns. <ability value=600>Arctic</ability>, <ability value=2>Amphibious</ability> and <ability value=114>Aquatic</ability> units within 6 spaces take 7 damage.",
      "class_name": "Melt",
      "revision": 1
    },
    {
      "asset_id": 5470,
      "resettable": 1,
      "name": "Mend Vessel",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2328,
      "activated": 1,
      "icon_name": "recharge",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Spend 8 Charges.  Target friendly champion within 4 spaces heals 25% of its max HP.  May target self.\r\n\r\n",
      "long_description": "Spend 8 Charges.  Target friendly champion within 4 spaces heals 25% of its max HP.  May target self.\r\n",
      "class_name": "MendVessel",
      "revision": 1
    },
    {
      "asset_id": 5225,
      "resettable": 1,
      "name": "Mercenary",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2003,
      "activated": 1,
      "icon_name": "cost",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -12,
      "short_description": "At the beginning of your turns you lose 2 nora.",
      "long_description": "At the beginning of your turns you lose 2 nora.",
      "class_name": "Mercenary",
      "revision": 1
    },
    {
      "asset_id": 5306,
      "resettable": 1,
      "name": "Merciful",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2128,
      "activated": 1,
      "icon_name": "merciful",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": -3,
      "short_description": "If a champion would be destroyed by this champion, it's HP is set to 1 instead.",
      "long_description": "If a champion would be destroyed by this champion, it's HP is set to 1 instead.",
      "class_name": "Merciful",
      "revision": 1
    },
    {
      "asset_id": 5294,
      "resettable": 1,
      "name": "Metamorphosis",
      "ap_cost": 5,
      "level": 0,
      "ability_id": 2117,
      "activated": 1,
      "icon_name": "transform",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "Target champion within 3 spaces is <mechanic value=cleansed>Cleansed</mechanic> and becomes a Snail with 5 SPD, 7 DMG, 1 RNG, 1 DEF, loses all of its base and upgraded abilities, and gains <ability value=545>Attack: Physical</ability> for 4 turns. If the target is a large champion, it becomes a Giant Toad instead.",
      "long_description": "Target champion within 3 spaces is <mechanic value=cleansed>Cleansed</mechanic> and becomes a Snail with 5 SPD, 7 DMG, 1 RNG, 1 DEF, loses all of its base and upgraded abilities, and gains <ability value=545>Attack: Physical</ability> for 4 turns. If the target is a large champion, it becomes a Giant Toad instead.",
      "class_name": "Metamorphosis",
      "revision": 1
    },
    {
      "asset_id": 7812,
      "resettable": 0,
      "name": "Mika's Healing Aria",
      "ap_cost": 3,
      "level": 2,
      "ability_id": 3326,
      "activated": 1,
      "icon_name": "healmass",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "Friendly champions, including this one, within 3 spaces heal 6 HP.",
      "long_description": "Friendly champions, including this one, within 3 spaces heal 6 HP.",
      "class_name": "HealingMass",
      "revision": 1
    },
    {
      "asset_id": 4958,
      "resettable": 1,
      "name": "Mimic Attack",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1817,
      "activated": 1,
      "icon_name": "mimic_damage",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "This unit's ATK is equal to the base attack of the champion with the highest base ATK in play.  If there are no other champion's in play this unit's ATK is 0. ",
      "long_description": "This unit's ATK is equal to the base attack of the champion with the highest base ATK in play.  If there are no other champion's in play this unit's ATK is 0. ",
      "class_name": "MimicAttack",
      "revision": 1
    },
    {
      "asset_id": 4883,
      "resettable": 1,
      "name": "Mimic Damage",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1765,
      "activated": 1,
      "icon_name": "mimic_defense",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 16,
      "short_description": "This unit's DMG is equal to the base DMG of the champion with the highest base DMG in play. This does not include Avatars. If there are no other champions in play, this unit's DMG is 0.\n",
      "long_description": "This unit's DMG is equal to the base DMG of the champion with the highest base DMG in play. This does not include Avatars. If there are no other champions in play, this unit's DMG is 0.\n",
      "class_name": "MimicDamage",
      "revision": 1
    },
    {
      "asset_id": 4959,
      "resettable": 1,
      "name": "Mimic Defense",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1816,
      "activated": 1,
      "icon_name": "mimic_defense",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "This unit's DEF is equal to the base DEF of the champion with the highest base DEF in play. This does not include Avatars.  If there are no other champions in play this unit's DEF is 0. ",
      "long_description": "This unit's DEF is equal to the base DEF of the champion with the highest base DEF in play. This does not include Avatars.  If there are no other champions in play this unit's DEF is 0. ",
      "class_name": "MimicDefense",
      "revision": 1
    },
    {
      "asset_id": 5411,
      "resettable": 1,
      "name": "Mind Control",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 2242,
      "activated": 1,
      "icon_name": "mind_control",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 60,
      "short_description": "This unit is removed from play, and the target champion owned by an opponent becomes Dominated (This unit is <condition value=possessed>Possessed</condition> and loses 8 HP at the beginning of each turns) and <condition value=defiled>Defiled</condition>.\r\n\r\n",
      "long_description": "This unit is removed from play, and the target champion owned by an opponent becomes Dominated (This unit is <condition value=possessed>Possessed</condition> and loses 8 HP at the beginning of each turns) and <condition value=defiled>Defiled</condition>.\r\n\r\n",
      "class_name": "MindControl",
      "revision": 1
    },
    {
      "asset_id": 7706,
      "resettable": 0,
      "name": "Mind Lock",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 3261,
      "activated": 1,
      "icon_name": "mind_lock",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 5,
      "short_description": "Target enemy champion within 5 spaces has a random activated ability (excluding basic attacks) gain +2 CD. This champion gains a copy that ability for 5 turns.",
      "long_description": "Target enemy champion within 5 spaces has a random activated ability (excluding basic attacks) gain +2 CD. This champion gains a copy that ability for 5 turns.",
      "class_name": "MindLock",
      "revision": 1
    },
    {
      "asset_id": 4300,
      "resettable": 1,
      "name": "Mind Maze",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 702,
      "activated": 1,
      "icon_name": "mind_control",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 1,
      "short_description": "Whenever a player casts a spell, 3 of their revealed non-champion runes have their cooldown increased by 4.",
      "long_description": "Whenever a player casts a spell, 3 of their revealed non-champion runes have their cooldown increased by 4.",
      "class_name": "RelicSlowMindTotem",
      "revision": 1
    },
    {
      "asset_id": 7171,
      "resettable": 0,
      "name": "Mind Meld",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3014,
      "activated": 1,
      "icon_name": "mind_meld",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "This champion has +1 DMG for each friendly real champion with <ability value=547>Attack: Psychic</ability> or that shares a race with this one.  Those champions gain 25% of the DMG bonus if they do not have Mind Meld.  This effect is rounded down and does not stack.",
      "long_description": "This champion has +1 DMG for each friendly real champion with <ability value=547>Attack: Psychic</ability> or that shares a race with this one.  Those champions gain 25% of the DMG bonus if they do not have Mind Meld.  This effect is rounded down and does not stack.",
      "class_name": "MindMeld",
      "revision": 1
    },
    {
      "asset_id": 7579,
      "resettable": 0,
      "name": "Mind Siphon",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3220,
      "activated": 1,
      "icon_name": "mindsiphon",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "When this champion is attacked by a basic attack, it gains the upgraded abilities of the attacking champion for 4 turns.",
      "long_description": "When this champion is attacked by a basic attack, it gains the upgraded abilities of the attacking champion for 4 turns.",
      "class_name": "MindSiphon",
      "revision": 1
    },
    {
      "asset_id": 5825,
      "resettable": 1,
      "name": "Mindflayer Jumper",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2834,
      "activated": 1,
      "icon_name": "ignore_invite",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this champion is destroyed, if it is equipped with a Mindflayer, the closest friendly unequipped champion is equipped with a Mindflayer. This will only jump from the original champion one time.\r\n",
      "long_description": "When this champion is destroyed, if it is equipped with a Mindflayer, the closest friendly unequipped champion is equipped with a Mindflayer. This will only jump from the original champion one time.\r\n",
      "class_name": "MindflayerJumper",
      "revision": 1
    },
    {
      "asset_id": 4523,
      "resettable": 1,
      "name": "Mindslice",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 922,
      "activated": 1,
      "icon_name": "mindslice",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "While this unit is in play, all attacks and attack abilities with a range of 4 or greater cost +1 AP, and all champions gain <ability value=1603>Reflection 2</ability>.",
      "long_description": "While this unit is in play, all attacks and attack abilities with a range of 4 or greater cost +1 AP, and all champions gain <ability value=1603>Reflection 2</ability>.",
      "class_name": "RelicObeliskOfTheMindslicer",
      "revision": 1
    },
    {
      "asset_id": 4502,
      "resettable": 1,
      "name": "Mindwipe Aura",
      "ap_cost": 3,
      "level": 1,
      "ability_id": 896,
      "activated": 1,
      "icon_name": "mind_control",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 1,
      "cost": 4,
      "short_description": "All opposing champions within 2 spaces of this unit becomes <condition value=pacified>Pacified</condition> for 2 turns.",
      "long_description": "All opposing champions within 2 spaces of this unit becomes <condition value=pacified>Pacified</condition> for 2 turns.",
      "class_name": "MindwipeAura",
      "revision": 1
    },
    {
      "asset_id": 4502,
      "resettable": 1,
      "name": "Mindwipe Aura",
      "ap_cost": 3,
      "level": 2,
      "ability_id": 897,
      "activated": 1,
      "icon_name": "mind_control",
      "comments": "",
      "prerequisite_id": 896,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 1,
      "cost": 8,
      "short_description": "All opposing champions within 3 spaces of this unit becomes <condition value=pacified>Pacified</condition> for 2 turns.",
      "long_description": "All opposing champions within 3 spaces of this unit becomes <condition value=pacified>Pacified</condition> for 2 turns.",
      "class_name": "MindwipeAura",
      "revision": 1
    },
    {
      "asset_id": 5373,
      "resettable": 1,
      "name": "Mine",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2205,
      "activated": 1,
      "icon_name": "domain_rock",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "Friendly small champions adjacent to this relic gain Use Mine (This champion is relocated to a space adjacent to friendly Mine).",
      "long_description": "Friendly small champions adjacent to this relic gain Use Mine (This champion is relocated to a space adjacent to friendly Mine).",
      "class_name": "Mine",
      "revision": 1
    },
    {
      "asset_id": 5086,
      "resettable": 1,
      "name": "Minion",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1423,
      "activated": 1,
      "icon_name": "sumimp",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 2,
      "short_description": "This champion is a minion!",
      "long_description": "This champion is a minion!",
      "class_name": "Minion",
      "revision": 1
    },
    {
      "asset_id": 5872,
      "resettable": 1,
      "name": "Mirefolk Fealty",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2881,
      "activated": 1,
      "icon_name": "mirefolk_revival",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "When this champion is deployed, friendly champions gain <ability value=1783>Subsume</ability> for 4 turns.  If the affected champion is a Mirefolk, it also gains <ability value=399>Force Barrier 2</ability> for 4 turns.\n",
      "long_description": "When this champion is deployed, friendly champions gain <ability value=1783>Subsume</ability> for 4 turns.  If the affected champion is a Mirefolk, it also gains <ability value=399>Force Barrier 2</ability> for 4 turns.\n",
      "class_name": "MirefolkFealty",
      "revision": 1
    },
    {
      "asset_id": 5769,
      "resettable": 1,
      "name": "Mirefolk Resurgence",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2593,
      "activated": 1,
      "icon_name": "mirefolk_revival",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 8,
      "short_description": "When this unit is deployed, friendly champions gain 1 AP. If the affected champion is a Mirefolk, it also gains +2 DMG for 3 turns.",
      "long_description": "When this unit is deployed, friendly champions gain 1 AP. If the affected champion is a Mirefolk, it also gains +2 DMG for 3 turns.",
      "class_name": "MirefolkResurgence",
      "revision": 1
    },
    {
      "asset_id": 5769,
      "resettable": 1,
      "name": "Mirefolk Revival",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2592,
      "activated": 1,
      "icon_name": "mirefolk_revival",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 8,
      "short_description": "When this unit is deployed, friendly champions are healed for 6 HP.   If the affected champion is a Mirefolk, it also gains <ability value=1052>Purified</ability> for 5 turns.",
      "long_description": "When this unit is deployed, friendly champions are healed for 6 HP.   If the affected champion is a Mirefolk, it also gains <ability value=1052>Purified</ability> for 5 turns.",
      "class_name": "MirefolkRevival",
      "revision": 1
    },
    {
      "asset_id": 5769,
      "resettable": 1,
      "name": "Mirefolk Transcendence",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2681,
      "activated": 1,
      "icon_name": "mirefolk_revival",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this champion is deployed, friendly champions gain <ability value=544>Attack: Magical</ability> for 3 turns. If the affected champion is a Mirefolk, opposing champions within 3 spaces of it take 3 Magical damage. This damage ignores DEF.",
      "long_description": "When this champion is deployed, friendly champions gain <ability value=544>Attack: Magical</ability> for 3 turns. If the affected champion is a Mirefolk, opposing champions within 3 spaces of it take 3 Magical damage. This damage ignores DEF.",
      "class_name": "MirefolkTranscendence",
      "revision": 1
    },
    {
      "asset_id": 7190,
      "resettable": 0,
      "name": "Mirror Swap",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 3034,
      "activated": 1,
      "icon_name": "swarm",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 5,
      "short_description": "This champion is relocated in place of the closest friendly illusion of itself within 5 spaces.",
      "long_description": "This champion is relocated in place of the closest friendly illusion of itself within 5 spaces.",
      "class_name": "MirrorSwap",
      "revision": 1
    },
    {
      "asset_id": 7189,
      "resettable": 0,
      "name": "Mirrorblade",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3033,
      "activated": 1,
      "icon_name": "swarm",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "When this champion makes a successful basic attack, two illusion copies of itself are summoned randomly within 4 spaces of the target.",
      "long_description": "When this champion makes a successful basic attack, two illusion copies of itself are summoned randomly within 4 spaces of the target.",
      "class_name": "Mirrorblade",
      "revision": 1
    },
    {
      "asset_id": 5377,
      "resettable": 1,
      "name": "Mirrored",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2209,
      "activated": 1,
      "icon_name": "mirrored",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 12,
      "short_description": "When this champion would take non-Physical damage from an attack, that damage is reduced by 50% (rounded down), and the attacking champion takes an equal amount of damage of the same type.",
      "long_description": "When this champion would take non-Physical damage from an attack, that damage is reduced by 50% (rounded down), and the attacking champion takes an equal amount of damage of the same type.",
      "class_name": "Mirrored",
      "revision": 1
    },
    {
      "asset_id": 5625,
      "resettable": 1,
      "name": "Mischief",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2489,
      "activated": 1,
      "icon_name": "nemesis_x",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 2,
      "short_description": "Target opposing champion within 5 spaces loses 1 AP. Friendly Imps within 5 spaces of the target each gain AP equal to the amount lost. Using this ability does not cause the unit to lose <condition value=stealthed>Stealthed</condition>.",
      "long_description": "Target opposing champion within 5 spaces loses 1 AP. Friendly Imps within 5 spaces of the target each gain AP equal to the amount lost. Using this ability does not cause the unit to lose <condition value=stealthed>Stealthed</condition>.",
      "class_name": "Mischief",
      "revision": 1
    },
    {
      "asset_id": 5720,
      "resettable": 1,
      "name": "Misfire",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2602,
      "activated": 1,
      "icon_name": "gun",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 7,
      "short_description": "At the beginning of each turn, a random opposing champion within 5 spaces takes 5 Physical damage.  This damage ignores DEF.",
      "long_description": "At the beginning of each turn, a random opposing champion within 5 spaces takes 5 Physical damage.  This damage ignores DEF.",
      "class_name": "Misfire",
      "revision": 1
    },
    {
      "asset_id": 7521,
      "resettable": 0,
      "name": "Misleading Signage",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3188,
      "activated": 1,
      "icon_name": "misleading_signage",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 20,
      "short_description": "At the end of this unit's turns, a random champion within 5 spaces without Wandering gains <ability value=2266>Wandering</ability>  and <ability value=1303>Gain Control</ability>for 3 turns.",
      "long_description": "At the end of this unit's turns, a random champion within 5 spaces without Wandering gains <ability value=2266>Wandering</ability>  and <ability value=1303>Gain Control</ability>for 3 turns.",
      "class_name": "MisleadingSignage",
      "revision": 1
    },
    {
      "asset_id": 4005,
      "resettable": 1,
      "name": "Mobility",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 6,
      "activated": 1,
      "icon_name": "mobility",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "This champion may disengage the turn it becomes <condition value=engaged>Engaged</condition>, and disengages for 0 AP.",
      "long_description": "This champion may disengage the turn it becomes <condition value=engaged>Engaged</condition>, and disengages for 0 AP.",
      "class_name": "Mobility",
      "revision": 1
    },
    {
      "asset_id": 5441,
      "resettable": 1,
      "name": "Mobilize Engine",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2293,
      "activated": 1,
      "icon_name": "mobilize_engine",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "This ability costs 15 nora to use.  This champion's speed is set to 7 for 1 turn, and it gains 9 AP.  This champion loses all AP at the end of this turn.  This ability comes into play on cooldown.",
      "long_description": "This ability costs 15 nora to use.  This champion's speed is set to 7 for 1 turn, and it gains 9 AP.  This champion loses all AP at the end of this turn.  This ability comes into play on cooldown.",
      "class_name": "MobilizeEngine",
      "revision": 1
    },
    {
      "asset_id": 5923,
      "resettable": 0,
      "name": "Mocking Blow",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2956,
      "activated": 1,
      "icon_name": "soul_bond",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 6,
      "short_description": "When a champion makes an unsuccessful basic attack against this unit, this unit attacks the attacker with that ability",
      "long_description": "When a champion makes an unsuccessful basic attack against this unit, this unit attacks the attacker with that ability",
      "class_name": "MockingBlow",
      "revision": 1
    },
    {
      "asset_id": 0,
      "resettable": 1,
      "name": "Moga Axeman",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 707,
      "activated": 1,
      "icon_name": "summoga",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "This unit is the Axeman from a Moga Assault Team.",
      "long_description": "This unit is the Axeman from a Moga Assault Team.",
      "class_name": "MogaAssaultAxe",
      "revision": 1
    },
    {
      "asset_id": 0,
      "resettable": 1,
      "name": "Moga Crossbowman",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 709,
      "activated": 1,
      "icon_name": "summoga",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "This unit is the Crossbowman from a Moga Assault Team.",
      "long_description": "This unit is the Crossbowman from a Moga Assault Team.",
      "class_name": "MogaAssaultCrossbow",
      "revision": 1
    },
    {
      "asset_id": 666,
      "resettable": 1,
      "name": "Moga Den",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 704,
      "activated": 1,
      "icon_name": "summoga",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 0,
      "short_description": "At the start of every fourth turn, Moga Den spawns a Moga Pup on an adjacent space for 5 Nora.",
      "long_description": "At the start of every fourth turn, Moga Den spawns a Moga Pup on an adjacent space for 5 Nora.",
      "class_name": "RelicMogaDen",
      "revision": 1
    },
    {
      "asset_id": 4462,
      "resettable": 1,
      "name": "Moga Riders",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 815,
      "activated": 1,
      "icon_name": "rider",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 25,
      "short_description": "When this unit is destroyed, no nora globe is dropped and a Moga Trapper and a Moga Netter are with no upgrades are spawned in its place at 1/3 of their maximum health.",
      "long_description": "When this unit is destroyed, no nora globe is dropped and a Moga Trapper and a Moga Netter are with no upgrades are spawned in its place at 1/3 of their maximum health.",
      "class_name": "MogaRiders",
      "revision": 1
    },
    {
      "asset_id": 0,
      "resettable": 1,
      "name": "Moga Shieldman",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 708,
      "activated": 1,
      "icon_name": "summoga",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "This unit is the Shieldman from a Moga Assault Team.",
      "long_description": "This unit is the Shieldman from a Moga Assault Team.",
      "class_name": "MogaAssaultShield",
      "revision": 1
    },
    {
      "asset_id": 4815,
      "resettable": 1,
      "name": "Momentum",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 1642,
      "activated": 1,
      "icon_name": "initiative",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 6,
      "activation_type": 1,
      "ranked": 1,
      "cost": 2,
      "short_description": "Friendly champions within 2 spaces gain 1 AP.",
      "long_description": "Friendly champions within 2 spaces gain 1 AP.",
      "class_name": "Momentum",
      "revision": 1
    },
    {
      "asset_id": 4815,
      "resettable": 1,
      "name": "Momentum",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 1643,
      "activated": 1,
      "icon_name": "initiative",
      "comments": "",
      "prerequisite_id": 1642,
      "cooldown": 6,
      "activation_type": 1,
      "ranked": 1,
      "cost": 4,
      "short_description": "Friendly champions within 2 spaces gain 2 AP.",
      "long_description": "Friendly champions within 2 spaces gain 2 AP.",
      "class_name": "Momentum",
      "revision": 1
    },
    {
      "asset_id": 4815,
      "resettable": 1,
      "name": "Momentum",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 1644,
      "activated": 1,
      "icon_name": "initiative",
      "comments": "",
      "prerequisite_id": 1643,
      "cooldown": 6,
      "activation_type": 1,
      "ranked": 1,
      "cost": 6,
      "short_description": "Friendly champions within 3 spaces gain 2 AP.",
      "long_description": "Friendly champions within 3 spaces gain 2 AP.",
      "class_name": "Momentum",
      "revision": 1
    },
    {
      "asset_id": 7724,
      "resettable": 0,
      "name": "Mother of Frond",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3268,
      "activated": 1,
      "icon_name": "motheroffrond",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "When this champion is deployed from the runedock, Ambling Fronds in your deck are revealed and cost 5 nora less to play (this does not stack). This champion has <ability value=2471>Protective</ability> if there is at least one friendly Ambling Frond in play.",
      "long_description": "When this champion is deployed from the runedock, Ambling Fronds in your deck are revealed and cost 5 nora less to play (this does not stack). This champion has +1 DEF and <ability value=2471>Protective</ability> if there is at least one friendly Ambling Frond in play.",
      "class_name": "MotherOfFrond",
      "revision": 1
    },
    {
      "asset_id": 7368,
      "resettable": 0,
      "name": "Motion Sensor",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3124,
      "activated": 1,
      "icon_name": "motion_sensor",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 15,
      "short_description": "When an enemy champion moves within 5 spaces, this champion permanently gains +8 SPD and this ability is removed.",
      "long_description": "When an enemy champion moves within 5 spaces, this champion permanently gains +8 SPD and this ability is removed.",
      "class_name": "MotionSensor",
      "revision": 1
    },
    {
      "asset_id": 5065,
      "resettable": 1,
      "name": "Motivate",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1241,
      "activated": 1,
      "icon_name": "allybuffs",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 7,
      "short_description": "All other friendly champions have +1 DMG.",
      "long_description": "All other friendly champions have +1 DMG.",
      "class_name": "Motivate",
      "revision": 1
    },
    {
      "asset_id": 4434,
      "resettable": 1,
      "name": "Mount",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 780,
      "activated": 1,
      "icon_name": "rider",
      "comments": "DEPRECATED: pointing at MogaRiders for testing with runes that still use mount, may be reintroduced in the future.",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "Rejoin this champion with an adjacent champion that had previously been dismounted.",
      "long_description": "Rejoin this champion with an adjacent champion that had previously been dismounted.",
      "class_name": "MogaRiders",
      "revision": 1
    },
    {
      "asset_id": 4907,
      "resettable": 1,
      "name": "Mountain King",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 1667,
      "activated": 1,
      "icon_name": "terrainrock",
      "comments": "(Note- all ranks of this ability should include this champion.)\r\n",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 2,
      "short_description": "This champion has <ability value=1306>Mountaineer</ability> and <ability value=3232>Chuck: Mangled Totem</ability>.",
      "long_description": "This champion has <ability value=1306>Mountaineer</ability> and <ability value=3232>Chuck: Mangled Totem</ability>.",
      "class_name": "MountainKing",
      "revision": 1
    },
    {
      "asset_id": 4907,
      "resettable": 1,
      "name": "Mountain King",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 1668,
      "activated": 1,
      "icon_name": "terrainrock",
      "comments": "(Note- all ranks of this ability should include this champion.)\r\n",
      "prerequisite_id": 1667,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 2,
      "short_description": "This champion has <ability value=1306>Mountaineer</ability> and <ability value=3232>Chuck: Mangled Totem</ability>.",
      "long_description": "This champion has <ability value=1306>Mountaineer</ability> and <ability value=3232>Chuck: Mangled Totem</ability>.",
      "class_name": "MountainKing",
      "revision": 1
    },
    {
      "asset_id": 4907,
      "resettable": 1,
      "name": "Mountain King",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 1669,
      "activated": 1,
      "icon_name": "terrainrock",
      "comments": "(Note- all ranks of this ability should include this champion.)\r\n",
      "prerequisite_id": 1668,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 2,
      "short_description": "This champion has <ability value=1306>Mountaineer</ability> and <ability value=3232>Chuck: Mangled Totem</ability>.",
      "long_description": "This champion has <ability value=1306>Mountaineer</ability> and <ability value=3232>Chuck: Mangled Totem</ability>.",
      "class_name": "MountainKing",
      "revision": 1
    },
    {
      "asset_id": 5117,
      "resettable": 1,
      "name": "Mountaineer",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1306,
      "activated": 1,
      "icon_name": "climb",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 2,
      "short_description": "This champion ignores movement restrictions and movement penalties imposed by terrain elevation and ignores terrain restrictions while moving.",
      "long_description": "This champion ignores movement restrictions and movement penalties imposed by terrain elevation and ignores terrain restrictions while moving.",
      "class_name": "Mountaineer",
      "revision": 1
    },
    {
      "asset_id": 4528,
      "resettable": 1,
      "name": "Mudsling",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 945,
      "activated": 1,
      "icon_name": "disable",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "Target unit within 5 spaces takes 50% DMG and gains <ability value=5>Lumbering</ability> and cannot <ability value=516>Leap</ability>, <ability value=2324>Pounce</ability> or <ability value=406>Teleport</ability> for 4 turns.",
      "long_description": "Target unit within 5 spaces takes 50% DMG and gains <ability value=5>Lumbering</ability> and cannot <ability value=516>Leap</ability>, <ability value=2324>Pounce</ability> or <ability value=406>Teleport</ability> for 4 turns.",
      "class_name": "Mudsling",
      "revision": 1
    },
    {
      "asset_id": 4556,
      "resettable": 1,
      "name": "Mudwalker",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 959,
      "activated": 1,
      "icon_name": "terrainmud",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 2,
      "short_description": "This unit ignores movement restrictions and movement penalties imposed by terrain that includes both water and dirt on the same space.",
      "long_description": "This unit ignores movement restrictions and movement penalties imposed by terrain that includes both water and dirt on the same space.",
      "class_name": "Mudwalker",
      "revision": 1
    },
    {
      "asset_id": 4008,
      "resettable": 1,
      "name": "Multiattack",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 15,
      "activated": 1,
      "icon_name": "multiattack",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 8,
      "short_description": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
      "long_description": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
      "class_name": "Multiattack",
      "revision": 1
    },
    {
      "asset_id": 4008,
      "resettable": 1,
      "name": "Multiattack",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 16,
      "activated": 1,
      "icon_name": "multiattack",
      "comments": "none",
      "prerequisite_id": 15,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 11,
      "short_description": "This champion's AP cost for making a basic attack is reduced by 2, to a minimum of 2 AP.",
      "long_description": "This champion's AP cost for making a basic attack is reduced by 2, to a minimum of 2 AP.",
      "class_name": "Multiattack",
      "revision": 1
    },
    {
      "asset_id": 4008,
      "resettable": 1,
      "name": "Multiattack",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 17,
      "activated": 1,
      "icon_name": "multiattack",
      "comments": "none",
      "prerequisite_id": 16,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 14,
      "short_description": "This champion's AP cost for making a basic attack is reduced by 3, to a minimum of 2 AP.",
      "long_description": "This champion's AP cost for making a basic attack is reduced by 3, to a minimum of 2 AP.",
      "class_name": "Multiattack",
      "revision": 1
    },
    {
      "asset_id": 5263,
      "resettable": 1,
      "name": "Multitude",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2084,
      "activated": 1,
      "icon_name": "swarm_of_moga",
      "comments": "Note: THIS ABILITY DOES NOT ACTUALLY DO ANYTHING\r\n\r\nThis ability merely marks a rune that has a rune group set where you can include 3 of the runes in the battle group, in the same way that Unique does not do anything and merely marks champions that have been flagged as only including 1 in the rune group",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "You may include up to 3 copies of this unit in a Battlegroup. ",
      "long_description": "You may include up to 3 copies of this unit in a Battlegroup. ",
      "class_name": "TestAbility",
      "revision": 1
    },
    {
      "asset_id": 4971,
      "resettable": 1,
      "name": "Murk",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1851,
      "activated": 1,
      "icon_name": "domain_shadows",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 16,
      "short_description": "<condition value=stealthed>Stealthed</condition> champions within 8 spaces, including this one, do not lose stealth when damaged.",
      "long_description": "<condition value=stealthed>Stealthed</condition> champions within 8 spaces, including this one, do not lose stealth when damaged.",
      "class_name": "Murk",
      "revision": 1
    },
    {
      "asset_id": 5646,
      "resettable": 1,
      "name": "Murkwater Frenzy",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2517,
      "activated": 1,
      "icon_name": "murkwater_frenzy",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "This unit gains <ability value=2>Amphibious</ability> and <ability value=3013>Soultap Feedback</ability>. While 4 friendly champions with Race: Snaptooth are in play, this champion gains <ability value=1504>Brutality</ability>.",
      "long_description": "This unit gains <ability value=2>Amphibious</ability> and <ability value=3013>Soultap Feedback</ability>. While 4 friendly champions with Race: Snaptooth are in play, this champion gains <ability value=1504>Brutality</ability>.",
      "class_name": "MurkwaterFrenzy",
      "revision": 1
    },
    {
      "asset_id": 7968,
      "resettable": 0,
      "name": "Murkwater Solemnity",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3355,
      "activated": 1,
      "icon_name": "murkwater_frenzy",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "This unit has <ability value=2>Amphibious</ability> and <ability value=1857>Soultap</ability>.",
      "long_description": "This unit has <ability value=2>Amphibious</ability> and <ability value=1857>Soultap</ability>.",
      "class_name": "MurkwaterSolemnity",
      "revision": 1
    },
    {
      "asset_id": 5576,
      "resettable": 1,
      "name": "Mutate",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 2436,
      "activated": 1,
      "icon_name": "mutation",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "Target friendly champion within 3 spaces gets +5 MAX HP, +2 DMG or +1 SPD. Target opposing champion gets -5 MAX HP, -2 DMG or -1 SPD. These effects can not be cleansed or dispelled. If target champion has a Mutation ability it also gains 4 charges.",
      "long_description": "Target friendly champion within 3 spaces gets +5 MAX HP, +2 DMG or +1 SPD. Target opposing champion gets -5 MAX HP, -2 DMG or -1 SPD. These effects can not be cleansed or dispelled. If target champion has a Mutation ability it also gains 4 charges.",
      "class_name": "Mutate",
      "revision": 1
    },
    {
      "asset_id": 5585,
      "resettable": 1,
      "name": "Mutation: Amphibious",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2445,
      "activated": 1,
      "icon_name": "mutation",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Spend 1 charge - this champion gains <ability value=2>Amphibious</ability>.",
      "long_description": "Spend 1 charge - this champion gains <ability value=2>Amphibious</ability>.",
      "class_name": "MutationAmphibious",
      "revision": 1
    },
    {
      "asset_id": 5586,
      "resettable": 1,
      "name": "Mutation: Arctic",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2446,
      "activated": 1,
      "icon_name": "mutation",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Spend 1 charge - this champion gains <ability value=600>Arctic</ability>",
      "long_description": "Spend 1 charge - this champion gains <ability value=600>Arctic</ability>",
      "class_name": "MutationArctic",
      "revision": 1
    },
    {
      "asset_id": 5507,
      "resettable": 1,
      "name": "Mutation: Camouflage",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2366,
      "activated": 1,
      "icon_name": "mutation",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Spend 2 charges - this champion gains Camouflage (When this unit is damaged by a ranged attack while it is occupying Vegetation, that damage by is reduced by 2).",
      "long_description": "Spend 2 charges - this champion gains Camouflage (When this unit is damaged by a ranged attack while it is occupying Vegetation, that damage by is reduced by 2).",
      "class_name": "MutationCamouflage",
      "revision": 1
    },
    {
      "asset_id": 5584,
      "resettable": 1,
      "name": "Mutation: Climb",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2444,
      "activated": 1,
      "icon_name": "mutation",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Spend 1 charge - this champion gains Climb (This champion ignores movement restrictions and movement penalties imposed by terrain elevation).",
      "long_description": "Spend 1 charge - this champion gains Climb (This champion ignores movement restrictions and movement penalties imposed by terrain elevation).",
      "class_name": "MutationClimb",
      "revision": 1
    },
    {
      "asset_id": 5580,
      "resettable": 1,
      "name": "Mutation: Damage",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2440,
      "activated": 1,
      "icon_name": "mutation",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Spend 3 charges - this champion gains +2 damage.",
      "long_description": "Spend 3 charges - this champion gains +2 damage.",
      "class_name": "MutationDamage",
      "revision": 1
    },
    {
      "asset_id": 5506,
      "resettable": 1,
      "name": "Mutation: Forestwalker",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2365,
      "activated": 1,
      "icon_name": "mutation",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Spend 1 charge - this champion gains Forest Walker (At the end of each turn, spaces within 4 of this champion become Vegetation for 3 turns).",
      "long_description": "Spend 1 charge - this champion gains Forest Walker (At the end of each turn, spaces within 4 of this champion become Vegetation for 3 turns).",
      "class_name": "MutationForestwalker",
      "revision": 1
    },
    {
      "asset_id": 5505,
      "resettable": 1,
      "name": "Mutation: Gore",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2692,
      "activated": 1,
      "icon_name": "mutation",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Spend 4 charges: This champion gains <ability value=2035>Stat Bonus: Damage 2</ability>. If it already has Stat Bonus: Damage 2, it gains <ability value=164>Rend 2</ability> instead.  If it already has <ability value=163>Rend</ability>, it gains <ability value=2190>Charged Attack</ability> instead and this ability is removed.",
      "long_description": "Spend 4 charges: This champion gains <ability value=2035>Stat Bonus: Damage 2</ability>. If it already has Stat Bonus: Damage 2, it gains <ability value=164>Rend 2</ability> instead.  If it already has <ability value=163>Rend</ability>, it gains <ability value=2190>Charged Attack</ability> instead and this ability is removed.",
      "class_name": "MutationGore",
      "revision": 1
    },
    {
      "asset_id": 5505,
      "resettable": 1,
      "name": "Mutation: Horror",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2691,
      "activated": 1,
      "icon_name": "mutation",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Spend 4 charges: This champion gains <ability value=1850>Frightful Blows</ability> instead.  If it already has Frightful Blows, it gains <ability value=1330>Dread</ability> instead and this ability is removed.",
      "long_description": "Spend 4 charges: This champion gains <ability value=1850>Frightful Blows</ability> instead.  If it already has Frightful Blows, it gains <ability value=1330>Dread</ability> instead and this ability is removed.",
      "class_name": "MutationHorror",
      "revision": 1
    },
    {
      "asset_id": 5583,
      "resettable": 1,
      "name": "Mutation: Lavawalker",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2443,
      "activated": 1,
      "icon_name": "mutation",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Spend 1 charge - this champion gains Lavawalker (This champion ignores movement restrictions and movement penalties imposed by Lava. Fire damage that would be dealt to this champion by Lava is prevented).",
      "long_description": "Spend 1 charge - this champion gains Lavawalker (This champion ignores movement restrictions and movement penalties imposed by Lava. Fire damage that would be dealt to this champion by Lava is prevented).",
      "class_name": "MutationLavawalker",
      "revision": 1
    },
    {
      "asset_id": 5508,
      "resettable": 1,
      "name": "Mutation: Leap 3",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2367,
      "activated": 1,
      "icon_name": "mutation",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Spend 4 charges: This champion gains <ability value=518>Leap 3</ability>.",
      "long_description": "Spend 4 charges: This champion gains <ability value=518>Leap 3</ability>.",
      "class_name": "MutationLeap",
      "revision": 1
    },
    {
      "asset_id": 5581,
      "resettable": 1,
      "name": "Mutation: Multiattack",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2441,
      "activated": 1,
      "icon_name": "mutation",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Spend 4 charges - this champion gains Multiattack 1 (This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP).",
      "long_description": "Spend 4 charges - this champion gains Multiattack 1 (This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP).",
      "class_name": "MutationMultiattack",
      "revision": 1
    },
    {
      "asset_id": 5509,
      "resettable": 1,
      "name": "Mutation: Tough",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2368,
      "activated": 1,
      "icon_name": "mutation",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Spend 3 charges: This champion gains a rank of <ability value=1900>Tough</ability>.",
      "long_description": "Spend 3 charges: This champion gains a rank of <ability value=1900>Tough</ability>.",
      "class_name": "MutationTough",
      "revision": 1
    },
    {
      "asset_id": 5505,
      "resettable": 1,
      "name": "Mutation: Violence",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2693,
      "activated": 1,
      "icon_name": "mutation",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Spend 4 charges: This champion gains <ability value=261>Enrage 2</ability>. If it already has Enrage 3, it gains <ability value=2837>Psychotic Break</ability> instead and this ability is removed.",
      "long_description": "Spend 4 charges: This champion gains <ability value=261>Enrage 2</ability>. If it already has Enrage 3, it gains <ability value=2837>Psychotic Break</ability> instead and this ability is removed.",
      "class_name": "MutationViolence",
      "revision": 1
    },
    {
      "asset_id": 5582,
      "resettable": 1,
      "name": "Mutation: Weaken Spells",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2442,
      "activated": 1,
      "icon_name": "mutation",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Spend 4 charges - this champion gains Weaken Spells (Friendly champions within 5 spaces take 5 less damage from spells).",
      "long_description": "Spend 4 charges - this champion gains Weaken Spells (Friendly champions within 5 spaces take 5 less damage from spells).",
      "class_name": "MutationWeakenSpells",
      "revision": 1
    },
    {
      "asset_id": 4388,
      "resettable": 1,
      "name": "Mysterious Gift",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1428,
      "activated": 1,
      "icon_name": "gift",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Drop a Mysterious Gift on an open location within 2 spaces. This gift may have positive or negative effects.",
      "long_description": "Drop a Mysterious Gift on an open location within 2 spaces. This gift may have positive or negative effects.",
      "class_name": "MysteriousGift",
      "revision": 1
    },
    {
      "asset_id": 5669,
      "resettable": 1,
      "name": "Mystery Meat",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2541,
      "activated": 1,
      "icon_name": "mystery_meat",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 0,
      "short_description": "Opposing units that devour this unit have a 50% chance of gaining <ability value=679>G'hernbound</ability> for 5 turns.",
      "long_description": "Opposing units that devour this unit have a 50% chance of gaining <ability value=679>G'hernbound</ability> for 5 turns.",
      "class_name": "MysteryMeat",
      "revision": 1
    },
    {
      "asset_id": 4315,
      "resettable": 1,
      "name": "Mystic Push",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1343,
      "activated": 1,
      "icon_name": "auranegative",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "Spell presence of friendly champions is increased by one and champions your enemy controls have their spell presence decreased by one.",
      "long_description": "Spell presence of friendly champions is increased by one and champions your enemy controls have their spell presence decreased by one.",
      "class_name": "MysticPush",
      "revision": 1
    },
    {
      "asset_id": 5239,
      "resettable": 1,
      "name": "Mystic Whirlpool",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2019,
      "activated": 1,
      "icon_name": "dispel",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 0,
      "short_description": "Whenever a unit without Amphibious moves within 4 spaces of this unit, it is pulled one space directly toward it.",
      "long_description": "Whenever a unit without Amphibious moves within 4 spaces of this unit, it is pulled one space directly toward it.",
      "class_name": "RelicMysticWhirlpool",
      "revision": 1
    },
    {
      "asset_id": 4706,
      "resettable": 1,
      "name": "Mythical",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1154,
      "activated": 1,
      "icon_name": "planar",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "When another copy of this unit is in play that you own, both it and this copy are destroyed.",
      "long_description": "When another copy of this unit is in play that you own, both it and this copy are destroyed.",
      "class_name": "Epic",
      "revision": 1
    },
    {
      "asset_id": 7138,
      "resettable": 0,
      "name": "Myx Hive",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2980,
      "activated": 1,
      "icon_name": "hatch_myx_pupae",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "At the start of your next turn, a Myx Pupae is deployed on an adjacent space for 10 Nora. This repeats at the beginning of every sixth turn.",
      "long_description": "At the start of your next turn, a Myx Pupae is deployed on an adjacent space for 10 Nora. This repeats at the beginning of every sixth turn.",
      "class_name": "RelicMyxDen",
      "revision": 1
    },
    {
      "asset_id": 5638,
      "resettable": 1,
      "name": "Myx Pupae",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2494,
      "activated": 1,
      "icon_name": "hatch_myx_pupae",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 0,
      "short_description": "After 5 turns, this relic is destroyed and a Young Myx Drone with no upgrades is summoned in its place.",
      "long_description": "After 5 turns, this relic is destroyed and a Young Myx Drone with no upgrades is summoned in its place.",
      "class_name": "hatchMyxPupae",
      "revision": 1
    },
    {
      "asset_id": 4293,
      "resettable": 1,
      "name": "Nature's Balance",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 692,
      "activated": 1,
      "icon_name": "soul_bond",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 15,
      "short_description": "Amplifications and Vulnerabilities are negated.",
      "long_description": "Amplifications and Vulnerabilities are negated.",
      "class_name": "RelicNaturesBalance",
      "revision": 1
    },
    {
      "asset_id": 4807,
      "resettable": 1,
      "name": "Nature's Blessing",
      "ap_cost": 4,
      "level": 1,
      "ability_id": 1571,
      "activated": 1,
      "icon_name": "cleanse",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 6,
      "activation_type": 1,
      "ranked": 1,
      "cost": 8,
      "short_description": "Target champion within 5 spaces is <mechanic value=cleansed>Cleansed</mechanic> and is healed for 7 HP",
      "long_description": "Target champion within 5 spaces is <mechanic value=cleansed>Cleansed</mechanic> and is healed for 7 HP",
      "class_name": "NaturesBlessing",
      "revision": 1
    },
    {
      "asset_id": 4807,
      "resettable": 1,
      "name": "Nature's Blessing",
      "ap_cost": 4,
      "level": 2,
      "ability_id": 1572,
      "activated": 1,
      "icon_name": "cleanse",
      "comments": "",
      "prerequisite_id": 1571,
      "cooldown": 6,
      "activation_type": 1,
      "ranked": 1,
      "cost": 10,
      "short_description": "Target champion within 5 spaces is <mechanic value=cleansed>Cleansed</mechanic> and is healed for 9 HP and gains 1 DEF for 4 turns.",
      "long_description": "Target champion within 5 spaces is <mechanic value=cleansed>Cleansed</mechanic> and is healed for 9 HP and gains 1 DEF for 4 turns.",
      "class_name": "NaturesBlessing",
      "revision": 1
    },
    {
      "asset_id": 4807,
      "resettable": 1,
      "name": "Nature's Blessing",
      "ap_cost": 4,
      "level": 3,
      "ability_id": 1573,
      "activated": 1,
      "icon_name": "cleanse",
      "comments": "",
      "prerequisite_id": 1572,
      "cooldown": 6,
      "activation_type": 1,
      "ranked": 1,
      "cost": 12,
      "short_description": "Target champion within 5 spaces is <mechanic value=cleansed>Cleansed</mechanic> and is healed for 11 HP and gains 2 DEF for 4 turns.",
      "long_description": "Target champion within 5 spaces is <mechanic value=cleansed>Cleansed</mechanic> and is healed for 11 HP and gains 2 DEF for 4 turns.",
      "class_name": "NaturesBlessing",
      "revision": 1
    },
    {
      "asset_id": 5523,
      "resettable": 1,
      "name": "Nature's Connections",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2674,
      "activated": 1,
      "icon_name": "forage",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 4,
      "short_description": "When a friendly champion within 5 spaces makes a successful basic attack, this unit heals for 2 HP.  If the attacking champion is a Plant, Ranger or Shaman, it also heals for 2 HP.",
      "long_description": "When a friendly champion within 5 spaces makes a successful basic attack, this unit heals for 2 HP.  If the attacking champion is a Plant, Ranger or Shaman, it also heals for 2 HP.",
      "class_name": "NaturesConnections",
      "revision": 1
    },
    {
      "asset_id": 5654,
      "resettable": 1,
      "name": "Necrosis",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2526,
      "activated": 1,
      "icon_name": "creep",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this champion is deployed from the runedock, your shrine's <mechanic value=deployment_zone>Deployment Zone</mechanic> expands by 1.  When a champion without Race: Worm or Necrosis is deployed from the runedock, your shrine's <mechanic value=deployment_zone>Deployment Zone</mechanic> decreases by 1 (this does not stack).",
      "long_description": "When this champion is deployed from the runedock, your shrine's <mechanic value=deployment_zone>Deployment Zone</mechanic> expands by 1.  When a champion without Race: Worm or Necrosis is deployed from the runedock, your shrine's <mechanic value=deployment_zone>Deployment Zone</mechanic> decreases by 1 (this does not stack).",
      "class_name": "Necrosis",
      "revision": 1
    },
    {
      "asset_id": 7241,
      "resettable": 0,
      "name": "Nefari Resurrection",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3057,
      "activated": 1,
      "icon_name": "soul_bond",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "Friendly Elves within 5 spaces have <ability value=3056>Overkill: Healing</ability>  and <ability value=3096>Cull</ability>.",
      "long_description": "Friendly Elves within 5 spaces have <ability value=3056>Overkill: Healing</ability>  and <ability value=3096>Cull</ability>.",
      "class_name": "RelicNefariResurrection",
      "revision": 1
    },
    {
      "asset_id": 4298,
      "resettable": 1,
      "name": "Nefari Torch",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 700,
      "activated": 1,
      "icon_name": "shrinebad",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 1,
      "short_description": "Whenever a player successfully casts a spell, their opponent's champions gain +1 DMG for 6 turns and gain 1 AP and their champions have -1 DMG for 6 turns.",
      "long_description": "Whenever a player successfully casts a spell, their opponent's champions gain +1 DMG for 6 turns and gain 1 AP and their champions have -1 DMG for 6 turns.",
      "class_name": "RelicBokGallows",
      "revision": 1
    },
    {
      "asset_id": 4268,
      "resettable": 1,
      "name": "Nemesis: Earth Golem",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 682,
      "activated": 1,
      "icon_name": "regen",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": -35,
      "short_description": "When this champion is deployed, a Level 1 Earth Golem with Iron Will is deployed within 3 spaces of your enemy's Shrine or Avatar, under their control.  If this champion is destroyed, the Earth Golem is also destroyed.",
      "long_description": "When this champion is deployed, a Level 1 Earth Golem with Iron Will is deployed within 3 spaces of your enemy's Shrine or Avatar, under their control.  If this champion is destroyed, the Earth Golem is also destroyed.",
      "class_name": "NemesisEarthGolem",
      "revision": 1
    },
    {
      "asset_id": 4929,
      "resettable": 1,
      "name": "Nemesis: Earthmover",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1046,
      "activated": 1,
      "icon_name": "regen",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": -25,
      "short_description": "When this champion is deployed, an Earthmover with <ability value=4>Iron Will</ability> is deployed within 3 spaces of your enemy's Shrine or Avatar, under their control.  If this champion is destroyed, the Earthmover is also destroyed.",
      "long_description": "When this champion is deployed, an Earthmover with <ability value=4>Iron Will</ability> is deployed within 3 spaces of your enemy's Shrine or Avatar, under their control.  If this champion is destroyed, the Earthmover is also destroyed.",
      "class_name": "NemesisEarthmover",
      "revision": 1
    },
    {
      "asset_id": 4816,
      "resettable": 1,
      "name": "Nemesis: Enraged Grizzly",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1695,
      "activated": 1,
      "icon_name": "regen",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": -20,
      "short_description": "When this champion is deployed, a Level 1 Enraged Grizzly with Iron Will is deployed within 3 spaces of your enemy's Shrine or Avatar, under their control.  If this champion is destroyed, the Enraged Grizzly is also destroyed.",
      "long_description": "When this champion is deployed, a Level 1 Enraged Grizzly with Iron Will is deployed within 3 spaces of your enemy's Shrine or Avatar, under their control.  If this champion is destroyed, the Enraged Grizzly is also destroyed.",
      "class_name": "NemesisEnragedGrizzly",
      "revision": 1
    },
    {
      "asset_id": 4267,
      "resettable": 1,
      "name": "Nemesis: G'hern Traitor",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 681,
      "activated": 1,
      "icon_name": "regen",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": -30,
      "short_description": "When this champion is deployed, a Level 1 G'hern Traitor with Iron Will is deployed within 3 spaces of your enemy's Shrine or Avatar, under their control.   If this champion is destroyed, the G'hern Traitor is also destroyed.",
      "long_description": "When this champion is deployed, a Level 1 G'hern Traitor with Iron Will is deployed within 3 spaces of your enemy's Shrine or Avatar, under their control.   If this champion is destroyed, the G'hern Traitor is also destroyed.",
      "class_name": "NemesisGhern",
      "revision": 1
    },
    {
      "asset_id": 4446,
      "resettable": 1,
      "name": "Nemesis: Ghoul",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 798,
      "activated": 1,
      "icon_name": "regen",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": -30,
      "short_description": "When this champion is deployed, a Level 1 Ghoul with Iron Will is deployed within 3 spaces of your enemy's Shrine or Avatar, under their control.  If this champion is destroyed, the Ghoul is also destroyed.",
      "long_description": "When this champion is deployed, a Level 1 Ghoul with Iron Will is deployed within 3 spaces of your enemy's Shrine or Avatar, under their control.  If this champion is destroyed, the Ghoul is also destroyed.",
      "class_name": "NemesisGhoul",
      "revision": 1
    },
    {
      "asset_id": 5213,
      "resettable": 1,
      "name": "Neophyte",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1990,
      "activated": 1,
      "icon_name": "revere",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "While Kartch is in play, this champion gains +5 MAX HP and +1 SPD.  While Gekaal is in play, this champion has <ability value=372>Heal Mass 3</ability>.",
      "long_description": "While Kartch is in play, this champion gains +5 MAX HP and +1 SPD.  While Gekaal is in play, this champion has <ability value=372>Heal Mass 3</ability>.",
      "class_name": "Neophyte",
      "revision": 1
    },
    {
      "asset_id": 7570,
      "resettable": 0,
      "name": "New Growth",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3215,
      "activated": 1,
      "icon_name": "newgrowth",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 14,
      "short_description": "The first time each turn an opposing real champion within 5 spaces is destroyed, a Young Sapling without upgrades is summoned adjacent to this unit.",
      "long_description": "The first time each turn an opposing real champion within 5 spaces is destroyed, a Young Sapling without upgrades is summoned adjacent to this unit.",
      "class_name": "NewGrowth",
      "revision": 1
    },
    {
      "asset_id": 4518,
      "resettable": 1,
      "name": "Nexus Aura",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1469,
      "activated": 1,
      "icon_name": "nexus_aura",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "For 2 turns, any damage from spells or attacks done to a champion within 2 spaces is split and shared equally with all champions in that range.  This effect is hidden until triggered.",
      "long_description": "For 2 turns, any damage from spells or attacks done to a champion within 2 spaces is split and shared equally with all champions in that range.  This effect is hidden until triggered.",
      "class_name": "NexusAura",
      "revision": 1
    },
    {
      "asset_id": 5706,
      "resettable": 1,
      "name": "Nightfall",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2587,
      "activated": 1,
      "icon_name": "stealth",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "When this champion is deployed or destroyed, the closest unstealthed friendly champion becomes <condition value=stealthed>Stealthed</condition> for 6 turns.",
      "long_description": "When this champion is deployed or destroyed, the closest unstealthed friendly champion becomes <condition value=stealthed>Stealthed</condition> for 6 turns.",
      "class_name": "Nightfall",
      "revision": 1
    },
    {
      "asset_id": 4868,
      "resettable": 1,
      "name": "Noble Sacrifice",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 2753,
      "activated": 1,
      "icon_name": "buff",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "This champion loses 8 HP and target other friendly champion that shares a race with this one within 3 spaces gains <ability value=1932>Loyalty</ability> for 8 turns.",
      "long_description": "This champion loses 8 HP and target other friendly champion that shares a race with this one within 3 spaces gains <ability value=1932>Loyalty</ability> for 8 turns.",
      "class_name": "NobleSacrifice",
      "revision": 1
    },
    {
      "asset_id": 0,
      "resettable": 0,
      "name": "Noetic Mind",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3376,
      "activated": 1,
      "icon_name": "mind_lock",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 7,
      "short_description": "This champion has <ability value=3261>Mind Lock</ability>. When another friendly champion within 5 spaces uses Mind Lock, this champion also gains the ability affected by Mind Lock for 5 turns.",
      "long_description": "This champion has <ability value=3261>Mind Lock</ability>. When another friendly champion within 5 spaces uses Mind Lock, this champion also gains the ability affected by Mind Lock for 5 turns.",
      "class_name": "NoeticMind",
      "revision": 1
    },
    {
      "asset_id": 4745,
      "resettable": 1,
      "name": "Nohkan Do",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1470,
      "activated": 1,
      "icon_name": "dodge",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 6,
      "short_description": "Attacks against this unit miss for 2 AP. This effect can trigger once per turn and does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>.",
      "long_description": "Attacks against this unit miss for 2 AP. This effect can trigger once per turn and does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>.",
      "class_name": "NohkanDo",
      "revision": 1
    },
    {
      "asset_id": 5364,
      "resettable": 1,
      "name": "Nora Barrier",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2196,
      "activated": 1,
      "icon_name": "nora_barrier",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "When this champion is deployed, it is <condition value=norashielded>Nora Shielded</condition> for 8 turns.",
      "long_description": "When this champion is deployed, it is <condition value=norashielded>Nora Shielded</condition> for 8 turns.",
      "class_name": "NoraBarrier",
      "revision": 1
    },
    {
      "asset_id": 5795,
      "resettable": 1,
      "name": "Nora Burn",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2779,
      "activated": 1,
      "icon_name": "drain",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "When this champion successfully damages a champion with a basic attack, that champion loses HP equal to 15% of the nora in its controller's nora bank, rounded down.",
      "long_description": "When this champion successfully damages a champion with a basic attack, that champion loses HP equal to 15% of the nora in its controller's nora bank, rounded down.",
      "class_name": "NoraBurn",
      "revision": 1
    },
    {
      "asset_id": 5514,
      "resettable": 1,
      "name": "Nora Gem",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2373,
      "activated": 1,
      "icon_name": "nora_gem",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 2,
      "short_description": "This unit is a Nora Gem. It gains the Luminescence abilities of friendly Nora Gem within 5 spaces.",
      "long_description": "This unit is a Nora Gem. It gains the Luminescence abilities of friendly Nora Gem within 5 spaces.",
      "class_name": "NoraGem",
      "revision": 1
    },
    {
      "asset_id": 5359,
      "resettable": 1,
      "name": "Nora Hex",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2191,
      "activated": 1,
      "icon_name": "nora_hex",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "Shrine nora generation for opposing players is reduced by 1 for every 3 charges on this champion.",
      "long_description": "Shrine nora generation for opposing players is reduced by 1 for every 3 charges on this champion.",
      "class_name": "NoraHex",
      "revision": 1
    },
    {
      "asset_id": 4885,
      "resettable": 1,
      "name": "Nora Incarnate",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1767,
      "activated": 1,
      "icon_name": "special",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 25,
      "short_description": "Any champion damaged by this champion's basic attack becomes <condition value=charred>Charred</condition> for 3 turns, <condition value=chilled>Chilled</condition> 3, <condition value=poisoned>Poisoned</condition> for 3 turns, <condition value=shocked>Shocked</condition> for 3 turns and <condition value=scoured>Scoured</condition> 3.",
      "long_description": "Any champion damaged by this champion's basic attack becomes <condition value=charred>Charred</condition> for 3 turns, <condition value=chilled>Chilled</condition> 3, <condition value=poisoned>Poisoned</condition> for 3 turns, <condition value=shocked>Shocked</condition> for 3 turns and <condition value=scoured>Scoured</condition> 3.",
      "class_name": "NoraIncarnate",
      "revision": 1
    },
    {
      "asset_id": 7163,
      "resettable": 0,
      "name": "Nora Induction",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3006,
      "activated": 1,
      "icon_name": "ichor_utility",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": -6,
      "short_description": "Whenever this champion makes a successful attack against a champion, the target's controller gains 2 nora.",
      "long_description": "Whenever this champion makes a successful attack against a champion, the target's controller gains 2 nora.",
      "class_name": "NoraInduction",
      "revision": 1
    },
    {
      "asset_id": 4546,
      "resettable": 1,
      "name": "Nora Leech",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 937,
      "activated": 1,
      "icon_name": "nora_thief",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "When your enemy would gain Nora through an ability, spell or relic, they gain 75% of that amount, and you gain 25% of that amount. When you would gain Nora through an ability, spell or relic you instead gain only 75% of that amount.",
      "long_description": "When your enemy would gain Nora through an ability, spell or relic, they gain 75% of that amount, and you gain 25% of that amount. When you would gain Nora through an ability, spell or relic you instead gain only 75% of that amount.",
      "class_name": "NoraLeech",
      "revision": 1
    },
    {
      "asset_id": 5089,
      "resettable": 1,
      "name": "Nora Link",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1916,
      "activated": 1,
      "icon_name": "noragen",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 8,
      "short_description": "Whenever a player's spell, relic, or ability generates nora, the other player gains an equal amount.",
      "long_description": "Whenever a player's spell, relic, or ability generates nora, the other player gains an equal amount.",
      "class_name": "MentalLink",
      "revision": 1
    },
    {
      "asset_id": 5079,
      "resettable": 1,
      "name": "Nora Lock",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 1915,
      "activated": 1,
      "icon_name": "nora_hex",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 5,
      "short_description": "For 3 turns, no nora is generated by relics, spells or abilities.",
      "long_description": "For 3 turns, no nora is generated by relics, spells or abilities.",
      "class_name": "NoraLock",
      "revision": 1
    },
    {
      "asset_id": 4190,
      "resettable": 1,
      "name": "Nora Mine",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 532,
      "activated": 1,
      "icon_name": "noragen",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "At the beginning of your turn, you gain 5 additional nora, as well as 1 additional nora for each Nora Miner in play (a Nora Miner is a unit with the Nora Miner ability).",
      "long_description": "At the beginning of your turn, you gain 5 additional nora, as well as 1 additional nora for each Nora Miner in play (a Nora Miner is a unit with the Nora Miner ability).",
      "class_name": "RelicNoraMine",
      "revision": 1
    },
    {
      "asset_id": 4121,
      "resettable": 1,
      "name": "Nora Miner",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 307,
      "activated": 1,
      "icon_name": "noragen",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 6,
      "short_description": "At the beginning of your turn, you gain 3 nora.",
      "long_description": "At the beginning of your turn, you gain 3 nora.",
      "class_name": "NoraMiner",
      "revision": 1
    },
    {
      "asset_id": 4121,
      "resettable": 1,
      "name": "Nora Miner",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 308,
      "activated": 1,
      "icon_name": "noragen",
      "comments": "none",
      "prerequisite_id": 307,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 12,
      "short_description": "At the beginning of your turn, you gain 6 nora.",
      "long_description": "At the beginning of your turn, you gain 6 nora.",
      "class_name": "NoraMiner",
      "revision": 1
    },
    {
      "asset_id": 4121,
      "resettable": 1,
      "name": "Nora Miner",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 309,
      "activated": 1,
      "icon_name": "noragen",
      "comments": "none",
      "prerequisite_id": 308,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 18,
      "short_description": "At the beginning of your turn, you gain 9 nora.",
      "long_description": "At the beginning of your turn, you gain 9 nora.",
      "class_name": "NoraMiner",
      "revision": 1
    },
    {
      "asset_id": 4296,
      "resettable": 1,
      "name": "Nora Pearls",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 698,
      "activated": 1,
      "icon_name": "noragen",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 1,
      "short_description": "When a player successfully casts a spell, the enemy gains Nora equal to 50% of that spells Nora cost. This does not stack.",
      "long_description": "When a player successfully casts a spell, the enemy gains Nora equal to 50% of that spells Nora cost. This does not stack.",
      "class_name": "RelicNoraPearls",
      "revision": 1
    },
    {
      "asset_id": 4470,
      "resettable": 1,
      "name": "Nora Shield",
      "ap_cost": 3,
      "level": 1,
      "ability_id": 840,
      "activated": 1,
      "icon_name": "nora_barrier",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 1,
      "cost": 4,
      "short_description": "Target friendly champion within 3 spaces becomes <condition value=norashielded>Nora Shielded</condition> for 2 turns.",
      "long_description": "Target friendly champion within 3 spaces becomes <condition value=norashielded>Nora Shielded</condition> for 2 turns.",
      "class_name": "NoraShield",
      "revision": 1
    },
    {
      "asset_id": 4470,
      "resettable": 1,
      "name": "Nora Shield",
      "ap_cost": 3,
      "level": 2,
      "ability_id": 841,
      "activated": 1,
      "icon_name": "nora_barrier",
      "comments": "",
      "prerequisite_id": 840,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 1,
      "cost": 8,
      "short_description": "Target friendly champion within 3 spaces becomes <condition value=norashielded>Nora Shielded</condition> for 4 turns.",
      "long_description": "Target friendly champion within 3 spaces becomes <condition value=norashielded>Nora Shielded</condition> for 4 turns.",
      "class_name": "NoraShield",
      "revision": 1
    },
    {
      "asset_id": 5400,
      "resettable": 1,
      "name": "Nora Thief",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2232,
      "activated": 1,
      "icon_name": "nora_thief",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 7,
      "short_description": "Spend 4 charges.  Your opponent loses up to 15 nora and you gain an equal amount.\r\n",
      "long_description": "Spend 4 charges.  Your opponent loses up to 15 nora and you gain an equal amount.\r\n",
      "class_name": "NoraThief",
      "revision": 1
    },
    {
      "asset_id": 5133,
      "resettable": 1,
      "name": "Nullify Amplification",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1925,
      "activated": 1,
      "icon_name": "inhibit",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 2,
      "short_description": "While this unit is play, Amplification effects are negated.",
      "long_description": "While this unit is play, Amplification effects are negated.",
      "class_name": "NullifyAmplification",
      "revision": 1
    },
    {
      "asset_id": 5178,
      "resettable": 1,
      "name": "Numerous",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1955,
      "activated": 1,
      "icon_name": "swarm_of_moga",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": -4,
      "short_description": "This champion takes double damage from area of effect spells and half damage from ranged attacks. It counts as 3 champions for purposes of Bulwark and Surge abilities. ",
      "long_description": "This champion takes double damage from area of effect spells and half damage from ranged attacks. It counts as 3 champions for purposes of Bulwark and Surge abilities. ",
      "class_name": "Numerous",
      "revision": 1
    },
    {
      "asset_id": 4632,
      "resettable": 1,
      "name": "Oaken Mace",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 1055,
      "activated": 1,
      "icon_name": "inquisition",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "This champion makes a Physical attack at RNG 1 with +2 DMG. If the target is a champion and successfully damaged, it becomes <condition  value=stunned>Stunned</condition> for 2 turns.",
      "long_description": "This champion makes a Physical attack at RNG 1 with +2 DMG. If the target is a champion and successfully damaged, it becomes <condition  value=stunned>Stunned</condition> for 2 turns.",
      "class_name": "OakenMaceAttack",
      "revision": 1
    },
    {
      "asset_id": 5462,
      "resettable": 1,
      "name": "Oblivion Shield",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2315,
      "activated": 1,
      "icon_name": "aegis",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 12,
      "short_description": "Damage from the first successful attack made against this champion each turn is prevented.",
      "long_description": "Damage from the first successful attack made against this champion each turn is prevented.",
      "class_name": "OblivionShield",
      "revision": 1
    },
    {
      "asset_id": 7970,
      "resettable": 0,
      "name": "Obsidian Flight",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3357,
      "activated": 1,
      "icon_name": "flight",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "This unit is <condition value=flying>Flying</condition> and has <ability value=1603>Reflection 2</ability> and <ability value=2004>Faithless</ability>. When within 3 spaces of a champion with Sanguine Flight, it also gains <ability value=2942>Masochist</ability>.",
      "long_description": "This unit is <condition value=flying>Flying</condition> and has <ability value=1603>Reflection 2</ability> and <ability value=2004>Faithless</ability>. When within 3 spaces of a champion with Sanguine Flight, it also gains <ability value=2942>Masochist</ability>.",
      "class_name": "ObsidianFlight",
      "revision": 1
    },
    {
      "asset_id": 5757,
      "resettable": 1,
      "name": "Obsidian Sigil",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2658,
      "activated": 1,
      "icon_name": "griffin_sigil",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "This champion gains <ability value=1320>Assault</ability> for 5 turns when a friendly unit with a Sigil ability is deployed from the runedock.",
      "long_description": "This champion gains <ability value=1320>Assault</ability> for 5 turns when a friendly unit with a Sigil ability is deployed from the runedock.",
      "class_name": "ObsidianSigil",
      "revision": 1
    },
    {
      "asset_id": 5316,
      "resettable": 1,
      "name": "Occlude",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2143,
      "activated": 1,
      "icon_name": "drain",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "This unit loses 3 HP and 3 random runes in your runedock are concealed.",
      "long_description": "This unit loses 3 HP and 3 random runes in your runedock are concealed.",
      "class_name": "Occlude",
      "revision": 1
    },
    {
      "asset_id": 8016,
      "resettable": 0,
      "name": "Occult Fascination",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3413,
      "activated": 1,
      "icon_name": "illuminate",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "While a champion with Race: Hyaenid or Class: Witch is within 4 spaces of this unit, it also gains <ability value=1336>Fascinate</ability>.",
      "long_description": "While a champion with Race: Hyaenid or Class: Witch is within 4 spaces of this unit, it also gains <ability value=1336>Fascinate</ability>.",
      "class_name": "OccultFascination",
      "revision": 1
    },
    {
      "asset_id": 4527,
      "resettable": 1,
      "name": "Octopus Form",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 851,
      "activated": 1,
      "icon_name": "transform",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "This unit becomes an Octopus with race Beast, <ability value=114>Aquatic</ability>, <ability value=324>Constriction</ability>, and <ability value=40>Immunity: Poison</ability>. It gains +6 HP and is <mechanic value=cleansed>Cleansed</mechanic>.",
      "long_description": "This unit becomes an Octopus with race Beast, <ability value=114>Aquatic</ability>, <ability value=324>Constriction</ability>, and <ability value=40>Immunity: Poison</ability>. It gains +6 HP and is <mechanic value=cleansed>Cleansed</mechanic>.",
      "class_name": "OctopusForm",
      "revision": 1
    },
    {
      "asset_id": 4750,
      "resettable": 1,
      "name": "Omnivore",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1474,
      "activated": 1,
      "icon_name": "devour",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "When this unit deals damage to a Beast or Plant champion, it heals HP equal to half the damage dealt and gains 1 AP.",
      "long_description": "When this unit deals damage to a Beast or Plant champion, it heals HP equal to half the damage dealt and gains 1 AP.",
      "class_name": "Omnivore",
      "revision": 1
    },
    {
      "asset_id": 7324,
      "resettable": 1,
      "name": "On The House",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2713,
      "activated": 1,
      "icon_name": "special_keg",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "When a friendly champion within 5 spaces collects a Nora Globe, it becomes <condition value=intoxicated>Intoxicated</condition> for 6 turns.",
      "long_description": "When a friendly champion within 5 spaces collects a Nora Globe, it becomes <condition value=intoxicated>Intoxicated</condition> for 6 turns.",
      "class_name": "OnTheHouse",
      "revision": 1
    },
    {
      "asset_id": 4887,
      "resettable": 1,
      "name": "One With Nora",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1769,
      "activated": 1,
      "icon_name": "defenseenhance",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 12,
      "short_description": "After this champion is damaged by a basic attack, it gains immunity to the attacker's damage type for 4 turns. ",
      "long_description": "After this champion is damaged by a basic attack, it gains immunity to the attacker's damage type for 4 turns. ",
      "class_name": "OneWithNora",
      "revision": 1
    },
    {
      "asset_id": 4693,
      "resettable": 1,
      "name": "Ooze Aura",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2757,
      "activated": 1,
      "icon_name": "novapoison",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "When this unit comes into play, spaces within 3 spaces of this unit become Ooze.",
      "long_description": "When this unit comes into play, spaces within 3 spaces of this unit become Ooze.",
      "class_name": "RelicOozeAura",
      "revision": 1
    },
    {
      "asset_id": 5779,
      "resettable": 1,
      "name": "Ooze Generator",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2758,
      "activated": 1,
      "icon_name": "terrainslime",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "At the end of your turn, spaces adjacent to terrain generated by this ability become Ooze.  When this relic leaves play, at end of turn, and the end of each turn thereafter, this terrain manipulation effect ends on the most recently affected spaces.",
      "long_description": "At the end of your turn, spaces adjacent to terrain generated by this ability become Ooze.  When this relic leaves play, at end of turn, and the end of each turn thereafter, this terrain manipulation effect ends on the most recently affected spaces.",
      "class_name": "OozeGenerator",
      "revision": 1
    },
    {
      "asset_id": 5656,
      "resettable": 1,
      "name": "Ooze Tap",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2528,
      "activated": 1,
      "icon_name": "ooze_tap",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 4,
      "short_description": "When a non-flying opposing champion within 5 spaces enters Ooze, it takes 2 Acid damage and friendly Slags occupying Ooze within 5 spaces of this unit each heal 2 HP. The damage effect of this ability does not stack and each friendly Slag can only be healed to a maximum of 6 HP from the champion entering Ooze.",
      "long_description": "When a non-flying opposing champion within 5 spaces enters Ooze, it takes 2 Acid damage and friendly Slags occupying Ooze within 5 spaces of this unit each heal 2 HP. The damage effect of this ability does not stack and each friendly Slag can only be healed to a maximum of 6 HP from the champion entering Ooze.",
      "class_name": "OozeTap",
      "revision": 1
    },
    {
      "asset_id": 5677,
      "resettable": 1,
      "name": "Oozing",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2549,
      "activated": 1,
      "icon_name": "ooze_tap",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 4,
      "short_description": "This unit has <ability value=2549>Trail: Ooze</ability>. When this unit is damaged, spaces within 3 spaces becomes Ooze for 3 turns and opposing units within 3 spaces become <condition value=scoured>Scoured</condition> and <condition value=grounded>Grounded</condition> for 2 turns.",
      "long_description": "This unit has <ability value=2549>Trail: Ooze</ability>. When this unit is damaged, spaces within 3 spaces becomes Ooze for 3 turns and opposing units within 3 spaces become <condition value=scoured>Scoured</condition> and <condition value=grounded>Grounded</condition> for 2 turns.",
      "class_name": "Oozing",
      "revision": 1
    },
    {
      "asset_id": 5753,
      "resettable": 1,
      "name": "Opportunistic",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2652,
      "activated": 1,
      "icon_name": "opportunistic",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "At the end of your opponent's turn, if this champion was not successfully attacked that turn, it gains 1 AP.",
      "long_description": "At the end of your opponent's turn, if this champion was not successfully attacked that turn, it gains 1 AP.",
      "class_name": "Opportunistic",
      "revision": 1
    },
    {
      "asset_id": 5746,
      "resettable": 1,
      "name": "Opposing Viewpoints",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2635,
      "activated": 1,
      "icon_name": "passive",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "Menalaus and Grimlic of K'thir have opposing viewpoints and refuse to co-operate (they may not be part of the same battlegroup).",
      "long_description": "Menalaus and Grimlic of K'thir have opposing viewpoints and refuse to co-operate (they may not be part of the same battlegroup).",
      "class_name": "Passive",
      "revision": 1
    },
    {
      "asset_id": 5389,
      "resettable": 1,
      "name": "Orb of Frostfall",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 2804,
      "activated": 1,
      "icon_name": "trail_snow",
      "comments": "",
      "prerequisite_id": 2221,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 1,
      "cost": 12,
      "short_description": "Champions within 8 spaces have <ability value=831>Trail: Snow</ability>.  If the affected champion is friendly, it also gains <ability value=600>Arctic</ability>",
      "long_description": "Champions within 8 spaces have <ability value=831>Trail: Snow</ability>.  If the affected champion is friendly, it also gains <ability value=600>Arctic</ability>",
      "class_name": "CurseOfSnowfall",
      "revision": 1
    },
    {
      "asset_id": 5389,
      "resettable": 1,
      "name": "Orb of Frostfall",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 2221,
      "activated": 1,
      "icon_name": "trail_snow",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 1,
      "cost": 8,
      "short_description": "Champions within 5 spaces have <ability value=831>Trail: Snow</ability>.  If the affected champion is friendly, it also gains <ability value=600>Arctic</ability>",
      "long_description": "Champions within 5 spaces have <ability value=831>Trail: Snow</ability>.  If the affected champion is friendly, it also gains <ability value=600>Arctic</ability>",
      "class_name": "CurseOfSnowfall",
      "revision": 1
    },
    {
      "asset_id": 5162,
      "resettable": 1,
      "name": "Orb of Protection",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1935,
      "activated": 1,
      "icon_name": "defenseenhance",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "All friendly Champions receive 20% less damage (after DEF) from spells and ranged attacks while Orb of Protection is in play. When ranged or spell damage occurs to an ally Champion, the Orb of Protection receives 3 damage.",
      "long_description": "All friendly Champions receive 20% less damage (after DEF) from spells and ranged attacks while Orb of Protection is in play. When ranged or spell damage occurs to an ally Champion, the Orb of Protection receives 3 damage.",
      "class_name": "RelicOrbOfProtection",
      "revision": 1
    },
    {
      "asset_id": 5248,
      "resettable": 1,
      "name": "Original Form",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 957,
      "activated": 1,
      "icon_name": "transform",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "This unit is <mechanic value=cleansed>Cleansed</mechanic> and returns to its original form.",
      "long_description": "This unit is <mechanic value=cleansed>Cleansed</mechanic> and returns to its original form.",
      "class_name": "ElfForm",
      "revision": 1
    },
    {
      "asset_id": 7239,
      "resettable": 0,
      "name": "Overkill: Healing",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3056,
      "activated": 1,
      "icon_name": "overkill",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this unit would destroy a unit with a basic attack, it is healed for the amount of damage given beyond the current health of the target.",
      "long_description": "When this unit would destroy a unit with a basic attack, it is healed for the amount of damage given beyond the current health of the target.",
      "class_name": "OverkillHealing",
      "revision": 1
    },
    {
      "asset_id": 5434,
      "resettable": 1,
      "name": "Overkill: Raze",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2284,
      "activated": 1,
      "icon_name": "overkill",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 1,
      "short_description": "Whenever this champion would destroy another champion with a basic attack, any damage over the current health of the target is dealt to that unit's owner's shrine, to a maximum of 5.",
      "long_description": "Whenever this champion would destroy another champion with a basic attack, any damage over the current health of the target is dealt to that unit's owner's shrine, to a maximum of 5.",
      "class_name": "Overkill",
      "revision": 1
    },
    {
      "asset_id": 4375,
      "resettable": 1,
      "name": "Overload",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 2655,
      "activated": 1,
      "icon_name": "electricaoe",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 5,
      "short_description": "Relics within 10 spaces take 10 Electricity damage.",
      "long_description": "Relics within 10 spaces take 10 Electricity damage.",
      "class_name": "RelicOverload",
      "revision": 1
    },
    {
      "asset_id": 5085,
      "resettable": 1,
      "name": "Overlord",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1422,
      "activated": 1,
      "icon_name": "surge",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 7,
      "short_description": "This unit has +1 ATK and +1 DMG for each friendly champion with the minion ability. This champion loses 10 life when a minion is destroyed.",
      "long_description": "This unit has +1 ATK and +1 DMG for each friendly champion with the minion ability. This champion loses 10 life when a minion is destroyed.",
      "class_name": "Overlord",
      "revision": 1
    },
    {
      "asset_id": 4286,
      "resettable": 1,
      "name": "Overseer: Moga",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 676,
      "activated": 1,
      "icon_name": "overseermoga",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 1,
      "short_description": "Friendly units within 5 spaces are not penalized by <ability value=679>G'hernbound</ability>.",
      "long_description": "Friendly units within 5 spaces are not penalized by <ability value=679>G'hernbound</ability>.",
      "class_name": "GhernAura",
      "revision": 1
    },
    {
      "asset_id": 4286,
      "resettable": 1,
      "name": "Overseer: Moga",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 677,
      "activated": 1,
      "icon_name": "overseermoga",
      "comments": "",
      "prerequisite_id": 676,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 4,
      "short_description": "Friendly units within 6 spaces are not penalized by <ability value=679>G'hernbound</ability>.",
      "long_description": "Friendly units within 6 spaces are not penalized by <ability value=679>G'hernbound</ability>.",
      "class_name": "GhernAura",
      "revision": 1
    },
    {
      "asset_id": 4286,
      "resettable": 1,
      "name": "Overseer: Moga",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 678,
      "activated": 1,
      "icon_name": "overseermoga",
      "comments": "",
      "prerequisite_id": 677,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 6,
      "short_description": "Friendly units within 7 spaces are not penalized by <ability value=679>G'hernbound</ability>.",
      "long_description": "Friendly units within 7 spaces are not penalized by <ability value=679>G'hernbound</ability>.",
      "class_name": "GhernAura",
      "revision": 1
    },
    {
      "asset_id": 5066,
      "resettable": 1,
      "name": "Pace",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1242,
      "activated": 1,
      "icon_name": "initiative",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this champion is successfully attacked by a basic attack, it gains 1 AP.",
      "long_description": "When this champion is successfully attacked by a basic attack, it gains 1 AP.",
      "class_name": "Pace",
      "revision": 1
    },
    {
      "asset_id": 7969,
      "resettable": 0,
      "name": "Pacifying Blows",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3356,
      "activated": 1,
      "icon_name": "charm",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "When this champion successfully attacks a champion with a basic attack, the target is Pacified for 1 turn.",
      "long_description": "When this champion successfully attacks a champion with a basic attack, the target is Pacified for 1 turn.",
      "class_name": "PacifyingBlows",
      "revision": 1
    },
    {
      "asset_id": 5317,
      "resettable": 1,
      "name": "Pack Leader",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2146,
      "activated": 1,
      "icon_name": "pack_leader",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 2,
      "short_description": "The first time this champion makes a basic attack against a champion each turn, other champions with <ability value=1938>Pack Mentality</ability> within melee range of the target make a free Physical attack against the same target.",
      "long_description": "The first time this champion makes a basic attack against a champion each turn, other champions with <ability value=1938>Pack Mentality</ability> within melee range of the target make a free Physical attack against the same target.",
      "class_name": "PackLeader",
      "revision": 1
    },
    {
      "asset_id": 5165,
      "resettable": 1,
      "name": "Pack Mentality",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1938,
      "activated": 1,
      "icon_name": "pack_leader",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 2,
      "short_description": "The first time this champion uses the Fuel Rage ability each turn, the ability's CD is set to 0.",
      "long_description": "The first time this champion uses the Fuel Rage ability each turn, the ability's CD is set to 0.",
      "class_name": "PackMentality",
      "revision": 1
    },
    {
      "asset_id": 5218,
      "resettable": 1,
      "name": "Page of K'thiras",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1995,
      "activated": 1,
      "icon_name": "revere",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "While Menalaus or Bowmage are in play, this champion has <ability value=399>Force Barrier 2</ability> and <ability value=897>Mindwipe Aura 2</ability>.",
      "long_description": "While Menalaus or Bowmage are in play, this champion has <ability value=399>Force Barrier 2</ability> and <ability value=897>Mindwipe Aura 2</ability>.",
      "class_name": "MenalausPage",
      "revision": 1
    },
    {
      "asset_id": 5530,
      "resettable": 1,
      "name": "Pain Curse",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2389,
      "activated": 1,
      "icon_name": "defile_corpse",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "Opposing <condition value=cursed>Cursed</condition> champions take 5 magical damage. This damage ignores DEF.",
      "long_description": "Opposing <condition value=cursed>Cursed</condition> champions take 5 magical damage. This damage ignores DEF.",
      "class_name": "PainCurse",
      "revision": 1
    },
    {
      "asset_id": 5662,
      "resettable": 1,
      "name": "Paragon: Jellebrium",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2534,
      "activated": 1,
      "icon_name": "commander_jelly",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "Friendly Jellebrium without this ability gain 5 HP and +1 DMG. Effects from Commander abilities do not stack.",
      "long_description": "Friendly Jellebrium without this ability gain 5 HP and +1 DMG. Effects from Commander abilities do not stack.",
      "class_name": "CommanderJellebrium",
      "revision": 1
    },
    {
      "asset_id": 5108,
      "resettable": 1,
      "name": "Paralysis",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1291,
      "activated": 1,
      "icon_name": "disable",
      "comments": "really just for bots",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "This champion is <condition value=paralyzed>Paralyzed</condition>, <condition value=immobile>Immobile</condition> and <condition value=impervious>Impervious</condition>.",
      "long_description": "This champion is <condition value=paralyzed>Paralyzed</condition>, <condition value=immobile>Immobile</condition> and <condition value=impervious>Impervious</condition>.",
      "class_name": "Paralysis",
      "revision": 1
    },
    {
      "asset_id": 4857,
      "resettable": 1,
      "name": "Paralytic Feedback",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1739,
      "activated": 1,
      "icon_name": "conduit",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "When this champion is successfully attacked by a basic attack from RNG 4 or greater, the attacking champion becomes <condition value=paralyzed>Paralyzed</condition> for 3 turns.",
      "long_description": "When this champion is successfully attacked by a basic attack from RNG 4 or greater, the attacking champion becomes <condition value=paralyzed>Paralyzed</condition> for 3 turns.",
      "class_name": "Feedback",
      "revision": 1
    },
    {
      "asset_id": 5485,
      "resettable": 1,
      "name": "Paralytic Strike",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2344,
      "activated": 1,
      "icon_name": "jolt",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "This champion does double damage to <condition value=paralyzed>Paralyzed</condition> champions.",
      "long_description": "This champion does double damage to <condition value=paralyzed>Paralyzed</condition> champions.",
      "class_name": "ParalyticStrike",
      "revision": 1
    },
    {
      "asset_id": 5484,
      "resettable": 1,
      "name": "Paralyze",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2343,
      "activated": 1,
      "icon_name": "sentry",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "Target champion within 3 spaces becomes <condition value=paralyzed>Paralyzed</condition> for 2 turns.",
      "long_description": "Target champion within 3 spaces becomes <condition value=paralyzed>Paralyzed</condition> for 2 turns.",
      "class_name": "Paralyze",
      "revision": 1
    },
    {
      "asset_id": 5429,
      "resettable": 1,
      "name": "Pariah",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2260,
      "activated": 1,
      "icon_name": "possess",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -5,
      "short_description": "This champion cannot be the target of friendly spells and abilities from other friendly units.",
      "long_description": "This champion cannot be the target of friendly spells and abilities from other friendly units.",
      "class_name": "Pariah",
      "revision": 1
    },
    {
      "asset_id": 4559,
      "resettable": 1,
      "name": "Passive",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 998,
      "activated": 1,
      "icon_name": "passive",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -10,
      "short_description": "This unit does not have a base attack.",
      "long_description": "This unit does not have a base attack.",
      "class_name": "Passive",
      "revision": 1
    },
    {
      "asset_id": 7358,
      "resettable": 0,
      "name": "Path of De'lim",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3115,
      "activated": 1,
      "icon_name": "deploy_chrgd",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "Friendly Elves and Plants gain Walk the Path (This champion is relocated to target space within 5 spaces. This ability may only target spaces within 2 spaces of a Path of De'lim relic. After relocation, the champion deals 3 Fire damage to units within 2 spaces).",
      "long_description": "Friendly Elves and Plants gain Walk the Path (This champion is relocated to target space within 5 spaces. This ability may only target spaces within 2 spaces of a Path of De'lim relic. After relocation, the champion deals 3 Fire damage to units within 2 spaces).",
      "class_name": "PathOfDelim",
      "revision": 1
    },
    {
      "asset_id": 4769,
      "resettable": 1,
      "name": "Pathfinding",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1493,
      "activated": 1,
      "icon_name": "climb",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "All friendly champions that share a race with this one have <ability value=1306>Mountaineer</ability>.",
      "long_description": "All friendly champions that share a race with this one have <ability value=1306>Mountaineer</ability>.",
      "class_name": "Pathfinding",
      "revision": 1
    },
    {
      "asset_id": 5538,
      "resettable": 1,
      "name": "Pawn",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2397,
      "activated": 1,
      "icon_name": "pawn",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "The first time this champion would be damaged by an attack each round, the closest friendly champion takes damage instead.",
      "long_description": "The first time this champion would be damaged by an attack each round, the closest friendly champion takes damage instead.",
      "class_name": "Pawn",
      "revision": 1
    },
    {
      "asset_id": 7997,
      "resettable": 0,
      "name": "Peaks Armaments",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3392,
      "activated": 1,
      "icon_name": "comboatk_devastate",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "When a friendly champion with Race: Cyclops, Race: Voil, Race: G'hern or Race: Moga becomes equipped, it gains 1 AP and +1 DEF for 4 turns. This does not stack.",
      "long_description": "When a friendly champion with Race: Cyclops, Race: Voil, Race: G'hern or Race: Moga becomes equipped, it gains 1 AP and +1 DEF for 4 turns. This does not stack.",
      "class_name": "PeaksArmaments",
      "revision": 1
    },
    {
      "asset_id": 7962,
      "resettable": 0,
      "name": "Peaks Exploit",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3349,
      "activated": 1,
      "icon_name": "exploit_ironfist",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 7,
      "short_description": "When this champion makes a successful basic attack against a target with <condition value=shocked>Shocked</condition>, <condition value=distracted>Distracted</condition> or <condition value=shrunken>Shrunken</condition> it gains 1 AP and has +2 DMG for the attack.",
      "long_description": "When this champion makes a successful basic attack against a target with <condition value=shocked>Shocked</condition>, <condition value=distracted>Distracted</condition> or <condition value=shrunken>Shrunken</condition> it gains 1 AP and has +2 DMG for the attack.",
      "class_name": "PeaksExploit",
      "revision": 1
    },
    {
      "asset_id": 7224,
      "resettable": 0,
      "name": "Penance",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3047,
      "activated": 1,
      "icon_name": "damageshield",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "When this unit is damaged, friendly champions within 3 spaces are healed for 50% of the damage (rounded down), and enemy champions within 3 spaces take Magical damage for 50% of the damage (rounded up, to a maximum of 12, ignores DEF).",
      "long_description": "When this unit is damaged, friendly champions within 3 spaces are healed for 50% of the damage (rounded down), and enemy champions within 3 spaces take Magical damage for 50% of the damage (rounded up, to a maximum of 12, ignores DEF).",
      "class_name": "Penance",
      "revision": 1
    },
    {
      "asset_id": 4297,
      "resettable": 1,
      "name": "Permafrost Obelisk",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 699,
      "activated": 1,
      "icon_name": "buff",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 1,
      "short_description": "This relic has <ability value=600>Arctic</ability>. When a player successfully casts a spell, the opponent's champions gains 3 HP permanently, up to a maximum of 100 HP.",
      "long_description": "This relic has <ability value=600>Arctic</ability>. When a player successfully casts a spell, the opponent's champions gains 3 HP permanently, up to a maximum of 100 HP.",
      "class_name": "RelicPermafrostObelisk",
      "revision": 1
    },
    {
      "asset_id": 4356,
      "resettable": 1,
      "name": "Perseverance",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1389,
      "activated": 1,
      "icon_name": "tgtdefensive",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "Whenever this champion's health falls below 1, it loses Perseverance and it is <mechanic value=cleansed>Cleansed</mechanic>, it's current health is set to 1, and gains <condition value=impervious>Impervious</condition>, <ability value=1237>Impenetrable</ability>, and <ability value=738>Shielded</ability> until the end of turn.",
      "long_description": "Whenever this champion's health falls below 1, it loses Perseverance and it is <mechanic value=cleansed>Cleansed</mechanic>, it's current health is set to 1, and gains <condition value=impervious>Impervious</condition>, <ability value=1237>Impenetrable</ability>, and <ability value=738>Shielded</ability> until the end of turn.",
      "class_name": "Perseverance",
      "revision": 1
    },
    {
      "asset_id": 5743,
      "resettable": 1,
      "name": "Pet: Bloody Imp",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2630,
      "activated": 1,
      "icon_name": "pet",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 15,
      "short_description": "When this champion is deployed, a Bloody Imp with no upgrades is summoned adjacent to it.",
      "long_description": "When this champion is deployed, a Bloody Imp with no upgrades is summoned adjacent to it.",
      "class_name": "PetScreamingImp",
      "revision": 1
    },
    {
      "asset_id": 5558,
      "resettable": 1,
      "name": "Pet: Garu Cub",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2418,
      "activated": 1,
      "icon_name": "pet",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 35,
      "short_description": "When this champion is deployed, a Garu Cub with no upgrades is summoned adjacent to it.",
      "long_description": "When this champion is deployed, a Garu Cub with no upgrades is summoned adjacent to it.",
      "class_name": "PetGaruCub",
      "revision": 1
    },
    {
      "asset_id": 7295,
      "resettable": 0,
      "name": "Pet: Grundelwulf Pup",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3083,
      "activated": 1,
      "icon_name": "pet",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 15,
      "short_description": "When this champion is deployed, a Grundelwulf Pup with no upgrades is summoned adjacent to it.",
      "long_description": "When this champion is deployed, a Grundelwulf Pup with no upgrades is summoned adjacent to it.",
      "class_name": "PetGrundelwulfPup",
      "revision": 1
    },
    {
      "asset_id": 5590,
      "resettable": 1,
      "name": "Pet: Lonx Snowguard",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2449,
      "activated": 1,
      "icon_name": "pet",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "When this champion is deployed, a Level 1 Lonx Snowguard is summoned adjacent to it. ",
      "long_description": "When this champion is deployed, a Level 1 Lonx Snowguard is summoned adjacent to it.",
      "class_name": "PetLonxSnowguard",
      "revision": 1
    },
    {
      "asset_id": 5009,
      "resettable": 1,
      "name": "Pet: Pygmy Hippo",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1890,
      "activated": 1,
      "icon_name": "pet",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 15,
      "short_description": "When this champion is deployed, a Pygmy Hippo with no upgrades is summoned adjacent to it.",
      "long_description": "When this champion is deployed, a Pygmy Hippo with no upgrades is summoned adjacent to it.",
      "class_name": "PetPygmyHippo",
      "revision": 1
    },
    {
      "asset_id": 7776,
      "resettable": 0,
      "name": "Pet: Shadowbunny",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3299,
      "activated": 1,
      "icon_name": "pet",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 15,
      "short_description": "When this champion is deployed, a Shadowbunny with <ability value=3298>Soul Transfer</ability> and no upgrades is summoned adjacent to it.",
      "long_description": "When this champion is deployed, a Shadow Bunny with <ability value=3298>Soul Transfer</ability> and no upgrades is summoned adjacent to it.",
      "class_name": "PetShadowBunny",
      "revision": 1
    },
    {
      "asset_id": 7340,
      "resettable": 0,
      "name": "Pet: Swiftwing",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3109,
      "activated": 1,
      "icon_name": "pet",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 12,
      "short_description": "When this champion is deployed, a Level 1 Swiftwing is summoned adjacent to it.",
      "long_description": "When this champion is deployed, a Level 1 Swiftwing is summoned adjacent to it.",
      "class_name": "PetSwiftwing",
      "revision": 1
    },
    {
      "asset_id": 4538,
      "resettable": 1,
      "name": "Pet: Tamed Lerper",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2135,
      "activated": 1,
      "icon_name": "pet",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 12,
      "short_description": "When this champion is deployed, a Tamed Lerper without upgrades is summoned adjacent to it.",
      "long_description": "When this champion is deployed, a Tamed Lerper without upgrades is summoned adjacent to it.",
      "class_name": "PetWingedLerper",
      "revision": 1
    },
    {
      "asset_id": 5337,
      "resettable": 1,
      "name": "Pet: Tempest Boar",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2267,
      "activated": 1,
      "icon_name": "pet",
      "comments": "Clone of Pet - Winged Lerper. Needs more precise information.",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 15,
      "short_description": "When this champion is deployed, a Level 1 Tempest Boar is summoned adjacent to it.  ",
      "long_description": "When this champion is deployed, a Level 1 Tempest Boar is summoned adjacent to it.  ",
      "class_name": "PetTempestBoar",
      "revision": 1
    },
    {
      "asset_id": 5527,
      "resettable": 1,
      "name": "Pet: Tusk the Mastodon",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2386,
      "activated": 1,
      "icon_name": "pet",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 20,
      "short_description": "When this champion is deployed, Tusk the Mastodon without upgrades is summoned adjacent to it.",
      "long_description": "When this champion is deployed, Tusk the Mastodon without upgrades is summoned adjacent to it.",
      "class_name": "PetMastadonTusk",
      "revision": 1
    },
    {
      "asset_id": 5672,
      "resettable": 1,
      "name": "Pet: Wolf",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2544,
      "activated": 1,
      "icon_name": "pet",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 15,
      "short_description": "When this champion is deployed, a Wolf with no upgrades is summoned adjacent to it.",
      "long_description": "When this champion is deployed, a Wolf with no upgrades is summoned adjacent to it.",
      "class_name": "PetWolf",
      "revision": 1
    },
    {
      "asset_id": 5475,
      "resettable": 1,
      "name": "Petrifying Gaze",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 2334,
      "activated": 1,
      "icon_name": "petrifying_gaze",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "This champion makes an Psychic attack against target opposing champion at Range 1-3. If damaged, the target becomes <condition value=petrified>Petrified</condition> for 4 turns.",
      "long_description": "This champion makes an Psychic attack against target opposing champion at Range 1-3. If damaged, the target becomes <condition value=petrified>Petrified</condition> for 4 turns.",
      "class_name": "PetrifyingGaze",
      "revision": 1
    },
    {
      "asset_id": 7751,
      "resettable": 0,
      "name": "Phalanx Marker",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3279,
      "activated": 1,
      "icon_name": "defenseenhance",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "This unit has <ability value=685>Arrow Eater</ability> and <ability value=117>Regeneration 3</ability> while there is an adjacent real friendly champion",
      "long_description": "This unit has <ability value=685>Arrow Eater</ability> and <ability value=117>Regeneration 3</ability> while there is an adjacent real friendly champion",
      "class_name": "PhalanxMarker",
      "revision": 1
    },
    {
      "asset_id": 4039,
      "resettable": 1,
      "name": "Phantom Dash",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 2644,
      "activated": 1,
      "icon_name": "relocate",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "For 1 turn, the next time a friendly champion makes a successful basic attack against target champion within 6 spaces, this champion is relocated to the closest available space to that champion.",
      "long_description": "For 1 turn, the next time a friendly champion makes a successful basic attack against target champion within 6 spaces, this champion is relocated to the closest available space to that champion.",
      "class_name": "PhantomDash",
      "revision": 1
    },
    {
      "asset_id": 5069,
      "resettable": 1,
      "name": "Phase Cleansing",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1245,
      "activated": 1,
      "icon_name": "blessed",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "When this champion becomes <condition value=incorporeal popup=false>Incorporeal</condition>, it is <mechanic value=cleansed>Cleansed</mechanic>",
      "long_description": "When this champion becomes <condition value=incorporeal popup=false>Incorporeal</condition>, it is <mechanic value=cleansed>Cleansed</mechanic>",
      "class_name": "PhaseCleansing",
      "revision": 1
    },
    {
      "asset_id": 4128,
      "resettable": 1,
      "name": "Phase Shift",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 326,
      "activated": 1,
      "icon_name": "ethereal",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "This unit becomes <condition value=incorporeal>Incorporeal</condition> for 2 turns.",
      "long_description": "This unit becomes <condition value=incorporeal>Incorporeal</condition> for 2 turns.",
      "class_name": "PhaseShift",
      "revision": 1
    },
    {
      "asset_id": 4892,
      "resettable": 1,
      "name": "Phylactery Bound",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1774,
      "activated": 1,
      "icon_name": "phylactery",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 15,
      "short_description": "When this unit is deployed from the runedock, a Phylactery relic is summoned in the closest friendly deployment zone.",
      "long_description": "When this unit is deployed from the runedock, a Phylactery relic is summoned in the closest friendly deployment zone.",
      "class_name": "PhylacteryBound",
      "revision": 1
    },
    {
      "asset_id": 5594,
      "resettable": 1,
      "name": "Physical Amped",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2737,
      "activated": 1,
      "icon_name": "amped_physical",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "This champion loses a charge at the end of its turn. While this champion has at least 8 charges, it has +1 SPD, +2 DMG, +2 DEF and Physical Aura 3.",
      "long_description": "This champion loses a charge at the end of its turn. While this champion has at least 8 charges, it has +1 SPD, +2 DMG, +2 DEF and Physical Aura 3.",
      "class_name": "PhysicalAmped",
      "revision": 1
    },
    {
      "asset_id": 4941,
      "resettable": 1,
      "name": "Pick Up",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 1826,
      "activated": 1,
      "icon_name": "buff",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Pick up target relic and equip it.",
      "long_description": "Pick up target relic and equip it.",
      "class_name": "PickUpRelic",
      "revision": 1
    },
    {
      "asset_id": 4140,
      "resettable": 1,
      "name": "Piercing Shot",
      "ap_cost": 1,
      "level": 1,
      "ability_id": 362,
      "activated": 1,
      "icon_name": "defpenalties",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 1,
      "cost": 3,
      "short_description": "This champion makes a ranged attack at +3 DMG and +1 AP.",
      "long_description": "This champion makes a ranged attack at +3 DMG and +1 AP.",
      "class_name": "PiercingShot",
      "revision": 1
    },
    {
      "asset_id": 4140,
      "resettable": 1,
      "name": "Piercing Shot",
      "ap_cost": 1,
      "level": 2,
      "ability_id": 363,
      "activated": 1,
      "icon_name": "defpenalties",
      "comments": "none",
      "prerequisite_id": 362,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 1,
      "cost": 6,
      "short_description": "This champion makes a ranged attack at +6 DMG and +1 AP.",
      "long_description": "This champion makes a ranged attack at +6 DMG and +1 AP.",
      "class_name": "PiercingShot",
      "revision": 1
    },
    {
      "asset_id": 4140,
      "resettable": 1,
      "name": "Piercing Shot",
      "ap_cost": 1,
      "level": 3,
      "ability_id": 364,
      "activated": 1,
      "icon_name": "defpenalties",
      "comments": "none",
      "prerequisite_id": 363,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 1,
      "cost": 9,
      "short_description": "This champion makes a ranged attack at +9 DMG and +1 AP.",
      "long_description": "This champion makes a ranged attack at +9 DMG and +1 AP.",
      "class_name": "PiercingShot",
      "revision": 1
    },
    {
      "asset_id": 5070,
      "resettable": 1,
      "name": "Pilfer",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 1246,
      "activated": 1,
      "icon_name": "antiequip",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 7,
      "short_description": "Equipment on target champion within 2 spaces is destroyed. If this champion is unequipped, that equipment is then equipped on this champion if possible.",
      "long_description": "Equipment on target champion within 2 spaces is destroyed. If this champion is unequipped, that equipment is then equipped on this champion if possible.",
      "class_name": "Pilfer",
      "revision": 1
    },
    {
      "asset_id": 4360,
      "resettable": 1,
      "name": "Pillage",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1393,
      "activated": 1,
      "icon_name": "noragen",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 3,
      "short_description": "When this champion enters an enemy font deployment zone, you gain 6 nora. This can trigger once per turn.",
      "long_description": "When this champion enters an enemy font deployment zone, you gain 6 nora. This can trigger once per turn.",
      "class_name": "Pillage",
      "revision": 1
    },
    {
      "asset_id": 5275,
      "resettable": 1,
      "name": "Pin Down",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2126,
      "activated": 1,
      "icon_name": "pindown",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 3,
      "ranked": 0,
      "cost": 8,
      "short_description": "This unit makes an attack at RNG 2-5 at 50% DMG. If the target is successfully damaged, it becomes <condition value=rooted>Rooted</condition> for 2 turns.",
      "long_description": "This unit makes an attack at RNG 2-5 at 50% DMG. If the target is successfully damaged, it becomes <condition value=rooted>Rooted</condition> for 2 turns.",
      "class_name": "PinDown",
      "revision": 1
    },
    {
      "asset_id": 5423,
      "resettable": 1,
      "name": "Pirate's Treasure",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2254,
      "activated": 1,
      "icon_name": "pirates_treasure",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "Whenever a friendly Tortun attacks, this unit gains a charge. When this unit is destroyed, an \"X\" appears on a space within 6 spaces. When a friendly champion moves into that space, it gains Recover Treasure (You gain 4 nora for every charge that was on Mangleshell when it was destroyed). ",
      "long_description": "Whenever a friendly Tortun attacks, this unit gains a charge. When this unit is destroyed, an \"X\" appears on a space within 6 spaces. When a friendly champion moves into that space, it gains Recover Treasure (You gain 4 nora for every charge that was on Mangleshell when it was destroyed). \r\n\r\n\r\n\r\n",
      "class_name": "PiratesTreasure",
      "revision": 1
    },
    {
      "asset_id": 5288,
      "resettable": 1,
      "name": "Pistol Shot",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 2111,
      "activated": 1,
      "icon_name": "gun",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "This unit makes a Physical attack at range 2-5.",
      "long_description": "This unit makes a Physical attack at range 2-5.",
      "class_name": "PistolShot",
      "revision": 1
    },
    {
      "asset_id": 4618,
      "resettable": 1,
      "name": "Pit Dragon Form",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 1033,
      "activated": 1,
      "icon_name": "transform",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "This unit is <mechanic value=cleansed>Cleansed</mechanic> and gains +5 MAX HP, +5 DMG, <ability value=46>Resistance: Physical 1</ability>, and <ability value=50>Resistance: Magical 1</ability>.",
      "long_description": "This unit is <mechanic value=cleansed>Cleansed</mechanic> and gains +5 MAX HP, +5 DMG, <ability value=46>Resistance: Physical 1</ability>, and <ability value=50>Resistance: Magical 1</ability>.",
      "class_name": "PitDragonForm",
      "revision": 1
    },
    {
      "asset_id": 4611,
      "resettable": 1,
      "name": "Plague Trap",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1026,
      "activated": 1,
      "icon_name": "trapdisease",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "When an enemy champion moves within 2 spaces of this relic, this relic is destroyed, and enemy champions within 2 spaces take 6 Disease damage and become <condition value=diseased>Diseased</condition> and <condition value=inhibited>Inhibited</condition> for 3 turns. This damage ignores DEF.",
      "long_description": "When an enemy champion moves within 2 spaces of this relic, this relic is destroyed, and enemy champions within 2 spaces take 6 Disease damage and become <condition value=diseased>Diseased</condition> and <condition value=inhibited>Inhibited</condition> for 3 turns. This damage ignores DEF.",
      "class_name": "RelicBileTrap",
      "revision": 1
    },
    {
      "asset_id": 4304,
      "resettable": 1,
      "name": "Planar Bound",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 680,
      "activated": 1,
      "icon_name": "planar",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "This unit is immune to relocate and remove from play effects.",
      "long_description": "This unit is immune to relocate and remove from play effects.",
      "class_name": "PlanarBound",
      "revision": 1
    },
    {
      "asset_id": 5345,
      "resettable": 1,
      "name": "Planar Hold",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2275,
      "activated": 1,
      "icon_name": "magnetic_hold",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "All champions within 8 spaces, including this one, have <ability value=680>Planar Bound</ability> and <ability value=669>Earthbound</ability>.",
      "long_description": "All champions within 8 spaces, including this one, have <ability value=680>Planar Bound</ability> and <ability value=669>Earthbound</ability>.",
      "class_name": "MagneticHold",
      "revision": 1
    },
    {
      "asset_id": 4656,
      "resettable": 1,
      "name": "Plant Regeneration",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 1083,
      "activated": 1,
      "icon_name": "plantregen",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 2,
      "short_description": "While occupying Grass, Vegetation, Dirt, or Water, this champion has <ability value=115>Regeneration 1</ability>.",
      "long_description": "While occupying Grass, Vegetation, Dirt, or Water, this champion has <ability value=115>Regeneration 1</ability>.",
      "class_name": "PlantRegeneration",
      "revision": 1
    },
    {
      "asset_id": 4656,
      "resettable": 1,
      "name": "Plant Regeneration",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 1084,
      "activated": 1,
      "icon_name": "plantregen",
      "comments": "",
      "prerequisite_id": 1083,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 4,
      "short_description": "While occupying Grass, Vegetation, Dirt, or Water, this champion has <ability value=116>Regeneration 2</ability>.",
      "long_description": "While occupying Grass, Vegetation, Dirt, or Water, this champion has <ability value=116>Regeneration 2</ability>.",
      "class_name": "PlantRegeneration",
      "revision": 1
    },
    {
      "asset_id": 4656,
      "resettable": 1,
      "name": "Plant Regeneration",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 1122,
      "activated": 1,
      "icon_name": "plantregen",
      "comments": "",
      "prerequisite_id": 1084,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 6,
      "short_description": "While occupying Grass, Vegetation, Dirt, or Water, this champion has <ability value=117>Regeneration 3</ability>.",
      "long_description": "While occupying Grass, Vegetation, Dirt, or Water, this champion has <ability value=117>Regeneration 3</ability>.",
      "class_name": "PlantRegeneration",
      "revision": 1
    },
    {
      "asset_id": 4954,
      "resettable": 1,
      "name": "Plant Seed",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 1838,
      "activated": 1,
      "icon_name": "spur",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "The Seed of Potential can be dropped as a relic.",
      "long_description": "The Seed of Potential can be dropped as a relic.",
      "class_name": "DropSeed",
      "revision": 1
    },
    {
      "asset_id": 5758,
      "resettable": 1,
      "name": "Platinum Sigil",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2659,
      "activated": 1,
      "icon_name": "griffin_sigil",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "This champion gains +1 RNG and <ability value=2478>Improve Range</ability> for 5 turns when a friendly unit with a Sigil ability is deployed from the runedock.",
      "long_description": "This champion gains +1 RNG and <ability value=2478>Improve Range</ability> for 5 turns when a friendly unit with a Sigil ability is deployed from the runedock.",
      "class_name": "PlatinumSigil",
      "revision": 1
    },
    {
      "asset_id": 4085,
      "resettable": 1,
      "name": "Poison",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 167,
      "activated": 1,
      "icon_name": "dot_poison",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 3,
      "short_description": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=poisoned>Poisoned</condition> for 3 turns.",
      "long_description": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=poisoned>Poisoned</condition> for 3 turns.",
      "class_name": "Poison",
      "revision": 1
    },
    {
      "asset_id": 4085,
      "resettable": 1,
      "name": "Poison",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 168,
      "activated": 1,
      "icon_name": "dot_poison",
      "comments": "none",
      "prerequisite_id": 167,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 6,
      "short_description": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=poisoned>Poisoned</condition> for 4 turns.",
      "long_description": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=poisoned>Poisoned</condition> for 4 turns.",
      "class_name": "Poison",
      "revision": 1
    },
    {
      "asset_id": 4085,
      "resettable": 1,
      "name": "Poison",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 169,
      "activated": 1,
      "icon_name": "dot_poison",
      "comments": "none",
      "prerequisite_id": 168,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 9,
      "short_description": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=poisoned>Poisoned</condition> for 5 turns.",
      "long_description": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=poisoned>Poisoned</condition> for 5 turns.",
      "class_name": "Poison",
      "revision": 1
    },
    {
      "asset_id": 4079,
      "resettable": 1,
      "name": "Poison Aura",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 143,
      "activated": 1,
      "icon_name": "novapoison",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 2,
      "short_description": "At the beginning of your opponent's turns, this unit deals 2 Poison damage to each champion within 2 spaces. This damage ignores DEF.",
      "long_description": "At the beginning of your opponent's turns, this unit deals 2 Poison damage to each champion within 2 spaces. This damage ignores DEF.",
      "class_name": "DamagingAuraPoison",
      "revision": 1
    },
    {
      "asset_id": 4079,
      "resettable": 1,
      "name": "Poison Aura",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 144,
      "activated": 1,
      "icon_name": "novapoison",
      "comments": "none",
      "prerequisite_id": 143,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 4,
      "short_description": "At the beginning of your opponent's turns, this unit deals 4 Poison damage to each champion within 2 spaces. This damage ignores DEF.",
      "long_description": "At the beginning of your opponent's turns, this unit deals 4 Poison damage to each champion within 2 spaces. This damage ignores DEF.",
      "class_name": "DamagingAuraPoison",
      "revision": 1
    },
    {
      "asset_id": 4079,
      "resettable": 1,
      "name": "Poison Aura",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 145,
      "activated": 1,
      "icon_name": "novapoison",
      "comments": "none",
      "prerequisite_id": 144,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 6,
      "short_description": "At the beginning of your opponent's turns, this unit deals 6 Poison damage to each champion within 2 spaces. This damage ignores DEF.",
      "long_description": "At the beginning of your opponent's turns, this unit deals 6 Poison damage to each champion within 2 spaces. This damage ignores DEF.",
      "class_name": "DamagingAuraPoison",
      "revision": 1
    },
    {
      "asset_id": 4318,
      "resettable": 1,
      "name": "Poison Charge",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 1346,
      "activated": 1,
      "icon_name": "amp_poison",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 5,
      "short_description": "Until end of turn, all Poison damage is increased by 2. This unit loses 5 HP.",
      "long_description": "Until end of turn, all Poison damage is increased by 2. This unit loses 5 HP.",
      "class_name": "PoisonCharge",
      "revision": 1
    },
    {
      "asset_id": 4156,
      "resettable": 1,
      "name": "Poison Cloud",
      "ap_cost": 3,
      "level": 1,
      "ability_id": 426,
      "activated": 1,
      "icon_name": "poison_cloud",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 5,
      "short_description": "Area Effect 2, Range 2: Affected space become <mechanic value=poison_cloud>Poison Cloud</mechanic> for 2 turns.",
      "long_description": "Area Effect 2, Range 2: Affected space become <mechanic value=poison_cloud>Poison Cloud</mechanic> for 2 turns.",
      "class_name": "PoisonCloud",
      "revision": 1
    },
    {
      "asset_id": 4156,
      "resettable": 1,
      "name": "Poison Cloud",
      "ap_cost": 3,
      "level": 2,
      "ability_id": 427,
      "activated": 1,
      "icon_name": "poison_cloud",
      "comments": "none",
      "prerequisite_id": 426,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 8,
      "short_description": "Area Effect 2, Range 3: Affected space become <mechanic value=poison_cloud>Poison Cloud</mechanic> for 2 turns.",
      "long_description": "Area Effect 2, Range 3: Affected space become <mechanic value=poison_cloud>Poison Cloud</mechanic> for 2 turns.",
      "class_name": "PoisonCloud",
      "revision": 1
    },
    {
      "asset_id": 4156,
      "resettable": 1,
      "name": "Poison Cloud",
      "ap_cost": 3,
      "level": 3,
      "ability_id": 428,
      "activated": 1,
      "icon_name": "poison_cloud",
      "comments": "none",
      "prerequisite_id": 427,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 10,
      "short_description": "Area Effect 2, Range 4: Affected space become <mechanic value=poison_cloud>Poison Cloud</mechanic> for 2 turns.",
      "long_description": "Area Effect 2, Range 4: Affected space become <mechanic value=poison_cloud>Poison Cloud</mechanic> for 2 turns.",
      "class_name": "PoisonCloud",
      "revision": 1
    },
    {
      "asset_id": 4661,
      "resettable": 1,
      "name": "Poison Cone",
      "ap_cost": 1,
      "level": 1,
      "ability_id": 1091,
      "activated": 1,
      "icon_name": "poisonaoe",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 6,
      "short_description": "Area Effect 2, Range 5: Affected units take Poison damage equal to 50% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=poisoned>Poisoned</condition> for 2 turns. ",
      "long_description": "Area Effect 2, Range 5: Affected units take Poison damage equal to 50% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=poisoned>Poisoned</condition> for 2 turns. ",
      "class_name": "PoisonCone",
      "revision": 1
    },
    {
      "asset_id": 4661,
      "resettable": 1,
      "name": "Poison Cone",
      "ap_cost": 1,
      "level": 2,
      "ability_id": 1092,
      "activated": 1,
      "icon_name": "poisonaoe",
      "comments": "",
      "prerequisite_id": 1091,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 8,
      "short_description": "Area Effect 2, Range 5: Affected units take Poison damage equal to 65% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=poisoned>Poisoned</condition> for 2 turns. ",
      "long_description": "Area Effect 2, Range 5: Affected units take Poison damage equal to 65% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=poisoned>Poisoned</condition> for 2 turns. ",
      "class_name": "PoisonCone",
      "revision": 1
    },
    {
      "asset_id": 4661,
      "resettable": 1,
      "name": "Poison Cone",
      "ap_cost": 1,
      "level": 3,
      "ability_id": 1093,
      "activated": 1,
      "icon_name": "poisonaoe",
      "comments": "",
      "prerequisite_id": 1092,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 10,
      "short_description": "Area Effect 2, Range 5: Affected units take Poison damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=poisoned>Poisoned</condition> for 2 turns. ",
      "long_description": "Area Effect 2, Range 5: Affected units take Poison damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=poisoned>Poisoned</condition> for 2 turns. ",
      "class_name": "PoisonCone",
      "revision": 1
    },
    {
      "asset_id": 4662,
      "resettable": 1,
      "name": "Poison Eater",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1094,
      "activated": 1,
      "icon_name": "eater_poison",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this unit would take Poison damage, it instead recovers HP equal to half the damage that would have been dealt. This unit cannot be <condition value=poisoned popup=false>Poisoned</condition>.",
      "long_description": "When this unit would take Poison damage, it instead recovers HP equal to half the damage that would have been dealt. This unit cannot be <condition value=poisoned popup=false>Poisoned</condition>.",
      "class_name": "PoisonEater",
      "revision": 1
    },
    {
      "asset_id": 4405,
      "resettable": 1,
      "name": "Poison Sting",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 730,
      "activated": 1,
      "icon_name": "poison",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 7,
      "short_description": "This champion makes a Poison attack at Range 2-5.  If the target is successfully damaged, it becomes<condition value=poisoned>Poisoned</condition> for 3 turns.",
      "long_description": "This champion makes a Poison attack at Range 2-5.  If the target is successfully damaged, it becomes<condition value=poisoned>Poisoned</condition> for 3 turns.",
      "class_name": "Sting",
      "revision": 1
    },
    {
      "asset_id": 4606,
      "resettable": 1,
      "name": "Poison Trap",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1022,
      "activated": 1,
      "icon_name": "trappoison",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "When an enemy champion moves within 2 spaces of the trap, all enemy champions within 2 spaces become <condition value=poisoned>Poisoned</condition> for 3 turns and lose all AP.",
      "long_description": "When an enemy champion moves within 2 spaces of the trap, all enemy champions within 2 spaces become <condition value=poisoned>Poisoned</condition> for 3 turns and lose all AP.",
      "class_name": "RelicPoisonTrap",
      "revision": 1
    },
    {
      "asset_id": 7259,
      "resettable": 0,
      "name": "Poisonburst",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 3066,
      "activated": 1,
      "icon_name": "poisonaoe",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 3,
      "ranked": 0,
      "cost": 8,
      "short_description": "This champion makes an attack at RNG 1-3 for 10 Poison damage.  If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=poisoned>Poisoned</condition> for 3 turns.",
      "long_description": "This champion makes an attack at RNG 1-3 for 10 Poison damage.  If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=poisoned>Poisoned</condition> for 3 turns.",
      "class_name": "PoisonBurst",
      "revision": 1
    },
    {
      "asset_id": 4156,
      "resettable": 1,
      "name": "Poisonous Stench",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2272,
      "activated": 1,
      "icon_name": "poison_cloud",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 12,
      "short_description": "Target a location within 4 spaces. All spaces within a range of 2 of that target are covered in a <mechanic value=poison_cloud>Poison Cloud</mechanic> until the end of the next turn.",
      "long_description": "Target a location within 4 spaces. All spaces within a range of 2 of that target are covered in a <mechanic value=poison_cloud>Poison Cloud</mechanic> until the end of the next turn.",
      "class_name": "PoisonCloud",
      "revision": 1
    },
    {
      "asset_id": 7988,
      "resettable": 0,
      "name": "Pond of Lilies",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3383,
      "activated": 1,
      "icon_name": "hallucinogenic",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "Friendly champions with race: Salaman within 2 spaces gain <ability value=2309>Hallucinogenic</ability>.",
      "long_description": "Friendly champions with race: Salaman within 2 spaces gain <ability value=2309>Hallucinogenic</ability>.",
      "class_name": "RelicPondOfLilies",
      "revision": 1
    },
    {
      "asset_id": 5269,
      "resettable": 1,
      "name": "Ponderous",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2093,
      "activated": 1,
      "icon_name": "lumbering",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -8,
      "short_description": "This champion's AP cost for attacks and attack abilities with an AP cost of 1 or higher is increased by 1.",
      "long_description": "This champion's AP cost for attacks and attack abilities with an AP cost of 1 or higher is increased by 1.",
      "class_name": "Ponderous",
      "revision": 1
    },
    {
      "asset_id": 7536,
      "resettable": 0,
      "name": "Ponderous Blows",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3194,
      "activated": 1,
      "icon_name": "lumbering",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this champion successfully attacks a champion with a basic attack, the target gains <ability value=2093>Ponderous</ability> for 2 turns.",
      "long_description": "When this champion successfully attacks a champion with a basic attack, the target gains <ability value=2093>Ponderous</ability> for 2 turns.",
      "class_name": "PonderousBlows",
      "revision": 1
    },
    {
      "asset_id": 4465,
      "resettable": 1,
      "name": "Portal",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 820,
      "activated": 1,
      "icon_name": "relocate",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "This unit may teleport to any deployment zone its controller controls.",
      "long_description": "This unit may teleport to any deployment zone its controller controls.",
      "class_name": "Portal",
      "revision": 1
    },
    {
      "asset_id": 7675,
      "resettable": 0,
      "name": "Portal (Relic)",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3252,
      "activated": 1,
      "icon_name": "relocate",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "This unit may teleport to any deployment zone its controller controls.",
      "long_description": "This unit may teleport to any deployment zone its controller controls.",
      "class_name": "PortalRelic",
      "revision": 1
    },
    {
      "asset_id": 7673,
      "resettable": 0,
      "name": "Portal Blast",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3251,
      "activated": 1,
      "icon_name": "deploy_chrgd",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 5,
      "short_description": "When this champion is successfully relocated, adjacent champions are knocked back 2 spaces.",
      "long_description": "When this champion is successfully relocated, adjacent champions are knocked back 2 spaces.",
      "class_name": "PortalBlast",
      "revision": 1
    },
    {
      "asset_id": 7372,
      "resettable": 0,
      "name": "Portal Dancer",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3128,
      "activated": 1,
      "icon_name": "deploy_chrgd",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "When this champion is successfully relocated, it gains <ability value=2077>Reflexes 2</ability> and <ability value=1377>Evasive 2</ability> for 2 turns.",
      "long_description": "When this champion is successfully relocated, it gains <ability value=2077>Reflexes 2</ability> and <ability value=1377>Evasive 2</ability> for 2 turns.",
      "class_name": "PortalDancer",
      "revision": 1
    },
    {
      "asset_id": 5495,
      "resettable": 1,
      "name": "Portal Nexus",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2354,
      "activated": 1,
      "icon_name": "relocate",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "All champions within 2 spaces are Relocated to the same random font.",
      "long_description": "All champions within 2 spaces are Relocated to the same random font.",
      "class_name": "PortalNexus",
      "revision": 1
    },
    {
      "asset_id": 7476,
      "resettable": 0,
      "name": "Portal Siphon",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3152,
      "activated": 1,
      "icon_name": "deploy_chrgd",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "When this champion is successfully relocated, enemy champions within 2 spaces lose 2 HP and this champion vampiric heals for an equal amount.",
      "long_description": "When this champion is successfully relocated, enemy champions within 2 spaces lose 2 HP and this champion vampiric heals for an equal amount.",
      "class_name": "PortalSiphon",
      "revision": 1
    },
    {
      "asset_id": 5910,
      "resettable": 0,
      "name": "Portal Walker",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2944,
      "activated": 1,
      "icon_name": "deploy_chrgd",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 5,
      "short_description": "When this champion is successfully relocated, it has +2 DMG until its next attack or for 6 turns.",
      "long_description": "When this champion is successfully relocated, it has +2 DMG until its next attack or for 6 turns.",
      "class_name": "PortalWalker",
      "revision": 1
    },
    {
      "asset_id": 7711,
      "resettable": 0,
      "name": "Portal Watcher",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3265,
      "activated": 1,
      "icon_name": "deploy_chrgd",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 3,
      "ranked": 0,
      "cost": 6,
      "short_description": "When a friendly champion relocates (including this one), this champion gains +1 DMG and a rank of <ability value=15>Multiattack</ability> for 1 turn. This can stack up to 3 times.",
      "long_description": "When a friendly champion relocates (including this one), this champion gains +1 DMG and a rank of <ability value=15>Multiattack</ability> for 1 turn. This can stack up to 3 times.",
      "class_name": "PortalWatcher",
      "revision": 1
    },
    {
      "asset_id": 7566,
      "resettable": 0,
      "name": "Portent",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3211,
      "activated": 1,
      "icon_name": "portent",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "This unit gains a Buffer of 10 HP. Every other round at the start of this units turns, its Buffer is reset to 10 HP.",
      "long_description": "This unit gains a Buffer of 10 HP. Every other round at the start of this units turns, its Buffer is reset to 10 HP.",
      "class_name": "Portent",
      "revision": 1
    },
    {
      "asset_id": 4155,
      "resettable": 1,
      "name": "Possess",
      "ap_cost": 4,
      "level": 1,
      "ability_id": 422,
      "activated": 1,
      "icon_name": "possess",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 1,
      "cost": 8,
      "short_description": "Target enemy champion within 2 spaces is <condition value=possessed>Possessed</condition> by you for 1 turn. This unit is <condition value=paralyzed>Paralyzed</condition> while this effect is active.",
      "long_description": "Target enemy champion within 2 spaces is <condition value=possessed>Possessed</condition> by you for 1 turn. This unit is <condition value=paralyzed>Paralyzed</condition> while this effect is active.",
      "class_name": "Possession",
      "revision": 1
    },
    {
      "asset_id": 4155,
      "resettable": 1,
      "name": "Possess",
      "ap_cost": 4,
      "level": 2,
      "ability_id": 423,
      "activated": 1,
      "icon_name": "possess",
      "comments": "none",
      "prerequisite_id": 422,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 1,
      "cost": 12,
      "short_description": "Target enemy champion within 2 spaces is <condition value=possessed>Possessed</condition> by you for 3 turns. This unit is <condition value=paralyzed>Paralyzed</condition> while this effect is active.",
      "long_description": "Target enemy champion within 2 spaces is <condition value=possessed>Possessed</condition> by you for 3 turns. This unit is <condition value=paralyzed>Paralyzed</condition> while this effect is active.",
      "class_name": "Possession",
      "revision": 1
    },
    {
      "asset_id": 4155,
      "resettable": 1,
      "name": "Possess",
      "ap_cost": 4,
      "level": 3,
      "ability_id": 424,
      "activated": 1,
      "icon_name": "possess",
      "comments": "none",
      "prerequisite_id": 423,
      "cooldown": 6,
      "activation_type": 1,
      "ranked": 1,
      "cost": 18,
      "short_description": "Target enemy champion within 2 spaces is <condition value=possessed>Possessed</condition> by you for 5 turns. This unit is <condition value=paralyzed>Paralyzed</condition> while this effect is active.",
      "long_description": "Target enemy champion within 2 spaces is <condition value=possessed>Possessed</condition> by you for 5 turns. This unit is <condition value=paralyzed>Paralyzed</condition> while this effect is active.",
      "class_name": "Possession",
      "revision": 1
    },
    {
      "asset_id": 4155,
      "resettable": 1,
      "name": "Possession",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 425,
      "activated": 1,
      "icon_name": "possess",
      "comments": "none",
      "prerequisite_id": 424,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 1,
      "cost": 8,
      "short_description": "Target enemy champion within 2 spaces is <condition value=possessed>Possessed</condition> by you for 3 turns, gains 2 AP and gains <ability value=1408>Chasm Walker</ability> for 4 turns. This unit gains <ability value=2474>Font Ignorance</ability> for 3 turns and becomes <condition value=paralyzed>Paralyzed</condition> while this effect is active.",
      "long_description": "Target enemy champion within 2 spaces is <condition value=possessed>Possessed</condition> by you for 3 turns, gains 2 AP and gains <ability value=1408>Chasm Walker</ability> for 4 turns. This unit gains <ability value=2474>Font Ignorance</ability> for 3 turns and becomes <condition value=paralyzed>Paralyzed</condition> while this effect is active.",
      "class_name": "PossessionNew",
      "revision": 1
    },
    {
      "asset_id": 5466,
      "resettable": 1,
      "name": "Pounce",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 2324,
      "activated": 1,
      "icon_name": "pounce",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "This champion is relocated to an empty space adjacent to target enemy unit within 5 spaces and deals Physical damage at +2 DMG against the target.",
      "long_description": "This champion is relocated to an empty space adjacent to target enemy unit within 5 spaces and deals Physical damage at +2 DMG against the target.",
      "class_name": "Pounce",
      "revision": 1
    },
    {
      "asset_id": 4135,
      "resettable": 1,
      "name": "Power Attack",
      "ap_cost": 1,
      "level": 1,
      "ability_id": 342,
      "activated": 1,
      "icon_name": "hammer",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 1,
      "cost": 2,
      "short_description": "This unit makes an attack with +2 DMG.",
      "long_description": "This unit makes an attack with +2 DMG.",
      "class_name": "PowerAttack",
      "revision": 1
    },
    {
      "asset_id": 4135,
      "resettable": 1,
      "name": "Power Attack",
      "ap_cost": 1,
      "level": 2,
      "ability_id": 343,
      "activated": 1,
      "icon_name": "hammer",
      "comments": "none",
      "prerequisite_id": 342,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 1,
      "cost": 4,
      "short_description": "This unit makes an attack with +4 DMG.",
      "long_description": "This unit makes an attack with +4 DMG.",
      "class_name": "PowerAttack",
      "revision": 1
    },
    {
      "asset_id": 4135,
      "resettable": 1,
      "name": "Power Attack",
      "ap_cost": 1,
      "level": 3,
      "ability_id": 344,
      "activated": 1,
      "icon_name": "hammer",
      "comments": "none",
      "prerequisite_id": 343,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 1,
      "cost": 6,
      "short_description": "This unit makes an attack with +6 DMG.",
      "long_description": "This unit makes an attack with +6 DMG.",
      "class_name": "PowerAttack",
      "revision": 1
    },
    {
      "asset_id": 7599,
      "resettable": 0,
      "name": "Power of Devotion",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3227,
      "activated": 1,
      "icon_name": "powerofdevotion",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "This champion has +2 MAX HP for each real friendly Plant or Elf, and an additional +1 DMG if the champion has <ability value=2840>Devotee of De'lim</ability> or <ability value=2820>Sacrifice of De'lim</ability>.",
      "long_description": "This champion has +2 MAX HP for each real friendly Plant or Elf, and an additional +1 DMG if the champion has <ability value=2840>Devotee of De'lim</ability> or <ability value=2820>Sacrifice of De'lim</ability>.",
      "class_name": "PowerOfDevotion",
      "revision": 1
    },
    {
      "asset_id": 4227,
      "resettable": 1,
      "name": "Power Store",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 598,
      "activated": 1,
      "icon_name": "noragen",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 45,
      "short_description": "This champion loses 10 HP and its owner gains 15 Nora.",
      "long_description": "This champion loses 10 HP and its owner gains 15 Nora.",
      "class_name": "PowerStore",
      "revision": 1
    },
    {
      "asset_id": 4893,
      "resettable": 1,
      "name": "Precision",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1775,
      "activated": 1,
      "icon_name": "hunted",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "This champion's attacks cannot miss and ignores the effects of Evasive and Reflexes.",
      "long_description": "This champion's attacks cannot miss and ignores the effects of Evasive and Reflexes.",
      "class_name": "Precision",
      "revision": 1
    },
    {
      "asset_id": 5136,
      "resettable": 1,
      "name": "Predator: Angel",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1927,
      "activated": 1,
      "icon_name": "predator_angel",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 1,
      "short_description": "When this champion comes into play, all Race: Angel champions in play take 10 Magical damage and becomes <condition value=frightened>Frightened</condition>.",
      "long_description": "When this champion comes into play, all Race: Angel champions in play take 10 Magical damage and becomes <condition value=frightened>Frightened</condition>.",
      "class_name": "PredatorAngel",
      "revision": 1
    },
    {
      "asset_id": 4894,
      "resettable": 1,
      "name": "Premonition",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1776,
      "activated": 1,
      "icon_name": "diplomat",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 2,
      "short_description": "When this unit is deployed, champions you own have <ability value=1237>Impenetrable</ability> for 2 turns.",
      "long_description": "When this unit is deployed, champions you own have <ability value=1237>Impenetrable</ability> for 2 turns.",
      "class_name": "Premonition",
      "revision": 1
    },
    {
      "asset_id": 5295,
      "resettable": 1,
      "name": "Preordained",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2118,
      "activated": 1,
      "icon_name": "scry",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "This rune is automatically revealed at the beginning of the game.",
      "long_description": "This rune is automatically revealed at the beginning of the game.",
      "class_name": "Preordained",
      "revision": 1
    },
    {
      "asset_id": 5690,
      "resettable": 1,
      "name": "Preparation",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2574,
      "activated": 1,
      "icon_name": "surge",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "At the end of each of its turns, if this unit did not attack, it has +1 DMG and +1 MAX RNG.  This effect stacks up to 4 times and is reset at the end of turn when this unit makes an attack.",
      "long_description": "At the end of each of its turns, if this unit did not attack, it has +1 DMG and +1 MAX RNG.  This effect stacks up to 4 times and is reset at the end of turn when this unit makes an attack.",
      "class_name": "Preparation",
      "revision": 1
    },
    {
      "asset_id": 4319,
      "resettable": 1,
      "name": "Prepared",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1347,
      "activated": 1,
      "icon_name": "block",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "When this champion is deployed, it gains <condition value=impervious>Impervious</condition> for 4 turns.",
      "long_description": "When this champion is deployed, it gains <condition value=impervious>Impervious</condition> for 4 turns.",
      "class_name": "Prepared",
      "revision": 1
    },
    {
      "asset_id": 5847,
      "resettable": 1,
      "name": "Presidential",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2856,
      "activated": 1,
      "icon_name": "majestic",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "This is a presidential unit.",
      "long_description": "This is a presidential unit.",
      "class_name": "Presidential",
      "revision": 1
    },
    {
      "asset_id": 4348,
      "resettable": 1,
      "name": "Prestige",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1382,
      "activated": 1,
      "icon_name": "iron_will",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "All friendly champions, including this one, within 5 spaces have <ability value=4>Iron Will</ability> and <ability value=3>Fearless</ability>.",
      "long_description": "All friendly champions, including this one, within 5 spaces have <ability value=4>Iron Will</ability> and <ability value=3>Fearless</ability>.",
      "class_name": "Prestige",
      "revision": 1
    },
    {
      "asset_id": 7548,
      "resettable": 0,
      "name": "Prevailing Perception",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3202,
      "activated": 1,
      "icon_name": "prevailingpreception",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "This champion gains the upgraded abilities of the last enemy champion deployed from the runedock while this champion was in play.  This effect lasts until this ability is activated again.",
      "long_description": "This champion gains the upgraded abilities of the last enemy champion deployed from the runedock while this champion was in play.  This effect lasts until this ability is activated again.",
      "class_name": "PrevailingPreception",
      "revision": 1
    },
    {
      "asset_id": 5257,
      "resettable": 1,
      "name": "Pride of Ailur",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2075,
      "activated": 1,
      "icon_name": "warriorspride",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "This champion has <ability value=479>Brushwalker</ability>. When this champion attacks another champion with an attack that costs at least 1 AP, the closest valid friendly champion within 8 spaces with <ability value=2299>Soul of Ailur</ability> gains 1 AP and gains +1 DEF for 6 turns (to a max of +2 DEF).",
      "long_description": "This champion has <ability value=479>Brushwalker</ability>. When this champion attacks another champion with an attack that costs at least 1 AP, the closest valid friendly champion within 8 spaces with <ability value=2299>Soul of Ailur</ability> gains 1 AP and gains +1 DEF for 6 turns (to a max of +2 DEF).",
      "class_name": "PrideOfAilur",
      "revision": 1
    },
    {
      "asset_id": 4189,
      "resettable": 1,
      "name": "Prismatic Crystals",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 531,
      "activated": 1,
      "icon_name": "passive",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "When a non-Fairy champion moves within 3 spaces of this unit, it becomes <condition value=pacified>Pacified</condition> for 2 turns.",
      "long_description": "When a non-Fairy champion moves within 3 spaces of this unit, it becomes <condition value=pacified>Pacified</condition> for 2 turns.",
      "class_name": "RelicPrismaticCrystals",
      "revision": 1
    },
    {
      "asset_id": 7693,
      "resettable": 0,
      "name": "Prismatic Sigil",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3258,
      "activated": 1,
      "icon_name": "griffin_sigil",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 2,
      "short_description": "This champion gains <ability value=764>Frost Attack</ability>, <ability value=767>Fire Attack</ability> and <ability value=766>Magical Attack</ability> for 5 turns when a friendly unit with a Sigil ability is deployed from the runedock.",
      "long_description": "This champion gains <ability value=764>Frost Attack</ability>, <ability value=767>Fire Attack</ability> and <ability value=766>Magical Attack</ability> for 5 turns when a friendly unit with a Sigil ability is deployed from the runedock.",
      "class_name": "PrismaticSigil",
      "revision": 1
    },
    {
      "asset_id": 5570,
      "resettable": 1,
      "name": "Prognostication",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2430,
      "activated": 1,
      "icon_name": "passive",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 12,
      "short_description": "After 3 turns, target champion within 4 spaces becomes <condition value=pacified>Pacified</condition> for 2 turns.  This effect is hidden until triggered.",
      "long_description": "After 3 turns, target champion within 4 spaces becomes <condition value=pacified>Pacified</condition> for 2 turns.  This effect is hidden until triggered.",
      "class_name": "Prognostication",
      "revision": 1
    },
    {
      "asset_id": 4666,
      "resettable": 1,
      "name": "Proliferation",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1490,
      "activated": 1,
      "icon_name": "surge",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 12,
      "short_description": "This champion gains +1 DMG, +1 ATK, +1 DEF and loses 2 HP at the start of each of your turns.",
      "long_description": "This champion gains +1 DMG, +1 ATK, +1 DEF and loses 2 HP at the start of each of your turns.",
      "class_name": "Proliferation",
      "revision": 1
    },
    {
      "asset_id": 5408,
      "resettable": 1,
      "name": "Propagate Charges",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 2240,
      "activated": 1,
      "icon_name": "propagate_charges",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 5,
      "short_description": "All other units in play gain a charge.\r\n\r\n",
      "long_description": "All other units in play gain a charge.\r\n",
      "class_name": "PropagateCharges",
      "revision": 1
    },
    {
      "asset_id": 5072,
      "resettable": 1,
      "name": "Propagate: Carrionling",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1247,
      "activated": 1,
      "icon_name": "propagate_carrionling",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "When this unit takes 5 or more damage, a Death Carrionling with no upgrades is summoned 5 spaces away from this champion (if there are no empty spaces, it will be summoned farther away).",
      "long_description": "When this unit takes 5 or more damage, a Carrionling with no upgrades is summoned 5 spaces away from this champion (if there are no empty spaces, it will be summoned farther away).",
      "class_name": "PropogateCarrionling",
      "revision": 1
    },
    {
      "asset_id": 4402,
      "resettable": 0,
      "name": "Propagate: Emberdawn Spiderling",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3342,
      "activated": 1,
      "icon_name": "propagate_spiderling",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 10,
      "short_description": "When this unit takes 5 or more damage, an Emberdawn Spiderling with no upgrades is summoned 5 spaces away from this champion (if there are no empty spaces, it will be summoned farther away).",
      "long_description": "When this unit takes 5 or more damage, an Emberdawn Spiderling with no upgrades is summoned 5 spaces away from this champion (if there are no empty spaces, it will be summoned farther away).",
      "class_name": "PropagateEmberdawnSpiderling",
      "revision": 1
    },
    {
      "asset_id": 5525,
      "resettable": 1,
      "name": "Propagate: Ice Block",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2384,
      "activated": 1,
      "icon_name": "domain_snow",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this unit takes 5 or more damage, an Ice Block relic with 10 HP is summoned 6 spaces away from this champion (if there are no empty spaces, it will be summoned farther away). This can trigger up to 3 times per turn.",
      "long_description": "When this unit takes 5 or more damage, an Ice Block relic with 10 HP is summoned 6 spaces away from this champion (if there are no empty spaces, it will be summoned farther away). This can trigger up to 3 times per turn.",
      "class_name": "PropagateIceBlock",
      "revision": 1
    },
    {
      "asset_id": 5834,
      "resettable": 1,
      "name": "Propagate: Self (relic)",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 2843,
      "activated": 1,
      "icon_name": "prophetic_balance",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 0,
      "short_description": "At the end of every 6 turns, a copy of this unit (without Propgate: Self and Shadowspawn) is summoned to a random location within 4 spaces of a random friendly copy of this unit.",
      "long_description": "At the end of every 6 turns, a copy of this unit (without Propgate: Self and Shadowspawn) is summoned to a random location within 4 spaces of a random friendly copy of this unit.",
      "class_name": "RelicPropagateSelf",
      "revision": 1
    },
    {
      "asset_id": 5834,
      "resettable": 0,
      "name": "Propagate: Self (relic)",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 2957,
      "activated": 1,
      "icon_name": "prophetic_balance",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 0,
      "short_description": "At the end of every 4 turns, a non-Shadowspawn version of this unit is deployed to a random location within 4 spaces of a random friendly copy of this unit.",
      "long_description": "At the end of every 4 turns, a non-Shadowspawn version of this unit is deployed to a random location within 4 spaces of a random friendly copy of this unit.",
      "class_name": "RelicPropagateSelf",
      "revision": 1
    },
    {
      "asset_id": 4402,
      "resettable": 1,
      "name": "Propagate: Spiderling",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 724,
      "activated": 1,
      "icon_name": "propagate_spiderling",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 10,
      "short_description": "When this unit takes 5 or more damage, a Spiderling with no upgrades is summoned 5 spaces away from this champion (if there are no empty spaces, it will be summoned farther away). This triggers up to 3 times per turn.",
      "long_description": "When this unit takes 5 or more damage, a Spiderling with no upgrades is summoned 5 spaces away from this champion (if there are no empty spaces, it will be summoned farther away). This triggers up to 3 times per turn.",
      "class_name": "Propogate",
      "revision": 1
    },
    {
      "asset_id": 5488,
      "resettable": 1,
      "name": "Prophetic Balance",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2347,
      "activated": 1,
      "icon_name": "prophetic_balance",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 4,
      "short_description": "Whenever an opposing champion gains AP outside of normal AP generation, this champion gains an equal amount of AP.  Any AP gained this way which would be lost due to the AP cap is gained by the closest friendly champion instead.",
      "long_description": "Whenever an opposing champion gains AP outside of normal AP generation, this champion gains an equal amount of AP.  Any AP gained this way which would be lost due to the AP cap is gained by the closest friendly champion instead.",
      "class_name": "PropheticBalance",
      "revision": 1
    },
    {
      "asset_id": 5053,
      "resettable": 1,
      "name": "Protect: Voil",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1231,
      "activated": 1,
      "icon_name": "block",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "Voil friendly champions that are adjacent to this champion have Guarded - Voil (While this champion is adjacent to a friendly Voil, all damage from enemy attacks are prevented).",
      "long_description": "Voil friendly champions that are adjacent to this champion have Guarded - Voil (While this champion is adjacent to a friendly Voil, all damage from enemy attacks are prevented).",
      "class_name": "GuardianVoil",
      "revision": 1
    },
    {
      "asset_id": 5612,
      "resettable": 1,
      "name": "Protective",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2471,
      "activated": 1,
      "icon_name": "protective",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "When another friendly champion that shares a race or class with this one is attacked with a basic attack, this champion gains +2 DMG for 2 turns. This stacks up to 2 times.",
      "long_description": "When another friendly champion that shares a race or class with this one is attacked with a basic attack, this champion gains +2 DMG for 2 turns. This stacks up to 2 times.",
      "class_name": "Protective",
      "revision": 1
    },
    {
      "asset_id": 4316,
      "resettable": 1,
      "name": "Provision: Defense",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1344,
      "activated": 1,
      "icon_name": "plunder",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 3,
      "short_description": "While this champion is equipped, it gains a rank of <ability value=213>Block</ability>, <ability value=597>Unstoppable</ability> and +1 DEF.",
      "long_description": "While this champion is equipped, it gains a rank of <ability value=213>Block</ability>, <ability value=597>Unstoppable</ability> and +1 DEF.",
      "class_name": "ProvisionDefense",
      "revision": 1
    },
    {
      "asset_id": 7363,
      "resettable": 0,
      "name": "Provision: Offense",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3119,
      "activated": 1,
      "icon_name": "plunder",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
      "long_description": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
      "class_name": "ProvisionOffense",
      "revision": 1
    },
    {
      "asset_id": 7364,
      "resettable": 0,
      "name": "Provision: Speed",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3120,
      "activated": 1,
      "icon_name": "plunder",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "While this champion is equipped, it gains +1 SPD and <ability value=6>Mobility</ability>.",
      "long_description": "While this champion is equipped, it gains +1 SPD and <ability value=6>Mobility</ability>.",
      "class_name": "ProvisionSpeed",
      "revision": 1
    },
    {
      "asset_id": 7409,
      "resettable": 0,
      "name": "Provision: Utility",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3148,
      "activated": 1,
      "icon_name": "plunder",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 2,
      "short_description": "While this champion is equipped, it gains <ability value=3062>Shatter Summoned</ability>, <ability value=1306>Mountaineer</ability> and <ability value=13>Detection 3</ability>.",
      "long_description": "While this champion is equipped, it gains <ability value=3062>Shatter Summoned</ability>, <ability value=1306>Mountaineer</ability> and <ability value=13>Detection 3</ability>.",
      "class_name": "ProvisionUtility",
      "revision": 1
    },
    {
      "asset_id": 7481,
      "resettable": 0,
      "name": "Psychic Agony",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3118,
      "activated": 1,
      "icon_name": "psychic_agony",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 8,
      "short_description": "The first time this champion falls below 50% HP, enemy champions take 5 Psychic damage. If the champion is <condition value=soultapped>Soultapped</condition>, it becomes <condition value=ensnared>Ensnared</condition> and <condition value=confused>Confused</condition> for 2 turns.",
      "long_description": "The first time this champion falls below 50% HP, enemy champions take 5 Psychic damage. If the champion is <condition value=soultapped>Soultapped</condition>, it becomes <condition value=ensnared>Ensnared</condition> and <condition value=confused>Confused</condition> for 2 turns.",
      "class_name": "PsychicAgony",
      "revision": 1
    },
    {
      "asset_id": 5361,
      "resettable": 1,
      "name": "Psychic Amped",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2193,
      "activated": 1,
      "icon_name": "amped_psychic",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "This champion loses a charge at the end of its turn. While this champion has at least 8 charges, it has +1 SPD, +2 DMG, +2 DEF and <ability value=161>Psychic Aura 3</ability>.",
      "long_description": "This champion loses a charge at the end of its turn. While this champion has at least 8 charges, it has +1 SPD, +2 DMG, +2 DEF and <ability value=161>Psychic Aura 3</ability>.",
      "class_name": "Amped",
      "revision": 1
    },
    {
      "asset_id": 7148,
      "resettable": 0,
      "name": "Psychic Anguish",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2990,
      "activated": 1,
      "icon_name": "psychic_anguish",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 6,
      "short_description": "Enemy champions within 5 spaces of this unit who take Psychic damage become <condition value=soultapped>Soultapped</condition> for 5 turns.",
      "long_description": "Enemy champions within 5 spaces of this unit who take Psychic damage become <condition value=soultapped>Soultapped</condition> for 5 turns.",
      "class_name": "PsychicAnguish",
      "revision": 1
    },
    {
      "asset_id": 4083,
      "resettable": 1,
      "name": "Psychic Aura",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 159,
      "activated": 1,
      "icon_name": "novapsychic",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 2,
      "short_description": "At the beginning of your opponent's turns, this unit deals 2 Psychic damage to each champion within 2 spaces. This damage ignores DEF.",
      "long_description": "At the beginning of your opponent's turns, this unit deals 2 Psychic damage to each champion within 2 spaces. This damage ignores DEF.",
      "class_name": "DamagingAuraPsychic",
      "revision": 1
    },
    {
      "asset_id": 4083,
      "resettable": 1,
      "name": "Psychic Aura",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 160,
      "activated": 1,
      "icon_name": "novapsychic",
      "comments": "none",
      "prerequisite_id": 159,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 4,
      "short_description": "At the beginning of your opponent's turns, this unit deals 4 Psychic damage to each champion within 2 spaces. This damage ignores DEF.",
      "long_description": "At the beginning of your opponent's turns, this unit deals 4 Psychic damage to each champion within 2 spaces. This damage ignores DEF.",
      "class_name": "DamagingAuraPsychic",
      "revision": 1
    },
    {
      "asset_id": 4083,
      "resettable": 1,
      "name": "Psychic Aura",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 161,
      "activated": 1,
      "icon_name": "novapsychic",
      "comments": "none",
      "prerequisite_id": 160,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 6,
      "short_description": "At the beginning of your opponent's turns, this unit deals 6 Psychic damage to each champion within 2 spaces. This damage ignores DEF.",
      "long_description": "At the beginning of your opponent's turns, this unit deals 6 Psychic damage to each champion within 2 spaces. This damage ignores DEF.",
      "class_name": "DamagingAuraPsychic",
      "revision": 1
    },
    {
      "asset_id": 7263,
      "resettable": 0,
      "name": "Psychic Blast",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3067,
      "activated": 1,
      "icon_name": "psychicaoe",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this unit makes a basic attack, all opposing champions within 2 spaces of the target take 50% Psychic damage.",
      "long_description": "When this unit makes a basic attack, all opposing champions within 2 spaces of the target take 50% Psychic damage.",
      "class_name": "PsychicBlast",
      "revision": 1
    },
    {
      "asset_id": 7486,
      "resettable": 0,
      "name": "Psychic Compulsion",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 3169,
      "activated": 1,
      "icon_name": "psychic_compulsion",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "Target enemy champion within 5 spaces becomes Compelled (This champion may only target the closest enemy champion to it with activated abilities, including basic attacks) for 4 turns.",
      "long_description": "Target enemy champion within 5 spaces becomes Compelled (This champion may only target the closest enemy champion to it with activated abilities, including basic attacks) for 4 turns.",
      "class_name": "PsychicCompulsion",
      "revision": 1
    },
    {
      "asset_id": 5340,
      "resettable": 1,
      "name": "Psychic Eater",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2269,
      "activated": 1,
      "icon_name": "eater_psychic",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this unit takes Psychic damage, it instead recovers HP equal to half the damage that would have been dealt.",
      "long_description": "When this unit takes Psychic damage, it instead recovers HP equal to half the damage that would have been dealt.",
      "class_name": "PsychicEater",
      "revision": 1
    },
    {
      "asset_id": 5479,
      "resettable": 1,
      "name": "Psychic Magnetism",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2338,
      "activated": 1,
      "icon_name": "pull",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "If this champion is successfully attacked with a ranged attack the attacking champion is relocated 2 spaces closer to this champion.",
      "long_description": "If this champion is successfully attacked with a ranged attack the attacking champion is relocated 2 spaces closer to this champion.",
      "class_name": "PsychicMagnetism",
      "revision": 1
    },
    {
      "asset_id": 4897,
      "resettable": 1,
      "name": "Psychic Ping",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 1779,
      "activated": 1,
      "icon_name": "psychic",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 15,
      "short_description": "When this unit comes into play, it deals 4 Psychic damage to nearest opposing champion within 5 spaces. At the beginning of each turn afterwards, this champion deals 4 Psychic damage to the enemy champion with greatest HP within 5 spaces. ",
      "long_description": "When this unit comes into play, it deals 4 Psychic damage to nearest opposing champion within 5 spaces. At the beginning of each turn afterwards, this champion deals 4 Psychic damage to the enemy champion with greatest HP within 5 spaces. ",
      "class_name": "PsychicPing",
      "revision": 1
    },
    {
      "asset_id": 4897,
      "resettable": 1,
      "name": "Psychic Ping",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 2506,
      "activated": 1,
      "icon_name": "psychic",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 20,
      "short_description": "When this unit comes into play, it deals 6 Psychic damage to nearest opposing champion within 5 spaces. At the beginning of each turn afterwards, this champion deals 6 Psychic damage to the enemy champion with greatest HP within 5 spaces. ",
      "long_description": "When this unit comes into play, it deals 6 Psychic damage to nearest opposing champion within 5 spaces. At the beginning of each turn afterwards, this champion deals 6 Psychic damage to the enemy champion with greatest HP within 5 spaces. ",
      "class_name": "PsychicPing",
      "revision": 1
    },
    {
      "asset_id": 4897,
      "resettable": 1,
      "name": "Psychic Ping",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 2507,
      "activated": 1,
      "icon_name": "psychic",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 25,
      "short_description": "When this unit comes into play, it deals 8 Psychic damage to nearest opposing champion within 5 spaces. At the beginning of each turn afterwards, this champion deals 8 Psychic damage to the enemy champion with greatest HP within 5 spaces. ",
      "long_description": "When this unit comes into play, it deals 8 Psychic damage to nearest opposing champion within 5 spaces. At the beginning of each turn afterwards, this champion deals 8 Psychic damage to the enemy champion with greatest HP within 5 spaces. ",
      "class_name": "PsychicPing",
      "revision": 1
    },
    {
      "asset_id": 4694,
      "resettable": 1,
      "name": "Psychic Pull",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 1057,
      "activated": 1,
      "icon_name": "",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 6,
      "short_description": "When this champion is a victim of a ranged attack, that champion has a 60% chance of being summoned.",
      "long_description": "When this champion is a victim of a ranged attack, that champion has a 60% chance of being summoned.",
      "class_name": "PsychicPull",
      "revision": 1
    },
    {
      "asset_id": 4694,
      "resettable": 1,
      "name": "Psychic Pull",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 1058,
      "activated": 1,
      "icon_name": "",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 6,
      "short_description": "When this champion is a victim of a ranged attack, that champion has a 75% chance of being summoned.",
      "long_description": "When this champion is a victim of a ranged attack, that champion has a 75% chance of being summoned.",
      "class_name": "PsychicPull",
      "revision": 1
    },
    {
      "asset_id": 4694,
      "resettable": 1,
      "name": "Psychic Pull",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 1059,
      "activated": 1,
      "icon_name": "",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 6,
      "short_description": "When this champion is a victim of a ranged attack, that champion has a 90% chance of being summoned.",
      "long_description": "When this champion is a victim of a ranged attack, that champion has a 90% chance of being summoned.",
      "class_name": "PsychicPull",
      "revision": 1
    },
    {
      "asset_id": 5713,
      "resettable": 1,
      "name": "Psychological Warfare",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2665,
      "activated": 1,
      "icon_name": "aggressive",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "This champion deals 4 additional damage and gives <condition name=confused>Confused</condition> for 4 turns to <condition value=frightened popup=false>Frightened</condition> champions on basic attacks.",
      "long_description": "This champion deals 4 additional damage and gives <condition name=confused>Confused</condition> for 4 turns to <condition value=frightened popup=false>Frightened</condition> champions on basic attacks.",
      "class_name": "PsychologicalWarfare",
      "revision": 1
    },
    {
      "asset_id": 5828,
      "resettable": 1,
      "name": "Psychotic Break",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2837,
      "activated": 1,
      "icon_name": "psychotic_break",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "When a unit is destroyed by an attack, this champion gains <ability value=2253>Manic</ability> for 2 turns.",
      "long_description": "When a unit is destroyed by an attack, this champion gains <ability value=2253>Manic</ability> for 2 turns.",
      "class_name": "PsychoticBreak",
      "revision": 1
    },
    {
      "asset_id": 5073,
      "resettable": 1,
      "name": "Pull",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 1248,
      "activated": 1,
      "icon_name": "pull",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "Target enemy champion within 5 spaces is relocated 3 spaces closer to an unoccupied non-damaging, non-chasm space. This ability shares a cooldown with Drop Harpoon.",
      "long_description": "Target enemy champion within 5 spaces is relocated 3 spaces closer to an unoccupied non-damaging, non-chasm space. This ability shares a cooldown with Drop Harpoon.",
      "class_name": "Pull",
      "revision": 1
    },
    {
      "asset_id": 4068,
      "resettable": 1,
      "name": "Pummel",
      "ap_cost": 1,
      "level": 1,
      "ability_id": 108,
      "activated": 1,
      "icon_name": "hammer",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 1,
      "cost": 4,
      "short_description": "This champion makes its basic melee attack against target opposing champion. If successful, this unit makes an additional basic attack for free against the same target.",
      "long_description": "This champion makes its basic melee attack against target opposing champion. If successful, this unit makes an additional basic attack for free against the same target.",
      "class_name": "Pummel",
      "revision": 1
    },
    {
      "asset_id": 4068,
      "resettable": 1,
      "name": "Pummel",
      "ap_cost": 1,
      "level": 2,
      "ability_id": 109,
      "activated": 1,
      "icon_name": "hammer",
      "comments": "none",
      "prerequisite_id": 108,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 7,
      "short_description": "This champion makes its basic melee attack against target opposing champion. If successful, this unit makes an additional basic attack for free against the same target.  This attack costs +1 AP compared to a normal basic attack.",
      "long_description": "This champion makes its basic melee attack against target opposing champion. If successful, this unit makes an additional basic attack for free against the same target.  This attack costs +1 AP compared to a normal basic attack.",
      "class_name": "Pummel",
      "revision": 1
    },
    {
      "asset_id": 4068,
      "resettable": 1,
      "name": "Pummel",
      "ap_cost": 1,
      "level": 3,
      "ability_id": 110,
      "activated": 1,
      "icon_name": "hammer",
      "comments": "none",
      "prerequisite_id": 109,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 1,
      "cost": 10,
      "short_description": "This champion makes its basic melee attack against target opposing champion. If successful, this unit makes an additional basic attack for free against the same target.",
      "long_description": "This champion makes its basic melee attack against target opposing champion. If successful, this unit makes an additional basic attack for free against the same target.",
      "class_name": "Pummel",
      "revision": 1
    },
    {
      "asset_id": 4320,
      "resettable": 1,
      "name": "Punish",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1348,
      "activated": 1,
      "icon_name": "punish",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
      "long_description": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
      "class_name": "Punish",
      "revision": 1
    },
    {
      "asset_id": 5348,
      "resettable": 1,
      "name": "Punishing Aura",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 2277,
      "activated": 1,
      "icon_name": "punishing_aura",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 9,
      "short_description": "At the end of this unit's turn, opposing champions within 5 spaces lose 2 HP for each AP they have.",
      "long_description": "At the end of this unit's turn, opposing champions within 5 spaces lose 2 HP for each AP they have.",
      "class_name": "PunishingAura",
      "revision": 1
    },
    {
      "asset_id": 5348,
      "resettable": 0,
      "name": "Punishing Aura",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 3367,
      "activated": 1,
      "icon_name": "punishing_aura",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 5,
      "short_description": "At the end of this unit's turn, opposing champions within 5 spaces lose 1 HP for each AP they have.",
      "long_description": "At the end of this unit's turn, opposing champions within 5 spaces lose 1 HP for each AP they have.",
      "class_name": "PunishingAura",
      "revision": 1
    },
    {
      "asset_id": 5501,
      "resettable": 1,
      "name": "Punishment",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2360,
      "activated": 1,
      "icon_name": "punishing_aura",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "Whenever an enemy champion within 8 spaces gains charges they lose 3 HP per charge gained.",
      "long_description": "Whenever an enemy champion within 8 spaces gains charges they lose 3 HP per charge gained.",
      "class_name": "Punishment",
      "revision": 1
    },
    {
      "asset_id": 4793,
      "resettable": 1,
      "name": "Puppet Master",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 1527,
      "activated": 1,
      "icon_name": "disable",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 7,
      "short_description": "Target enemy champion within 3 spaces is <condition value=possessed>Possessed</condition>, <condition value=pacified>Pacified</condition> and  gains <ability value=2474>Font Ignorance</ability> for 3 turns and gains this unit's remaining AP. This unit loses all AP and also gains Font Ignorance for 3 turns.",
      "long_description": "Target enemy champion within 3 spaces is <condition value=possessed>Possessed</condition>, <condition value=pacified>Pacified</condition> and  gains <ability value=2474>Font Ignorance</ability> for 3 turns and gains this unit's remaining AP. This unit loses all AP and also gains Font Ignorance for 3 turns.",
      "class_name": "PuppetMaster",
      "revision": 1
    },
    {
      "asset_id": 7164,
      "resettable": 0,
      "name": "Purging Flames",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3007,
      "activated": 1,
      "icon_name": "dispel",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 8,
      "short_description": "When a champion within 5 spaces takes Fire damage, it is <mechanic value=dispelled>Dispelled</mechanic> if it is an enemy champion.  If the champion is friendly, it is <mechanic value=cleansed>Cleansed</mechanic> instead.",
      "long_description": "When a champion within 5 spaces takes Fire damage, it is <mechanic value=dispelled>Dispelled</mechanic> if it is an enemy champion.  If the champion is friendly, it is <mechanic value=cleansed>Cleansed</mechanic> instead.",
      "class_name": "PurgingFlames",
      "revision": 1
    },
    {
      "asset_id": 4628,
      "resettable": 1,
      "name": "Purified",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1052,
      "activated": 1,
      "icon_name": "cleanse",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 5,
      "short_description": "At the beginning of your turn, this unit is <mechanic value=cleansed>Cleansed</mechanic>.",
      "long_description": "At the beginning of your turn, this unit is <mechanic value=cleansed>Cleansed</mechanic>.",
      "class_name": "Purified",
      "revision": 1
    },
    {
      "asset_id": 4450,
      "resettable": 1,
      "name": "Pyro the Patient",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2775,
      "activated": 1,
      "icon_name": "hero",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "This rune is a Limited Edition rune from Plague of Ba'lah, and counts as a Skeletal Rifleman.",
      "long_description": "This rune is a Limited Edition rune from Plague of Ba'lah, and counts as a Skeletal Rifleman.",
      "class_name": "Placeholder",
      "revision": 1
    },
    {
      "asset_id": 8003,
      "resettable": 0,
      "name": "Queen of the Night",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3400,
      "activated": 1,
      "icon_name": "forsaken_conduit",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "This champion has <ability value=2397>Pawn</ability>. Friendly champions with Class: Witch within 5 spaces gain <ability value=2832>Domain: Dead Magic Zone</ability>. If a champion with Lord of Strigoi is in play, this champion gains Race: Vampyre and <ability value=3363>Bloodlust</ability> permanently.",
      "long_description": "This champion has <ability value=2397>Pawn</ability>. Friendly champions with Class: Witch within 5 spaces gain <ability value=2832>Domain: Dead Magic Zone</ability>. If a champion with Lord of Strigoi is in play, this champion gains Race: Vampyre and <ability value=3363>Bloodlust</ability> permanently.",
      "class_name": "QueenOfTheNight",
      "revision": 1
    },
    {
      "asset_id": 5893,
      "resettable": 1,
      "name": "Quest: Complete Training",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2902,
      "activated": 1,
      "icon_name": "opportunistic",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "If this champion kills another champion, it permanently gains +10 MAX HP, +2 DMG and gains Freezing Discipline, then this ability is removed.",
      "long_description": "If this champion kills another champion, it permanently gains +10 MAX HP, +2 DMG and gains Freezing Discipline, then this ability is removed.",
      "class_name": "QuestCompleteTraining",
      "revision": 1
    },
    {
      "asset_id": 7588,
      "resettable": 0,
      "name": "Quest: Crusade",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3222,
      "activated": 1,
      "icon_name": "opportunistic",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "The first time this champion moves within 3 spaces of an enemy avatar, shrine or font, it is healed for 25 HP and permanently gains +1 DEF, +2 DMG and <ability value=2276>Inquisition</ability>.",
      "long_description": "The first time this champion moves within 3 spaces of an enemy avatar, shrine or font, it is healed for 25 HP and permanently gains +1 DEF, +2 DMG and <ability value=2276>Inquisition</ability>.",
      "class_name": "QuestVisions",
      "revision": 1
    },
    {
      "asset_id": 5144,
      "resettable": 1,
      "name": "Quest: Damage",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1892,
      "activated": 1,
      "icon_name": "opportunistic",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "Whenever this champion has dealt 25 damage, it permanently gains +2 DMG and a rank of <ability value=15>Multiattack</ability>. When this champion has dealt 50 damage it permanently gains another +2 DMG and another rank of Multiattack.",
      "long_description": "Whenever this champion has dealt 25 damage, it permanently gains +2 DMG and a rank of <ability value=15>Multiattack</ability>. When this champion has dealt 50 damage it permanently gains another +2 DMG and another rank of Multiattack.",
      "class_name": "QuestDamage",
      "revision": 1
    },
    {
      "asset_id": 5604,
      "resettable": 1,
      "name": "Quest: Kill Enemy",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2463,
      "activated": 1,
      "icon_name": "opportunistic",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "When this champion destroys an enemy champion, it loses this ability, is healed for 20 HP and permanently gains +3 DMG and +1 DEF.",
      "long_description": "When this champion destroys an enemy champion, it loses this ability, is healed for 20 HP and permanently gains +3 DMG and +1 DEF.",
      "class_name": "QuestKillEnemy",
      "revision": 1
    },
    {
      "asset_id": 5604,
      "resettable": 1,
      "name": "Quest: Runner",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2773,
      "activated": 1,
      "icon_name": "opportunistic",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "For every 10 spaces this champion moves, it permanently gains +1 DMG and +3 MAX HP. This ability is removed after 4 triggers.",
      "long_description": "For every 10 spaces this champion moves, it permanently gains +1 DMG and +3 MAX HP. This ability is removed after 4 triggers.",
      "class_name": "QuestRunner",
      "revision": 1
    },
    {
      "asset_id": 7188,
      "resettable": 0,
      "name": "Quest: Support Ally",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3032,
      "activated": 1,
      "icon_name": "opportunistic",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 12,
      "short_description": "When this champion targets a friendly champion with an ability, this champion permanently gains a rank of <ability value=115>Regeneration</ability>.  On the fourth trigger, this ability is removed and this champion also permanently gains <ability value=372>Heal Mass 3</ability>.",
      "long_description": "When this champion targets a friendly champion with an ability, this champion permanently gains a rank of <ability value=115>Regeneration</ability>.  On the fourth trigger, this ability is removed and this champion also permanently gains <ability value=372>Heal Mass 3</ability>.",
      "class_name": "QuestSupportAlly",
      "revision": 1
    },
    {
      "asset_id": 5125,
      "resettable": 1,
      "name": "Quick-Tempered",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 1307,
      "activated": 1,
      "icon_name": "",
      "comments": "",
      "prerequisite_id": 1315,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 8,
      "short_description": "When this champion is successfully attacked or damaged it gains 2 AP.",
      "long_description": "When this champion is successfully attacked or damaged it gains 2 AP.",
      "class_name": "QuickTempered",
      "revision": 1
    },
    {
      "asset_id": 5125,
      "resettable": 1,
      "name": "Quick-Tempered",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 1315,
      "activated": 1,
      "icon_name": "",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 4,
      "short_description": "When this champion is successfully attacked or damaged it gains 1 AP.",
      "long_description": "When this champion is successfully attacked or damaged it gains 1 AP.",
      "class_name": "QuickTempered",
      "revision": 1
    },
    {
      "asset_id": 4289,
      "resettable": 1,
      "name": "Rabid",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 663,
      "activated": 1,
      "icon_name": "dot_rabid",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 3,
      "short_description": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=diseased>Diseased</condition> for 3 turns.",
      "long_description": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=diseased>Diseased</condition> for 3 turns.",
      "class_name": "Rabid",
      "revision": 1
    },
    {
      "asset_id": 4289,
      "resettable": 1,
      "name": "Rabid",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 664,
      "activated": 1,
      "icon_name": "dot_rabid",
      "comments": "",
      "prerequisite_id": 663,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 6,
      "short_description": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=diseased>Diseased</condition> for 4 turns.",
      "long_description": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=diseased>Diseased</condition> for 4 turns.",
      "class_name": "Rabid",
      "revision": 1
    },
    {
      "asset_id": 4289,
      "resettable": 1,
      "name": "Rabid",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 665,
      "activated": 1,
      "icon_name": "dot_rabid",
      "comments": "",
      "prerequisite_id": 664,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 9,
      "short_description": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=diseased>Diseased</condition> for 5 turns.",
      "long_description": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=diseased>Diseased</condition> for 5 turns.",
      "class_name": "Rabid",
      "revision": 1
    },
    {
      "asset_id": 5346,
      "resettable": 1,
      "name": "Race Charged",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2740,
      "activated": 1,
      "icon_name": "charged_race",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 2,
      "short_description": "At the beginning of its turn, this unit gains 1 charge for every two friendly champion within 6 spaces that shares a race with it, to a maximum of 3 charges.",
      "long_description": "At the beginning of its turn, this unit gains 1 charge for every two friendly champion within 6 spaces that shares a race with it, to a maximum of 3 charges.",
      "class_name": "RaceCharged",
      "revision": 1
    },
    {
      "asset_id": 4961,
      "resettable": 1,
      "name": "Radiant Blow",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 1780,
      "activated": 1,
      "icon_name": "radiant_blow",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "This champion makes a Fire attack at +2 DMG.  All opposing champions within 2 spaces of the target become <condition value=blinded>Blinded</condition> for 2 turns.",
      "long_description": "This champion makes a Fire attack at +2 DMG.  All opposing champions within 2 spaces of the target become <condition value=blinded>Blinded</condition> for 2 turns.",
      "class_name": "RadiantBlow",
      "revision": 1
    },
    {
      "asset_id": 7545,
      "resettable": 0,
      "name": "Raider",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3199,
      "activated": 1,
      "icon_name": "raider",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "You gain 4 nora when an enemy relic is destroyed.  If the relic was Summoned, you gain 2 nora instead.",
      "long_description": "You gain 4 nora when an enemy relic is destroyed.  If the relic was Summoned, you gain 2 nora instead.",
      "class_name": "Raider",
      "revision": 1
    },
    {
      "asset_id": 4660,
      "resettable": 1,
      "name": "Rain of Arrows",
      "ap_cost": 1,
      "level": 1,
      "ability_id": 1088,
      "activated": 1,
      "icon_name": "arrowaoe",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 6,
      "short_description": "Area Effect 2, Range 5: Affected units in the affected area take Physical damage equal to 50% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=eviscerated>Eviscerated</condition> for 2 turns.",
      "long_description": "Area Effect 2, Range 5: Affected units in the affected area take Physical damage equal to 50% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=eviscerated>Eviscerated</condition> for 2 turns.",
      "class_name": "RainOfArrows",
      "revision": 1
    },
    {
      "asset_id": 4660,
      "resettable": 1,
      "name": "Rain of Arrows",
      "ap_cost": 1,
      "level": 2,
      "ability_id": 1089,
      "activated": 1,
      "icon_name": "arrowaoe",
      "comments": "",
      "prerequisite_id": 1088,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 8,
      "short_description": "Area Effect 2, Range 5: Affected units in the affected area take Physical damage equal to 65% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=eviscerated>Eviscerated</condition> for 2 turns.",
      "long_description": "Area Effect 2, Range 5: Affected units in the affected area take Physical damage equal to 65% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=eviscerated>Eviscerated</condition> for 2 turns.",
      "class_name": "RainOfArrows",
      "revision": 1
    },
    {
      "asset_id": 4660,
      "resettable": 1,
      "name": "Rain of Arrows",
      "ap_cost": 1,
      "level": 3,
      "ability_id": 1090,
      "activated": 1,
      "icon_name": "arrowaoe",
      "comments": "",
      "prerequisite_id": 1089,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 10,
      "short_description": "Area Effect 2, Range 5: Affected units in the affected area take Physical damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=eviscerated>Eviscerated</condition> for 2 turns.",
      "long_description": "Area Effect 2, Range 5: Affected units in the affected area take Physical damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=eviscerated>Eviscerated</condition> for 2 turns.",
      "class_name": "RainOfArrows",
      "revision": 1
    },
    {
      "asset_id": 7798,
      "resettable": 0,
      "name": "Rally",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 3318,
      "activated": 1,
      "icon_name": "allybuffs",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 4,
      "short_description": "Champions (including this one) that come into play under your control within 3 spaces of this unit gain <condition value=impervious>Impervious</condition> for 2 turns.",
      "long_description": "Champions (including this one) that come into play under your control within 3 spaces of this unit gain <condition value=impervious>Impervious</condition> for 2 turns.",
      "class_name": "Rally",
      "revision": 1
    },
    {
      "asset_id": 5456,
      "resettable": 1,
      "name": "Rally",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 2308,
      "activated": 1,
      "icon_name": "allybuffs",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 10,
      "short_description": "Champions (including this one) that come into play under your control within 3 spaces of this unit gain <condition value=impervious>Impervious</condition> for 4 turns.",
      "long_description": "Champions (including this one) that come into play under your control within 3 spaces of this unit gain <condition value=impervious>Impervious</condition> for 4 turns.",
      "class_name": "Rally",
      "revision": 1
    },
    {
      "asset_id": 5140,
      "resettable": 1,
      "name": "Rallying Cries",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 2053,
      "activated": 1,
      "icon_name": "allybuffs",
      "comments": "none",
      "prerequisite_id": 1688,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 8,
      "short_description": "All friendly champions within 3 spaces gain 1 AP at the beginning of your turn.",
      "long_description": "All friendly champions within 3 spaces gain 1 AP at the beginning of your turn.",
      "class_name": "RallyingCries",
      "revision": 1
    },
    {
      "asset_id": 5140,
      "resettable": 1,
      "name": "Rallying Cries",
      "ap_cost": 0,
      "level": 4,
      "ability_id": 2054,
      "activated": 1,
      "icon_name": "allybuffs",
      "comments": "none",
      "prerequisite_id": 2053,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 2,
      "short_description": "All friendly champions within 4 spaces gain 1 AP at the beginning of your turn.",
      "long_description": "All friendly champions within 4 spaces gain 1 AP at the beginning of your turn.",
      "class_name": "RallyingCries",
      "revision": 1
    },
    {
      "asset_id": 5140,
      "resettable": 1,
      "name": "Rallying Cries",
      "ap_cost": 0,
      "level": 5,
      "ability_id": 2055,
      "activated": 1,
      "icon_name": "allybuffs",
      "comments": "none",
      "prerequisite_id": 2054,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 2,
      "short_description": "All friendly champions within 5 spaces gain 1 AP at the beginning of your turn.",
      "long_description": "All friendly champions within 5 spaces gain 1 AP at the beginning of your turn.",
      "class_name": "RallyingCries",
      "revision": 1
    },
    {
      "asset_id": 5140,
      "resettable": 1,
      "name": "Rallying Cries",
      "ap_cost": 0,
      "level": 6,
      "ability_id": 2056,
      "activated": 1,
      "icon_name": "allybuffs",
      "comments": "none",
      "prerequisite_id": 2055,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 2,
      "short_description": "All friendly champions within 6 spaces gain 1 AP at the beginning of your turn.",
      "long_description": "All friendly champions within 6 spaces gain 1 AP at the beginning of your turn.",
      "class_name": "RallyingCries",
      "revision": 1
    },
    {
      "asset_id": 5140,
      "resettable": 1,
      "name": "Rallying Cries",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 1687,
      "activated": 1,
      "icon_name": "allybuffs",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 4,
      "short_description": "All adjacent friendly champions gain 1 AP at the beginning of your turn.",
      "long_description": "All adjacent friendly champions gain 1 AP at the beginning of your turn.",
      "class_name": "RallyingCries",
      "revision": 1
    },
    {
      "asset_id": 5140,
      "resettable": 1,
      "name": "Rallying Cries",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 1688,
      "activated": 1,
      "icon_name": "allybuffs",
      "comments": "none",
      "prerequisite_id": 1687,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 6,
      "short_description": "All friendly champions within 2 spaces gain 1 AP at the beginning of your turn.",
      "long_description": "All friendly champions within 2 spaces gain 1 AP at the beginning of your turn.",
      "class_name": "RallyingCries",
      "revision": 1
    },
    {
      "asset_id": 7992,
      "resettable": 0,
      "name": "Rallying Flag",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3387,
      "activated": 1,
      "icon_name": "allybuffs",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "Friendly champions within 3 spaces of this relic gain +2 DEF and <ability value=1476>Resilient</ability>.",
      "long_description": "Friendly champions within 3 spaces of this relic gain +2 DEF and <ability value=1476>Resilient</ability>.",
      "class_name": "RelicRallyingFlag",
      "revision": 1
    },
    {
      "asset_id": 7709,
      "resettable": 0,
      "name": "Ranged Stance",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 3263,
      "activated": 1,
      "icon_name": "ranged_stance",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "Until this ability is activated again, this champion has -1 SPD and +3 MAX RNG.",
      "long_description": "Until this ability is activated again, this champion has -1 SPD and +3 MAX RNG.",
      "class_name": "RangedStance",
      "revision": 1
    },
    {
      "asset_id": 7201,
      "resettable": 0,
      "name": "Ransack Relic",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 3042,
      "activated": 1,
      "icon_name": "ransack",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "Target relic within three spaces is destroyed, you recover Nora equal to half its Nora cost (rounded down).",
      "long_description": "Target relic within three spaces is destroyed, you recover Nora equal to half its Nora cost (rounded down).",
      "class_name": "RansackRelic",
      "revision": 1
    },
    {
      "asset_id": 5433,
      "resettable": 1,
      "name": "Rapid Growth",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 2283,
      "activated": 1,
      "icon_name": "rapid_growth",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 1,
      "cost": 50,
      "short_description": "Summon a copy of this champion with no upgrades on target space within 5 spaces. This ability costs 20 nora to activate and begins on CD.",
      "long_description": "Summon a copy of this champion with no upgrades on target space within 5 spaces. This ability costs 20 nora to activate and begins on CD.",
      "class_name": "RapidGrowth",
      "revision": 1
    },
    {
      "asset_id": 5914,
      "resettable": 0,
      "name": "Raven Tongue",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 2948,
      "activated": 1,
      "icon_name": "nora_hex",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "Target summoned champion is destroyed, and a Raven Messenger with 10 HP and RNG 1-3 is summoned in its place, under your control",
      "long_description": "Target summoned champion is destroyed, and a Raven Messenger with 10 HP and RNG 1-3 is summoned in its place, under your control",
      "class_name": "RavenTongue",
      "revision": 1
    },
    {
      "asset_id": 5075,
      "resettable": 1,
      "name": "Ravenous Torrent",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 1250,
      "activated": 1,
      "icon_name": "disease",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 5,
      "short_description": "This champion takes 5 HP Disease damage and makes a ranged-combat, Disease attack at DMG 10 and RNG 5. This damage ignores DEF.",
      "long_description": "This champion takes 5 HP Disease damage and makes a ranged-combat, Disease attack at DMG 10 and RNG 5. This damage ignores DEF.",
      "class_name": "RavenousTorrent",
      "revision": 1
    },
    {
      "asset_id": 5578,
      "resettable": 1,
      "name": "Ravish",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2438,
      "activated": 1,
      "icon_name": "overkill",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 5,
      "short_description": "Target real champion you own is destroyed. Closest friendly champion to the target champion gains 35% of the destroyed champion's current HP and DMG.",
      "long_description": "Target real champion you own is destroyed. Closest friendly champion to the target champion gains 35% of the destroyed champion's current HP and DMG.",
      "class_name": "Ravish",
      "revision": 1
    },
    {
      "asset_id": 5076,
      "resettable": 1,
      "name": "Raze",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1251,
      "activated": 1,
      "icon_name": "shrinebad",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this champion comes into play, your opponents shrine takes 5 damage. Transfigured Avatars take 15",
      "long_description": "When this champion comes into play, your opponents shrine takes 5 damage. Transfigured Avatars take 15",
      "class_name": "Raze",
      "revision": 1
    },
    {
      "asset_id": 5077,
      "resettable": 1,
      "name": "Readiness",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1252,
      "activated": 1,
      "icon_name": "defenseenhance",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "This champion has a bonus to DEF equal to half of this unit's AP (rounded down).",
      "long_description": "This champion has a bonus to DEF equal to half of this unit's AP (rounded down).",
      "class_name": "Readiness",
      "revision": 1
    },
    {
      "asset_id": 4389,
      "resettable": 1,
      "name": "Ready",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 1430,
      "activated": 1,
      "icon_name": "buff",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "At the end of its turns, this champion gains 2 AP if it did not activate an ability that turn.",
      "long_description": "At the end of its turns, this champion gains 2 AP if it did not activate an ability that turn.",
      "class_name": "Ready",
      "revision": 1
    },
    {
      "asset_id": 4767,
      "resettable": 1,
      "name": "Ready",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 1492,
      "activated": 1,
      "icon_name": "buff",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "At the end of its turns, this champion gains 1 AP if it did not activate an ability that turn.",
      "long_description": "At the end of its turns, this champion gains 1 AP if it did not activate an ability that turn.",
      "class_name": "Ready",
      "revision": 1
    },
    {
      "asset_id": 5049,
      "resettable": 1,
      "name": "Ready the Catapult",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1532,
      "activated": 1,
      "icon_name": "",
      "comments": "This ability sucks!",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 5,
      "short_description": "This champion gains Stone Bomb (Rank 3) for 50 nora",
      "long_description": "This champion gains Stone Bomb (Rank 3) for 50 nora",
      "class_name": "ReadyCatapult",
      "revision": 1
    },
    {
      "asset_id": 7417,
      "resettable": 0,
      "name": "Reallocate: Speed",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3149,
      "activated": 1,
      "icon_name": "reallocate_speed",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 2,
      "short_description": "This champion has +1 SPD and the next champion you deploy from the runedock permanently has -1 SPD.",
      "long_description": "This champion has +1 SPD and the next champion you deploy from the runedock permanently has -1 SPD.",
      "class_name": "ReallocateSpeed",
      "revision": 1
    },
    {
      "asset_id": 7276,
      "resettable": 0,
      "name": "Rebirth",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3074,
      "activated": 1,
      "icon_name": "revive",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 35,
      "short_description": "When this champion is destroyed, it drops no nora globe and is redeployed in the closest friendly deployment zone without this ability, but gains 5 AP and permanently gains +4 DMG and +25 MAX HP.",
      "long_description": "When this champion is destroyed, it drops no nora globe and is redeployed in the closest friendly deployment zone without this ability, but gains 5 AP and permanently gains +4 DMG and +25 MAX HP.",
      "class_name": "Rebirth",
      "revision": 1
    },
    {
      "asset_id": 5148,
      "resettable": 1,
      "name": "Rebuke",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 1673,
      "activated": 1,
      "icon_name": "rebuke",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 1,
      "short_description": "Whenever an opposing champion within 5 spaces gains AP through spells and abilities, it takes 1 electricity damage per AP gained.",
      "long_description": "Whenever an opposing champion within 5 spaces gains AP through spells and abilities, it takes 1 electricity damage per AP gained.",
      "class_name": "Rebuke",
      "revision": 1
    },
    {
      "asset_id": 5148,
      "resettable": 1,
      "name": "Rebuke",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 1674,
      "activated": 1,
      "icon_name": "rebuke",
      "comments": "none",
      "prerequisite_id": 1673,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 2,
      "short_description": "Whenever an opposing champion within 6 spaces gains AP through spells and abilities, it takes 2 electricity damage per AP gained.",
      "long_description": "Whenever an opposing champion within 6 spaces gains AP through spells and abilities, it takes 2 electricity damage per AP gained.",
      "class_name": "Rebuke",
      "revision": 1
    },
    {
      "asset_id": 5148,
      "resettable": 1,
      "name": "Rebuke",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 2063,
      "activated": 1,
      "icon_name": "rebuke",
      "comments": "none",
      "prerequisite_id": 1674,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 3,
      "short_description": "Whenever an opposing champion within 7 spaces gains AP through spells and abilities, it takes 3 electricity damage per AP gained.",
      "long_description": "Whenever an opposing champion within 7 spaces gains AP through spells and abilities, it takes 3 electricity damage per AP gained.",
      "class_name": "Rebuke",
      "revision": 1
    },
    {
      "asset_id": 5148,
      "resettable": 1,
      "name": "Rebuke",
      "ap_cost": 0,
      "level": 4,
      "ability_id": 2064,
      "activated": 1,
      "icon_name": "rebuke",
      "comments": "none",
      "prerequisite_id": 2063,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 4,
      "short_description": "Whenever an opposing champion within 8 spaces gains AP through spells and abilities, it takes 4 electricity damage per AP gained.",
      "long_description": "Whenever an opposing champion within 8 spaces gains AP through spells and abilities, it takes 4 electricity damage per AP gained.",
      "class_name": "Rebuke",
      "revision": 1
    },
    {
      "asset_id": 5356,
      "resettable": 1,
      "name": "Recharge",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2188,
      "activated": 1,
      "icon_name": "recharge",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "Spend 5 Charges. Current cooldowns of this champion's other abilities are reduced by 3.",
      "long_description": "Spend 5 Charges. Current cooldowns of this champion's other abilities are reduced by 3.",
      "class_name": "Recharge",
      "revision": 1
    },
    {
      "asset_id": 7451,
      "resettable": 0,
      "name": "Reckless",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3158,
      "activated": 1,
      "icon_name": "reckless",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -4,
      "short_description": "When this champion spends 4 or more AP on attacks and abilities in a single turn, it loses 4 HP.",
      "long_description": "When this champion spends 4 or more AP on attacks and abilities in a single turn, it loses 4 HP.",
      "class_name": "Reckless",
      "revision": 1
    },
    {
      "asset_id": 4589,
      "resettable": 1,
      "name": "Reckless Blast",
      "ap_cost": 1,
      "level": 1,
      "ability_id": 960,
      "activated": 1,
      "icon_name": "magicaoe",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 2,
      "short_description": "This unit makes a Magical attack at RNG 2-5 at 8 DMG and the closest friendly champion to the damaged champion takes 4 magic damage as well. This damage ignores DEF.",
      "long_description": "This unit makes a Magical attack at RNG 2-5 at 8 DMG and the closest friendly champion to the damaged champion takes 4 magic damage as well. This damage ignores DEF.",
      "class_name": "RecklessBlast",
      "revision": 1
    },
    {
      "asset_id": 4589,
      "resettable": 1,
      "name": "Reckless Blast",
      "ap_cost": 1,
      "level": 2,
      "ability_id": 961,
      "activated": 1,
      "icon_name": "magicaoe",
      "comments": "",
      "prerequisite_id": 960,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 4,
      "short_description": "This unit makes a Magical attack at RNG 2-5 at 10 DMG and the closest friendly champion to the damaged champion takes 4 magic damage as well. This damage ignores DEF.",
      "long_description": "This unit makes a Magical attack at RNG 2-5 at 10 DMG and the closest friendly champion to the damaged champion takes 4 magic damage as well. This damage ignores DEF.",
      "class_name": "RecklessBlast",
      "revision": 1
    },
    {
      "asset_id": 4589,
      "resettable": 1,
      "name": "Reckless Blast",
      "ap_cost": 1,
      "level": 3,
      "ability_id": 962,
      "activated": 1,
      "icon_name": "magicaoe",
      "comments": "",
      "prerequisite_id": 961,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 6,
      "short_description": "This unit makes a Magical attack at RNG 2-5 at 12 DMG and the closest friendly champion to the damaged champion takes 4 magic damage as well. This damage ignores DEF.",
      "long_description": "This unit makes a Magical attack at RNG 2-5 at 12 DMG and the closest friendly champion to the damaged champion takes 4 magic damage as well. This damage ignores DEF.",
      "class_name": "RecklessBlast",
      "revision": 1
    },
    {
      "asset_id": 4480,
      "resettable": 1,
      "name": "Reckless Flight",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 874,
      "activated": 1,
      "icon_name": "wandering_new",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -10,
      "short_description": "At the beginning of your turn, this unit moves 2 spaces randomly, usually towards your enemy's Shrine or Avatar. This unit cannot spend AP on movement. This unit has mobility.",
      "long_description": "At the beginning of your turn, this unit moves 2 spaces randomly, usually towards your enemy's Shrine or Avatar. This unit cannot spend AP on movement. This unit has mobility.",
      "class_name": "RecklessFlight",
      "revision": 1
    },
    {
      "asset_id": 5821,
      "resettable": 1,
      "name": "Reckless Fury",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2830,
      "activated": 1,
      "icon_name": "reckless_fury",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -5,
      "short_description": "This champion has -1 damage for every 10 nora in your norabank.",
      "long_description": "This champion has -1 damage for every 10 nora in your norabank.",
      "class_name": "RecklessFury",
      "revision": 1
    },
    {
      "asset_id": 4590,
      "resettable": 1,
      "name": "Reckless Teleport",
      "ap_cost": 4,
      "level": 1,
      "ability_id": 963,
      "activated": 1,
      "icon_name": "relocate",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 1,
      "cost": 3,
      "short_description": "Range 6: This champion is relocated to a random location within 2 spaces of target space.",
      "long_description": "Range 6: This champion is relocated to a random location within 2 spaces of target space.",
      "class_name": "RecklessTeleport",
      "revision": 1
    },
    {
      "asset_id": 4590,
      "resettable": 1,
      "name": "Reckless Teleport",
      "ap_cost": 4,
      "level": 2,
      "ability_id": 964,
      "activated": 1,
      "icon_name": "relocate",
      "comments": "",
      "prerequisite_id": 963,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 1,
      "cost": 5,
      "short_description": "Range 7: This champion is relocated to a random location within 2 spaces of target space.",
      "long_description": "Range 7: This champion is relocated to a random location within 2 spaces of target space.",
      "class_name": "RecklessTeleport",
      "revision": 1
    },
    {
      "asset_id": 4590,
      "resettable": 1,
      "name": "Reckless Teleport",
      "ap_cost": 4,
      "level": 3,
      "ability_id": 965,
      "activated": 1,
      "icon_name": "relocate",
      "comments": "",
      "prerequisite_id": 964,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 1,
      "cost": 7,
      "short_description": "Range 8: This champion is relocated to a random location within 2 spaces of target space.",
      "long_description": "Range 8: This champion is relocated to a random location within 2 spaces of target space.",
      "class_name": "RecklessTeleport",
      "revision": 1
    },
    {
      "asset_id": 7151,
      "resettable": 0,
      "name": "Reclaim Materials",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2993,
      "activated": 1,
      "icon_name": "reclaim_materials",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "When a real friendly Construct is destroyed, you gain 3 nora. This stacks up to 2 times.",
      "long_description": "When a real friendly Construct is destroyed, you gain 3 nora. This stacks up to 2 times.",
      "class_name": "ReclaimMaterials",
      "revision": 1
    },
    {
      "asset_id": 5503,
      "resettable": 1,
      "name": "Reclaim Remains",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 2362,
      "activated": 1,
      "icon_name": "reconstruct",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 2,
      "short_description": "Target adjacent Stitched Remains is destroyed.  This champion gains 12 charges.",
      "long_description": "Target adjacent Stitched Remains is destroyed.  This champion gains 12 charges.",
      "class_name": "ReclaimRemains",
      "revision": 1
    },
    {
      "asset_id": 4704,
      "resettable": 1,
      "name": "Recoil",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1152,
      "activated": 1,
      "icon_name": "knockback",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "When this champion makes a basic attack, it is knocked back 1 space in the direction opposite its target.",
      "long_description": "When this champion makes a basic attack, it is knocked back 1 space in the direction opposite its target.",
      "class_name": "Recoil",
      "revision": 1
    },
    {
      "asset_id": 4279,
      "resettable": 1,
      "name": "Recombine",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 671,
      "activated": 1,
      "icon_name": "reconstruct",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 2,
      "short_description": "Target adjacent real champion which is a copy of this champion is absorbed into this unit: this unit gains HP equal to the target's current HP and the target is removed from play. If this unit has <ability value=670>Replicate</ability>, its cooldown ends.",
      "long_description": "Target adjacent real champion which is a copy of this champion is absorbed into this unit: this unit gains HP equal to the target's current HP and the target is removed from play. If this unit has <ability value=670>Replicate</ability>, its cooldown ends.",
      "class_name": "Recombine",
      "revision": 1
    },
    {
      "asset_id": 5284,
      "resettable": 1,
      "name": "Reconstitute",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2107,
      "activated": 1,
      "icon_name": "heal",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 20,
      "short_description": "At the beginning of your turns, this champion is healed to full HP.",
      "long_description": "At the beginning of your turns, this champion is healed to full HP.",
      "class_name": "Reconstitute",
      "revision": 1
    },
    {
      "asset_id": 5281,
      "resettable": 1,
      "name": "Reconstruct: Blackguard",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2104,
      "activated": 1,
      "icon_name": "reconstruct",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 12,
      "short_description": "Target Stitched Remains relic within 3 spaces is destroyed and a Stitched Blackguard is spawned in the location the relic occupied.  This ability shares a CD with other Reconstruct abilities.",
      "long_description": "Target Stitched Remains relic within 3 spaces is destroyed and a Stitched Blackguard is spawned in the location the relic occupied.  This ability shares a CD with other Reconstruct abilities.",
      "class_name": "ReconstructBlackguard",
      "revision": 1
    },
    {
      "asset_id": 5283,
      "resettable": 1,
      "name": "Reconstruct: Dreameater",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2106,
      "activated": 1,
      "icon_name": "reconstruct",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 12,
      "short_description": "Target Stitched Remains relic within 3 spaces is destroyed and a Stitched Dreameater is spawned in the location the relic occupied.  This ability shares a CD with other Reconstruct abilities.",
      "long_description": "Target Stitched Remains relic within 3 spaces is destroyed and a Stitched Dreameater is spawned in the location the relic occupied.  This ability shares a CD with other Reconstruct abilities.",
      "class_name": "ReconstructDreameater",
      "revision": 1
    },
    {
      "asset_id": 5282,
      "resettable": 1,
      "name": "Reconstruct: Magician",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2105,
      "activated": 1,
      "icon_name": "reconstruct",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 12,
      "short_description": "Target Stitched Remains relic within 3 spaces is destroyed and a Stitched Magician is spawned in the location the relic occupied.  This ability shares a CD with other Reconstruct abilities.",
      "long_description": "Target Stitched Remains relic within 3 spaces is destroyed and a Stitched Magician is spawned in the location the relic occupied.  This ability shares a CD with other Reconstruct abilities.",
      "class_name": "ReconstructMagician",
      "revision": 1
    },
    {
      "asset_id": 5459,
      "resettable": 1,
      "name": "Reconstruct: Mangler",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2311,
      "activated": 1,
      "icon_name": "reconstruct",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 12,
      "short_description": " Target Stitched Remains relic within 3 spaces is destroyed and a Stitched Mangler is spawned in the location the relic occupied. This ability shares a CD with other Reconstruct abilities.",
      "long_description": " Target Stitched Remains relic within 3 spaces is destroyed and a Stitched Mangler is spawned in the location the relic occupied. This ability shares a CD with other Reconstruct abilities.",
      "class_name": "ReconstructMangler",
      "revision": 1
    },
    {
      "asset_id": 5334,
      "resettable": 1,
      "name": "Recover Treasure",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 2264,
      "activated": 1,
      "icon_name": "pirates_treasure",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "You gain 4 nora for every charge that was on the Mangleshell when it was destroyed.",
      "long_description": "You gain 4 nora for every charge that was on the Mangleshell when it was destroyed.",
      "class_name": "RecoverTreasure",
      "revision": 1
    },
    {
      "asset_id": 4317,
      "resettable": 1,
      "name": "Recruit Snowcat",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1345,
      "activated": 1,
      "icon_name": "sumsnowcat",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 15,
      "short_description": "When this champion enters play a Snowcat is summoned in each of your deployment zones.",
      "long_description": "When this champion enters play a Snowcat is summoned in each of your deployment zones.",
      "class_name": "RecruitSnowcat",
      "revision": 1
    },
    {
      "asset_id": 7158,
      "resettable": 0,
      "name": "Red Sand",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3000,
      "activated": 1,
      "icon_name": "AuraNegative",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "This champion takes 3 Fire damage for every AP it spends",
      "long_description": "This champion takes 3 Fire damage for every AP it spends",
      "class_name": "RedSand",
      "revision": 1
    },
    {
      "asset_id": 5186,
      "resettable": 1,
      "name": "Reduce Magic",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1963,
      "activated": 1,
      "icon_name": "dark_aura",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "All magical damage is reduced by 20% (after DEF). This effect does not stack.",
      "long_description": "All magical damage is reduced by 20% (after DEF). This effect does not stack.",
      "class_name": "ReduceMagic",
      "revision": 1
    },
    {
      "asset_id": 4804,
      "resettable": 1,
      "name": "Reflection",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 1557,
      "activated": 1,
      "icon_name": "damageshield",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 2,
      "short_description": "Champions attacking this champion from range take 2 damage of the Attacker's damage type.\r\n",
      "long_description": "Champions attacking this champion from range take 2 damage of the Attacker's damage type.",
      "class_name": "PainSplit",
      "revision": 1
    },
    {
      "asset_id": 4804,
      "resettable": 1,
      "name": "Reflection",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 1603,
      "activated": 1,
      "icon_name": "damageshield",
      "comments": "none",
      "prerequisite_id": 1557,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 3,
      "short_description": "Champions attacking this champion from range take 3 damage of the Attacker's damage type.",
      "long_description": "Champions attacking this champion from range take 3 damage of the Attacker's damage type.",
      "class_name": "PainSplit",
      "revision": 1
    },
    {
      "asset_id": 4804,
      "resettable": 1,
      "name": "Reflection",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 1604,
      "activated": 1,
      "icon_name": "damageshield",
      "comments": "none",
      "prerequisite_id": 1603,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 4,
      "short_description": "Champions attacking this champion from range take 4 damage of the Attacker's damage type.",
      "long_description": "Champions attacking this champion from range take 4 damage of the Attacker's damage type.",
      "class_name": "PainSplit",
      "revision": 1
    },
    {
      "asset_id": 4804,
      "resettable": 1,
      "name": "Reflection",
      "ap_cost": 0,
      "level": 4,
      "ability_id": 1606,
      "activated": 1,
      "icon_name": "damageshield",
      "comments": "none",
      "prerequisite_id": 1604,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 5,
      "short_description": "Champions attacking this champion from range take 5 damage of the Attacker's damage type.",
      "long_description": "Champions attacking this champion from range take 5 damage of the Attacker's damage type.",
      "class_name": "PainSplit",
      "revision": 1
    },
    {
      "asset_id": 4804,
      "resettable": 1,
      "name": "Reflection",
      "ap_cost": 0,
      "level": 5,
      "ability_id": 1608,
      "activated": 1,
      "icon_name": "damageshield",
      "comments": "none",
      "prerequisite_id": 1606,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 6,
      "short_description": "Champions attacking this champion from range take 6 damage of the Attacker's damage type.",
      "long_description": "Champions attacking this champion from range take 6 damage of the Attacker's damage type.",
      "class_name": "PainSplit",
      "revision": 1
    },
    {
      "asset_id": 4804,
      "resettable": 1,
      "name": "Reflection",
      "ap_cost": 0,
      "level": 6,
      "ability_id": 1609,
      "activated": 1,
      "icon_name": "damageshield",
      "comments": "none",
      "prerequisite_id": 1608,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 7,
      "short_description": "Champions attacking this champion from range take 7 damage of the Attacker's damage type.",
      "long_description": "Champions attacking this champion from range take 7 damage of the Attacker's damage type.",
      "class_name": "PainSplit",
      "revision": 1
    },
    {
      "asset_id": 5258,
      "resettable": 1,
      "name": "Reflexes",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 2076,
      "activated": 1,
      "icon_name": "reflexes",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 3,
      "short_description": "This unit takes 20% less damage (after DEF) from melee attacks.",
      "long_description": "This unit takes 20% less damage (after DEF) from melee attacks.",
      "class_name": "Reflexes",
      "revision": 1
    },
    {
      "asset_id": 5258,
      "resettable": 1,
      "name": "Reflexes",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 2077,
      "activated": 1,
      "icon_name": "reflexes",
      "comments": "",
      "prerequisite_id": 2076,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 6,
      "short_description": "This unit takes 35% less damage (after DEF) from melee attacks.",
      "long_description": "This unit takes 35% less damage (after DEF) from melee attacks.",
      "class_name": "Reflexes",
      "revision": 1
    },
    {
      "asset_id": 5258,
      "resettable": 1,
      "name": "Reflexes",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 2078,
      "activated": 1,
      "icon_name": "reflexes",
      "comments": "",
      "prerequisite_id": 2077,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 9,
      "short_description": "This unit takes 50% less damage (after DEF) from melee attacks.",
      "long_description": "This unit takes 50% less damage (after DEF) from melee attacks.",
      "class_name": "Reflexes",
      "revision": 1
    },
    {
      "asset_id": 5796,
      "resettable": 1,
      "name": "Regal Presence",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 331,
      "activated": 1,
      "icon_name": "majestic",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "Friendly champions within 3 spaces that share a race with this champion have <ability value=1932>Loyalty</ability>.",
      "long_description": "Friendly champions within 3 spaces that share a race with this champion have <ability value=1932>Loyalty</ability>.",
      "class_name": "RegalPresence",
      "revision": 1
    },
    {
      "asset_id": 4072,
      "resettable": 1,
      "name": "Regeneration",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 115,
      "activated": 1,
      "icon_name": "regen",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 2,
      "short_description": "At the beginning of your turn, this unit heals 2 HP.",
      "long_description": "At the beginning of your turn, this unit heals 2 HP.",
      "class_name": "Regeneration",
      "revision": 1
    },
    {
      "asset_id": 4072,
      "resettable": 1,
      "name": "Regeneration",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 116,
      "activated": 1,
      "icon_name": "regen",
      "comments": "none",
      "prerequisite_id": 115,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 5,
      "short_description": "At the beginning of your turn, this unit heals 4 HP.",
      "long_description": "At the beginning of your turn, this unit heals 4 HP.",
      "class_name": "Regeneration",
      "revision": 1
    },
    {
      "asset_id": 4072,
      "resettable": 1,
      "name": "Regeneration",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 117,
      "activated": 1,
      "icon_name": "regen",
      "comments": "none",
      "prerequisite_id": 116,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 8,
      "short_description": "At the beginning of your turn, this unit heals 6 HP.",
      "long_description": "At the beginning of your turn, this unit heals 6 HP.",
      "class_name": "Regeneration",
      "revision": 1
    },
    {
      "asset_id": 4900,
      "resettable": 1,
      "name": "Reinforce",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1782,
      "activated": 1,
      "icon_name": "tgtdefensive",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": -10,
      "short_description": "When this unit is deployed the closest champion you own is returned to the rune dock with a cooldown of 10 and you gain 50% of its nora cost.\r\n",
      "long_description": "When this unit is deployed the closest champion you own is returned to the rune dock with a cooldown of 10 and you gain 50% of its nora cost.\r\n",
      "class_name": "Reinforce",
      "revision": 1
    },
    {
      "asset_id": 5663,
      "resettable": 1,
      "name": "Reinforcement",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 2535,
      "activated": 1,
      "icon_name": "reinforcement",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 5,
      "short_description": "When this champion is deployed, it gains 1 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
      "long_description": "When this champion is deployed, it gains 1 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
      "class_name": "Reinforcement",
      "revision": 1
    },
    {
      "asset_id": 5663,
      "resettable": 1,
      "name": "Reinforcement",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 2608,
      "activated": 1,
      "icon_name": "reinforcement",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 8,
      "short_description": "When this champion is deployed, it gains 2 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
      "long_description": "When this champion is deployed, it gains 2 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
      "class_name": "Reinforcement",
      "revision": 1
    },
    {
      "asset_id": 4191,
      "resettable": 1,
      "name": "Rejuvenating Fountain",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 533,
      "activated": 1,
      "icon_name": "healmass",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "Spaces adjacent to this unit become Shallow Water. Friendly champions within 5 spaces gain <ability value=116>Regeneration 2</ability> and <ability value=1052>Purified</ability>.",
      "long_description": "Spaces adjacent to this unit become Shallow Water. Friendly champions within 5 spaces gain <ability value=116>Regeneration 2</ability> and <ability value=1052>Purified</ability>.",
      "class_name": "RelicRejuvenatingFountain",
      "revision": 1
    },
    {
      "asset_id": 4560,
      "resettable": 1,
      "name": "Relic Drop: Spore",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1003,
      "activated": 1,
      "icon_name": "spore",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": -4,
      "short_description": "When this champion is deployed from the runedock, it spends the first 4 turns as a Mushroom relic with 1 DEF and 20 HP.  When this unit is destroyed, it becomes the same mushroom relic without this ability.",
      "long_description": "When this champion is deployed from the runedock, it spends the first 4 turns as a Mushroom relic with 1 DEF and 20 HP.  When this unit is destroyed, it becomes the same mushroom relic without this ability.",
      "class_name": "Sporedrop",
      "revision": 1
    },
    {
      "asset_id": 7380,
      "resettable": 0,
      "name": "Relic Drop: Tomb",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3132,
      "activated": 1,
      "icon_name": "tombdrop",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -4,
      "short_description": "When this champion is deployed from the runedock, it spends the first 4 turns as a Tomb relic with 1 DEF and 20 HP.  When this unit is destroyed, it becomes the same Tomb relic.",
      "long_description": "When this champion is deployed from the runedock, it spends the first 4 turns as a Tomb relic with 1 DEF and 20 HP.  When this unit is destroyed, it becomes the same Tomb relic.",
      "class_name": "Tombdrop",
      "revision": 1
    },
    {
      "asset_id": 5916,
      "resettable": 0,
      "name": "Relic Drop: Tree",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2950,
      "activated": 1,
      "icon_name": "rapid_growth",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -4,
      "short_description": "When this champion is deployed, it spends the first 4 turns as an Tree relic with 1 DEF and 20 HP. When this unit is destroyed, it becomes the same Tree relic.",
      "long_description": "When this champion is deployed, it spends the first 4 turns as an Tree relic with 1 DEF and 20 HP. When this unit is destroyed, it becomes the same Tree relic.",
      "class_name": "Dragonbark",
      "revision": 1
    },
    {
      "asset_id": 5190,
      "resettable": 1,
      "name": "Relic Guardian",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1967,
      "activated": 1,
      "icon_name": "defenseenhance",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 8,
      "short_description": "This champion gains +4 DMG and +2 DEF when it is within 3 spaces of a friendly relic.",
      "long_description": "This champion gains +4 DMG and +2 DEF when it is within 3 spaces of a friendly relic.",
      "class_name": "RelicGuardian",
      "revision": 1
    },
    {
      "asset_id": 4375,
      "resettable": 1,
      "name": "Relic Overload",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1414,
      "activated": 1,
      "icon_name": "electricaoe",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 5,
      "short_description": "Relics within 10 spaces take 10 Electricity damage.",
      "long_description": "Relics within 10 spaces take 10 Electricity damage.",
      "class_name": "RelicOverload",
      "revision": 1
    },
    {
      "asset_id": 4321,
      "resettable": 1,
      "name": "Relieve",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 1349,
      "activated": 1,
      "icon_name": "cleanse",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 2,
      "short_description": "Target champion within 5 spaces is <mechanic value=cleansed>Cleansed</mechanic> and all effects removed are applied to this unit.",
      "long_description": "Target champion within 5 spaces is <mechanic value=cleansed>Cleansed</mechanic> and all effects removed are applied to this unit.",
      "class_name": "Relieve",
      "revision": 1
    },
    {
      "asset_id": 7766,
      "resettable": 0,
      "name": "Reload",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3292,
      "activated": 1,
      "icon_name": "gun",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 2,
      "short_description": "When this champion collects a Nora globe, the counter on its <ability value=1706>Ammunition</ability> ability is reset.",
      "long_description": "When this champion collects a Nora globe, the counter on its <ability value=1706>Ammunition</ability> ability is reset.",
      "class_name": "Reload",
      "revision": 1
    },
    {
      "asset_id": 5678,
      "resettable": 1,
      "name": "Relocate Self",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2550,
      "activated": 1,
      "icon_name": "relocate",
      "comments": "Relic",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "This unit is relocated to target space within 5 spaces.  This ability begins on CD.",
      "long_description": "This unit is relocated to target space within 5 spaces.  This ability begins on CD.",
      "class_name": "RelocateHideout",
      "revision": 1
    },
    {
      "asset_id": 4275,
      "resettable": 1,
      "name": "Relocate: Ally",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 657,
      "activated": 1,
      "icon_name": "relocate",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "Target friendly champion within 5 spaces is relocated to the nearest available space adjacent to this unit. This ability cannot target <ability value=680>Planar Bound</ability> or <mechanic value=immobile>Immobile</mechanic> units.",
      "long_description": "Target friendly champion within 5 spaces is relocated to the nearest available space adjacent to this unit. This ability cannot target <ability value=680>Planar Bound</ability> or <mechanic value=immobile>Immobile</mechanic> units.",
      "class_name": "SummonAlly",
      "revision": 1
    },
    {
      "asset_id": 4963,
      "resettable": 1,
      "name": "Relocate: Arthropod",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 1792,
      "activated": 1,
      "icon_name": "relocate_arthropod",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "Target friendly Arthropod within 5 spaces is relocated to a space adjacent to this unit.",
      "long_description": "Target friendly Arthropod within 5 spaces is relocated to a space adjacent to this unit.",
      "class_name": "SpiderCall",
      "revision": 1
    },
    {
      "asset_id": 4413,
      "resettable": 1,
      "name": "Relocate: Demon",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 741,
      "activated": 1,
      "icon_name": "relocate",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "Target friendly Demon within 5 spaces is relocated to a space adjacent to this unit.",
      "long_description": "Target friendly Demon within 5 spaces is relocated to a space adjacent to this unit.",
      "class_name": "BeckonDemon",
      "revision": 1
    },
    {
      "asset_id": 5845,
      "resettable": 1,
      "name": "Relocate: DMZ",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 2854,
      "activated": 1,
      "icon_name": "special",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "Target friendly champion, within 5 spaces, who is standing on <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic> is relocated next to this unit.",
      "long_description": "Target friendly champion, within 5 spaces, who is standing on <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic> is relocated next to this unit.",
      "class_name": "UtterdarkWormhole",
      "revision": 1
    },
    {
      "asset_id": 4275,
      "resettable": 0,
      "name": "Relocate: Fairy (Relic)",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3346,
      "activated": 1,
      "icon_name": "relocate",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "Target friendly Fairy within 5 spaces is relocated to a space adjacent to this unit.",
      "long_description": "Target friendly Fairy within 5 spaces is relocated to a space adjacent to this unit.",
      "class_name": "RelocateFairy",
      "revision": 1
    },
    {
      "asset_id": 5676,
      "resettable": 1,
      "name": "Relocate: Ferren (Relic)",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2546,
      "activated": 1,
      "icon_name": "relocate",
      "comments": "Relic version",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "Target friendly Ferren within 5 spaces is relocated to a space adjacent to this unit.",
      "long_description": "Target friendly Ferren within 5 spaces is relocated to a space adjacent to this unit.",
      "class_name": "RelocateFerren",
      "revision": 1
    },
    {
      "asset_id": 4357,
      "resettable": 1,
      "name": "Relocate: Relic",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 1390,
      "activated": 1,
      "icon_name": "relocate_relic",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "Target friendly relic within 5 spaces is relocated to the nearest available space adjacent to this unit. This ability cannot target <ability value=680>Planar Bound</ability> or <mechanic value=immobile>Immobile</mechanic> units.",
      "long_description": "Target friendly relic within 5 spaces is relocated to the nearest available space adjacent to this unit. This ability cannot target <ability value=680>Planar Bound</ability> or <mechanic value=immobile>Immobile</mechanic> units.",
      "class_name": "RelocateRelic",
      "revision": 1
    },
    {
      "asset_id": 5362,
      "resettable": 1,
      "name": "Relocation",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2194,
      "activated": 1,
      "icon_name": "relocation",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "Spend 20 charges.   This champion is relocated to target space and loses Rooted.",
      "long_description": "Spend 20 charges.   This champion is relocated to target space and loses Rooted.",
      "class_name": "Relocation",
      "revision": 1
    },
    {
      "asset_id": 5723,
      "resettable": 1,
      "name": "Remembrance of Kings",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2605,
      "activated": 1,
      "icon_name": "novasonic",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 0,
      "short_description": "When this unit is deployed, this unit gains +2 MAX HP for each real friendly Dwarf.",
      "long_description": "When this unit is deployed, this unit gains +2 MAX HP for each real friendly Dwarf.",
      "class_name": "RemembranceOfKings",
      "revision": 1
    },
    {
      "asset_id": 5350,
      "resettable": 1,
      "name": "Remove Charge",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 2182,
      "activated": 1,
      "icon_name": "removed_charged",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 1,
      "short_description": "Target unit within 7 spaces loses a charge and this unit gains a charge.  A unit may only gain charges from Add Charge or Remove Charge once per round.",
      "long_description": "Target unit within 7 spaces loses a charge and this unit gains a charge.  A unit may only gain charges from Add Charge or Remove Charge once per round.",
      "class_name": "RemoveCharge",
      "revision": 1
    },
    {
      "asset_id": 5298,
      "resettable": 1,
      "name": "Remove Disguise",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2121,
      "activated": 1,
      "icon_name": "transform",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "This ability begins play on cooldown.  This unit is destroyed and a Level 3 Garu Shaman, Garu Hunter, or Garu Primitive is spawned in the location this unit occupied.",
      "long_description": "This ability begins play on cooldown.  This unit is destroyed and a Level 3 Garu Shaman, Garu Hunter, or Garu Primitive is spawned in the location this unit occupied.",
      "class_name": "RemoveDisguise",
      "revision": 1
    },
    {
      "asset_id": 4084,
      "resettable": 1,
      "name": "Rend",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 163,
      "activated": 1,
      "icon_name": "dot_rend",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 3,
      "short_description": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 3 turns",
      "long_description": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 3 turns",
      "class_name": "Rend",
      "revision": 1
    },
    {
      "asset_id": 4084,
      "resettable": 1,
      "name": "Rend",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 164,
      "activated": 1,
      "icon_name": "dot_rend",
      "comments": "none",
      "prerequisite_id": 163,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 5,
      "short_description": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 4 turns",
      "long_description": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 4 turns",
      "class_name": "Rend",
      "revision": 1
    },
    {
      "asset_id": 4084,
      "resettable": 1,
      "name": "Rend",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 165,
      "activated": 1,
      "icon_name": "dot_rend",
      "comments": "none",
      "prerequisite_id": 164,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 8,
      "short_description": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 5 turns",
      "long_description": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 5 turns",
      "class_name": "Rend",
      "revision": 1
    },
    {
      "asset_id": 7532,
      "resettable": 0,
      "name": "Render",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3192,
      "activated": 1,
      "icon_name": "render",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "When this effect comes into play and at the beginning of each turn, this champion has +DMG equal to the highest DEF value on enemy champions for 1 turn.",
      "long_description": "When this effect comes into play and at the beginning of each turn, this champion has +DMG equal to the highest DEF value on enemy champions for 1 turn.",
      "class_name": "Render",
      "revision": 1
    },
    {
      "asset_id": 5907,
      "resettable": 1,
      "name": "Renovate",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2918,
      "activated": 1,
      "icon_name": "soul_bond",
      "comments": "x",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 10,
      "short_description": "This champion deals 1 additional damage to champions for each starting ability above 2 on that champion.",
      "long_description": "This champion deals 1 additional damage to champions for each starting ability above 2 on that champion.",
      "class_name": "Renovate",
      "revision": 1
    },
    {
      "asset_id": 4280,
      "resettable": 1,
      "name": "Replicate",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 670,
      "activated": 1,
      "icon_name": "swarm",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "Create a replica of this champion on target adjacent space. This unit loses half of its current HP (rounded down) and the replica has that amount of HP.",
      "long_description": "Create a replica of this champion on target adjacent space. This unit loses half of its current HP (rounded down) and the replica has that amount of HP.",
      "class_name": "Replicate",
      "revision": 1
    },
    {
      "asset_id": 5502,
      "resettable": 1,
      "name": "Repulsion",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2361,
      "activated": 1,
      "icon_name": "repulsion",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "At the beginning of your turn, any enemy champion without <ability value=4 popup=false>Iron Will</ability> within 5 spaces of this unit is moved 2 spaces directly away from this unit.",
      "long_description": "At the beginning of your turn, any enemy champion without <ability value=4 popup=false>Iron Will</ability> within 5 spaces of this unit is moved 2 spaces directly away from this unit.",
      "class_name": "Repulsion",
      "revision": 1
    },
    {
      "asset_id": 4493,
      "resettable": 1,
      "name": "Requite",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1136,
      "activated": 1,
      "icon_name": "ondeath",
      "comments": "Created for Euan on Euan's last stand.",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": -5,
      "short_description": "When this unit dies, its enemy shrine is destroyed.",
      "long_description": "When this unit dies, its enemy shrine is destroyed.",
      "class_name": "Requite",
      "revision": 1
    },
    {
      "asset_id": 4752,
      "resettable": 1,
      "name": "Resilient",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1476,
      "activated": 1,
      "icon_name": "defenseenhance",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "If this champion was to take less than 4 damage, that damage is prevented.",
      "long_description": "If this champion was to take less than 4 damage, that damage is prevented.",
      "class_name": "Resilient",
      "revision": 1
    },
    {
      "asset_id": 4031,
      "resettable": 1,
      "name": "Resistance: Acid",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 74,
      "activated": 1,
      "icon_name": "resistance_acid",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 0,
      "short_description": "When this unit takes Acid damage, that damage is reduced by 20% (after DEF, rounded down).",
      "long_description": "When this unit takes Acid damage, that damage is reduced by 20% (after DEF, rounded down).",
      "class_name": "ResistanceAcid",
      "revision": 1
    },
    {
      "asset_id": 4031,
      "resettable": 1,
      "name": "Resistance: Acid",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 75,
      "activated": 1,
      "icon_name": "resistance_acid",
      "comments": "none",
      "prerequisite_id": 74,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 1,
      "short_description": "When this unit takes Acid damage, that damage is reduced by 35% (after DEF, rounded up).",
      "long_description": "When this unit takes Acid damage, that damage is reduced by 35% (after DEF, rounded up).",
      "class_name": "ResistanceAcid",
      "revision": 1
    },
    {
      "asset_id": 4031,
      "resettable": 1,
      "name": "Resistance: Acid",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 76,
      "activated": 1,
      "icon_name": "resistance_acid",
      "comments": "none",
      "prerequisite_id": 75,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 2,
      "short_description": "When this unit takes Acid damage, that damage is reduced by 50% (after DEF, rounded up).",
      "long_description": "When this unit takes Acid damage, that damage is reduced by 50% (after DEF, rounded up).",
      "class_name": "ResistanceAcid",
      "revision": 1
    },
    {
      "asset_id": 4032,
      "resettable": 1,
      "name": "Resistance: Disease",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 78,
      "activated": 1,
      "icon_name": "resistance_disease",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 0,
      "short_description": "When this unit takes Disease damage, that damage is reduced by 20% (after DEF, rounded up).",
      "long_description": "When this unit takes Disease damage, that damage is reduced by 20% (after DEF, rounded up).",
      "class_name": "ResistanceDisease",
      "revision": 1
    },
    {
      "asset_id": 4032,
      "resettable": 1,
      "name": "Resistance: Disease",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 79,
      "activated": 1,
      "icon_name": "resistance_disease",
      "comments": "none",
      "prerequisite_id": 78,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 1,
      "short_description": "When this unit takes Disease damage, that damage is reduced by 35% (after DEF, rounded up).",
      "long_description": "When this unit takes Disease damage, that damage is reduced by 35% (after DEF, rounded up).",
      "class_name": "ResistanceDisease",
      "revision": 1
    },
    {
      "asset_id": 4032,
      "resettable": 1,
      "name": "Resistance: Disease",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 80,
      "activated": 1,
      "icon_name": "resistance_disease",
      "comments": "none",
      "prerequisite_id": 79,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 2,
      "short_description": "When this unit takes Disease damage, that damage is reduced by 50% (after DEF, rounded up).",
      "long_description": "When this unit takes Disease damage, that damage is reduced by 50% (after DEF, rounded up).",
      "class_name": "ResistanceDisease",
      "revision": 1
    },
    {
      "asset_id": 4028,
      "resettable": 1,
      "name": "Resistance: Electricity",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 62,
      "activated": 1,
      "icon_name": "resistance_electric",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 0,
      "short_description": "When this unit takes Electricity damage, that damage is reduced by 20% (after DEF, rounded up).",
      "long_description": "When this unit takes Electricity damage, that damage is reduced by 20% (after DEF, rounded up).",
      "class_name": "ResistanceElectricity",
      "revision": 1
    },
    {
      "asset_id": 4028,
      "resettable": 1,
      "name": "Resistance: Electricity",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 63,
      "activated": 1,
      "icon_name": "resistance_electric",
      "comments": "none",
      "prerequisite_id": 62,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 1,
      "short_description": "When this unit takes Electricity damage, that damage is reduced by 35% (after DEF, rounded up).",
      "long_description": "When this unit takes Electricity damage, that damage is reduced by 35% (after DEF, rounded up).",
      "class_name": "ResistanceElectricity",
      "revision": 1
    },
    {
      "asset_id": 4028,
      "resettable": 1,
      "name": "Resistance: Electricity",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 64,
      "activated": 1,
      "icon_name": "resistance_electric",
      "comments": "none",
      "prerequisite_id": 63,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 2,
      "short_description": "When this unit takes Electricity damage, that damage is reduced by 50% (after DEF, rounded up).",
      "long_description": "When this unit takes Electricity damage, that damage is reduced by 50% (after DEF, rounded up).",
      "class_name": "ResistanceElectricity",
      "revision": 1
    },
    {
      "asset_id": 4026,
      "resettable": 1,
      "name": "Resistance: Fire",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 54,
      "activated": 1,
      "icon_name": "resistance_fire",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 1,
      "short_description": "When this unit takes Fire damage, that damage is reduced by 20% (after DEF, rounded up).",
      "long_description": "When this unit takes Fire damage, that damage is reduced by 20% (after DEF, rounded up).",
      "class_name": "ResistanceFire",
      "revision": 1
    },
    {
      "asset_id": 4026,
      "resettable": 1,
      "name": "Resistance: Fire",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 55,
      "activated": 1,
      "icon_name": "resistance_fire",
      "comments": "none",
      "prerequisite_id": 54,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 2,
      "short_description": "When this unit takes Fire damage, that damage is reduced by 35% (after DEF, rounded up).",
      "long_description": "When this unit takes Fire damage, that damage is reduced by 35% (after DEF, rounded up).",
      "class_name": "ResistanceFire",
      "revision": 1
    },
    {
      "asset_id": 4026,
      "resettable": 1,
      "name": "Resistance: Fire",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 56,
      "activated": 1,
      "icon_name": "resistance_fire",
      "comments": "none",
      "prerequisite_id": 55,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 3,
      "short_description": "When this unit takes Fire damage, that damage is reduced by 50% (after DEF, rounded up).",
      "long_description": "When this unit takes Fire damage, that damage is reduced by 50% (after DEF, rounded up).",
      "class_name": "ResistanceFire",
      "revision": 1
    },
    {
      "asset_id": 4027,
      "resettable": 1,
      "name": "Resistance: Frost",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 58,
      "activated": 1,
      "icon_name": "resistance_frost",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 1,
      "short_description": "When this unit takes Frost damage, that damage is reduced by 20% (after DEF, rounded up).",
      "long_description": "When this unit takes Frost damage, that damage is reduced by 20% (after DEF, rounded up).",
      "class_name": "ResistanceCold",
      "revision": 1
    },
    {
      "asset_id": 4027,
      "resettable": 1,
      "name": "Resistance: Frost",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 59,
      "activated": 1,
      "icon_name": "resistance_frost",
      "comments": "none",
      "prerequisite_id": 58,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 2,
      "short_description": "When this unit takes Frost damage, that damage is reduced by 35% (after DEF, rounded up).",
      "long_description": "When this unit takes Frost damage, that damage is reduced by 35% (after DEF, rounded up).",
      "class_name": "ResistanceCold",
      "revision": 1
    },
    {
      "asset_id": 4027,
      "resettable": 1,
      "name": "Resistance: Frost",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 60,
      "activated": 1,
      "icon_name": "resistance_frost",
      "comments": "none",
      "prerequisite_id": 59,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 3,
      "short_description": "When this unit takes Frost damage, that damage is reduced by 50% (after DEF, rounded up).",
      "long_description": "When this unit takes Frost damage, that damage is reduced by 50% (after DEF, rounded up).",
      "class_name": "ResistanceCold",
      "revision": 1
    },
    {
      "asset_id": 4025,
      "resettable": 1,
      "name": "Resistance: Magical",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 50,
      "activated": 1,
      "icon_name": "resistance_magic",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 3,
      "short_description": "When this unit takes Magical damage, that damage is reduced by 20% (after DEF, rounded up).",
      "long_description": "When this unit takes Magical damage, that damage is reduced by 20% (after DEF, rounded up).",
      "class_name": "ResistanceMagical",
      "revision": 1
    },
    {
      "asset_id": 4025,
      "resettable": 1,
      "name": "Resistance: Magical",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 51,
      "activated": 1,
      "icon_name": "resistance_magic",
      "comments": "none",
      "prerequisite_id": 50,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 4,
      "short_description": "When this unit takes Magical damage, that damage is reduced by 35% (after DEF, rounded up).",
      "long_description": "When this unit takes Magical damage, that damage is reduced by 35% (after DEF, rounded up).",
      "class_name": "ResistanceMagical",
      "revision": 1
    },
    {
      "asset_id": 4025,
      "resettable": 1,
      "name": "Resistance: Magical",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 52,
      "activated": 1,
      "icon_name": "resistance_magic",
      "comments": "none",
      "prerequisite_id": 51,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 5,
      "short_description": "When this unit takes Magical damage, that damage is reduced by 50% (after DEF, rounded up).",
      "long_description": "When this unit takes Magical damage, that damage is reduced by 50% (after DEF, rounded up).",
      "class_name": "ResistanceMagical",
      "revision": 1
    },
    {
      "asset_id": 4024,
      "resettable": 1,
      "name": "Resistance: Physical",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 46,
      "activated": 1,
      "icon_name": "resistance_physical",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 4,
      "short_description": "When this unit takes Physical damage, that damage is reduced by 20% (after DEF, rounded up).",
      "long_description": "When this unit takes Physical damage, that damage is reduced by 20% (after DEF, rounded up).",
      "class_name": "ResistancePhysical",
      "revision": 1
    },
    {
      "asset_id": 4024,
      "resettable": 1,
      "name": "Resistance: Physical",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 47,
      "activated": 1,
      "icon_name": "resistance_physical",
      "comments": "none",
      "prerequisite_id": 46,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 6,
      "short_description": "When this unit takes Physical damage, that damage is reduced by 35% (after DEF, rounded up).",
      "long_description": "When this unit takes Physical damage, that damage is reduced by 35% (after DEF, rounded up).",
      "class_name": "ResistancePhysical",
      "revision": 1
    },
    {
      "asset_id": 4024,
      "resettable": 1,
      "name": "Resistance: Physical",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 48,
      "activated": 1,
      "icon_name": "resistance_physical",
      "comments": "none",
      "prerequisite_id": 47,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 8,
      "short_description": "When this unit takes Physical damage, that damage is reduced by 50% (after DEF, rounded up).",
      "long_description": "When this unit takes Physical damage, that damage is reduced by 50% (after DEF, rounded up).",
      "class_name": "ResistancePhysical",
      "revision": 1
    },
    {
      "asset_id": 4029,
      "resettable": 1,
      "name": "Resistance: Poison",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 66,
      "activated": 1,
      "icon_name": "resistance_poison",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 0,
      "short_description": "When this unit takes Poison damage, that damage is reduced by 20% (after DEF, rounded up).",
      "long_description": "When this unit takes Poison damage, that damage is reduced by 20% (after DEF, rounded up).",
      "class_name": "ResistancePoison",
      "revision": 1
    },
    {
      "asset_id": 4029,
      "resettable": 1,
      "name": "Resistance: Poison",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 67,
      "activated": 1,
      "icon_name": "resistance_poison",
      "comments": "none",
      "prerequisite_id": 66,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 1,
      "short_description": "When this unit takes Poison damage, that damage is reduced by 35% (after DEF, rounded up).",
      "long_description": "When this unit takes Poison damage, that damage is reduced by 35% (after DEF, rounded up).",
      "class_name": "ResistancePoison",
      "revision": 1
    },
    {
      "asset_id": 4029,
      "resettable": 1,
      "name": "Resistance: Poison",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 68,
      "activated": 1,
      "icon_name": "resistance_poison",
      "comments": "none",
      "prerequisite_id": 67,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 2,
      "short_description": "When this unit takes Poison damage, that damage is reduced by 50% (after DEF, rounded up).",
      "long_description": "When this unit takes Poison damage, that damage is reduced by 50% (after DEF, rounded up).",
      "class_name": "ResistancePoison",
      "revision": 1
    },
    {
      "asset_id": 4033,
      "resettable": 1,
      "name": "Resistance: Psychic",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 82,
      "activated": 1,
      "icon_name": "resistance_psychic",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 0,
      "short_description": "When this unit takes Psychic damage, that damage is reduced by 20% (after DEF, rounded up).",
      "long_description": "When this unit takes Psychic damage, that damage is reduced by 20% (after DEF, rounded up).",
      "class_name": "ResistancePsychic",
      "revision": 1
    },
    {
      "asset_id": 4033,
      "resettable": 1,
      "name": "Resistance: Psychic",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 83,
      "activated": 1,
      "icon_name": "resistance_psychic",
      "comments": "none",
      "prerequisite_id": 82,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 1,
      "short_description": "When this unit takes Psychic damage, that damage is reduced by 35% (after DEF, rounded up).",
      "long_description": "When this unit takes Psychic damage, that damage is reduced by 35% (after DEF, rounded up).",
      "class_name": "ResistancePsychic",
      "revision": 1
    },
    {
      "asset_id": 4033,
      "resettable": 1,
      "name": "Resistance: Psychic",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 84,
      "activated": 1,
      "icon_name": "resistance_psychic",
      "comments": "none",
      "prerequisite_id": 83,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 2,
      "short_description": "When this unit takes Psychic damage, that damage is reduced by 50% (after DEF, rounded up).",
      "long_description": "When this unit takes Psychic damage, that damage is reduced by 50% (after DEF, rounded up).",
      "class_name": "ResistancePsychic",
      "revision": 1
    },
    {
      "asset_id": 4030,
      "resettable": 1,
      "name": "Resistance: Sonic",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 70,
      "activated": 1,
      "icon_name": "resistance_sonic",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 0,
      "short_description": "When this unit takes Sonic damage, that damage is reduced by 20% (after DEF, rounded up).",
      "long_description": "When this unit takes Sonic damage, that damage is reduced by 20% (after DEF, rounded up).",
      "class_name": "ResistanceSonic",
      "revision": 1
    },
    {
      "asset_id": 4030,
      "resettable": 1,
      "name": "Resistance: Sonic",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 71,
      "activated": 1,
      "icon_name": "resistance_sonic",
      "comments": "none",
      "prerequisite_id": 70,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 1,
      "short_description": "When this unit takes Sonic damage, that damage is reduced by 35% (after DEF, rounded up).",
      "long_description": "When this unit takes Sonic damage, that damage is reduced by 35% (after DEF, rounded up).",
      "class_name": "ResistanceSonic",
      "revision": 1
    },
    {
      "asset_id": 4030,
      "resettable": 1,
      "name": "Resistance: Sonic",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 72,
      "activated": 1,
      "icon_name": "resistance_sonic",
      "comments": "none",
      "prerequisite_id": 71,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 2,
      "short_description": "When this unit takes Sonic damage, that damage is reduced by 50% (after DEF, rounded up).",
      "long_description": "When this unit takes Sonic damage, that damage is reduced by 50% (after DEF, rounded up).",
      "class_name": "ResistanceSonic",
      "revision": 1
    },
    {
      "asset_id": 4345,
      "resettable": 1,
      "name": "Resolute",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1374,
      "activated": 1,
      "icon_name": "ironwill",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "For 2 turns, all damage from attacks at RNG 1 against this unit is prevented.  This effect is hidden until triggered.",
      "long_description": "For 2 turns, all damage from attacks at RNG 1 against this unit is prevented.  This effect is hidden until triggered.",
      "class_name": "BestialFury",
      "revision": 1
    },
    {
      "asset_id": 5055,
      "resettable": 1,
      "name": "Resonance",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1912,
      "activated": 1,
      "icon_name": "iceguard",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 7,
      "short_description": "At the beginning of each of its turns, this champion gains DMG for 1 turn equal to the amount of nora your opponent generated through spells, relics and abilities in the last 2 turns.  This DMG is only applied for nora generated while this champion is in play.",
      "long_description": "At the beginning of each of its turns, this champion gains DMG for 1 turn equal to the amount of nora your opponent generated through spells, relics and abilities in the last 2 turns.  This DMG is only applied for nora generated while this champion is in play.",
      "class_name": "Resonance",
      "revision": 1
    },
    {
      "asset_id": 5693,
      "resettable": 1,
      "name": "Restless Souls",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2569,
      "activated": 1,
      "icon_name": "ondeath",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 14,
      "short_description": "The first time each turn a real enemy champion within 5 spaces is destroyed, a Restless Soul with no upgrades is summoned adjacent to this unit.",
      "long_description": "The first time each turn a real enemy champion within 5 spaces is destroyed, a Restless Soul with no upgrades is summoned adjacent to this unit.",
      "class_name": "RestlessSouls",
      "revision": 1
    },
    {
      "asset_id": 5772,
      "resettable": 1,
      "name": "Restraining Aura",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2685,
      "activated": 1,
      "icon_name": "special",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "When an enemy champion within 5 spaces activates an ability (excluding basic attacks), that ability has +3 cooldown.",
      "long_description": "When an enemy champion within 5 spaces activates an ability (excluding basic attacks), that ability has +3 cooldown.",
      "class_name": "RestrainingAura",
      "revision": 1
    },
    {
      "asset_id": 4899,
      "resettable": 1,
      "name": "Restrict",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1781,
      "activated": 1,
      "icon_name": "unequipable",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "All champions within 6 spaces of this unit are unequippable.",
      "long_description": "All champions within 6 spaces of this unit are unequippable.",
      "class_name": "Restrict",
      "revision": 1
    },
    {
      "asset_id": 5515,
      "resettable": 1,
      "name": "Restricting Luminescence",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2374,
      "activated": 1,
      "icon_name": "restricting_luminesence",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 2,
      "short_description": "Enemy champions within 5 spaces have <ability value=814>Unequippable</ability>.",
      "long_description": "Enemy champions within 5 spaces have <ability value=814>Unequippable</ability>.",
      "class_name": "RestrictingLuminescence",
      "revision": 1
    },
    {
      "asset_id": 4900,
      "resettable": 1,
      "name": "Resurgence",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 2071,
      "activated": 1,
      "icon_name": "special",
      "comments": "none",
      "prerequisite_id": 1616,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 2,
      "short_description": "When this unit comes into play, non-champion runes you control have their cooldown lowered by 3 and champion runes have their cooldown lowered by 5.",
      "long_description": "When this unit comes into play, non-champion runes you control have their cooldown lowered by 3 and champion runes have their cooldown lowered by 5.",
      "class_name": "Resurgence",
      "revision": 1
    },
    {
      "asset_id": 4900,
      "resettable": 1,
      "name": "Resurgence",
      "ap_cost": 0,
      "level": 4,
      "ability_id": 2072,
      "activated": 1,
      "icon_name": "special",
      "comments": "none",
      "prerequisite_id": 2071,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 2,
      "short_description": "When this unit comes into play, non-champion runes you control have their cooldown lowered by 3 and champion runes have their cooldown lowered by 6.",
      "long_description": "When this unit comes into play, non-champion runes you control have their cooldown lowered by 3 and champion runes have their cooldown lowered by 6.",
      "class_name": "Resurgence",
      "revision": 1
    },
    {
      "asset_id": 4900,
      "resettable": 1,
      "name": "Resurgence",
      "ap_cost": 0,
      "level": 5,
      "ability_id": 2073,
      "activated": 1,
      "icon_name": "special",
      "comments": "none",
      "prerequisite_id": 2072,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 2,
      "short_description": "When this unit comes into play, non-champion runes you control have their cooldown lowered by 3 and champion runes have their cooldown lowered by 7.",
      "long_description": "When this unit comes into play, non-champion runes you control have their cooldown lowered by 3 and champion runes have their cooldown lowered by 7.",
      "class_name": "Resurgence",
      "revision": 1
    },
    {
      "asset_id": 4900,
      "resettable": 1,
      "name": "Resurgence",
      "ap_cost": 0,
      "level": 6,
      "ability_id": 2074,
      "activated": 1,
      "icon_name": "special",
      "comments": "none",
      "prerequisite_id": 2073,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 2,
      "short_description": "When this unit comes into play, non-champion runes you control have their cooldown lowered by 5 and champion runes have their cooldown lowered by 10.",
      "long_description": "When this unit comes into play, non-champion runes you control have their cooldown lowered by 5 and champion runes have their cooldown lowered by 10.",
      "class_name": "Resurgence",
      "revision": 1
    },
    {
      "asset_id": 4900,
      "resettable": 1,
      "name": "Resurgence",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 1615,
      "activated": 1,
      "icon_name": "special",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 2,
      "short_description": "When this unit comes into play, non-champion runes you control have their cooldown lowered by 3 and champion runes have their cooldown lowered by 3.",
      "long_description": "When this unit comes into play, non-champion runes you control have their cooldown lowered by 3 and champion runes have their cooldown lowered by 3.",
      "class_name": "Resurgence",
      "revision": 1
    },
    {
      "asset_id": 4900,
      "resettable": 1,
      "name": "Resurgence",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 1616,
      "activated": 1,
      "icon_name": "special",
      "comments": "none",
      "prerequisite_id": 1615,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 2,
      "short_description": "When this unit comes into play, non-champion runes you control have their cooldown lowered by 3 and champion runes have their cooldown lowered by 4.",
      "long_description": "When this unit comes into play, non-champion runes you control have their cooldown lowered by 3 and champion runes have their cooldown lowered by 4.",
      "class_name": "Resurgence",
      "revision": 1
    },
    {
      "asset_id": 4471,
      "resettable": 1,
      "name": "Resurrect",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 842,
      "activated": 1,
      "icon_name": "revive",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 1,
      "cost": 2,
      "short_description": "For 4 turns, the cooldown of the next champion you own that dies is set to 0.",
      "long_description": "For 4 turns, the cooldown of the next champion you own that dies is set to 0.",
      "class_name": "Resurrect",
      "revision": 1
    },
    {
      "asset_id": 4471,
      "resettable": 1,
      "name": "Resurrect",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 843,
      "activated": 1,
      "icon_name": "revive",
      "comments": "",
      "prerequisite_id": 842,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 1,
      "cost": 4,
      "short_description": "For 4 turns, the cooldown of the next champion you own that dies is set to 0.",
      "long_description": "For 4 turns, the cooldown of the next champion you own that dies is set to 0.",
      "class_name": "Resurrect",
      "revision": 1
    },
    {
      "asset_id": 4489,
      "resettable": 1,
      "name": "Retreat",
      "ap_cost": 1,
      "level": 1,
      "ability_id": 893,
      "activated": 1,
      "icon_name": "mobility",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 1,
      "cost": 3,
      "short_description": "This champion can disengage for free and move 1 space.",
      "long_description": "This champion can disengage for free and move 1 space.",
      "class_name": "Retreat",
      "revision": 1
    },
    {
      "asset_id": 4489,
      "resettable": 1,
      "name": "Retreat",
      "ap_cost": 1,
      "level": 2,
      "ability_id": 894,
      "activated": 1,
      "icon_name": "mobility",
      "comments": "",
      "prerequisite_id": 893,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 1,
      "cost": 6,
      "short_description": "This champion can disengage for free and move 2 spaces.",
      "long_description": "This champion can disengage for free and move 2 spaces.",
      "class_name": "Retreat",
      "revision": 1
    },
    {
      "asset_id": 4489,
      "resettable": 1,
      "name": "Retreat",
      "ap_cost": 1,
      "level": 3,
      "ability_id": 895,
      "activated": 1,
      "icon_name": "mobility",
      "comments": "",
      "prerequisite_id": 894,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 1,
      "cost": 6,
      "short_description": "This champion can disengage for free and move 3 spaces.",
      "long_description": "This champion can disengage for free and move 3 spaces.",
      "class_name": "Retreat",
      "revision": 1
    },
    {
      "asset_id": 5620,
      "resettable": 1,
      "name": "Rev 'Em Up",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2636,
      "activated": 1,
      "icon_name": "build_mine",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 9,
      "short_description": "Range 3: Target champion with Race: Construct gains <ability value=2253>Manic</ability> for 4 turns.",
      "long_description": "Range 3: Target champion with Race: Construct gains <ability value=2253>Manic</ability> for 4 turns.",
      "class_name": "RevEmUp",
      "revision": 1
    },
    {
      "asset_id": 5900,
      "resettable": 1,
      "name": "Reveal: Kas Pupil",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2911,
      "activated": 1,
      "icon_name": "find_pupil",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Summon a Kas Pupil on target adjacent square. This ability is removed after use.",
      "long_description": "Summon a Kas Pupil on target adjacent square. This ability is removed after use.",
      "class_name": "RevealKasPupil",
      "revision": 1
    },
    {
      "asset_id": 5901,
      "resettable": 1,
      "name": "Reveal: Source Crystal",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2912,
      "activated": 1,
      "icon_name": "source_crystal",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Spawn a Source Crystal on target adjacent square.",
      "long_description": "Spawn a Source Crystal on target adjacent square.",
      "class_name": "RevealSourceCrystal",
      "revision": 1
    },
    {
      "asset_id": 5665,
      "resettable": 1,
      "name": "Revel in Misery",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2537,
      "activated": 1,
      "icon_name": "forsaken_conduit",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 8,
      "short_description": "When an opposing champion with <condition value=cursed>Cursed</condition>, Hexed or <condition value=diseased>Diseased</condition> is damaged by an attack, this champion heals for 25% of the damage dealt (to a minimum of 3).",
      "long_description": "When an opposing champion with <condition value=cursed>Cursed</condition>, Hexed or <condition value=diseased>Diseased</condition> is damaged by an attack, this champion heals for 25% of the damage dealt (to a minimum of 3).",
      "class_name": "RevelInMisery",
      "revision": 1
    },
    {
      "asset_id": 4902,
      "resettable": 1,
      "name": "Revenge",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1784,
      "activated": 1,
      "icon_name": "execute",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 8,
      "short_description": "This unit attacks the closest enemy unit within range whenever one of your champions dies.\r\n",
      "long_description": "This unit attacks the closest enemy unit within range whenever one of your champions dies.\r\n",
      "class_name": "Revenge",
      "revision": 1
    },
    {
      "asset_id": 5129,
      "resettable": 1,
      "name": "Revere: Akakios",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1921,
      "activated": 1,
      "icon_name": "revere",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "While this champion is in play, Akakios costs 10% less nora to deploy. While Akakios is in play, whenever a champion takes fire damage this champion generates 1 nora (This does not include damage from <condition value=charred>Charred</condition>).",
      "long_description": "While this champion is in play, Akakios costs 10% less nora to deploy. While Akakios is in play, whenever a champion takes fire damage this champion generates 1 nora (This does not include damage from <condition value=charred>Charred</condition>).",
      "class_name": "RevereAkakios",
      "revision": 1
    },
    {
      "asset_id": 5130,
      "resettable": 1,
      "name": "Revere: Drakon",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1922,
      "activated": 1,
      "icon_name": "revere",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "While this champion is in play, Drakon costs 10% less nora to deploy. While Drakon is in play this unit has the <ability value=1899>Scale Armor</ability> ability.",
      "long_description": "While this champion is in play, Drakon costs 10% less nora to deploy. While Drakon is in play this unit has the <ability value=1899>Scale Armor</ability> ability.",
      "class_name": "RevereDrakon",
      "revision": 1
    },
    {
      "asset_id": 5124,
      "resettable": 1,
      "name": "Revere: Firemaw",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1919,
      "activated": 1,
      "icon_name": "revere",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "While this champion is in play, Firemaw costs 10% less nora to deploy. While Firemaw is in play, this champion has <ability value=3088>Flameburst</ability> and <ability value=633>Terraform: Lava</ability>.",
      "long_description": "While this champion is in play, Firemaw costs 10% less nora to deploy. While Firemaw is in play, this champion has <ability value=3088>Flameburst</ability> and <ability value=633>Terraform: Lava</ability>.",
      "class_name": "RevereFiremaw",
      "revision": 1
    },
    {
      "asset_id": 5097,
      "resettable": 1,
      "name": "Revere: Hydraxor",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1917,
      "activated": 1,
      "icon_name": "revere",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "While this champion is in play, Hydraxor costs 10% less nora to deploy. While Hydraxor is in play, this champion gains <ability value=1325>Domain: Water</ability> and any damage this champion deals counts toward Hydraxor's <ability value=1892>Quest: Damage</ability>.",
      "long_description": "While this champion is in play, Hydraxor costs 10% less nora to deploy. While Hydraxor is in play, this champion gains <ability value=1325>Domain: Water</ability> and any damage this champion deals counts toward Hydraxor's <ability value=1892>Quest: Damage</ability>.",
      "class_name": "RevereHydraxor",
      "revision": 1
    },
    {
      "asset_id": 5131,
      "resettable": 1,
      "name": "Revere: Icesnap",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1923,
      "activated": 1,
      "icon_name": "revere",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "While this champion is in play, Icesnap costs 10% less nora to deploy. While Icesnap is in play, whenever a champion takes frost damage this champion generates 1 nora (This does not include damage from <condition value=chilled>Chilled</condition>).",
      "long_description": "While this champion is in play, Icesnap costs 10% less nora to deploy. While Icesnap is in play, whenever a champion takes frost damage this champion generates 1 nora (This does not include damage from <condition value=chilled>Chilled</condition>).",
      "class_name": "RevereIcesnap",
      "revision": 1
    },
    {
      "asset_id": 5132,
      "resettable": 1,
      "name": "Revere: Mairdreth of the Rot",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1924,
      "activated": 1,
      "icon_name": "revere",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "While this champion is in play, Mairdreth of the Rot costs 10% less nora to deploy. If Mairdreth of the Rot is in play, this champion gains <ability value=973>Afflict 2</ability> and <ability value=2537>Revel in Misery</ability>.",
      "long_description": "While this champion is in play, Mairdreth of the Rot costs 10% less nora to deploy. If Mairdreth of the Rot is in play, this champion gains <ability value=973>Afflict 2</ability> and <ability value=2537>Revel in Misery</ability>.",
      "class_name": "RevereSerpentOfDecay",
      "revision": 1
    },
    {
      "asset_id": 5122,
      "resettable": 1,
      "name": "Revere: The Exile",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1918,
      "activated": 1,
      "icon_name": "revere",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "While this champion is in play, The Exile costs 10% less nora to deploy. While The Exile is in play, this champion has the Deep Wounds Ability.",
      "long_description": "While this champion is in play, The Exile costs 10% less nora to deploy. While The Exile is in play, this champion has the Deep Wounds Ability.",
      "class_name": "RevereTearerOfCorpses",
      "revision": 1
    },
    {
      "asset_id": 5128,
      "resettable": 1,
      "name": "Revere: Thirion",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1920,
      "activated": 1,
      "icon_name": "revere",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "While this champion is in play, Thirion costs 10% less nora to deploy. While Thirion is in play, this champion gains +2 RNG.",
      "long_description": "While this champion is in play, Thirion costs 10% less nora to deploy. While Thirion is in play, this champion gains +2 RNG.",
      "class_name": "RevereThirion",
      "revision": 1
    },
    {
      "asset_id": 5471,
      "resettable": 1,
      "name": "Revere: Zeventrech",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2329,
      "activated": 1,
      "icon_name": "revere",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "While this champion is in play, Zeventrech the Last costs 10% less nora to deploy. While Zeventrech the Last is in play, this champion gains <ability value=1131>Ally: Savage Tundra</ability>.",
      "long_description": "While this champion is in play, Zeventrech the Last costs 10% less nora to deploy. While Zeventrech the Last is in play, this champion gains <ability value=1131>Ally: Savage Tundra</ability>.",
      "class_name": "RevereZeventrech",
      "revision": 1
    },
    {
      "asset_id": 5839,
      "resettable": 1,
      "name": "Revitalizing Flavors",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2848,
      "activated": 1,
      "icon_name": "heal",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 12,
      "short_description": "Area Effect 2, Range 8: Friendly champions are healed for 12 HP.",
      "long_description": "Area Effect 2, Range 8: Friendly champions are healed for 12 HP.",
      "class_name": "RevitalizingFlavors",
      "revision": 1
    },
    {
      "asset_id": 5467,
      "resettable": 1,
      "name": "Ricochet Shot",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 2325,
      "activated": 1,
      "icon_name": "cannon_barrage",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 3,
      "ranked": 0,
      "cost": 10,
      "short_description": "This champion makes a physical attack against target champion. If successful, the nearest other opposing champion within 4 spaces of the target takes 1 physical damage and if that champion takes damage is <condition value=stunned>Stunned</condition> for 2 turns. This damage ignores Defense.",
      "long_description": "This champion makes a physical attack against target champion. If successful, the nearest other opposing champion within 4 spaces of the target takes 1 physical damage and if that champion takes damage is <condition value=stunned>Stunned</condition> for 2 turns. This damage ignores Defense.",
      "class_name": "RicochetShot",
      "revision": 1
    },
    {
      "asset_id": 5874,
      "resettable": 1,
      "name": "Ride Down",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2883,
      "activated": 1,
      "icon_name": "decapitate",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "Target a champion with 15 or less HP within 3 spaces. This champion moves in a straight line through non-Impeding terrain and destroys that champion. This ability is on the attack chain.",
      "long_description": "Target a champion with 15 or less HP within 3 spaces. This champion moves in a straight line through non-Impeding terrain and destroys that champion. This ability is on the attack chain.",
      "class_name": "RideDown",
      "revision": 1
    },
    {
      "asset_id": 7667,
      "resettable": 0,
      "name": "Rift Bound",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3249,
      "activated": 1,
      "icon_name": "rift_bound",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -8,
      "short_description": "At the end of its turns, if this unit does not occupy Dead Magic Zone, it loses 2 MAX HP.",
      "long_description": "At the end of its turns, if this unit does not occupy Dead Magic Zone, it loses 2 MAX HP.",
      "class_name": "RiftBound",
      "revision": 1
    },
    {
      "asset_id": 7663,
      "resettable": 0,
      "name": "Rift Nova",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 3247,
      "activated": 1,
      "icon_name": "stormreader",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "Area Effect 2, Range 5: Enemy champions occupying a <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic> or Dread Field in the area lose 6 HP and lose 1 SPD for 2 turns for each friendly spirit within the AoE (to a maximum of -3).",
      "long_description": "Area Effect 2, Range 5: Enemy champions occupying a <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic> or Dread Field in the area lose 6 HP and lose 1 SPD for 2 turns for each friendly spirit within the AoE (to a maximum of -3).",
      "class_name": "RiftNova",
      "revision": 1
    },
    {
      "asset_id": 7735,
      "resettable": 0,
      "name": "Riftwalker",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 3274,
      "activated": 1,
      "icon_name": "riftwalker",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "This champion is relocated to target <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic> within 5 spaces. Enemy champions within 2 spaces become <condition value=awestruck>Awestruck</condition> for 2 turns. For each affected unit, this champion gains +1 AP and +1 DMG for 1 turn.",
      "long_description": "This champion is relocated to target <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic> within 5 spaces. Enemy champions within 2 spaces become <condition value=awestruck>Awestruck</condition> for 2 turns. For each affected unit, this champion gains +1 AP and +1 DMG for 1 turn.",
      "class_name": "Riftwalker",
      "revision": 1
    },
    {
      "asset_id": 4232,
      "resettable": 1,
      "name": "Righteous Shield",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 605,
      "activated": 1,
      "icon_name": "aegis",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 7,
      "short_description": "Target champion within 2 spaces becomes <condition value=impervious>Impervious</condition> for 2 turns.",
      "long_description": "Target champion within 2 spaces becomes <condition value=impervious>Impervious</condition> for 2 turns.",
      "class_name": "RighteousShield",
      "revision": 1
    },
    {
      "asset_id": 4116,
      "resettable": 1,
      "name": "Riposte",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 287,
      "activated": 1,
      "icon_name": "counter",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 4,
      "short_description": "When a champion makes an unsuccessful close-combat attack against this unit, this unit makes a close-combat attack against that unit at +1 DMG.",
      "long_description": "When a champion makes an unsuccessful close-combat attack against this unit, this unit makes a close-combat attack against that unit at +1 DMG.",
      "class_name": "Riposte",
      "revision": 1
    },
    {
      "asset_id": 4116,
      "resettable": 1,
      "name": "Riposte",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 288,
      "activated": 1,
      "icon_name": "counter",
      "comments": "none",
      "prerequisite_id": 287,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 5,
      "short_description": "When a champion makes an unsuccessful close-combat attack against this unit, this unit makes a close-combat attack against that unit at +2 DMG.",
      "long_description": "When a champion makes an unsuccessful close-combat attack against this unit, this unit makes a close-combat attack against that unit at +2 DMG.",
      "class_name": "Riposte",
      "revision": 1
    },
    {
      "asset_id": 4116,
      "resettable": 1,
      "name": "Riposte",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 289,
      "activated": 1,
      "icon_name": "counter",
      "comments": "none",
      "prerequisite_id": 288,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 6,
      "short_description": "When a champion makes an unsuccessful close-combat attack against this unit, this unit makes a close-combat attack against that unit at +3 DMG.",
      "long_description": "When a champion makes an unsuccessful close-combat attack against this unit, this unit makes a close-combat attack against that unit at +3 DMG.",
      "class_name": "Riposte",
      "revision": 1
    },
    {
      "asset_id": 5813,
      "resettable": 1,
      "name": "Ripples",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2822,
      "activated": 1,
      "icon_name": "special",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "When a friendly champion is deployed from the rune dock, this champion's cooldowns are reduced by 1.\r\n",
      "long_description": "When a friendly champion is deployed from the rune dock, this champion's cooldowns are reduced by 1.",
      "class_name": "Ripples",
      "revision": 1
    },
    {
      "asset_id": 4754,
      "resettable": 1,
      "name": "Rise",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1478,
      "activated": 1,
      "icon_name": "ondeath",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 30,
      "short_description": "When this unit dies at the beginning of your opponents turn, it is re-spawned at your nearest deployment zone without Rise or Elsari Coven abilities, -10 HP and -1 SPD. It gains Race: undead and the Boon of the Undead abilities.",
      "long_description": "When this unit dies at the beginning of your opponents turn, it is re-spawned at your nearest deployment zone without Rise or Elsari Coven abilities, -10 HP and -1 SPD. It gains Race: undead and the Boon of the Undead abilities.",
      "class_name": "Rise",
      "revision": 1
    },
    {
      "asset_id": 4903,
      "resettable": 1,
      "name": "Rite of Healing",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 1785,
      "activated": 1,
      "icon_name": "fascinate",
      "comments": "All 3 Rite of X abilities share a cooldown.",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 2,
      "short_description": "Target real champion you own within 5 spaces is destroyed. All friendly champions are healed for 8 HP and gain <ability value=117>Regeneration 3</ability> for 3 turns.",
      "long_description": "Target real champion you own within 5 spaces is destroyed. All friendly champions are healed for 8 HP and gain <ability value=117>Regeneration 3</ability> for 3 turns.",
      "class_name": "RiteOfCreation",
      "revision": 1
    },
    {
      "asset_id": 4905,
      "resettable": 1,
      "name": "Rite of Power",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 1787,
      "activated": 1,
      "icon_name": "final_judgement",
      "comments": "All three Rites share a cooldown",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 2,
      "short_description": "Target real champion you own within 5 spaces is destroyed and friendly champions gain +1 DMG permanently and gain +1 SPD for 3 turns.",
      "long_description": "Target real champion you own within 5 spaces is destroyed and friendly champions gain +1 DMG permanently and gain +1 SPD for 3 turns.",
      "class_name": "RiteOfPower",
      "revision": 1
    },
    {
      "asset_id": 4904,
      "resettable": 1,
      "name": "Ritual of Destruction",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 1786,
      "activated": 1,
      "icon_name": "ondeath_damage",
      "comments": "All three Rites share a cooldown",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 3,
      "short_description": "Target summoned champion within 5 spaces is destroyed. The closest enemy champion within 5 spaces takes 10 acid damage.",
      "long_description": "Target summoned champion within 5 spaces is destroyed. The closest enemy champion within 5 spaces takes 10 acid damage.",
      "class_name": "RitualOfDestruction",
      "revision": 1
    },
    {
      "asset_id": 7337,
      "resettable": 0,
      "name": "Ritual of Healing",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 3107,
      "activated": 1,
      "icon_name": "ondeath_healing",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 3,
      "short_description": "Target summoned champion within 5 spaces is destroyed. The closest friendly champion within 5 spaces and this champion heals for 8 HP.",
      "long_description": "Target summoned champion within 5 spaces is destroyed. The closest friendly champion within 5 spaces and this champion heals for 8 HP.",
      "class_name": "RitualOfHealing",
      "revision": 1
    },
    {
      "asset_id": 4905,
      "resettable": 0,
      "name": "Ritual of Power",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2958,
      "activated": 1,
      "icon_name": "deconstruct",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 3,
      "short_description": "Target summoned champion within 5 spaces is destroyed. Friendly champions get +2 DMG for 4 turns.",
      "long_description": "Target summoned champion within 5 spaces is destroyed. Friendly champions get +2 DMG for 4 turns.",
      "class_name": "RitualOfPower",
      "revision": 1
    },
    {
      "asset_id": 5006,
      "resettable": 1,
      "name": "Roar of the Fallen",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1887,
      "activated": 1,
      "icon_name": "ondeath",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 1,
      "short_description": "When this unit is destroyed, all opposing champions have -1 DEF and -5 DMG for 3 turns.",
      "long_description": "When this unit is destroyed, all opposing champions have -1 DEF and -5 DMG for 3 turns.",
      "class_name": "RoarOfTheFallen",
      "revision": 1
    },
    {
      "asset_id": 5730,
      "resettable": 1,
      "name": "Rock Aura",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2617,
      "activated": 1,
      "icon_name": "terrainrock",
      "comments": "x",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "When this unit comes into play, spaces within 3 spaces of this unit become Rock.",
      "long_description": "When this unit comes into play, spaces within 3 spaces of this unit become Rock.",
      "class_name": "RockAura",
      "revision": 1
    },
    {
      "asset_id": 5655,
      "resettable": 1,
      "name": "Rock Defiance",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2527,
      "activated": 1,
      "icon_name": "troll_defiance",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 5,
      "short_description": "When this unit is successfully attacked, this unit and friendly units within 5 spaces with this ability has +1 DMG for 3 turns and gains 1 MAX HP permanently.",
      "long_description": "When this unit is successfully attacked, this unit and friendly units within 5 spaces with this ability has +1 DMG for 3 turns and gains 1 MAX HP permanently.",
      "class_name": "TrollDefiance",
      "revision": 1
    },
    {
      "asset_id": 4478,
      "resettable": 1,
      "name": "Rock Eater",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 868,
      "activated": 1,
      "icon_name": "eater_rock",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 7,
      "short_description": "When this unit takes Physical damage, it instead recovers HP equal to half the damage that would have been dealt.",
      "long_description": "When this unit takes Physical damage, it instead recovers HP equal to half the damage that would have been dealt.",
      "class_name": "RockEater",
      "revision": 1
    },
    {
      "asset_id": 5695,
      "resettable": 1,
      "name": "Rock Front",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2571,
      "activated": 1,
      "icon_name": "trail_rock",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "At the beginning of each turn, all spaces within 3 spaces of this champion become Rock for 4 turns.",
      "long_description": "At the beginning of each turn, all spaces within 3 spaces of this champion become Rock for 4 turns.",
      "class_name": "RockFront",
      "revision": 1
    },
    {
      "asset_id": 5729,
      "resettable": 1,
      "name": "Rock Generator",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2616,
      "activated": 1,
      "icon_name": "terrainrock",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "At the end of your turn, spaces adjacent to terrain generated by this ability become Rock.  When this relic leaves play, at end of turn, and the end of each turn thereafter, this terrain manipulation effect ends on the most recently affected spaces.",
      "long_description": "At the end of your turn, spaces adjacent to terrain generated by this ability become Rock.  When this relic leaves play, at end of turn, and the end of each turn thereafter, this terrain manipulation effect ends on the most recently affected spaces.",
      "class_name": "RockGenerator",
      "revision": 1
    },
    {
      "asset_id": 5687,
      "resettable": 1,
      "name": "Rock Slide",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 2562,
      "activated": 1,
      "icon_name": "physicalaoe",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "Area Effect 2, Range 5: Champions without <ability value=2527>Rock Defiance</ability> in the affected area take 12 Physical damage and become <condition value=grounded>Grounded</condition> for 3 turns. This damage ignores DEF. Affected spaces become Rock for 3 turns.",
      "long_description": "Area Effect 2, Range 5: Champions without <ability value=2527>Rock Defiance</ability> in the affected area take 12 Physical damage and become <condition value=grounded>Grounded</condition> for 3 turns. This damage ignores DEF. Affected spaces become Rock for 3 turns.",
      "class_name": "RockSlide",
      "revision": 1
    },
    {
      "asset_id": 4609,
      "resettable": 1,
      "name": "Rock Trap",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1029,
      "activated": 1,
      "icon_name": "traprock",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "When an enemy champion moves within 2 spaces of the trap, the trap is destroyed and all enemy champions within range take 4 Physical damage, are knocked back 2 spaces, and become <condition value=stunned>Stunned</condition> for 1 turn if they took damage. This damage ignores DEF.",
      "long_description": "When an enemy champion moves within 2 spaces of the trap, the trap is destroyed and all enemy champions within range take 4 Physical damage, are knocked back 2 spaces, and become <condition value=stunned>Stunned</condition> for 1 turn if they took damage. This damage ignores DEF.",
      "class_name": "RelicRockTrap",
      "revision": 1
    },
    {
      "asset_id": 5189,
      "resettable": 1,
      "name": "Rotting Blows",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1966,
      "activated": 1,
      "icon_name": "disease",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=decaying>Decaying</condition> for 4 turns.",
      "long_description": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=decaying>Decaying</condition> for 4 turns.",
      "class_name": "RottingBlows",
      "revision": 1
    },
    {
      "asset_id": 5176,
      "resettable": 1,
      "name": "Rouse",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1953,
      "activated": 1,
      "icon_name": "allybuffs",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "Other real friendly champions with less than 9 base DMG get +2 DMG while this unit is in play. This ability does not stack.",
      "long_description": "Other real friendly champions with less than 9 base DMG get +2 DMG while this unit is in play. This ability does not stack.",
      "class_name": "Rouse",
      "revision": 1
    },
    {
      "asset_id": 5856,
      "resettable": 1,
      "name": "Rover: Accrue",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2865,
      "activated": 1,
      "icon_name": "rover_resources",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "This champion has Accrue when it is not within 5 spaces of a font or shrine.",
      "long_description": "This champion has Accrue (This champion gains 2 AP at the end of your turn if it did not attack.) when it is not within 5 spaces of a font or shrine or shrine.",
      "class_name": "RoverAccrue",
      "revision": 1
    },
    {
      "asset_id": 5860,
      "resettable": 1,
      "name": "Rover: Assassinate",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2869,
      "activated": 1,
      "icon_name": "rover_offensive",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "This champion has Assassinate when it is not within 5 spaces of a font or shrine.",
      "long_description": "This champion has Assassinate 2(while Stealthed, this champion makes an attack against target champion at triple DMG and +1 AP. This attack ignores DEF and does not miss.) when it is not within 5 spaces of a font or shrine.",
      "class_name": "RoverAssassinate",
      "revision": 1
    },
    {
      "asset_id": 5858,
      "resettable": 1,
      "name": "Rover: Blitz",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2867,
      "activated": 1,
      "icon_name": "rover_offensive",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "This champion has Blitz when it is not within 5 spaces of a font or shrine.",
      "long_description": "This champion has Blitz (this champion gets +1 DMG for each space it moves until end of turn.) when it is not within 5 spaces of a font or shrine.",
      "class_name": "RoverBlitz",
      "revision": 1
    },
    {
      "asset_id": 5861,
      "resettable": 1,
      "name": "Rover: Conqueror",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2870,
      "activated": 1,
      "icon_name": "rover_offensive",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "This champion has Conqueror when it is not within 5 spaces of a font or shrine.",
      "long_description": "This champion has Conqueror (While this champion is in a neutral or enemy font zone it gets +1 DEF, +2 DMG and Fear 3.) when it is not within 5 spaces of a font or shrine.",
      "class_name": "RoverConqueror",
      "revision": 1
    },
    {
      "asset_id": 5850,
      "resettable": 1,
      "name": "Rover: Deep Dive",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2859,
      "activated": 1,
      "icon_name": "rover_defensive",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "This champion has Deep Dive when it is not within 5 spaces of a font or shrine. ",
      "long_description": "This champion has Deep Dive (This ability may be activated only if this unit occupies water. This unit is relocated to target water space.) when it is not within 5 spaces of a font or shrine. ",
      "class_name": "RoverDeepDive",
      "revision": 1
    },
    {
      "asset_id": 5829,
      "resettable": 1,
      "name": "Rover: Elusive",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2838,
      "activated": 1,
      "icon_name": "rover_defensive",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "This champion has Elusive when it is not within 5 spaces of a font or shrine.",
      "long_description": "This champion has Elusive (All ranged attacks against this champion miss if it is not Stunned or Paralyzed.) when it is not within 5 spaces of a font or shrine.",
      "class_name": "RoverElusive",
      "revision": 1
    },
    {
      "asset_id": 5803,
      "resettable": 1,
      "name": "Rover: Evasive",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2812,
      "activated": 1,
      "icon_name": "rover_defensive",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "This champion has <ability value=1378>Evasive 3</ability> when it is not within 5 spaces of a font or shrine.",
      "long_description": "This champion has <ability value=1378>Evasive 3</ability> when it is not within 5 spaces of a font or shrine.",
      "class_name": "RoverEvasive",
      "revision": 1
    },
    {
      "asset_id": 5871,
      "resettable": 1,
      "name": "Rover: Fire Volatility",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2880,
      "activated": 1,
      "icon_name": "rover_offensive",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "This champion has Fire Volatility (When this unit takes fire damage, it releases a flame pulse equal to that damage, to a maximum of 12 damage, to every unit within 2 spaces. This damage ignores DEF. This unit can not become <condition value=charred popup=false>Charred</condition>.) when it is not within 5 spaces of a font or shrine.",
      "long_description": "This champion has Fire Volatility (When this unit takes fire damage, it releases a flame pulse equal to that damage, to a maximum of 12 damage, to every unit within 2 spaces. This damage ignores DEF. This unit can not become <condition value=charred popup=false>Charred</condition>.) when it is not within 5 spaces of a font or shrine.",
      "class_name": "RoverFireVolatility",
      "revision": 1
    },
    {
      "asset_id": 5855,
      "resettable": 1,
      "name": "Rover: HighTide",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2864,
      "activated": 1,
      "icon_name": "rover_offensive",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "This champion has High Tide when it is not within 5 spaces of a font or shrine. ",
      "long_description": "This champion has High Tide (At the beginning of each turn, all spaces within 3 spaces of this champion becomes Shallow Water (Impeding Vegetation) for 4 turns.) when it is not within 5 spaces of a font or shrine. ",
      "class_name": "RoverHighTide",
      "revision": 1
    },
    {
      "asset_id": 5804,
      "resettable": 1,
      "name": "Rover: Hostile",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2813,
      "activated": 1,
      "icon_name": "rover_offensive",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "This champion has <ability value=1233>Hostile</ability> when it is not within 5 spaces of a font or shrine.",
      "long_description": "This champion has <ability value=1233>Hostile</ability> when it is not within 5 spaces of a font or shrine.",
      "class_name": "RoverHostile",
      "revision": 1
    },
    {
      "asset_id": 5854,
      "resettable": 1,
      "name": "Rover: Incite Rage",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2863,
      "activated": 1,
      "icon_name": "rover_offensive",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "This champion has Incite Rage when it is not within 5 spaces of a font or shrine. ",
      "long_description": "This champion has Incite Rage(Target friendly barbarian champion gains Berserker 3 for 5 turns and recovers 8 AP.) when it is not within 5 spaces of a font or shrine. ",
      "class_name": "RoverInciteRage",
      "revision": 1
    },
    {
      "asset_id": 5857,
      "resettable": 1,
      "name": "Rover: Incoherent Babbling",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2866,
      "activated": 1,
      "icon_name": "rover_babbling",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "This champion has <ability value=2824>Incoherent Babbling</ability> when it is not within 5 spaces of a font or shrine.",
      "long_description": "This champion has <ability value=2824>Incoherent Babbling</ability> when it is not within 5 spaces of a font or shrine.",
      "class_name": "RoverIncoherentBabbling",
      "revision": 1
    },
    {
      "asset_id": 5853,
      "resettable": 1,
      "name": "Rover: Judgement",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2862,
      "activated": 1,
      "icon_name": "rover_offensive",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "This champion has Judgement when it is not within 5 spaces of a font or shrine. ",
      "long_description": "This champion has <ability value=2116>Judgement</ability> when it is not within 5 spaces of a font or shrine. ",
      "class_name": "RoverJudgement",
      "revision": 1
    },
    {
      "asset_id": 5859,
      "resettable": 1,
      "name": "Rover: Mobility",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2868,
      "activated": 1,
      "icon_name": "rover_defensive",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "This champion has <ability value=6>Mobility</ability> when it is not within 5 spaces of a font or shrine. \r\n",
      "long_description": "This champion has <ability value=6>Mobility</ability> when it is not within 5 spaces of a font or shrine. \r\n",
      "class_name": "RoverMobility",
      "revision": 1
    },
    {
      "asset_id": 5852,
      "resettable": 1,
      "name": "Rover: Multiattack",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2861,
      "activated": 1,
      "icon_name": "rover_offensive",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "This champion has <ability value=16>Multiattack 2</ability> when it is not within 5 spaces of a font or shrine.",
      "long_description": "This champion has <ability value=16>Multiattack 2</ability> when it is not within 5 spaces of a font or shrine.",
      "class_name": "RoverMultiattack",
      "revision": 1
    },
    {
      "asset_id": 5862,
      "resettable": 1,
      "name": "Rover: Stat Bonus: Speed",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2871,
      "activated": 1,
      "icon_name": "rover_resources",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "This champion has Stat Bonus: Speed 1 when it is not within 5 spaces of a font or shrine. ",
      "long_description": "This champion has Stat Bonus: Speed 1 when it is not within 5 spaces of a font or shrine. ",
      "class_name": "RoverSpeed",
      "revision": 1
    },
    {
      "asset_id": 5806,
      "resettable": 1,
      "name": "Rover: Surge: Enemy",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2815,
      "activated": 1,
      "icon_name": "rover_resources",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "This champion has Surge: Enemy when it is not within 5 spaces of a font or shrine.",
      "long_description": "This champion has Surge: Enemy (This unit has +1 DMG for each deployed enemy champion.) when it is not within 5 spaces of a font or shrine.",
      "class_name": "RoverSurgeEnemy",
      "revision": 1
    },
    {
      "asset_id": 5851,
      "resettable": 1,
      "name": "Rover: Swallow Whole",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2860,
      "activated": 1,
      "icon_name": "rover_offensive",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "This champion has Swallow Whole when it is not within 5 spaces of a font or shrine. ",
      "long_description": "This champion has Swallow Whole (Target small, opposing, champion is removed from play and loses 8 health each turn. If this champion leaves play or loses this ability, any champions with health remaining is deployed in the nearest available space. Units with the Elite ability may not be targeted by this ability.)when it is not within 5 spaces of a font or shrine. ",
      "class_name": "RoverSwallowWhole",
      "revision": 1
    },
    {
      "asset_id": 5805,
      "resettable": 1,
      "name": "Rover: Tough 3",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2814,
      "activated": 1,
      "icon_name": "rover_defensive",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "This champion has Tough 3 when it is not within 5 spaces of a font or shrine.",
      "long_description": "This champion has Tough 3 (Any time this champion would take damage, it takes 3 less than normal.) when it is not within 5 spaces of a font or shrine.",
      "class_name": "RoverTough",
      "revision": 1
    },
    {
      "asset_id": 5849,
      "resettable": 1,
      "name": "Rover: Trail Water",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2858,
      "activated": 1,
      "icon_name": "rover_resources",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "This champion has Trail: Water when it is not within 5 spaces of a font or shrine.",
      "long_description": "This champion has Trail: Water (At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes Water (Impeding 1) for 3 turns.) when it is not within 5 spaces of a font or shrine.",
      "class_name": "RoverTrailWater",
      "revision": 1
    },
    {
      "asset_id": 5205,
      "resettable": 1,
      "name": "Royal Blood",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1982,
      "activated": 1,
      "icon_name": "majestic",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "While Talgar is in play, this champion gains +2 DMG and <ability value=15>Multiattack 1</ability>. While Euan is in play, this champion gains +2 DEF and <ability value=31>Defender</ability>.",
      "long_description": "While Talgar is in play, this champion gains +2 DMG and <ability value=15>Multiattack 1</ability>. While Euan is in play, this champion gains +2 DEF and <ability value=31>Defender</ability>.",
      "class_name": "RoyalBlood",
      "revision": 1
    },
    {
      "asset_id": 7141,
      "resettable": 0,
      "name": "Ruby Catalyst",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2983,
      "activated": 1,
      "icon_name": "ruby_catalyst",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "When a unit takes Fire damage, this unit gains +2 MAX HP.  This does not include damage from Charred. When this unit is destroyed, enemy champions within 5 spaces take Fire damage equal this unit's MAX HP, divided evenly (to a minimum of 2 and a maximum of 10).",
      "long_description": "When a unit takes Fire damage, this unit gains +2 MAX HP.  This does not include damage from Charred. When this unit is destroyed, enemy champions within 5 spaces take Fire damage equal this unit's MAX HP, divided evenly (to a minimum of 2 and a maximum of 10).",
      "class_name": "RelicRubyCatalyst",
      "revision": 1
    },
    {
      "asset_id": 5571,
      "resettable": 1,
      "name": "Rude Fighter",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2431,
      "activated": 1,
      "icon_name": "enrage",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 0,
      "short_description": "When this champion successfully hits a champion with a basic attack, that champion becomes Antagonized.",
      "long_description": "When this champion successfully hits a champion with a basic attack, that champion becomes Antagonized.",
      "class_name": "RudeFighter",
      "revision": 1
    },
    {
      "asset_id": 4820,
      "resettable": 1,
      "name": "Rugolth's Fist",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 1699,
      "activated": 1,
      "icon_name": "novaphysical",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "Non-Flying enemy Champions within 4 spaces take 12 Physical damage and lose all AP. This damage ignores DEF.",
      "long_description": "Non-Flying enemy Champions within 4 spaces take 12 Physical damage and lose all AP. This damage ignores DEF.",
      "class_name": "RugolthsFist",
      "revision": 1
    },
    {
      "asset_id": 5078,
      "resettable": 1,
      "name": "Ruin",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 1253,
      "activated": 1,
      "icon_name": "terraingrass",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 5,
      "short_description": "Target relic within 3 spaces is destroyed. If the relic was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Shatter).",
      "long_description": "Target relic within 3 spaces is destroyed. If the relic was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Shatter).",
      "class_name": "ReclaimRelic",
      "revision": 1
    },
    {
      "asset_id": 5202,
      "resettable": 1,
      "name": "Running Start",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1979,
      "activated": 1,
      "icon_name": "flight",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "Whenever this champion moves 2 or more spaces, it gains <ability value=1>Flight</ability> for 2 turns.",
      "long_description": "Whenever this champion moves 2 or more spaces, it gains <ability value=1>Flight</ability> for 2 turns.",
      "class_name": "RunningStart",
      "revision": 1
    },
    {
      "asset_id": 5792,
      "resettable": 1,
      "name": "Running Strike",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2769,
      "activated": 1,
      "icon_name": "running_strike",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 15,
      "short_description": "For every 2 spaces this champion moves in a single turn, it gains +1 DMG and +1 RNG for 1 turn.  This stacks up to 4 times.",
      "long_description": "For every 2 spaces this champion moves in a single turn, it gains +1 DMG and +1 RNG for 1 turn.  This stacks up to 4 times.",
      "class_name": "RunningStrike",
      "revision": 1
    },
    {
      "asset_id": 4450,
      "resettable": 1,
      "name": "Ryv the Ruthless",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2719,
      "activated": 1,
      "icon_name": "hero",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "This rune is a Limited Edition rune from Broken Shard, and counts as a Ruthless Netmaster.",
      "long_description": "This rune is a Limited Edition rune from Broken Shard, and counts as a Ruthless Netmaster.",
      "class_name": "Placeholder",
      "revision": 1
    },
    {
      "asset_id": 7760,
      "resettable": 0,
      "name": "Sabotage: Acid",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3287,
      "activated": 1,
      "icon_name": "sabotage_acid",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Acid damage and gains <ability value=93>Vulnerability: Acid</ability>.",
      "long_description": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Acid damage and gains <ability value=93>Vulnerability: Acid</ability>.",
      "class_name": "SabotageAcid",
      "revision": 1
    },
    {
      "asset_id": 7762,
      "resettable": 0,
      "name": "Sabotage: Armor",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3288,
      "activated": 1,
      "icon_name": "sabotage_armor",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "The next enemy champion deployed from the runedock while this champion is in play has -2 DEF and <ability value=2008>Liability</ability>.",
      "long_description": "The next enemy champion deployed from the runedock while this champion is in play has -2 DEF and <ability value=2008>Liability</ability>.",
      "class_name": "SabotageArmor",
      "revision": 1
    },
    {
      "asset_id": 7759,
      "resettable": 0,
      "name": "Sabotage: Defile",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3286,
      "activated": 1,
      "icon_name": "sabotage_defile",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "The next enemy champion deployed from the runedock while this champion is in play becomes <condition value=diseased>Diseased 3</condition>, <condition value=defiled>Defiled</condition> and <condition value=inhibited>Inhibited</condition> for 8 rounds.",
      "long_description": "The next enemy champion deployed from the runedock while this champion is in play becomes <condition value=diseased>Diseased 3</condition>, <condition value=defiled>Defiled</condition> and <condition value=inhibited>Inhibited</condition> for 8 rounds.",
      "class_name": "SabotageDefile",
      "revision": 1
    },
    {
      "asset_id": 7290,
      "resettable": 0,
      "name": "Sabotage: Electricity",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3081,
      "activated": 1,
      "icon_name": "sabotage_acid",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 4,
      "short_description": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Electricity damage and gains <ability value=90>Vulnerability: Electricity</ability>.",
      "long_description": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Electricity damage and gains <ability value=90>Vulnerability: Electricity</ability>.",
      "class_name": "SabotageElectricity",
      "revision": 1
    },
    {
      "asset_id": 7300,
      "resettable": 0,
      "name": "Sabotage: Fire",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3085,
      "activated": 1,
      "icon_name": "sabotage_acid",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 4,
      "short_description": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Fire damage and gains <ability value=88>Vulnerability: Fire</ability>.",
      "long_description": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Fire damage and gains <ability value=88>Vulnerability: Fire</ability>.",
      "class_name": "SabotageFire",
      "revision": 1
    },
    {
      "asset_id": 7758,
      "resettable": 0,
      "name": "Sabotage: Lethargy",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3285,
      "activated": 1,
      "icon_name": "sabotage_lethargy",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "The next enemy champion deployed from the runedock while this champion is in play has -2 DMG and <ability value=2012>Lethargic</ability>.",
      "long_description": "The next enemy champion deployed from the runedock while this champion is in play has -2 DMG and <ability value=2012>Lethargic</ability>.",
      "class_name": "SabotageLethargy",
      "revision": 1
    },
    {
      "asset_id": 7855,
      "resettable": 0,
      "name": "Sabotage: Poison",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3334,
      "activated": 1,
      "icon_name": "sabotage_acid",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 4,
      "short_description": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Poison damage and gains <ability value=91>Vulnerability: Poison</ability>.",
      "long_description": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Poison damage and gains <ability value=91>Vulnerability: Poison</ability>.",
      "class_name": "SabotagePoison",
      "revision": 1
    },
    {
      "asset_id": 4896,
      "resettable": 1,
      "name": "Sabotage: Psychic",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1778,
      "activated": 1,
      "icon_name": "sabotage_acid",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 4,
      "short_description": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Psychic damage and gains <ability value=95>Vulnerability: Psychic</ability>.",
      "long_description": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Psychic damage and gains <ability value=95>Vulnerability: Psychic</ability>.",
      "class_name": "SabotagePsychic",
      "revision": 1
    },
    {
      "asset_id": 4291,
      "resettable": 1,
      "name": "Sacrifice at Altar",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 675,
      "activated": 1,
      "icon_name": "sacrifice",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "<mechanic value=sacrifice>Sacrifice</mechanic> this unit, and the nearest opposing champion within 6 spaces loses 15 HP. If this unit is Summoned, the HP loss is reduced to 8. This ability only works on Undead champions.",
      "long_description": "<mechanic value=sacrifice>Sacrifice</mechanic> this unit, and the nearest opposing champion within 6 spaces loses 15 HP. If this unit is Summoned, the HP loss is reduced to 8. This ability only works on Undead champions.",
      "class_name": "SacrificeAltar",
      "revision": 1
    },
    {
      "asset_id": 5811,
      "resettable": 1,
      "name": "Sacrifice of De'lim",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 2820,
      "activated": 1,
      "icon_name": "chan_fuel",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "<mechanic value=sacrifice>Sacrifice</mechanic> target Treefolk champion you own within 5 spaces and friendly units with <ability value=2840>Devotee of De'lim</ability> gain +2 DMG.  If the champion has a nora cost of 30 or more, 25% of the sacrificed champion's nora cost is refunded.",
      "long_description": "<mechanic value=sacrifice>Sacrifice</mechanic> target Treefolk champion you own within 5 spaces and friendly units with <ability value=2840>Devotee of De'lim</ability> gain +2 DMG.  If the champion has a nora cost of 30 or more, 25% of the sacrificed champion's nora cost is refunded.",
      "class_name": "SacrificeOfDelim",
      "revision": 1
    },
    {
      "asset_id": 0,
      "resettable": 1,
      "name": "Sacrificial Altar",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 714,
      "activated": 1,
      "icon_name": "sacrifice",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "Friendly Undead champions within 2 spaces gain <ability value=675>Sacrifice at Altar</ability>, which allows them to deal 15 Loss of Life to the nearest opponent within 6 spaces. Summoned undead units only deal 10 Loss of Life. Only champions with the same owner as the Altar can be sacrificed.",
      "long_description": "Friendly Undead champions within 2 spaces gain <ability value=675>Sacrifice at Altar</ability>, which allows them to deal 15 Loss of Life to the nearest opponent within 6 spaces. Summoned undead units only deal 10 Loss of Life. Only champions with the same owner as the Altar can be sacrificed.",
      "class_name": "RelicSacrificialAltar",
      "revision": 1
    },
    {
      "asset_id": 5539,
      "resettable": 1,
      "name": "Sacrificial Power",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2398,
      "activated": 1,
      "icon_name": "sacrificial_power",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 5,
      "short_description": "This champion has <ability value=2399>Dark Summons</ability> and <ability value=820>Portal</ability>. When a real opposing champion is destroyed this champion's cooldowns are reduced by 10. Sheoul Disciples cost 10 less nora.",
      "long_description": "This champion has <ability value=2399>Dark Summons</ability> and <ability value=820>Portal</ability>. When a real opposing champion is destroyed this champion's cooldowns are reduced by 10. Sheoul Disciples cost 10 less nora.",
      "class_name": "SacrificialPower",
      "revision": 1
    },
    {
      "asset_id": 7366,
      "resettable": 0,
      "name": "Salaman Ingenuity: Cooldowns",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3122,
      "activated": 1,
      "icon_name": "salamaningenuity",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "When a friendly equipment or relic is deployed from the runedock within 5 spaces of this unit, friendly Salaman within 5 spaces (including this one) have their abilities on CD have their CD reduced by 1.",
      "long_description": "When a friendly equipment or relic is deployed from the runedock within 5 spaces of this unit, friendly Salaman within 5 spaces (including this one) have their abilities on CD have their CD reduced by 1.",
      "class_name": "SalamanIngenuityCooldowns",
      "revision": 1
    },
    {
      "asset_id": 7365,
      "resettable": 0,
      "name": "Salaman Ingenuity: Damage",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3121,
      "activated": 1,
      "icon_name": "salamaningenuity",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "When a friendly equipment or relic is deployed from the runedock within 5 spaces of this unit, friendly Salaman within 5 spaces (including this one) gain +2 DMG for 4 turns.  This stacks up to 3 times.",
      "long_description": "When a friendly equipment or relic is deployed from the runedock within 5 spaces of this unit, friendly Salaman within 5 spaces (including this one) gain +2 DMG for 4 turns.  This stacks up to 3 times.",
      "class_name": "SalamanIngenuityDamage",
      "revision": 1
    },
    {
      "asset_id": 7598,
      "resettable": 0,
      "name": "Salaman Ingenuity: Evasive",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3226,
      "activated": 1,
      "icon_name": "salamaningenuity",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "When a friendly equipment or relic is deployed from the runedock within 5 spaces of this unit, friendly Salaman within 5 spaces (including this one) gain a rank of <ability value=1376>Evasive</ability> for 4 turns.",
      "long_description": "When a friendly equipment or relic is deployed from the runedock within 5 spaces of this unit, friendly Salaman within 5 spaces (including this one) gain a rank of <ability value=1376>Evasive</ability> for 4 turns.",
      "class_name": "SalamanIngenuityEvasive",
      "revision": 1
    },
    {
      "asset_id": 7764,
      "resettable": 0,
      "name": "Salvage Equipment",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3290,
      "activated": 1,
      "icon_name": "reclaim_materials",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "When an equipment or equipped champion is destroyed, this champion heals for 5 HP and gains 2 AP.",
      "long_description": "When an equipment or equipped champion is destroyed, this champion heals for 5 HP and gains 2 AP.",
      "class_name": "Salvage",
      "revision": 1
    },
    {
      "asset_id": 5167,
      "resettable": 1,
      "name": "Sanctuary of Hope",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1940,
      "activated": 1,
      "icon_name": "aurapositive",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "Friendly champions within 4 spaces of this unit have their AP cost for all abilities (excluding basic attacks) reduced by 1 AP. When a friendly Champion uses an ability (excluding basic attacks) within 4 spaces of this unit, this unit takes 3 Physical damage.",
      "long_description": "Friendly champions within 4 spaces of this unit have their AP cost for all abilities (excluding basic attacks) reduced by 1 AP. When a friendly Champion uses an ability (excluding basic attacks) within 4 spaces of this unit, this unit takes 3 Physical damage.",
      "class_name": "RelicSanctuaryOfHope",
      "revision": 1
    },
    {
      "asset_id": 5113,
      "resettable": 1,
      "name": "Sand Aura",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1299,
      "activated": 1,
      "icon_name": "terrainsand",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "When this unit comes into play, spaces within 3 spaces of this unit become Sand.",
      "long_description": "When this unit comes into play, spaces within 3 spaces of this unit become Sand.",
      "class_name": "RelicSandGenerator",
      "revision": 1
    },
    {
      "asset_id": 4667,
      "resettable": 1,
      "name": "Sand Spray",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 1101,
      "activated": 1,
      "icon_name": "sand",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "Area Effect 2, Range 5: Enemy units take 10 Physical damage. This damage ignores DEF.  Units successfully damaged become <condition value=sandblasted>Sandblasted</condition> for 4 turns. Spaces within the affected area become Sand for 6 turns.",
      "long_description": "Area Effect 2, Range 5: Enemy units take 10 Physical damage. This damage ignores DEF.  Units successfully damaged become <condition value=sandblasted>Sandblasted</condition> for 4 turns. Spaces within the affected area become Sand for 6 turns.",
      "class_name": "SandSpray",
      "revision": 1
    },
    {
      "asset_id": 5080,
      "resettable": 1,
      "name": "Sand Veil",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1254,
      "activated": 1,
      "icon_name": "terrainsand",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "When this champion comes into play all terrain within 10 spaces turns into sand terrain for 3 turns.",
      "long_description": "When this champion comes into play all terrain within 10 spaces turns into sand terrain for 3 turns.",
      "class_name": "SandVeil",
      "revision": 1
    },
    {
      "asset_id": 7450,
      "resettable": 0,
      "name": "Sandbreach",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3157,
      "activated": 1,
      "icon_name": "terrainsand",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "When this unit is damaged, spaces within 2 spaces becomes Sand for 3 turns. Enemy champions within those spaces become <condition value=sandblasted>Sandblasted</condition> for 3 turns. This triggers once per turn.",
      "long_description": "When this unit is damaged, spaces within 2 spaces becomes Sand for 3 turns. Enemy champions within those spaces become <condition value=sandblasted>Sandblasted</condition> for 3 turns. This triggers once per turn.",
      "class_name": "Sandbreach",
      "revision": 1
    },
    {
      "asset_id": 4379,
      "resettable": 1,
      "name": "Sands of Time",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1418,
      "activated": 1,
      "icon_name": "scry",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "When a real opposing unit within 6 spaces  is destroyed by an attack, an opposing revealed rune has its cooldown increased by 5.",
      "long_description": "When a real opposing unit within 6 spaces  is destroyed by an attack, an opposing revealed rune has its cooldown increased by 5.",
      "class_name": "RelicWitchesHourglass",
      "revision": 1
    },
    {
      "asset_id": 4668,
      "resettable": 1,
      "name": "Sandstriker",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1100,
      "activated": 1,
      "icon_name": "offenseenhance",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "While this champion occupies Sand terrain, it has +5 DMG.",
      "long_description": "While this champion occupies Sand terrain, it has +5 DMG.",
      "class_name": "Sandstriker",
      "revision": 1
    },
    {
      "asset_id": 7984,
      "resettable": 0,
      "name": "Sanguine Flight",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3380,
      "activated": 1,
      "icon_name": "flight",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "This champion is <condition value=flying>Flying</condition> and has <ability value=3379>Magic Ward</ability> and <ability value=977>Bleed</ability>.",
      "long_description": "This champion is <condition value=flying>Flying</condition> and has <ability value=3379>Magic Ward</ability> and <ability value=977>Bleed</ability>.",
      "class_name": "SanguineFlight",
      "revision": 1
    },
    {
      "asset_id": 8001,
      "resettable": 0,
      "name": "Sanguine Sorceress",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3398,
      "activated": 1,
      "icon_name": "greater_vampirism",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "This champion has <ability value=607>Essence Capture</ability>. While there is a friendly champion with <ability value=3399>Lord of Strigoi</ability> in play, friendly champions with Race: Vampyre within 3 spaces of this champion gain <ability value=3151>Bloodspurt</ability>.",
      "long_description": "This champion has <ability value=607>Essence Capture</ability>. While there is a friendly champion with <ability value=3399>Lord of Strigoi</ability> in play, friendly champions with Race: Vampyre within 3 spaces of this champion gain <ability value=3151>Bloodspurt</ability>.",
      "class_name": "SanguineSorceress",
      "revision": 1
    },
    {
      "asset_id": 7135,
      "resettable": 0,
      "name": "Sapphire Catalyst",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2977,
      "activated": 1,
      "icon_name": "sapphire_catalyst",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "When a unit takes Frost damage, this unit gains +2 MAX HP.  This does not include damage from Chilled. When this unit is destroyed, enemy champions within 5 spaces take Frost damage equal this unit's MAX HP, divided evenly (to a minimum of 2 and a maximum of 10).",
      "long_description": "When a unit takes Frost damage, this unit gains +2 MAX HP.  This does not include damage from Chilled. When this unit is destroyed, enemy champions within 5 spaces take Frost damage equal this unit's MAX HP, divided evenly (to a minimum of 2 and a maximum of 10).",
      "class_name": "RelicSapphireCatalyst",
      "revision": 1
    },
    {
      "asset_id": 7287,
      "resettable": 0,
      "name": "Sapping Armor",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3079,
      "activated": 1,
      "icon_name": "sapping_armor",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "When this champion is successfully attacked by a basic attack, the attacking champion loses 3 AP.",
      "long_description": "When this champion is successfully attacked by a basic attack, the attacking champion loses 3 AP.",
      "class_name": "SappingArmor",
      "revision": 1
    },
    {
      "asset_id": 4114,
      "resettable": 1,
      "name": "Sapping Blow",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 280,
      "activated": 1,
      "icon_name": "offenseenhance",
      "comments": "none",
      "prerequisite_id": 279,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 7,
      "short_description": "When this unit damages a champion on an attack, that unit loses 2 AP.",
      "long_description": "When this unit damages a champion on an attack, that unit loses 2 AP.",
      "class_name": "SappingBlow",
      "revision": 1
    },
    {
      "asset_id": 4595,
      "resettable": 1,
      "name": "Sapping Strike",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 978,
      "activated": 1,
      "icon_name": "stab",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 5,
      "short_description": "This champion makes a Physical attack for 12 damage against target enemy unit at RNG 2-5. If the target is successfully damaged, it loses all AP. This damage ignores DEF. ",
      "long_description": "This champion makes a Physical attack for 12 damage against target enemy unit at RNG 2-5. If the target is successfully damaged, it loses all AP. This damage ignores DEF. ",
      "class_name": "Boomerang",
      "revision": 1
    },
    {
      "asset_id": 5151,
      "resettable": 1,
      "name": "Savage",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1896,
      "activated": 1,
      "icon_name": "savage",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "While 4 or more friendly champions with this ability are in play, when this champion's health falls below 1 it is <mechanic value=cleansed>Cleansed</mechanic>, it's current health is set to 1, and it gains <condition value=impervious>Impervious</condition> until the end of that turn. Once Impervious triggers this champion will die at the end of 2 turns.",
      "long_description": "While 4 or more friendly champions with this ability are in play, when this champion's health falls below 1 it is <mechanic value=cleansed>Cleansed</mechanic>, it's current health is set to 1, and it gains <condition value=impervious>Impervious</condition> until the end of that turn. Once Impervious triggers this champion will die at the end of 2 turns.",
      "class_name": "Savage",
      "revision": 1
    },
    {
      "asset_id": 7269,
      "resettable": 0,
      "name": "Savage Armaments",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3070,
      "activated": 1,
      "icon_name": "comboatk_devastate",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 5,
      "short_description": "When a friendly champion with Race: Yeti, Race: Lonx, or Race: Jakei becomes equipped, it gains 1 AP and +1 DMG for 4 turns. This does not stack.",
      "long_description": "When a friendly champion with Race: Yeti, Race: Lonx, or Race: Jakei becomes equipped, it gains 1 AP and +1 DMG for 4 turns. This does not stack.",
      "class_name": "SavageArmaments",
      "revision": 1
    },
    {
      "asset_id": 5665,
      "resettable": 1,
      "name": "Savage Conduit",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2742,
      "activated": 1,
      "icon_name": "savage_conduit",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 10,
      "short_description": "When an opposing champion with Chilled, Frozen or <condition value=awestruck popup=false>Awestruck</condition> is damaged by an attack, this champion heals for 25% of the damage dealt (to a minimum of 3).",
      "long_description": "When an opposing champion with Chilled, Frozen or <condition value=awestruck popup=false>Awestruck</condition> is damaged by an attack, this champion heals for 25% of the damage dealt (to a minimum of 3).",
      "class_name": "SavageConduit",
      "revision": 1
    },
    {
      "asset_id": 5670,
      "resettable": 1,
      "name": "Savage Exploit",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2542,
      "activated": 1,
      "icon_name": "iceguard",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 7,
      "short_description": "When this champion makes a successful basic attack against a target with <condition value=frozen>Frozen</condition>, <condition value=chilled>Chilled</condition> or <condition value=awestruck popup=false>Awestruck</condition>, it gains 1 AP and has +2 DMG for the attack.",
      "long_description": "When this champion makes a successful basic attack against a target with <condition value=frozen>Frozen</condition>, <condition value=chilled>Chilled</condition> or <condition value=awestruck popup=false>Awestruck</condition>, it gains 1 AP and has +2 DMG for the attack.",
      "class_name": "SavageExploit",
      "revision": 1
    },
    {
      "asset_id": 4814,
      "resettable": 1,
      "name": "Savage Roar",
      "ap_cost": 3,
      "level": 1,
      "ability_id": 1635,
      "activated": 1,
      "icon_name": "novasonic",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 6,
      "activation_type": 1,
      "ranked": 1,
      "cost": 6,
      "short_description": "All enemy champions within 2 spaces take 5 Sonic damage, lose 1 AP and are knocked back 1 space.",
      "long_description": "All enemy champions within 2 spaces take 5 Sonic damage, lose 1 AP and are knocked back 1 space.",
      "class_name": "SavageRoar",
      "revision": 1
    },
    {
      "asset_id": 4814,
      "resettable": 1,
      "name": "Savage Roar",
      "ap_cost": 3,
      "level": 2,
      "ability_id": 1636,
      "activated": 1,
      "icon_name": "novasonic",
      "comments": "",
      "prerequisite_id": 1635,
      "cooldown": 6,
      "activation_type": 1,
      "ranked": 1,
      "cost": 6,
      "short_description": "All enemy champions within 2 spaces take 6 Sonic damage, lose 1 AP and are knocked back 1 space.",
      "long_description": "All enemy champions within 2 spaces take 6 Sonic damage, lose 1 AP and are knocked back 1 space.",
      "class_name": "SavageRoar",
      "revision": 1
    },
    {
      "asset_id": 4814,
      "resettable": 1,
      "name": "Savage Roar",
      "ap_cost": 3,
      "level": 3,
      "ability_id": 1637,
      "activated": 1,
      "icon_name": "novasonic",
      "comments": "",
      "prerequisite_id": 1636,
      "cooldown": 6,
      "activation_type": 1,
      "ranked": 1,
      "cost": 6,
      "short_description": "All enemy champions within 2 spaces take 12 Sonic damage, lose 3 AP and are knocked back 2 spaces.",
      "long_description": "All enemy champions within 2 spaces take 12 Sonic damage, lose 3 AP and are knocked back 2 spaces.",
      "class_name": "SavageRoar",
      "revision": 1
    },
    {
      "asset_id": 5152,
      "resettable": 1,
      "name": "Scale Armor",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1899,
      "activated": 1,
      "icon_name": "scale_armor",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "This champion takes 25% less damage (after DEF) from attacks.",
      "long_description": "This champion takes 25% less damage (after DEF) from attacks.",
      "class_name": "ScaleArmor",
      "revision": 1
    },
    {
      "asset_id": 5756,
      "resettable": 1,
      "name": "Scarlet Sigil",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2657,
      "activated": 1,
      "icon_name": "griffin_sigil",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "This champion gains +1 DMG and <ability value=543>Attack: Fire</ability> for 5 turns when a friendly unit with a Sigil ability is deployed from the runedock.\r\n",
      "long_description": "This champion gains +1 DMG and <ability value=543>Attack: Fire</ability> for 5 turns when a friendly unit with a Sigil ability is deployed from the runedock.\r\n\r\n",
      "class_name": "ScarletSigil",
      "revision": 1
    },
    {
      "asset_id": 4387,
      "resettable": 1,
      "name": "Scavenger",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1427,
      "activated": 1,
      "icon_name": "devour",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -5,
      "short_description": "This champion can only attack champions and cannot attack champions that are at full health.",
      "long_description": "This champion can only attack champions and cannot attack champions that are at full health.",
      "class_name": "Scavenger",
      "revision": 1
    },
    {
      "asset_id": 8005,
      "resettable": 0,
      "name": "Scavenger Idolatry",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3402,
      "activated": 1,
      "icon_name": "dogpile",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "This champion has <ability value=2502>Dogpile</ability>. If you have 4 or more champions with Race: Hyaenid or Race: Djinn in play, this champion gains <ability value=2652>Opportunistic</ability>.",
      "long_description": "This champion has <ability value=2502>Dogpile</ability>. If you have 4 or more champions with Race: Hyaenid or Race: Djinn in play, this champion gains <ability value=2652>Opportunistic</ability>.",
      "class_name": "ScavengerIdolatry",
      "revision": 1
    },
    {
      "asset_id": 8004,
      "resettable": 0,
      "name": "Scavenger Instinct",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3401,
      "activated": 1,
      "icon_name": "dogpile",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "This champion has <ability value=2502>Dogpile</ability>. If you have 4 or more champions with Race: Hyaenid or Race: Djinn in play, this champion gains <ability value=966>Cackle</ability>. If you have 6 champions with Race: Hyaenid or Race: Djinn in play, the range of Cackle is increased by 1 space.",
      "long_description": "This champion has <ability value=2502>Dogpile</ability>. If you have 4 or more champions with Race: Hyaenid or Race: Djinn in play, this champion gains <ability value=966>Cackle</ability>. If you have 6 champions with Race: Hyaenid or Race: Djinn in play, the range of Cackle is increased by 1 space.",
      "class_name": "ScavengerInstinct",
      "revision": 1
    },
    {
      "asset_id": 7780,
      "resettable": 0,
      "name": "Scavenger Pack",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3301,
      "activated": 1,
      "icon_name": "pack_mentality",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 40,
      "short_description": "When this champion is deployed from the runedock, 2 Scavenger Pack champions with no upgrades are summoned adjacent to it.",
      "long_description": "When this champion is deployed from the runedock, 2 Scavenger Pack champions with no upgrades are summoned adjacent to it.",
      "class_name": "ScavengerPack",
      "revision": 1
    },
    {
      "asset_id": 4468,
      "resettable": 1,
      "name": "Scimitar of the Deep",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 833,
      "activated": 1,
      "icon_name": "tsunami",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "This champion makes a Physical attack at RNG 1. When this champion occupies Water, it gets +10 DMG on this attack.",
      "long_description": "This champion makes a Physical attack at RNG 1. When this champion occupies Water, it gets +10 DMG on this attack.",
      "class_name": "ScimitarOfTheDeepAttack",
      "revision": 1
    },
    {
      "asset_id": 7971,
      "resettable": 0,
      "name": "Scolding Blows",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3358,
      "activated": 1,
      "icon_name": "attack_fire",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "When this champion successfully attacks a champion with a basic attack, the target becomes <condition value=scolded>Scolded</condition> for 2 turns.",
      "long_description": "When this champion successfully attacks a champion with a basic attack, the target becomes <condition value=scolded>Scolded</condition> for 2 turns.",
      "class_name": "ScoldingBlows",
      "revision": 1
    },
    {
      "asset_id": 4065,
      "resettable": 1,
      "name": "Scorn",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 105,
      "activated": 1,
      "icon_name": "shrinebad",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": -3,
      "short_description": "When this unit is deployed, its owner's Shrine or Avatar loses 8 HP.",
      "long_description": "When this unit is deployed, its owner's Shrine or Avatar loses 8 HP.",
      "class_name": "Scorn",
      "revision": 1
    },
    {
      "asset_id": 5233,
      "resettable": 1,
      "name": "Scornful",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2011,
      "activated": 1,
      "icon_name": "shrinebad",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -6,
      "short_description": "When this unit is deployed, its owner's Shrine or Avatar loses 3 HP. At the beginning of your turns, your Shrine or Avatar loses 3 HP while this champion is in play.",
      "long_description": "When this unit is deployed, its owner's Shrine or Avatar loses 3 HP. At the beginning of your turns, your Shrine or Avatar loses 3 HP while this champion is in play.",
      "class_name": "Scornful",
      "revision": 1
    },
    {
      "asset_id": 5392,
      "resettable": 1,
      "name": "Scornful Gaze",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2224,
      "activated": 1,
      "icon_name": "scry",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "Champions deployed from the runedock after this relic is in play have <ability value=2011>Scornful</ability>. This relic loses 25% of its MAX HP (rounded up) whenever a champion is deployed.",
      "long_description": "Champions deployed from the runedock after this relic is in play have <ability value=2011>Scornful</ability>. This relic loses 25% of its MAX HP (rounded up) whenever a champion is deployed.",
      "class_name": "ScornfulGaze",
      "revision": 1
    },
    {
      "asset_id": 5627,
      "resettable": 1,
      "name": "Scour",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 2491,
      "activated": 1,
      "icon_name": "scour",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 1,
      "cost": 3,
      "short_description": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=scoured>Scoured</condition> for 3 turns",
      "long_description": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=scoured>Scoured</condition> for 3 turns",
      "class_name": "Scour",
      "revision": 1
    },
    {
      "asset_id": 5627,
      "resettable": 1,
      "name": "Scour",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 2492,
      "activated": 1,
      "icon_name": "scour",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 6,
      "short_description": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=scoured>Scoured</condition> for 4 turns",
      "long_description": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=scoured>Scoured</condition> for 4 turns",
      "class_name": "Scour",
      "revision": 1
    },
    {
      "asset_id": 5627,
      "resettable": 1,
      "name": "Scour",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 2493,
      "activated": 1,
      "icon_name": "scour",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 9,
      "short_description": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=scoured>Scoured</condition> for 5 turns",
      "long_description": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=scoured>Scoured</condition> for 5 turns",
      "class_name": "Scour",
      "revision": 1
    },
    {
      "asset_id": 5521,
      "resettable": 1,
      "name": "Scouring Luminescence",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2380,
      "activated": 1,
      "icon_name": "scouring_luminesence",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 8,
      "short_description": "When this unit is deployed and at the start of its turns, opposing champions within 4 spaces take 4 Acid damage and become Scoured 2.",
      "long_description": "When this unit is deployed and at the start of its turns, opposing champions within 4 spaces take 4 Acid damage and become Scoured 2.",
      "class_name": "ScouringLuminescence",
      "revision": 1
    },
    {
      "asset_id": 5739,
      "resettable": 1,
      "name": "Scrapper",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2626,
      "activated": 1,
      "icon_name": "scrapper",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 9,
      "short_description": "When this champion makes a successful basic attack, it gains <ability value=2077>Reflexes 2</ability> and <ability value=1377>Evasive 2</ability> for 2 turns.",
      "long_description": "When this champion makes a successful basic attack, it gains <ability value=2077>Reflexes 2</ability> and <ability value=1377>Evasive 2</ability> for 2 turns.",
      "class_name": "Scrapper",
      "revision": 1
    },
    {
      "asset_id": 4814,
      "resettable": 1,
      "name": "Screech",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 2688,
      "activated": 1,
      "icon_name": "sonicaoe",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "Opposing champions within 2 spaces take 12 Sonic damage, opposing champions within 4 spaces take 10 Sonic damage, and opposing champions within 6 spaces take 8 Sonic damage. This damage ignores DEF.",
      "long_description": "Opposing champions within 2 spaces take 12 Sonic damage, opposing champions within 4 spaces take 10 Sonic damage, and opposing champions within 6 spaces take 8 Sonic damage. This damage ignores DEF.",
      "class_name": "Screech",
      "revision": 1
    },
    {
      "asset_id": 5418,
      "resettable": 1,
      "name": "Scythe Whirl",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2250,
      "activated": 1,
      "icon_name": "scythe_wirlwind",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 3,
      "ranked": 0,
      "cost": 8,
      "short_description": "This unit gains <ability value=1378>Evasive 3</ability> for 2 turns and all opposing units within 3 spaces takes Physical damage equal to this unit's DMG.  Units successfully damaged become <condition value=eviscerated>Eviscerated</condition> for 3 turns.",
      "long_description": "This unit gains <ability value=1378>Evasive 3</ability> for 2 turns and all opposing units within 3 spaces takes Physical damage equal to this unit's DMG.  Units successfully damaged become <condition value=eviscerated>Eviscerated</condition> for 3 turns.",
      "class_name": "ScytheWhirl",
      "revision": 1
    },
    {
      "asset_id": 5658,
      "resettable": 1,
      "name": "Seal of the Vashal",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 2530,
      "activated": 1,
      "icon_name": "seal_of_the_vashal",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "Target friendly Vashal or Beast within 5 spaces is <condition value=norashielded>Nora Shielded</condition> and heals for 3 for each unit with Seal of the Vashal (to a maximum of 12). Target champion gains Unsealed (This unit can not be the target of Seal of the Vashal) for 6 turns. This ability is removed after use.",
      "long_description": "Target friendly Vashal or Beast within 5 spaces is <condition value=norashielded>Nora Shielded</condition> and heals for 3 for each unit with Seal of the Vashal (to a maximum of 12). Target champion gains Unsealed (This unit can not be the target of Seal of the Vashal) for 6 turns. This ability is removed after use.",
      "class_name": "SealoftheVashal",
      "revision": 1
    },
    {
      "asset_id": 5658,
      "resettable": 0,
      "name": "Seal of the Vashal (Relic)",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3166,
      "activated": 1,
      "icon_name": "seal_of_the_vashal",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "Target friendly Vashal or Beast within 3 spaces is Nora Shielded (Whenever this champion takes damage, its owner recovers 1 point of nora per point of damage taken) for 2 turns and heals for 3 for each unit with Seal of the Vashal (to a maximum of 12).  This ability is removed after use.",
      "long_description": "Target friendly Vashal or Beast within 3 spaces is Nora Shielded (Whenever this champion takes damage, its owner recovers 1 point of nora per point of damage taken) for 2 turns and heals for 3 for each unit with Seal of the Vashal (to a maximum of 12).  This ability is removed after use.",
      "class_name": "SealoftheVashal",
      "revision": 1
    },
    {
      "asset_id": 5775,
      "resettable": 1,
      "name": "Sealing Aura",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2694,
      "activated": 1,
      "icon_name": "special",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "Opposing units may not be deployed within 6 spaces of this unit.",
      "long_description": "Opposing units may not be deployed within 6 spaces of this unit.",
      "class_name": "SealingAura",
      "revision": 1
    },
    {
      "asset_id": 4803,
      "resettable": 1,
      "name": "Searing Aura",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 1556,
      "activated": 1,
      "icon_name": "novafire",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 3,
      "short_description": "When an opposing champion moves within 1 space of this champion or when this champion moves within 1 space of an opposing champion, the opposing champion suffers 1 Fire damage. At the end of your turn all opposing champions within 1 space suffer 1 Fire damage. Damage given by this ability ignores DEF.",
      "long_description": "When an opposing champion moves within 1 space of this champion or when this champion moves within 1 space of an opposing champion, the opposing champion suffers 1 Fire damage. At the end of your turn all opposing champions within 1 space suffer 1 Fire damage. Damage given by this ability ignores DEF.",
      "class_name": "SearingAura",
      "revision": 1
    },
    {
      "asset_id": 4803,
      "resettable": 1,
      "name": "Searing Aura",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 1610,
      "activated": 1,
      "icon_name": "novafire",
      "comments": "none",
      "prerequisite_id": 1556,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 4,
      "short_description": "When an opposing champion moves within 1 space of this champion or when this champion moves within 1 space of an opposing champion, the opposing champion suffers 2 Fire damage. At the end of your turn all opposing champions within 1 space suffer 2 Fire damage. Damage given by this ability ignores DEF.",
      "long_description": "When an opposing champion moves within 1 space of this champion or when this champion moves within 1 space of an opposing champion, the opposing champion suffers 2 Fire damage. At the end of your turn all opposing champions within 1 space suffer 2 Fire damage. Damage given by this ability ignores DEF.",
      "class_name": "SearingAura",
      "revision": 1
    },
    {
      "asset_id": 4803,
      "resettable": 1,
      "name": "Searing Aura ",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 1611,
      "activated": 1,
      "icon_name": "novafire",
      "comments": "none",
      "prerequisite_id": 1610,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 5,
      "short_description": "When an opposing champion moves within 1 space of this champion or when this champion moves within 1 space of an opposing champion, the opposing champion suffers 2 Fire damage. At the end of your turn all opposing champions within 1 space suffer 3 Fire damage. Damage given by this ability ignores DEF.",
      "long_description": "When an opposing champion moves within 1 space of this champion or when this champion moves within 1 space of an opposing champion, the opposing champion suffers 2 Fire damage. At the end of your turn all opposing champions within 1 space suffer 3 Fire damage. Damage given by this ability ignores DEF.",
      "class_name": "SearingAura",
      "revision": 1
    },
    {
      "asset_id": 4803,
      "resettable": 1,
      "name": "Searing Aura",
      "ap_cost": 0,
      "level": 4,
      "ability_id": 1612,
      "activated": 1,
      "icon_name": "novafire",
      "comments": "none",
      "prerequisite_id": 1611,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 6,
      "short_description": "When an opposing champion moves within 2 spaces of this champion or when this champion moves within 2 spaces of an opposing champion, the opposing champion suffers 2 Fire damage. At the end of your turn all opposing champions within 2 spaces suffer 3 Fire damage. Damage given by this ability ignores DEF.",
      "long_description": "When an opposing champion moves within 2 spaces of this champion or when this champion moves within 2 spaces of an opposing champion, the opposing champion suffers 2 Fire damage. At the end of your turn all opposing champions within 2 spaces suffer 3 Fire damage. Damage given by this ability ignores DEF.",
      "class_name": "SearingAura",
      "revision": 1
    },
    {
      "asset_id": 4803,
      "resettable": 1,
      "name": "Searing Aura",
      "ap_cost": 0,
      "level": 5,
      "ability_id": 1613,
      "activated": 1,
      "icon_name": "novafire",
      "comments": "none",
      "prerequisite_id": 1612,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 7,
      "short_description": "When an opposing champion moves within 2 spaces of this champion or when this champion moves within 2 spaces of an opposing champion, the opposing champion suffers 3 Fire damage. At the end of your turn all opposing champions within 2 spaces suffer 4 Fire damage. Damage given by this ability ignores DEF.",
      "long_description": "When an opposing champion moves within 2 spaces of this champion or when this champion moves within 2 spaces of an opposing champion, the opposing champion suffers 3 Fire damage. At the end of your turn all opposing champions within 2 spaces suffer 4 Fire damage. Damage given by this ability ignores DEF.",
      "class_name": "SearingAura",
      "revision": 1
    },
    {
      "asset_id": 4803,
      "resettable": 1,
      "name": "Searing Aura",
      "ap_cost": 0,
      "level": 6,
      "ability_id": 1614,
      "activated": 1,
      "icon_name": "novafire",
      "comments": "none",
      "prerequisite_id": 1613,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 8,
      "short_description": "When an opposing champion moves within 2 spaces of this champion or when this champion moves within 2 spaces of an opposing champion, the opposing champion suffers 4 Fire damage. At the end of your turn all opposing champions within 2 spaces suffer 5 Fire damage. Damage given by this ability ignores DEF.",
      "long_description": "When an opposing champion moves within 2 spaces of this champion or when this champion moves within 2 spaces of an opposing champion, the opposing champion suffers 4 Fire damage. At the end of your turn all opposing champions within 2 spaces suffer 5 Fire damage. Damage given by this ability ignores DEF.",
      "class_name": "SearingAura",
      "revision": 1
    },
    {
      "asset_id": 5552,
      "resettable": 1,
      "name": "Searing Heat",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2412,
      "activated": 1,
      "icon_name": "fiery_death",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "At the beginning of your turn all other champions take 4 fire damage.",
      "long_description": "At the beginning of your turn all other champions take 4 fire damage.",
      "class_name": "SearingHeat",
      "revision": 1
    },
    {
      "asset_id": 7682,
      "resettable": 0,
      "name": "Secluded Shrine",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3253,
      "activated": 1,
      "icon_name": "secluded_shrine",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "When a real champion within 5 spaces is destroyed, friendly Paladins, Priests and Shamans within 5 spaces are Cleansed and heals for 6 HP.",
      "long_description": "When a real champion within 5 spaces is destroyed, friendly Paladins, Priests and Shamans within 5 spaces are Cleansed and heals for 6 HP.",
      "class_name": "SecludedShrine",
      "revision": 1
    },
    {
      "asset_id": 5326,
      "resettable": 1,
      "name": "Secure Fonts",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2155,
      "activated": 1,
      "icon_name": "bound_nora",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 5,
      "short_description": "For 3 turns, fonts you currently control cannot be contested. This ability comes into play on cooldown.",
      "long_description": "For 3 turns, fonts you currently control cannot be contested. This ability comes into play on cooldown.",
      "class_name": "SecureFonts",
      "revision": 1
    },
    {
      "asset_id": 7448,
      "resettable": 0,
      "name": "Seism",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3147,
      "activated": 1,
      "icon_name": "seism",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 14,
      "short_description": "When this champion is deployed, the closest enemy relic takes 20 Physical damage.",
      "long_description": "When this champion is deployed, the closest enemy relic takes 20 Physical damage.",
      "class_name": "Seism",
      "revision": 1
    },
    {
      "asset_id": 4678,
      "resettable": 1,
      "name": "Seismic Leap",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 1467,
      "activated": 1,
      "icon_name": "leap_massive",
      "comments": "",
      "prerequisite_id": 1466,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 6,
      "short_description": "This champion is relocated to target space within 4 spaces. Non-flying enemy champions within 2 spaces of the target takes 8 Physical damage (this damage ignores DEF), are knocked back 1 space and become <condition value=slowed>Slowed</condition> for 2 turns.",
      "long_description": "This champion is relocated to target space within 4 spaces. Non-flying enemy champions within 2 spaces of the target takes 8 Physical damage (this damage ignores DEF), are knocked back 1 space and become <condition value=slowed>Slowed</condition> for 2 turns.",
      "class_name": "SeismicLeap",
      "revision": 1
    },
    {
      "asset_id": 4212,
      "resettable": 1,
      "name": "Self Destruct",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 562,
      "activated": 1,
      "icon_name": "sacrifice",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "This unit destroys itself. This ability can only be activated by the unit's owner.",
      "long_description": "This unit destroys itself. This ability can only be activated by the unit's owner.",
      "class_name": "SelfDestruct",
      "revision": 1
    },
    {
      "asset_id": 4474,
      "resettable": 1,
      "name": "Semi Aquatic",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 859,
      "activated": 1,
      "icon_name": "semiaquatic",
      "comments": "",
      "prerequisite_id": 114,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 2,
      "short_description": "This unit is <ability value=2>Amphibious</ability>.  This unit has +1 SPD when within 3 spaces of water. At the beginning of your turns, if it is not within 3 spaces of water it has -1 SPD and loses 3 HP.",
      "long_description": "This unit is <ability value=2>Amphibious</ability>.  This unit has +1 SPD when within 3 spaces of water. At the beginning of your turns, if it is not within 3 spaces of water it has -1 SPD and loses 3 HP.",
      "class_name": "SemiAquatic",
      "revision": 1
    },
    {
      "asset_id": 5342,
      "resettable": 1,
      "name": "Sentinel",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2271,
      "activated": 1,
      "icon_name": "multiattack",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "Whenever an enemy champion within this unit's range successfully attacks another friendly unit, this unit makes a free basic attack against the attacking champion.  ",
      "long_description": "Whenever an enemy champion within this unit's range successfully attacks another friendly unit, this unit makes a free basic attack against the attacking champion.  ",
      "class_name": "Sentinel",
      "revision": 1
    },
    {
      "asset_id": 4705,
      "resettable": 1,
      "name": "Sentry",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 818,
      "activated": 1,
      "icon_name": "sentry",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 1,
      "short_description": "This unit's spell presence is increased by 1.",
      "long_description": "This unit's spell presence is increased by 1.",
      "class_name": "Sentry",
      "revision": 1
    },
    {
      "asset_id": 4705,
      "resettable": 1,
      "name": "Sentry",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 819,
      "activated": 1,
      "icon_name": "sentry",
      "comments": "",
      "prerequisite_id": 818,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 2,
      "short_description": "This unit's spell presence is increased by 2.",
      "long_description": "This unit's spell presence is increased by 2.",
      "class_name": "Sentry",
      "revision": 1
    },
    {
      "asset_id": 4705,
      "resettable": 1,
      "name": "Sentry",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 1189,
      "activated": 1,
      "icon_name": "sentry",
      "comments": "",
      "prerequisite_id": 819,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 3,
      "short_description": "This unit's spell presence is increased by 3.",
      "long_description": "This unit's spell presence is increased by 3.",
      "class_name": "Sentry",
      "revision": 1
    },
    {
      "asset_id": 8009,
      "resettable": 0,
      "name": "Serf to Djinn: Dao",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3406,
      "activated": 1,
      "icon_name": "revere",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "While a friendly Peaks Dao is in play, this champion gains <ability value=343>Power Attack 2</ability> and <ability value=3266>Combat Awareness 1</ability>.",
      "long_description": "While a friendly Peaks Dao is in play, this champion gains <ability value=343>Power Attack 2</ability> and <ability value=3266>Combat Awareness 1</ability>.",
      "class_name": "SerfToDjinnDao",
      "revision": 1
    },
    {
      "asset_id": 8010,
      "resettable": 0,
      "name": "Serf to Djinn: Dew",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3407,
      "activated": 1,
      "icon_name": "revere",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "While a friendly Peaks Dew is in play, this champion gains <ability value=1075>Heal Self 2</ability> and <ability value=1952>Slam</ability>.",
      "long_description": "While a friendly Peaks Dew is in play, this champion gains <ability value=1075>Heal Self 2</ability> and <ability value=1952>Slam</ability>.",
      "class_name": "SerfToDjinnDew",
      "revision": 1
    },
    {
      "asset_id": 8011,
      "resettable": 0,
      "name": "Serf to Djinn: Ifrit",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3408,
      "activated": 1,
      "icon_name": "revere",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "While a friendly Peaks Ifrit is in play, this champion gains <ability value=732>Fury</ability> and <ability value=380>Flame Nova 3</ability>.",
      "long_description": "While a friendly Peaks Ifrit is in play, this champion gains <ability value=732>Fury</ability> and <ability value=380>Flame Nova 3</ability>.",
      "class_name": "SerfToDjinnIfrit",
      "revision": 1
    },
    {
      "asset_id": 8012,
      "resettable": 0,
      "name": "Serf to Djinn: Marid",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3409,
      "activated": 1,
      "icon_name": "revere",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "While a friendly Peaks Marid is in play, it gains <ability value=1909>Storm Acolyte</ability> and <ability value=2539>Lightning Blast</ability>.",
      "long_description": "While a friendly Peaks Marid is in play, it gains <ability value=1909>Storm Acolyte</ability> and <ability value=2539>Lightning Blast</ability>.",
      "class_name": "SerfToDjinnMarid",
      "revision": 1
    },
    {
      "asset_id": 5705,
      "resettable": 1,
      "name": "Serf to the Djinn",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2585,
      "activated": 1,
      "icon_name": "revere",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this champion is within 4 spaces of a friendly Djinn, it gains <ability value=24>Berserker 2</ability> and +1 MAX RNG.",
      "long_description": "When this champion is within 4 spaces of a friendly Djinn, it gains <ability value=24>Berserker 2</ability> and +1 MAX RNG.",
      "class_name": "SerfToTheDjinn",
      "revision": 1
    },
    {
      "asset_id": 4749,
      "resettable": 1,
      "name": "Serkan's Arrival",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1507,
      "activated": 1,
      "icon_name": "",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -3,
      "short_description": "Any Lich King's in play when this unit is deployed lose half their HP. Lich Kings deployed while this unit is in play lose half of their HP.",
      "long_description": "Any Lich King's in play when this unit is deployed lose half their HP. Lich Kings deployed while this unit is in play lose half of their HP.",
      "class_name": "SerkansArrival",
      "revision": 1
    },
    {
      "asset_id": 4774,
      "resettable": 1,
      "name": "Serkan's Nemesis",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1508,
      "activated": 1,
      "icon_name": "",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -5,
      "short_description": "Opposing Paladins, and Priests gain Hunter: Serkan.",
      "long_description": "Opposing Paladins, and Priests gain Hunter: Serkan.",
      "class_name": "SerkansNemesis",
      "revision": 1
    },
    {
      "asset_id": 5217,
      "resettable": 1,
      "name": "Sermon",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 1994,
      "activated": 1,
      "icon_name": "soothserenade",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "Friendly champions that share a race with this one get +1 DEF, +2 DMG and +5 HP until this champion next moves. This ability does not stack.",
      "long_description": "Friendly champions that share a race with this one get +1 DEF, +2 DMG and +5 HP until this champion next moves. This ability does not stack.",
      "class_name": "Sermon",
      "revision": 1
    },
    {
      "asset_id": 4597,
      "resettable": 1,
      "name": "Serpent Master",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 999,
      "activated": 1,
      "icon_name": "boost",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "Serpents within 4 spaces of this unit get +1 DEF, +2 DMG, and +5 HP. This ability does not stack.",
      "long_description": "Serpents within 4 spaces of this unit get +1 DEF, +2 DMG, and +5 HP. This ability does not stack.",
      "class_name": "SerpentMaster",
      "revision": 1
    },
    {
      "asset_id": 4682,
      "resettable": 1,
      "name": "Set Ablaze",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 1120,
      "activated": 1,
      "icon_name": "fire",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "Target champion within 2 spaces takes 4 Fire damage and is Consumed By Fire (This champion is <condition value=shielded>Shielded</condition>, <mechanic value=immobile>Immobile</mechanic> and <mechanic value=pacified>Pacified</mechanic>. At the beginning of your turn, this champion takes 8 Fire Damage) for 2 turns.  Friendly units take an additional 4 Fire damage.  May target self.",
      "long_description": "Target champion within 2 spaces takes 4 Fire damage and is Consumed By Fire (This champion is <condition value=shielded>Shielded</condition>, <mechanic value=immobile>Immobile</mechanic> and <mechanic value=pacified>Pacified</mechanic>. At the beginning of your turn, this champion takes 8 Fire Damage) for 2 turns.  Friendly units take an additional 4 Fire damage.  May target self.",
      "class_name": "SetAblaze",
      "revision": 1
    },
    {
      "asset_id": 5007,
      "resettable": 1,
      "name": "Sever Summoning DO NOT USE",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1888,
      "activated": 1,
      "icon_name": "drain",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 6,
      "short_description": "When this champion enters play, all summoned champions are destroyed.",
      "long_description": "When this champion enters play, all summoned champions are destroyed.",
      "class_name": "ServerSummoning",
      "revision": 1
    },
    {
      "asset_id": 5780,
      "resettable": 1,
      "name": "Shadestrike",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2701,
      "activated": 1,
      "icon_name": "terrain_dmz",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this champion makes a successful basic attack, spaces within 2 spaces of the target becomes a Dead Magic Zone for 3 turns.",
      "long_description": "When this champion makes a successful basic attack, spaces within 2 spaces of the target becomes a Dead Magic Zone for 3 turns.",
      "class_name": "Shadestrike",
      "revision": 1
    },
    {
      "asset_id": 4908,
      "resettable": 1,
      "name": "Shadow Shift",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 1790,
      "activated": 1,
      "icon_name": "shadow_shift",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "This unit is relocated to target space within 5 spaces, and loses <condition value=rooted>Rooted</condition>.  This ability does not break stealth and is only usable while <condition value=stealthed>Stealthed</condition>.",
      "long_description": "This unit is relocated to target space within 5 spaces, and loses <condition value=rooted>Rooted</condition>.  This ability does not break stealth and is only usable while <condition value=stealthed>Stealthed</condition>.",
      "class_name": "ShadowShift",
      "revision": 1
    },
    {
      "asset_id": 5675,
      "resettable": 1,
      "name": "Shadow Shift (Relic)",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2548,
      "activated": 1,
      "icon_name": "shadow_shift",
      "comments": "Relic",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "This unit is relocated to target space within 5 spaces, and loses <condition value=rooted>Rooted</condition>.  This ability does not break stealth and is only usable while <condition value=stealthed>Stealthed</condition>.",
      "long_description": "This unit is relocated to target space within 5 spaces, and loses <condition value=rooted>Rooted</condition>.  This ability does not break stealth and is only usable while <condition value=stealthed>Stealthed</condition>.",
      "class_name": "RelicShadowShift",
      "revision": 1
    },
    {
      "asset_id": 7158,
      "resettable": 0,
      "name": "Shadowdancer",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3001,
      "activated": 1,
      "icon_name": "shadowdancer",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 10,
      "short_description": "When this champion makes a successful basic attack, a Lesser Shadowrake is summoned to a space adjacent to the target.  This effect can only occur once per turn and only if no copy created by this champion is in play. ",
      "long_description": "When this champion makes a successful basic attack, a Lesser Shadowrake is summoned to a space adjacent to the target.  This effect can only occur once per turn and only if no copy created by this champion is in play. ",
      "class_name": "Shadowdancer",
      "revision": 1
    },
    {
      "asset_id": 4230,
      "resettable": 1,
      "name": "Shadowspawn",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 601,
      "activated": 1,
      "icon_name": "shadowspawn",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "This unit comes into play <condition value=stealthed>Stealthed</condition>.",
      "long_description": "This unit comes into play <condition value=stealthed>Stealthed</condition>.",
      "class_name": "Shadowspawn",
      "revision": 1
    },
    {
      "asset_id": 5498,
      "resettable": 1,
      "name": "Shadowstrike",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2357,
      "activated": 1,
      "icon_name": "stealth",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 12,
      "short_description": "This champion becomes stealthed after making a basic attack.",
      "long_description": "This champion becomes stealthed after making a basic attack.",
      "class_name": "Shadowstrike",
      "revision": 1
    },
    {
      "asset_id": 4400,
      "resettable": 1,
      "name": "Shatter",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 721,
      "activated": 1,
      "icon_name": "antiequip",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "Destroy equipment on target champion within 3 spaces. If the equipment was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Ruin).",
      "long_description": "Destroy equipment on target champion within 3 spaces. If the equipment was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Ruin).",
      "class_name": "Shatter",
      "revision": 1
    },
    {
      "asset_id": 7959,
      "resettable": 0,
      "name": "Shatter (Relic)",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3345,
      "activated": 1,
      "icon_name": "antiequip",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "Destroy equipment on target champion within 3 spaces.",
      "long_description": "Destroy equipment on target champion within 3 spaces.",
      "class_name": "Shatter",
      "revision": 1
    },
    {
      "asset_id": 7253,
      "resettable": 0,
      "name": "Shatter Summoned",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 3062,
      "activated": 1,
      "icon_name": "shattered_dreams",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 2,
      "short_description": "Area Effect 3, Range 5: Enemy illusions and summoned units take 15 Psychic damage.",
      "long_description": "Area Effect 3, Range 5: Enemy illusions and summoned units take 15 Psychic damage.",
      "class_name": "ShatterSummoned",
      "revision": 1
    },
    {
      "asset_id": 4548,
      "resettable": 1,
      "name": "Sheoul Firebow",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 808,
      "activated": 1,
      "icon_name": "fire",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "This champion makes a Fire attack at RNG 3-5 at +2 DMG.",
      "long_description": "This champion makes a Fire attack at RNG 3-5 at +2 DMG.",
      "class_name": "SheoulFirebowAttack",
      "revision": 1
    },
    {
      "asset_id": 5195,
      "resettable": 1,
      "name": "Sheoul's Bond",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1972,
      "activated": 1,
      "icon_name": "blockade",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "While a friendly Sheoul Demon is in play, this champion gains <ability value=936>Surge: Demon</ability>. If there are no friendly demons, this champion has -1 SPD.",
      "long_description": "While a friendly Sheoul Demon is in play, this champion gains <ability value=936>Surge: Demon</ability>. If there are no friendly demons, this champion has -1 SPD.",
      "class_name": "Reverence",
      "revision": 1
    },
    {
      "asset_id": 4757,
      "resettable": 1,
      "name": "Shield Allies",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 1481,
      "activated": 1,
      "icon_name": "aurapositive",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 5,
      "short_description": "For 2 turns, friendly normal-sized champions and relics that are within 2 spaces of this unit gain <ability value=1378>Evasive 3</ability>.",
      "long_description": "For 2 turns, friendly normal-sized champions and relics that are within 2 spaces of this unit gain <ability value=1378>Evasive 3</ability>.",
      "class_name": "ShieldAllies",
      "revision": 1
    },
    {
      "asset_id": 4410,
      "resettable": 1,
      "name": "Shielded",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 738,
      "activated": 1,
      "icon_name": "spell_resistance",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "This champion may not be the target of opposing spells",
      "long_description": "This champion may not be the target of opposing spells",
      "class_name": "Shielded",
      "revision": 1
    },
    {
      "asset_id": 5596,
      "resettable": 1,
      "name": "Shimmering Wings",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2627,
      "activated": 1,
      "icon_name": "shimmering_wings",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "For 2 turns, this champion loses Tough, gains <ability value=2582>Impairing Feedback</ability>, <ability value=6>Mobility</ability>, <ability value=427>Poison Cloud 2</ability> and its RNG becomes 3-5.",
      "long_description": "For 2 turns, this champion loses Tough, gains <ability value=2582>Impairing Feedback</ability>, <ability value=6>Mobility</ability>, <ability value=427>Poison Cloud 2</ability> and its RNG becomes 3-5.",
      "class_name": "ShimmeringWings",
      "revision": 1
    },
    {
      "asset_id": 5477,
      "resettable": 1,
      "name": "Shockwave",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 2336,
      "activated": 1,
      "icon_name": "physicalaoe",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 12,
      "short_description": "All opposing champions within 3 spaces of this unit take 10 physical damage.  All opposing champions hit by this ability then release a shockwave dealing 5 physical damage to all opposing champions within 5 spaces. This damage ignores defense.",
      "long_description": "All opposing champions within 3 spaces of this unit take 10 physical damage.  All opposing champions hit by this ability then release a shockwave dealing 5 physical damage to all opposing champions within 5 spaces. This damage ignores defense.",
      "class_name": "Shockwave",
      "revision": 1
    },
    {
      "asset_id": 4481,
      "resettable": 1,
      "name": "Short Lived",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 875,
      "activated": 1,
      "icon_name": "ondeath",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": -20,
      "short_description": "This unit is destroyed after 6 turns.",
      "long_description": "This unit is destroyed after 6 turns.",
      "class_name": "ShortLived",
      "revision": 1
    },
    {
      "asset_id": 4481,
      "resettable": 1,
      "name": "Short Lived",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 876,
      "activated": 1,
      "icon_name": "ondeath",
      "comments": "",
      "prerequisite_id": 875,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": -15,
      "short_description": "This unit is destroyed after 8 turns.",
      "long_description": "This unit is destroyed after 8 turns.",
      "class_name": "ShortLived",
      "revision": 1
    },
    {
      "asset_id": 4993,
      "resettable": 1,
      "name": "Shred Defense",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 1874,
      "activated": 1,
      "icon_name": "defpenalties",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "Target champion within 2 spaces has its DEF set to 0 for 2 turns and takes Physical damage equal to the amount of DEF lost. It also gains <ability value=5>Lumbering</ability> for 2 turns.",
      "long_description": "Target champion within 2 spaces has its DEF set to 0 for 2 turns and takes Physical damage equal to the amount of DEF lost. It also gains <ability value=5>Lumbering</ability> for 2 turns.",
      "class_name": "Shred",
      "revision": 1
    },
    {
      "asset_id": 4584,
      "resettable": 1,
      "name": "Shrine Defender",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 969,
      "activated": 1,
      "icon_name": "tgtdefensive",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "While this unit is within your 8 spaces of its shrine, this unit gets +2 DMG and +2 SPD and your Shrine has +8 HP. When your Shrine is Transfigured, this unit has <ability value=1759>Impassioned</ability>.",
      "long_description": "While this unit is within your 8 spaces of its shrine, this unit gets +2 DMG and +2 SPD and your Shrine has +8 HP. When your Shrine is Transfigured, this unit has <ability value=1759>Impassioned</ability>.",
      "class_name": "ShrineDefender",
      "revision": 1
    },
    {
      "asset_id": 4674,
      "resettable": 1,
      "name": "Shrine Exertion",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 1111,
      "activated": 1,
      "icon_name": "shrinebad",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 5,
      "short_description": "Your Shrine or Avatar loses 10 HP, and this champion recovers 3 AP.",
      "long_description": "Your Shrine or Avatar loses 10 HP, and this champion recovers 3 AP.",
      "class_name": "ShrineExertion",
      "revision": 1
    },
    {
      "asset_id": 4381,
      "resettable": 1,
      "name": "Shrine Linked",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1350,
      "activated": 1,
      "icon_name": "shrine_linked",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 1,
      "short_description": "When this unit is damaged, your Shrine is healed 4 HP. ",
      "long_description": "When this unit is damaged, your Shrine is healed 4 HP. ",
      "class_name": "ShrineLinked",
      "revision": 1
    },
    {
      "asset_id": 5220,
      "resettable": 1,
      "name": "Shrine Mulligan",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1997,
      "activated": 1,
      "icon_name": "scry",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "You obtain a new set of starting runes. This ability is removed after it is used, after you play a rune, or after the first round.",
      "long_description": "You obtain a new set of starting runes. This ability is removed after it is used, after you play a rune, or after the first round.",
      "class_name": "ShrineScry",
      "revision": 1
    },
    {
      "asset_id": 4302,
      "resettable": 1,
      "name": "Shrine Resistance",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 710,
      "activated": 1,
      "icon_name": "defenseenhance",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "Shrines take 50% less damage (rounded down) from spells and 30% less damage (rounded down) from abilities and attacks and are Immune to knockback damage.",
      "long_description": "Shrines take 50% less damage (rounded down) from spells and 30% less damage (rounded down) from abilities and attacks and are Immune to knockback damage.",
      "class_name": "ShrineSpellResist",
      "revision": 1
    },
    {
      "asset_id": 5220,
      "resettable": 0,
      "name": "Shrine Scry",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3394,
      "activated": 1,
      "icon_name": "scry",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Your shrine loses 7 HP and one of your runes is revealed.",
      "long_description": "Your shrine loses 7 HP and one of your runes is revealed.",
      "class_name": "ShrineScry2",
      "revision": 1
    },
    {
      "asset_id": 5639,
      "resettable": 1,
      "name": "Shrink",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2504,
      "activated": 1,
      "icon_name": "shrink",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "Target champion within 5 squares becomes <condition value=shrunken>Shrunken</condition> for 3 turns.",
      "long_description": "Target champion within 5 squares becomes <condition value=shrunken>Shrunken</condition> for 3 turns.",
      "class_name": "Shrink",
      "revision": 1
    },
    {
      "asset_id": 5632,
      "resettable": 1,
      "name": "Shrinking Gaze",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2503,
      "activated": 1,
      "icon_name": "shrink",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "Opposing champions that move within 3 spaces of this unit become <condition value=shrunken>Shrunken</condition> for 3 turns.",
      "long_description": "Opposing champions that move within 3 spaces of this unit become <condition value=shrunken>Shrunken</condition> for 3 turns.",
      "class_name": "ShrinkingGaze",
      "revision": 1
    },
    {
      "asset_id": 5751,
      "resettable": 1,
      "name": "Shrinking Scion",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 2648,
      "activated": 1,
      "icon_name": "shrink",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 12,
      "short_description": "Until this champion moves, it has +4 DMG, +1 MAX RNG, and <ability value=2503>Shrinking Gaze</ability>.",
      "long_description": "Until this champion moves, it has +4 DMG, +1 MAX RNG, and <ability value=2503>Shrinking Gaze</ability>.",
      "class_name": "ShrinkingScion",
      "revision": 1
    },
    {
      "asset_id": 5885,
      "resettable": 1,
      "name": "Shrive",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 2894,
      "activated": 1,
      "icon_name": "shrive",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "This champion makes an attack against an opposing champion at 50% damage. If the attack is successful, that champion is <mechanic value=dispelled>Dispelled</mechanic> and it loses 5 HP for each condition removed.",
      "long_description": "This champion makes an attack against an opposing champion at 50% damage. If the attack is successful, that champion is <mechanic value=dispelled>Dispelled</mechanic> and it loses 5 HP for each condition removed.",
      "class_name": "Shrive",
      "revision": 1
    },
    {
      "asset_id": 4968,
      "resettable": 1,
      "name": "Shroud",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1849,
      "activated": 1,
      "icon_name": "aurapositive",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "Other friendly champions within 3 spaces gain <ability value=1377>Evasive 2</ability>  This does not stack.",
      "long_description": "Other friendly champions within 3 spaces gain <ability value=1377>Evasive 2</ability>  This does not stack.",
      "class_name": "DarkShroud",
      "revision": 1
    },
    {
      "asset_id": 5082,
      "resettable": 1,
      "name": "Sibling",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1256,
      "activated": 1,
      "icon_name": "sibling",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "When this champion is deployed, champions with the same name are revealed in your runedock. When you have a champion in play with the same name as this one, this champion gains +1 DEF, +1 SPD and +5 HP.",
      "long_description": "When this champion is deployed, champions with the same name are revealed in your runedock. When you have a champion in play with the same name as this one, this champion gains +1 DEF, +1 SPD and +5 HP.",
      "class_name": "Sibling",
      "revision": 1
    },
    {
      "asset_id": 7199,
      "resettable": 1,
      "name": "Siege",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 565,
      "activated": 1,
      "icon_name": "shrinebad",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 1,
      "short_description": "This champion deals double damage against relics.",
      "long_description": "This champion deals double damage against relics.",
      "class_name": "Siege",
      "revision": 1
    },
    {
      "asset_id": 4703,
      "resettable": 1,
      "name": "Siege Lord",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1810,
      "activated": 1,
      "icon_name": "crush",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "No relics can be played from the runedock within 12 spaces of this champion.",
      "long_description": "No relics can be played from the runedock within 12 spaces of this champion.",
      "class_name": "SiegeLord",
      "revision": 1
    },
    {
      "asset_id": 4967,
      "resettable": 1,
      "name": "Silence",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1848,
      "activated": 1,
      "icon_name": "drain",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this champion successfully damages a champion with a basic attack, that champion becomes <condition value=distracted>Distracted</condition> for 2 turns.",
      "long_description": "When this champion successfully damages a champion with a basic attack, that champion becomes <condition value=distracted>Distracted</condition> for 2 turns.",
      "class_name": "Silence",
      "revision": 1
    },
    {
      "asset_id": 5752,
      "resettable": 1,
      "name": "Silent Contemplation",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 2651,
      "activated": 1,
      "icon_name": "merciful",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "Until this champion moves, it has +4 MAX RNG, <ability value=680>Planar Bound</ability>, and <ability value=2271>Sentinel</ability>.",
      "long_description": "Until this champion moves, it has +4 MAX RNG, <ability value=680>Planar Bound</ability>, and <ability value=2271>Sentinel</ability>.",
      "class_name": "SilentContemplation",
      "revision": 1
    },
    {
      "asset_id": 4303,
      "resettable": 1,
      "name": "Siphoning Aura",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 711,
      "activated": 1,
      "icon_name": "possess",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "At the beginning of your opponent's turn, all champions within 2 spaces lose 3 HP, and this champion is healed by an equal amount.",
      "long_description": "At the beginning of your opponent's turn, all champions within 2 spaces lose 3 HP, and this champion is healed by an equal amount.",
      "class_name": "SiphoningAura",
      "revision": 1
    },
    {
      "asset_id": 5537,
      "resettable": 1,
      "name": "Siren's Song",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2396,
      "activated": 1,
      "icon_name": "soothserenade",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 7,
      "short_description": "Whenever an enemy champion without <ability value=4 popup=false>Iron Will</ability> that is within 5 spaces of this unit moves away from this unit, the enemy is pulled one space directly toward this unit.",
      "long_description": "Whenever an enemy champion without <ability value=4 popup=false>Iron Will</ability> that is within 5 spaces of this unit moves away from this unit, the enemy is pulled one space directly toward this unit.",
      "class_name": "SirensSong",
      "revision": 1
    },
    {
      "asset_id": 7344,
      "resettable": 0,
      "name": "Sirocco",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 3110,
      "activated": 1,
      "icon_name": "sirocco",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 3,
      "short_description": "Area Effect 5: Friendly champions occupying Sand have <ability value=2076>Reflexes 1</ability> and <ability value=1376>Evasive 1</ability> for 4 turns.",
      "long_description": "Area Effect 5: Friendly champions occupying Sand have <ability value=2076>Reflexes 1</ability> and <ability value=1376>Evasive 1</ability> for 4 turns.",
      "class_name": "Sirocco",
      "revision": 1
    },
    {
      "asset_id": 4482,
      "resettable": 1,
      "name": "Skeezick Alliance",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 878,
      "activated": 1,
      "icon_name": "skeezickalliance",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "While 3 or more friendly Skeezick are in play, this unit gains +2 DMG. If there are 5 or more friendly Skeezick are in play, this unit also gains +1 DEF.",
      "long_description": "While 3 or more friendly Skeezick are in play, this unit gains +2 DMG. If there are 5 or more friendly Skeezick are in play, this unit also gains +1 DEF.",
      "class_name": "SkeezickAlliance",
      "revision": 1
    },
    {
      "asset_id": 7684,
      "resettable": 0,
      "name": "Skeezick Banner",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3254,
      "activated": 1,
      "icon_name": "skeezick_banner",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 10,
      "short_description": "Friendly Skeezicks within 5 spaces gain <ability value=878>Skeezick Alliance</ability>.  If they already have Skeezick Alliance, they gain <ability value=2961>Skeezick Rebel</ability> instead.",
      "long_description": "Friendly Skeezicks within 5 spaces gain <ability value=878>Skeezick Alliance</ability>.  If they already have Skeezick Alliance, they gain <ability value=2961>Skeezick Rebel</ability> instead.",
      "class_name": "SkeezickBanner",
      "revision": 1
    },
    {
      "asset_id": 4511,
      "resettable": 1,
      "name": "Skeezick Blade",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 920,
      "activated": 1,
      "icon_name": "stab",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "This champion makes a Physical attack at RNG 1. If successfully damaged, the target becomes <condition value=eviscerated>Eviscerated</condition> for 3 turns and <condition value=inhibitied>Inhibitied</condition>.",
      "long_description": "This champion makes a Physical attack at RNG 1. If successfully damaged, the target becomes <condition value=eviscerated>Eviscerated</condition> for 3 turns and <condition value=inhibitied>Inhibitied</condition>.",
      "class_name": "SkeezickBladeAttack",
      "revision": 1
    },
    {
      "asset_id": 4400,
      "resettable": 1,
      "name": "Skeezick Furnace",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2767,
      "activated": 1,
      "icon_name": "noragen",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 0,
      "ranked": 0,
      "cost": 2,
      "short_description": "Destroy target relic within 3 spaces.  Its owner gains 10 nora.",
      "long_description": "Destroy target relic within 3 spaces.  Its owner gains 10 nora.",
      "class_name": "Incinerator",
      "revision": 1
    },
    {
      "asset_id": 5681,
      "resettable": 1,
      "name": "Skeezick Rapture",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2554,
      "activated": 1,
      "icon_name": "skeezickalliance",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 4,
      "short_description": "Friendly Skeezick within 6 spaces have <ability value=539>Attack: Acid</ability> and <ability value=2491>Scour rank 1</ability>.",
      "long_description": "Friendly Skeezick within 6 spaces have <ability value=539>Attack: Acid</ability> and <ability value=2491>Scour rank 1</ability>.",
      "class_name": "SkeezickRapture",
      "revision": 1
    },
    {
      "asset_id": 5925,
      "resettable": 0,
      "name": "Skeezick Rebel",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2961,
      "activated": 1,
      "icon_name": "intensify",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "When a real friendly champion is destroyed, this unit is healed for 6 HP. If that unit was a Skeezick, this unit also gains +2 Max HP and <ability value=259>Enrage 1</ability>.",
      "long_description": "When a real friendly champion is destroyed, this unit is healed for 6 HP. If that unit was a Skeezick, this unit also gains +2 Max HP and <ability value=259>Enrage 1</ability>.",
      "class_name": "SkeezickRebel",
      "revision": 1
    },
    {
      "asset_id": 4581,
      "resettable": 1,
      "name": "Skeezick Rider",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1010,
      "activated": 1,
      "icon_name": "rider",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 20,
      "short_description": "When this unit is destroyed, no drop globe is dropped, a Skeezick Trapper with no upgrades is spawned in the location this unit occupied.",
      "long_description": "When this unit is destroyed, no drop globe is dropped, a Skeezick Trapper with no upgrades is spawned in the location this unit occupied.",
      "class_name": "SkeezickRider",
      "revision": 1
    },
    {
      "asset_id": 4575,
      "resettable": 1,
      "name": "Skeletal Rider",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1000,
      "activated": 1,
      "icon_name": "rider",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 15,
      "short_description": "When this unit is destroyed, no nora globe is dropped and a Decayed Mercenary with no upgrades is spawned in the location this unit occupied.",
      "long_description": "When this unit is destroyed, no nora globe is dropped and a Decayed Mercenary with no upgrades is spawned in the location this unit occupied.",
      "class_name": "SkeletalRider",
      "revision": 1
    },
    {
      "asset_id": 4262,
      "resettable": 1,
      "name": "Skirmisher",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 655,
      "activated": 1,
      "icon_name": "hunter",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -2,
      "short_description": "This unit can only attack champions and transfigured Avatars.",
      "long_description": "This unit can only attack champions and transfigured Avatars.",
      "class_name": "FleshEater",
      "revision": 1
    },
    {
      "asset_id": 7127,
      "resettable": 1,
      "name": "Skylancer",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 1574,
      "activated": 1,
      "icon_name": "spear",
      "comments": "",
      "prerequisite_id": 1573,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 1,
      "short_description": "This unit deals 10% more damage to units units that are <condition value=flying>Flying</condition> or <condition value=grounded>Grounded</condition>",
      "long_description": "This unit deals 10% more damage to units units that are <condition value=flying>Flying</condition> or <condition value=grounded>Grounded</condition>",
      "class_name": "Skylancer",
      "revision": 1
    },
    {
      "asset_id": 7127,
      "resettable": 1,
      "name": "Skylancer",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 1575,
      "activated": 1,
      "icon_name": "spear",
      "comments": "",
      "prerequisite_id": 1574,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 2,
      "short_description": "This unit deals 20% more damage to units units that are <condition value=flying>Flying</condition> or <condition value=grounded>Grounded</condition>",
      "long_description": "This unit deals 20% more damage to units units that are <condition value=flying>Flying</condition> or <condition value=grounded>Grounded</condition>",
      "class_name": "Skylancer",
      "revision": 1
    },
    {
      "asset_id": 7127,
      "resettable": 1,
      "name": "Skylancer",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 1576,
      "activated": 1,
      "icon_name": "spear",
      "comments": "",
      "prerequisite_id": 1575,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 3,
      "short_description": "This unit deals 30% more damage to units units that are <condition value=flying>Flying</condition> or <condition value=grounded>Grounded</condition>",
      "long_description": "This unit deals 30% more damage to units units that are <condition value=flying>Flying</condition> or <condition value=grounded>Grounded</condition>",
      "class_name": "Skylancer",
      "revision": 1
    },
    {
      "asset_id": 5175,
      "resettable": 1,
      "name": "Slam",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1952,
      "activated": 1,
      "icon_name": "knockback",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this champion successfully damages a champion with a basic attack, the target is knocked back 2 spaces. ",
      "long_description": "When this champion successfully damages a champion with a basic attack, the target is knocked back 2 spaces. ",
      "class_name": "Slam",
      "revision": 1
    },
    {
      "asset_id": 7730,
      "resettable": 0,
      "name": "Slayer's Spear",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 3271,
      "activated": 1,
      "icon_name": "spear",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 3,
      "ranked": 0,
      "cost": 8,
      "short_description": "This champion makes a Physical attack at range 2-5. If this attack is successful, the enemy champion becomes <condition value=tagged>Tagged</condition><ability value=3277>.</ability>",
      "long_description": "This champion makes a Physical attack at range 2-5. If this attack is successful, the enemy champion becomes <condition value=tagged>Tagged</condition><ability value=3277>.</ability>",
      "class_name": "HuntersSpear",
      "revision": 1
    },
    {
      "asset_id": 7289,
      "resettable": 0,
      "name": "Sleeper Agent",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3080,
      "activated": 1,
      "icon_name": "sleeper_agent",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 20,
      "short_description": "At the end of the turn after being deployed, this champion is permanently Possessed by your opponent.",
      "long_description": "At the end of the turn after being deployed, this champion is permanently Possessed by your opponent.",
      "class_name": "SleeperAgent",
      "revision": 1
    },
    {
      "asset_id": 7512,
      "resettable": 0,
      "name": "Slipstream Fulcrum",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3184,
      "activated": 1,
      "icon_name": "gale",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "When a champion moves within 3 spaces of this unit via normal movement, it gains 1 AP. This triggers up to 2 times a turn for each champion.",
      "long_description": "When a champion moves within 3 spaces of this unit via normal movement, it gains 1 AP. This triggers up to 2 times a turn for each champion.",
      "class_name": "SlipstreamFulcrum",
      "revision": 1
    },
    {
      "asset_id": 7549,
      "resettable": 0,
      "name": "Slothful",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3203,
      "activated": 1,
      "icon_name": "slothful",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": -6,
      "short_description": "After using an activated ability (including basic attacks), this champion becomes <ability value=757>Immobile</ability> for 1 turn.",
      "long_description": "After using an activated ability (including basic attacks), this champion becomes <ability value=757>Immobile</ability> for 1 turn.",
      "class_name": "Slothful",
      "revision": 1
    },
    {
      "asset_id": 4982,
      "resettable": 1,
      "name": "Slowing Armor",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1864,
      "activated": 1,
      "icon_name": "conduit",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 7,
      "short_description": "When this champion is successfully attacked by any attack, the attacking champion becomes <mechanic value=slowed>Slowed</mechanic> for 3 turns.\n",
      "long_description": "When this champion is successfully attacked by any attack, the attacking champion becomes <mechanic value=slowed>Slowed</mechanic> for 3 turns.\n",
      "class_name": "IceArmor",
      "revision": 1
    },
    {
      "asset_id": 7985,
      "resettable": 0,
      "name": "Sludge Pool",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3381,
      "activated": 1,
      "icon_name": "novaacid",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "Friendly champions within 5 spaces with Race: Slag gain <ability value=1047>Acid Eater</ability> and <ability value=2777>Tunnel Ooze</ability>. If they already have Acid Eater, they gain <ability value=2994>Vigor: Acid</ability> instead. ",
      "long_description": "Friendly champions within 5 spaces with Race: Slag gain <ability value=1047>Acid Eater</ability> and <ability value=2777>Tunnel Ooze</ability>. If they already have Acid Eater, they gain <ability value=2994>Vigor: Acid</ability> instead. ",
      "class_name": "SludgePool",
      "revision": 1
    },
    {
      "asset_id": 7887,
      "resettable": 0,
      "name": "Smash Ukulele",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 3335,
      "activated": 1,
      "icon_name": "dreadsong",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "If this champion is equipped with a Dwarven Ukulele, it is destroyed and champions within 5 spaces takes 8 Sonic damage and this champion becomes Enraged 2 for 3 turns.",
      "long_description": "If this champion is equipped with a Dwarven Ukulele, it is destroyed and champions within 5 spaces takes 8 Sonic damage and this champion becomes Enraged 2 for 3 turns.",
      "class_name": "SmashUkulele",
      "revision": 1
    },
    {
      "asset_id": 4408,
      "resettable": 1,
      "name": "Smite the Unholy",
      "ap_cost": 4,
      "level": 1,
      "ability_id": 734,
      "activated": 1,
      "icon_name": "smite",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 4,
      "short_description": "Target Undead, Demon or Forsaken Wastes unit takes 8 damage.",
      "long_description": "Target Undead, Demon or Forsaken Wastes unit takes 8 damage.",
      "class_name": "SmiteTheUnholy",
      "revision": 1
    },
    {
      "asset_id": 4408,
      "resettable": 1,
      "name": "Smite the Unholy",
      "ap_cost": 4,
      "level": 2,
      "ability_id": 735,
      "activated": 1,
      "icon_name": "smite",
      "comments": "",
      "prerequisite_id": 734,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 9,
      "short_description": "Target Undead, Demon or Forsaken Wastes unit takes 16 damage.",
      "long_description": "Target Undead, Demon or Forsaken Wastes unit takes 16 damage.",
      "class_name": "SmiteTheUnholy",
      "revision": 1
    },
    {
      "asset_id": 4408,
      "resettable": 1,
      "name": "Smite the Unholy",
      "ap_cost": 4,
      "level": 3,
      "ability_id": 736,
      "activated": 1,
      "icon_name": "smite",
      "comments": "",
      "prerequisite_id": 735,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 16,
      "short_description": "Target Undead, Demon or Forsaken Wastes unit takes 24 damage.",
      "long_description": "Target Undead, Demon or Forsaken Wastes unit takes 24 damage.",
      "class_name": "SmiteTheUnholy",
      "revision": 1
    },
    {
      "asset_id": 5563,
      "resettable": 1,
      "name": "Snake Form",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2423,
      "activated": 1,
      "icon_name": "transform",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "This unit is <mechanic value=cleansed>Cleansed</mechanic> and becomes a Snake with RNG 1-3, Bolt, Spit and Entangling Attack.",
      "long_description": "This unit is <mechanic value=cleansed>Cleansed</mechanic> and becomes a Snake with RNG 1-3, Bolt, Spit and Entangling Attack.",
      "class_name": "SnakeForm",
      "revision": 1
    },
    {
      "asset_id": 5629,
      "resettable": 1,
      "name": "Snaptooth Crypt",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2496,
      "activated": 1,
      "icon_name": "debuff",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "Friendly champions with Race: Snaptooth within 5 spaces of this unit gain <ability value=2784>Hunter: Soultapped</ability> and <ability value=607>Essence Capture</ability>.",
      "long_description": "Friendly champions with Race: Snaptooth within 5 spaces of this unit gain <ability value=2784>Hunter: Soultapped</ability> and <ability value=607>Essence Capture</ability>.",
      "class_name": "SnaptoothCrypt",
      "revision": 1
    },
    {
      "asset_id": 4325,
      "resettable": 1,
      "name": "Snatch",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 1353,
      "activated": 1,
      "icon_name": "antiequip",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "Equipment within 3 spaces is destroyed. You gain 2 AP per equipment destroyed this way.",
      "long_description": "Equipment within 3 spaces is destroyed. You gain 2 AP per equipment destroyed this way.",
      "class_name": "Snatch",
      "revision": 1
    },
    {
      "asset_id": 4326,
      "resettable": 1,
      "name": "Sneak",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1354,
      "activated": 1,
      "icon_name": "stealth",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "This unit becomes <condition value=stealthed>Stealthed</condition> at the end of your turn if you have runes in your rune dock that are still concealed and there are no enemy champions within 3 spaces.",
      "long_description": "This unit becomes <condition value=stealthed>Stealthed</condition> at the end of your turn if you have runes in your rune dock that are still concealed and there are no enemy champions within 3 spaces.",
      "class_name": "Sneak",
      "revision": 1
    },
    {
      "asset_id": 5635,
      "resettable": 1,
      "name": "Snogvie's Greeting",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2505,
      "activated": 1,
      "icon_name": "greeting_sonic",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 8,
      "short_description": "When this champion comes into play, all enemy champions take 5 sonic damage and become <condition value=distracted>Distracted</condition> for 2 turns. This damage ignores defense. ",
      "long_description": "When this champion comes into play, all enemy champions take 5 sonic damage and become <condition value=distracted>Distracted</condition> for 2 turns. This damage ignores defense. ",
      "class_name": "SonicGreeting",
      "revision": 1
    },
    {
      "asset_id": 5305,
      "resettable": 1,
      "name": "Snow Shroud",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 2667,
      "activated": 1,
      "icon_name": "domain_snow",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 5,
      "short_description": "Target champion within 5 spaces occupying Ice or Snow has <ability value=2077>Reflexes 2</ability> and <ability value=1377>Evasive 2</ability> for 2 turns.",
      "long_description": "Target champion within 5 spaces occupying Ice or Snow has <ability value=2077>Reflexes 2</ability> and <ability value=1377>Evasive 2</ability> for 2 turns.",
      "class_name": "SnowShroud",
      "revision": 1
    },
    {
      "asset_id": 4432,
      "resettable": 1,
      "name": "Snow-Fall",
      "ap_cost": 2,
      "level": 1,
      "ability_id": 777,
      "activated": 1,
      "icon_name": "terrainsnow",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 2,
      "short_description": "Area Effect 2: Affected spaces become Snow (Impeding 1) for 4 turns.",
      "long_description": "Area Effect 2: Affected spaces become Snow (Impeding 1) for 4 turns.",
      "class_name": "Snowcharge",
      "revision": 1
    },
    {
      "asset_id": 4432,
      "resettable": 1,
      "name": "Snow-Fall",
      "ap_cost": 2,
      "level": 2,
      "ability_id": 778,
      "activated": 1,
      "icon_name": "terrainsnow",
      "comments": "",
      "prerequisite_id": 777,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 4,
      "short_description": "Area Effect 4: Affected spaces become Snow (Impeding 1) for 4 turns.",
      "long_description": "Area Effect 4: Affected spaces become Snow (Impeding 1) for 4 turns.",
      "class_name": "Snowcharge",
      "revision": 1
    },
    {
      "asset_id": 4758,
      "resettable": 1,
      "name": "Snowball",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1482,
      "activated": 1,
      "icon_name": "ice",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 5,
      "short_description": "This unit makes a Frost attack at range 2-4 for 8 DMG. This damage ignores DEF.",
      "long_description": "This unit makes a Frost attack at range 2-4 for 8 DMG. This damage ignores DEF.",
      "class_name": "Snowball",
      "revision": 1
    },
    {
      "asset_id": 5677,
      "resettable": 1,
      "name": "Snowbreach",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2796,
      "activated": 1,
      "icon_name": "terrainsnow",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this unit is damaged, spaces within 2 spaces becomes Deep Snow (Impeding 2) for 3 turns.",
      "long_description": "When this unit is damaged, spaces within 2 spaces becomes Deep Snow (Impeding 2) for 3 turns.",
      "class_name": "Snowbreach",
      "revision": 1
    },
    {
      "asset_id": 5236,
      "resettable": 1,
      "name": "Snowcat Burrow",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2016,
      "activated": 1,
      "icon_name": "sumsnowcat",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 0,
      "short_description": "At the start of your next turn, the Snowcat Burrow will spawn a Snowcat on an adjacent space for 10 Nora. Additional Snowcats will be spawned at the beginning of every fourth turn after that.",
      "long_description": "At the start of your next turn, the Snowcat Burrow will spawn a Snowcat on an adjacent space for 10 Nora. Additional Snowcats will be spawned at the beginning of every fourth turn after that.",
      "class_name": "RelicSnowcatBurrow",
      "revision": 1
    },
    {
      "asset_id": 5763,
      "resettable": 1,
      "name": "Snowstrike",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2669,
      "activated": 1,
      "icon_name": "iceaoe",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this champion makes a successful basic attack, spaces within 1 space of the target becomes Deep Snow (Impeding 2) for 3 turns.",
      "long_description": "When this champion makes a successful basic attack, spaces within 1 space of the target becomes Deep Snow (Impeding 2) for 3 turns.",
      "class_name": "SnowStrike",
      "revision": 1
    },
    {
      "asset_id": 4561,
      "resettable": 1,
      "name": "Soften",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 1001,
      "activated": 1,
      "icon_name": "defpenalties",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "Area Effect 3, Range 5: Affected opposing champions have -3 DEF for 3 turns.",
      "long_description": "Area Effect 3, Range 5: Affected opposing champions have -3 DEF for 3 turns.",
      "class_name": "Soften",
      "revision": 1
    },
    {
      "asset_id": 7250,
      "resettable": 0,
      "name": "Solar Flare",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 3061,
      "activated": 1,
      "icon_name": "fireaoe",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "Enemy champions within 3 spaces take 8 Fire damage and are knocked back 2 spaces.  Champions successfully damaged become <condition value=illuminated>Illuminated</condition> for 3 turns.",
      "long_description": "Enemy champions within 3 spaces take 8 Fire damage and are knocked back 2 spaces.  Champions successfully damaged become <condition value=illuminated>Illuminated</condition> for 3 turns.",
      "class_name": "SolarFlare",
      "revision": 1
    },
    {
      "asset_id": 5791,
      "resettable": 1,
      "name": "Sole Purpose",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2768,
      "activated": 1,
      "icon_name": "ondeath",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -8,
      "short_description": "When this champion makes a basic attack, it loses 3 Charges. For each charge it lacks, it loses 4 HP instead.",
      "long_description": "When this champion makes a basic attack, it loses 3 Charges. For each charge it lacks, it loses 4 HP instead.",
      "class_name": "SolePurpose",
      "revision": 1
    },
    {
      "asset_id": 4759,
      "resettable": 1,
      "name": "Solidify",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 1483,
      "activated": 1,
      "icon_name": "ethereal",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 2,
      "short_description": "Target champion within 5 spaces becomes <condition value=solid>Solid</condition> for 3 turns. May target self.",
      "long_description": "Target champion within 5 spaces becomes <condition value=solid>Solid</condition> for 3 turns. May target self.",
      "class_name": "Solidify",
      "revision": 1
    },
    {
      "asset_id": 4760,
      "resettable": 1,
      "name": "Solitary",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1484,
      "activated": 1,
      "icon_name": "regen",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "This unit has +3 DMG, +2 DEF, and +5 MAX HP when there are no friendly champions within 6 spaces.",
      "long_description": "This unit has +3 DMG, +2 DEF, and +5 MAX HP when there are no friendly champions within 6 spaces.",
      "class_name": "Solitary",
      "revision": 1
    },
    {
      "asset_id": 5903,
      "resettable": 1,
      "name": "Solo: Artillery",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2914,
      "activated": 1,
      "icon_name": "",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "This champion has Artillery as long as there is not more than one other champion within 3 spaces.",
      "long_description": "This champion has Artillery as long as there is not more than one other champion within 3 spaces.",
      "class_name": "SoloArtillery",
      "revision": 1
    },
    {
      "asset_id": 5902,
      "resettable": 1,
      "name": "Solo: Burn 3",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2913,
      "activated": 1,
      "icon_name": "",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "This champion has Burn 3 as long as there is not more than one other champion within 3 spaces.",
      "long_description": "This champion has Burn 3 as long as there is not more than one other champion within 3 spaces.",
      "class_name": "SoloBurn",
      "revision": 1
    },
    {
      "asset_id": 5899,
      "resettable": 1,
      "name": "Solo: Crushing Blow",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2910,
      "activated": 1,
      "icon_name": "solo_shrink",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "This champion has Crushing Blow as long as there is not more than one other champion within 3 spaces.",
      "long_description": "This champion has Crushing Blow as long as there is not more than one other champion within 3 spaces.",
      "class_name": "SoloCrushingBlow",
      "revision": 1
    },
    {
      "asset_id": 5895,
      "resettable": 1,
      "name": "Solo: Deep Wounds",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2904,
      "activated": 1,
      "icon_name": "offenseenhance",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "This champion has Deep Wounds as long as there is not more than one other champion within 3 spaces.",
      "long_description": "This champion has Deep Wounds as long as there is not more than one other champion within 3 spaces.",
      "class_name": "SoloDeepWounds",
      "revision": 1
    },
    {
      "asset_id": 5906,
      "resettable": 1,
      "name": "Solo: Encouraged",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2917,
      "activated": 1,
      "icon_name": "",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "This champion has Encouraged as long as there is not more than one other champion within three spaces.",
      "long_description": "This champion has Encouraged as long as there is not more than one other champion within three spaces.",
      "class_name": "SoloEncouraged",
      "revision": 1
    },
    {
      "asset_id": 5894,
      "resettable": 1,
      "name": "Solo: Evasive 3",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2903,
      "activated": 1,
      "icon_name": "solo_mobility",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "This champion has <ability value=1378>Evasive 3</ability> as long as there is not more than one other champion within 3 spaces.",
      "long_description": "This champion has <ability value=1378>Evasive 3</ability> as long as there is not more than one other champion within 3 spaces.",
      "class_name": "SoloEvasive",
      "revision": 1
    },
    {
      "asset_id": 5897,
      "resettable": 1,
      "name": "Solo: Forbidden Discipline",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2908,
      "activated": 1,
      "icon_name": "discipline_forbidden_solo",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 1,
      "short_description": "This champion has <ability value=2818>Forbidden Discipline</ability> as long as there is not more than one other champion within 3 spaces.",
      "long_description": "This champion has <ability value=2818>Forbidden Discipline</ability> as long as there is not more than one other champion within 3 spaces.",
      "class_name": "SoloForbiddenDiscipline",
      "revision": 1
    },
    {
      "asset_id": 5904,
      "resettable": 1,
      "name": "Solo: Freezing Aura",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2915,
      "activated": 1,
      "icon_name": "",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "This champion has Freezing Aura as long as there is not more than one other champion within 3 spaces.",
      "long_description": "This champion has Freezing Aura as long as there is not more than one other champion within 3 spaces.",
      "class_name": "SoloFreezingAura",
      "revision": 1
    },
    {
      "asset_id": 5881,
      "resettable": 1,
      "name": "Solo: Frightful Blows",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2890,
      "activated": 1,
      "icon_name": "solo_fear",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "This champion has Frightful Blows as long as there is not more than one other champion within 3 spaces.",
      "long_description": "This champion has Frightful Blows as long as there is not more than one other champion within 3 spaces.",
      "class_name": "SoloFrightfulBlows",
      "revision": 1
    },
    {
      "asset_id": 5877,
      "resettable": 1,
      "name": "Solo: Knockout",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2886,
      "activated": 1,
      "icon_name": "solo_stun",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "This champion has Knockout as long as there is not more than one other champion within 3 spaces.",
      "long_description": "This champion has Knockout as long as there is not more than one other champion within 3 spaces.",
      "class_name": "SoloKnockout",
      "revision": 1
    },
    {
      "asset_id": 5905,
      "resettable": 1,
      "name": "Solo: Multiattack 1",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2916,
      "activated": 1,
      "icon_name": "",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "This champion has Multiattack 1 as long as there is not more than one other champion within 3 spaces.",
      "long_description": "This champion has Multiattack 1 as long as there is not more than one other champion within 3 spaces.",
      "class_name": "SoloMultiattack",
      "revision": 1
    },
    {
      "asset_id": 5878,
      "resettable": 1,
      "name": "Solo: Paralytic Feedback",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2887,
      "activated": 1,
      "icon_name": "solo_electricaoe",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "This champion has Paralytic Feedback as long as there is not more than one other champion within 3 spaces.",
      "long_description": "This champion has Paralytic Feedback as long as there is not more than one other champion within 3 spaces.",
      "class_name": "SoloParalyticFeedback",
      "revision": 1
    },
    {
      "asset_id": 5879,
      "resettable": 1,
      "name": "Solo: Purified",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2888,
      "activated": 1,
      "icon_name": "solo_cleanse",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "This champion has Purified as long as there is not more than one other champion within 3 spaces.",
      "long_description": "This champion has Purified as long as there is not more than one other champion within 3 spaces.",
      "class_name": "SoloPurified",
      "revision": 1
    },
    {
      "asset_id": 5876,
      "resettable": 1,
      "name": "Solo: Relic Guardian",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2885,
      "activated": 1,
      "icon_name": "solo_defenseenhance",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "This champion has Relic Guardian as long as there is not more than one other champion within 3 spaces.",
      "long_description": "This champion has Relic Guardian as long as there is not more than one other champion within 3 spaces.",
      "class_name": "SoloRelicGuardian",
      "revision": 1
    },
    {
      "asset_id": 5875,
      "resettable": 1,
      "name": "Solo: Scrapper",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2884,
      "activated": 1,
      "icon_name": "solo_scrapper",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 12,
      "short_description": "This champion has Scrapper as long as there is not more than one other champion within 3 spaces.",
      "long_description": "This champion has Scrapper as long as there is not more than one other champion within 3 spaces.",
      "class_name": "SoloScrapper",
      "revision": 1
    },
    {
      "asset_id": 5880,
      "resettable": 1,
      "name": "Solo: Vaporize",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2889,
      "activated": 1,
      "icon_name": "solo_relocate",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "This champion has Vaporize as long as there is not more than one other champion within 3 spaces.",
      "long_description": "This champion has Vaporize as long as there is not more than one other champion within 3 spaces.",
      "class_name": "SoloVaporize",
      "revision": 1
    },
    {
      "asset_id": 5882,
      "resettable": 1,
      "name": "Solo: Void Shield",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2891,
      "activated": 1,
      "icon_name": "tetra_shield",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "This champion has Void Shield as long as there is not more than one other champion within 3 spaces.",
      "long_description": "This champion has Void Shield as long as there is not more than one other champion within 3 spaces.",
      "class_name": "SoloVoidShield",
      "revision": 1
    },
    {
      "asset_id": 4080,
      "resettable": 1,
      "name": "Sonic Aura",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 147,
      "activated": 1,
      "icon_name": "novasonic",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 2,
      "short_description": "At the beginning of your opponent's turns, this unit deals 2 Sonic damage to each champion within 2 spaces. This damage ignores DEF.",
      "long_description": "At the beginning of your opponent's turns, this unit deals 2 Sonic damage to each champion within 2 spaces. This damage ignores DEF.",
      "class_name": "DamagingAuraSonic",
      "revision": 1
    },
    {
      "asset_id": 4080,
      "resettable": 1,
      "name": "Sonic Aura",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 148,
      "activated": 1,
      "icon_name": "novasonic",
      "comments": "none",
      "prerequisite_id": 147,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 4,
      "short_description": "At the beginning of your opponent's turns, this unit deals 4 Sonic damage to each champion within 2 spaces. This damage ignores DEF.",
      "long_description": "At the beginning of your opponent's turns, this unit deals 4 Sonic damage to each champion within 2 spaces. This damage ignores DEF.",
      "class_name": "DamagingAuraSonic",
      "revision": 1
    },
    {
      "asset_id": 4080,
      "resettable": 1,
      "name": "Sonic Aura",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 149,
      "activated": 1,
      "icon_name": "novasonic",
      "comments": "none",
      "prerequisite_id": 148,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 6,
      "short_description": "At the beginning of your opponent's turns, this unit deals 6 Sonic damage to each champion within 2 spaces. This damage ignores DEF.",
      "long_description": "At the beginning of your opponent's turns, this unit deals 6 Sonic damage to each champion within 2 spaces. This damage ignores DEF.",
      "class_name": "DamagingAuraSonic",
      "revision": 1
    },
    {
      "asset_id": 5339,
      "resettable": 1,
      "name": "Sonic Eater",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2268,
      "activated": 1,
      "icon_name": "eater_sonic",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this unit takes Sonic damage, it instead recovers HP equal to half the damage that would have been dealt.  This unit cannot be Distracted.",
      "long_description": "When this unit takes Sonic damage, it instead recovers HP equal to half the damage that would have been dealt.  This unit cannot be Distracted.",
      "class_name": "SonicEater",
      "revision": 1
    },
    {
      "asset_id": 5166,
      "resettable": 1,
      "name": "Sonic Flight",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1939,
      "activated": 1,
      "icon_name": "flight_sonic",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 4,
      "short_description": "This champion has <condition value=flying>Flying</condition>, <ability value=92>Vulnerability: Sonic</ability> and <ability value=1376>Evasive 1</ability>",
      "long_description": "This champion has <condition value=flying>Flying</condition>, <ability value=92>Vulnerability: Sonic</ability> and an additional rank of <ability value=1376>Evasive</ability>",
      "class_name": "SonicFlight",
      "revision": 2
    },
    {
      "asset_id": 4700,
      "resettable": 1,
      "name": "Sonic Roar",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 1147,
      "activated": 1,
      "icon_name": "novasonic",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 5,
      "short_description": "Champions within 2 spaces take 4 Sonic damage.  Champions successfully damaged champions become <condition value=awestruck>Awestruck</condition> for 2 turns. Relics within 2 spaces take 8 Sonic damage. This damage ignores DEF.",
      "long_description": "Champions within 2 spaces take 4 Sonic damage.  Champions successfully damaged champions become <condition value=awestruck>Awestruck</condition> for 2 turns. Relics within 2 spaces take 8 Sonic damage. This damage ignores DEF.",
      "class_name": "SonicRoar",
      "revision": 1
    },
    {
      "asset_id": 7302,
      "resettable": 0,
      "name": "Sonic Surge",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 3087,
      "activated": 1,
      "icon_name": "charge_sonic",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 12,
      "short_description": "This champion gains 3 AP and Pacified for 1 turn.  For each space moved, enemy champions within 2 spaces take 3 Sonic damage (this damage ignores DEF).  This ability begins on CD.",
      "long_description": "This champion gains 3 AP and Pacified for 1 turn.  For each space moved, enemy champions within 2 spaces take 3 Sonic damage (this damage ignores DEF).  This ability begins on CD.",
      "class_name": "SonicSurge",
      "revision": 1
    },
    {
      "asset_id": 7526,
      "resettable": 0,
      "name": "Sonicburst",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 3189,
      "activated": 1,
      "icon_name": "sonicaoe",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 3,
      "ranked": 0,
      "cost": 8,
      "short_description": "This champion makes an attack at RNG 1-3 for 10 Sonic damage. If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=distracted>Distracted</condition> for 3 turns.",
      "long_description": "This champion makes an attack at RNG 1-3 for 10 Sonic damage. If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=distracted>Distracted</condition> for 3 turns.",
      "class_name": "SonicBurst",
      "revision": 1
    },
    {
      "asset_id": 5292,
      "resettable": 1,
      "name": "Soothing Serenade",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2115,
      "activated": 1,
      "icon_name": "soothserenade",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "Target champion within 5 spaces becomes <condition value=pacified>Pacified</condition> for 2 turns.",
      "long_description": "Target champion within 5 spaces becomes <condition value=pacified>Pacified</condition> for 2 turns.",
      "class_name": "SoothingSerenade",
      "revision": 1
    },
    {
      "asset_id": 5546,
      "resettable": 1,
      "name": "Soul Battery",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2406,
      "activated": 1,
      "icon_name": "merge",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "At the start of each turn champions with Hellstorm gain a charge for each champion in play with Soul Battery.  This champion can be freed by adjacent champions.",
      "long_description": "At the start of each turn champions with Hellstorm gain a charge for each champion in play with Soul Battery.  This champion can be freed by adjacent champions.",
      "class_name": "SoulBattery",
      "revision": 1
    },
    {
      "asset_id": 5436,
      "resettable": 1,
      "name": "Soul Bond",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2286,
      "activated": 1,
      "icon_name": "soul_bond",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 6,
      "short_description": "When this champion is deployed or destroyed, the next 12 damage dealt to other Soul Bond champions is prevented.",
      "long_description": "When this champion is deployed or destroyed, the next 12 damage dealt to other Soul Bond champions is prevented.",
      "class_name": "SoulBond",
      "revision": 1
    },
    {
      "asset_id": 5431,
      "resettable": 1,
      "name": "Soul Channeling",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2281,
      "activated": 1,
      "icon_name": "dot_soultap",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 8,
      "short_description": "At the beginning of its turns, this champion is healed for 2 HP for every champion in play with Soultapped. At the end of its turns, opposing champions within 2 spaces become <condition value=soultapped>Soultapped</condition> for 5 turns.",
      "long_description": "At the beginning of its turns, this champion is healed for 2 HP for every champion in play with Soultapped. At the end of its turns, opposing champions within 2 spaces become <condition value=soultapped>Soultapped</condition> for 5 turns.",
      "class_name": "SoulChanneling",
      "revision": 1
    },
    {
      "asset_id": 4675,
      "resettable": 1,
      "name": "Soul Collection",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1112,
      "activated": 1,
      "icon_name": "nora_eater",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "When this champion moves within 5 spaces of a nora globe, or a nora globe drops from a champion within 5 spaces of this champion, this champion automatically recovers it.",
      "long_description": "When this champion moves within 5 spaces of a nora globe, or a nora globe drops from a champion within 5 spaces of this champion, this champion automatically recovers it.",
      "class_name": "SoulCollection",
      "revision": 1
    },
    {
      "asset_id": 7999,
      "resettable": 0,
      "name": "Soul Feast",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3395,
      "activated": 1,
      "icon_name": "dot_soultap",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "This champion deals 30% additional damage to <condition value=soultapped>Soultapped</condition> champions on basic attacks.",
      "long_description": "This champion deals 30% additional damage to <condition value=soultapped>Soultapped</condition> champions on basic attacks.",
      "class_name": "SoulFeast",
      "revision": 1
    },
    {
      "asset_id": 4344,
      "resettable": 0,
      "name": "Soul Linked",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 3339,
      "activated": 1,
      "icon_name": "soul_linked",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "When this unit is deployed, it gains 10 HP for every real (non-summoned, non-illusion) champion your enemy has in play, with a maximum of 100 HP. If your enemy does not have any champions in play, this unit is destroyed.",
      "long_description": "When this unit is deployed, it gains 10 HP for every real (non-summoned, non-illusion) champion your enemy has in play, with a maximum of 100 HP. If your enemy does not have any champions in play, this unit is destroyed.",
      "class_name": "SoulLinked",
      "revision": 1
    },
    {
      "asset_id": 4344,
      "resettable": 1,
      "name": "Soul Linked",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 1372,
      "activated": 1,
      "icon_name": "soul_linked",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "When this unit is deployed, it gains 5 HP for every real (non-summoned, non-illusion) champion your enemy has in play, with a maximum of 50 HP. If your enemy does not have any champions in play, this unit is destroyed.",
      "long_description": "When this unit is deployed, it gains 5 HP for every real (non-summoned, non-illusion) champion your enemy has in play, with a maximum of 50 HP. If your enemy does not have any champions in play, this unit is destroyed.",
      "class_name": "SoulLinked",
      "revision": 1
    },
    {
      "asset_id": 4023,
      "resettable": 1,
      "name": "Soul Mason",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 45,
      "activated": 1,
      "icon_name": "shrinegood",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 3,
      "short_description": "When this unit destroys a champion, your shrine heals HP equal to 20% of the destroyed champion's nora cost.",
      "long_description": "When this unit destroys a champion, your shrine heals HP equal to 20% of the destroyed champion's nora cost.",
      "class_name": "SoulMason",
      "revision": 1
    },
    {
      "asset_id": 5447,
      "resettable": 1,
      "name": "Soul of Ailur",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2299,
      "activated": 1,
      "icon_name": "warriorspride",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "This champion has <ability value=479>Brushwalker</ability>. When this champion attacks another champion with an attack that costs at least 1 AP, the closest valid friendly champion within 8 spaces with <ability value=2075>Pride of Ailur</ability> gains 1 AP and gains +2 DMG for 6 turns (to a max of +4 DMG).",
      "long_description": "This champion has <ability value=479>Brushwalker</ability>. When this champion attacks another champion with an attack that costs at least 1 AP, the closest valid friendly champion within 8 spaces with <ability value=2075>Pride of Ailur</ability> gains 1 AP and gains +2 DMG for 6 turns (to a max of +4 DMG).",
      "class_name": "SoulOfAilur",
      "revision": 1
    },
    {
      "asset_id": 4343,
      "resettable": 1,
      "name": "Soul Siphon",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1371,
      "activated": 1,
      "icon_name": "soul_siphon",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 20,
      "short_description": "When a real champion is destroyed this unit gains 5 MAX HP (to a maximum of 100) and +1 DMG permanently.",
      "long_description": "When a real champion is destroyed this unit gains 5 MAX HP (to a maximum of 100) and +1 DMG permanently.",
      "class_name": "SoulSiphon",
      "revision": 1
    },
    {
      "asset_id": 7774,
      "resettable": 0,
      "name": "Soul Transfer",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3298,
      "activated": 1,
      "icon_name": "soulsift",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 10,
      "short_description": "When this champion is destroyed, the closest friendly Salaam the Fell Bunny permanently gains <ability value=99>Life Siphon</ability>, +1 SPD and +10 MAX HP. If there are no friendly Salaam the Fell Bunny, the closest friendly Beast champion permanently gains +1 SPD and +5 MAX HP.",
      "long_description": "When this champion is destroyed, the closest friendly Salaam the Fell Bunny permanently gains <ability value=99>Life Siphon</ability>, +1 SPD and +10 MAX HP. If there are no friendly Salaam the Fell Bunny, the closest friendly Beast champion permanently gains +1 SPD and +5 MAX HP.",
      "class_name": "SoulTransfer",
      "revision": 1
    },
    {
      "asset_id": 5920,
      "resettable": 0,
      "name": "Soul Trapper",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2954,
      "activated": 1,
      "icon_name": "soulsift",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "This unit has +1 DMG for each charge it has.",
      "long_description": "This unit has +1 DMG for each charge it has.",
      "class_name": "SoulTrapper",
      "revision": 1
    },
    {
      "asset_id": 5712,
      "resettable": 1,
      "name": "Soul Vitality",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2594,
      "activated": 1,
      "icon_name": "surge",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 4,
      "short_description": "When a non-illusion champion is destroyed, this champion gains 1 AP.  If the champion was real, this champion gains 2 AP instead.",
      "long_description": "When a non-illusion champion is destroyed, this champion gains 1 AP.  If the champion was real, this champion gains 2 AP instead.",
      "class_name": "SoulVitality",
      "revision": 1
    },
    {
      "asset_id": 4055,
      "resettable": 1,
      "name": "Soulburst",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 97,
      "activated": 1,
      "icon_name": "deathnovamagic",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 18,
      "short_description": "When this unit is destroyed, it deals 20 Magical damage to each champion within 2 spaces.",
      "long_description": "When this unit is destroyed, it deals 20 Magical damage to each champion within 2 spaces.",
      "class_name": "Soulburst",
      "revision": 1
    },
    {
      "asset_id": 4173,
      "resettable": 1,
      "name": "Souldrinker",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 485,
      "activated": 1,
      "icon_name": "nora_eater",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 11,
      "short_description": "When this unit destroys a champion, it heals HP equal to half the destroyed champions's nora cost.",
      "long_description": "When this unit destroys a champion, it heals HP equal to half the destroyed champions's nora cost.",
      "class_name": "Souldrinker",
      "revision": 1
    },
    {
      "asset_id": 4174,
      "resettable": 1,
      "name": "Soulharvester",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 486,
      "activated": 1,
      "icon_name": "nora_eater",
      "comments": "none",
      "prerequisite_id": 2611,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 25,
      "short_description": "When this unit destroys an enemy champion, you gain nora equal to half the destroyed champion's nora cost.",
      "long_description": "When this unit destroys an enemy champion, you gain nora equal to half the destroyed champion's nora cost.",
      "class_name": "Soulharvester",
      "revision": 1
    },
    {
      "asset_id": 4174,
      "resettable": 1,
      "name": "Soulharvester",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 2611,
      "activated": 1,
      "icon_name": "ondeath",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 15,
      "short_description": "When this unit destroys an enemy champion, you gain nora equal to 25% of the destroyed champion's nora cost.",
      "long_description": "When this unit destroys an enemy champion, you gain nora equal to 25% of the destroyed champion's nora cost.",
      "class_name": "Soulharvester",
      "revision": 1
    },
    {
      "asset_id": 7181,
      "resettable": 0,
      "name": "Soulseeker",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 3026,
      "activated": 1,
      "icon_name": "relocate_lightning",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "This champion is relocated adjacent to target champion within 5 spaces with <condition value=soultapped>Soultapped</condition> or <condition value=cursed>Cursed</condition> and gains +2 SPD for 3 turns.",
      "long_description": "This champion is relocated adjacent to target champion within 5 spaces with <condition value=soultapped>Soultapped</condition> or <condition value=cursed>Cursed</condition> and gains +2 SPD for 3 turns.",
      "class_name": "Soulseeker",
      "revision": 1
    },
    {
      "asset_id": 4176,
      "resettable": 1,
      "name": "Soulsift",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 488,
      "activated": 1,
      "icon_name": "soulsift",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 5,
      "short_description": "When this unit is destroyed, you gain nora equal to 20% of this units nora cost.",
      "long_description": "When this unit is destroyed, you gain nora equal to 20% of this units nora cost.",
      "class_name": "Soulsift",
      "revision": 1
    },
    {
      "asset_id": 4176,
      "resettable": 1,
      "name": "Soulsift",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 489,
      "activated": 1,
      "icon_name": "soulsift",
      "comments": "none",
      "prerequisite_id": 488,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 10,
      "short_description": "When this unit is destroyed, you gain nora equal to 40% of this units nora cost.",
      "long_description": "When this unit is destroyed, you gain nora equal to 40% of this units nora cost.",
      "class_name": "Soulsift",
      "revision": 1
    },
    {
      "asset_id": 4176,
      "resettable": 1,
      "name": "Soulsift",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 490,
      "activated": 1,
      "icon_name": "soulsift",
      "comments": "none",
      "prerequisite_id": 489,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 15,
      "short_description": "When this unit is destroyed, you gain nora equal to 60% of this units nora cost.",
      "long_description": "When this unit is destroyed, you gain nora equal to 60% of this units nora cost.",
      "class_name": "Soulsift",
      "revision": 1
    },
    {
      "asset_id": 5163,
      "resettable": 1,
      "name": "Soulsphere",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1936,
      "activated": 1,
      "icon_name": "soul_bond",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "All champions you own share damage equally with each other rounded up while this unit is in play (this ignores defense except on the target of an attack).  This unit takes 3 damage when a unit you own takes damage.",
      "long_description": "All champions you own share damage equally with each other rounded up while this unit is in play (this ignores defense except on the target of an attack).  This unit takes 3 damage when a unit you own takes damage.",
      "class_name": "RelicSoulsphere",
      "revision": 1
    },
    {
      "asset_id": 4909,
      "resettable": 1,
      "name": "Soulstrike",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1791,
      "activated": 1,
      "icon_name": "lossoflife",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 18,
      "short_description": "Whenever this champion successfully hits an opponent with a basic attack, target champion loses life equal to 25% of its max HP. This ability ignores immunities.",
      "long_description": "Whenever this champion successfully hits an opponent with a basic attack, target champion loses life equal to 25% of its max HP. This ability ignores immunities.",
      "class_name": "Soulstrike",
      "revision": 1
    },
    {
      "asset_id": 4975,
      "resettable": 1,
      "name": "Soultap",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1857,
      "activated": 1,
      "icon_name": "dot_soultap",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 5,
      "short_description": "Any time this champion damages another with a basic attack, the target becomes <condition value=soultapped>Soultapped</condition> for 6 turns",
      "long_description": "Any time this champion damages another with a basic attack, the target becomes <condition value=soultapped>Soultapped</condition> for 6 turns",
      "class_name": "Soultap",
      "revision": 1
    },
    {
      "asset_id": 7170,
      "resettable": 0,
      "name": "Soultap Feedback",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3013,
      "activated": 1,
      "icon_name": "soultap_feedback",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 3,
      "short_description": "When this champion is attacked, the attacking champion becomes <condition value=soultapped>Soultapped</condition> for 5 turns.",
      "long_description": "When this champion is attacked, the attacking champion becomes <condition value=soultapped>Soultapped</condition> for 5 turns.",
      "class_name": "SoultapFeedback",
      "revision": 1
    },
    {
      "asset_id": 5519,
      "resettable": 1,
      "name": "Soultap Luminescence",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2378,
      "activated": 1,
      "icon_name": "soultap_luminesence",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "When this unit is deployed and at the start of its turns, opposing champions within 4 spaces become <condition value=soultapped>Soultapped</condition> for 5 turns.",
      "long_description": "When this unit is deployed and at the start of its turns, opposing champions within 4 spaces become <condition value=soultapped>Soultapped</condition> for 5 turns.",
      "class_name": "SoultapLuminescence",
      "revision": 1
    },
    {
      "asset_id": 7149,
      "resettable": 0,
      "name": "Soulwrack",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 2991,
      "activated": 1,
      "icon_name": "soulwrack",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "This champion makes a Loss of Life attack at RNG 2-5. This attack deals bonus damage equal to the number of champions with <condition value=soultapped>Soultapped</condition>.",
      "long_description": "This champion makes a Loss of Life attack at RNG 2-5. This attack deals bonus damage equal to the number of champions with <condition value=soultapped>Soultapped</condition>.",
      "class_name": "Soulwrack",
      "revision": 1
    },
    {
      "asset_id": 5896,
      "resettable": 1,
      "name": "Source Crystal Lava",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2907,
      "activated": 1,
      "icon_name": "terrainlava",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "If more than 3 Source Crystals are in play, this Source Crystal gains Lava Fall 2.",
      "long_description": "If more than 3 Source Crystals are in play, this Source Crystal gains Lava Fall 2.",
      "class_name": "SourceCrystalLava",
      "revision": 1
    },
    {
      "asset_id": 7656,
      "resettable": 0,
      "name": "Sovereign Bounty",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3246,
      "activated": 1,
      "icon_name": "sovereign_bounty",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 12,
      "short_description": "This champion permanently gains a random non-basic attack ability from the next 3 champions you deploy from the runedock.  This does not stack.",
      "long_description": "This champion permanently gains a random non-basic attack ability from the next 3 champions you deploy from the runedock.  This does not stack.",
      "class_name": "GimmeYerStuff",
      "revision": 1
    },
    {
      "asset_id": 4327,
      "resettable": 1,
      "name": "Spark Charge",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 1355,
      "activated": 1,
      "icon_name": "amp_lightning",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 5,
      "short_description": "Until end of turn, all Electricity damage is increased by 2. This unit loses 6 HP.",
      "long_description": "Until end of turn, all Electricity damage is increased by 2. This unit loses 6 HP.",
      "class_name": "SparkCharge",
      "revision": 1
    },
    {
      "asset_id": 5417,
      "resettable": 1,
      "name": "Spark Curse",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2248,
      "activated": 1,
      "icon_name": "spark_curse",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "Units that become <condition value=shocked popup=false>Shocked</condition> also becomes <condition value=cursed>Cursed</condition> for 2 turns.",
      "long_description": "Units that become <condition value=shocked popup=false>Shocked</condition> also becomes <condition value=cursed>Cursed</condition> for 2 turns.",
      "class_name": "SparkCurse",
      "revision": 1
    },
    {
      "asset_id": 7329,
      "resettable": 0,
      "name": "Spatial Dysplasia",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 3102,
      "activated": 1,
      "icon_name": "spatial_dysplasia",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "Area Effect 2, Range 5: Enemy champions are pulled 1 space towards the center tile and take 4 Psychic damage for every enemy champion within the affected area (this ignores DEF).",
      "long_description": "Area Effect 2, Range 5: Enemy champions are pulled 1 space towards the center tile and take 4 Psychic damage for every enemy champion within the affected area (this ignores DEF).",
      "class_name": "SpatialDysplasia",
      "revision": 1
    },
    {
      "asset_id": 5797,
      "resettable": 1,
      "name": "Spell Aegis",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2786,
      "activated": 1,
      "icon_name": "dark_aura",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "When an opposing spell is successfully cast, opposing spells cost 5 additional nora for 5 turns.",
      "long_description": "When an opposing spell is successfully cast, opposing spells cost 5 additional nora for 5 turns.",
      "class_name": "SpellAegis",
      "revision": 1
    },
    {
      "asset_id": 4328,
      "resettable": 1,
      "name": "Spell Blockade",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1356,
      "activated": 1,
      "icon_name": "counterspell_mastery",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 8,
      "activation_type": 1,
      "ranked": 0,
      "cost": 50,
      "short_description": "The next spell cast by your enemy backfires. This units health is reduced to 1 when Spell Blockade triggers.  This effect is hidden until triggered.  If the unit that activated this effect is removed from play before it is triggered then the effect will not trigger.",
      "long_description": "The next spell cast by your enemy backfires. This units health is reduced to 1 when Spell Blockade triggers.  This effect is hidden until triggered.  If the unit that activated this effect is removed from play before it is triggered then the effect will not trigger.",
      "class_name": "SpellBlockade",
      "revision": 1
    },
    {
      "asset_id": 7800,
      "resettable": 0,
      "name": "Spell Breach",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3319,
      "activated": 1,
      "icon_name": "counterspell_mastery",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "Friendly champions within 5 spaces (including this one), gain +1 SPD for 2 turns when an enemy spell is successfully cast.",
      "long_description": "Friendly champions within 5 spaces (including this one), gain +1 SPD for 2 turns when an enemy spell is successfully cast.",
      "class_name": "SpellBreach",
      "revision": 1
    },
    {
      "asset_id": 5343,
      "resettable": 1,
      "name": "Spell Charged",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 2175,
      "activated": 1,
      "icon_name": "charged_spell",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 1,
      "short_description": "When a spell is played, this unit gains 1 charge.",
      "long_description": "When a spell is played, this unit gains 1 charge.",
      "class_name": "SpellCharged",
      "revision": 1
    },
    {
      "asset_id": 5343,
      "resettable": 1,
      "name": "Spell Charged",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 2176,
      "activated": 1,
      "icon_name": "charged_spell",
      "comments": "",
      "prerequisite_id": 2175,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 2,
      "short_description": "When a spell is played, this unit gains 2 charges.",
      "long_description": "When a spell is played, this unit gains 2 charges.",
      "class_name": "SpellCharged",
      "revision": 1
    },
    {
      "asset_id": 5343,
      "resettable": 1,
      "name": "Spell Charged",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 2177,
      "activated": 1,
      "icon_name": "charged_spell",
      "comments": "",
      "prerequisite_id": 2176,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 3,
      "short_description": "When a spell is played, this unit gains 3 charges.",
      "long_description": "When a spell is played, this unit gains 3 charges.",
      "class_name": "SpellCharged",
      "revision": 1
    },
    {
      "asset_id": 4898,
      "resettable": 1,
      "name": "Spell Resistance",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1534,
      "activated": 1,
      "icon_name": "spell_resistance",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "This unit takes 50% less damage from spells.\r\n",
      "long_description": "This unit takes 50% less damage from spells.",
      "class_name": "SpellResistance",
      "revision": 1
    },
    {
      "asset_id": 5483,
      "resettable": 1,
      "name": "Spell Shift",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2342,
      "activated": 1,
      "icon_name": "special",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "Spend 8 charges.  All cooldowns on your spells are reduced by 5.",
      "long_description": "Spend 8 charges.  All cooldowns on your spells are reduced by 5.",
      "class_name": "SpellShift",
      "revision": 1
    },
    {
      "asset_id": 5560,
      "resettable": 1,
      "name": "Spell Siphon",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2420,
      "activated": 1,
      "icon_name": "",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "Whenever this unit is affected by an opposing spell, this unit's controller gains 50% of the nora cost of that spell.  This does not stack.",
      "long_description": "Whenever this unit is affected by an opposing spell, this unit's controller gains 50% of the nora cost of that spell.  This does not stack.",
      "class_name": "SpellSiphon",
      "revision": 1
    },
    {
      "asset_id": 7497,
      "resettable": 0,
      "name": "Spellsurge: Blinding Flash",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3176,
      "activated": 1,
      "icon_name": "special",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this champion is deployed, Blinding Flash spells are revealed from your runedock.  Blinding Flash spells costs 10 nora less (this does not stack) and this champion is healed for 8 HP when a Blinding Flash spell is played.",
      "long_description": "When this champion is deployed, Blinding Flash spells are revealed from your runedock.  Blinding Flash spells costs 10 nora less (this does not stack) and this champion is healed for 8 HP when a Blinding Flash spell is played.",
      "class_name": "SpellsurgeBlindingFlash",
      "revision": 1
    },
    {
      "asset_id": 7972,
      "resettable": 0,
      "name": "Spellsurge: Burnout",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3359,
      "activated": 1,
      "icon_name": "special",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this champion is deployed, Burnout spells are revealed from your runedock. Burnout spells cost 10 nora less (this does not stack) and this champion is healed for 8 HP when a friendly Burnout spell is played.",
      "long_description": "When this champion is deployed, Burnout spells are revealed from your runedock. Burnout spells cost 10 nora less (this does not stack) and this champion is healed for 8 HP when a friendly Burnout spell is played.",
      "class_name": "SpellsurgeBurnout",
      "revision": 1
    },
    {
      "asset_id": 7973,
      "resettable": 0,
      "name": "Spellsurge: Elemental Vortex",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3360,
      "activated": 1,
      "icon_name": "special",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this champion is deployed, Elemental Vortex spells are revealed from your runedock. Elemental Vortex spells costs 10 nora less (this does not stack) and this champion is healed for 8 HP when a friendly Elemental Vortex spell is played.",
      "long_description": "When this champion is deployed, Elemental Vortex spells are revealed from your runedock. Elemental Vortex spells costs 10 nora less (this does not stack) and this champion is healed for 8 HP when a friendly Elemental Vortex spell is played.",
      "class_name": "SpellsurgeElementalVortex",
      "revision": 1
    },
    {
      "asset_id": 7974,
      "resettable": 0,
      "name": "Spellsurge: Festering Wounds",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3361,
      "activated": 1,
      "icon_name": "special",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this champion is deployed, Festering Wounds spells are revealed from your runedock. Festering Wounds spells costs 10 nora less (this does not stack) and this champion is healed for 8 HP when a friendly Festering Wounds spell is played.",
      "long_description": "When this champion is deployed, Festering Wounds spells are revealed from your runedock. Festering Wounds spells costs 10 nora less (this does not stack) and this champion is healed for 8 HP when a friendly Festering Wounds spell is played.",
      "class_name": "SpellsurgeFesteringWounds",
      "revision": 1
    },
    {
      "asset_id": 8020,
      "resettable": 0,
      "name": "Spellsurge: Fiery Ambush",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3417,
      "activated": 1,
      "icon_name": "special",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this champion is deployed, Fiery Ambush spell runes are revealed in your runedock. Fiery Ambush spells cost 10 nora less (this does not stack) and this champion is healed for 8 HP when a friendly Fiery Ambush spell is played.",
      "long_description": "When this champion is deployed, Fiery Ambush spell runes are revealed in your runedock. Fiery Ambush spells cost 10 nora less (this does not stack) and this champion is healed for 8 HP when a friendly Fiery Ambush spell is played.",
      "class_name": "SpellsurgeFieryAmbush",
      "revision": 1
    },
    {
      "asset_id": 5776,
      "resettable": 1,
      "name": "Spellsurge: Murkwater Weakness",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2754,
      "activated": 1,
      "icon_name": "special",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this champion is deployed, Murkwater Weakness spells are revealed from your runedock.  Murkwater Weakness spells costs 10 nora less (this does not stack) and this champion is healed for 8 HP when a Murkwater Weakness spell is played.",
      "long_description": "When this champion is deployed, Murkwater Weakness spells are revealed from your runedock.  Murkwater Weakness spells costs 10 nora less (this does not stack) and this champion is healed for 8 HP when a Murkwater Weakness spell is played.",
      "class_name": "SpellsurgeGloomwater",
      "revision": 1
    },
    {
      "asset_id": 7452,
      "resettable": 0,
      "name": "Spellsurge: Sandstorm",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3159,
      "activated": 1,
      "icon_name": "special",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this champion is deployed, Sandstorm spells are revealed from your runedock.  Sandstorm spells costs 10 nora less (this does not stack) and this champion is healed for 8 HP when a Sandstorm spell is played.",
      "long_description": "When this champion is deployed, Sandstorm spells are revealed from your runedock.  Sandstorm spells costs 10 nora less (this does not stack) and this champion is healed for 8 HP when a Sandstorm spell is played.",
      "class_name": "SpellsurgeSandstorm",
      "revision": 1
    },
    {
      "asset_id": 5776,
      "resettable": 1,
      "name": "Spellsurge: Snowstorm",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2810,
      "activated": 1,
      "icon_name": "special",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this champion is deployed, Snowstorm spells are revealed from your runedock.  Snowstorm spells costs 10 nora less (this does not stack) and this champion is healed for 8 HP when a Snowstorm spell is played.",
      "long_description": "When this champion is deployed, Snowstorm spells are revealed from your runedock.  Snowstorm spells costs 10 nora less (this does not stack) and this champion is healed for 8 HP when a Snowstorm spell is played.",
      "class_name": "SpellsurgeSnowstorm",
      "revision": 1
    },
    {
      "asset_id": 7571,
      "resettable": 0,
      "name": "Spellsurge: Spontaneous Growth",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3216,
      "activated": 1,
      "icon_name": "special",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this champion is deployed, Spontaneous Growth spells are revealed from your runedock.  Spontaneous Growth spells costs 10 nora less (this does not stack) and this champion is healed for 8 HP when a Spontaneous Growth spell is played.",
      "long_description": "When this champion is deployed, Spontaneous Growth spells are revealed from your runedock.  Spontaneous Growth spells costs 10 nora less (this does not stack) and this champion is healed for 8 HP when a Spontaneous Growth spell is played.",
      "class_name": "SpellsurgeSpontaneousGrowth",
      "revision": 1
    },
    {
      "asset_id": 7975,
      "resettable": 0,
      "name": "Spellsurge: Suppress",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3362,
      "activated": 1,
      "icon_name": "special",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this champion is deployed, Suppress spells are revealed from your runedock. Suppress spells costs 10 nora less (this does not stack) and this champion is healed for 8 HP when a friendly Suppress spell is played.",
      "long_description": "When this champion is deployed, Suppress spells are revealed from your runedock. Suppress spells costs 10 nora less (this does not stack) and this champion is healed for 8 HP when a friendly Suppress spell is played.",
      "class_name": "SpellsurgeSuppress",
      "revision": 1
    },
    {
      "asset_id": 4409,
      "resettable": 1,
      "name": "Spellswallower",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 737,
      "activated": 1,
      "icon_name": "spellswallow",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
      "long_description": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
      "class_name": "SpellSwallower",
      "revision": 1
    },
    {
      "asset_id": 4329,
      "resettable": 1,
      "name": "Spelltouched",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1357,
      "activated": 1,
      "icon_name": "inhibit",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": -10,
      "short_description": "When an enemy casts a spell, this unit loses 10 HP.",
      "long_description": "When an enemy casts a spell, this unit loses 10 HP.",
      "class_name": "Spelltouched",
      "revision": 1
    },
    {
      "asset_id": 5565,
      "resettable": 1,
      "name": "Spider Form",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2425,
      "activated": 1,
      "icon_name": "propagate_spiderling",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "This unit is <mechanic value=cleansed>Cleansed</mechanic> and becomes a Spider with RNG 1, Creep and Crawl, Windstriker, Web and Cocoon.",
      "long_description": "This unit is <mechanic value=cleansed>Cleansed</mechanic> and becomes a Spider with RNG 1, Creep and Crawl, Windstriker, Web and Cocoon.",
      "class_name": "SpiderForm",
      "revision": 1
    },
    {
      "asset_id": 4911,
      "resettable": 1,
      "name": "Spider Frenzy",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1793,
      "activated": 1,
      "icon_name": "sumspider",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "Other friendly champions with Race: Arthropod within 8 spaces have <ability value=6>Mobility</ability>.",
      "long_description": "Other friendly champions with Race: Arthropod within 8 spaces have <ability value=6>Mobility</ability>.",
      "class_name": "SpiderFrenzy",
      "revision": 1
    },
    {
      "asset_id": 4418,
      "resettable": 1,
      "name": "Spike Nova",
      "ap_cost": 3,
      "level": 1,
      "ability_id": 749,
      "activated": 1,
      "icon_name": "novaspike",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 2,
      "short_description": "This unit deals 3 Physical damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged become <condition value=burred>Burred</condition> for 4 turns.",
      "long_description": "This unit deals 3 Physical damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged become <condition value=burred>Burred</condition> for 4 turns.",
      "class_name": "SpikeNova",
      "revision": 1
    },
    {
      "asset_id": 4418,
      "resettable": 1,
      "name": "Spike Nova",
      "ap_cost": 3,
      "level": 2,
      "ability_id": 750,
      "activated": 1,
      "icon_name": "novaspike",
      "comments": "",
      "prerequisite_id": 749,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 4,
      "short_description": "This unit deals 6 Physical damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged become <condition value=burred>Burred</condition> for 4 turns.",
      "long_description": "This unit deals 6 Physical damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged become <condition value=burred>Burred</condition> for 4 turns.",
      "class_name": "SpikeNova",
      "revision": 1
    },
    {
      "asset_id": 4418,
      "resettable": 1,
      "name": "Spike Nova",
      "ap_cost": 3,
      "level": 3,
      "ability_id": 751,
      "activated": 1,
      "icon_name": "novaspike",
      "comments": "",
      "prerequisite_id": 750,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 6,
      "short_description": "This unit deals 9 Physical damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged become <condition value=burred>Burred</condition> for 4 turns.",
      "long_description": "This unit deals 9 Physical damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged become <condition value=burred>Burred</condition> for 4 turns.",
      "class_name": "SpikeNova",
      "revision": 1
    },
    {
      "asset_id": 7506,
      "resettable": 0,
      "name": "Spirit Harvest",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 3181,
      "activated": 1,
      "icon_name": "phylactery",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 3,
      "ranked": 0,
      "cost": 10,
      "short_description": "This champion makes a Loss of Life attack against target champion at RNG 2-5. If this destroys the champion, a Phylactery relic is summoned in the closest friendly deployment zone. ",
      "long_description": "This champion makes a Loss of Life attack against target champion at RNG 2-5. If this destroys the champion, a Phylactery relic is summoned in the closest friendly deployment zone. ",
      "class_name": "SpiritHarvest",
      "revision": 1
    },
    {
      "asset_id": 5442,
      "resettable": 1,
      "name": "Spirit Projection",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2294,
      "activated": 1,
      "icon_name": "spirit_proj",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 25,
      "short_description": "When this champion is deployed and at the start of its turns, if there is no Manifestation of this unit in play, a <ability value=2304>Manifestation</ability> of this unit without upgrades is summoned within 3 spaces of this champion. This ability triggers only if the champion is a Garu Medium or Spirit of the Mountain.",
      "long_description": "When this champion is deployed and at the start of its turns, if there is no Manifestation of this unit in play, a <ability value=2304>Manifestation</ability> of this unit without upgrades is summoned within 3 spaces of this champion. This ability triggers only if the champion is a Garu Medium or Spirit of the Mountain.",
      "class_name": "SpiritProjection",
      "revision": 1
    },
    {
      "asset_id": 4810,
      "resettable": 1,
      "name": "Spit Poison",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 1585,
      "activated": 1,
      "icon_name": "poison",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 8,
      "activation_type": 1,
      "ranked": 1,
      "cost": 6,
      "short_description": "This champion makes a Poison attack at Range 1-3.",
      "long_description": "This champion makes a Poison attack at Range 1-3.",
      "class_name": "SpitPoison",
      "revision": 1
    },
    {
      "asset_id": 4810,
      "resettable": 1,
      "name": "Spit Poison",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 1586,
      "activated": 1,
      "icon_name": "poison",
      "comments": "",
      "prerequisite_id": 1585,
      "cooldown": 8,
      "activation_type": 1,
      "ranked": 1,
      "cost": 6,
      "short_description": "This champion makes a Poison attack at Range 1-3. If successful, the target becomes <condition value=poisoned>Poisoned</condition> for 2 turns.",
      "long_description": "This champion makes a Poison attack at Range 1-3. If successful, the target becomes <condition value=poisoned>Poisoned</condition> for 2 turns.",
      "class_name": "SpitPoison",
      "revision": 1
    },
    {
      "asset_id": 4810,
      "resettable": 1,
      "name": "Spit Poison",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 1587,
      "activated": 1,
      "icon_name": "poison",
      "comments": "",
      "prerequisite_id": 1586,
      "cooldown": 8,
      "activation_type": 1,
      "ranked": 1,
      "cost": 6,
      "short_description": "This champion makes a Poison attack at Range 1-4. If successful, the target becomes <condition value=poisoned>Poisoned</condition> for 4 turns.",
      "long_description": "This champion makes a Poison attack at Range 1-4. If successful, the target becomes <condition value=poisoned>Poisoned</condition> for 4 turns.",
      "class_name": "SpitPoison",
      "revision": 1
    },
    {
      "asset_id": 4761,
      "resettable": 1,
      "name": "Splash",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 1485,
      "activated": 1,
      "icon_name": "tsunami",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 2,
      "short_description": "Spaces within 3 spaces of this champion are Water (Impeding 1) for 4 turns.",
      "long_description": "Spaces within 3 spaces of this champion are Water (Impeding 1) for 4 turns.",
      "class_name": "Splash",
      "revision": 1
    },
    {
      "asset_id": 5084,
      "resettable": 1,
      "name": "Splintering",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1258,
      "activated": 1,
      "icon_name": "defpenalties",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 2,
      "short_description": "After this champion deals Physical damage to a champion on a close-combat attack, this champion loses 4 HP and gains +2 DMG and a Bone Spur is created in an adjacent space. When a champion with Race: Skeleton captures a Bone Spur, they gain +1 DMG for 1 turn and +2 MAX HP permanently. All other champions take 3 Physical damage when capturing a Bone Spur.",
      "long_description": "After this champion deals Physical damage to a champion on a close-combat attack, this champion loses 4 HP and gains +2 DMG and a Bone Spur is created in an adjacent space. When a champion with Race: Skeleton captures a Bone Spur, they gain +1 DMG for 1 turn and +2 MAX HP permanently. All other champions take 3 Physical damage when capturing a Bone Spur.",
      "class_name": "Splintering",
      "revision": 1
    },
    {
      "asset_id": 5155,
      "resettable": 1,
      "name": "Split",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1259,
      "activated": 1,
      "icon_name": "duplicate",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "When this unit is successfully damaged from a basic combat attack (takes more than 0 damage), it splits in two and both copies' hp are halved.",
      "long_description": "When this unit is successfully damaged from a basic combat attack (takes more than 0 damage), it splits in two and both copies' hp are halved.",
      "class_name": "Split",
      "revision": 1
    },
    {
      "asset_id": 5335,
      "resettable": 1,
      "name": "Split Hero",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2265,
      "activated": 1,
      "icon_name": "split_requirement_hero",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "If this unit is in play with a full-faction battlegroup, it is destroyed. This unit cannot be Reanimated. This unit has <ability value=4>Iron Will</ability>. You may only have one Split Hero champions in your battlegroup. This unit counts as a <ability value=802>Hero</ability>.",
      "long_description": "If this unit is in play with a full-faction battlegroup, it is destroyed. This unit cannot be Reanimated. This unit has <ability value=4>Iron Will</ability>. You may only have one Split Hero champions in your battlegroup. This unit counts as a <ability value=802>Hero</ability>.",
      "class_name": "SplitHero",
      "revision": 1
    },
    {
      "asset_id": 4035,
      "resettable": 1,
      "name": "Split Stone Tribe",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 712,
      "activated": 1,
      "icon_name": "aurapositive",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "This cyclops is a member of the Split Stone tribe.",
      "long_description": "This cyclops is a member of the Split Stone tribe.",
      "class_name": "SplitStoneCyclops",
      "revision": 1
    },
    {
      "asset_id": 4072,
      "resettable": 1,
      "name": "Spontaneous Regeneration",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2741,
      "activated": 1,
      "icon_name": "regen",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 14,
      "short_description": "For every 20 damage this champion takes in a single turn, it is healed for 9 HP.",
      "long_description": "For every 20 damage this champion takes in a single turn, it is healed for 9 HP.",
      "class_name": "SpontaneousRegeneration",
      "revision": 1
    },
    {
      "asset_id": 7488,
      "resettable": 0,
      "name": "Sporedrop Mushroom",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3170,
      "activated": 1,
      "icon_name": "spore",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "This relic will turn into a Sporegill",
      "long_description": "This relic will turn into a Sporegill",
      "class_name": "SporedropMushroom",
      "revision": 1
    },
    {
      "asset_id": 5696,
      "resettable": 1,
      "name": "Spur",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2572,
      "activated": 1,
      "icon_name": "spur",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 7,
      "short_description": "This champion has +1 DMG and +1 SPD for each opposing champion within 4 spaces.",
      "long_description": "This champion has +1 DMG and +1 SPD for each opposing champion within 4 spaces.",
      "class_name": "Spur",
      "revision": 1
    },
    {
      "asset_id": 4797,
      "resettable": 1,
      "name": "Stab",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 1533,
      "activated": 1,
      "icon_name": "stab",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "This champion makes a Physical melee attack against target champion.",
      "long_description": "This champion makes a Physical melee attack against target champion.",
      "class_name": "Stab",
      "revision": 1
    },
    {
      "asset_id": 7454,
      "resettable": 0,
      "name": "Stability",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3161,
      "activated": 1,
      "icon_name": "stability",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "This champion's SPD cannot be changed from its base value.",
      "long_description": "This champion's SPD cannot be changed from its base value.",
      "class_name": "Stability",
      "revision": 1
    },
    {
      "asset_id": 5480,
      "resettable": 1,
      "name": "Stall",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2341,
      "activated": 1,
      "icon_name": "debuff",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "Target champion within 5 spaces has -4 SPD for 3 turns. This does not stack.",
      "long_description": "Target champion within 5 spaces has -4 SPD for 3 turns. This does not stack.",
      "class_name": "Stall",
      "revision": 1
    },
    {
      "asset_id": 4244,
      "resettable": 1,
      "name": "Starlight",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 2672,
      "activated": 1,
      "icon_name": "magic",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "This champion makes a Magical attack at RNG 2-5.  If the target is successfully damaged, it also takes an additional 2 damage for each champion with Race: Fairy or <ability value=544>Attack: Magical</ability> within 5 spaces of this champion (the additional damage ignores DEF).",
      "long_description": "This champion makes a Magical attack at RNG 2-5.  If the target is successfully damaged, it also takes an additional 2 damage for each champion with Race: Fairy or <ability value=544>Attack: Magical</ability> within 5 spaces of this champion (the additional damage ignores DEF).",
      "class_name": "Starlight",
      "revision": 1
    },
    {
      "asset_id": 5486,
      "resettable": 1,
      "name": "Starshine",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2345,
      "activated": 1,
      "icon_name": "distract",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 9,
      "short_description": "The closest friendly champion that moves within 5 spaces gains a rank of <ability value=608>Majestic</ability>.",
      "long_description": "The closest friendly champion that moves within 5 spaces gains a rank of <ability value=608>Majestic</ability>.",
      "class_name": "Starshine",
      "revision": 1
    },
    {
      "asset_id": 4988,
      "resettable": 1,
      "name": "Startle",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1870,
      "activated": 1,
      "icon_name": "enrage",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 3,
      "short_description": "This unit becomes <condition value=enraged3>Enraged 3</condition> for 2 turns whenever it loses <condition value=stealthed>Stealthed</condition>.",
      "long_description": "This unit becomes <condition value=enraged3>Enraged 3</condition> for 2 turns whenever it loses <condition value=stealthed>Stealthed</condition>.",
      "class_name": "Startle",
      "revision": 1
    },
    {
      "asset_id": 7168,
      "resettable": 0,
      "name": "Stasis",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3011,
      "activated": 1,
      "icon_name": "crystallize",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -6,
      "short_description": "When this champion comes into play, it is <mechanic value=pacified>Pacified</mechanic> and <mechanic value=immobile>Immobile</mechanic> for 3 turns.  This effect cannot be <mechanic value=cleansed>Cleansed</mechanic>.",
      "long_description": "When this champion comes into play, it is <mechanic value=pacified>Pacified</mechanic> and <mechanic value=immobile>Immobile</mechanic> for 3 turns.  This effect cannot be <mechanic value=cleansed>Cleansed</mechanic>.",
      "class_name": "Stasis",
      "revision": 1
    },
    {
      "asset_id": 5252,
      "resettable": 1,
      "name": "Stat Bonus: Damage",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 2034,
      "activated": 1,
      "icon_name": "plusdamage",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 2,
      "short_description": "This champion has +1 DMG.",
      "long_description": "This champion has +1 DMG.",
      "class_name": "StatBonusDamage",
      "revision": 1
    },
    {
      "asset_id": 5252,
      "resettable": 1,
      "name": "Stat Bonus: Damage",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 2035,
      "activated": 1,
      "icon_name": "plusdamage",
      "comments": "",
      "prerequisite_id": 2034,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 3,
      "short_description": "This champion has +2 DMG.",
      "long_description": "This champion has +2 DMG.",
      "class_name": "StatBonusDamage",
      "revision": 1
    },
    {
      "asset_id": 5252,
      "resettable": 1,
      "name": "Stat Bonus: Damage",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 2139,
      "activated": 1,
      "icon_name": "plusdamage",
      "comments": "",
      "prerequisite_id": 2035,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 4,
      "short_description": "This champion has +3 DMG.",
      "long_description": "This champion has +3 DMG.",
      "class_name": "StatBonusDamage",
      "revision": 1
    },
    {
      "asset_id": 5249,
      "resettable": 1,
      "name": "Stat Bonus: Defense",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 2029,
      "activated": 1,
      "icon_name": "plusdefense",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 3,
      "short_description": "This champion gains +1 DEF.",
      "long_description": "This champion gains +1 DEF.",
      "class_name": "StatBonusDefense",
      "revision": 1
    },
    {
      "asset_id": 5249,
      "resettable": 1,
      "name": "Stat Bonus: Defense",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 2030,
      "activated": 1,
      "icon_name": "plusdefense",
      "comments": "",
      "prerequisite_id": 2029,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 6,
      "short_description": "This champion gains +2 DEF.",
      "long_description": "This champion gains +2 DEF.",
      "class_name": "StatBonusDefense",
      "revision": 1
    },
    {
      "asset_id": 5249,
      "resettable": 1,
      "name": "Stat Bonus: Defense",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 2136,
      "activated": 1,
      "icon_name": "plusdefense",
      "comments": "",
      "prerequisite_id": 2030,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 9,
      "short_description": "This champion gains +3 DEF.",
      "long_description": "This champion gains +3 DEF.",
      "class_name": "StatBonusDefense",
      "revision": 1
    },
    {
      "asset_id": 5251,
      "resettable": 1,
      "name": "Stat Bonus: Health",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 2032,
      "activated": 1,
      "icon_name": "plushealth",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 3,
      "short_description": "This champion has +4 HP.",
      "long_description": "This champion has +4 HP.",
      "class_name": "StatBonusHealth",
      "revision": 1
    },
    {
      "asset_id": 5251,
      "resettable": 1,
      "name": "Stat Bonus: Health",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 2033,
      "activated": 1,
      "icon_name": "plushealth",
      "comments": "",
      "prerequisite_id": 2032,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 5,
      "short_description": "This champion has +6 HP.",
      "long_description": "This champion has +6 HP.",
      "class_name": "StatBonusHealth",
      "revision": 1
    },
    {
      "asset_id": 5251,
      "resettable": 1,
      "name": "Stat Bonus: Health",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 2138,
      "activated": 1,
      "icon_name": "plushealth",
      "comments": "",
      "prerequisite_id": 2033,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 7,
      "short_description": "This champion has +8 HP.",
      "long_description": "This champion has +8 HP.",
      "class_name": "StatBonusHealth",
      "revision": 1
    },
    {
      "asset_id": 5249,
      "resettable": 1,
      "name": "Stat Bonus: Range",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 2710,
      "activated": 1,
      "icon_name": "plusrange",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 8,
      "short_description": "This champion gains +1 MAX RNG.",
      "long_description": "This champion gains +1 MAX RNG.",
      "class_name": "StatBonusRange",
      "revision": 1
    },
    {
      "asset_id": 5250,
      "resettable": 1,
      "name": "Stat Bonus: Speed",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 2031,
      "activated": 1,
      "icon_name": "plusspeed",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 8,
      "short_description": "This champion gains +1 SPD.",
      "long_description": "This champion gains +1 SPD.",
      "class_name": "StatBonusSpeed",
      "revision": 1
    },
    {
      "asset_id": 5250,
      "resettable": 1,
      "name": "Stat Bonus: Speed",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 2137,
      "activated": 1,
      "icon_name": "plusspeed",
      "comments": "",
      "prerequisite_id": 2031,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 16,
      "short_description": "This champion gains +2 SPD.",
      "long_description": "This champion gains +2 SPD.",
      "class_name": "StatBonusSpeed",
      "revision": 1
    },
    {
      "asset_id": 5250,
      "resettable": 1,
      "name": "Stat Bonus: Speed",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 2140,
      "activated": 1,
      "icon_name": "plusspeed",
      "comments": "",
      "prerequisite_id": 2137,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 24,
      "short_description": "This champion gains +3 SPD.",
      "long_description": "This champion gains +3 SPD.",
      "class_name": "StatBonusSpeed",
      "revision": 1
    },
    {
      "asset_id": 4996,
      "resettable": 1,
      "name": "Static Aura",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1877,
      "activated": 1,
      "icon_name": "novaelectric",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 6,
      "short_description": "Whenever an enemy champion moves within 2 spaces of this champion, it takes 2 points of Electricity damage.",
      "long_description": "Whenever an enemy champion moves within 2 spaces of this champion, it takes 2 points of Electricity damage.",
      "class_name": "StaticAura",
      "revision": 1
    },
    {
      "asset_id": 5416,
      "resettable": 1,
      "name": "Static Greeting",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2247,
      "activated": 1,
      "icon_name": "greeting_static",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "When this champion comes into play, all enemy champions become <condition value=shocked>Shocked</condition> for 2 turns\r\n",
      "long_description": "When this champion comes into play, all enemy champions become <condition value=shocked>Shocked</condition> for 2 turns\r\n",
      "class_name": "StaticGreeting",
      "revision": 1
    },
    {
      "asset_id": 7763,
      "resettable": 0,
      "name": "Static Shock",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3289,
      "activated": 1,
      "icon_name": "static_shock",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "When an enemy champion within 5 spaces loses AP, it takes 2 Electricity damage per AP lost, to a maximum of 10.",
      "long_description": "When an enemy champion within 5 spaces loses AP, it takes 2 Electricity damage per AP lost, to a maximum of 10.",
      "class_name": "StaticShock",
      "revision": 1
    },
    {
      "asset_id": 5401,
      "resettable": 1,
      "name": "Stationary",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2233,
      "activated": 1,
      "icon_name": "lumbering",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -10,
      "short_description": "This unit may not spend AP on normal movement. Relocation effects are not affected.",
      "long_description": "This unit may not spend AP on normal movement. Relocation effects are not affected.",
      "class_name": "Stationary",
      "revision": 1
    },
    {
      "asset_id": 5154,
      "resettable": 1,
      "name": "Statue Form",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 1903,
      "activated": 1,
      "icon_name": "transform",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 5,
      "short_description": "This champion becomes <ability value=757>Immobile</ability> and <ability value=669>Earthbound</ability> It gains <ability value=35>Immunity: Physical</ability>, <ability value=117>Regeneration 3</ability>, +3 DEF, -5 DMG and its range is set to 1.",
      "long_description": "This champion becomes <ability value=757>Immobile</ability> and <ability value=669>Earthbound</ability> It gains <ability value=35>Immunity: Physical</ability>, <ability value=117>Regeneration 3</ability>, +3 DEF, -5 DMG and its range is set to 1.",
      "class_name": "StatueForm",
      "revision": 1
    },
    {
      "asset_id": 5837,
      "resettable": 1,
      "name": "Statue of Xulos",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2846,
      "activated": 1,
      "icon_name": "shrine_linked",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 12,
      "short_description": "At the end of each turn, this relic gains 2 MAX HP.  Xulos has +1 DMG and +2 HP for every 10 HP this relic currently has.\r\n",
      "long_description": "At the end of each turn, this relic gains 2 MAX HP.  Xulos has +1 DMG and +2 HP for every 10 HP this relic currently has.\r\n",
      "class_name": "RelicStatueOfXulos",
      "revision": 1
    },
    {
      "asset_id": 4127,
      "resettable": 1,
      "name": "Stealth",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 325,
      "activated": 1,
      "icon_name": "stealth",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 7,
      "short_description": "This unit becomes <condition value=stealthed>Stealthed</condition>.",
      "long_description": "This unit becomes <condition value=stealthed>Stealthed</condition>.",
      "class_name": "Stealth",
      "revision": 1
    },
    {
      "asset_id": 4593,
      "resettable": 1,
      "name": "Still Life",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2799,
      "activated": 1,
      "icon_name": "stealth",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "At the beginning of your opponent's turns, if this champion did not move during your last turn, it becomes <condition value=stealthed>Stealthed</condition> for 5 turns.",
      "long_description": "At the beginning of your opponent's turns, if this champion did not move during your last turn, it becomes <condition value=stealthed>Stealthed</condition> for 5 turns.",
      "class_name": "StillLife",
      "revision": 1
    },
    {
      "asset_id": 5277,
      "resettable": 1,
      "name": "Stitched",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2101,
      "activated": 1,
      "icon_name": "stitched",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 1,
      "short_description": "When this champion is destroyed, a Stitched Remains relic is summoned to the closest available space.",
      "long_description": "When this champion is destroyed, a Stitched Remains relic is summoned to the closest available space.",
      "class_name": "Stitched",
      "revision": 1
    },
    {
      "asset_id": 5528,
      "resettable": 1,
      "name": "Stitched Possessed",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2387,
      "activated": 1,
      "icon_name": "psychic",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "At the beginning of each turn, this champion deals 6 Psychic damage to the friendly champion with greatest HP within 6 spaces.",
      "long_description": "At the beginning of each turn, this champion deals 6 Psychic damage to the friendly champion with greatest HP within 6 spaces.",
      "class_name": "StitchedPossessed",
      "revision": 1
    },
    {
      "asset_id": 5503,
      "resettable": 1,
      "name": "Stitched Reconstitution",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 2788,
      "activated": 1,
      "icon_name": "reconstitute",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "Destroy target Stitched Remains within 3 spaces. This champion gains 3 AP, is healed for 8 HP and gains a Stitchling Rider (to a maximum of 4).",
      "long_description": "Destroy target Stitched Remains within 3 spaces. This champion gains 3 AP, is healed for 8 HP and gains a Stitchling Rider (to a maximum of 4).",
      "class_name": "StitchedReconstitution",
      "revision": 1
    },
    {
      "asset_id": 5314,
      "resettable": 1,
      "name": "Stitched Remains",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2144,
      "activated": 1,
      "icon_name": "reconstitute",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "This is the remains of a Stitched. This relic drops a Nora Globe worth 10 Nora when it is destroyed.",
      "long_description": "This is the remains of a Stitched. This relic drops a Nora Globe worth 10 Nora when it is destroyed.",
      "class_name": "StitchedRemains",
      "revision": 1
    },
    {
      "asset_id": 5798,
      "resettable": 1,
      "name": "Stitched Symbiosis",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2787,
      "activated": 1,
      "icon_name": "stitched",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 3,
      "ranked": 0,
      "cost": 15,
      "short_description": "This champion comes into play with 2 Stitchling Riders.  At the beginning of your turn, this unit heals 3 HP as long as it has at least 1 Stitched Rider on it.  When this champion is successfully attacked by a basic attack, it loses a stack of Stitchling Riders and a Symbiotic Stitchling with no upgrades is summoned adjacent to the attacking champion.",
      "long_description": "This champion comes into play with 2 Stitchling Riders.  At the beginning of your turn, this unit heals 3 HP as long as it has at least 1 Stitched Rider on it.  When this champion is successfully attacked by a basic attack, it loses a stack of Stitchling Riders and a Symbiotic Stitchling with no upgrades is summoned adjacent to the attacking champion.",
      "class_name": "StitchedSymbiosis",
      "revision": 1
    },
    {
      "asset_id": 5789,
      "resettable": 1,
      "name": "Stone Barrage",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 2764,
      "activated": 1,
      "icon_name": "physicalaoe",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "3 random opposing champions within 5 spaces take 9 physical damage (reduced by 3 per trigger against the same champion). This damage ignores DEF.",
      "long_description": "3 random opposing champions within 5 spaces take 9 physical damage (reduced by 3 per trigger against the same champion). This damage ignores DEF.",
      "class_name": "StoneBarrage",
      "revision": 1
    },
    {
      "asset_id": 4429,
      "resettable": 1,
      "name": "Stone Bomb",
      "ap_cost": 1,
      "level": 1,
      "ability_id": 768,
      "activated": 1,
      "icon_name": "physicalaoe",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 6,
      "short_description": "Area Effect 2, Range 5:  Affected units take Physical damage equal to 50% of this unit's DMG. This damage ignores DEF. Champions successfully damaged are knocked back 1 space.",
      "long_description": "Area Effect 2, Range 5:  Affected units take Physical damage equal to 50% of this unit's DMG. This damage ignores DEF. Champions successfully damaged are knocked back 1 space.",
      "class_name": "StoneBomb",
      "revision": 1
    },
    {
      "asset_id": 4429,
      "resettable": 1,
      "name": "Stone Bomb",
      "ap_cost": 1,
      "level": 2,
      "ability_id": 769,
      "activated": 1,
      "icon_name": "physicalaoe",
      "comments": "",
      "prerequisite_id": 768,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 8,
      "short_description": "Area Effect 2, Range 5:  Affected units take Physical damage equal to 65% of this unit's DMG. This damage ignores DEF. Champions successfully damaged are knocked back 1 space.",
      "long_description": "Area Effect 2, Range 5:  Affected units take Physical damage equal to 65% of this unit's DMG. This damage ignores DEF. Champions successfully damaged are knocked back 1 space.",
      "class_name": "StoneBomb",
      "revision": 1
    },
    {
      "asset_id": 4429,
      "resettable": 1,
      "name": "Stone Bomb",
      "ap_cost": 1,
      "level": 3,
      "ability_id": 770,
      "activated": 1,
      "icon_name": "physicalaoe",
      "comments": "",
      "prerequisite_id": 769,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 10,
      "short_description": "Area Effect 2, Range 5:  Affected units take Physical damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged are knocked back 1 space.",
      "long_description": "Area Effect 2, Range 5:  Affected units take Physical damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged are knocked back 1 space.",
      "class_name": "StoneBomb",
      "revision": 1
    },
    {
      "asset_id": 5802,
      "resettable": 1,
      "name": "Stone Shield",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2811,
      "activated": 1,
      "icon_name": "defenseenhance",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "This champion has <ability value=1902>Tough 3</ability> when <ability value=2764>Stone Barrage</ability> is not on CD.",
      "long_description": "This champion has <ability value=1902>Tough 3</ability> when <ability value=2764>Stone Barrage</ability> is not on CD.",
      "class_name": "StoneShield",
      "revision": 1
    },
    {
      "asset_id": 5027,
      "resettable": 1,
      "name": "Storm Acolyte",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1909,
      "activated": 1,
      "icon_name": "acolyte_storm",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "Whenever a champion takes Electricity damage, this champion heals 2 HP.  This triggers up to 3 times per turn and does not include damage from <condition value=shocked popup=false>Shocked</condition>.\r\n",
      "long_description": "Whenever a champion takes Electricity damage, this champion heals 2 HP.  This triggers up to 3 times per turn and does not include damage from <condition value=shocked popup=false>Shocked</condition>.\r\n",
      "class_name": "StormAcolyte",
      "revision": 1
    },
    {
      "asset_id": 7267,
      "resettable": 0,
      "name": "Storm Field",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 3069,
      "activated": 1,
      "icon_name": "terrainstorm",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "Area Effect 2, Range 5: Affected spaces becomes Storm Field (5 Electricity damage per square upon entry) for 4 turns.",
      "long_description": "Area Effect 2, Range 5: Affected spaces becomes Storm Field (5 Electricity damage per square upon entry) for 4 turns.",
      "class_name": "StormField",
      "revision": 1
    },
    {
      "asset_id": 7562,
      "resettable": 0,
      "name": "Stormreader",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3210,
      "activated": 1,
      "icon_name": "stormreader",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 30,
      "short_description": "The first time each turn an enemy champion within 5 spaces takes Electricity damage, this champion deals 6 Electricity damage to that champion (ignores DEF). The same champion cannot be damaged by multiple copies of this ability in the same turn.",
      "long_description": "The first time each turn an enemy champion within 5 spaces takes Electricity damage, this champion deals 6 Electricity damage to that champion (ignores DEF). The same champion cannot be damaged by multiple copies of this ability in the same turn.",
      "class_name": "Stormreader",
      "revision": 1
    },
    {
      "asset_id": 7546,
      "resettable": 0,
      "name": "Stormseeker",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 3200,
      "activated": 1,
      "icon_name": "relocate_lightning",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "This champion is relocated adjacent to target champion within 5 spaces with <condition value=shocked>Shocked</condition>, <condition value=paralyzed>Paralyzed</condition> or <condition value=distracted>Distracted</condition> and gains +2 SPD for 3 turns.",
      "long_description": "This champion is relocated adjacent to target champion within 5 spaces with <condition value=shocked>Shocked</condition>, <condition value=paralyzed>Paralyzed</condition> or <condition value=distracted>Distracted</condition> and gains +2 SPD for 3 turns.",
      "class_name": "Stormseeker",
      "revision": 1
    },
    {
      "asset_id": 4823,
      "resettable": 1,
      "name": "Strafing Strike",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2746,
      "activated": 1,
      "icon_name": "allybuffs",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this champion makes a successful basic attack, it gains Leap 3 for 3 turns.",
      "long_description": "When this champion makes a successful basic attack, it gains Leap 3 for 3 turns.",
      "class_name": "StrafingStrike",
      "revision": 1
    },
    {
      "asset_id": 5403,
      "resettable": 1,
      "name": "Strength of Body",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2235,
      "activated": 1,
      "icon_name": "buff",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "This champion's has +DMG equal to its HP divided by 5 (rounded down).",
      "long_description": "This champion's has +DMG equal to its HP divided by 5 (rounded down).",
      "class_name": "StrengthofBody",
      "revision": 1
    },
    {
      "asset_id": 5840,
      "resettable": 1,
      "name": "Strengthening Draught",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2849,
      "activated": 1,
      "icon_name": "icon_strengthening_draught",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "AE2: Unit gain Tough 2 for 6 turns.",
      "long_description": "AE2: Unit gain Tough 2 for 6 turns.",
      "class_name": "StrengtheningDraught",
      "revision": 1
    },
    {
      "asset_id": 4762,
      "resettable": 1,
      "name": "Strike",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1486,
      "activated": 1,
      "icon_name": "defpenalties",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "This champion's attacks ignore DEF if the target's DEF is greater than 0.",
      "long_description": "This champion's attacks ignore DEF if the target's DEF is greater than 0.",
      "class_name": "Strike",
      "revision": 1
    },
    {
      "asset_id": 4512,
      "resettable": 1,
      "name": "Stronghold",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1421,
      "activated": 1,
      "icon_name": "knockback",
      "comments": "For the stronghold spell (this ability has no AP cost)",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "All non-flying champions within 5 spaces take 10 damage and are knocked back one space",
      "long_description": "All non-flying champions within 5 spaces take 10 damage and are knocked back one space",
      "class_name": "StrongholdAbility",
      "revision": 1
    },
    {
      "asset_id": 4152,
      "resettable": 1,
      "name": "Stun",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 410,
      "activated": 1,
      "icon_name": "stun",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "This champion makes an attack at 8 DMG.  If successful, the target becomes <condition value=stunned>Stunned</condition> for 2 turns.",
      "long_description": "This champion makes an attack at 8 DMG.  If successful, the target becomes <condition value=stunned>Stunned</condition> for 2 turns.",
      "class_name": "Stun",
      "revision": 1
    },
    {
      "asset_id": 5623,
      "resettable": 1,
      "name": "Stunning",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2487,
      "activated": 1,
      "icon_name": "stunning",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 17,
      "short_description": "The first time this champion is successfully attacked each turn, the attacking champion becomes <condition value=stunned>Stunned</condition> for 3 turns.",
      "long_description": "The first time this champion is successfully attacked each turn, the attacking champion becomes <condition value=stunned>Stunned</condition> for 3 turns.",
      "class_name": "Stunning",
      "revision": 1
    },
    {
      "asset_id": 5353,
      "resettable": 1,
      "name": "Stunning Wail",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2185,
      "activated": 1,
      "icon_name": "stunning",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "Spend 8 Charges. Opposing champions within 6 spaces become <condition value=stunned>Stunned</condition> for 2 turns and this champion loses all remaining charges.",
      "long_description": "Spend 8 Charges. Opposing champions within 6 spaces become <condition value=stunned>Stunned</condition> for 2 turns and this champion loses all remaining charges.",
      "class_name": "StunningWail",
      "revision": 1
    },
    {
      "asset_id": 5886,
      "resettable": 1,
      "name": "Submission Hold",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 2895,
      "activated": 1,
      "icon_name": "submission_hold",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "This champion makes a melee attack against opposing <condition value=stationary>Stationary</condition> champion. If successful, the target takes 50% damage and becomes <condition value=pacified>Pacified</condition> for 2 turns..",
      "long_description": "This champion makes a melee attack against opposing <condition value=stationary>Stationary</condition> champion. If successful, the target takes 50% damage and becomes <condition value=pacified>Pacified</condition> for 2 turns..",
      "class_name": "SubmissionHold",
      "revision": 1
    },
    {
      "asset_id": 5145,
      "resettable": 1,
      "name": "Subsume",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1783,
      "activated": 1,
      "icon_name": "blessed",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this unit is the target of an opponent's spell or abilities (excluding basic attacks), it is healed for 10 HP.",
      "long_description": "When this unit is the target of an opponent's spell or abilities (excluding basic attacks), it is healed for 10 HP.",
      "class_name": "Subsume",
      "revision": 1
    },
    {
      "asset_id": 4330,
      "resettable": 1,
      "name": "Summon Axe",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 1358,
      "activated": 1,
      "icon_name": "whirl",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Axeman's Fate equipment is removed from the nearest champion equipped with it and is then equipped to this unit. If this unit is already equipped, the currently equipped equipment is destroyed.",
      "long_description": "Axeman's Fate equipment is removed from the nearest champion equipped with it and is then equipped to this unit. If this unit is already equipped, the currently equipped equipment is destroyed.",
      "class_name": "SummonAxe",
      "revision": 1
    },
    {
      "asset_id": 5596,
      "resettable": 1,
      "name": "Summon: Archery Bale",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2565,
      "activated": 1,
      "icon_name": "deploy",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 15,
      "short_description": "Summon an Archery Bale relic with <ability value=2495>Archery Bale</ability> to target adjacent space.",
      "long_description": "Summon an Archery Bale relic with <ability value=2495>Archery Bale</ability> to target adjacent space.",
      "class_name": "SummonArcheryBale",
      "revision": 1
    },
    {
      "asset_id": 5183,
      "resettable": 1,
      "name": "Summon: Artillery Marker",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2755,
      "activated": 1,
      "icon_name": "deploy",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 20,
      "short_description": "Summon an Artillery Marker relic with <ability value=2151>Artillery Marker</ability> to target adjacent space.",
      "long_description": "Summon an Artillery Marker relic with <ability value=2151>Artillery Marker</ability> to target adjacent space.",
      "class_name": "SummonArtilleryMarker",
      "revision": 1
    },
    {
      "asset_id": 4158,
      "resettable": 1,
      "name": "Summon: Beast",
      "ap_cost": 4,
      "level": 1,
      "ability_id": 434,
      "activated": 1,
      "icon_name": "sumbeast",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 1,
      "cost": 3,
      "short_description": "A Beast champion is summoned to target adjacent space, under your control (0 DEF, 4 SPD, 1 RNG, 6 DMG, 9 HP, Attack - Physical, Detection 1).",
      "long_description": "A Beast champion is summoned to target adjacent space, under your control (0 DEF, 4 SPD, 1 RNG, 6 DMG, 9 HP, Attack - Physical, Detection 1).",
      "class_name": "SummonBeast",
      "revision": 1
    },
    {
      "asset_id": 4158,
      "resettable": 1,
      "name": "Summon: Beast",
      "ap_cost": 4,
      "level": 2,
      "ability_id": 435,
      "activated": 1,
      "icon_name": "sumbeast",
      "comments": "none",
      "prerequisite_id": 434,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 1,
      "cost": 5,
      "short_description": "A Beast champion is summoned to target adjacent space, under your control (0 DEF, 5 SPD, 1 RNG , 8 DMG, 12 HP, Attack - Physical, Detection 2).",
      "long_description": "A Beast champion is summoned to target adjacent space, under your control (0 DEF, 5 SPD, 1 RNG , 8 DMG, 12 HP, Attack - Physical, Detection 2).",
      "class_name": "SummonBeast",
      "revision": 1
    },
    {
      "asset_id": 4158,
      "resettable": 1,
      "name": "Summon: Beast",
      "ap_cost": 4,
      "level": 3,
      "ability_id": 436,
      "activated": 1,
      "icon_name": "sumbeast",
      "comments": "none",
      "prerequisite_id": 435,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 1,
      "cost": 7,
      "short_description": "A Beast champion is summoned to target adjacent space, under your control (0 DEF, 6 SPD, 1 RNG, 10 DMG, 15 HP, Attack - Physical, Detection 3).",
      "long_description": "A Beast champion is summoned to target adjacent space, under your control (0 DEF, 6 SPD, 1 RNG, 10 DMG, 15 HP, Attack - Physical, Detection 3).",
      "class_name": "SummonBeast",
      "revision": 1
    },
    {
      "asset_id": 5557,
      "resettable": 1,
      "name": "Summon: Boghopper Tad",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 2417,
      "activated": 1,
      "icon_name": "summon_tad",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "Summon a Boghopper Tad with no upgrades to a target adjacent space.",
      "long_description": "Summon a Boghopper Tad with no upgrades to a target adjacent space.",
      "class_name": "SummonBoghopperTad",
      "revision": 1
    },
    {
      "asset_id": 5543,
      "resettable": 0,
      "name": "Summon: Boghopper Zombie",
      "ap_cost": 4,
      "level": 2,
      "ability_id": 2934,
      "activated": 1,
      "icon_name": "sumskel",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 7,
      "short_description": "Summon a Boghopper Zombie with <ability value=518>Leap 3</ability> and <ability value=877>Bodyguard</ability> to target, within 3 spaces. Spooky!",
      "long_description": "Summon a Boghopper Zombie with <ability value=518>Leap 3</ability> and <ability value=877>Bodyguard</ability> to target, within 3 spaces. Spooky!",
      "class_name": "SummonBoghopperZombie",
      "revision": 1
    },
    {
      "asset_id": 5543,
      "resettable": 0,
      "name": "Summon: Boghopper Zombie",
      "ap_cost": 4,
      "level": 3,
      "ability_id": 2935,
      "activated": 1,
      "icon_name": "sumskel",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "Summon a Boghopper Zombie with <ability value=518>Leap 3</ability> and <ability value=877>Bodyguard</ability> to target, within 4 spaces. Spooky!",
      "long_description": "Summon a Boghopper Zombie with <ability value=518>Leap 3</ability> and <ability value=877>Bodyguard</ability> to target, within 4 spaces. Spooky!",
      "class_name": "SummonBoghopperZombie",
      "revision": 1
    },
    {
      "asset_id": 5543,
      "resettable": 1,
      "name": "Summon: Boghopper Zombie",
      "ap_cost": 4,
      "level": 1,
      "ability_id": 2402,
      "activated": 1,
      "icon_name": "sumskel",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "Summon a Boghopper Zombie with <ability value=518>Leap 3</ability> and <ability value=877>Bodyguard</ability> to target, within 2 spaces. Spooky!",
      "long_description": "Summon a Boghopper Zombie with <ability value=518>Leap 3</ability> and <ability value=877>Bodyguard</ability> to target, within 2 spaces. Spooky!",
      "class_name": "SummonBoghopperZombie",
      "revision": 1
    },
    {
      "asset_id": 5183,
      "resettable": 1,
      "name": "Summon: Bone Trap",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2781,
      "activated": 1,
      "icon_name": "deploy",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "Summon an Bone Trap relic with <ability value=601>Shadowspawn</ability> and <ability value=2776>Bone Trap</ability> to target adjacent space. This ability does not break stealth",
      "long_description": "Summon an Bone Trap relic with <ability value=601>Shadowspawn</ability> and <ability value=2776>Bone Trap</ability> to target adjacent space. This ability does not break stealth",
      "class_name": "SummonBoneTrap",
      "revision": 1
    },
    {
      "asset_id": 5311,
      "resettable": 1,
      "name": "Summon: Crested Fesh",
      "ap_cost": 5,
      "level": 0,
      "ability_id": 2133,
      "activated": 1,
      "icon_name": "sumfesh",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 20,
      "short_description": "Summon a Crested Fesh with no upgrades to target adjacent space.",
      "long_description": "Summon a Crested Fesh with no upgrades to target adjacent space.",
      "class_name": "SummonFesh",
      "revision": 1
    },
    {
      "asset_id": 5183,
      "resettable": 1,
      "name": "Summon: Dimension Door",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2709,
      "activated": 1,
      "icon_name": "deploy",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 15,
      "short_description": "Summon a Dimension Door relic with <ability value=2698>Dimension Door</ability> to target adjacent space.",
      "long_description": "Summon a Dimension Door relic with <ability value=2698>Dimension Door</ability> to target adjacent space.",
      "class_name": "SummonDimensionDoor",
      "revision": 1
    },
    {
      "asset_id": 4839,
      "resettable": 1,
      "name": "Summon: Dragon",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 1721,
      "activated": 1,
      "icon_name": "sumdragon",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "Summon a Dragon Homunculus on an adjacent space.",
      "long_description": "Summon a Dragon Homunculus on an adjacent space.",
      "class_name": "SummonDragon",
      "revision": 1
    },
    {
      "asset_id": 4839,
      "resettable": 1,
      "name": "Summon: Dragon (Relic)",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2403,
      "activated": 1,
      "icon_name": "sumdragon",
      "comments": "x",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 12,
      "short_description": "Summon a Dragon Homunculus on an adjacent space. This unit loses 5 HP.",
      "long_description": "Summon a Dragon Homunculus on an adjacent space. This unit loses 5 HP.",
      "class_name": "RelicSummonDragon",
      "revision": 1
    },
    {
      "asset_id": 7166,
      "resettable": 0,
      "name": "Summon: Dreamblossom",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 3009,
      "activated": 1,
      "icon_name": "deploy",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "Summon a Dreamblossom relic with <ability value=2978>Dreamblossom</ability> and <ability value=3028>Demolish</ability> to target adjacent space.",
      "long_description": "Summon a Dreamblossom relic with <ability value=2978>Dreamblossom</ability> and <ability value=3028>Demolish</ability> to target adjacent space.",
      "class_name": "SummonDreamblossom",
      "revision": 1
    },
    {
      "asset_id": 7478,
      "resettable": 1,
      "name": "Summon: Electric Fireflies",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 2558,
      "activated": 1,
      "icon_name": "sumelectric_firefly",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 15,
      "short_description": "Summon 2 Electric Fireflies to adjacent spaces.",
      "long_description": "Summon 2 Electric Fireflies to adjacent spaces.",
      "class_name": "SummonElectricFireflies",
      "revision": 1
    },
    {
      "asset_id": 5619,
      "resettable": 1,
      "name": "Summon: Festering Corpse",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 2586,
      "activated": 1,
      "icon_name": "sum_festering_corpse",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 15,
      "short_description": "Summon a Festering Corpse with no upgrades and 75% HP to target adjacent space.",
      "long_description": "Summon a Festering Corpse with no upgrades and 75% HP to target adjacent space.",
      "class_name": "SummonFesteringCorpse",
      "revision": 1
    },
    {
      "asset_id": 5873,
      "resettable": 1,
      "name": "Summon: Flash Bang",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2882,
      "activated": 1,
      "icon_name": "deploy",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 15,
      "short_description": "Summon a Flash Bang relic with <ability value=601>Shadowspawn</ability> and <ability value=2844>Flash Bang</ability> to target adjacent space. This ability does not break stealth",
      "long_description": "Summon a Flash Bang relic with <ability value=601>Shadowspawn</ability> and <ability value=2844>Flash Bang</ability> to target adjacent space. This ability does not break stealth",
      "class_name": "SummonFlashBang",
      "revision": 1
    },
    {
      "asset_id": 5384,
      "resettable": 1,
      "name": "Summon: Furbull Litter",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 2218,
      "activated": 1,
      "icon_name": "sum_furbulbaby",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 6,
      "activation_type": 0,
      "ranked": 0,
      "cost": 50,
      "short_description": "Summon 2 Baby Furbulls without upgrades to adjacent spaces.",
      "long_description": "Summon 2 Baby Furbulls without upgrades to adjacent spaces.",
      "class_name": "SummonBabyFurbull",
      "revision": 1
    },
    {
      "asset_id": 5596,
      "resettable": 1,
      "name": "Summon: Gatling Gun",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2590,
      "activated": 1,
      "icon_name": "deploy",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 15,
      "short_description": "Summon a Gatling Gun relic with <ability value=2602>Misfire</ability> to target adjacent space.",
      "long_description": "Summon a Gatling Gun relic with <ability value=2602>Misfire</ability> to target adjacent space.",
      "class_name": "SummonGaltingGun",
      "revision": 1
    },
    {
      "asset_id": 7498,
      "resettable": 0,
      "name": "Summon: Guardian's Treasure",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 3177,
      "activated": 1,
      "icon_name": "deploy",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 15,
      "short_description": "Summon a Guardian's Treasure relic (0 DEF, 20 HP, <ability value=3179>Guardian's Treasure</ability>, <ability value=1336>Fascinate</ability>, <ability value=608>Majestic 1</ability>) to target adjacent space.",
      "long_description": "Summon a Guardian's Treasure relic (0 DEF, 20 HP, <ability value=3179>Guardian's Treasure</ability>, <ability value=1336>Fascinate</ability>, <ability value=608>Majestic 1</ability>) to target adjacent space.",
      "class_name": "SummonGuardiansTreasure",
      "revision": 1
    },
    {
      "asset_id": 5187,
      "resettable": 1,
      "name": "Summon: Hive",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 1964,
      "activated": 1,
      "icon_name": "plant_hive",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 15,
      "short_description": "Summon a Hive relic with <ability value=2017>Hive</ability> to target adjacent space.",
      "long_description": "Summon a Hive relic with <ability value=2017>Hive</ability> to target adjacent space.",
      "class_name": "PlantHive",
      "revision": 1
    },
    {
      "asset_id": 5444,
      "resettable": 1,
      "name": "Summon: Land Mine",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2296,
      "activated": 1,
      "icon_name": "landmine",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 15,
      "short_description": "Summon a Land Mine relic with <ability value=601>Shadowspawn</ability> and <ability value=2149>Land Mine</ability> to target adjacent space.  This ability is hidden.",
      "long_description": "Summon a Land Mine relic with <ability value=601>Shadowspawn</ability> and <ability value=2149>Land Mine</ability> to target adjacent space.  This ability is hidden.",
      "class_name": "SummonLandMine",
      "revision": 1
    },
    {
      "asset_id": 5911,
      "resettable": 0,
      "name": "Summon: Long Fuse Bomb",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 2945,
      "activated": 1,
      "icon_name": "cannon_barrage",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 15,
      "short_description": "Summon a Long Fuse Bomb relic with <ability value=2946>Long Fuse Bomb</ability>, <ability value=1056>Impregnable</ability> and <ability value=2260>Pariah</ability> to target space within 4 spaces.",
      "long_description": "Summon a Long Fuse Bomb relic with <ability value=2946>Long Fuse Bomb</ability>, <ability value=1056>Impregnable</ability> and <ability value=2260>Pariah</ability> to target space within 4 spaces.",
      "class_name": "SummonLongFuseBomb",
      "revision": 1
    },
    {
      "asset_id": 5500,
      "resettable": 1,
      "name": "Summon: Mechanical Crabs",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 2359,
      "activated": 1,
      "icon_name": "summon_mechcrab",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "Summons a Mechanical Crabs champion with no upgrades to target adjacent space.",
      "long_description": "Summons a Mechanical Crabs champion with no upgrades to target adjacent space.",
      "class_name": "SummonMechanicalCrabs",
      "revision": 1
    },
    {
      "asset_id": 4042,
      "resettable": 1,
      "name": "Summon: Moga",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 660,
      "activated": 1,
      "icon_name": "summoga",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 7,
      "short_description": "Summon a Moga Pup on target adjacent space.",
      "long_description": "Summon a Moga Pup on target adjacent space.",
      "class_name": "SpawnMoga",
      "revision": 1
    },
    {
      "asset_id": 7360,
      "resettable": 0,
      "name": "Summon: Path of De'lim",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 3117,
      "activated": 1,
      "icon_name": "deploy",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 7,
      "short_description": "Summon a Path of De'lim relic with <ability value=3115>Path of De'lim</ability> to target adjacent space.",
      "long_description": "Summon a Path of De'lim relic with <ability value=3115>Path of De'lim</ability> to target adjacent space.",
      "class_name": "SummonPathOfDelim",
      "revision": 1
    },
    {
      "asset_id": 5596,
      "resettable": 1,
      "name": "Summon: Prismatic Crystals",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2456,
      "activated": 1,
      "icon_name": "deploy",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "Summon a Prismatic Crystals relic with <ability value=531>Prismatic Crystals</ability> to target adjacent space.",
      "long_description": "Summon a Prismatic Crystals relic with <ability value=531>Prismatic Crystals</ability> to target adjacent space.",
      "class_name": "SummonPrismaticCrystals",
      "revision": 1
    },
    {
      "asset_id": 5183,
      "resettable": 1,
      "name": "Summon: Rock Trap",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2711,
      "activated": 1,
      "icon_name": "deploy",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 15,
      "short_description": "Summon a Rock Trap relic with <ability value=601>Shadowspawn</ability> and <ability value=1029>Rock Trap</ability> to target adjacent space. This ability does not break stealth",
      "long_description": "Summon a Rock Trap relic with <ability value=601>Shadowspawn</ability> and <ability value=1029>Rock Trap</ability> to target adjacent space. This ability does not break stealth",
      "class_name": "SummonRockTrap",
      "revision": 1
    },
    {
      "asset_id": 4586,
      "resettable": 1,
      "name": "Summon: Serpent",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 1004,
      "activated": 1,
      "icon_name": "sumsnake",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 15,
      "short_description": "Randomly summon a Poison Serpent with 0 DEF, 6 SPD, 9 DMG, HP of 15, RNG 1 and <ability value=168>Poison 2</ability> or a Constrictor Serpent with 0 DEF, 5 SPD, 7 DMG, HP of 25, RNG 1 and <ability value=324>Constriction</ability> to target adjacent space.",
      "long_description": "Randomly summon a Poison Serpent with 0 DEF, 6 SPD, 9 DMG, HP of 15, RNG 1 and <ability value=168>Poison 2</ability> or a Constrictor Serpent with 0 DEF, 5 SPD, 7 DMG, HP of 25, RNG 1 and <ability value=324>Constriction</ability> to target adjacent space.",
      "class_name": "SummonSerpent",
      "revision": 1
    },
    {
      "asset_id": 4157,
      "resettable": 1,
      "name": "Summon: Skeleton",
      "ap_cost": 4,
      "level": 1,
      "ability_id": 430,
      "activated": 1,
      "icon_name": "sumskel",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 1,
      "cost": 4,
      "short_description": "An Undead Skeleton Warrior champion is summoned to target adjacent space, under your control (0 DEF, 4 SPD, 1 RNG, 5 DMG, 9 HP, <ability value=545>Attack: Physical</ability>).",
      "long_description": "An Undead Skeleton Warrior champion is summoned to target adjacent space, under your control (0 DEF, 4 SPD, 1 RNG, 5 DMG, 9 HP, <ability value=545>Attack: Physical</ability>).",
      "class_name": "SummonUndead",
      "revision": 1
    },
    {
      "asset_id": 4157,
      "resettable": 1,
      "name": "Summon: Skeleton",
      "ap_cost": 4,
      "level": 2,
      "ability_id": 431,
      "activated": 1,
      "icon_name": "sumskel",
      "comments": "none",
      "prerequisite_id": 430,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 1,
      "cost": 7,
      "short_description": "An Undead Skeleton Warrior champion is summoned to target adjacent space, under your control (0 DEF, 6 SPD, 1 RNG, 7 DMG, 12 HP, <ability value=545>Attack: Physical</ability>).",
      "long_description": "An Undead Skeleton Warrior champion is summoned to target adjacent space, under your control (0 DEF, 6 SPD, 1 RNG, 7 DMG, 12 HP, <ability value=545>Attack: Physical</ability>).",
      "class_name": "SummonUndead",
      "revision": 1
    },
    {
      "asset_id": 4157,
      "resettable": 1,
      "name": "Summon: Skeleton",
      "ap_cost": 4,
      "level": 3,
      "ability_id": 432,
      "activated": 1,
      "icon_name": "sumskel",
      "comments": "none",
      "prerequisite_id": 431,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 1,
      "cost": 10,
      "short_description": "An Undead Skeleton Warrior champion is summoned to target adjacent space, under your control (0 DEF, 7 SPD, 1 RNG, 9 DMG, 15 HP, <ability value=545>Attack: Physical</ability>).",
      "long_description": "An Undead Skeleton Warrior champion is summoned to target adjacent space, under your control (0 DEF, 7 SPD, 1 RNG, 9 DMG, 15 HP, <ability value=545>Attack: Physical</ability>).",
      "class_name": "SummonUndead",
      "revision": 1
    },
    {
      "asset_id": 5183,
      "resettable": 1,
      "name": "Summon: Snow Trap",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1960,
      "activated": 1,
      "icon_name": "trapfrost",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "Summon a Snow Trap relic with <ability value=600>Arctic</ability>, <ability value=601>Shadowspawn</ability> and <ability value=1025>Arctic Trap</ability> to target adjacent space. This ability does not break stealth",
      "long_description": "Summon a Snow Trap relic with <ability value=600>Arctic</ability>, <ability value=601>Shadowspawn</ability> and <ability value=1025>Arctic Trap</ability> to target adjacent space. This ability does not break stealth",
      "class_name": "SummonSnowTrap",
      "revision": 1
    },
    {
      "asset_id": 5490,
      "resettable": 1,
      "name": "Summon: Snowcat",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 2349,
      "activated": 1,
      "icon_name": "sumsnowcat",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 7,
      "short_description": "Summon a Snowcat with no upgrades to target adjacent space.",
      "long_description": "Summon a Snowcat with no upgrades to target adjacent space.",
      "class_name": "SummonSnowcat",
      "revision": 1
    },
    {
      "asset_id": 4976,
      "resettable": 1,
      "name": "Summon: Spiderling",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 1858,
      "activated": 1,
      "icon_name": "sumspider",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 7,
      "short_description": "Summon a Spiderling champion with no upgrades to target adjacent space.",
      "long_description": "Summon a Spiderling champion with no upgrades to target adjacent space.",
      "class_name": "SpawnSpiderling",
      "revision": 1
    },
    {
      "asset_id": 5449,
      "resettable": 1,
      "name": "Summon: Tortalleon",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 2301,
      "activated": 1,
      "icon_name": "chrg_summ_tortalleon",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 40,
      "short_description": "Spend 8 Charges.  This unit becomes <condition value=immobile>Immobile</condition> for 2 turns.  At the beginning of its next turn, a Tortalleon Pygmy without upgrades is summoned to an adjacent space.",
      "long_description": "Spend 8 Charges.  This unit becomes <condition value=immobile>Immobile</condition> for 2 turns.  At the beginning of its next turn, a Tortalleon Pygmy without upgrades is summoned to an adjacent space.",
      "class_name": "ChargedSummonTortalleon",
      "revision": 1
    },
    {
      "asset_id": 7577,
      "resettable": 0,
      "name": "Summon: Watershed Anchor",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 3218,
      "activated": 1,
      "icon_name": "deploy",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 18,
      "short_description": "Summon a Watershed Anchor relic with <ability value=3185>Anchoring Force</ability> to target adjacent space.",
      "long_description": "Summon a Watershed Anchor relic with <ability value=3185>Anchoring Force</ability> to target adjacent space.",
      "class_name": "SummonWatershedAnchor",
      "revision": 1
    },
    {
      "asset_id": 4282,
      "resettable": 1,
      "name": "Summon: Young Bat",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 686,
      "activated": 1,
      "icon_name": "sumbat",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 1,
      "cost": 10,
      "short_description": "A Young Bat with no upgrades is summoned on to target adjacent space.",
      "long_description": "A Young Bat with no upgrades is summoned on to target adjacent space.",
      "class_name": "SummonBat",
      "revision": 1
    },
    {
      "asset_id": 4499,
      "resettable": 1,
      "name": "Summon: Young Imp",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 903,
      "activated": 1,
      "icon_name": "sumimp",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 1,
      "cost": 11,
      "short_description": "Summon a Young Imp with no upgrades to target adjacent space.",
      "long_description": "Summon a Young Imp with no upgrades to target adjacent space.",
      "class_name": "SummonImp",
      "revision": 1
    },
    {
      "asset_id": 7477,
      "resettable": 1,
      "name": "Summon: Young Piledriver",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 2483,
      "activated": 1,
      "icon_name": "summon_groble",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 35,
      "short_description": "Summon a Young Piledriver with no upgrades to target adjacent space.",
      "long_description": "Summon a Young Piledriver with no upgrades to target adjacent space.",
      "class_name": "SummonGroble",
      "revision": 1
    },
    {
      "asset_id": 4763,
      "resettable": 1,
      "name": "Summon: Young Sapling",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 1487,
      "activated": 1,
      "icon_name": "sumtree",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "Summon a Young Sapling with no upgrades to target adjacent space.",
      "long_description": "Summon a Young Sapling with no upgrades to target adjacent space.",
      "class_name": "SummonTreespirit",
      "revision": 1
    },
    {
      "asset_id": 4132,
      "resettable": 1,
      "name": "Sunder",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 330,
      "activated": 1,
      "icon_name": "debuff",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 8,
      "short_description": "When this champion makes a successful basic attack against a champion, the target gains 2 stacks of <condition value=sundered>Sundered</condition> for 3 turns. ",
      "long_description": "When this champion makes a successful basic attack against a champion, the target gains 2 stacks of <condition value=sundered>Sundered</condition> for 3 turns. ",
      "class_name": "Sunder",
      "revision": 1
    },
    {
      "asset_id": 4132,
      "resettable": 1,
      "name": "Sunder",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 332,
      "activated": 1,
      "icon_name": "debuff",
      "comments": "none",
      "prerequisite_id": 331,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 5,
      "short_description": "When this champion makes a successful basic attack against a champion, the target becomes <condition value=sundered>Sundered</condition> for 3 turns. ",
      "long_description": "When this champion makes a successful basic attack against a champion, the target becomes <condition value=sundered>Sundered</condition> for 3 turns. ",
      "class_name": "Sunder",
      "revision": 1
    },
    {
      "asset_id": 7388,
      "resettable": 0,
      "name": "Sundered Exploit",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3139,
      "activated": 1,
      "icon_name": "exploit_sundered",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 7,
      "short_description": "When this champion makes a successful basic attack against a target with <condition value=sundered>Sundered</condition>, <condition value=scoured>Scoured</condition> or <condition value=fatigued>Fatigued</condition>, it gains 1 AP and has +2 DMG for the attack.",
      "long_description": "When this champion makes a successful basic attack against a target with <condition value=sundered>Sundered</condition>, <condition value=scoured>Scoured</condition> or <condition value=fatigued>Fatigued</condition>, it gains 1 AP and has +2 DMG for the attack.",
      "class_name": "SunderedExploit",
      "revision": 1
    },
    {
      "asset_id": 7126,
      "resettable": 0,
      "name": "Sundering Discipline",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2941,
      "activated": 1,
      "icon_name": "discipline_sundering",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 3,
      "short_description": "The next basic attack this champion makes causes <condition value=sundered>Sundered</condition> for 4 turns. If the target was <condition value=frozen popup=false>Frozen</condition>, all friendly Monks gain 1 damage for 6 turns",
      "long_description": "The next basic attack this champion makes causes <condition value=sundered>Sundered</condition> for 4 turns. If the target was <condition value=frozen popup=false>Frozen</condition>, all friendly Monks gain 1 damage for 6 turns",
      "class_name": "SunderingDiscipline",
      "revision": 1
    },
    {
      "asset_id": 5346,
      "resettable": 1,
      "name": "Supercharged",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 2178,
      "activated": 1,
      "icon_name": "supercharged",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 3,
      "short_description": "This unit gains 1 charge at the start of its turn.",
      "long_description": "This unit gains 1 charge at the start of its turn.",
      "class_name": "Supercharged",
      "revision": 1
    },
    {
      "asset_id": 5346,
      "resettable": 1,
      "name": "Supercharged",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 2179,
      "activated": 1,
      "icon_name": "supercharged",
      "comments": "",
      "prerequisite_id": 2178,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 6,
      "short_description": "This unit gains 2 charges at the start of its turn.",
      "long_description": "This unit gains 2 charges at the start of its turn.",
      "class_name": "Supercharged",
      "revision": 1
    },
    {
      "asset_id": 5346,
      "resettable": 1,
      "name": "Supercharged",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 2180,
      "activated": 1,
      "icon_name": "supercharged",
      "comments": "",
      "prerequisite_id": 2179,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 9,
      "short_description": "This unit gains 3 charges at the start of its turn.",
      "long_description": "This unit gains 3 charges at the start of its turn.",
      "class_name": "Supercharged",
      "revision": 1
    },
    {
      "asset_id": 5620,
      "resettable": 1,
      "name": "Superior Tinkering",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2578,
      "activated": 1,
      "icon_name": "build_mine",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "Target construct within 2 spaces gains +1 DMG and +10 MAX HP.  This effect does not stack.",
      "long_description": "Target construct within 2 spaces gains +1 DMG and +10 MAX HP.  This effect does not stack.",
      "class_name": "SuperiorTinkering",
      "revision": 1
    },
    {
      "asset_id": 4331,
      "resettable": 1,
      "name": "Suppress Knowledge",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1359,
      "activated": 1,
      "icon_name": "suppress_knowledge",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "When this unit leaves play, all enemies spells gain an additional 2 turn cooldown.",
      "long_description": "When this unit leaves play, all enemies spells gain an additional 2 turn cooldown.",
      "class_name": "SuppressKnowledge",
      "revision": 1
    },
    {
      "asset_id": 5454,
      "resettable": 1,
      "name": "Suppress Transfigure",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2306,
      "activated": 1,
      "icon_name": "spite",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 0,
      "short_description": "Whenever an opponent successfully casts a spell, the cooldown of the Transfigure ability on that player's avatar is increased by 1",
      "long_description": "Whenever an opponent successfully casts a spell, the cooldown of the Transfigure ability on that player's avatar is increased by 1",
      "class_name": "SuppressTransfigure",
      "revision": 1
    },
    {
      "asset_id": 7383,
      "resettable": 0,
      "name": "Suppression",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 3134,
      "activated": 1,
      "icon_name": "special",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 5,
      "short_description": "Target enemy champion within 5 spaces has <ability value=3064>Weighty</ability> and <ability value=2093>Ponderous</ability> for 2 turns.",
      "long_description": "Target enemy champion within 5 spaces has <ability value=3064>Weighty</ability> and <ability value=2093>Ponderous</ability> for 2 turns.",
      "class_name": "Suppression",
      "revision": 1
    },
    {
      "asset_id": 4600,
      "resettable": 1,
      "name": "Surge: Aquatic",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 1015,
      "activated": 1,
      "icon_name": "surge_aquatic",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 5,
      "short_description": "This unit has +1 DMG for each friendly <ability value=114>Aquatic</ability> or <ability value=859>Semi Aquatic</ability>.",
      "long_description": "This unit has +1 DMG for each friendly <ability value=114>Aquatic</ability> or <ability value=859>Semi Aquatic</ability>.",
      "class_name": "SurgeAquatic",
      "revision": 1
    },
    {
      "asset_id": 4436,
      "resettable": 1,
      "name": "Surge: Arthropod",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 783,
      "activated": 1,
      "icon_name": "surge_spider",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 5,
      "short_description": "This unit has +1 DMG for each friendly Arthropod.",
      "long_description": "This unit has +1 DMG for each friendly Arthropod.",
      "class_name": "SurgeSpider",
      "revision": 1
    },
    {
      "asset_id": 4604,
      "resettable": 1,
      "name": "Surge: Beast",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1020,
      "activated": 1,
      "icon_name": "surge_beast",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "This unit has +1 DMG for every friendly Beast.",
      "long_description": "This unit has +1 DMG for every friendly Beast.",
      "class_name": "SurgeBeast",
      "revision": 1
    },
    {
      "asset_id": 4551,
      "resettable": 1,
      "name": "Surge: Boghopper",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 948,
      "activated": 1,
      "icon_name": "surge_boghopper",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 5,
      "short_description": "This unit has +1 DMG for each friendly Boghopper.",
      "long_description": "This unit has +1 DMG for each friendly Boghopper.",
      "class_name": "SurgeBoghopper",
      "revision": 1
    },
    {
      "asset_id": 5504,
      "resettable": 1,
      "name": "Surge: Concealed",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2363,
      "activated": 1,
      "icon_name": "surge_concealed",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "This unit has +1 DMG for every 2 runes you have concealed.",
      "long_description": "This unit has +1 DMG for every 2 runes you have concealed.",
      "class_name": "SurgeConcealed",
      "revision": 1
    },
    {
      "asset_id": 7180,
      "resettable": 0,
      "name": "Surge: Cursed",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3023,
      "activated": 1,
      "icon_name": "surge_cursed",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "This unit has +1 DMG for each champion that is <condition value=cursed>Cursed</condition>.",
      "long_description": "This unit has +1 DMG for each champion that is <condition value=cursed>Cursed</condition>.",
      "class_name": "SurgeCursed",
      "revision": 1
    },
    {
      "asset_id": 4645,
      "resettable": 1,
      "name": "Surge: Cyclops",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 1067,
      "activated": 1,
      "icon_name": "surge_behemoth",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 5,
      "short_description": "This unit has +1 DMG for every friendly Cyclops champion.",
      "long_description": "This unit has +1 DMG for every friendly Cyclops champion.",
      "class_name": "SurgeCyclops",
      "revision": 1
    },
    {
      "asset_id": 4544,
      "resettable": 1,
      "name": "Surge: Demon",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 936,
      "activated": 1,
      "icon_name": "surge_demon",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "This unit has +1 DMG for every friendly Demon.",
      "long_description": "This unit has +1 DMG for every friendly Demon.",
      "class_name": "ZealotDemon",
      "revision": 1
    },
    {
      "asset_id": 4544,
      "resettable": 0,
      "name": "Surge: Demon Elf",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2972,
      "activated": 1,
      "icon_name": "surge_demonelf",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "This unit has +1 DMG for every friendly champion with the races Demon and Elf.",
      "long_description": "This unit has +1 DMG for every friendly champion with the races Demon and Elf.",
      "class_name": "SurgeDemonElf",
      "revision": 1
    },
    {
      "asset_id": 4435,
      "resettable": 1,
      "name": "Surge: Dragon",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 781,
      "activated": 1,
      "icon_name": "surge_dragon",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 5,
      "short_description": "This unit has +1 DMG for each friendly Dragon.",
      "long_description": "This unit has +1 DMG for each friendly Dragon.",
      "class_name": "SurgeDragon",
      "revision": 1
    },
    {
      "asset_id": 4821,
      "resettable": 1,
      "name": "Surge: Draksar",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 1700,
      "activated": 1,
      "icon_name": "surge_draksar",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 5,
      "short_description": "This unit has +1 DMG for each friendly Draksar.",
      "long_description": "This unit has +1 DMG for each friendly Draksar.",
      "class_name": "SurgeDraksar",
      "revision": 1
    },
    {
      "asset_id": 4562,
      "resettable": 1,
      "name": "Surge: Dwarf",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 971,
      "activated": 1,
      "icon_name": "surge_dwarf",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "This unit has +1 DMG for each friendly Dwarf.",
      "long_description": "This unit has +1 DMG for each friendly Dwarf.",
      "class_name": "SurgeDwarf",
      "revision": 1
    },
    {
      "asset_id": 4773,
      "resettable": 0,
      "name": "Surge: Elemental",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2963,
      "activated": 1,
      "icon_name": "surge_rock",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "This unit gets +1 DMG for every friendly Elemental",
      "long_description": "This unit gets +1 DMG for every friendly Elemental",
      "class_name": "SurgeElemental",
      "revision": 1
    },
    {
      "asset_id": 4570,
      "resettable": 1,
      "name": "Surge: Enemy",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1006,
      "activated": 1,
      "icon_name": "surge_enemy",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "This unit has +1 DMG for each deployed enemy champion.",
      "long_description": "This unit has +1 DMG for each deployed enemy champion.",
      "class_name": "SurgeEnemy",
      "revision": 1
    },
    {
      "asset_id": 7131,
      "resettable": 0,
      "name": "Surge: Equipped",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2973,
      "activated": 1,
      "icon_name": "surge_equipped",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "This unit gets +1 DMG for every equipped champion.",
      "long_description": "This unit gets +1 DMG for every equipped champion.",
      "class_name": "SurgeEquipped",
      "revision": 1
    },
    {
      "asset_id": 4284,
      "resettable": 1,
      "name": "Surge: G'hern",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 667,
      "activated": 1,
      "icon_name": "surge_ghern",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 7,
      "short_description": "This unit has +1 DMG for every friendly G'hern.",
      "long_description": "This unit has +1 DMG for every friendly G'hern.",
      "class_name": "SurgeGhern",
      "revision": 1
    },
    {
      "asset_id": 5704,
      "resettable": 1,
      "name": "Surge: Hyaenid",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2584,
      "activated": 1,
      "icon_name": "surge_hyaenid",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "This unit has +1 DMG for each friendly Hyaenid.",
      "long_description": "This unit has +1 DMG for each friendly Hyaenid.",
      "class_name": "SurgeHyaenid",
      "revision": 1
    },
    {
      "asset_id": 5308,
      "resettable": 1,
      "name": "Surge: Kanen",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2130,
      "activated": 1,
      "icon_name": "surge_kanen",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 5,
      "short_description": "This unit has +1 DMG for each friendly Kanen.",
      "long_description": "This unit has +1 DMG for each friendly Kanen.",
      "class_name": "SurgeKanen",
      "revision": 1
    },
    {
      "asset_id": 4038,
      "resettable": 1,
      "name": "Surge: Moga",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 715,
      "activated": 1,
      "icon_name": "surge_moga",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 8,
      "short_description": "This unit has +1 DMG for each friendly Moga.",
      "long_description": "This unit has +1 DMG for each friendly Moga.",
      "class_name": "SurgeMoga",
      "revision": 1
    },
    {
      "asset_id": 5180,
      "resettable": 1,
      "name": "Surge: Paladin",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1957,
      "activated": 1,
      "icon_name": "offenseenhance",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "This champion gains +1 DMG for each other friendly Paladin.",
      "long_description": "This champion gains +1 DMG for each other friendly Paladin.",
      "class_name": "SurgePaladin",
      "revision": 1
    },
    {
      "asset_id": 5087,
      "resettable": 1,
      "name": "Surge: Plant",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1261,
      "activated": 1,
      "icon_name": "surge_plant",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "This unit has +1 DMG for each friendly Plant.",
      "long_description": "This unit has +1 DMG for each friendly Plant.",
      "class_name": "SurgePlant",
      "revision": 1
    },
    {
      "asset_id": 7257,
      "resettable": 0,
      "name": "Surge: Races",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3065,
      "activated": 1,
      "icon_name": "surge_races",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "This unit has +1 DMG for each different Race on friendly champions.",
      "long_description": "This unit has +1 DMG for each different Race on friendly champions.",
      "class_name": "SurgeRaces",
      "revision": 1
    },
    {
      "asset_id": 4366,
      "resettable": 1,
      "name": "Surge: Ranger",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1402,
      "activated": 1,
      "icon_name": "surge_ranger",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "This unit has +1 DMG for each other friendly Ranger.",
      "long_description": "This unit has +1 DMG for each other friendly Ranger.",
      "class_name": "SurgeRanger",
      "revision": 1
    },
    {
      "asset_id": 5760,
      "resettable": 1,
      "name": "Surge: Rock",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2662,
      "activated": 1,
      "icon_name": "surge_rock",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "This unit has +1 DMG for every 2 champions occupying Rock.",
      "long_description": "This unit has +1 DMG for every 2 champions occupying Rock.",
      "class_name": "SurgeRock",
      "revision": 1
    },
    {
      "asset_id": 4937,
      "resettable": 1,
      "name": "Surge: Shadows",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1795,
      "activated": 1,
      "icon_name": "surge_shadow",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "This champion gets +1 DMG for all stealthed champions you or your opponent controls.",
      "long_description": "This champion gets +1 DMG for all stealthed champions you or your opponent controls.",
      "class_name": "SurgeShadows",
      "revision": 1
    },
    {
      "asset_id": 4508,
      "resettable": 1,
      "name": "Surge: Skeezick",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 930,
      "activated": 1,
      "icon_name": "surge_skeezick",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 5,
      "short_description": "This unit has +1 DMG for each friendly Skeezick.",
      "long_description": "This unit has +1 DMG for each friendly Skeezick. ",
      "class_name": "SurgeSkeezick",
      "revision": 1
    },
    {
      "asset_id": 4539,
      "resettable": 1,
      "name": "Surge: Skeleton",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 925,
      "activated": 1,
      "icon_name": "surge_skeleton",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 8,
      "short_description": "This unit has +1 DMG for each friendly Skeleton.",
      "long_description": "This unit has +1 DMG for each friendly Skeleton.",
      "class_name": "SurgeSkeleton",
      "revision": 1
    },
    {
      "asset_id": 5694,
      "resettable": 1,
      "name": "Surge: Spirit",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2570,
      "activated": 1,
      "icon_name": "surge_spirit",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "This unit has +1 DMG for each friendly Spirit.",
      "long_description": "This unit has +1 DMG for each friendly Spirit.",
      "class_name": "SurgeSpirit",
      "revision": 1
    },
    {
      "asset_id": 5760,
      "resettable": 1,
      "name": "Surge: Tundra",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2668,
      "activated": 1,
      "icon_name": "surge_tundra",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "This unit has +1 DMG for every 2 champions occupying Ice or Snow.",
      "long_description": "This unit has +1 DMG for every 2 champions occupying Ice or Snow.",
      "class_name": "SurgeTundra",
      "revision": 1
    },
    {
      "asset_id": 4621,
      "resettable": 1,
      "name": "Surge: Voil",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1036,
      "activated": 1,
      "icon_name": "surge_voil",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "This unit has +1 DMG for every friendly Voil",
      "long_description": "This unit has +1 DMG for every friendly Voil",
      "class_name": "SurgeVoil",
      "revision": 1
    },
    {
      "asset_id": 4436,
      "resettable": 0,
      "name": "Surge: Worm",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2965,
      "activated": 1,
      "icon_name": "surge_carrionling",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "This unit has +1 DMG for each friendly Worm.",
      "long_description": "This unit has +1 DMG for each friendly Worm.",
      "class_name": "SurgeWorm",
      "revision": 1
    },
    {
      "asset_id": 7282,
      "resettable": 0,
      "name": "Sustain: Berserker",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 3076,
      "activated": 1,
      "icon_name": "grantability",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 7,
      "short_description": "Target champion within 7 spaces gains <ability value=24>Berserker 2</ability> until this ability is used again.",
      "long_description": "Target champion within 7 spaces gains <ability value=24>Berserker 2</ability> until this ability is used again.",
      "class_name": "SustainBerserker",
      "revision": 1
    },
    {
      "asset_id": 5818,
      "resettable": 1,
      "name": "Sustain: Unstoppable",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 2827,
      "activated": 1,
      "icon_name": "grantability",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 5,
      "short_description": "Target champion within 7 spaces gains <ability value=597>Unstoppable</ability> until this ability is used again or this unit leaves play. This is not Dispellable.",
      "long_description": "Target champion within 7 spaces gains <ability value=597>Unstoppable</ability> until this ability is used again or this unit leaves play. This is not Dispellable.",
      "class_name": "SustainUnstoppable",
      "revision": 1
    },
    {
      "asset_id": 5203,
      "resettable": 1,
      "name": "Swallow Whole",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 1980,
      "activated": 1,
      "icon_name": "swallow",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 20,
      "short_description": "Target small non-<ability value=1045>Elite</ability> enemy champion is removed from play and loses 8 HP at the beginning of each turn. While this effect is active, this champion gains <ability value=5>Lumbering</ability>, <ability value=680>Planar Bound</ability> and <ability value=2474>Font Ignorance</ability>. After 2 turns or if this champion leaves play or loses this ability, any champions with HP remaining are deployed in the nearest available space.",
      "long_description": "Target small non-<ability value=1045>Elite</ability> enemy champion is removed from play and loses 15 HP at the beginning of the next turn. While this effect is active, this champion gains <ability value=5>Lumbering</ability>, <ability value=680>Planar Bound</ability> and <ability value=2474>Font Ignorance</ability>. After 2 turns or if this champion leaves play or loses this ability, any champions with HP remaining are deployed in the nearest available space.",
      "class_name": "SwallowWhole",
      "revision": 1
    },
    {
      "asset_id": 7963,
      "resettable": 0,
      "name": "Swamp Exploit",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3350,
      "activated": 1,
      "icon_name": "exploit_ironfist",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 7,
      "short_description": "When this champion makes a successful basic attack against a target with <condition value=poisoned>Poisoned</condition>, <condition value=soultapped>Soultapped</condition> or <condition value=blinded>Blinded</condition> it gains 1 AP and has +2 DMG for the attack.",
      "long_description": "When this champion makes a successful basic attack against a target with <condition value=poisoned>Poisoned</condition>, <condition value=soultapped>Soultapped</condition> or <condition value=blinded>Blinded</condition> it gains 1 AP and has +2 DMG for the attack.",
      "class_name": "SwampExploit",
      "revision": 1
    },
    {
      "asset_id": 5424,
      "resettable": 1,
      "name": "Swamp Teachings",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 2472,
      "activated": 1,
      "icon_name": "semiaquatic",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "This unit loses 10 HP and target Boghopper Tad within 3 spaces is removed from play and a Boghopper Pupil with no upgrades is summoned in the same location the Boghopper Tad occupied. ",
      "long_description": "This unit loses 10 HP and target Boghopper Tad within 3 spaces is removed from play and a Boghopper Pupil with no upgrades is summoned in the same location the Boghopper Tad occupied. ",
      "class_name": "SwampTeachings",
      "revision": 1
    },
    {
      "asset_id": 5088,
      "resettable": 1,
      "name": "Swap",
      "ap_cost": 2,
      "level": 1,
      "ability_id": 1262,
      "activated": 1,
      "icon_name": "relocate",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 2,
      "short_description": "Exchange places with target friendly champion of the same size within 1 to 3 spaces.",
      "long_description": "Exchange places with target friendly champion of the same size within 1 to 3 spaces.",
      "class_name": "Swap",
      "revision": 1
    },
    {
      "asset_id": 5088,
      "resettable": 1,
      "name": "Swap",
      "ap_cost": 2,
      "level": 2,
      "ability_id": 1263,
      "activated": 1,
      "icon_name": "relocate",
      "comments": "",
      "prerequisite_id": 1262,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 4,
      "short_description": "Exchange places with target friendly champion of the same size within 1 to 4 spaces.",
      "long_description": "Exchange places with target friendly champion of the same size within 1 to 4 spaces.",
      "class_name": "Swap",
      "revision": 1
    },
    {
      "asset_id": 5088,
      "resettable": 1,
      "name": "Swap",
      "ap_cost": 2,
      "level": 3,
      "ability_id": 1264,
      "activated": 1,
      "icon_name": "relocate",
      "comments": "",
      "prerequisite_id": 1263,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 6,
      "short_description": "Exchange places with target friendly champion of the same size within 1 to 5 spaces.",
      "long_description": "Exchange places with target friendly champion of the same size within 1 to 5 spaces.",
      "class_name": "Swap",
      "revision": 1
    },
    {
      "asset_id": 7789,
      "resettable": 0,
      "name": "Swarm: Bat Swarm",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3311,
      "activated": 1,
      "icon_name": "swarm_kanen",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 25,
      "short_description": "When this champion destroys a champion on a basic attack, a Bat Swarm with no upgrades is summoned under your control in the location the destroyed champion occupied.",
      "long_description": "When this champion destroys a champion on a basic attack, a Bat Swarm with no upgrades is summoned under your control in the location the destroyed champion occupied.",
      "class_name": "SwarmBatSwarm",
      "revision": 1
    },
    {
      "asset_id": 7981,
      "resettable": 0,
      "name": "Swarm: Boghopper Zombie",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3372,
      "activated": 1,
      "icon_name": "swarm_kanen",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 20,
      "short_description": "When this champion destroys a champion on a basic attack, a Level 1 Boghopper Zombie champion without upgrades and with <ability value=518>Leap 3</ability> and <ability value=1403>Latch On</ability> is summoned under your control in the location the destroyed champion occupied.",
      "long_description": "When this champion destroys a champion on a basic attack, a Level 1 Boghopper Zombie champion without upgrades and with <ability value=518>Leap 3</ability> and <ability value=1403>Latch On</ability> is summoned under your control in the location the destroyed champion occupied.",
      "class_name": "SwarmBogHopperZombie",
      "revision": 1
    },
    {
      "asset_id": 5086,
      "resettable": 1,
      "name": "Swarm: Carrionling",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1265,
      "activated": 1,
      "icon_name": "swarm_carrionling",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 7,
      "short_description": "When this champion destroys a champion on a basic attack, a Carrionling champion is with no upgrades is summoned under your control in the location the destroyed champion occupied.",
      "long_description": "When this champion destroys a champion on a basic attack, a Carrionling champion is with no upgrades is summoned under your control in the location the destroyed champion occupied.",
      "class_name": "SwarmCarrionling",
      "revision": 1
    },
    {
      "asset_id": 7790,
      "resettable": 0,
      "name": "Swarm: Clockwork Swarm",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3312,
      "activated": 1,
      "icon_name": "swarm_kanen",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 18,
      "short_description": "When this champion destroys a champion on a basic attack, a Clockwork Swarm with no upgrades is summoned under your control in the location the destroyed champion occupied.",
      "long_description": "When this champion destroys a champion on a basic attack, a Clockwork Swarm with no upgrades is summoned under your control in the location the destroyed champion occupied.",
      "class_name": "SwarmClockworkSwarm",
      "revision": 1
    },
    {
      "asset_id": 4681,
      "resettable": 1,
      "name": "Swarm: Deep-Elf Skeleton",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1143,
      "activated": 1,
      "icon_name": "swarm_skeleton",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 7,
      "short_description": "When this champion destroys a champion on a basic attack, a Deep-Elf Skeleton with no upgrades is summoned under your control in the location the destroyed champion occupied.",
      "long_description": "When this champion destroys a champion on a basic attack, a Deep-Elf Skeleton with no upgrades is summoned under your control in the location the destroyed champion occupied.",
      "class_name": "SwarmDeepElfSkeleton",
      "revision": 1
    },
    {
      "asset_id": 5318,
      "resettable": 1,
      "name": "Swarm: Festering Corpse",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2147,
      "activated": 1,
      "icon_name": "swarm_corpse",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 14,
      "short_description": "When this champion destroys a champion on a basic attack, a Festering Corpse champion with no upgrades and 75% HP is summoned to the closest available space.",
      "long_description": "When this champion destroys a champion on a basic attack, a Festering Corpse champion with no upgrades and 75% HP is summoned to the closest available space.",
      "class_name": "SwarmFesteringCorpse",
      "revision": 1
    },
    {
      "asset_id": 7791,
      "resettable": 0,
      "name": "Swarm: Hyaenid Instigator",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3313,
      "activated": 1,
      "icon_name": "swarm_kanen",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 25,
      "short_description": "When this champion destroys a champion on a basic attack, a Hyaenid Instigator with no upgrades is summoned under your control in the location the destroyed champion occupied.",
      "long_description": "When this champion destroys a champion on a basic attack, a Hyaenid Instigator with no upgrades is summoned under your control in the location the destroyed champion occupied.",
      "class_name": "SwarmHyaenidInstigator",
      "revision": 1
    },
    {
      "asset_id": 5264,
      "resettable": 1,
      "name": "Swarm: Kanen Mongrel",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2087,
      "activated": 1,
      "icon_name": "swarm_kanen",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 14,
      "short_description": "When this champion destroys a champion on a basic attack, a Kanen Mongrel champion is summoned under your control in the location the destroyed champion occupied.",
      "long_description": "When this champion destroys a champion on a basic attack, a Kanen Mongrel champion is summoned under your control in the location the destroyed champion occupied.",
      "class_name": "SwarmKanenMongrel",
      "revision": 1
    },
    {
      "asset_id": 7792,
      "resettable": 0,
      "name": "Swarm: Locust",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3314,
      "activated": 1,
      "icon_name": "swarm_kanen",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 25,
      "short_description": "When this champion destroys a champion on a basic attack, a Locust with no upgrades is summoned under your control in the location the destroyed champion occupied.",
      "long_description": "When this champion destroys a champion on a basic attack, a Locust with no upgrades is summoned under your control in the location the destroyed champion occupied.",
      "class_name": "SwarmLocust",
      "revision": 1
    },
    {
      "asset_id": 4926,
      "resettable": 1,
      "name": "Swarm: Magma Bunny",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1808,
      "activated": 1,
      "icon_name": "swarm_magma_bunny",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 14,
      "short_description": "When this champion destroys a champion on a basic attack, a Magma Bunny champion with no upgrades is summoned under your control in the location the destroyed champion occupied.",
      "long_description": "When this champion destroys a champion on a basic attack, a Magma Bunny champion with no upgrades is summoned under your control in the location the destroyed champion occupied.",
      "class_name": "SwarmMagmaBunny",
      "revision": 1
    },
    {
      "asset_id": 4770,
      "resettable": 1,
      "name": "Swarm: Moga",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1498,
      "activated": 1,
      "icon_name": "swarm_moga",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 14,
      "short_description": "When this champion destroys a champion on a basic attack, a Moga Scout with no upgrades is summoned under your control in the location the destroyed champion occupied.",
      "long_description": "When this champion destroys a champion on a basic attack, a Moga Scout with no upgrades is summoned under your control in the location the destroyed champion occupied.",
      "class_name": "SwarmMoga",
      "revision": 1
    },
    {
      "asset_id": 7793,
      "resettable": 0,
      "name": "Swarm: Polar Ant",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3315,
      "activated": 1,
      "icon_name": "swarm_kanen",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 25,
      "short_description": "When this champion destroys a champion on a basic attack, a Polar Ant with no upgrades is summoned under your control in the location the destroyed champion occupied.",
      "long_description": "When this champion destroys a champion on a basic attack, a Polar Ant with no upgrades is summoned under your control in the location the destroyed champion occupied.",
      "class_name": "SwarmPolarAnt",
      "revision": 1
    },
    {
      "asset_id": 7794,
      "resettable": 0,
      "name": "Swarm: Skeezick Rioter",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3316,
      "activated": 1,
      "icon_name": "swarm_kanen",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 25,
      "short_description": "When this champion destroys a champion on a basic attack, a Skeezick Rioter with no upgrades is summoned under your control in the location the destroyed champion occupied.",
      "long_description": "When this champion destroys a champion on a basic attack, a Skeezick Rioter with no upgrades is summoned under your control in the location the destroyed champion occupied.",
      "class_name": "SwarmSkeezickRioter",
      "revision": 1
    },
    {
      "asset_id": 4538,
      "resettable": 1,
      "name": "Swarm: Snowcat",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 924,
      "activated": 1,
      "icon_name": "swarm_cat",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 7,
      "short_description": "When this champion destroys a champion on a basic attack, a Snowcat champion with no upgrades is summoned under your control in the location the destroyed champion occupied.",
      "long_description": "When this champion destroys a champion on a basic attack, a Snowcat champion with no upgrades is summoned under your control in the location the destroyed champion occupied.",
      "class_name": "SwarmSnowcat",
      "revision": 1
    },
    {
      "asset_id": 5648,
      "resettable": 1,
      "name": "Swarm: Tundra Beast",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2519,
      "activated": 1,
      "icon_name": "swarm_arcticbeast",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 14,
      "short_description": "When this champion destroys a champion on a basic attack, a Tundra Beast champion with no upgrades is summoned under your control in the location the destroyed champion occupied.",
      "long_description": "When this champion destroys a champion on a basic attack, a Tundra Beast champion with no upgrades is summoned under your control in the location the destroyed champion occupied.",
      "class_name": "SwarmTundraBeast",
      "revision": 1
    },
    {
      "asset_id": 5121,
      "resettable": 1,
      "name": "Sweep",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 1312,
      "activated": 1,
      "icon_name": "whirl",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "All champions within 2 spaces take 8 Physical damage and are knocked back 2 spaces. This damage ignores DEF.",
      "long_description": "All champions within 2 spaces take 8 Physical damage and are knocked back 2 spaces. This damage ignores DEF.",
      "class_name": "Sweep",
      "revision": 1
    },
    {
      "asset_id": 7729,
      "resettable": 0,
      "name": "Swift Current",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3270,
      "activated": 1,
      "icon_name": "pull_guile",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "When this champion makes a successful basic attack, friendly champions within 5 spaces gains Mobility for 1 turn and moves 1 space towards the target if able. If the affected champion shares a race or class with this one, it also gains 1 AP. This effect can trigger only once per turn.",
      "long_description": "When this champion makes a successful basic attack, friendly champions within 5 spaces gains Mobility for 1 turn and moves 1 space towards the target if able. If the affected champion shares a race or class with this one, it also gains 1 AP. This effect can trigger only once per turn.",
      "class_name": "SwiftCurrent",
      "revision": 1
    },
    {
      "asset_id": 5435,
      "resettable": 1,
      "name": "Sword Breaker",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2285,
      "activated": 1,
      "icon_name": "wrecker",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this champion successfully attacks a champion with a basic attack, any equipment on that champion is destroyed.",
      "long_description": "When this champion successfully attacks a champion with a basic attack, any equipment on that champion is destroyed.",
      "class_name": "Wrecker",
      "revision": 1
    },
    {
      "asset_id": 4934,
      "resettable": 1,
      "name": "Sword of Shadows",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1820,
      "activated": 1,
      "icon_name": "shadow_shift",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "All allies within 3 spaces of this relic become Shadow touched for 2 turns when this relic is deployed and at the end of your turns. (Shadow touched - This champion has -2 DMG. If this champion dies while under the effect of this debuff, a Shade is summoned under the control of the owner of the Sword of Shadows)",
      "long_description": "All allies within 3 spaces of this relic become Shadow touched for 2 turns when this relic is deployed and at the end of your turns. (Shadow touched - This champion has -2 DMG. If this champion dies while under the effect of this debuff, a Shade is summoned under the control of the owner of the Sword of Shadows)",
      "class_name": "RelicSwordOfShadows",
      "revision": 1
    },
    {
      "asset_id": 5534,
      "resettable": 1,
      "name": "Tactician",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2393,
      "activated": 1,
      "icon_name": "tactician",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "Friendly champions within 3 spaces have +1 MAX RNG if they have a MIN RNG of 1.",
      "long_description": "Friendly champions within 3 spaces have +1 MAX RNG if they have a MIN RNG of 1.",
      "class_name": "Tactician",
      "revision": 1
    },
    {
      "asset_id": 5562,
      "resettable": 1,
      "name": "Tailwind",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2422,
      "activated": 1,
      "icon_name": "tailwind",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 14,
      "short_description": "On every fourth space that this champion moves in this turn, friendly champions within 8 spaces of this unit with <condition value=flying>Flying</condition> and which do not have Tailwind gain 1 AP.",
      "long_description": "On every fourth space that this champion moves in this turn, friendly champions within 8 spaces of this unit with <condition value=flying>Flying</condition> and which do not have Tailwind gain 1 AP.",
      "class_name": "Tailwind",
      "revision": 1
    },
    {
      "asset_id": 4301,
      "resettable": 1,
      "name": "Tainted Statue",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 703,
      "activated": 1,
      "icon_name": "noragen",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 1,
      "short_description": "Spells cost 35% more nora to cast.",
      "long_description": "Spells cost 35% more nora to cast.",
      "class_name": "RelicTaintedStatue",
      "revision": 1
    },
    {
      "asset_id": 5090,
      "resettable": 1,
      "name": "Take Form",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 1266,
      "activated": 1,
      "icon_name": "transform",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 50,
      "short_description": "This unit loses all abilities and conditions and becomes a cleansed copy with full HP of a target non-hero, non-planarbound champion of the same size within 10 spaces. Target champion can not have a nora cost of 80 or more. Equipment on the target champion is not copied.",
      "long_description": "This unit loses all abilities and conditions and becomes a cleansed copy with full HP of a target non-hero, non-planarbound champion of the same size within 10 spaces. Target champion can not have a nora cost of 80 or more. Equipment on the target champion is not copied.",
      "class_name": "TakeForm",
      "revision": 1
    },
    {
      "asset_id": 7193,
      "resettable": 0,
      "name": "Take Prisoner",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 3039,
      "activated": 1,
      "icon_name": "take_prisoner",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "Target enemy champion within 3 spaces with 10 or less current HP is Possessed. That champion has <ability value=2005>Careless</ability> and <ability value=877>Bodyguard</ability> while Possessed.",
      "long_description": "Target enemy champion within 3 spaces with 10 or less current HP is Possessed. That champion has <ability value=2005>Careless</ability> and <ability value=877>Bodyguard</ability> while Possessed.",
      "class_name": "TakePrisoner",
      "revision": 1
    },
    {
      "asset_id": 4657,
      "resettable": 1,
      "name": "Take Root",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 1087,
      "activated": 1,
      "icon_name": "plantregen",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 2,
      "short_description": "This champion loses Take Root and gains Uproot, <ability value=655>Skirmisher</ability>, <mechanic value=immobile>Immobile</mechanic>, <ability value=106>Camouflage</ability>, and <ability value=15>Multiattack 1</ability>. It also gains +2 DMG, +2 DEF, +5 MAX HP, and +1 MAX RNG.",
      "long_description": "This champion loses Take Root and gains Uproot, <ability value=655>Skirmisher</ability>, <mechanic value=immobile>Immobile</mechanic>, <ability value=106>Camouflage</ability>, and <ability value=15>Multiattack 1</ability>. It also gains +2 DMG, +2 DEF, +5 MAX HP, and +1 MAX RNG.",
      "class_name": "TakeRoot",
      "revision": 1
    },
    {
      "asset_id": 4970,
      "resettable": 1,
      "name": "Talon Attack",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1796,
      "activated": 1,
      "icon_name": "hawk_attack",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 5,
      "short_description": "This champion makes a close-combat Physical attack. When a champion takes 1 or more damage from this attack, it becomes <condition value=eviscerated>Eviscerated</condition> for 3 turns.",
      "long_description": "This champion makes a close-combat Physical attack. When a champion takes 1 or more damage from this attack, it becomes <condition value=eviscerated>Eviscerated</condition> for 3 turns.",
      "class_name": "TalonAttack",
      "revision": 1
    },
    {
      "asset_id": 4574,
      "resettable": 1,
      "name": "Tame Beast",
      "ap_cost": 4,
      "level": 1,
      "ability_id": 1007,
      "activated": 1,
      "icon_name": "possess",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 1,
      "cost": 2,
      "short_description": "Target enemy Beast champion within 2 spaces is <condition value=possessed>Possessed</condition> by you for 1 turn. This unit is <condition value=paralyzed>Paralyzed</condition> while this effect is active.",
      "long_description": "Target enemy Beast champion within 2 spaces is <condition value=possessed>Possessed</condition> by you for 1 turn. This unit is <condition value=paralyzed>Paralyzed</condition> while this effect is active.",
      "class_name": "TameBeast",
      "revision": 1
    },
    {
      "asset_id": 4574,
      "resettable": 1,
      "name": "Tame Beast",
      "ap_cost": 4,
      "level": 2,
      "ability_id": 1008,
      "activated": 1,
      "icon_name": "possess",
      "comments": "",
      "prerequisite_id": 1007,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 1,
      "cost": 5,
      "short_description": "Target enemy Beast champion within 2 spaces is <condition value=possessed>Possessed</condition> by you for 2 turns. This unit is <condition value=paralyzed>Paralyzed</condition> while this effect is active.",
      "long_description": "Target enemy Beast champion within 2 spaces is <condition value=possessed>Possessed</condition> by you for 2 turns. This unit is <condition value=paralyzed>Paralyzed</condition> while this effect is active.",
      "class_name": "TameBeast",
      "revision": 1
    },
    {
      "asset_id": 4986,
      "resettable": 1,
      "name": "Tameable",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1868,
      "activated": 1,
      "icon_name": "passive",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "This champion has +4 DMG while a friendly Lonx is in play. If a friendly Lonx Beast Tamer is in play, it has +1 SPD.",
      "long_description": "This champion has +4 DMG while a friendly Lonx is in play. If a friendly Lonx Beast Tamer is in play, it has +1 SPD.",
      "class_name": "Tamed",
      "revision": 1
    },
    {
      "asset_id": 5092,
      "resettable": 1,
      "name": "Tamper",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1268,
      "activated": 1,
      "icon_name": "",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "Target enemy champion within 4 spaces has its base ATK and base DMG swapped for the next 4 turns. This ability shares a cooldown with Fiddle and Meddle.",
      "long_description": "Target enemy champion within 4 spaces has its base ATK and base DMG swapped for the next 4 turns. This ability shares a cooldown with Fiddle and Meddle.",
      "class_name": "Tamper",
      "revision": 1
    },
    {
      "asset_id": 4598,
      "resettable": 1,
      "name": "Tangle",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 1018,
      "activated": 1,
      "icon_name": "disable",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "Disengagement from this unit will remove all remaining AP from champion.",
      "long_description": "Disengagement from this unit will remove all remaining AP from champion.",
      "class_name": "Tangle",
      "revision": 1
    },
    {
      "asset_id": 4564,
      "resettable": 1,
      "name": "Tariff",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1009,
      "activated": 1,
      "icon_name": "cost",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 12,
      "short_description": "When a real enemy champion is destroyed, that champion's controller loses 8 nora. If that player has less than 8 nora in their nora bank, their Shrine or Avatar loses 5 HP instead.  This does not stack.",
      "long_description": "When a real enemy champion is destroyed, that champion's controller loses 8 nora. If that player has less than 8 nora in their nora bank, their Shrine or Avatar loses 5 HP instead.  This does not stack.",
      "class_name": "Tariff",
      "revision": 1
    },
    {
      "asset_id": 4722,
      "resettable": 0,
      "name": "Taunt",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1174,
      "activated": 1,
      "icon_name": "reckless_fury",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "This champion taunts your enemies.",
      "long_description": "This champion taunts your enemies.",
      "class_name": "Taunt",
      "revision": 1
    },
    {
      "asset_id": 4729,
      "resettable": 1,
      "name": "Taunt (18)",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1181,
      "activated": 1,
      "icon_name": "reckless_fury",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Taunt your enemies with the phrase \"x!\"",
      "long_description": "Taunt your enemies with the phrase \"x!\"",
      "class_name": "TauntNoMatch",
      "revision": 1
    },
    {
      "asset_id": 4730,
      "resettable": 1,
      "name": "Taunt (19)",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1182,
      "activated": 1,
      "icon_name": "reckless_fury",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Taunt your enemies with the phrase \"x!\"",
      "long_description": "Taunt your enemies with the phrase \"x!\"",
      "class_name": "TauntNoMatch",
      "revision": 1
    },
    {
      "asset_id": 4731,
      "resettable": 1,
      "name": "Taunt (20)",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1183,
      "activated": 1,
      "icon_name": "reckless_fury",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Taunt your enemies with the phrase \"x!\"",
      "long_description": "Taunt your enemies with the phrase \"x!\"",
      "class_name": "TauntNoMatch",
      "revision": 1
    },
    {
      "asset_id": 4732,
      "resettable": 1,
      "name": "Taunt (21)",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1184,
      "activated": 1,
      "icon_name": "reckless_fury",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Taunt your enemies with the phrase \"x!\"",
      "long_description": "Taunt your enemies with the phrase \"x!\"",
      "class_name": "TauntNoMatch",
      "revision": 1
    },
    {
      "asset_id": 4733,
      "resettable": 1,
      "name": "Taunt (22)",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1185,
      "activated": 1,
      "icon_name": "reckless_fury",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Taunt your enemies with the phrase \"x!\"",
      "long_description": "Taunt your enemies with the phrase \"x!\"",
      "class_name": "TauntNoMatch",
      "revision": 1
    },
    {
      "asset_id": 4734,
      "resettable": 1,
      "name": "Taunt (23)",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1186,
      "activated": 1,
      "icon_name": "reckless_fury",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Taunt your enemies with the phrase \"x!\"",
      "long_description": "Taunt your enemies with the phrase \"x!\"",
      "class_name": "TauntNoMatch",
      "revision": 1
    },
    {
      "asset_id": 4735,
      "resettable": 1,
      "name": "Taunt (24)",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1187,
      "activated": 1,
      "icon_name": "reckless_fury",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Taunt your enemies with the phrase \"x!\"",
      "long_description": "Taunt your enemies with the phrase \"x!\"",
      "class_name": "TauntNoMatch",
      "revision": 1
    },
    {
      "asset_id": 4736,
      "resettable": 1,
      "name": "Taunt (25)",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1188,
      "activated": 1,
      "icon_name": "reckless_fury",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Taunt your enemies with the phrase \"x!\"",
      "long_description": "Taunt your enemies with the phrase \"x!\"",
      "class_name": "TauntNoMatch",
      "revision": 1
    },
    {
      "asset_id": 4717,
      "resettable": 0,
      "name": "Taunt (Chaos, Panic, Disorder)",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1169,
      "activated": 1,
      "icon_name": "reckless_fury",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Taunt your enemies with the phrase \"Chaos, panic, and disorder...my work here is done.\"",
      "long_description": "Taunt your enemies with the phrase \"Chaos, panic, and disorder...my work here is done.\"",
      "class_name": "TauntWorkHere",
      "revision": 1
    },
    {
      "asset_id": 4719,
      "resettable": 0,
      "name": "Taunt (Did you think)",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1171,
      "activated": 1,
      "icon_name": "reckless_fury",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Taunt your enemies with the phrase \"Did you really think that was going to work?\"",
      "long_description": "Taunt your enemies with the phrase \"Did you really think that was going to work?\"",
      "class_name": "TauntDidYouThink",
      "revision": 1
    },
    {
      "asset_id": 4721,
      "resettable": 0,
      "name": "Taunt (Error)",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1173,
      "activated": 1,
      "icon_name": "reckless_fury",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Taunt your enemies with the phrase \"That error has cost you this battle!\"",
      "long_description": "Taunt your enemies with the phrase \"That error has cost you this battle!\"",
      "class_name": "TauntError",
      "revision": 1
    },
    {
      "asset_id": 4725,
      "resettable": 0,
      "name": "Taunt (Failed)",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1177,
      "activated": 1,
      "icon_name": "reckless_fury",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Taunt your enemies with the phrase \"Whatever kind of strategy you were going for, you failed.\"",
      "long_description": "Taunt your enemies with the phrase \"Whatever kind of strategy you were going for, you failed.\"",
      "class_name": "TauntFailed",
      "revision": 1
    },
    {
      "asset_id": 4724,
      "resettable": 0,
      "name": "Taunt (Go back)",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1176,
      "activated": 1,
      "icon_name": "reckless_fury",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Taunt your enemies with the phrase \"Go back to the Nora from whence you came!\"",
      "long_description": "Taunt your enemies with the phrase \"Go back to the Nora from whence you came!\"",
      "class_name": "TauntGoBack",
      "revision": 1
    },
    {
      "asset_id": 4716,
      "resettable": 0,
      "name": "Taunt (Haven't Started)",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1168,
      "activated": 1,
      "icon_name": "reckless_fury",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Taunt your enemies with the phrase \"You have lost and you haven't even started the battle yet.\"",
      "long_description": "Taunt your enemies with the phrase \"You have lost and you haven't even started the battle yet.\"",
      "class_name": "TauntHaventStarted",
      "revision": 1
    },
    {
      "asset_id": 4718,
      "resettable": 0,
      "name": "Taunt (Inexperienced)",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1170,
      "activated": 1,
      "icon_name": "reckless_fury",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Taunt your enemies with the phrase \"I like you. You remind me of when I was new and inexperienced.\"",
      "long_description": "Taunt your enemies with the phrase \"I like you. You remind me of when I was new and inexperienced.\"",
      "class_name": "TauntInexperienced",
      "revision": 1
    },
    {
      "asset_id": 4723,
      "resettable": 0,
      "name": "Taunt (Offend)",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1175,
      "activated": 1,
      "icon_name": "reckless_fury",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Taunt your enemies with the phrase \"You offend me with your meager attempts at combat!\"",
      "long_description": "Taunt your enemies with the phrase \"You offend me with your meager attempts at combat!\"",
      "class_name": "TauntOffend",
      "revision": 1
    },
    {
      "asset_id": 4720,
      "resettable": 0,
      "name": "Taunt (Surrender)",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1172,
      "activated": 1,
      "icon_name": "reckless_fury",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Taunt your enemies with the phrase \"Surrender now and save yourself the trouble!.",
      "long_description": "Taunt your enemies with the phrase \"Surrender now and save yourself the trouble!.",
      "class_name": "TauntSurrender",
      "revision": 1
    },
    {
      "asset_id": 4715,
      "resettable": 1,
      "name": "Taunt: Aria",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1167,
      "activated": 1,
      "icon_name": "reckless_fury",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Taunt your enemies.",
      "long_description": "Taunt your enemies.",
      "class_name": "TauntNotBright",
      "revision": 1
    },
    {
      "asset_id": 4727,
      "resettable": 0,
      "name": "Taunt: Blood Owl",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1179,
      "activated": 1,
      "icon_name": "reckless_fury",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Taunt your enemies with the phrase \"Now you will see my true power!\"",
      "long_description": "Taunt your enemies with the phrase \"Now you will see my true power!\"",
      "class_name": "TauntMyPower",
      "revision": 1
    },
    {
      "asset_id": 4726,
      "resettable": 1,
      "name": "Taunt: Doom",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1178,
      "activated": 1,
      "icon_name": "reckless_fury",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Taunt your enemies with the phrase \"DOOOOOOM!\"",
      "long_description": "Taunt your enemies with the phrase \"DOOOOOOM!\"",
      "class_name": "TauntDestroyThem",
      "revision": 1
    },
    {
      "asset_id": 4719,
      "resettable": 0,
      "name": "Taunt: Legions",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3369,
      "activated": 1,
      "icon_name": "reckless_fury",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Taunt your enemies with the phrase \"To battle, my LEGIONS!\"",
      "long_description": "Taunt your enemies with the phrase \"To battle, my LEGIONS!\"",
      "class_name": "TauntLegions",
      "revision": 1
    },
    {
      "asset_id": 4720,
      "resettable": 0,
      "name": "Taunt: Maxxarek",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3370,
      "activated": 1,
      "icon_name": "reckless_fury",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Taunt your enemies with the phrase \"Here comes Maxxarek!\"",
      "long_description": "Taunt your enemies with the phrase \"Here comes Maxxarek!\"",
      "class_name": "TauntMaxxarek",
      "revision": 1
    },
    {
      "asset_id": 4721,
      "resettable": 1,
      "name": "Taunt: Nisk",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1180,
      "activated": 1,
      "icon_name": "reckless_fury",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Taunt your enemies with the phrase \"That error has cost you this battle!\"",
      "long_description": "Taunt your enemies with the phrase \"That error has cost you this battle!\"",
      "class_name": "TauntError",
      "revision": 1
    },
    {
      "asset_id": 4713,
      "resettable": 1,
      "name": "Taunt: Pyro",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1166,
      "activated": 1,
      "icon_name": "reckless_fury",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Taunt your enemies.",
      "long_description": "Taunt your enemies.",
      "class_name": "TauntNoMatch",
      "revision": 1
    },
    {
      "asset_id": 4718,
      "resettable": 0,
      "name": "Taunt: Raava",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3368,
      "activated": 1,
      "icon_name": "reckless_fury",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Taunt your enemies with the phrase \"Time is wasted on you!\"",
      "long_description": "Taunt your enemies with the phrase \"Time is wasted on you!\"",
      "class_name": "TauntRaava",
      "revision": 1
    },
    {
      "asset_id": 4712,
      "resettable": 1,
      "name": "Taunt: Ryv",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1165,
      "activated": 1,
      "icon_name": "reckless_fury",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Taunt your enemies.",
      "long_description": "Taunt your enemies.",
      "class_name": "TauntWhispering",
      "revision": 1
    },
    {
      "asset_id": 4709,
      "resettable": 1,
      "name": "Taunt: Vallassa",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1162,
      "activated": 1,
      "icon_name": "reckless_fury",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Taunt your enemies.",
      "long_description": "Taunt your enemies.",
      "class_name": "TauntDarkfire",
      "revision": 1
    },
    {
      "asset_id": 4536,
      "resettable": 1,
      "name": "Team",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 862,
      "activated": 1,
      "icon_name": "marauder",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 18,
      "short_description": "When this unit dies, no nora globe is dropped and it re-spawns in the same space, but gets -2 DMG, loses Multiattack and Team.",
      "long_description": "When this unit dies, no nora globe is dropped and it re-spawns in the same space, but gets -2 DMG, loses Multiattack and Team.",
      "class_name": "Team",
      "revision": 1
    },
    {
      "asset_id": 5094,
      "resettable": 1,
      "name": "Tectonic Pulse",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 1270,
      "activated": 1,
      "icon_name": "physicalaoe",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "This champion makes an attack against target champion within 2-5 spaces, in a straight line, at DMG 15. When this attack is made, the intervening spaces between this champion and the target become <mechanic value=unstableground>Unstable Ground</mechanic> until the end of your enemy's turn. When this attack deals 1 or more damage to the target, that champion is knocked back 2 spaces.",
      "long_description": "This champion makes an attack against target champion within 2-5 spaces, in a straight line, at DMG 15. When this attack is made, the intervening spaces between this champion and the target become <mechanic value=unstableground>Unstable Ground</mechanic> until the end of your enemy's turn. When this attack deals 1 or more damage to the target, that champion is knocked back 2 spaces.",
      "class_name": "TectonicPulse",
      "revision": 1
    },
    {
      "asset_id": 5001,
      "resettable": 1,
      "name": "Telekinetic Thrust",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 1881,
      "activated": 1,
      "icon_name": "knockback",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "Target opposing champion within 4 spaces takes 6 physical damage and is knocked back 3 spaces (this damage ignores DEF).",
      "long_description": "Target opposing champion within 4 spaces takes 6 physical damage and is knocked back 3 spaces (this damage ignores DEF).",
      "class_name": "TelekineticThrust",
      "revision": 1
    },
    {
      "asset_id": 4151,
      "resettable": 1,
      "name": "Teleport",
      "ap_cost": 4,
      "level": 1,
      "ability_id": 406,
      "activated": 1,
      "icon_name": "relocate",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 1,
      "cost": 6,
      "short_description": "This champion loses <condition value=rooted>Rooted</condition> and is relocated to target space within 5 spaces.",
      "long_description": "This champion loses <condition value=rooted>Rooted</condition> and is relocated to target space within 5 spaces.",
      "class_name": "Teleport",
      "revision": 1
    },
    {
      "asset_id": 4151,
      "resettable": 1,
      "name": "Teleport",
      "ap_cost": 4,
      "level": 2,
      "ability_id": 407,
      "activated": 1,
      "icon_name": "relocate",
      "comments": "none",
      "prerequisite_id": 406,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 1,
      "cost": 10,
      "short_description": "This champion loses <condition value=rooted>Rooted</condition> and is relocated to target space within 6 spaces.",
      "long_description": "This champion loses <condition value=rooted>Rooted</condition> and is relocated to target space within 6 spaces.",
      "class_name": "Teleport",
      "revision": 1
    },
    {
      "asset_id": 4151,
      "resettable": 1,
      "name": "Teleport",
      "ap_cost": 4,
      "level": 3,
      "ability_id": 408,
      "activated": 1,
      "icon_name": "relocate",
      "comments": "none",
      "prerequisite_id": 407,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 1,
      "cost": 14,
      "short_description": "This champion loses <condition value=rooted>Rooted</condition> and is relocated to target space within 7 spaces.",
      "long_description": "This champion loses <condition value=rooted>Rooted</condition> and is relocated to target space within 7 spaces.",
      "class_name": "Teleport",
      "revision": 1
    },
    {
      "asset_id": 4151,
      "resettable": 0,
      "name": "Teleport (Relic)",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3396,
      "activated": 1,
      "icon_name": "relocate",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "This unit is relocated to target space within 5 spaces.",
      "long_description": "This unit is relocated to target space within 5 spaces.",
      "class_name": "TeleportRelic",
      "revision": 1
    },
    {
      "asset_id": 5824,
      "resettable": 1,
      "name": "Teleport: Blood Ball",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 2833,
      "activated": 1,
      "icon_name": "relocate",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "This champion relocates to a Blood Ball within 6 spaces.",
      "long_description": "This champion relocates to a Blood Ball within 6 spaces.",
      "class_name": "RelocateBloodBall",
      "revision": 1
    },
    {
      "asset_id": 7183,
      "resettable": 0,
      "name": "Teleport: Equipped",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 3024,
      "activated": 1,
      "icon_name": "relocate_equipped",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 3,
      "short_description": "This champion is relocated to target equipped champion within 5 spaces.",
      "long_description": "This champion is relocated to target equipped champion within 5 spaces.",
      "class_name": "TeleportEquipped",
      "revision": 1
    },
    {
      "asset_id": 7183,
      "resettable": 0,
      "name": "Teleport: Equipped (Relic)",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3344,
      "activated": 1,
      "icon_name": "relocate_equipped",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 3,
      "short_description": "This champion is relocated to target equipped champion within 5 spaces.",
      "long_description": "This champion is relocated to target equipped champion within 5 spaces.",
      "class_name": "TeleportEquipped",
      "revision": 1
    },
    {
      "asset_id": 5240,
      "resettable": 1,
      "name": "Temple of Brutality",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2020,
      "activated": 1,
      "icon_name": "drain",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "Friendly demons and beasts within 4 spaces of this relic gain <ability value=347>Berserk Attack 2</ability> and <ability value=260>Enrage 2</ability>.",
      "long_description": "Friendly demons and beasts within 4 spaces of this relic gain <ability value=347>Berserk Attack 2</ability> and <ability value=260>Enrage 2</ability>.",
      "class_name": "RelicTempleOfBrutality",
      "revision": 1
    },
    {
      "asset_id": 5095,
      "resettable": 1,
      "name": "Tempo",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1271,
      "activated": 1,
      "icon_name": "dancesong",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "When a spell is successfully cast, this champion gains 1 AP.",
      "long_description": "When a spell is successfully cast, this champion gains 1 AP.",
      "class_name": "Tempo",
      "revision": 1
    },
    {
      "asset_id": 7192,
      "resettable": 0,
      "name": "Terminus",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3035,
      "activated": 1,
      "icon_name": "terminus",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "When a champion within 8 spaces loses AP, this champion gains AP equal to the amount lost, to a maximum of 4 AP per turn.",
      "long_description": "When a champion within 8 spaces loses AP, this champion gains AP equal to the amount lost, to a maximum of 4 AP per turn.",
      "class_name": "Terminus",
      "revision": 1
    },
    {
      "asset_id": 4245,
      "resettable": 1,
      "name": "Terraform: Dirt",
      "ap_cost": 1,
      "level": 1,
      "ability_id": 631,
      "activated": 1,
      "icon_name": "terrainmud",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 3,
      "short_description": "Target space within 3 spaces, and all spaces adjacent to it, are Dirt for 6 turns.",
      "long_description": "Target space within 3 spaces, and all spaces adjacent to it, are Dirt for 6 turns.",
      "class_name": "TerraformDirt",
      "revision": 1
    },
    {
      "asset_id": 4245,
      "resettable": 1,
      "name": "Terraform: Dirt",
      "ap_cost": 1,
      "level": 2,
      "ability_id": 635,
      "activated": 1,
      "icon_name": "terrainmud",
      "comments": "",
      "prerequisite_id": 631,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 1,
      "cost": 4,
      "short_description": "Target space within 3 spaces, and all spaces adjacent to it, are Dirt for 6 turns.",
      "long_description": "Target space within 3 spaces, and all spaces adjacent to it, are Dirt for 6 turns.",
      "class_name": "TerraformDirt",
      "revision": 1
    },
    {
      "asset_id": 4248,
      "resettable": 1,
      "name": "Terraform: Ice",
      "ap_cost": 2,
      "level": 1,
      "ability_id": 634,
      "activated": 1,
      "icon_name": "terrainice",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 3,
      "short_description": "This champion has Icewalker. Target space within 3 spaces, and all spaces adjacent to it, are <mechanic value=ice_terrain>Ice Terrain</mechanic> for 6 turns.",
      "long_description": "This champion has Icewalker. Target space within 3 spaces, and all spaces adjacent to it, are <mechanic value=ice_terrain>Ice Terrain</mechanic> for 6 turns.",
      "class_name": "TerraformIce",
      "revision": 1
    },
    {
      "asset_id": 4248,
      "resettable": 1,
      "name": "Terraform: Ice",
      "ap_cost": 2,
      "level": 2,
      "ability_id": 638,
      "activated": 1,
      "icon_name": "terrainice",
      "comments": "",
      "prerequisite_id": 634,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 1,
      "cost": 4,
      "short_description": "This champion has Icewalker. Target space within 3 spaces, and all spaces adjacent to it, are <mechanic value=ice_terrain>Ice Terrain</mechanic> for 6 turns.",
      "long_description": "This champion has Icewalker. Target space within 3 spaces, and all spaces adjacent to it, are <mechanic value=ice_terrain>Ice Terrain</mechanic> for 6 turns.",
      "class_name": "TerraformIce",
      "revision": 1
    },
    {
      "asset_id": 4247,
      "resettable": 1,
      "name": "Terraform: Lava",
      "ap_cost": 2,
      "level": 1,
      "ability_id": 633,
      "activated": 1,
      "icon_name": "terrainlava",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 4,
      "short_description": "This champion has <ability value=480>Lavawalker</ability>. Target space within 3 spaces is Lava (Impeding 1, 8 Fire damage on entry and when occupied) for 6 turns.",
      "long_description": "This champion has <ability value=480>Lavawalker</ability>. Target space within 3 spaces is Lava (Impeding 1, 8 Fire damage on entry and when occupied) for 6 turns.",
      "class_name": "TerraformLava",
      "revision": 1
    },
    {
      "asset_id": 4247,
      "resettable": 1,
      "name": "Terraform: Lava",
      "ap_cost": 2,
      "level": 2,
      "ability_id": 637,
      "activated": 1,
      "icon_name": "terrainlava",
      "comments": "",
      "prerequisite_id": 633,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 1,
      "cost": 8,
      "short_description": "This champion has <ability value=480>Lavawalker</ability>. Target space within 3 spaces is Lava (Impeding 1, 8 Fire damage on entry and when occupied) for 6 turns.",
      "long_description": "This champion has <ability value=480>Lavawalker</ability>. Target space within 3 spaces is Lava (Impeding 1, 8 Fire damage on entry and when occupied) for 6 turns.",
      "class_name": "TerraformLava",
      "revision": 1
    },
    {
      "asset_id": 5256,
      "resettable": 1,
      "name": "Terraform: Rock",
      "ap_cost": 2,
      "level": 1,
      "ability_id": 2036,
      "activated": 1,
      "icon_name": "terrainrock",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 3,
      "short_description": "Target space within 3 spaces, and all spaces adjacent to it, are Rock for 6 turns. Any friendly champion occupying target space gains <ability value=2414>Throw Boulder</ability> for 1 turn.",
      "long_description": "Target space within 3 spaces, and all spaces adjacent to it, are Rock for 6 turns. Any friendly champion occupying target space gains <ability value=2414>Throw Boulder</ability> for 1 turn.",
      "class_name": "TerraformRock",
      "revision": 1
    },
    {
      "asset_id": 5256,
      "resettable": 1,
      "name": "Terraform: Rock",
      "ap_cost": 2,
      "level": 2,
      "ability_id": 2037,
      "activated": 1,
      "icon_name": "terrainrock",
      "comments": "",
      "prerequisite_id": 2036,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 1,
      "cost": 4,
      "short_description": "Target space within 3 spaces, and all spaces adjacent to it, are Rock for 6 turns. Any friendly champion occupying target space gains <ability value=2414>Throw Boulder</ability> for 1 turn.",
      "long_description": "Target space within 3 spaces, and all spaces adjacent to it, are Rock for 6 turns. Any friendly champion occupying target space gains <ability value=2414>Throw Boulder</ability> for 1 turn.",
      "class_name": "TerraformRock",
      "revision": 1
    },
    {
      "asset_id": 4246,
      "resettable": 1,
      "name": "Terraform: Water",
      "ap_cost": 2,
      "level": 1,
      "ability_id": 632,
      "activated": 1,
      "icon_name": "terrainwater",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 3,
      "short_description": "This champion is <ability value=2>Amphibious</ability>. Target space within 3 spaces, and all spaces adjacent to it, are Water (Impeding 1) for 6 turns.",
      "long_description": "This champion is <ability value=2>Amphibious</ability>. Target space within 3 spaces, and all spaces adjacent to it, are Water (Impeding 1) for 6 turns.",
      "class_name": "TerraformWater",
      "revision": 1
    },
    {
      "asset_id": 4246,
      "resettable": 1,
      "name": "Terraform: Water",
      "ap_cost": 2,
      "level": 2,
      "ability_id": 636,
      "activated": 1,
      "icon_name": "terrainwater",
      "comments": "",
      "prerequisite_id": 632,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 1,
      "cost": 4,
      "short_description": "This champion is <ability value=2>Amphibious</ability>. Target space within 3 spaces, and all spaces adjacent to it, are Water (Impeding 1) for 6 turns.",
      "long_description": "This champion is <ability value=2>Amphibious</ability>. Target space within 3 spaces, and all spaces adjacent to it, are Water (Impeding 1) for 6 turns.",
      "class_name": "TerraformWater",
      "revision": 1
    },
    {
      "asset_id": 5603,
      "resettable": 1,
      "name": "Terraformer",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 830,
      "activated": 1,
      "icon_name": "terrainrock",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "This unit can walk unhindered over any terrain types it can terraform.",
      "long_description": "This unit can walk unhindered over any terrain types it can terraform.",
      "class_name": "TestAbility",
      "revision": 1
    },
    {
      "asset_id": 4376,
      "resettable": 1,
      "name": "Terrain Stabilizer",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1415,
      "activated": 1,
      "icon_name": "terrainrock",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "When a spell or an ability cast by your enemy would cause the terrain to change, the terrain changes to Rock instead.",
      "long_description": "When a spell or an ability cast by your enemy would cause the terrain to change, the terrain changes to Rock instead.",
      "class_name": "RelicTerrainStabilizer",
      "revision": 1
    },
    {
      "asset_id": 4108,
      "resettable": 1,
      "name": "Territorial",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2697,
      "activated": 1,
      "icon_name": "pack_leader",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "When an opposing non-Illusion champion is deployed within 8 spaces, this champion gains <ability value=15>Multiattack 1</ability>, <ability value=259>Enrage 1</ability>, +4 DMG, +1 DEF and +1 SPD for 4 turns. This can trigger up to 2 times per turn.",
      "long_description": "When an opposing non-Illusion champion is deployed within 8 spaces, this champion gains <ability value=15>Multiattack 1</ability>, <ability value=259>Enrage 1</ability>, +4 DMG, +1 DEF and +1 SPD for 4 turns. This can trigger up to 2 times per turn.",
      "class_name": "Territorial",
      "revision": 1
    },
    {
      "asset_id": 5898,
      "resettable": 1,
      "name": "Terrorize",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 2909,
      "activated": 1,
      "icon_name": "ignore_invite",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 5,
      "short_description": "Target enemy champion within 4 spaces becomes <condition value=frightened>Frightened</condition> for 3 turns. If that champion becomes Frightened, it is relocated 4 spaces away.",
      "long_description": "Target enemy champion within 4 spaces becomes <condition value=frightened>Frightened</condition> for 3 turns. If that champion becomes Frightened, it is relocated 4 spaces away.",
      "class_name": "Terrify",
      "revision": 1
    },
    {
      "asset_id": 4987,
      "resettable": 1,
      "name": "test Ability",
      "ap_cost": 5,
      "level": 0,
      "ability_id": 2000,
      "activated": 1,
      "icon_name": "",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 5,
      "short_description": "This is a test ability.",
      "long_description": "TTTHHHIIISSS IIISSS AAA TTTEEESSSTTT AAABBBIIILLLIIITTTYYY.",
      "class_name": "test",
      "revision": 1
    },
    {
      "asset_id": 5430,
      "resettable": 1,
      "name": "Tetra Shield",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2280,
      "activated": 1,
      "icon_name": "tetra_shield",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 5,
      "short_description": "When this champion comes into play and at the start of each of its turns, it gains immunity to one of the following damage types at random for 2 turns: Physical, Fire or Electricity. ",
      "long_description": "When this champion comes into play and at the start of each of its turns, it gains immunity to one of the following damage types at random for 2 turns: Physical, Fire or Electricity. ",
      "class_name": "TetraShield",
      "revision": 1
    },
    {
      "asset_id": 7236,
      "resettable": 0,
      "name": "The Farm: Beasts",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3054,
      "activated": 1,
      "icon_name": "soul_bond",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Friendly Beasts gain <ability value=1320>Assault</ability>. This shares a CD with removes the effects of The Farm: Mutants when activated.",
      "long_description": "Friendly Beasts gain <ability value=1320>Assault</ability>. This shares a CD with removes the effects of The Farm: Mutants when activated.",
      "class_name": "TheFarmBeasts",
      "revision": 1
    },
    {
      "asset_id": 7237,
      "resettable": 0,
      "name": "The Farm: Mutants",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3055,
      "activated": 1,
      "icon_name": "soul_bond",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Friendly Mutants gain <ability value=2324>Pounce</ability>. This shares a CD with removes the effects of The Farm: Beasts when activated.",
      "long_description": "Friendly Mutants gain <ability value=2324>Pounce</ability>. This shares a CD with removes the effects of The Farm: Beasts when activated.",
      "class_name": "TheFarmMutants",
      "revision": 1
    },
    {
      "asset_id": 7234,
      "resettable": 0,
      "name": "The Resistance: Elemental",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3053,
      "activated": 1,
      "icon_name": "soul_bond",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Friendly Elementals gain Explosive Attack 1. This shares a CD with The Resistance: Hyaenid and activating this ability removes the effects of The Resistance: Hyaenid.",
      "long_description": "Friendly Elementals gain Explosive Attack 1. This shares a CD with The Resistance: Hyaenid and activating this ability removes the effects of The Resistance: Hyaenid.",
      "class_name": "TheResistanceDjinn",
      "revision": 1
    },
    {
      "asset_id": 7233,
      "resettable": 0,
      "name": "The Resistance: Hyaenids",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3052,
      "activated": 1,
      "icon_name": "soul_bond",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Friendly Hyaenids gain Mobility. This shares a CD with and removes the effects of The Resistance: Elemental when activated.",
      "long_description": "Friendly Hyaenids gain Mobility. This shares a CD with and removes the effects of The Resistance: Elemental when activated.",
      "class_name": "TheResistanceHyaenids",
      "revision": 1
    },
    {
      "asset_id": 5443,
      "resettable": 1,
      "name": "Thirst for Battle",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2295,
      "activated": 1,
      "icon_name": "thirst_for_battle",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 10,
      "short_description": "At the end of its turn, this unit permanently gains +2 DMG and +1 DEF if it is engaged.",
      "long_description": "At the end of its turn, this unit permanently gains +2 DMG and +1 DEF if it is engaged.",
      "class_name": "ThirstForBattle",
      "revision": 1
    },
    {
      "asset_id": 4613,
      "resettable": 1,
      "name": "Thorn Trap",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1028,
      "activated": 1,
      "icon_name": "trapthorn",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "When an enemy unit moves within 2 spaces of the trap, the relic is destroyed and enemy units within range take 6 physical damage and lose 40% SPD for 5 turns. This damage ignores DEF. All affected units become <condition value=eviscerated>Eviscerated</condition> for 5 turns.",
      "long_description": "When an enemy unit moves within 2 spaces of the trap, the relic is destroyed and enemy units within range take 6 physical damage and lose 40% SPD for 5 turns. This damage ignores DEF. All affected units become <condition value=eviscerated>Eviscerated</condition> for 5 turns.",
      "class_name": "RelicThornTrap",
      "revision": 1
    },
    {
      "asset_id": 4974,
      "resettable": 1,
      "name": "Thrash",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 1856,
      "activated": 1,
      "icon_name": "fear",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "This champion loses HP equal to 50% of its current damage.  All enemy champions within 5 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
      "long_description": "This champion loses HP equal to 50% of its current damage.  All enemy champions within 5 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
      "class_name": "Thrash",
      "revision": 1
    },
    {
      "asset_id": 5747,
      "resettable": 1,
      "name": "Three Wishes",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2641,
      "activated": 1,
      "icon_name": "fascinate",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "Target champion within 3 spaces gains both of this units selected upgrade abilities. This ability is removed after 3 uses.",
      "long_description": "Target champion within 3 spaces gains both of this units selected upgrade abilities. This ability is removed after 3 uses.",
      "class_name": "ThreeWishes",
      "revision": 1
    },
    {
      "asset_id": 5242,
      "resettable": 1,
      "name": "Throne of the Circle",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2022,
      "activated": 1,
      "icon_name": "special",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "Friendly Wizards have Spell Resistance and Magic Nova 3.",
      "long_description": "Friendly Wizards have Spell Resistance and Magic Nova 3.",
      "class_name": "RelicThroneOfTheEternalCircle",
      "revision": 1
    },
    {
      "asset_id": 4334,
      "resettable": 1,
      "name": "Throw Axe",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 1362,
      "activated": 1,
      "icon_name": "whirl",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 5,
      "short_description": "This unit makes a Physical attack at RNG 2-5.  If successful, the target has -1 DEF for 5 turns.",
      "long_description": "This unit makes a Physical attack at RNG 2-5.  If successful, the target has -1 DEF for 5 turns.",
      "class_name": "ThrowAxe",
      "revision": 1
    },
    {
      "asset_id": 5554,
      "resettable": 1,
      "name": "Throw Boulder",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 2414,
      "activated": 1,
      "icon_name": "rock",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 5,
      "short_description": "This champion makes a Physical attack at RNG 2-5. This attack causes <condition value=awestruck>Awestruck</condition> for 2 turns.",
      "long_description": "This champion makes a Physical attack at RNG 2-5. This attack causes <condition value=awestruck>Awestruck</condition> for 2 turns.",
      "class_name": "ChuckBoulder",
      "revision": 1
    },
    {
      "asset_id": 4219,
      "resettable": 1,
      "name": "Throw Champion",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 817,
      "activated": 1,
      "icon_name": "throw_champ",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 15,
      "short_description": "Target adjacent friendly champion gains Catapult (This unit leaps to target location within 5 spaces).",
      "long_description": "Target adjacent friendly champion gains Catapult (This unit leaps to target location within 5 spaces).",
      "class_name": "DwarvenCatapult",
      "revision": 1
    },
    {
      "asset_id": 4747,
      "resettable": 1,
      "name": "Throw Javelin",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 2576,
      "activated": 1,
      "icon_name": "spear",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 3,
      "short_description": "This champion makes a Physical attack at range 2-5.",
      "long_description": "This champion makes a Physical attack at range 2-5.",
      "class_name": "ShieldThrow",
      "revision": 1
    },
    {
      "asset_id": 4747,
      "resettable": 1,
      "name": "Throw Shield",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 1505,
      "activated": 1,
      "icon_name": "throw_shield",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 3,
      "short_description": "This champion makes a Physical attack at range 2-5.",
      "long_description": "This champion makes a Physical attack at range 2-5.",
      "class_name": "ShieldThrow",
      "revision": 1
    },
    {
      "asset_id": 4906,
      "resettable": 1,
      "name": "Thunder Strike",
      "ap_cost": 1,
      "level": 1,
      "ability_id": 1661,
      "activated": 1,
      "icon_name": "electricaoe",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 6,
      "activation_type": 1,
      "ranked": 1,
      "cost": 2,
      "short_description": "Target champion within 5 spaces takes 8 Electricity damage, then each champion within 2 spaces of the target takes 5 Electricity damage, then each champion within 2 spaces of those champions takes 2 Electricity damage. All affected units loses all AP. This damage ignores DEF. A single champion may not take more than one instance of damage from this effect.",
      "long_description": "Target champion within 5 spaces takes 8 Electricity damage, then each champion within 2 spaces of the target takes 5 Electricity damage, then each champion within 2 spaces of those champions takes 2 Electricity damage. All affected units loses all AP. This damage ignores DEF. A single champion may not take more than one instance of damage from this effect.",
      "class_name": "ThunderStrike",
      "revision": 1
    },
    {
      "asset_id": 4906,
      "resettable": 1,
      "name": "Thunder Strike",
      "ap_cost": 1,
      "level": 2,
      "ability_id": 1662,
      "activated": 1,
      "icon_name": "electricaoe",
      "comments": "none",
      "prerequisite_id": 1661,
      "cooldown": 6,
      "activation_type": 1,
      "ranked": 1,
      "cost": 2,
      "short_description": "Target champion within 5 spaces takes 9 Electricity damage, then each champion within 2 spaces of the target takes 6 Electricity damage, then each champion within 2 spaces of those champions takes 3 Electricity damage. All affected units loses all AP. This damage ignores DEF. A single champion may not take more than one instance of damage from this effect.",
      "long_description": "Target champion within 5 spaces takes 9 Electricity damage, then each champion within 2 spaces of the target takes 6 Electricity damage, then each champion within 2 spaces of those champions takes 3 Electricity damage. All affected units loses all AP. This damage ignores DEF. A single champion may not take more than one instance of damage from this effect.",
      "class_name": "ThunderStrike",
      "revision": 1
    },
    {
      "asset_id": 4906,
      "resettable": 1,
      "name": "Thunder Strike",
      "ap_cost": 1,
      "level": 3,
      "ability_id": 1663,
      "activated": 1,
      "icon_name": "electricaoe",
      "comments": "none",
      "prerequisite_id": 1662,
      "cooldown": 6,
      "activation_type": 1,
      "ranked": 1,
      "cost": 2,
      "short_description": "Target champion within 5 spaces takes 17 Electricity damage, then each champion within 2 spaces of the target takes 14 Electricity damage, then each champion within 2 spaces of those champions takes 11 Electricity damage. All affected units loses all AP. This damage ignores DEF. A single champion may not take more than one instance of damage from this effect.",
      "long_description": "Target champion within 5 spaces takes 17 Electricity damage, then each champion within 2 spaces of the target takes 14 Electricity damage, then each champion within 2 spaces of those champions takes 11 Electricity damage. All affected units loses all AP. This damage ignores DEF. A single champion may not take more than one instance of damage from this effect.",
      "class_name": "ThunderStrike",
      "revision": 1
    },
    {
      "asset_id": 7246,
      "resettable": 0,
      "name": "Thunderous Charge",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3059,
      "activated": 1,
      "icon_name": "thunderous_charge",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this champion makes a successful Charge attack, the target and enemy champions within 2 spaces of the target become <condition value=slowed>Slowed</condition> for 2 turns.",
      "long_description": "When this champion makes a successful Charge attack, the target and enemy champions within 2 spaces of the target become <condition value=slowed>Slowed</condition> for 2 turns.",
      "class_name": "ThunderousCharge",
      "revision": 1
    },
    {
      "asset_id": 4484,
      "resettable": 1,
      "name": "Tidal Wave",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 883,
      "activated": 1,
      "icon_name": "tsunami",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "Area Effect 2, Range 5: Affected Non-Aquatic, non-Semi-aquatic, and non-Amphibious champions take 12 Physical damage.  This damage ignores DEF.  For 3 turns, spaces within the affected area are Shallow Water.",
      "long_description": "Area Effect 2, Range 5: Affected Non-Aquatic, non-Semi-aquatic, and non-Amphibious champions take 12 Physical damage.  This damage ignores DEF.  For 3 turns, spaces within the affected area are Shallow Water.",
      "class_name": "TidalWave",
      "revision": 1
    },
    {
      "asset_id": 4467,
      "resettable": 1,
      "name": "Time Bend",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2748,
      "activated": 1,
      "icon_name": "confuse",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 12,
      "short_description": "This champion is removed from play. At the end of 2 turns, it is returned to play in the location where it was removed from play. If that location is occupied, the redeployment effect is delayed for 1 turn (this process repeats until the unit is successfully redeployed). This ability begins on CD.",
      "long_description": "This champion is removed from play. At the end of 2 turns, it is returned to play in the location where it was removed from play. If that location is occupied, the redeployment effect is delayed for 1 turn (this process repeats until the unit is successfully redeployed). This ability begins on CD.",
      "class_name": "TimeBend",
      "revision": 1
    },
    {
      "asset_id": 5096,
      "resettable": 1,
      "name": "Titan",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1272,
      "activated": 1,
      "icon_name": "titan",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "This unit has <ability value=3>Fearless</ability>, <ability value=680>Planar Bound</ability>, <ability value=814 popup=false>Unequippable</ability>, <ability value=4>Iron Will</ability>, <ability value=597>Unstoppable</ability>, <ability value=942>Eternal</ability>, <ability value=1201>Clear</ability> and <ability value=3379>Magic Ward</ability>. If this champion is deployed when you have less than 3 real champions in play, it is destroyed.",
      "long_description": "This unit has <ability value=3>Fearless</ability>, <ability value=680>Planar Bound</ability>, <ability value=814 popup=false>Unequippable</ability>, <ability value=4>Iron Will</ability>, <ability value=597>Unstoppable</ability>, <ability value=942>Eternal</ability>, <ability value=1201>Clear</ability> and <ability value=3379>Magic Ward</ability>. If this champion is deployed when you have less than 3 real champions in play, it is destroyed.",
      "class_name": "Titan",
      "revision": 1
    },
    {
      "asset_id": 4748,
      "resettable": 1,
      "name": "Tithe to Serkan",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1506,
      "activated": 1,
      "icon_name": "blessed",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -8,
      "short_description": "Other friendly Liches have their DMG reduced by 1.",
      "long_description": "Other friendly Liches have their DMG reduced by 1.",
      "class_name": "TithetoSerkan",
      "revision": 1
    },
    {
      "asset_id": 7489,
      "resettable": 0,
      "name": "Tomb Marker",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3171,
      "activated": 1,
      "icon_name": "tombdrop",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "This relic will turn into Tomb Sentinel.",
      "long_description": "This relic will turn into Tomb Sentinel.",
      "class_name": "TombMarker",
      "revision": 1
    },
    {
      "asset_id": 4186,
      "resettable": 1,
      "name": "Tome of Hate",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 528,
      "activated": 1,
      "icon_name": "drain",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "At the end of your turn, if your shrine is damaged each champion loses 2 HP, and then your shrine heals 1 HP for each champion that lost HP this way. Otherwise, this relic loses 2 HP.",
      "long_description": "At the end of your turn, if your shrine is damaged each champion loses 2 HP, and then your shrine heals 1 HP for each champion that lost HP this way. Otherwise, this relic loses 2 HP.",
      "class_name": "RelicTomeOfHate",
      "revision": 1
    },
    {
      "asset_id": 4569,
      "resettable": 1,
      "name": "Torch",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 1011,
      "activated": 1,
      "icon_name": "cataclysm",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 3,
      "short_description": "When an enemy champion is healed, the source of the healing loses HP equal to 25% of the total amount healed. If that source is a spell, all champions affected take the damage. This effect does not stack.",
      "long_description": "When an enemy champion is healed, the source of the healing loses HP equal to 25% of the total amount healed. If that source is a spell, all champions affected take the damage. This effect does not stack.",
      "class_name": "Torch",
      "revision": 1
    },
    {
      "asset_id": 4569,
      "resettable": 1,
      "name": "Torch",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 1012,
      "activated": 1,
      "icon_name": "cataclysm",
      "comments": "",
      "prerequisite_id": 1011,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 6,
      "short_description": "When an enemy champion is healed, the source of the healing loses HP equal to 50% of the total amount healed. If that source is a spell, all champions affected take the damage. This effect does not stack.",
      "long_description": "When an enemy champion is healed, the source of the healing loses HP equal to 50% of the total amount healed. If that source is a spell, all champions affected take the damage. This effect does not stack.",
      "class_name": "Torch",
      "revision": 1
    },
    {
      "asset_id": 4476,
      "resettable": 1,
      "name": "Tormented",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 861,
      "activated": 1,
      "icon_name": "enrage",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 3,
      "short_description": "This unit receives a damage boost when injured. If at 80% of max HP, it gains +1 DMG. At 60% it gains +2 DMG, at 40% it gains +3 DMG and at 20% it gains +4 DMG.",
      "long_description": "This unit receives a damage boost when injured. If at 80% of max HP, it gains +1 DMG. At 60% it gains +2 DMG, at 40% it gains +3 DMG and at 20% it gains +4 DMG.",
      "class_name": "Tormented",
      "revision": 1
    },
    {
      "asset_id": 7120,
      "resettable": 0,
      "name": "Tortun Shell",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2929,
      "activated": 1,
      "icon_name": "turtle",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -6,
      "short_description": "This champion has <ability value=2093>Ponderous</ability>, <ability value=2>Amphibious</ability>, <ability value=647>Turtle</ability> and <ability value=3161>Stability</ability>.",
      "long_description": "This champion has <ability value=2093>Ponderous</ability>, <ability value=2>Amphibious</ability>, <ability value=647>Turtle</ability> and <ability value=3161>Stability</ability>.",
      "class_name": "TortunShell",
      "revision": 1
    },
    {
      "asset_id": 4470,
      "resettable": 1,
      "name": "Tortun's Trade",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2152,
      "activated": 1,
      "icon_name": "plunder",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "This ability costs 4 nora to activate.  Target Tortun within 5 spaces gains 2 AP.  Each Tortun may be the target of one Tortun's Trade ability per turn.  This ability begins on CD.",
      "long_description": "This ability costs 4 nora to activate.  Target Tortun within 5 spaces gains 2 AP.  Each Tortun may be the target of one Tortun's Trade ability per turn.  This ability begins on CD.",
      "class_name": "TortunsTrade",
      "revision": 1
    },
    {
      "asset_id": 7321,
      "resettable": 0,
      "name": "Toss Equipment",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 3097,
      "activated": 1,
      "icon_name": "comboatk_devastate",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 2,
      "short_description": "This champion's equipment is destroyed and target unequipped champion within 5 spaces is then equipped with that equipment.",
      "long_description": "This champion's equipment is destroyed and target unequipped champion within 5 spaces is then equipped with that equipment.",
      "class_name": "TossEquipment",
      "revision": 1
    },
    {
      "asset_id": 5453,
      "resettable": 1,
      "name": "Toss Globule",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2305,
      "activated": 1,
      "icon_name": "toss_globule",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 2,
      "short_description": "Target unequipped opposing champion within 5 spaces gains this unit's equipment.",
      "long_description": "Target unequipped opposing champion within 5 spaces gains this unit's equipment.",
      "class_name": "Toss",
      "revision": 1
    },
    {
      "asset_id": 4382,
      "resettable": 1,
      "name": "Totem of the Muses",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1420,
      "activated": 1,
      "icon_name": "swarm",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "When a real (non-Illusion, non-Summoned) Moga champion you own dies, a Moga Pup is summoned adjacent to this unit. This effect does not stack.",
      "long_description": "When a real (non-Illusion, non-Summoned) Moga champion you own dies, a Moga Pup is summoned adjacent to this unit. This effect does not stack.",
      "class_name": "RelicTotemOfTheMuses",
      "revision": 1
    },
    {
      "asset_id": 5153,
      "resettable": 1,
      "name": "Tough",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 1900,
      "activated": 1,
      "icon_name": "defenseenhance",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 4,
      "short_description": "Any time this unit would take damage, it takes 1 less than normal. ",
      "long_description": "Any time this unit would take damage, it takes 1 less than normal. ",
      "class_name": "Tough",
      "revision": 1
    },
    {
      "asset_id": 5153,
      "resettable": 1,
      "name": "Tough",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 1901,
      "activated": 1,
      "icon_name": "defenseenhance",
      "comments": "",
      "prerequisite_id": 1900,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 8,
      "short_description": "Any time this unit would take damage, it takes 2 less than normal. ",
      "long_description": "Any time this unit would take damage, it takes 2 less than normal. ",
      "class_name": "Tough",
      "revision": 1
    },
    {
      "asset_id": 5153,
      "resettable": 1,
      "name": "Tough",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 1902,
      "activated": 1,
      "icon_name": "defenseenhance",
      "comments": "",
      "prerequisite_id": 1901,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 12,
      "short_description": "Any time this unit would take damage, it takes 3 less than normal. ",
      "long_description": "Any time this unit would take damage, it takes 3 less than normal. ",
      "class_name": "Tough",
      "revision": 1
    },
    {
      "asset_id": 4332,
      "resettable": 1,
      "name": "Trail: Crystal",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1360,
      "activated": 1,
      "icon_name": "trail_crystal",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 2,
      "short_description": "At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes Crystal (This space is Inaccessible) for 2 turns.",
      "long_description": "At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes Crystal (This space is Inaccessible) for 2 turns.",
      "class_name": "TrailCrystal",
      "revision": 1
    },
    {
      "asset_id": 5844,
      "resettable": 1,
      "name": "Trail: Fire Wall",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2853,
      "activated": 1,
      "icon_name": "trail_firewall",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes a Fire Wall (Whenever an enemy champion enters this space, it takes 5 Fire damage and becomes Charred 4) for 3 turns.",
      "long_description": "At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes a Fire Wall (Whenever an enemy champion enters this space, it takes 5 Fire damage and becomes Charred 4) for 3 turns.",
      "class_name": "TrailFirewall",
      "revision": 1
    },
    {
      "asset_id": 5115,
      "resettable": 1,
      "name": "Trail: Hallowed Ground",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1304,
      "activated": 1,
      "icon_name": "trail_hallowed",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 7,
      "short_description": "At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes <mechanic value=hallowed_ground>Hallowed Ground</mechanic>",
      "long_description": "At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes <mechanic value=hallowed_ground>Hallowed Ground</mechanic>",
      "class_name": "TrailHallowedGround",
      "revision": 1
    },
    {
      "asset_id": 5109,
      "resettable": 1,
      "name": "Trail: Ice",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1295,
      "activated": 1,
      "icon_name": "trail_ice",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes Ice for 3 turns.",
      "long_description": "At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes Ice for 3 turns.",
      "class_name": "TrailIce",
      "revision": 1
    },
    {
      "asset_id": 4452,
      "resettable": 1,
      "name": "Trail: Lava",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 804,
      "activated": 1,
      "icon_name": "trail_lava",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 12,
      "short_description": "At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes Shallow Lava (4 Fire damage on entry and at the beginning of each of the occupying champion's turns) for 3 turns.",
      "long_description": "At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes Shallow Lava (4 Fire damage on entry and at the beginning of each of the occupying champion's turns) for 3 turns.",
      "class_name": "TrailLava",
      "revision": 1
    },
    {
      "asset_id": 4529,
      "resettable": 1,
      "name": "Trail: Mud",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 951,
      "activated": 1,
      "icon_name": "trail_mud",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "At the beginning of each turn and whenever this champion moves, spaces this unit occupies become Mud (Impeding 1, Water) for 3 turns.",
      "long_description": "At the beginning of each turn and whenever this champion moves, spaces this unit occupies become Mud (Impeding 1, Water) for 3 turns.",
      "class_name": "TrailMud",
      "revision": 1
    },
    {
      "asset_id": 5671,
      "resettable": 1,
      "name": "Trail: Ooze",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2543,
      "activated": 1,
      "icon_name": "trail_slime",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes Ooze for 3 turns.",
      "long_description": "At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes Ooze for 3 turns.",
      "class_name": "TrailOoze",
      "revision": 1
    },
    {
      "asset_id": 4333,
      "resettable": 1,
      "name": "Trail: Rock",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1361,
      "activated": 1,
      "icon_name": "trail_rock",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes Rock for 3 turns.",
      "long_description": "At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes Rock for 3 turns.",
      "class_name": "TrailStone",
      "revision": 1
    },
    {
      "asset_id": 4669,
      "resettable": 1,
      "name": "Trail: Sand",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1102,
      "activated": 1,
      "icon_name": "trail_sand",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes Sand for 4 turns.",
      "long_description": "At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes Sand for 4 turns. ",
      "class_name": "TrailSand",
      "revision": 1
    },
    {
      "asset_id": 4475,
      "resettable": 1,
      "name": "Trail: Slime",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 860,
      "activated": 1,
      "icon_name": "trail_slime",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes Slime (Impeding 1 Water) for 3 turns.",
      "long_description": "At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes Slime (Impeding 1 Water) for 3 turns.",
      "class_name": "TrailSlime",
      "revision": 1
    },
    {
      "asset_id": 4466,
      "resettable": 1,
      "name": "Trail: Snow",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 831,
      "activated": 1,
      "icon_name": "trail_snow",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes Snow (Impeding 1) for 3 turns.",
      "long_description": "At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes Snow (Impeding 1) for 3 turns.",
      "class_name": "TrailSnow",
      "revision": 1
    },
    {
      "asset_id": 4960,
      "resettable": 1,
      "name": "Trail: Vegetation",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1842,
      "activated": 1,
      "icon_name": "trail_vegetation",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes Vegetation for 3 turns. ",
      "long_description": "At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes Vegetation for 3 turns. ",
      "class_name": "TrailVegetation",
      "revision": 1
    },
    {
      "asset_id": 4623,
      "resettable": 1,
      "name": "Trail: Water",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1044,
      "activated": 1,
      "icon_name": "trail_water",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes Water (Impeding 1) for 3 turns.",
      "long_description": "At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes Water (Impeding 1) for 3 turns.",
      "class_name": "TrailWater",
      "revision": 1
    },
    {
      "asset_id": 5363,
      "resettable": 1,
      "name": "Trail: Web",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2195,
      "activated": 1,
      "icon_name": "trail_web",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 7,
      "short_description": "At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes <mechanic value=web_terrain>Web Terrain</mechanic> for 3 turns. ",
      "long_description": "At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes <mechanic value=web_terrain>Web Terrain</mechanic> for 3 turns. ",
      "class_name": "TrailWeb",
      "revision": 1
    },
    {
      "asset_id": 5262,
      "resettable": 1,
      "name": "Trailblaze",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2083,
      "activated": 1,
      "icon_name": "climb",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "All friendly champions have Brushwalker (This champion ignores movement restrictions and movement penalties imposed by Vegetation.).",
      "long_description": "All friendly champions have Brushwalker (This champion ignores movement restrictions and movement penalties imposed by Vegetation.).",
      "class_name": "Trailblaze",
      "revision": 1
    },
    {
      "asset_id": 4784,
      "resettable": 1,
      "name": "Train: Arctic Camo",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1518,
      "activated": 1,
      "icon_name": "camo",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Target friendly champion within 5 spaces permanently gains Arctic Camouflage (When this unit is damaged by a ranged attack while it is occupying Snow or Ice, reduce that damage by 2).  This ability costs 2 nora.",
      "long_description": "Target friendly champion within 5 spaces permanently gains Arctic Camouflage (When this unit is damaged by a ranged attack while it is occupying Snow or Ice, reduce that damage by 2).  This ability costs 2 nora.",
      "class_name": "BestowArcticCamo",
      "revision": 1
    },
    {
      "asset_id": 4780,
      "resettable": 1,
      "name": "Train: Assault",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1514,
      "activated": 1,
      "icon_name": "multiattack",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "Target friendly champion within 5 spaces permanently gains <ability value=1320>Assault</ability>.  This ability costs 6 nora.",
      "long_description": "Target friendly champion within 5 spaces permanently gains <ability value=1320>Assault</ability>.  This ability costs 6 nora.",
      "class_name": "BestowAssault",
      "revision": 1
    },
    {
      "asset_id": 4782,
      "resettable": 1,
      "name": "Train: Clear",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1516,
      "activated": 1,
      "icon_name": "cost",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Target friendly champion within 5 spaces permanently gains Clear (This unit ignores non-elevation based restrictions of terrain). This ability costs 5 nora.",
      "long_description": "Target friendly champion within 5 spaces permanently gains Clear (This unit ignores non-elevation based restrictions of terrain). This ability costs 5 nora.",
      "class_name": "BestowClear",
      "revision": 1
    },
    {
      "asset_id": 4783,
      "resettable": 1,
      "name": "Train: Damage",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1517,
      "activated": 1,
      "icon_name": "cost",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "Target friendly champion within 5 spaces permanently gains +2 DMG. This ability costs 3 nora and does not stack.",
      "long_description": "Target friendly champion within 5 spaces permanently gains +2 DMG. This ability costs 3 nora and does not stack.",
      "class_name": "BestowDamageTraining",
      "revision": 1
    },
    {
      "asset_id": 4790,
      "resettable": 1,
      "name": "Train: Damage Shield: Magical",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1524,
      "activated": 1,
      "icon_name": "cost",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Target friendly champion within 5 spaces permanently gains Damage Shield: Magical 3 (When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Magical damage. This damage ignores DEF). This ability costs 3 Nora.",
      "long_description": "Target friendly champion within 5 spaces permanently gains Damage Shield: Magical 3 (When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Magical damage. This damage ignores DEF). This ability costs 3 Nora.",
      "class_name": "BestowDamageShieldMagical",
      "revision": 1
    },
    {
      "asset_id": 5512,
      "resettable": 1,
      "name": "Train: Death Nova: Magical",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2370,
      "activated": 1,
      "icon_name": "cost",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Target friendly champion within 5 spaces permanently gains <ability value=176>Death Nova: Magical 2</ability>. This ability costs 4 nora.",
      "long_description": "Target friendly champion within 5 spaces permanently gains <ability value=176>Death Nova: Magical 2</ability>. This ability costs 4 nora.",
      "class_name": "TrainDeathNovaMagical",
      "revision": 1
    },
    {
      "asset_id": 4789,
      "resettable": 1,
      "name": "Train: Defense",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1523,
      "activated": 1,
      "icon_name": "cost",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 2,
      "short_description": "Target friendly champion within 5 spaces permanently gains +1 DEF.  This ability costs 2 nora and does not stack.",
      "long_description": "Target friendly champion within 5 spaces permanently gains +1 DEF.  This ability costs 2 nora and does not stack.",
      "class_name": "BestowDefenseTraining",
      "revision": 1
    },
    {
      "asset_id": 4792,
      "resettable": 1,
      "name": "Train: Evasive",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1526,
      "activated": 1,
      "icon_name": "cost",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Target friendly champion within 5 spaces permanently gains 1 rank of Evasive (This unit takes 20% less damage from ranged attacks). This ability costs 3 nora and does not stack.",
      "long_description": "Target friendly champion within 5 spaces permanently gains 1 rank of Evasive (This unit takes 20% less damage from ranged attacks). This ability costs 3 nora and does not stack.",
      "class_name": "BestowEvasive",
      "revision": 1
    },
    {
      "asset_id": 4791,
      "resettable": 1,
      "name": "Train: Farshot",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1525,
      "activated": 1,
      "icon_name": "cost",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Target friendly ranged champion within 5 spaces permanently gains a rank of Farshot (This champion makes a ranged attack at +1 RNG and +1 AP). This ability costs 3 nora and does not stack.",
      "long_description": "Target friendly ranged champion within 5 spaces permanently gains a rank of Farshot (This champion makes a ranged attack at +1 RNG and +1 AP). This ability costs 3 nora and does not stack.",
      "class_name": "BestowFarshot",
      "revision": 1
    },
    {
      "asset_id": 4781,
      "resettable": 1,
      "name": "Train: Healing Salve",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1515,
      "activated": 1,
      "icon_name": "heal",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Target friendly champion within 5 spaces is healed for 8 HP.  This ability costs 4 nora.",
      "long_description": "Target friendly champion within 5 spaces is healed for 8 HP.  This ability costs 4 nora.",
      "class_name": "HealingSalve",
      "revision": 1
    },
    {
      "asset_id": 4788,
      "resettable": 1,
      "name": "Train: Mobility",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1522,
      "activated": 1,
      "icon_name": "cost",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "Target friendly champion within 5 spaces permanently gains <ability value=6>Mobility</ability>.  This ability costs 4 nora.",
      "long_description": "Target friendly champion within 5 spaces permanently gains <ability value=6>Mobility</ability>.  This ability costs 4 nora.",
      "class_name": "BestowMobility",
      "revision": 1
    },
    {
      "asset_id": 5888,
      "resettable": 1,
      "name": "Train: Nohkan Do",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2897,
      "activated": 1,
      "icon_name": "cost",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "Target friendly champion within 5 spaces permanently gains <ability value=1470>Nohkan Do</ability>. This ability costs 6 nora.",
      "long_description": "Target friendly champion within 5 spaces permanently gains <ability value=1470>Nohkan Do</ability>. This ability costs 6 nora.",
      "class_name": "TrainNohkanDo",
      "revision": 1
    },
    {
      "asset_id": 4787,
      "resettable": 1,
      "name": "Train: Preserved",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1521,
      "activated": 1,
      "icon_name": "ondeath",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Target friendly champion within 5 spaces permanently gains Preserved (This champion's cooldown is reduced by 2 the next time it is destroyed). This ability costs 4 nora and does not stack.",
      "long_description": "Target friendly champion within 5 spaces permanently gains Preserved (This champion's cooldown is reduced by 2 the next time it is destroyed). This ability costs 4 nora and does not stack.",
      "class_name": "Preservation",
      "revision": 1
    },
    {
      "asset_id": 4778,
      "resettable": 1,
      "name": "Train: Refreshing Elixir",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1512,
      "activated": 1,
      "icon_name": "cost",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Target friendly champion within 5 spaces gains 1 AP. This ability costs 5 nora.",
      "long_description": "Target friendly champion within 5 spaces gains 1 AP. This ability costs 5 nora.",
      "class_name": "BestowAP",
      "revision": 1
    },
    {
      "asset_id": 4786,
      "resettable": 1,
      "name": "Train: Regeneration",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1520,
      "activated": 1,
      "icon_name": "cost",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Target friendly champion within 5 spaces permanently gains <ability value=116>Regeneration 2</ability>. This ability costs 5 nora and does not stack.",
      "long_description": "Target friendly champion within 5 spaces permanently gains <ability value=116>Regeneration 2</ability>. This ability costs 5 nora and does not stack.",
      "class_name": "BestowRegeneration",
      "revision": 1
    },
    {
      "asset_id": 4777,
      "resettable": 1,
      "name": "Train: Shrine Exertion",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1511,
      "activated": 1,
      "icon_name": "cost",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Target friendly champion within 5 spaces permanently gains <ability value=1111>Shrine Exertion</ability>.  This ability costs 5 nora.",
      "long_description": "Target friendly champion within 5 spaces permanently gains <ability value=1111>Shrine Exertion</ability>.  This ability costs 5 nora.",
      "class_name": "BestowExertion",
      "revision": 1
    },
    {
      "asset_id": 4785,
      "resettable": 1,
      "name": "Train: Spell Resistance",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1519,
      "activated": 1,
      "icon_name": "cost",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Target friendly champion within 5 spaces permanently gains <ability value=1534>Spell Resistance</ability>. This ability costs 2 nora.",
      "long_description": "Target friendly champion within 5 spaces permanently gains <ability value=1534>Spell Resistance</ability>. This ability costs 2 nora.",
      "class_name": "BestowSpellResistance",
      "revision": 1
    },
    {
      "asset_id": 4779,
      "resettable": 1,
      "name": "Train: Strike",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1513,
      "activated": 1,
      "icon_name": "cost",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Target friendly champion within 5 spaces permanently gains <ability value=1486>Strike</ability>. This ability costs 3 nora.",
      "long_description": "Target friendly champion within 5 spaces permanently gains <ability value=1486>Strike</ability>. This ability costs 3 nora.",
      "class_name": "BestowAttackTraining",
      "revision": 1
    },
    {
      "asset_id": 0,
      "resettable": 0,
      "name": "Traitor",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3327,
      "activated": 1,
      "icon_name": "sleeper_agent",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 0,
      "short_description": "This traitorous champion has switched sides!",
      "long_description": "This traitorous champion has switched sides!",
      "class_name": "Traitor",
      "revision": 1
    },
    {
      "asset_id": 4917,
      "resettable": 1,
      "name": "Trample",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1799,
      "activated": 1,
      "icon_name": "crush",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 6,
      "short_description": "Whenever this champion moves by way of its normal movement, all opposing champions within 2 spaces take 2 damage. \r\n",
      "long_description": "Whenever this champion moves by way of its normal movement, all opposing champions within 2 spaces take 2 damage. \r\n",
      "class_name": "Trample",
      "revision": 1
    },
    {
      "asset_id": 4403,
      "resettable": 1,
      "name": "Transfer Life",
      "ap_cost": 2,
      "level": 1,
      "ability_id": 725,
      "activated": 1,
      "icon_name": "heal",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 3,
      "short_description": "This unit loses 9 HP, and target champion within 5 spaces heals 12 HP.",
      "long_description": "This unit loses 9 HP, and target champion within 5 spaces heals 12 HP.",
      "class_name": "TransferLife",
      "revision": 1
    },
    {
      "asset_id": 4403,
      "resettable": 1,
      "name": "Transfer Life",
      "ap_cost": 2,
      "level": 2,
      "ability_id": 726,
      "activated": 1,
      "icon_name": "heal",
      "comments": "",
      "prerequisite_id": 725,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 1,
      "cost": 6,
      "short_description": "This unit loses 6 HP, and target champion within 5 spaces heals 12 HP.",
      "long_description": "This unit loses 6 HP, and target champion within 5 spaces heals 12 HP.",
      "class_name": "TransferLife",
      "revision": 1
    },
    {
      "asset_id": 4913,
      "resettable": 1,
      "name": "Transfigure",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1497,
      "activated": 1,
      "icon_name": "transfigure",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 8,
      "activation_type": 1,
      "ranked": 0,
      "cost": 20,
      "short_description": "Releases your Avatar from its Stone form, allowing it to fight as a Champion.  This will reduce your shrine nora generation by 20.",
      "long_description": "Releases your Avatar from its Stone form, allowing it to fight as a Champion.  This will reduce your shrine nora generation by 20.",
      "class_name": "Transfigure",
      "revision": 1
    },
    {
      "asset_id": 4913,
      "resettable": 1,
      "name": "Transfigure",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 1812,
      "activated": 1,
      "icon_name": "transfigure",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 8,
      "activation_type": 1,
      "ranked": 1,
      "cost": 20,
      "short_description": "Release your Avatar from its Stone Form, gaining 10 HP and allowing it to fight as a Champion. While in this form, your shrine nora generation is reduced by 20. This ability begins on cooldown.",
      "long_description": "Release your Avatar from its Stone Form, gaining 10 HP and allowing it to fight as a Champion. While in this form, your shrine nora generation is reduced by 20. This ability begins on cooldown.",
      "class_name": "Transfigure",
      "revision": 1
    },
    {
      "asset_id": 4913,
      "resettable": 1,
      "name": "Transfigure",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 1813,
      "activated": 1,
      "icon_name": "transfigure",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 8,
      "activation_type": 1,
      "ranked": 1,
      "cost": 20,
      "short_description": "Release your Avatar from its Stone Form, gaining 10 HP and allowing it to fight as a Champion. While in this form, your shrine nora generation is reduced by 20. This ability begins on cooldown.",
      "long_description": "Release your Avatar from its Stone Form, gaining 10 HP and allowing it to fight as a Champion. While in this form, your shrine nora generation is reduced by 20. This ability begins on cooldown.",
      "class_name": "Transfigure",
      "revision": 1
    },
    {
      "asset_id": 4913,
      "resettable": 1,
      "name": "Transfigure",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 1814,
      "activated": 1,
      "icon_name": "transfigure",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 8,
      "activation_type": 1,
      "ranked": 1,
      "cost": 20,
      "short_description": "Release your Avatar from its Stone Form, gaining 10 HP and allowing it to fight as a Champion. While in this form, your shrine nora generation is reduced by 20. This ability begins on cooldown.",
      "long_description": "Release your Avatar from its Stone Form, gaining 10 HP and allowing it to fight as a Champion. While in this form, your shrine nora generation is reduced by 20. This ability begins on cooldown.",
      "class_name": "Transfigure",
      "revision": 1
    },
    {
      "asset_id": 4913,
      "resettable": 1,
      "name": "Transfigure",
      "ap_cost": 0,
      "level": 4,
      "ability_id": 1815,
      "activated": 1,
      "icon_name": "transfigure",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 8,
      "activation_type": 1,
      "ranked": 1,
      "cost": 20,
      "short_description": "Release your Avatar from its Stone Form, gaining 10 HP and allowing it to fight as a Champion. While in this form, your shrine nora generation is reduced by 20. This ability begins on cooldown.",
      "long_description": "Release your Avatar from its Stone Form, gaining 10 HP and allowing it to fight as a Champion. While in this form, your shrine nora generation is reduced by 20. This ability begins on cooldown.",
      "class_name": "Transfigure",
      "revision": 1
    },
    {
      "asset_id": 4913,
      "resettable": 1,
      "name": "Transfigure ",
      "ap_cost": 0,
      "level": 5,
      "ability_id": 1944,
      "activated": 1,
      "icon_name": "transfigure",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 8,
      "activation_type": 1,
      "ranked": 1,
      "cost": 20,
      "short_description": "Release your Avatar from its Stone Form, gaining 10 HP and allowing it to fight as a Champion. While in this form, your shrine nora generation is reduced by 20. This ability begins on cooldown.",
      "long_description": "Release your Avatar from its Stone Form, gaining 10 HP and allowing it to fight as a Champion. While in this form, your shrine nora generation is reduced by 20. This ability begins on cooldown.",
      "class_name": "Transfigure",
      "revision": 1
    },
    {
      "asset_id": 5836,
      "resettable": 1,
      "name": "Transmission Relay (relic)",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2845,
      "activated": 1,
      "icon_name": "skyreign",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 2,
      "ranked": 0,
      "cost": 10,
      "short_description": "When this relic is deployed and at the end of each turn, a Dragon is revealed in your runedock.  If no Dragons are concealed, a random Dragon on CD has its CD reduced by 4.  This relic loses 3 HP when a friendly dragon is deployed.\r\n",
      "long_description": "When this relic is deployed and at the end of each turn, a Dragon is revealed in your runedock.  If no Dragons are concealed, a random Dragon on CD has its CD reduced by 4.  This relic loses 3 HP when a friendly dragon is deployed.\r\n",
      "class_name": "RelicTransmissionRelay",
      "revision": 1
    },
    {
      "asset_id": 4350,
      "resettable": 1,
      "name": "Transplant",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1384,
      "activated": 1,
      "icon_name": "sumtree",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "When this champion would be destroyed and has at least 10 MAX HP, the nearest friendly plant champion is destroyed and this champion respawns on that location with -10 MAX HP.",
      "long_description": "When this champion would be destroyed and has at least 10 MAX HP, the nearest friendly plant champion is destroyed and this champion respawns on that location with -10 MAX HP.",
      "class_name": "Transplant",
      "revision": 1
    },
    {
      "asset_id": 4350,
      "resettable": 1,
      "name": "Transplant Other",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 1375,
      "activated": 1,
      "icon_name": "relocate",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "Target a friendly plant champion within 6 spaces. This champion is relocated adjacent to the target and fully healed. The target takes damage equal to this champion's max hp.",
      "long_description": "Target a friendly plant champion within 6 spaces. This champion is relocated adjacent to the target and fully healed. The target takes damage equal to this champion's max hp.",
      "class_name": "Transplantx",
      "revision": 1
    },
    {
      "asset_id": 5491,
      "resettable": 1,
      "name": "Transport",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 2351,
      "activated": 1,
      "icon_name": "tortun_load",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 15,
      "short_description": "Target adjacent friendly normal-sized Tortun is removed from play.      ",
      "long_description": "Target adjacent friendly normal-sized Tortun is removed from play.      ",
      "class_name": "TransportTortun",
      "revision": 1
    },
    {
      "asset_id": 4764,
      "resettable": 1,
      "name": "Tree Form",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 1488,
      "activated": 1,
      "icon_name": "transform",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "This unit is <mechanic value=cleansed>Cleansed</mechanic> and becomes a Gnarlwood Tree and gains gets +2 DEF, +4 DMG, +10 HP, <ability value=1085>Boost: Plant</ability> and <ability value=1083>Plant Regeneration</ability>",
      "long_description": "This unit is <mechanic value=cleansed>Cleansed</mechanic> and becomes a Gnarlwood Tree and gains gets +2 DEF, +4 DMG, +10 HP, <ability value=1085>Boost: Plant</ability> and <ability value=1083>Plant Regeneration</ability>",
      "class_name": "TreeForm",
      "revision": 1
    },
    {
      "asset_id": 4479,
      "resettable": 1,
      "name": "Tremor",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 869,
      "activated": 1,
      "icon_name": "physicalaoe",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "Opposing champions without <condition value=flying popup=false>Flying</condition> within 3 spaces of this unit are knocked back 1 space, gain <ability value=5>Lumbering</ability> for 2 turns and take 6 Physical damage. Enemy relics in the affected area take 6 Physical damage. This damage ignores DEF.",
      "long_description": "Opposing champions without <condition value=flying popup=false>Flying</condition> within 3 spaces of this unit are knocked back 1 space, gain <ability value=5>Lumbering</ability> for 2 turns and take 6 Physical damage. Enemy relics in the affected area take 6 Physical damage. This damage ignores DEF.",
      "class_name": "Tremor",
      "revision": 1
    },
    {
      "asset_id": 5241,
      "resettable": 1,
      "name": "Tribal Hut",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2021,
      "activated": 1,
      "icon_name": "sibling",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "Friendly Cyclops Lurker, Drudge Cyclops and Cyclops Hauler have Sibling.",
      "long_description": "Friendly Cyclops Lurker, Drudge Cyclops and Cyclops Hauler have Sibling.",
      "class_name": "RelicTribalHut",
      "revision": 1
    },
    {
      "asset_id": 5668,
      "resettable": 1,
      "name": "Trickster",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2540,
      "activated": 1,
      "icon_name": "nemesis_x",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 10,
      "short_description": "When this unit activates an ability that is not a basic attack, it becomes <condition value=stealthed>Stealthed</condition> for 6 turns and gains <ability value=1790>Shadow Shift</ability> for 1 turn.",
      "long_description": "When this unit activates an ability that is not a basic attack, it becomes <condition value=stealthed>Stealthed</condition> for 6 turns and gains <ability value=1790>Shadow Shift</ability> for 1 turn.",
      "class_name": "Trickster",
      "revision": 1
    },
    {
      "asset_id": 7911,
      "resettable": 0,
      "name": "Triumphant Horn",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 3341,
      "activated": 1,
      "icon_name": "horn_kithir",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "All friendly champions get +1 DEF and have +4 DMG on melee attacks for 2 turns.",
      "long_description": "All friendly champions get +1 DEF and have +4 DMG on melee attacks for 2 turns.",
      "class_name": "HornOfKthir",
      "revision": 1
    },
    {
      "asset_id": 5722,
      "resettable": 1,
      "name": "Triumphant Roar",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 2604,
      "activated": 1,
      "icon_name": "novasonic",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 12,
      "short_description": "Enemy champions within 4 spaces take 12 Sonic damage and become <condition value=distracted>Distracted</condition> and <condition value=frightened>Frightened</condition> for 2 turns.",
      "long_description": "Enemy champions within 4 spaces take 12 Sonic damage and become <condition value=distracted>Distracted</condition> and <condition value=frightened>Frightened</condition> for 2 turns.",
      "class_name": "TriumphalRoar",
      "revision": 1
    },
    {
      "asset_id": 7371,
      "resettable": 0,
      "name": "True Nature",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3127,
      "activated": 1,
      "icon_name": "true_nature",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "When this champion makes a basic attack, the other champion is Dispelled and becomes <condition name=confused>Confused</condition> for the attack.  Damage Shields and abilities that generate a condition for its effect (such as Confuse Attacker) will still trigger.",
      "long_description": "When this champion makes a basic attack, the other champion is Dispelled and becomes <condition name=confused>Confused</condition> for the attack.  Damage Shields and abilities that generate a condition for its effect (such as Confuse Attacker) will still trigger.",
      "class_name": "TrueNature",
      "revision": 1
    },
    {
      "asset_id": 7627,
      "resettable": 0,
      "name": "Truthseeker",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 3234,
      "activated": 1,
      "icon_name": "relocate_lightning",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "This champion is relocated adjacent to target champion within 5 spaces with <condition value=branded>Branded</condition> or <ability value=2004>Faithless</ability> and gains +2 SPD for 3 turns.",
      "long_description": "This champion is relocated adjacent to target champion within 5 spaces with <condition value=branded>Branded</condition> or <ability value=2004>Faithless</ability> and gains +2 SPD for 3 turns.",
      "class_name": "Truthseeker",
      "revision": 1
    },
    {
      "asset_id": 7854,
      "resettable": 0,
      "name": "Tundra Awakening",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3331,
      "activated": 1,
      "icon_name": "fangandfur",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "This champion has +1 DMG, +1 DEF and +1 SPD for every 2 opposing champions occupying Snow or Ice.",
      "long_description": "This champion has +1 DMG, +1 DEF and +1 SPD for every 2 opposing champions occupying Snow or Ice.",
      "class_name": "TundraAwakening",
      "revision": 1
    },
    {
      "asset_id": 7274,
      "resettable": 0,
      "name": "Tundra Menace",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3073,
      "activated": 1,
      "icon_name": "tundra_menace",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 14,
      "short_description": "The first time each turn a friendly Jakei or Elemental is deployed from the runedock, this champion gains 2 AP and enemy champions within 2 spaces takes 4 Frost damage.",
      "long_description": "The first time each turn a friendly Jakei or Elemental is deployed from the runedock, this champion gains 2 AP and enemy champions within 2 spaces takes 4 Frost damage.",
      "class_name": "TundraMenace",
      "revision": 1
    },
    {
      "asset_id": 7978,
      "resettable": 0,
      "name": "Tundra Rites",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3365,
      "activated": 1,
      "icon_name": "aurapositive",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "Friendly units within 5 spaces of this relic gain <ability value=540>Attack: Frost</ability>. If they are Race: Jakei they also gain <ability value=2542>Savage Exploit</ability>.",
      "long_description": "Friendly units within 5 spaces of this relic gain <ability value=540>Attack: Frost</ability>. If they are Race: Jakei they also gain <ability value=2542>Savage Exploit</ability>.",
      "class_name": "TundraRites",
      "revision": 1
    },
    {
      "asset_id": 4918,
      "resettable": 1,
      "name": "Tunnel Trap",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 1800,
      "activated": 1,
      "icon_name": "traprock",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "This unit becomes <condition value=stealthed>Stealthed</condition> and moves directly to target space within 5 spaces.",
      "long_description": "This unit becomes <condition value=stealthed>Stealthed</condition> and moves directly to target space within 5 spaces.",
      "class_name": "TunnelTrap",
      "revision": 1
    },
    {
      "asset_id": 4420,
      "resettable": 1,
      "name": "Tunnel: Earth",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 755,
      "activated": 1,
      "icon_name": "tunnel_earth",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 1,
      "cost": 4,
      "short_description": "This unit is relocated to target Dirt or Rock space within 6 spaces.",
      "long_description": "This unit is relocated to target Dirt or Rock space within 6 spaces.",
      "class_name": "TunnelEarth",
      "revision": 1
    },
    {
      "asset_id": 4972,
      "resettable": 1,
      "name": "Tunnel: Lava",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 1852,
      "activated": 1,
      "icon_name": "tunnel_lava",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 1,
      "cost": 4,
      "short_description": "This unit is relocated to target Lava space within 6 spaces.",
      "long_description": "This unit is relocated to target Lava space within 6 spaces.",
      "class_name": "TunnelLava",
      "revision": 1
    },
    {
      "asset_id": 5762,
      "resettable": 1,
      "name": "Tunnel: Ooze",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 2777,
      "activated": 1,
      "icon_name": "tunnel_ooze",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "This unit is relocated to target Ooze space within 6 spaces.",
      "long_description": "This unit is relocated to target Ooze space within 6 spaces.",
      "class_name": "TunnelOoze",
      "revision": 1
    },
    {
      "asset_id": 4701,
      "resettable": 1,
      "name": "Tunnel: Sand",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 1148,
      "activated": 1,
      "icon_name": "tunnel_sand",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 1,
      "cost": 4,
      "short_description": "This unit is relocated to target Sand space within 6 spaces.",
      "long_description": "This unit is relocated to target Sand space within 6 spaces.",
      "class_name": "TunnelSand",
      "revision": 1
    },
    {
      "asset_id": 4701,
      "resettable": 1,
      "name": "Tunnel: Sand",
      "ap_cost": 4,
      "level": 2,
      "ability_id": 1149,
      "activated": 1,
      "icon_name": "tunnel_sand",
      "comments": "",
      "prerequisite_id": 1148,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 1,
      "cost": 4,
      "short_description": "This ability can only be activated if this unit is occupying Sand terrain. This unit moves directly to target Sand space within 6 spaces.",
      "long_description": "This ability can only be activated if this unit is occupying Sand terrain. This unit moves directly to target Sand space within 6 spaces.",
      "class_name": "TunnelSand",
      "revision": 1
    },
    {
      "asset_id": 4701,
      "resettable": 1,
      "name": "Tunnel: Sand",
      "ap_cost": 4,
      "level": 3,
      "ability_id": 1150,
      "activated": 1,
      "icon_name": "tunnel_sand",
      "comments": "",
      "prerequisite_id": 1149,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 1,
      "cost": 7,
      "short_description": "This ability can only be activated if this unit is occupying Sand terrain. This unit moves directly to target Sand space within 7 spaces.",
      "long_description": "This ability can only be activated if this unit is occupying Sand terrain. This unit moves directly to target Sand space within 7 spaces.",
      "class_name": "TunnelSand",
      "revision": 1
    },
    {
      "asset_id": 4419,
      "resettable": 1,
      "name": "Tunnel: Snow",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 752,
      "activated": 1,
      "icon_name": "tunnel_snow",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 1,
      "cost": 4,
      "short_description": "This unit is relocated to target Snow or Ice space within 6 spaces.",
      "long_description": "This unit is relocated to target Snow or Ice space within 6 spaces.",
      "class_name": "TunnelSnow",
      "revision": 1
    },
    {
      "asset_id": 5266,
      "resettable": 1,
      "name": "Tunnel: Vegetation",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 2088,
      "activated": 1,
      "icon_name": "tunnel_vegetation",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 1,
      "cost": 7,
      "short_description": "This unit is relocated to target Vegetation space within 6 spaces.",
      "long_description": "This unit is relocated to target Vegetation space within 6 spaces.",
      "class_name": "TunnelVegetation",
      "revision": 1
    },
    {
      "asset_id": 4930,
      "resettable": 1,
      "name": "Turret Team",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1531,
      "activated": 1,
      "icon_name": "turret_team",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 25,
      "short_description": "When this unit dies a Weaponsmith and Dwarven Handler with no upgrades are spawned in its place at 1/3 of their maximum health.",
      "long_description": "When this unit dies a Weaponsmith and Dwarven Handler with no upgrades are spawned in its place at 1/3 of their maximum health.",
      "class_name": "TurretTeam",
      "revision": 1
    },
    {
      "asset_id": 4258,
      "resettable": 1,
      "name": "Turtle",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 647,
      "activated": 1,
      "icon_name": "turtle",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 5,
      "short_description": "This unit becomes <condition value=impervious>Impervious</condition>, <condition value=immobile>Immobile</condition> and <condition value=pacified>Pacified</condition> and has an AP cap of 0 for 2 turns.",
      "long_description": "This unit becomes <condition value=impervious>Impervious</condition>, <condition value=immobile>Immobile</condition> and <condition value=pacified>Pacified</condition> and has an AP cap of 0 for 2 turns.",
      "class_name": "Turtle",
      "revision": 1
    },
    {
      "asset_id": 5556,
      "resettable": 1,
      "name": "Tutorial Immortality",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2416,
      "activated": 1,
      "icon_name": "",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "Prevents key tutorial champions from dying.",
      "long_description": "Prevents key tutorial champions from dying.",
      "class_name": "TutorialImmortality",
      "revision": 1
    },
    {
      "asset_id": 7387,
      "resettable": 0,
      "name": "Twisted Essence",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3138,
      "activated": 1,
      "icon_name": "twisted_essence",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=twisted>Twisted</condition> for 3 turns.",
      "long_description": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=twisted>Twisted</condition> for 3 turns.",
      "class_name": "TwistedEssence",
      "revision": 1
    },
    {
      "asset_id": 0,
      "resettable": 1,
      "name": "Under Construction",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2322,
      "activated": 1,
      "icon_name": "domain_rock",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "This mine is under construction and will be ready next turn.",
      "long_description": "This mine is under construction and will be ready next turn.",
      "class_name": "UnderConstruction",
      "revision": 1
    },
    {
      "asset_id": 7961,
      "resettable": 0,
      "name": "Underdepths Exploit",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3348,
      "activated": 1,
      "icon_name": "exploit_ironfist",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 7,
      "short_description": "When this champion makes a successful basic attack against a target with <condition value=charred>Charred</condition>, <condition value=bloodied>Bloodied</condition> or <condition value=frightened>Frightened</condition> it gains 1 AP and has +2 DMG for the attack.",
      "long_description": "When this champion makes a successful basic attack against a target with <condition value=charred>Charred</condition>, <condition value=bloodied>Bloodied</condition> or <condition value=frightened>Frightened</condition> it gains 1 AP and has +2 DMG for the attack.",
      "class_name": "UnderdepthsExploit",
      "revision": 1
    },
    {
      "asset_id": 4461,
      "resettable": 1,
      "name": "Unequippable",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 814,
      "activated": 1,
      "icon_name": "unequipable",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -5,
      "short_description": "This champion may not be equipped.",
      "long_description": "This champion may not be equipped.",
      "class_name": "Unequippable",
      "revision": 1
    },
    {
      "asset_id": 7993,
      "resettable": 0,
      "name": "Unholy Armaments",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3388,
      "activated": 1,
      "icon_name": "comboatk_devastate",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "When a friendly champion with Race: Lich, Race: Skeleton or Race: Vampire becomes equipped, it gains 1 AP and +2 DMG for 2 turns. This does not stack.",
      "long_description": "When a friendly champion with Race: Lich, Race: Skeleton or Race: Vampire becomes equipped, it gains 1 AP and +2 DMG for 2 turns. This does not stack.",
      "class_name": "UnholyArmaments",
      "revision": 1
    },
    {
      "asset_id": 4243,
      "resettable": 1,
      "name": "Unholy Tomb",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 629,
      "activated": 1,
      "icon_name": "ondeath",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "At the start of your turns, all enemy champions lose 1 HP and you gain 1 nora for each HP lost this way.  This does not stack.",
      "long_description": "At the start of your turns, all enemy champions lose 1 HP and you gain 1 nora for each HP lost this way.  This does not stack.",
      "class_name": "RelicUnholyTomb",
      "revision": 1
    },
    {
      "asset_id": 4385,
      "resettable": 1,
      "name": "Unique",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1409,
      "activated": 1,
      "icon_name": "planar",
      "comments": "This ability does not need to do anything other than flag champions as unique.",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "Only one copy of this rune may be played in a Battle Group.",
      "long_description": "Only one copy of this rune may be played in a Battle Group.",
      "class_name": "TestAbility",
      "revision": 1
    },
    {
      "asset_id": 4335,
      "resettable": 1,
      "name": "Unleash",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1363,
      "activated": 1,
      "icon_name": "unleashed",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "Friendly champions within 3 spaces gain <ability value=1364>Fuel Rage</ability>.",
      "long_description": "Friendly champions within 3 spaces gain <ability value=1364>Fuel Rage</ability>.",
      "class_name": "Unleash",
      "revision": 1
    },
    {
      "asset_id": 5079,
      "resettable": 1,
      "name": "Unleash Memories",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2670,
      "activated": 1,
      "icon_name": "nora",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "Spend all charges. You gain 2 nora for each charge lost this way (up to 40).",
      "long_description": "Spend all charges. You gain 2 nora for each charge lost this way (up to 40).",
      "class_name": "UnleashMemories",
      "revision": 1
    },
    {
      "asset_id": 5492,
      "resettable": 1,
      "name": "Unload",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2350,
      "activated": 1,
      "icon_name": "tortun_unload",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Champions removed from play with <ability value=2351>Transport</ability> are returned to play adjacent to this champion.  Champions returned this way keep the HP they had but all effects and equipment on those champions are removed.",
      "long_description": "Champions removed from play with <ability value=2351>Transport</ability> are returned to play adjacent to this champion.  Champions returned this way keep the HP they had but all effects and equipment on those champions are removed.",
      "class_name": "Unload",
      "revision": 1
    },
    {
      "asset_id": 4765,
      "resettable": 1,
      "name": "Unspeakable",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1489,
      "activated": 1,
      "icon_name": "ignore_invite",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "When this unit is deployed, all enemy units become <condition value=frightened>Frightened</condition> until the end of next turn.",
      "long_description": "When this unit is deployed, all enemy units become <condition value=frightened>Frightened</condition> until the end of next turn.",
      "class_name": "Unspeakable",
      "revision": 1
    },
    {
      "asset_id": 4256,
      "resettable": 1,
      "name": "Unstable",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 653,
      "activated": 1,
      "icon_name": "ondeath",
      "comments": "For Dark Rising",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "This unit dies after 1 - 6 rounds.",
      "long_description": "This unit dies after 1 - 6 rounds.",
      "class_name": "Unstable",
      "revision": 1
    },
    {
      "asset_id": 4226,
      "resettable": 1,
      "name": "Unstoppable",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 597,
      "activated": 1,
      "icon_name": "unstoppable",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "This champion cannot be <condition value=stunned>Stunned</condition>, <condition value=ensnared>Ensnared</condition>, <condition value=paralyzed>Paralyzed</condition> or <condition value=rooted>Rooted</condition>, and is immune to Knockback. This unit is also immune to any effects that cause the loss of AP.",
      "long_description": "This champion cannot be <condition value=stunned>Stunned</condition>, <condition value=ensnared>Ensnared</condition>, <condition value=paralyzed>Paralyzed</condition> or <condition value=rooted>Rooted</condition>, and is immune to Knockback. This unit is also immune to any effects that cause the loss of AP.",
      "class_name": "Unstoppable",
      "revision": 1
    },
    {
      "asset_id": 5098,
      "resettable": 1,
      "name": "Untamed",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1273,
      "activated": 1,
      "icon_name": "aggressive",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "This champion may not become <condition value=pacified>Pacified</condition>.",
      "long_description": "This champion may not become <condition value=pacified>Pacified</condition>.",
      "class_name": "Untamed",
      "revision": 1
    },
    {
      "asset_id": 7540,
      "resettable": 0,
      "name": "Updraft",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3196,
      "activated": 1,
      "icon_name": "tailwind",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this champion is deployed from the runedock, friendly champions gain <condition value=flying>Flying</condition> for 4 turns. If it shares a race with this champion or already has <condition value=flying>Flying</condition>, it also gains <ability value=1395>Hunter: Walker</ability> for 4 turns.",
      "long_description": "When this champion is deployed from the runedock, friendly champions gain <condition value=flying>Flying</condition> for 4 turns. If it shares a race with this champion or already has <condition value=flying>Flying</condition>, it also gains <ability value=1395>Hunter: Walker</ability> for 4 turns.",
      "class_name": "Updraft",
      "revision": 1
    },
    {
      "asset_id": 4657,
      "resettable": 1,
      "name": "Uproot",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 2654,
      "activated": 1,
      "icon_name": "plantregen",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 1,
      "short_description": "This champion loses the effects of Take Root. This ability starts on cooldown and is removed upon use.",
      "long_description": "This champion loses the effects of Take Root. This ability starts on cooldown and is removed upon use.",
      "class_name": "Uproot",
      "revision": 1
    },
    {
      "asset_id": 5374,
      "resettable": 1,
      "name": "Use Mine",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2206,
      "activated": 1,
      "icon_name": "tunnel_earth",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "This champion is relocated to a space adjacent to friendly Mine.",
      "long_description": "This champion is relocated to a space adjacent to friendly Mine.",
      "class_name": "UseMine",
      "revision": 1
    },
    {
      "asset_id": 5129,
      "resettable": 0,
      "name": "Valdac's Chosen",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2959,
      "activated": 1,
      "icon_name": "revere",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "While this ability in in play, this unit has <ability value=544>Attack: Magical</ability>, Demi-Gods cost 10% less and have their cooldowns reduced by 3 at the beginning of its turns. When a Demi-God comes into play this unit heals for 20 HP and this ability is removed.",
      "long_description": "While this ability in in play, this unit has <ability value=544>Attack: Magical</ability>, Demi-Gods cost 10% less and have their cooldowns reduced by 3 at the beginning of its turns. When a Demi-God comes into play this unit heals for 20 HP and this ability is removed.",
      "class_name": "ValdacChosen",
      "revision": 1
    },
    {
      "asset_id": 5924,
      "resettable": 0,
      "name": "Valdac's Soul",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2960,
      "activated": 1,
      "icon_name": "revere",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "When this unit dies the nearest friendly <mechanic value=dragonkin>Dragonkin</mechanic> gains <ability value=2959>Valdac's Chosen</ability>",
      "long_description": "When this unit dies the nearest friendly <mechanic value=dragonkin>Dragonkin</mechanic> gains <ability value=2959>Valdac's Chosen</ability>",
      "class_name": "ValdacSoul",
      "revision": 1
    },
    {
      "asset_id": 7696,
      "resettable": 0,
      "name": "Valdaci Sacrifice: Burr",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 3259,
      "activated": 1,
      "icon_name": "valdacisac_burr",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 2,
      "short_description": "This champion loses 5 HP and target enemy champion within 5 spaces is equipped with Valdaci Burr (Equipped champion is <condition value=Burred>Burred</condition>).",
      "long_description": "This champion loses 5 HP and target enemy champion within 5 spaces is equipped with Valdaci Burr (Equipped champion is <condition value=Burred>Burred</condition>).",
      "class_name": "ValdaciSacrificeBurr",
      "revision": 1
    },
    {
      "asset_id": 7690,
      "resettable": 0,
      "name": "Valdaci Sacrifice: Crossbow",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 3257,
      "activated": 1,
      "icon_name": "valdacisac_xbow",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 5,
      "short_description": "This champion loses 5 HP and a Valdaci Crossbow relic with 15 HP and <ability value=2602>Misfire</ability> is summoned to target adjacent unoccupied tile. ",
      "long_description": "This champion loses 5 HP and a Valdaci Crossbow relic with 15 HP and <ability value=2602>Misfire</ability> is summoned to target adjacent unoccupied tile. ",
      "class_name": "ValdaciSacrificeCrossbow",
      "revision": 1
    },
    {
      "asset_id": 7697,
      "resettable": 0,
      "name": "Valdaci Sacrifice: Emerald",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 3260,
      "activated": 1,
      "icon_name": "valdacisac_emerald",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 5,
      "short_description": "This champion loses 5 HP and a Valdaci Emerald relic with 15 HP and <ability value=153>Acidic Aura 3</ability> is summoned to target adjacent unoccupied tile. ",
      "long_description": "This champion loses 5 HP and a Valdaci Emerald relic with 15 HP and <ability value=153>Acidic Aura 3</ability> is summoned to target adjacent unoccupied tile. ",
      "class_name": "ValdaciSacrificeEmerald",
      "revision": 1
    },
    {
      "asset_id": 7726,
      "resettable": 0,
      "name": "Valdaci Sacrifice: Shield",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 3269,
      "activated": 1,
      "icon_name": "valdacisac_shield",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 2,
      "short_description": "This champion loses 5 HP and target friendly champion within 5 spaces is equipped with Valdaci Shield (Equipped champion has <ability value=3266>Combat Awareness 1</ability>).",
      "long_description": "This champion loses 5 HP and target friendly champion within 5 spaces is equipped with Valdaci Shield (Equipped champion has <ability value=3266>Combat Awareness 1</ability>).",
      "class_name": "ValdaciSacrificeShield",
      "revision": 1
    },
    {
      "asset_id": 7687,
      "resettable": 0,
      "name": "Valdaci Sacrifice: Tracker",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 3255,
      "activated": 1,
      "icon_name": "valdacisac_tracker",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 2,
      "short_description": "This champion loses 5 HP and the closest friendly equippable champion within 5 spaces is equipped with Valdaci Tracker (Equipped champion has <ability value=13>Detection 3</ability> and <ability value=2671>Illuminate</ability>).",
      "long_description": "This champion loses 5 HP and the closest friendly equippable champion within 5 spaces is equipped with Valdaci Tracker (Equipped champion has <ability value=13>Detection 3</ability> and <ability value=2671>Illuminate</ability>).",
      "class_name": "ValdaciSacrificeTracker",
      "revision": 1
    },
    {
      "asset_id": 4450,
      "resettable": 1,
      "name": "Vallassa the Elder",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2718,
      "activated": 1,
      "icon_name": "hero",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "This rune is a Limited Edition rune from Broken Shard, and counts as a Jakei Heretic.",
      "long_description": "This rune is a Limited Edition rune from Broken Shard, and counts as a Jakei Heretic.",
      "class_name": "Placeholder",
      "revision": 1
    },
    {
      "asset_id": 8000,
      "resettable": 0,
      "name": "Vampiric Thirst",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3397,
      "activated": 1,
      "icon_name": "heal",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "This champion has <ability value=99>Life Siphon</ability>. When a friendly champion with Race: Vampyre within 3 spaces vampiric heals, this champion loses 5 HP, gains 1 AP and gains +1 DMG for 1 turn. This ability can trigger up to 2 times per turn.",
      "long_description": "This champion has <ability value=99>Life Siphon</ability>. When a friendly champion with Race: Vampyre within 3 spaces vampiric heals, this champion loses 5 HP, gains 1 AP and gains +1 DMG for 1 turn. This ability can trigger up to 2 times per turn.",
      "class_name": "VampiricThirst",
      "revision": 1
    },
    {
      "asset_id": 7184,
      "resettable": 0,
      "name": "Vanguard",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3025,
      "activated": 1,
      "icon_name": "vanguard",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "When this champion is within 5 spaces of a friendly champion with <ability value=685>Arrow Eater</ability> or <ability value=2469>Elusive</ability>, this unit gains <ability value=116>Regeneration 2</ability> and +1 SPD.",
      "long_description": "When this champion is within 5 spaces of a friendly champion with <ability value=685>Arrow Eater</ability> or <ability value=2469>Elusive</ability>, this unit gains <ability value=116>Regeneration 2</ability> and +1 SPD.",
      "class_name": "Vanguard",
      "revision": 1
    },
    {
      "asset_id": 5099,
      "resettable": 1,
      "name": "Vaporize",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1274,
      "activated": 1,
      "icon_name": "ethereal",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 7,
      "short_description": "When this champion is successfully attacked it becomes <condition value=incorporeal>Incorporeal</condition> for the remainder of the turn.",
      "long_description": "When this champion is successfully attacked it becomes <condition value=incorporeal>Incorporeal</condition> for the remainder of the turn.",
      "class_name": "Vaporize",
      "revision": 1
    },
    {
      "asset_id": 4756,
      "resettable": 1,
      "name": "Veiled Flight",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1480,
      "activated": 1,
      "icon_name": "flight_veiled",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "This unit gains <condition value=flying>Flying</condition> when <condition value=stealthed>Stealthed</condition>.",
      "long_description": "This unit gains <condition value=flying>Flying</condition> when <condition value=stealthed>Stealthed</condition>.",
      "class_name": "VeiledFlight",
      "revision": 1
    },
    {
      "asset_id": 5101,
      "resettable": 1,
      "name": "Vengeful",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1276,
      "activated": 1,
      "icon_name": "enrage",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "This unit gains +1 DMG every time a real friendly champion which shares a race with this champion is destroyed.",
      "long_description": "This unit gains +1 DMG every time a real friendly champion which shares a race with this champion is destroyed.",
      "class_name": "Vengeful",
      "revision": 1
    },
    {
      "asset_id": 4607,
      "resettable": 1,
      "name": "Venom Trap",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1023,
      "activated": 1,
      "icon_name": "trap",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "When an enemy champion moves within 2 spaces of this relic, this relic is destroyed and enemy units within 2 spaces take 6 Acid damage, become <condition value=scoured>Scoured</condition> for 3 turns, and Blinded (Any attack this unit makes will miss) for 1 turn. This damage ignores DEF.",
      "long_description": "When an enemy champion moves within 2 spaces of this relic, this relic is destroyed and enemy units within 2 spaces take 6 Acid damage, become <condition value=scoured>Scoured</condition> for 3 turns, and Blinded (Any attack this unit makes will miss) for 1 turn. This damage ignores DEF.",
      "class_name": "RelicVenomTrap",
      "revision": 1
    },
    {
      "asset_id": 7996,
      "resettable": 0,
      "name": "Verdant Armaments",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3391,
      "activated": 1,
      "icon_name": "comboatk_devastate",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "When a friendly champion with Race: Elf, Race: Fairy or Race: Centaur becomes equipped, it gains 1 AP and +2 DMG for 2 turns. This does not stack.",
      "long_description": "When a friendly champion with Race: Elf, Race: Fairy or Race: Centaur becomes equipped, it gains 1 AP and +2 DMG for 2 turns. This does not stack.",
      "class_name": "VerdantArmaments",
      "revision": 1
    },
    {
      "asset_id": 7572,
      "resettable": 0,
      "name": "Verdant Force",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 3217,
      "activated": 1,
      "icon_name": "domain_vegetation",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "Friendly champions (including self) gains <ability value=479>Brushwalker</ability> and <ability value=106>Camouflage</ability> for 3 turns, and spaces within 2 tiles of all friendly champions (including self) become Jungle for 3 turns.",
      "long_description": "Friendly champions (including self) gains <ability value=479>Brushwalker</ability> and <ability value=106>Camouflage</ability> for 3 turns, and spaces within 2 tiles of all friendly champions (including self) become Jungle for 3 turns.",
      "class_name": "VerdantForce",
      "revision": 1
    },
    {
      "asset_id": 7369,
      "resettable": 0,
      "name": "Verdict of Al'mara",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 3125,
      "activated": 1,
      "icon_name": "verdict_of_almara",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "This champion makes a Magical attack at RNG 2-5.  If the attack is successful and the target is Branded, the target also becomes <condition value=stunned>Stunned</condition> for 2 turns.",
      "long_description": "This champion makes a Magical attack at RNG 2-5.  If the attack is successful and the target is Branded, the target also becomes <condition value=stunned>Stunned</condition> for 2 turns.",
      "class_name": "VerdictOfAlmara",
      "revision": 1
    },
    {
      "asset_id": 5139,
      "resettable": 1,
      "name": "Vicious Blow",
      "ap_cost": 1,
      "level": 1,
      "ability_id": 1689,
      "activated": 1,
      "icon_name": "stab",
      "comments": "Attack+1 ap cost",
      "prerequisite_id": null,
      "cooldown": 8,
      "activation_type": 1,
      "ranked": 1,
      "cost": 2,
      "short_description": "This unit makes an attack against a champion. If the attack is successful, the attacked unit is <condition value=eviscerated>Eviscerated</condition> for 2 turns, and is knocked back 1 space.\r\n",
      "long_description": "This unit makes an attack against a champion. If the attack is successful, the attacked unit is <condition value=eviscerated>Eviscerated</condition> for 2 turns, and is knocked back 1 space.\r\n",
      "class_name": "ViciousBlow",
      "revision": 1
    },
    {
      "asset_id": 5139,
      "resettable": 1,
      "name": "Vicious Blow",
      "ap_cost": 1,
      "level": 2,
      "ability_id": 1690,
      "activated": 1,
      "icon_name": "stab",
      "comments": "Attack+1 ap cost",
      "prerequisite_id": 1689,
      "cooldown": 8,
      "activation_type": 1,
      "ranked": 1,
      "cost": 2,
      "short_description": "This unit makes an attack against a champion. If the attack is successful, the attacked unit is <condition value=eviscerated>Eviscerated</condition> for 3 turns, and is knocked back 1 space.\r\n",
      "long_description": "This unit makes an attack against a champion. If the attack is successful, the attacked unit is <condition value=eviscerated>Eviscerated</condition> for 3 turns, and is knocked back 1 space.\r\n",
      "class_name": "ViciousBlow",
      "revision": 1
    },
    {
      "asset_id": 5139,
      "resettable": 1,
      "name": "Vicious Blow",
      "ap_cost": 1,
      "level": 3,
      "ability_id": 1691,
      "activated": 1,
      "icon_name": "stab",
      "comments": "Attack+1 ap cost",
      "prerequisite_id": 1690,
      "cooldown": 8,
      "activation_type": 1,
      "ranked": 1,
      "cost": 2,
      "short_description": "This unit makes an attack against a champion. If the attack is successful, the attacked unit is <condition value=eviscerated>Eviscerated</condition> for 3 turns, and is knocked back 2 spaces.\r\n",
      "long_description": "This unit makes an attack against a champion. If the attack is successful, the attacked unit is <condition value=eviscerated>Eviscerated</condition> for 3 turns, and is knocked back 2 spaces.\r\n",
      "class_name": "ViciousBlow",
      "revision": 1
    },
    {
      "asset_id": 5139,
      "resettable": 1,
      "name": "Vicious Blow",
      "ap_cost": 1,
      "level": 4,
      "ability_id": 1692,
      "activated": 1,
      "icon_name": "stab",
      "comments": "Attack+1 ap cost",
      "prerequisite_id": 1691,
      "cooldown": 8,
      "activation_type": 1,
      "ranked": 1,
      "cost": 2,
      "short_description": "This unit makes an attack against a champion. If the attack is successful, the attacked unit is <condition value=eviscerated>Eviscerated</condition> for 4 turns, and is knocked back 2 spaces.\r\n",
      "long_description": "This unit makes an attack against a champion. If the attack is successful, the attacked unit is <condition value=eviscerated>Eviscerated</condition> for 4 turns, and is knocked back 2 spaces.\r\n",
      "class_name": "ViciousBlow",
      "revision": 1
    },
    {
      "asset_id": 5139,
      "resettable": 1,
      "name": "Vicious Blow",
      "ap_cost": 1,
      "level": 5,
      "ability_id": 1693,
      "activated": 1,
      "icon_name": "stab",
      "comments": "Attack+1 ap cost",
      "prerequisite_id": 1692,
      "cooldown": 8,
      "activation_type": 1,
      "ranked": 1,
      "cost": 2,
      "short_description": "This unit makes an attack against a champion. If the attack is successful, the attacked unit is <condition value=eviscerated>Eviscerated</condition> for 4 turns, and is knocked back 3 spaces.\r\n",
      "long_description": "This unit makes an attack against a champion. If the attack is successful, the attacked unit is <condition value=eviscerated>Eviscerated</condition> for 4 turns, and is knocked back 3 spaces.\r\n",
      "class_name": "ViciousBlow",
      "revision": 1
    },
    {
      "asset_id": 5139,
      "resettable": 1,
      "name": "Vicious Blow",
      "ap_cost": 1,
      "level": 6,
      "ability_id": 1694,
      "activated": 1,
      "icon_name": "stab",
      "comments": "Attack+1 ap cost",
      "prerequisite_id": 1693,
      "cooldown": 6,
      "activation_type": 1,
      "ranked": 1,
      "cost": 2,
      "short_description": "This unit makes an attack against a champion. If the attack is successful, the attacked unit is <condition value=eviscerated>Eviscerated</condition> for 5 turns, and is knocked back 3 spaces.",
      "long_description": "This unit makes an attack against a champion. If the attack is successful, the attacked unit is <condition value=eviscerated>Eviscerated</condition> for 5 turns, and is knocked back 3 spaces.",
      "class_name": "ViciousBlow",
      "revision": 1
    },
    {
      "asset_id": 4933,
      "resettable": 1,
      "name": "Vicious Harpoon",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1819,
      "activated": 1,
      "icon_name": "pull",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "At the end of your turn, the closest opposing champion within 3 spaces takes 8 Physical damage and is moved adjacent to this relic.",
      "long_description": "At the end of your turn, the closest opposing champion within 3 spaces takes 8 Physical damage and is moved adjacent to this relic.",
      "class_name": "RelicViciousHarpoon",
      "revision": 1
    },
    {
      "asset_id": 5692,
      "resettable": 1,
      "name": "Vigilance",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2568,
      "activated": 1,
      "icon_name": "vigilance",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 8,
      "short_description": "This champion has +1 DMG for each engaged friendly champion within 5 spaces, including itself.  At the end of its turn, it gains a rank of <ability value=1900>Tough</ability> for 2 turns for each engaged friendly champion within 5 spaces, including this one.  It also gains +1 SPD if that champion shares a race or class with it, not including itself.",
      "long_description": "This champion has +1 DMG for each engaged friendly champion within 5 spaces, including itself.  At the end of its turn, it gains a rank of <ability value=1900>Tough</ability> for 2 turns for each engaged friendly champion within 5 spaces, including this one.  It also gains +1 SPD if that champion shares a race or class with it, not including itself.",
      "class_name": "Vigilance",
      "revision": 1
    },
    {
      "asset_id": 7152,
      "resettable": 0,
      "name": "Vigor: Acid",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2994,
      "activated": 1,
      "icon_name": "vigor_acid",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 7,
      "short_description": "The first time each turn a champion within 3 spaces takes Acid damage from a source other than this champion, this champion gains 2 AP.",
      "long_description": "The first time each turn a champion within 3 spaces takes Acid damage from a source other than this champion, this champion gains 2 AP.",
      "class_name": "VigorAcid",
      "revision": 1
    },
    {
      "asset_id": 7169,
      "resettable": 0,
      "name": "Vigor: Psychic",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3012,
      "activated": 1,
      "icon_name": "vigor_psychic",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 7,
      "short_description": "The first time each turn a champion within 3 spaces takes Psychic damage from a source other than this champion, this champion gains 2 AP.",
      "long_description": "The first time each turn a champion within 3 spaces takes Psychic damage from a source other than this champion, this champion gains 2 AP.",
      "class_name": "VigorPsychic",
      "revision": 1
    },
    {
      "asset_id": 4755,
      "resettable": 1,
      "name": "Vigorous Cry",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1479,
      "activated": 1,
      "icon_name": "allybuffs",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "Whenever this unit makes a successful attack against a champion with a basic attack, friendly champions within 5 spaces gain 1 AP.",
      "long_description": "Whenever this unit makes a successful attack against a champion with a basic attack, friendly champions within 5 spaces gain 1 AP.",
      "class_name": "VigorousCry",
      "revision": 1
    },
    {
      "asset_id": 5102,
      "resettable": 1,
      "name": "Vindictive",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1277,
      "activated": 1,
      "icon_name": "multiattack",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "When a champion you own that shares a race with this champion is on cooldown, this champion gains <ability value=17>Multiattack 3</ability>.",
      "long_description": "When a champion you own that shares a race with this champion is on cooldown, this champion gains <ability value=17>Multiattack 3</ability>.",
      "class_name": "Vindictive",
      "revision": 1
    },
    {
      "asset_id": 4263,
      "resettable": 0,
      "name": "Vine Whip",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 3332,
      "activated": 1,
      "icon_name": "drive",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 3,
      "ranked": 0,
      "cost": 6,
      "short_description": "This champion makes a Physical attack at RNG 2-5. If the target is occupying Vegetation, <condition value=ensnared>Ensnared</condition> or <condition value=rooted>Rooted</condition> and is successfully damaged, the target also becomes <condition value=burred>Burred</condition> for 3 turns and <condition value=eviscerated>Eviscerated</condition> for 3 turns.",
      "long_description": "This champion makes a Physical attack at RNG 2-5. If the target is occupying Vegetation, <condition value=ensnared>Ensnared</condition> or <condition value=rooted>Rooted</condition> and is successfully damaged, the target also becomes <condition value=burred>Burred</condition> for 3 turns and <condition value=eviscerated>Eviscerated</condition> for 3 turns.",
      "class_name": "VineWhip",
      "revision": 1
    },
    {
      "asset_id": 5523,
      "resettable": 1,
      "name": "Vinetouch",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2382,
      "activated": 1,
      "icon_name": "gif_of_ironwood",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "Friendly Champions that come into play within 3 spaces of this unit gain Race: Treefolk and Race: Plant.",
      "long_description": "Friendly Champions that come into play within 3 spaces of this unit gain Race: Treefolk and Race: Plant.",
      "class_name": "Vinetouch",
      "revision": 1
    },
    {
      "asset_id": 5332,
      "resettable": 1,
      "name": "Violence Charged",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 2261,
      "activated": 1,
      "icon_name": "charged_abuse",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 4,
      "short_description": "When an opposing champion makes a basic attack, this unit gains 1 charge.",
      "long_description": "When an opposing champion makes a basic attack, this unit gains 1 charge.",
      "class_name": "ViolenceCharged",
      "revision": 1
    },
    {
      "asset_id": 5332,
      "resettable": 1,
      "name": "Violence Charged",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 2262,
      "activated": 1,
      "icon_name": "charged_abuse",
      "comments": "",
      "prerequisite_id": 2261,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 8,
      "short_description": "When an opposing champion makes a basic attack, this unit gains 2 charges.",
      "long_description": "When an opposing champion makes a basic attack, this unit gains 2 charges.",
      "class_name": "ViolenceCharged",
      "revision": 1
    },
    {
      "asset_id": 5332,
      "resettable": 1,
      "name": "Violence Charged",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 2263,
      "activated": 1,
      "icon_name": "charged_abuse",
      "comments": "",
      "prerequisite_id": 2262,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 12,
      "short_description": "When an opposing champion makes a basic attack, this unit gains 3 charges.",
      "long_description": "When an opposing champion makes a basic attack, this unit gains 3 charges.",
      "class_name": "ViolenceCharged",
      "revision": 1
    },
    {
      "asset_id": 5000,
      "resettable": 1,
      "name": "Violent",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1880,
      "activated": 1,
      "icon_name": "aggressive",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 2,
      "short_description": "This champion has <ability value=732>Fury</ability> if a friendly champion that shares a race or class with it is within 2 spaces.",
      "long_description": "This champion has <ability value=732>Fury</ability> if a friendly champion that shares a race or class with it is within 2 spaces.",
      "class_name": "Violent",
      "revision": 1
    },
    {
      "asset_id": 7206,
      "resettable": 0,
      "name": "Vitality: Creation",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3043,
      "activated": 1,
      "icon_name": "fascinate",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "The first time each turn a champion comes into play, this champion gains +2 MAX HP.",
      "long_description": "The first time each turn a champion comes into play, this champion gains +2 MAX HP.",
      "class_name": "VitalityCreation",
      "revision": 1
    },
    {
      "asset_id": 5683,
      "resettable": 1,
      "name": "Vitality: Nora",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2556,
      "activated": 1,
      "icon_name": "noragen",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 4,
      "short_description": "The first time each turn that nora is generated via spells, relics and abilities, this champion gains +2 MAX HP.",
      "long_description": "The first time each turn that nora is generated via spells, relics and abilities, this champion gains +2 MAX HP.",
      "class_name": "NoraVitality",
      "revision": 1
    },
    {
      "asset_id": 5201,
      "resettable": 1,
      "name": "Vitalize",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1978,
      "activated": 1,
      "icon_name": "allybuffs",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "Other real friendly champions within 5 spaces with 5 base SPD or less get +1 SPD while this unit is in play. This ability does not stack.",
      "long_description": "Other real friendly champions within 5 spaces with 5 base SPD or less get +1 SPD while this unit is in play. This ability does not stack.",
      "class_name": "Vitalize",
      "revision": 1
    },
    {
      "asset_id": 5784,
      "resettable": 1,
      "name": "Vivify",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2707,
      "activated": 1,
      "icon_name": "allybuffs",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "When a friendly champion within 3 spaces that shares a race with this champion makes a successful attack, this champion gains 1 AP.",
      "long_description": "When a friendly champion within 3 spaces that shares a race with this champion makes a successful attack, this champion gains 1 AP.",
      "class_name": "Vivify",
      "revision": 1
    },
    {
      "asset_id": 7965,
      "resettable": 0,
      "name": "Voice of the Clans",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3352,
      "activated": 1,
      "icon_name": "savage",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "When this unit enters play, it gains a copy of <ability value=2875>Warchief: Blood Clan</ability>, <ability value=2873>Warchief: Stone Clan</ability>, <ability value=2872>Warchief: Storm Clan</ability> and <ability value=3403>Warchief: Beast Clan</ability> if any other friendly unit has that ability. When a friendly champion enters play that has one of those abilities, this unit gains a copy of that ability.",
      "long_description": "When this unit enters play, it gains a copy of <ability value=2875>Warchief: Blood Clan</ability>, <ability value=2873>Warchief: Stone Clan</ability>, <ability value=2872>Warchief: Storm Clan</ability> and <ability value=3403>Warchief: Beast Clan</ability> if any other friendly unit has that ability. When a friendly champion enters play that has one of those abilities, this unit gains a copy of that ability.",
      "class_name": "VoiceOfTheClans",
      "revision": 1
    },
    {
      "asset_id": 4737,
      "resettable": 1,
      "name": "Voices in Their Head",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 2573,
      "activated": 1,
      "icon_name": "possess",
      "comments": "Relic",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 20,
      "short_description": "Target opposing champion within 3 spaces becomes <condition value=possessed>Possessed</condition>, recovers 4 AP and gains <ability value=2005>Careless</ability> and <ability value=2253>Manic</ability> for 1 turn, and gains <ability value=1408>Chasm Walker</ability> for 2 turns.",
      "long_description": "Target opposing champion within 3 spaces becomes <condition value=possessed>Possessed</condition>, recovers 4 AP and gains <ability value=2005>Careless</ability> and <ability value=2253>Manic</ability> for 1 turn, and gains <ability value=1408>Chasm Walker</ability> for 2 turns.",
      "class_name": "VoicesInTheirHead",
      "revision": 1
    },
    {
      "asset_id": 5191,
      "resettable": 1,
      "name": "Void Howl",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1968,
      "activated": 1,
      "icon_name": "sonicaoe",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 15,
      "short_description": "When this champion dies, it deals 12 Sonic Damage to all champions within 3 spaces. This damage ignores DEF. If an opposing non-Illusion, non-Summoned champion is destroyed by this ability, a Voidhowler is spawned under your control.",
      "long_description": "When this champion dies, it deals 12 Sonic Damage to all champions within 3 spaces. This damage ignores DEF. If an opposing non-Illusion, non-Summoned champion is destroyed by this ability, a Voidhowler is spawned under your control.",
      "class_name": "VoidHowl",
      "revision": 1
    },
    {
      "asset_id": 5750,
      "resettable": 1,
      "name": "Void Shield",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2649,
      "activated": 1,
      "icon_name": "tetra_shield",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "When this champion takes 4 or more damage, it gains a rank of Resistance to that damage type.",
      "long_description": "When this champion takes 4 or more damage, it gains a rank of Resistance to that damage type.",
      "class_name": "ChaosShield",
      "revision": 1
    },
    {
      "asset_id": 5432,
      "resettable": 1,
      "name": "Void Strike",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 2650,
      "activated": 1,
      "icon_name": "chaos_incarnate",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "This champion's next basic attack this turn has +1 DMG for every 20 nora in your nora bank and deals <mechanic value=lossoflife>Loss of Life</mechanic> instead.",
      "long_description": "This champion's next basic attack this turn has +1 DMG for every 20 nora in your nora bank and deals <mechanic value=lossoflife>Loss of Life</mechanic> instead.",
      "class_name": "ChaosStrike",
      "revision": 1
    },
    {
      "asset_id": 5892,
      "resettable": 1,
      "name": "Void Touch",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2901,
      "activated": 1,
      "icon_name": "touch_void",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "When this champion successfully hits a champion with a basic attack, the attacked champion loses an ability with the highest nora cost (this does not remove basic attacks).",
      "long_description": "When this champion successfully hits a champion with a basic attack, the attacked champion loses an ability with the highest nora cost (this does not remove basic attacks).",
      "class_name": "VoidTouch",
      "revision": 1
    },
    {
      "asset_id": 4592,
      "resettable": 1,
      "name": "Voil Bound",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 967,
      "activated": 1,
      "icon_name": "disable",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -6,
      "short_description": "At the beginning of your enemy's turns, there are no other friendly Voil in play, this unit is <condition value=possessed>Possessed</condition> by your enemy until end of turn.",
      "long_description": "At the beginning of your enemy's turns, there are no other friendly Voil in play, this unit is <condition value=possessed>Possessed</condition> by your enemy until end of turn.",
      "class_name": "VoilBound",
      "revision": 1
    },
    {
      "asset_id": 5156,
      "resettable": 1,
      "name": "Voil Caverns",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1928,
      "activated": 1,
      "icon_name": "sumbat",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 11,
      "short_description": "The first time each turn a real enemy champion within 5 spaces is destroyed, a Young Bat with no upgrades is summoned adjacent to this unit.",
      "long_description": "The first time each turn a real enemy champion within 5 spaces is destroyed, a Young Bat with no upgrades is summoned adjacent to this unit.",
      "class_name": "VoilCaverns",
      "revision": 1
    },
    {
      "asset_id": 7991,
      "resettable": 0,
      "name": "Voil King's Crypt",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3386,
      "activated": 1,
      "icon_name": "intensify",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "Friendly champions with Race: Voil within 5 spaces gain <ability value=1276>Vengeful</ability> and <ability value=2557>Martyrdom</ability>.",
      "long_description": "Friendly champions with Race: Voil within 5 spaces gain <ability value=1276>Vengeful</ability> and <ability value=2557>Martyrdom</ability>.",
      "class_name": "RelicVoilKingsCrypt",
      "revision": 1
    },
    {
      "asset_id": 7339,
      "resettable": 0,
      "name": "Voil Senses",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3108,
      "activated": 1,
      "icon_name": "voil_senses",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 8,
      "short_description": "When a friendly Voil within 5 spaces makes a successful basic attack, this champion gains +1 MAX RNG and +2 DMG for 1 turn.  This ability can trigger up to 3 times per turn.",
      "long_description": "When a friendly Voil within 5 spaces makes a successful basic attack, this champion gains +1 MAX RNG and +2 DMG for 1 turn.  This ability can trigger up to 3 times per turn.",
      "class_name": "VoilSenses",
      "revision": 1
    },
    {
      "asset_id": 4059,
      "resettable": 1,
      "name": "Volatile",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 104,
      "activated": 1,
      "icon_name": "shrinebad",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 0,
      "short_description": "When this unit is deployed, if ther are no friendly champions from this unit's faction, your shrine loses 55 HP.",
      "long_description": "When this unit is deployed, if ther are no friendly champions from this unit's faction, your shrine loses 55 HP.",
      "class_name": "Volatile",
      "revision": 1
    },
    {
      "asset_id": 5103,
      "resettable": 1,
      "name": "Volatile: Demon",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1278,
      "activated": 1,
      "icon_name": "volatile",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -8,
      "short_description": "When this champion is deployed, if you do not control a Demon champion, your shrine loses 10 HP.",
      "long_description": "When this champion is deployed, if you do not control a Demon champion, your shrine loses 10 HP.",
      "class_name": "VolatileDemon",
      "revision": 1
    },
    {
      "asset_id": 4921,
      "resettable": 1,
      "name": "Volley Leader",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1803,
      "activated": 1,
      "icon_name": "dictate",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "Other friendly Archers within 5 spaces gain a rank of <ability value=1088>Rain of Arrows</ability>.",
      "long_description": "Other friendly Archers within 5 spaces gain a rank of <ability value=1088>Rain of Arrows</ability>.",
      "class_name": "VolleyLeader",
      "revision": 1
    },
    {
      "asset_id": 4051,
      "resettable": 1,
      "name": "Vulnerability: Acid",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 93,
      "activated": 1,
      "icon_name": "vuln_acid",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": -2,
      "short_description": "When this unit takes Acid damage, that damage is increased by 25% (after DEF).",
      "long_description": "When this unit takes Acid damage, that damage is increased by 25% (after DEF).",
      "class_name": "VulnerabilityAcid",
      "revision": 1
    },
    {
      "asset_id": 4052,
      "resettable": 1,
      "name": "Vulnerability: Disease",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 94,
      "activated": 1,
      "icon_name": "vuln_disease",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": -2,
      "short_description": "When this unit takes Disease damage, that damage is increased by 25% (after DEF).",
      "long_description": "When this unit takes Disease damage, that damage is increased by 25% (after DEF).",
      "class_name": "VulnerabilityDisease",
      "revision": 1
    },
    {
      "asset_id": 4048,
      "resettable": 1,
      "name": "Vulnerability: Electricity",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 90,
      "activated": 1,
      "icon_name": "vuln_electric",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": -2,
      "short_description": "When this unit takes Electricity damage, that damage is increased by 25% (after DEF).",
      "long_description": "When this unit takes Electricity damage, that damage is increased by 25% (after DEF).",
      "class_name": "VulnerabilityElectricity",
      "revision": 1
    },
    {
      "asset_id": 4046,
      "resettable": 1,
      "name": "Vulnerability: Fire",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 88,
      "activated": 1,
      "icon_name": "vuln_fire",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": -4,
      "short_description": "When this unit takes Fire damage, that damage is increased by 25% (after DEF).",
      "long_description": "When this unit takes Fire damage, that damage is increased by 25% (after DEF).",
      "class_name": "VulnerabilityFire",
      "revision": 1
    },
    {
      "asset_id": 4047,
      "resettable": 1,
      "name": "Vulnerability: Frost",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 89,
      "activated": 1,
      "icon_name": "vuln_frost",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": -4,
      "short_description": "When this unit takes Frost damage, that damage is increased by 25% (after DEF).",
      "long_description": "When this unit takes Frost damage, that damage is increased by 25% (after DEF).",
      "class_name": "VulnerabilityCold",
      "revision": 1
    },
    {
      "asset_id": 4045,
      "resettable": 1,
      "name": "Vulnerability: Magical",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 87,
      "activated": 1,
      "icon_name": "vuln_magic",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": -6,
      "short_description": "When this unit takes Magical damage, that damage is increased by 25% (after DEF).",
      "long_description": "When this unit takes Magical damage, that damage is increased by 25% (after DEF).",
      "class_name": "VulnerabilityMagical",
      "revision": 1
    },
    {
      "asset_id": 4044,
      "resettable": 1,
      "name": "Vulnerability: Physical",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 86,
      "activated": 1,
      "icon_name": "vuln_physical",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": -8,
      "short_description": "When this unit takes Physical damage, that damage is increased by 25% (after DEF).",
      "long_description": "When this unit takes Physical damage, that damage is increased by 25% (after DEF).",
      "class_name": "VulnerabilityPhysical",
      "revision": 1
    },
    {
      "asset_id": 4049,
      "resettable": 1,
      "name": "Vulnerability: Poison",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 91,
      "activated": 1,
      "icon_name": "vuln_poison",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": -2,
      "short_description": "When this unit takes Poison damage, that damage is increased by 25% (after DEF).",
      "long_description": "When this unit takes Poison damage, that damage is increased by 25% (after DEF).",
      "class_name": "VulnerabilityPoison",
      "revision": 1
    },
    {
      "asset_id": 4053,
      "resettable": 1,
      "name": "Vulnerability: Psychic",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 95,
      "activated": 1,
      "icon_name": "vuln_psychic",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": -2,
      "short_description": "When this unit takes Psychic damage, that damage is increased by 25% (after DEF).",
      "long_description": "When this unit takes Psychic damage, that damage is increased by 25% (after DEF).",
      "class_name": "VulnerabilityPsychic",
      "revision": 1
    },
    {
      "asset_id": 4050,
      "resettable": 1,
      "name": "Vulnerability: Sonic",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 92,
      "activated": 1,
      "icon_name": "vuln_sonic",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": -2,
      "short_description": "When this unit takes Sonic damage, that damage is increased by 25% (after DEF).",
      "long_description": "When this unit takes Sonic damage, that damage is increased by 25% (after DEF).",
      "class_name": "VulnerabilitySonic",
      "revision": 1
    },
    {
      "asset_id": 5126,
      "resettable": 1,
      "name": "Vulnerable",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1316,
      "activated": 1,
      "icon_name": "vuln_physical",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -3,
      "short_description": "When this unit makes an attack, it gets -1 DEF for 2 turns.",
      "long_description": "When this unit makes an attack, it gets -1 DEF for 2 turns.",
      "class_name": "Vulnerable",
      "revision": 1
    },
    {
      "asset_id": 5199,
      "resettable": 1,
      "name": "Wail of Grief",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 1976,
      "activated": 1,
      "icon_name": "novasonic",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "Enemy champions within 3 spaces take 8 Sonic damage and lose all AP. This damage ignores DEF.",
      "long_description": "Enemy champions within 3 spaces take 8 Sonic damage and lose all AP. This damage ignores DEF.",
      "class_name": "GriefSong",
      "revision": 1
    },
    {
      "asset_id": 7359,
      "resettable": 0,
      "name": "Walk the Path",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 3116,
      "activated": 1,
      "icon_name": "relocate",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "This champion is relocated to target space within 5 spaces. This ability may only target spaces within 2 spaces of a Path of De'lim relic. After relocation, the champion deals 3 Fire damage to units within 2 spaces.",
      "long_description": "This champion is relocated to target space within 5 spaces. This ability may only target spaces within 2 spaces of a Path of De'lim relic. After relocation, the champion deals 3 Fire damage to units within 2 spaces.",
      "class_name": "WalkThePath",
      "revision": 1
    },
    {
      "asset_id": 4636,
      "resettable": 1,
      "name": "Wandering",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2266,
      "activated": 1,
      "icon_name": "wandering_new",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -30,
      "short_description": "At the end of your opponent's turns, this unit moves 2 spaces randomly towards your enemies Shrine or Avatar. This unit cannot spend AP on movement.",
      "long_description": "At the end of your opponent's turns, this unit moves 2 spaces randomly towards your enemies Shrine or Avatar. This unit cannot spend AP on movement.",
      "class_name": "Wandering",
      "revision": 1
    },
    {
      "asset_id": 5149,
      "resettable": 1,
      "name": "War Leader",
      "ap_cost": 2,
      "level": 1,
      "ability_id": 1675,
      "activated": 1,
      "icon_name": "allybuffs",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 6,
      "activation_type": 1,
      "ranked": 1,
      "cost": 2,
      "short_description": "Adjacent friendly champions gain 1 AP and Benediction (This champion has +3 DMG, +2 SPD, and +1 DEF. This effect does not stack) for 2 turns.",
      "long_description": "Adjacent friendly champions gain 1 AP and Benediction (This champion has +3 DMG, +2 SPD, and +1 DEF. This effect does not stack) for 2 turns.",
      "class_name": "WarLeader",
      "revision": 1
    },
    {
      "asset_id": 5149,
      "resettable": 1,
      "name": "War Leader",
      "ap_cost": 2,
      "level": 2,
      "ability_id": 1676,
      "activated": 1,
      "icon_name": "allybuffs",
      "comments": "none",
      "prerequisite_id": 1675,
      "cooldown": 6,
      "activation_type": 1,
      "ranked": 1,
      "cost": 2,
      "short_description": "Friendly champions within 2 spaces gain 1 AP and Benediction (This champion has +3 DMG, +2 SPD, and +1 DEF. This effect does not stack) for 2 turns.",
      "long_description": "Friendly champions within 2 spaces gain 1 AP and Benediction (This champion has +3 DMG, +2 SPD, and +1 DEF. This effect does not stack) for 2 turns.",
      "class_name": "WarLeader",
      "revision": 1
    },
    {
      "asset_id": 5149,
      "resettable": 1,
      "name": "War Leader",
      "ap_cost": 2,
      "level": 3,
      "ability_id": 1677,
      "activated": 1,
      "icon_name": "allybuffs",
      "comments": "none",
      "prerequisite_id": 1676,
      "cooldown": 6,
      "activation_type": 1,
      "ranked": 1,
      "cost": 2,
      "short_description": "Friendly champions within 2 spaces gain 2 AP and Benediction (This champion has +3 DMG, +2 SPD, and +1 DEF. This effect does not stack) for 2 turns.",
      "long_description": "Friendly champions within 2 spaces gain 2 AP and Benediction (This champion has +3 DMG, +2 SPD, and +1 DEF. This effect does not stack) for 2 turns.",
      "class_name": "WarLeader",
      "revision": 1
    },
    {
      "asset_id": 0,
      "resettable": 1,
      "name": "Warbanner (FS)",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 823,
      "activated": 1,
      "icon_name": "allybuffs",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "While this Warbanner relic is in play, all of your deployed champions from Forglar Swamp gain +5 HP and +1 DMG. This does not affect teammates.",
      "long_description": "While this Warbanner relic is in play, all of your deployed champions from Forglar Swamp gain +5 HP and +1 DMG. This does not affect teammates.",
      "class_name": "WarbannerForglar",
      "revision": 1
    },
    {
      "asset_id": 0,
      "resettable": 1,
      "name": "Warbanner (FW)",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 824,
      "activated": 1,
      "icon_name": "allybuffs",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "While this Warbanner relic is in play, all of your deployed champions from Forsaken Wastes gain +5 HP and +1 DMG. This does not affect teammates.",
      "long_description": "While this Warbanner relic is in play, all of your deployed champions from Forsaken Wastes gain +5 HP and +1 DMG. This does not affect teammates.",
      "class_name": "WarbannerForsakenWastes",
      "revision": 1
    },
    {
      "asset_id": 0,
      "resettable": 1,
      "name": "Warbanner (IS)",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 825,
      "activated": 1,
      "icon_name": "allybuffs",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "While this Warbanner relic is in play, all of your deployed champions from Ironfist Stronghold gain +5 HP and +1 DMG. This does not affect teammates.",
      "long_description": "While this Warbanner relic is in play, all of your deployed champions from Ironfist Stronghold gain +5 HP and +1 DMG. This does not affect teammates.",
      "class_name": "WarbannerIronfist",
      "revision": 1
    },
    {
      "asset_id": 0,
      "resettable": 1,
      "name": "Warbanner (KF)",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 826,
      "activated": 1,
      "icon_name": "allybuffs",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "While this Warbanner relic is in play, all of your deployed champions from K'thir Forest gain +5 HP and +1 DMG.  This does not affect teammates.",
      "long_description": "While this Warbanner relic is in play, all of your deployed champions from K'thir Forest gain +5 HP and +1 DMG.  This does not affect teammates.",
      "class_name": "WarbannerKthirForest",
      "revision": 1
    },
    {
      "asset_id": 0,
      "resettable": 1,
      "name": "Warbanner (SL)",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 828,
      "activated": 1,
      "icon_name": "allybuffs",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "While this Warbanner relic is in play, all of your deployed champions from Sundered Lands gain +5 HP and +1 DMG. This does not affect teammates.",
      "long_description": "While this Warbanner relic is in play, all of your deployed champions from Sundered Lands gain +5 HP and +1 DMG. This does not affect teammates.",
      "class_name": "WarbannerSunderedLands",
      "revision": 1
    },
    {
      "asset_id": 0,
      "resettable": 1,
      "name": "Warbanner (SP)",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 827,
      "activated": 1,
      "icon_name": "allybuffs",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "While this Warbanner relic is in play, all of your deployed champions from Shattered Peaks gain +5 HP and +1 DMG. This does not affect teammates.",
      "long_description": "While this Warbanner relic is in play, all of your deployed champions from Shattered Peaks gain +5 HP and +1 DMG. This does not affect teammates.",
      "class_name": "WarbannerShatteredPeaks",
      "revision": 1
    },
    {
      "asset_id": 0,
      "resettable": 1,
      "name": "Warbanner (ST)",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 822,
      "activated": 1,
      "icon_name": "allybuffs",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "While this Warbanner relic is in play, all of your deployed champions from Savage Tundra gain +5 HP and +1 DMG. This does not affect teammates.",
      "long_description": "While this Warbanner relic is in play, all of your deployed champions from Savage Tundra gain +5 HP and +1 DMG. This does not affect teammates.",
      "class_name": "WarbannerSavageTundra",
      "revision": 1
    },
    {
      "asset_id": 0,
      "resettable": 1,
      "name": "Warbanner (UD)",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 829,
      "activated": 1,
      "icon_name": "allybuffs",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "While this Warbanner relic is in play, all of your deployed champions from Underdepths gain +5 HP and +1 DMG. This does not affect teammates.",
      "long_description": "While this Warbanner relic is in play, all of your deployed champions from Underdepths gain +5 HP and +1 DMG. This does not affect teammates.",
      "class_name": "WarbannerUnderdepths",
      "revision": 1
    },
    {
      "asset_id": 8006,
      "resettable": 0,
      "name": "Warchief: Beast Clan",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3403,
      "activated": 1,
      "icon_name": "beast_clan",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "This unit has <ability value=1306>Mountaineer</ability>. At the end of your turn, this unit gains a rank of <ability value=394>Charge</ability>. When this unit is destroyed and there is no other champion with this ability, the closest friendly champion with Race: Barbarian gains this ability.",
      "long_description": "This unit has <ability value=1306>Mountaineer</ability>. At the end of your turn, this unit gains a rank of <ability value=394>Charge</ability>. When this unit is destroyed and there is no other champion with this ability, the closest friendly champion with Race: Barbarian gains this ability.",
      "class_name": "WarchiefBeastClan",
      "revision": 1
    },
    {
      "asset_id": 5866,
      "resettable": 1,
      "name": "Warchief: Blood Clan",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2875,
      "activated": 1,
      "icon_name": "blood_clan",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "This unit is <ability value=3>Fearless</ability>. At the end of your turn, this unit gains 1 rank of <ability value=163>Rend</ability>. When this unit is destroyed and there is no other champion with this ability, the closest friendly champion with Race: Barbarian gains this ability.",
      "long_description": "This unit is <ability value=3>Fearless</ability>. At the end of your turn, this unit gains 1 rank of <ability value=163>Rend</ability>. When this unit is destroyed and there is no other champion with this ability, the closest friendly champion with Race: Barbarian gains this ability.",
      "class_name": "WarchiefBloodclan",
      "revision": 1
    },
    {
      "asset_id": 5864,
      "resettable": 1,
      "name": "Warchief: Stone Clan",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2873,
      "activated": 1,
      "icon_name": "stone_clan",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "This unit has <ability value=3379>Magic Ward</ability>. At the end of your turn, this unit gains a rank of <ability value=1900>Tough</ability>. When this unit is destroyed and there is no other champion with this ability, the closest friendly champion with Race: Barbarian gains this ability.\n",
      "long_description": "This unit has <ability value=3379>Magic Ward</ability>. At the end of your turn, this unit gains a rank of <ability value=1900>Tough</ability>. When this unit is destroyed and there is no other champion with this ability, the closest friendly champion with Race: Barbarian gains this ability.\n",
      "class_name": "WarchiefStoneclan",
      "revision": 1
    },
    {
      "asset_id": 5863,
      "resettable": 1,
      "name": "Warchief: Storm Clan",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2872,
      "activated": 1,
      "icon_name": "storm_clan",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "This unit has <ability value=3158>Reckless</ability>. At the end of its turn, this unit gains one rank of <ability value=2289>Lightning Storm</ability>. When this unit is destroyed and there are no other champion with this ability, the closest friendly champion with Race: Barbarian gains this ability.",
      "long_description": "This unit has <ability value=3158>Reckless</ability>. At the end of its turn, this unit gains one rank of <ability value=2289>Lightning Storm</ability>. When this unit is destroyed and there are no other champion with this ability, the closest friendly champion with Race: Barbarian gains this ability.",
      "class_name": "WarchiefStormclan",
      "revision": 1
    },
    {
      "asset_id": 4109,
      "resettable": 1,
      "name": "Warcry",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 263,
      "activated": 1,
      "icon_name": "allybuffs",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 1,
      "cost": 10,
      "short_description": "When this unit makes a successful basic attack, friendly champions within 3 spaces that share a race with this champion recover 2 AP and get +2 DMG until end of turn.  This triggers once per turn and units can be affected once per turn.",
      "long_description": "When this unit makes a successful basic attack, friendly champions within 3 spaces that share a race with this champion recover 2 AP and get +2 DMG until end of turn.  This triggers once per turn and units can be affected once per turn.",
      "class_name": "Warcry",
      "revision": 1
    },
    {
      "asset_id": 5511,
      "resettable": 1,
      "name": "Warding",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2372,
      "activated": 1,
      "icon_name": "spell_resistance",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 2,
      "short_description": "This champion cannot be targeted by spells.",
      "long_description": "This champion cannot be targeted by spells.",
      "class_name": "Warding",
      "revision": 1
    },
    {
      "asset_id": 4337,
      "resettable": 1,
      "name": "Warguard",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2476,
      "activated": 1,
      "icon_name": "aegis",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 12,
      "short_description": "When this unit takes damage from an attack or spell, that damage is reduced to 2.  After this effect occurs 5 times, this unit is destroyed.",
      "long_description": "When this unit takes damage from an attack or spell, that damage is reduced to 2.  After this effect occurs 5 times, this unit is destroyed.",
      "class_name": "Warguard",
      "revision": 1
    },
    {
      "asset_id": 7769,
      "resettable": 0,
      "name": "Warlord",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3294,
      "activated": 1,
      "icon_name": "warlord",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 8,
      "short_description": "When a friendly champion within 5 spaces that shares a race or class with this one makes a successful targeted attack, this champion gains +1 MAX RNG and +1 DMG for 1 turn. This ability can trigger up to 3 times per turn.",
      "long_description": "When a friendly champion within 5 spaces that shares a race or class with this one makes a successful targeted attack, this champion gains +1 MAX RNG and +1 DMG for 1 turn. This ability can trigger up to 3 times per turn.",
      "class_name": "Warlord",
      "revision": 1
    },
    {
      "asset_id": 5846,
      "resettable": 1,
      "name": "Warm and Fuzzy",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2855,
      "activated": 1,
      "icon_name": "furring",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "This unit is warm and fuzzy.",
      "long_description": "This unit is warm and fuzzy.",
      "class_name": "WarmAndFuzzy",
      "revision": 1
    },
    {
      "asset_id": 5107,
      "resettable": 1,
      "name": "Warmonger",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1290,
      "activated": 1,
      "icon_name": "enrage",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -2,
      "short_description": "When a friendly real champion is destroyed, this champion gains -1 DEF and +1 DMG.",
      "long_description": "When a friendly real champion is destroyed, this champion gains -1 DEF and +1 DMG.",
      "class_name": "Warmonger",
      "revision": 1
    },
    {
      "asset_id": 4693,
      "resettable": 1,
      "name": "Water Aura",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1133,
      "activated": 1,
      "icon_name": "terrainwater",
      "comments": "The implementing class for this ability is RelicFloodGenerator, despite its name being different. -Alan.",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "When this unit comes into play, spaces within 3 spaces of this unit become Shallow Water.",
      "long_description": "When this unit comes into play, spaces within 3 spaces of this unit become Shallow Water.",
      "class_name": "RelicFloodGenerator",
      "revision": 1
    },
    {
      "asset_id": 5310,
      "resettable": 1,
      "name": "Water Front",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2132,
      "activated": 1,
      "icon_name": "terrainwater",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "At the beginning of each turn, all spaces within 3 spaces of this champion becomes Shallow Water for 4 turns.",
      "long_description": "At the beginning of each turn, all spaces within 3 spaces of this champion becomes Shallow Water for 4 turns.",
      "class_name": "HighTide",
      "revision": 1
    },
    {
      "asset_id": 4710,
      "resettable": 1,
      "name": "Water Generator",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1163,
      "activated": 1,
      "icon_name": "terrainwater",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "At the end of your turn, spaces adjacent to terrain generated by this ability become Water.  When this relic leaves play, at end of turn, and the end of each turn thereafter, this terrain manipulation effect ends on the most recently affected spaces.",
      "long_description": "At the end of your turn, spaces adjacent to terrain generated by this ability become Water.  When this relic leaves play, at end of turn, and the end of each turn thereafter, this terrain manipulation effect ends on the most recently affected spaces.",
      "class_name": "WaterGenerator",
      "revision": 1
    },
    {
      "asset_id": 5738,
      "resettable": 1,
      "name": "Water Veil",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2625,
      "activated": 1,
      "icon_name": "terrainwater",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "When this champion comes into play, spaces within 10 spaces turns into Shallow Water terrain for 3 turns.",
      "long_description": "When this champion comes into play, spaces within 10 spaces turns into Shallow Water terrain for 3 turns.",
      "class_name": "WaterVeil",
      "revision": 1
    },
    {
      "asset_id": 5767,
      "resettable": 1,
      "name": "Water Vortex",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 2679,
      "activated": 1,
      "icon_name": "special",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 9,
      "short_description": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this champion take 12 Physical damage and are knocked back 1 space. This damage ignores DEF.",
      "long_description": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this champion take 12 Physical damage and are knocked back 1 space. This damage ignores DEF.",
      "class_name": "WaterVortex",
      "revision": 1
    },
    {
      "asset_id": 4811,
      "resettable": 1,
      "name": "Water Walker",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 1593,
      "activated": 1,
      "icon_name": "terrainwater",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 6,
      "short_description": "This champion has <ability value=1044>Trail: Water</ability> and <ability value=2>Amphibious</ability>. At the end of each turn, all spaces adjacent to this champion becomes Shallow Water for 2 turns.",
      "long_description": "This champion has <ability value=1044>Trail: Water</ability> and <ability value=2>Amphibious</ability>. At the end of each turn, all spaces adjacent to this champion becomes Shallow Water for 2 turns.",
      "class_name": "WaterWalker",
      "revision": 1
    },
    {
      "asset_id": 4811,
      "resettable": 1,
      "name": "Water Walker",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 1594,
      "activated": 1,
      "icon_name": "terrainwater",
      "comments": "",
      "prerequisite_id": 1593,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 6,
      "short_description": "This champion has <ability value=1044>Trail: Water</ability> and <ability value=2>Amphibious</ability>. At the end of each turn, all spaces within 2 spaces of this champion becomes Shallow Water for 2 turns.",
      "long_description": "This champion has <ability value=1044>Trail: Water</ability> and <ability value=2>Amphibious</ability>. At the end of each turn, all spaces within 2 spaces of this champion becomes Shallow Water for 2 turns.",
      "class_name": "WaterWalker",
      "revision": 1
    },
    {
      "asset_id": 4811,
      "resettable": 1,
      "name": "Water Walker",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 1595,
      "activated": 1,
      "icon_name": "terrainwater",
      "comments": "",
      "prerequisite_id": 1594,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 6,
      "short_description": "This champion has <ability value=1044>Trail: Water</ability> and <ability value=2>Amphibious</ability>. At the end of each turn, all spaces within 2 spaces of this champion becomes Shallow Water for 4 turns.",
      "long_description": "This champion has <ability value=1044>Trail: Water</ability> and <ability value=2>Amphibious</ability>. At the end of each turn, all spaces within 2 spaces of this champion becomes Shallow Water for 4 turns.",
      "class_name": "WaterWalker",
      "revision": 1
    },
    {
      "asset_id": 5185,
      "resettable": 1,
      "name": "Weaken Spells",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1962,
      "activated": 1,
      "icon_name": "dark_aura",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 8,
      "short_description": "Friendly champions within 5 spaces take 5 less damage from spells.",
      "long_description": "Friendly champions within 5 spaces take 5 less damage from spells.",
      "class_name": "WeakenSpells",
      "revision": 1
    },
    {
      "asset_id": 5235,
      "resettable": 1,
      "name": "Weapon Forge",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2015,
      "activated": 1,
      "icon_name": "forge",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 0,
      "short_description": "Target champion within 5 spaces becomes equipped with either Heavy Crossbow, Axeman's Fate or Sunder Axe. This unit loses 5 HP. Equipment generated by this ability has a nora cost of 0.",
      "long_description": "Target champion within 5 spaces becomes equipped with either Heavy Crossbow, Axeman's Fate or Sunder Axe. This unit loses 5 HP. Equipment generated by this ability has a nora cost of 0.",
      "class_name": "RelicMysticForge",
      "revision": 1
    },
    {
      "asset_id": 5235,
      "resettable": 1,
      "name": "Weapon Forger",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 2475,
      "activated": 1,
      "icon_name": "forge",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 25,
      "short_description": "Target champion within 5 spaces becomes equipped with either Heavy Crossbow, Axeman's Fate or Sunder Axe. This unit loses 5 HP. Equipment generated by this ability has a nora cost of 0.",
      "long_description": "Target champion within 5 spaces becomes equipped with either Heavy Crossbow, Axeman's Fate or Sunder Axe. This unit loses 5 HP. Equipment generated by this ability has a nora cost of 0.",
      "class_name": "RelicMysticForge",
      "revision": 1
    },
    {
      "asset_id": 5104,
      "resettable": 1,
      "name": "Weary",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1279,
      "activated": 1,
      "icon_name": "debuff",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this champion successfully damages a champion with a basic attack, if that champion does not have <condition value=wearied>Wearied</condition>, it becomes <condition value=wearied>Wearied</condition> for 6 turns. ",
      "long_description": "When this champion successfully damages a champion with a basic attack, if that champion does not have <condition value=wearied>Wearied</condition>, it becomes <condition value=wearied>Wearied</condition> for 6 turns. ",
      "class_name": "Weary",
      "revision": 1
    },
    {
      "asset_id": 4923,
      "resettable": 1,
      "name": "Weave Web",
      "ap_cost": 3,
      "level": 0,
      "ability_id": 1805,
      "activated": 1,
      "icon_name": "web",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "Area Effect 2, Range 3: Affected area is becomes <mechanic value=web_terrain>Web Terrain</mechanic> for 4 turns.",
      "long_description": "Area Effect 2, Range 3: Affected area is becomes <mechanic value=web_terrain>Web Terrain</mechanic> for 4 turns.",
      "class_name": "Weave",
      "revision": 1
    },
    {
      "asset_id": 4249,
      "resettable": 1,
      "name": "Web",
      "ap_cost": 1,
      "level": 0,
      "ability_id": 639,
      "activated": 1,
      "icon_name": "net_web",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 6,
      "short_description": "This unit makes an attack against a champion within 4 spaces. If successful, that unit takes 70% DMG (with a minimum of 10) and becomes <condition value=grounded>Grounded</condition> for 2 turns, Ensnared 2 (Each move costs an additional 2 AP) for 2 turns. This damage ignores DEF.",
      "long_description": "This unit makes an attack against a champion within 4 spaces. If successful, that unit takes 70% DMG (with a minimum of 10) and becomes <condition value=grounded>Grounded</condition> for 2 turns, Ensnared 2 (Each move costs an additional 2 AP) for 2 turns. This damage ignores DEF.",
      "class_name": "WebAttack",
      "revision": 1
    },
    {
      "asset_id": 7311,
      "resettable": 0,
      "name": "Weighty",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3064,
      "activated": 1,
      "icon_name": "weighty",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": -8,
      "short_description": "When this champion has moved 3 spaces via normal movement, it gains <ability value=5>Lumbering</ability> for 1 turn.",
      "long_description": "When this champion has moved 3 spaces via normal movement, it gains <ability value=5>Lumbering</ability> for 1 turn.",
      "class_name": "Weighty",
      "revision": 1
    },
    {
      "asset_id": 4924,
      "resettable": 1,
      "name": "Whirl of Blades",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1806,
      "activated": 1,
      "icon_name": "whirl",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 18,
      "short_description": "Whenever this champion engages an opponent it makes a free attack against that opponent. This champion gets -2 DMG for 1 turn whenever it makes this attack.",
      "long_description": "Whenever this champion engages an opponent it makes a free attack against that opponent. This champion gets -2 DMG for 1 turn whenever it makes this attack.",
      "class_name": "WhirlOfBlades",
      "revision": 1
    },
    {
      "asset_id": 7493,
      "resettable": 0,
      "name": "Whirling Stones",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3174,
      "activated": 1,
      "icon_name": "whirling_stones",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 14,
      "short_description": "At the end of this unit's turns and when it is the target of a basic attack, the closest enemy champion within 3 spaces takes 5 Physical damage and is knocked back 1 space.",
      "long_description": "At the end of this unit's turns and when it is the target of a basic attack, the closest enemy champion within 3 spaces takes 5 Physical damage and is knocked back 1 space.",
      "class_name": "WhirlingStones",
      "revision": 1
    },
    {
      "asset_id": 4159,
      "resettable": 1,
      "name": "Whirlwind Attack",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 438,
      "activated": 1,
      "icon_name": "whirl",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "Adjacent champions take damage equal to 75% of this unit's DMG. This damage ignores DEF.",
      "long_description": "Adjacent champions take damage equal to 75% of this unit's DMG. This damage ignores DEF.",
      "class_name": "WhirlwindAttack",
      "revision": 1
    },
    {
      "asset_id": 4159,
      "resettable": 1,
      "name": "Whirlwind Attack",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 439,
      "activated": 1,
      "icon_name": "whirl",
      "comments": "none",
      "prerequisite_id": 438,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 1,
      "cost": 5,
      "short_description": "This champion makes a close-combat attack against target champion. Then, each other adjacent champion takes damage equal to 80% of this champion's DMG, of the same type as this champion's basic attack.",
      "long_description": "This champion makes a close-combat attack against target champion. Then, each other adjacent champion takes damage equal to 80% of this champion's DMG, of the same type as this champion's basic attack.",
      "class_name": "WhirlwindAttack",
      "revision": 1
    },
    {
      "asset_id": 4159,
      "resettable": 1,
      "name": "Whirlwind Attack",
      "ap_cost": 0,
      "level": 3,
      "ability_id": 440,
      "activated": 1,
      "icon_name": "whirl",
      "comments": "none",
      "prerequisite_id": 439,
      "cooldown": 1,
      "activation_type": 1,
      "ranked": 1,
      "cost": 9,
      "short_description": "This champion makes a close-combat attack against target champion. Then, each other adjacent champion takes damage equal to this champion's DMG, of the same type as this champion's basic attack.",
      "long_description": "This champion makes a close-combat attack against target champion. Then, each other adjacent champion takes damage equal to this champion's DMG, of the same type as this champion's basic attack.",
      "class_name": "WhirlwindAttack",
      "revision": 1
    },
    {
      "asset_id": 4964,
      "resettable": 1,
      "name": "Wicked Aura",
      "ap_cost": 0,
      "level": 1,
      "ability_id": 1844,
      "activated": 1,
      "icon_name": "auranegative",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 6,
      "short_description": "Whenever an enemy champion within 4 spaces would gain AP, they get 1 less than normal.",
      "long_description": "Whenever an enemy champion within 4 spaces would gain AP, they get 1 less than normal.",
      "class_name": "WickedAura",
      "revision": 1
    },
    {
      "asset_id": 4964,
      "resettable": 1,
      "name": "Wicked Aura",
      "ap_cost": 0,
      "level": 2,
      "ability_id": 1845,
      "activated": 1,
      "icon_name": "auranegative",
      "comments": "",
      "prerequisite_id": 1844,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 1,
      "cost": 9,
      "short_description": "Whenever an enemy champion within 5 spaces would gain AP, they get 1 less than normal.",
      "long_description": "Whenever an enemy champion within 5 spaces would gain AP, they get 1 less than normal.",
      "class_name": "WickedAura",
      "revision": 1
    },
    {
      "asset_id": 4818,
      "resettable": 1,
      "name": "Widowmaker",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1698,
      "activated": 1,
      "icon_name": "stab",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 2,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "This unit makes an attack for 0 AP against any adjacent opposing champion with 30% or less of its HP remaining.",
      "long_description": "This unit makes an attack for 0 AP against any adjacent opposing champion with 30% or less of its HP remaining.",
      "class_name": "Widowmaker",
      "revision": 1
    },
    {
      "asset_id": 4942,
      "resettable": 1,
      "name": "Wieldable",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 1827,
      "activated": 1,
      "icon_name": "loyalty",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "This relic can be picked up and equipped by its owner.",
      "long_description": "This relic can be picked up and equipped by its owner.",
      "class_name": "PickUpRelicAuraAbstract",
      "revision": 1
    },
    {
      "asset_id": 5321,
      "resettable": 1,
      "name": "Will of Kain Taris",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2150,
      "activated": 1,
      "icon_name": "special",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "All friendly Kanen gain +1 DEF, +1 DMG and +5 HP if a friendly Kanen Witch is in play. This effect does not stack.",
      "long_description": "All friendly Kanen gain +1 DEF, +1 DMG and +5 HP if a friendly Kanen Witch is in play. This effect does not stack.",
      "class_name": "WillOfKainTaris",
      "revision": 1
    },
    {
      "asset_id": 4683,
      "resettable": 1,
      "name": "Wind Aura",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1121,
      "activated": 1,
      "icon_name": "gale",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "Champions within 5 spaces of this champion are <condition value=grounded>Grounded</condition>.",
      "long_description": "Champions within 5 spaces of this champion are <condition value=grounded>Grounded</condition>.",
      "class_name": "WindAura",
      "revision": 1
    },
    {
      "asset_id": 5785,
      "resettable": 1,
      "name": "Winter Cheer",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2806,
      "activated": 1,
      "icon_name": "domain_snow",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "This unit is filled with Winter Cheer!",
      "long_description": "This unit is filled with Winter Cheer!",
      "class_name": "WinterCheer",
      "revision": 1
    },
    {
      "asset_id": 5323,
      "resettable": 1,
      "name": "Winter Gloom",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2807,
      "activated": 1,
      "icon_name": "domain_snow",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 0,
      "short_description": "This unit is filled with Winter Gloom!",
      "long_description": "This unit is filled with Winter Gloom!",
      "class_name": "WinterGloom",
      "revision": 1
    },
    {
      "asset_id": 5105,
      "resettable": 1,
      "name": "Wisdom",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1280,
      "activated": 1,
      "icon_name": "diplomat",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 3,
      "short_description": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
      "long_description": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
      "class_name": "Wisdom",
      "revision": 1
    },
    {
      "asset_id": 7312,
      "resettable": 0,
      "name": "Wisp Whisperer",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3060,
      "activated": 1,
      "icon_name": "wisp_whisperer",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "For every 25 damage dealt by this champion, an Ancient Wisp is summoned to an adjacent space.",
      "long_description": "For every 25 damage dealt by this champion, an Ancient Wisp is summoned to an adjacent space.",
      "class_name": "WispWhisperer",
      "revision": 1
    },
    {
      "asset_id": 5629,
      "resettable": 0,
      "name": "Witches' Hourglass",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2971,
      "activated": 1,
      "icon_name": "scry",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 8,
      "short_description": "Friendly champions with Class: Witch within 5 spaces of this unit gain <ability value=2596>Forsaken Exploit</ability>.",
      "long_description": "Friendly champions with Class: Witch within 5 spaces of this unit gain <ability value=2596>Forsaken Exploit</ability>.",
      "class_name": "WitchesHourglass",
      "revision": 1
    },
    {
      "asset_id": 4506,
      "resettable": 1,
      "name": "Wolf Form",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 856,
      "activated": 1,
      "icon_name": "transform",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 5,
      "activation_type": 1,
      "ranked": 0,
      "cost": 10,
      "short_description": "This champion gets Race: Beast and gains <ability value=600>Arctic</ability> and <ability value=163>Rend</ability>. It is <mechanic value=cleansed>Cleansed</mechanic> and has RNG 1, +5 DMG, +5 MAX HP.",
      "long_description": "This champion gets Race: Beast and gains <ability value=600>Arctic</ability> and <ability value=163>Rend</ability>. It is <mechanic value=cleansed>Cleansed</mechanic> and has RNG 1, +5 DMG, +5 MAX HP.",
      "class_name": "WolfForm",
      "revision": 1
    },
    {
      "asset_id": 4916,
      "resettable": 1,
      "name": "Wolf Pack",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1798,
      "activated": 1,
      "icon_name": "pack_mentality",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 40,
      "short_description": "When this champion is deployed from the runedock, 2 Timber Wolves champions with no upgrades are summoned adjacent to it.",
      "long_description": "When this champion is deployed from the runedock, 2 Timber Wolves champions with no upgrades are summoned adjacent to it.",
      "class_name": "WolfPack",
      "revision": 1
    },
    {
      "asset_id": 5254,
      "resettable": 1,
      "name": "Wolf Rider",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2038,
      "activated": 1,
      "icon_name": "rider",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 30,
      "short_description": "When this unit is destroyed, no nora globe is dropped and an Icefisher with no upgrades is spawned in the location this unit occupied.",
      "long_description": "When this unit is destroyed, no nora globe is dropped and an Icefisher with no upgrades is spawned in the location this unit occupied.",
      "class_name": "WolfRider",
      "revision": 1
    },
    {
      "asset_id": 4294,
      "resettable": 1,
      "name": "Wooden Scales",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 696,
      "activated": 1,
      "icon_name": "soul_bond",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 1,
      "short_description": "When a player successfully casts a spell, each of that player's champions gets -1 DEF and the opponent's champions gets +1 DEF for 6 turns.",
      "long_description": "When a player successfully casts a spell, each of that player's champions gets -1 DEF and the opponent's champions gets +1 DEF for 6 turns.",
      "class_name": "RelicWoodenScales",
      "revision": 1
    },
    {
      "asset_id": 5681,
      "resettable": 1,
      "name": "Worm Lord",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2553,
      "activated": 1,
      "icon_name": "creep_master",
      "comments": "none",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 6,
      "short_description": "This champion has <ability value=2526>Necrosis</ability>.  When a real enemy champion is destroyed by a champion with Race: Worm or Necrosis within 5 spaces, your shrine's <mechanic value=deployment_zone>Deployment Zone</mechanic> expands by 1.",
      "long_description": "This champion has <ability value=2526>Necrosis</ability>.  When a real enemy champion is destroyed by a champion with Race: Worm or Necrosis within 5 spaces, your shrine's <mechanic value=deployment_zone>Deployment Zone</mechanic> expands by 1.",
      "class_name": "WormLord",
      "revision": 1
    },
    {
      "asset_id": 5207,
      "resettable": 1,
      "name": "Worship: Lich",
      "ap_cost": 2,
      "level": 0,
      "ability_id": 1984,
      "activated": 1,
      "icon_name": "buff",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 3,
      "activation_type": 1,
      "ranked": 0,
      "cost": 4,
      "short_description": "This champion loses 6 HP and gains <mechanic value=immobile>Immobile</mechanic> for 2 turns, and friendly Liches gain <ability value=117>Regeneration 3</ability> until this champion moves.",
      "long_description": "This champion loses 6 HP and gains <mechanic value=immobile>Immobile</mechanic> for 2 turns, and friendly Liches gain <ability value=117>Regeneration 3</ability> until this champion moves.",
      "class_name": "Worship",
      "revision": 1
    },
    {
      "asset_id": 5106,
      "resettable": 1,
      "name": "Worthwhile",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1281,
      "activated": 1,
      "icon_name": "",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 7,
      "short_description": "When this champion dies, ten runes are revealed.",
      "long_description": "When this champion dies, ten runes are revealed.",
      "class_name": "Worthwhile",
      "revision": 1
    },
    {
      "asset_id": 7771,
      "resettable": 0,
      "name": "Zeal: Damage",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3296,
      "activated": 1,
      "icon_name": "channel_damage",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this champion makes a successful basic attack, it gains +2 DMG for 5 turns.",
      "long_description": "When this champion makes a successful basic attack, it gains +2 DMG for 5 turns.",
      "class_name": "ZealDamage",
      "revision": 1
    },
    {
      "asset_id": 7772,
      "resettable": 0,
      "name": "Zeal: Defense",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3297,
      "activated": 1,
      "icon_name": "channel_defense",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 4,
      "short_description": "When this champion makes a successful basic attack, it gains +2 DEF for 5 turns.",
      "long_description": "When this champion makes a successful basic attack, it gains +2 DEF for 5 turns.",
      "class_name": "ZealDefense",
      "revision": 1
    },
    {
      "asset_id": 5732,
      "resettable": 1,
      "name": "Zeal: Speed",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2619,
      "activated": 1,
      "icon_name": "channel_speed",
      "comments": "x",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 6,
      "short_description": "When this champion makes a successful basic attack, it gains +1 SPD for 5 turns.",
      "long_description": "When this champion makes a successful basic attack, it gains +1 SPD for 5 turns.",
      "class_name": "Zeal",
      "revision": 1
    },
    {
      "asset_id": 7982,
      "resettable": 0,
      "name": "Zealot",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 3375,
      "activated": 1,
      "icon_name": "surge",
      "comments": null,
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 5,
      "short_description": "This unit gains +1 DMG for every other friendly real champion to a maximum of 5.",
      "long_description": "This unit gains +1 DMG for every other friendly real champion to a maximum of 5.",
      "class_name": "Zealot",
      "revision": 1
    },
    {
      "asset_id": 4540,
      "resettable": 1,
      "name": "Zealot: Moga",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 929,
      "activated": 1,
      "icon_name": "surge",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "This unit has +1 DMG for every friendly Moga.",
      "long_description": "This unit has +1 DMG for every friendly Moga.",
      "class_name": "ZealotMoga",
      "revision": 1
    },
    {
      "asset_id": 4928,
      "resettable": 1,
      "name": "Zealot: Skeezick",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 956,
      "activated": 1,
      "icon_name": "offenseenhance",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 10,
      "short_description": "This unit has +1 DMG for every friendly Skeezick.",
      "long_description": "This unit has +1 DMG for every friendly Skeezick.",
      "class_name": "ZealotSkeezick",
      "revision": 1
    },
    {
      "asset_id": 4619,
      "resettable": 1,
      "name": "Zealot: Voil",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1034,
      "activated": 1,
      "icon_name": "surge",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 9,
      "short_description": "This unit has +1 DMG for every friendly Voil or Bat.",
      "long_description": "This unit has +1 DMG for every friendly Voil or Bat.",
      "class_name": "ZealotVoil",
      "revision": 1
    },
    {
      "asset_id": 4989,
      "resettable": 1,
      "name": "Zephyr Shield",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1871,
      "activated": 1,
      "icon_name": "zephyr_shield",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 2,
      "ranked": 0,
      "cost": 12,
      "short_description": "When this champion moves 4 spaces in a single turn, the next successful attack in 4 turns against it misses.  This effect stacks up to 3 times.",
      "long_description": "When this champion moves 4 spaces in a single turn, the next successful attack in 4 turns against it misses.  This effect stacks up to 3 times.",
      "class_name": "WindShield",
      "revision": 1
    },
    {
      "asset_id": 5252,
      "resettable": 1,
      "name": "Zombie Apocalypse",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 2142,
      "activated": 1,
      "icon_name": "zombie_apoc",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 4,
      "short_description": "This champion has <ability value=1211>Disease Eater</ability> and <ability value=1054>Healing Deficiency</ability>.  While you control at least 5 Zombies, this unit gains <ability value=2147>Swarm: Festering Corpse</ability>.",
      "long_description": "This champion has <ability value=1211>Disease Eater</ability> and <ability value=1054>Healing Deficiency</ability>.  While you control at least 5 Zombies, this unit gains <ability value=2147>Swarm: Festering Corpse</ability>.",
      "class_name": "ZombieApocalypse",
      "revision": 1
    },
    {
      "asset_id": 5709,
      "resettable": 1,
      "name": "Zombie Herder",
      "ap_cost": 4,
      "level": 0,
      "ability_id": 2591,
      "activated": 1,
      "icon_name": "desert_hearder",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 4,
      "activation_type": 1,
      "ranked": 0,
      "cost": 8,
      "short_description": "Friendly Zombies within 5 spaces gain 3 AP and <ability value=396>Charge 3</ability> and lose Lethargic, Weighty, and Lumbering for 1 turn.  If the champion already has Charge, it gains <ability value=2092>Crushing Charge</ability> instead.",
      "long_description": "Friendly Zombies within 5 spaces gain 3 AP and <ability value=396>Charge 3</ability> and lose Lethargic, Weighty, and Lumbering for 1 turn.  If the champion already has Charge, it gains <ability value=2092>Crushing Charge</ability> instead.",
      "class_name": "ZombieHerder",
      "revision": 1
    },
    {
      "asset_id": 4567,
      "resettable": 1,
      "name": "Zombie Plague",
      "ap_cost": 0,
      "level": 0,
      "ability_id": 1013,
      "activated": 1,
      "icon_name": "diseaseaoe",
      "comments": "",
      "prerequisite_id": null,
      "cooldown": 0,
      "activation_type": 0,
      "ranked": 0,
      "cost": 20,
      "short_description": "This champion has <ability value=43>Immunity: Disease</ability>. When this champion successfully damages a non-Undead champion with a basic attack, that champion becomes Plagued for 6 turns. When a Plagued champion is destroyed, a Festering Corpse is summoned in its place, under your control.",
      "long_description": "This champion has <ability value=43>Immunity: Disease</ability>. When this champion successfully damages a non-Undead champion with a basic attack, that champion becomes Plagued for 6 turns. When a Plagued champion is destroyed, a Festering Corpse is summoned in its place, under your control.",
      "class_name": "ZombiePlague",
      "revision": 1
    }
  ]

export {abilities}